var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key2, value9) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value: value9 }) : obj[key2] = value9;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { ref, getCurrentInstance, onMounted, shallowRef, toRefs, computed, watch, defineComponent, reactive, nextTick } from "vue-demi";
import { stringify } from "qs";
import Vue$1 from "vue";
import axios from "axios";
import { formatOssUrl, OssUpload } from "@oppein-lib/op-upload";
import { defineComponent as defineComponent$1 } from "@vue/composition-api";
const json = (data22, headers) => {
  headers["Content-Type"] = "application/json";
  return JSON.stringify(data22);
};
const url = (data22, headers) => {
  headers["Content-Type"] = "application/x-www-form-urlencoded";
  return stringify(data22);
};
const form = (data22, headers) => {
  headers["Content-Type"] = "multipart/form-data";
  const formData = new FormData();
  for (const key2 in data22) {
    formData.append(key2, data22[key2]);
  }
  return formData;
};
var contentType = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  json,
  url,
  form
});
function lexer(str) {
  var tokens = [];
  var i = 0;
  while (i < str.length) {
    var char = str[i];
    if (char === "*" || char === "+" || char === "?") {
      tokens.push({
        type: "MODIFIER",
        index: i,
        value: str[i++]
      });
      continue;
    }
    if (char === "\\") {
      tokens.push({
        type: "ESCAPED_CHAR",
        index: i++,
        value: str[i++]
      });
      continue;
    }
    if (char === "{") {
      tokens.push({
        type: "OPEN",
        index: i,
        value: str[i++]
      });
      continue;
    }
    if (char === "}") {
      tokens.push({
        type: "CLOSE",
        index: i,
        value: str[i++]
      });
      continue;
    }
    if (char === ":") {
      var name = "";
      var j = i + 1;
      while (j < str.length) {
        var code = str.charCodeAt(j);
        if (code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122 || code === 95) {
          name += str[j++];
          continue;
        }
        break;
      }
      if (!name)
        throw new TypeError("Missing parameter name at " + i);
      tokens.push({
        type: "NAME",
        index: i,
        value: name
      });
      i = j;
      continue;
    }
    if (char === "(") {
      var count3 = 1;
      var pattern = "";
      var j = i + 1;
      if (str[j] === "?") {
        throw new TypeError('Pattern cannot start with "?" at ' + j);
      }
      while (j < str.length) {
        if (str[j] === "\\") {
          pattern += str[j++] + str[j++];
          continue;
        }
        if (str[j] === ")") {
          count3--;
          if (count3 === 0) {
            j++;
            break;
          }
        } else if (str[j] === "(") {
          count3++;
          if (str[j + 1] !== "?") {
            throw new TypeError("Capturing groups are not allowed at " + j);
          }
        }
        pattern += str[j++];
      }
      if (count3)
        throw new TypeError("Unbalanced pattern at " + i);
      if (!pattern)
        throw new TypeError("Missing pattern at " + i);
      tokens.push({
        type: "PATTERN",
        index: i,
        value: pattern
      });
      i = j;
      continue;
    }
    tokens.push({
      type: "CHAR",
      index: i,
      value: str[i++]
    });
  }
  tokens.push({
    type: "END",
    index: i,
    value: ""
  });
  return tokens;
}
function parse(str, options) {
  if (options === void 0) {
    options = {};
  }
  var tokens = lexer(str);
  var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
  var defaultPattern = "[^" + escapeString(options.delimiter || "/#?") + "]+?";
  var result = [];
  var key2 = 0;
  var i = 0;
  var path = "";
  var tryConsume = function(type) {
    if (i < tokens.length && tokens[i].type === type)
      return tokens[i++].value;
  };
  var mustConsume = function(type) {
    var value10 = tryConsume(type);
    if (value10 !== void 0)
      return value10;
    var _a2 = tokens[i], nextType = _a2.type, index2 = _a2.index;
    throw new TypeError("Unexpected " + nextType + " at " + index2 + ", expected " + type);
  };
  var consumeText = function() {
    var result2 = "";
    var value10;
    while (value10 = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR")) {
      result2 += value10;
    }
    return result2;
  };
  while (i < tokens.length) {
    var char = tryConsume("CHAR");
    var name = tryConsume("NAME");
    var pattern = tryConsume("PATTERN");
    if (name || pattern) {
      var prefix = char || "";
      if (prefixes.indexOf(prefix) === -1) {
        path += prefix;
        prefix = "";
      }
      if (path) {
        result.push(path);
        path = "";
      }
      result.push({
        name: name || key2++,
        prefix,
        suffix: "",
        pattern: pattern || defaultPattern,
        modifier: tryConsume("MODIFIER") || ""
      });
      continue;
    }
    var value9 = char || tryConsume("ESCAPED_CHAR");
    if (value9) {
      path += value9;
      continue;
    }
    if (path) {
      result.push(path);
      path = "";
    }
    var open3 = tryConsume("OPEN");
    if (open3) {
      var prefix = consumeText();
      var name_1 = tryConsume("NAME") || "";
      var pattern_1 = tryConsume("PATTERN") || "";
      var suffix = consumeText();
      mustConsume("CLOSE");
      result.push({
        name: name_1 || (pattern_1 ? key2++ : ""),
        pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
        prefix,
        suffix,
        modifier: tryConsume("MODIFIER") || ""
      });
      continue;
    }
    mustConsume("END");
  }
  return result;
}
function compile(str, options) {
  return tokensToFunction(parse(str, options), options);
}
function tokensToFunction(tokens, options) {
  if (options === void 0) {
    options = {};
  }
  var reFlags = flags(options);
  var _a = options.encode, encode2 = _a === void 0 ? function(x) {
    return x;
  } : _a, _b = options.validate, validate3 = _b === void 0 ? true : _b;
  var matches2 = tokens.map(function(token) {
    if (typeof token === "object") {
      return new RegExp("^(?:" + token.pattern + ")$", reFlags);
    }
  });
  return function(data22) {
    var path = "";
    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];
      if (typeof token === "string") {
        path += token;
        continue;
      }
      var value9 = data22 ? data22[token.name] : void 0;
      var optional = token.modifier === "?" || token.modifier === "*";
      var repeat = token.modifier === "*" || token.modifier === "+";
      if (Array.isArray(value9)) {
        if (!repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but got an array');
        }
        if (value9.length === 0) {
          if (optional)
            continue;
          throw new TypeError('Expected "' + token.name + '" to not be empty');
        }
        for (var j = 0; j < value9.length; j++) {
          var segment = encode2(value9[j], token);
          if (validate3 && !matches2[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
          }
          path += token.prefix + segment + token.suffix;
        }
        continue;
      }
      if (typeof value9 === "string" || typeof value9 === "number") {
        var segment = encode2(String(value9), token);
        if (validate3 && !matches2[i].test(segment)) {
          throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
        }
        path += token.prefix + segment + token.suffix;
        continue;
      }
      if (optional)
        continue;
      var typeOfMessage = repeat ? "an array" : "a string";
      throw new TypeError('Expected "' + token.name + '" to be ' + typeOfMessage);
    }
    return path;
  };
}
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function flags(options) {
  return options && options.sensitive ? "" : "i";
}
function regexpToRegexp(path, keys) {
  if (!keys)
    return path;
  var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
  var index2 = 0;
  var execResult = groupsRegex.exec(path.source);
  while (execResult) {
    keys.push({
      name: execResult[1] || index2++,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: ""
    });
    execResult = groupsRegex.exec(path.source);
  }
  return path;
}
function arrayToRegexp(paths, keys, options) {
  var parts = paths.map(function(path) {
    return pathToRegexp(path, keys, options).source;
  });
  return new RegExp("(?:" + parts.join("|") + ")", flags(options));
}
function stringToRegexp(path, keys, options) {
  return tokensToRegexp(parse(path, options), keys, options);
}
function tokensToRegexp(tokens, keys, options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode2 = _d === void 0 ? function(x) {
    return x;
  } : _d;
  var endsWith = "[" + escapeString(options.endsWith || "") + "]|$";
  var delimiter = "[" + escapeString(options.delimiter || "/#?") + "]";
  var route2 = start ? "^" : "";
  for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
    var token = tokens_1[_i];
    if (typeof token === "string") {
      route2 += escapeString(encode2(token));
    } else {
      var prefix = escapeString(encode2(token.prefix));
      var suffix = escapeString(encode2(token.suffix));
      if (token.pattern) {
        if (keys)
          keys.push(token);
        if (prefix || suffix) {
          if (token.modifier === "+" || token.modifier === "*") {
            var mod = token.modifier === "*" ? "?" : "";
            route2 += "(?:" + prefix + "((?:" + token.pattern + ")(?:" + suffix + prefix + "(?:" + token.pattern + "))*)" + suffix + ")" + mod;
          } else {
            route2 += "(?:" + prefix + "(" + token.pattern + ")" + suffix + ")" + token.modifier;
          }
        } else {
          route2 += "(" + token.pattern + ")" + token.modifier;
        }
      } else {
        route2 += "(?:" + prefix + suffix + ")" + token.modifier;
      }
    }
  }
  if (end) {
    if (!strict)
      route2 += delimiter + "?";
    route2 += !options.endsWith ? "$" : "(?=" + endsWith + ")";
  } else {
    var endToken = tokens[tokens.length - 1];
    var isEndDelimited = typeof endToken === "string" ? delimiter.indexOf(endToken[endToken.length - 1]) > -1 : endToken === void 0;
    if (!strict) {
      route2 += "(?:" + delimiter + "(?=" + endsWith + "))?";
    }
    if (!isEndDelimited) {
      route2 += "(?=" + delimiter + "|" + endsWith + ")";
    }
  }
  return new RegExp(route2, flags(options));
}
function pathToRegexp(path, keys, options) {
  if (path instanceof RegExp)
    return regexpToRegexp(path, keys);
  if (Array.isArray(path))
    return arrayToRegexp(path, keys, options);
  return stringToRegexp(path, keys, options);
}
const checkRESTfullApi = (regexpArr, url2) => {
  pathToRegexp(url2, regexpArr);
  return regexpArr.length > 0;
};
const checkRESTfullParams = (params, data22) => {
  const used = [];
  if (Object.keys(data22).length === 0) {
    return used;
  }
  params.forEach((item) => {
    if (data22[item.name])
      used.push([item.name]);
  });
  return used;
};
const handleRESTfullData = (urlParams, data22) => {
  urlParams.forEach((item) => {
    delete data22[item];
  });
  return data22;
};
class AjaxConfig {
  constructor(config) {
    Object.assign(this, config);
  }
  set _url(value9) {
    this.baseUrl = value9;
    this.url = value9;
  }
  get(url2) {
    this._url = url2;
    this.method = "get";
    return this;
  }
  delete(url2) {
    this._url = url2;
    this.method = "delete";
    return this;
  }
  head(url2) {
    this._url = url2;
    this.method = "head";
    return this;
  }
  options(url2) {
    this._url = url2;
    this.method = "options";
    return this;
  }
  post(url2) {
    this._url = url2;
    this.method = "post";
    return this;
  }
  put(url2) {
    this._url = url2;
    this.method = "put";
    return this;
  }
  patch(url2) {
    this._url = url2;
    this.method = "patch";
    return this;
  }
  format(type) {
    if (!contentType[type]) {
      Vue$1.util.warn(`[services format: contentType]: ${type} is undefined`);
    }
    this.transformRequest = [contentType[type]];
    return this;
  }
  setData(data22) {
    let newData = data22;
    const RESTfullParams = [];
    if (checkRESTfullApi(RESTfullParams, this.baseUrl)) {
      const arr = checkRESTfullParams(RESTfullParams, data22);
      if (arr.length > 0) {
        const toPath = compile(this.baseUrl);
        const RESTfulUrl = toPath(data22);
        const newValue = handleRESTfullData(arr, data22);
        this.url = RESTfulUrl;
        newData = newValue;
      }
    }
    if (this.method === "get") {
      this.params = newData;
    } else {
      this.data = newData;
    }
    return this;
  }
}
var responseHandleNewsso = [(response) => {
  if (response.data.code && !(response.data.code === "200" || response.data.code === "100000")) {
    let message2 = response.data.message || response.data.msg || response.data.exception || response.data.errMsg || "\u672A\u77E5\u5F02\u5E38";
    Promise.reject(message2);
  }
  return response;
}, (error) => {
  Promise.reject(error);
}];
const getCookie = (name) => {
  const session = sessionStorage.getItem(name);
  if (session) {
    return session;
  }
  var arr = document.cookie.split("; ");
  for (let i = 0; i < arr.length; i++) {
    const arr2 = arr[i].split("=");
    if (arr2[0] === name) {
      return arr2[1];
    }
  }
  return "";
};
var requestWithToken = [(config) => {
  const token = getCookie("Oauth2-AccessToken");
  if (token) {
    config.headers["Oauth2-AccessToken"] = token;
  }
  return config;
}, (error) => Promise.reject(error)];
var retryWhenTimeout = [(response) => response, (error) => {
  const config = error.config;
  if (!config || !config.retry)
    return Promise.reject(error);
  config.__retryCount = config.__retryCount || 0;
  if (config.__retryCount >= config.retry) {
    return Promise.reject(error);
  }
  config.__retryCount += 1;
  const delayRetry = new Promise((resolve) => {
    setTimeout(() => resolve(), config.retryDelay || 0);
  });
  return delayRetry.then(() => Axios(config));
}];
let cacheSubAppCode = "";
var handleSetAppCode = [(config) => {
  let _subAppCode = "";
  if (cacheSubAppCode) {
    _subAppCode = cacheSubAppCode;
  } else {
    _subAppCode = cacheSubAppCode = sessionStorage.getItem("__PLUGIN_SUB_APPCODE__");
  }
  if (!config.headers) {
    config.headers = {};
  }
  if (_subAppCode) {
    config.headers["AppCode"] = _subAppCode.slice(0, 4);
    config.headers["SubAppCode"] = _subAppCode;
  }
  return config;
}, (error) => Promise.reject(error)];
axios.defaults.timeout = 1e3 * 60 * 2;
axios.defaults.retry = 3;
axios.defaults.retryDelay = 500;
const Axios = axios.create({
  withCredentials: true,
  "X-Requested-With": "XMLHttpRequest"
});
Axios.interceptors.request.use(...requestWithToken);
Axios.interceptors.request.use(...handleSetAppCode);
Axios.interceptors.request.use((config) => {
  return config;
}, (error) => {
  return Promise.reject(error);
});
Axios.interceptors.response.use(...responseHandleNewsso);
Axios.interceptors.response.use(...retryWhenTimeout);
Axios.interceptors.response.use((response) => response, (error) => {
  return Promise.reject(error);
});
const AxiosWebApi = axios.create();
AxiosWebApi.interceptors.request.use(...handleSetAppCode);
AxiosWebApi.interceptors.request.use((config) => config, (error) => {
  return Promise.reject(error);
});
const inBrowser$1 = typeof window !== "undefined";
const ua$1 = inBrowser$1 && navigator.userAgent.toLowerCase() || "";
const regWeiXin = ua$1.match(/micromessenger/i);
const regWxWork = ua$1.match(/wxwork/i);
const regH5plus = ua$1.match(/html5plus/i);
const regMiniprogram = ua$1.match(/miniprogram/i);
const isWxwork = () => {
  return regWeiXin && regWeiXin[0] == "micromessenger" && regWxWork && regWxWork[0] == "wxwork";
};
const isWx = () => {
  return regWxWork === null && regWeiXin && regWeiXin[0] == "micromessenger";
};
const isH5plus = () => {
  return regH5plus && regH5plus[0] == "html5plus";
};
const isMiniProgram = () => {
  return regMiniprogram && regMiniprogram[0] == "miniprogram";
};
const isPCWidth = () => {
  if (inBrowser$1) {
    const clientWidth = document.body.clientWidth;
    if (window.$OP_COMPONENT_MODE === "auto" || !window.$OP_COMPONENT_MODE) {
      return clientWidth > 600;
    } else if (window.$OP_COMPONENT_MODE === "mobile") {
      return false;
    } else if (window.$OP_COMPONENT_MODE === "pc") {
      return true;
    } else {
      return clientWidth > 600;
    }
  } else {
    return true;
  }
};
class BaseUrl {
  constructor() {
    this.env = "pro";
    this.baseUrl = {
      sit: {
        apigateway: "https://apigatewaysit.oppein.com",
        cdnPath: "https://mtdsrestest.oppein.com/",
        ossPath: "https://opyx-mtds-test.oss-cn-shenzhen.aliyuncs.com/"
      },
      uat: {
        apigateway: "https://apigatewayuat.oppein.com",
        cdnPath: "https://mtdsrestest.oppein.com/",
        ossPath: "https://opyx-mtds-test.oss-cn-shenzhen.aliyuncs.com/"
      },
      ver: {
        apigateway: "https://apigatewayver.oppein.com",
        cdnPath: "https://mtdsrestest.oppein.com/",
        ossPath: "https://opyx-mtds-test.oss-cn-shenzhen.aliyuncs.com/"
      },
      pro: {
        apigateway: "https://apigateway.oppein.com",
        cdnPath: "https://mtdsosscdn.oppein.com/",
        ossPath: "https://mtdsosscdn.oppein.com/"
      }
    };
  }
  init(env) {
    this.env = env;
    return this;
  }
  getBaseUrl() {
    if (inBrowser$1) {
      return this.baseUrl[sessionStorage.getItem("oppein-component/env") || this.env];
    } else {
      return this.baseUrl[this.env];
    }
  }
}
const baseUrlInst = new BaseUrl();
const PLUGIN_SUB_ADDCODE = "__PLUGIN_SUB_APPCODE__";
const initAppCode = (subAppCode) => {
  sessionStorage.setItem(PLUGIN_SUB_ADDCODE, subAppCode);
};
const getAppCode = () => {
  const subAppCode = sessionStorage.getItem(PLUGIN_SUB_ADDCODE);
  const appCode = subAppCode.slice(0, 4);
  return {
    subAppCode,
    appCode
  };
};
const request = (api2, data22) => new Promise((resolve, reject) => {
  const params = api2.setData(data22);
  params.baseURL = baseUrlInst.getBaseUrl().apigateway;
  Axios(params).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    if (!error.response) {
      return;
    }
    reject(error);
  });
});
const asyncRequest = async (api2, data22) => {
  try {
    const params = api2.setData(data22);
    params.baseURL = baseUrlInst.getBaseUrl().apigateway;
    return await Axios(params);
  } catch (error) {
    return Promise.reject(error);
  }
};
const reqWebApi = (url2, method, data22) => {
  new Promise((resolve, reject) => {
    const _methods = method.toLocaleLowerCase();
    const _params = {
      url: url2,
      method: _methods,
      baseURL: baseUrlInst.getBaseUrl().apigateway
    };
    if (_methods === "get") {
      _params.params = data22;
    } else if (_methods === "post") {
      _params.data = data22;
    }
    AxiosWebApi(_params).then((result) => {
      resolve(result.data);
    }).catch((error) => {
      if (!error.response) {
        return;
      }
      reject(error);
    });
  });
};
const requestServer = {
  baseUrlInst,
  request,
  reqWebApi,
  asyncRequest,
  initAppCode,
  getAppCode
};
var __glob_6_35 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  baseUrlInst,
  request,
  reqWebApi,
  asyncRequest,
  initAppCode,
  getAppCode,
  "default": requestServer
});
const ajax$4 = (config) => new AjaxConfig(config);
const GET_UC_REGION_BY_ID = ajax$4().get("/ucenterapi/anonymous/internal/region/getRegionByIdToAnonymous");
const GET_REGION_LIST_BY_PID = ajax$4().get("/ucenterapi/anonymous/internal/region/getRegionListByPidToAnonymous");
const GET_REGION_COUNTRY_LIST_BY_PID = ajax$4().get("/ucenterapi/internal/region/getRegionCountryListByPid");
const GET_MARKET_SEARCH = ajax$4().post("/ucenterapi/uc/internal/market/listMarketBaseInfoByCon");
const GET_MARKET_LIST_BY_CON = ajax$4().post("/ucenterapi/internal/org/getOrgPageListByConToPost");
const GET_USER_PAGE_LIST_BY_CON_TO_POST = ajax$4().post("/ucenterapi/internal/user/getUserPageListByConToPost");
const GET_USER_BY_CON_POST = ajax$4().post("ucenterapi/internal/account/selectAccountListByIdList");
const GET_ORGANIZATIONAL_STRUCTURE_LIST = ajax$4().post("/ucenterapi/internal/org/getOrganizationalStructureList");
const GET_UC_ORGANIZATION_TREE = ajax$4().get("ucenterapi/internal/department/selectDepartmentList");
const GET_POSITION_PAGE_LIST_BY_CON_TO_POST = ajax$4().post("/ucenterapi/internal/position/getPositionPageListByConToPost");
const GET_DEPARTMENT_PAGE_LIST_BY_CON_TO_POST = ajax$4().get("/ucenterapi/uc/internal/department/getDepartmentInfoPageListByCon");
ajax$4().get("/ucenter/api/ucenter/dictConfigure/getDictPowerPlatformListToUser.json");
const GET_ROLE_PAGE_LIST_BY_CON_TO_POST = ajax$4().post("/ucenterapi/internal/role/getRolePageListByConToPost");
const GET_BRAND_CATEGORY = ajax$4().get("/ucenter/api/ucenter/brandCategory/getAllBrandOrCategoryListToTree.json");
const GET_SHOP_PAGE_LIST = ajax$4().post("/ucenterapi/internal/shop/getShopPageListByConToPost");
const GET_SHOP_VIRTUAL_LIST = ajax$4().post("/ucenterapi/internal/shop/getFictitiousShopPageListByConToPost");
const GET_DIC_BY_TYPE = ajax$4().post("/ucenter/api/ucenter/dict/getDictMapByTypeList");
const GET_TREE_DIC_BY_CODE = ajax$4().get("/mtdsbase/internal/cache/getUCDictCOTreeListByRegexpLeftCode");
const GET_CHANNEL_LIST = ajax$4().get("/ucenter/api/ucenter/dictConfigure/getDictChannelHierarchyConfigureTreeList.json");
const GET_ORG_RIGHT_LIST = ajax$4().post("ucenterapi/internal/org/selectOrgRightPageListByCon");
const GET_MARKET_LINE_LIST = ajax$4().get("ucenterapi/internal/line/selectLineTreeListByOrgBelongMarketClassify");
const GET_MARKET_LINE_TREE = ajax$4().get("ucenterapi/internal/line/selectLineTreeList");
function getRegionListByPid(params) {
  return new Promise((resolve, reject) => {
    request(GET_REGION_LIST_BY_PID, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}
function getUCRegionById(params) {
  return new Promise((resolve, reject) => {
    request(GET_UC_REGION_BY_ID, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}
function getRegionCountryListByPid(params) {
  return new Promise((resolve, reject) => {
    request(GET_REGION_COUNTRY_LIST_BY_PID, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}
const getMarketSearch = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_MARKET_SEARCH, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getMarketListData = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_MARKET_LIST_BY_CON, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getUserPageListByConToPost = (params) => {
  return request(GET_USER_PAGE_LIST_BY_CON_TO_POST, params);
};
const getUserByConPost = (params) => {
  return request(GET_USER_BY_CON_POST, params);
};
const CACHE_ORG_DATA = {};
const getUcOrganizationTree = async (params) => {
  if (params && params.orgType && CACHE_ORG_DATA[params.orgType]) {
    return CACHE_ORG_DATA[params.orgType];
  }
  const _data = await request(GET_UC_ORGANIZATION_TREE, __spreadValues({
    tree: true
  }, params));
  if (params && params.orgType) {
    CACHE_ORG_DATA[params.orgType] = _data;
  }
  return _data;
};
const getOrganizationalStructureList = (params) => {
  return request(GET_ORGANIZATIONAL_STRUCTURE_LIST, params);
};
const getPositionPageListByConToPost = (params) => {
  return request(GET_POSITION_PAGE_LIST_BY_CON_TO_POST, params);
};
const getDepartmentPageListByConToPost = (params) => {
  return request(GET_DEPARTMENT_PAGE_LIST_BY_CON_TO_POST, params);
};
const getRolePageListByConToPost = (params) => {
  return request(GET_ROLE_PAGE_LIST_BY_CON_TO_POST, params);
};
const getBrandCategoryList = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_BRAND_CATEGORY, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getShopPageList = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_SHOP_PAGE_LIST, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getShopVirtualList = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_SHOP_VIRTUAL_LIST, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getDitByDitTypes = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_DIC_BY_TYPE, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getTreeDictByCode = (code) => {
  return new Promise((resolve, reject) => {
    request(GET_TREE_DIC_BY_CODE, {
      code
    }).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getChannelList = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_CHANNEL_LIST, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getOrgRightList = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_ORG_RIGHT_LIST, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getMarketLineList = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_MARKET_LINE_LIST, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getMarketLineTree = (params) => {
  return new Promise((resolve, reject) => {
    request(GET_MARKET_LINE_TREE, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const CACHE_DIC_DATA = {};
function useDictData(typeList) {
  const dictData = {};
  for (let type of typeList) {
    dictData[type] = ref([]);
  }
  const getDictData = async () => {
    const noCacheTypeList = [];
    for (let type of typeList) {
      if (CACHE_DIC_DATA[type]) {
        dictData[type].value = CACHE_DIC_DATA[type];
      } else {
        noCacheTypeList.push(type);
      }
    }
    if (noCacheTypeList.length === 0) {
      return dictData;
    }
    const res = await getDitByDitTypes({
      typeList: noCacheTypeList
    });
    if (res.status && res.data) {
      for (let type of noCacheTypeList) {
        dictData[type].value = res.data[type];
        CACHE_DIC_DATA[type] = res.data[type];
      }
    }
    return dictData;
  };
  const getTreeDictData = async (code) => {
    if (!code && typeof code !== "string") {
      /* @__PURE__ */ console.error("\u5FC5\u987B\u4F20\u5165\u5355\u4E2A\u5B57\u5178code");
      return ref([]);
    }
    if (!CACHE_DIC_DATA[code] || CACHE_DIC_DATA[code] && CACHE_DIC_DATA[code].every((x) => !x.children || x.children.length === 0)) {
      const res = await getTreeDictByCode(code);
      const data22 = res.data[0].children;
      handleNoDataChildren(data22);
      dictData[code].value = data22;
      CACHE_DIC_DATA[code] = data22;
    } else {
      dictData[code].value = CACHE_DIC_DATA[code];
    }
    return dictData[code];
  };
  function handleNoDataChildren(arr) {
    arr.forEach((item) => {
      if (item.children && item.children.length === 0) {
        delete item.children;
      } else {
        handleNoDataChildren(item.children);
      }
    });
  }
  return __spreadValues({
    getDictData,
    getTreeDictData
  }, dictData);
}
function useModal(props2) {
  const visible2 = ref(false);
  const open3 = () => {
    if (!props2.disabled) {
      visible2.value = true;
    }
  };
  const close3 = () => {
    visible2.value = false;
  };
  return {
    visible: visible2,
    open: open3,
    close: close3
  };
}
const get$1 = (from, ...selectors) => [...selectors].map((s) => s.replace(/\[([^[\]]*)\]/g, ".$1.").split(".").filter((t4) => t4 !== "").reduce((prev4, cur) => prev4 && prev4[cur], from));
const deepClone = (obj) => {
  if (obj === null)
    return null;
  let clone2 = Object.assign({}, obj);
  Object.keys(clone2).forEach((key2) => clone2[key2] = typeof obj[key2] === "object" ? deepClone(obj[key2]) : obj[key2]);
  if (Array.isArray(obj)) {
    clone2.length = obj.length;
    return Array.from(clone2);
  }
  return clone2;
};
const getQueryString = (name) => {
  const query = window.location.href.split("?")[1];
  if (!query)
    return false;
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === name) {
      /* @__PURE__ */ console.log(pair[1]);
      return pair[1];
    }
  }
  return false;
};
const getOauth2AccessToken = () => {
  return getQueryString("Oauth2-AccessToken") ? getQueryString("Oauth2-AccessToken") : getCookie("Oauth2-AccessToken");
};
const dataURLtoFile = (dataurl, fileName) => {
  let arr = dataurl.split(",");
  let bstr = atob(arr[1] || arr[0]);
  const _mineMatch = arr[0].match(/:(.*?);/);
  let mine = _mineMatch ? _mineMatch[1] : "";
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  if (mine) {
    return new File([u8arr], fileName, {
      type: mine
    });
  } else {
    return new File([u8arr], fileName);
  }
};
const getData$1 = (p, o) => p.reduce((xs, x) => xs && xs[x] ? xs[x] : null, o);
const changeComPrefix = (name, prefix) => {
  if (prefix) {
    return name.replace(/^Op/, prefix);
  } else {
    return name;
  }
};
function hasOwnPropertyCall(obj, key2) {
  return Object.prototype.hasOwnProperty.call(obj, key2);
}
function tile2nest(array, key2, pKey, childrenKey2) {
  if (!array || array.constructor !== Array) {
    return array;
  }
  let ary = [...array];
  key2 = key2 || "id";
  pKey = pKey || "parentId";
  childrenKey2 = childrenKey2 || "children";
  let ary2remove = [];
  ary.map((item) => {
    if (item[key2] !== item[pKey]) {
      let p = ary.filter((c) => c[key2] === item[pKey]);
      if (p && p.length == 1) {
        p[0][childrenKey2] = p[0][childrenKey2] || [];
        p[0][childrenKey2].push(item);
        ary2remove.push(item[key2]);
      }
    }
  });
  ary2remove.map((item) => {
    ary = ary.filter((c) => c[key2] !== item);
  });
  return ary;
}
function arrayEquals$1(ary1, ary2) {
  if (!ary1 || !ary2) {
    return ary1 === ary2;
  }
  if (ary1.length != ary2.length) {
    return false;
  }
  for (var i = 0, l = ary1.length; i < l; i++) {
    if (ary1[i] instanceof Array && ary2[i] instanceof Array) {
      if (!arrayEquals$1(ary1[i], ary2[i])) {
        return false;
      }
    } else if (ary1[i] instanceof Object && ary2[i] instanceof Object) {
      if (!objectEquals(ary1[i], ary2[i])) {
        return false;
      }
    } else if (ary1[i] != ary2[i]) {
      return false;
    }
  }
  return true;
}
function objectEquals(obj1, obj2, props2) {
  if (!props2 || props2.constructor !== Array) {
    props2 = [];
  }
  if (!obj1 || !obj2) {
    return obj1 === obj2;
  }
  for (let propName in obj1) {
    if (props2.length > 0 && props2.indexOf(propName) === -1) {
      continue;
    }
    if (hasOwnPropertyCall(obj1, propName) != hasOwnPropertyCall(obj2, propName)) {
      return false;
    } else if (typeof obj1[propName] != typeof obj2[propName]) {
      return false;
    }
  }
  for (let propName in obj2) {
    if (props2.length > 0 && props2.indexOf(propName) === -1) {
      continue;
    }
    if (hasOwnPropertyCall(obj1, propName) != hasOwnPropertyCall(obj2, propName)) {
      return false;
    } else if (typeof obj1[propName] != typeof obj2[propName]) {
      return false;
    }
    if (!hasOwnPropertyCall(obj1, propName)) {
      continue;
    }
    if (obj1[propName] instanceof Array && obj2[propName] instanceof Array) {
      if (!arrayEquals$1(obj1[propName], obj2[propName])) {
        return false;
      }
    } else if (obj1[propName] instanceof Object && obj2[propName] instanceof Object) {
      if (!objectEquals(obj1[propName], obj2[propName])) {
        return false;
      }
    } else if (obj1[propName] != obj2[propName]) {
      return false;
    }
  }
  return true;
}
function getValueByPath(obj, path, subIndex) {
  if (!obj || !path || path.constructor != String) {
    return null;
  }
  if (!/^\w?.*[\w|\]]$/.test(path)) {
    return null;
  }
  let pathAry = path.split(".");
  if (pathAry.length == 1) {
    return obj[path];
  } else if (pathAry.length > 1) {
    let ret = obj;
    for (var i = 0; i < pathAry.length; i++) {
      if (ret === null || ret === void 0) {
        return null;
      }
      const key2 = pathAry[i];
      const match = /^(\w+)\[(\d+)\]$/.exec(key2);
      if (match) {
        ret = ret[match[1]][match[2]];
      } else if (ret && ret.constructor === Array) {
        let index2 = 0;
        if (subIndex != null && subIndex != void 0) {
          let preIndex = Number.parseInt(subIndex);
          if (!isNaN(preIndex)) {
            index2 = preIndex;
          }
        }
        ret = ret[index2][key2];
      } else {
        ret = ret[key2];
      }
    }
    return ret;
  }
  return null;
}
function setValueByPath(obj, path, value9, subIndex) {
  if (!obj || !path || path.constructor != String) {
    return;
  }
  if (!/^\w?.*[\w|\]]$/.test(path)) {
    return;
  }
  let pathAry = path.split(".");
  if (pathAry.length == 1) {
    obj[path] = value9;
  } else if (pathAry.length > 1) {
    let ret = obj;
    for (var i = 0; i < pathAry.length; i++) {
      const key2 = pathAry[i];
      const match = /^(\w+)\[(\d+)\]$/.exec(key2);
      if (i == pathAry.length - 1) {
        if (match) {
          ret[match[1]][match[2]] = value9;
        } else if (ret && ret.constructor === Array) {
          let index2 = 0;
          if (subIndex != null && subIndex != void 0) {
            let preIndex = Number.parseInt(subIndex);
            if (!isNaN(preIndex)) {
              index2 = preIndex;
            }
          }
          ret[index2][key2] = value9;
        } else {
          ret[key2] = value9;
        }
      } else {
        if (match) {
          ret = ret[match[1]][match[2]];
        } else {
          ret = ret[key2];
        }
      }
    }
  }
}
const revertTree2List = (tree, value9, config) => {
  const arr = [];
  function revertTree(tree2, value10, config2, list) {
    let flag = false;
    if (!tree2)
      return;
    const _key = Object.keys(config2);
    const _value = Object.values(config2);
    if (_key.length > 1) {
      /* @__PURE__ */ console.error("\u53EA\u80FD\u5224\u65AD\u4E00\u4E2A\u8FD4\u56DE\u6761\u4EF6");
      return;
    }
    if (tree2[_key[0]] === value10 || flag) {
      list.push(tree2[_value[0]]);
      return true;
    }
    if (Array.isArray(tree2)) {
      flag = tree2.some((item) => revertTree(item, value10, config2, list));
    }
    if (tree2.children && tree2.children.length !== 0) {
      flag = tree2.children.some((item) => revertTree(item, value10, config2, list));
    }
    if (flag) {
      list.push(tree2[_value[0]]);
      return true;
    }
    return false;
  }
  revertTree(tree, value9, config, arr);
  const result = arr.filter((x) => !!x).reverse();
  return result;
};
function proxyGetCurrentInstance() {
  const proxy = getCurrentInstance().proxy;
  const emit2 = proxy.$emit.bind(proxy);
  const {
    $vnode: vnode,
    $slots: slots2,
    $refs,
    $root: root2
  } = proxy;
  return {
    vnode,
    slots: slots2,
    root: root2,
    $refs,
    emit: emit2
  };
}
function initFieldsToArray(config) {
  let fields = Object.keys(config);
  let fieldsArr = {};
  fields.map((field) => {
    fieldsArr[`${field}Arr`] = [];
  });
  return {
    fieldsArr,
    fields
  };
}
function arrayStringSplitToObject(valAry, fieldsArr, fields) {
  let ary = [];
  valAry.forEach((m, index2) => {
    let item = {
      name: m
    };
    fields.map((field) => {
      if (fieldsArr[`${field}Arr`].length > index2) {
        item[field] = fieldsArr[`${field}Arr`][index2];
      }
    });
    ary.push(item);
  });
  return ary;
}
function useVForm(config) {
  const {
    vnode
  } = proxyGetCurrentInstance();
  const vFormInst = ref(null);
  const getArrayValFromVForm = (value9) => {
    let _tempAry = [];
    const {
      fieldsArr,
      fields
    } = initFieldsToArray(config.value);
    if (config.value && fields.length > 0) {
      fields.map((field) => {
        if (hasOwnPropertyCall(config.value, field)) {
          let fieldVal = getValueByPath(vFormInst.value, config.value[field]);
          if (fieldVal) {
            fieldsArr[`${field}Arr`] = fieldVal.split(",").trim();
          }
        }
      });
    }
    if (value9) {
      const _valAry = value9.split(",").trim();
      _tempAry = arrayStringSplitToObject(_valAry, fieldsArr, fields);
    }
    return _tempAry;
  };
  const setValToVForm = (list) => {
    const {
      fieldsArr,
      fields
    } = initFieldsToArray(config.value);
    if (list && Array.isArray(list)) {
      list.forEach((m) => {
        fields.forEach((field) => {
          if (hasOwnPropertyCall(m, field)) {
            fieldsArr[`${field}Arr`].push(m[field]);
          }
        });
      });
      if (config.value) {
        fields.forEach((field) => {
          if (hasOwnPropertyCall(config.value, field)) {
            setValueByPath(vFormInst.value, config.value[field], fieldsArr[`${field}Arr`].join(","));
          }
        });
      }
    }
  };
  function getWatchMapInstance(instance2) {
    if (!instance2) {
      return null;
    }
    if (hasOwnPropertyCall(instance2, "watchMap")) {
      return instance2;
    } else {
      return getWatchMapInstance(instance2.$parent);
    }
  }
  onMounted(() => {
    vFormInst.value = getWatchMapInstance(vnode.context);
  });
  return {
    vFormInst,
    getArrayValFromVForm,
    setValToVForm
  };
}
function useVModel(value9, defaultValue, onChange, eventName) {
  const {
    emit: emit2,
    vnode
  } = proxyGetCurrentInstance();
  const internalValue = ref();
  internalValue.value = defaultValue;
  if (Object.prototype.hasOwnProperty.call(vnode.componentOptions.propsData, "value")) {
    return [value9, (newValue, ...args) => {
      emit2 == null ? void 0 : emit2("input", newValue, ...args);
      onChange == null ? void 0 : onChange(newValue, ...args);
      if (eventName && eventName !== "input") {
        emit2 == null ? void 0 : emit2(eventName, newValue, ...args);
      }
    }];
  }
  return [internalValue, (newValue, ...args) => {
    internalValue.value = newValue;
    onChange == null ? void 0 : onChange(newValue, ...args);
    if (eventName && eventName !== "input") {
      emit2 == null ? void 0 : emit2(eventName, newValue, ...args);
    }
  }];
}
const ajax$3 = (config) => new AjaxConfig(config);
const JS_API_SIGNATURE = ajax$3().post("/appcenter/anonymous/wx/mp/createJsApiSignature");
const AGENT_JS_API_SIGNATURE = ajax$3().post("/appcenter/anonymous/wx/cp/createAgentJsApiSignature");
const JS_API_SIGNATURE_WXWORK = ajax$3().post("/appcenter/anonymous/wx/cp/createJsApiSignature");
const JsApiSignature = (params) => {
  return new Promise((resolve, reject) => {
    request(JS_API_SIGNATURE, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const AgentJsApiSignature = (params) => {
  return new Promise((resolve, reject) => {
    request(AGENT_JS_API_SIGNATURE, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const WxworkJsApiSignature = (params) => {
  return new Promise((resolve, reject) => {
    request(JS_API_SIGNATURE_WXWORK, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
function remoteLoad(url2, isCallback) {
  const r = {
    createScript: null,
    removeScript: null
  };
  r.createScript = (url22) => {
    const scriptElement = document.createElement("script");
    document.body.appendChild(scriptElement);
    const promise = new Promise((resolve, reject) => {
      scriptElement.addEventListener("load", (e) => {
        r.removeScript(scriptElement);
        if (!isCallback) {
          resolve(e);
        }
      }, false);
      scriptElement.addEventListener("error", (e) => {
        r.removeScript(scriptElement);
        reject(e);
      }, false);
      if (isCallback) {
        window.callback = () => {
          resolve();
          window.callback = null;
        };
      }
    });
    if (isCallback) {
      url22 += "&callback=callback";
    }
    scriptElement.src = url22;
    return promise;
  };
  r.removeScript = (scriptElement) => {
    document.body.removeChild(scriptElement);
  };
  return r.createScript(url2);
}
const JS_API_LIST = ["checkJsApi", "chooseImage", "getLocalImgData"];
if (inBrowser$1) {
  window.__wxConfig__ = false;
}
function useWxJsSdk(jsApiList = []) {
  const _jsApiList = JS_API_LIST.concat(jsApiList);
  async function initWeChatConfig(appid, debug = false) {
    if (!window.wx) {
      await remoteLoad("https://res2.wx.qq.com/open/js/jweixin-1.6.0.js");
    }
    const href = window.location.href.split("#")[0];
    const res = await JsApiSignature({
      appid,
      url: href
    }).catch((err) => {
      throw new Error("\u83B7\u53D6\u5FAE\u4FE1JS-SDK\u7B7E\u540D\u5931\u8D25");
    });
    const signatureData = res.data;
    wx.config({
      beta: true,
      debug,
      jsApiList: _jsApiList,
      appId: appid,
      timestamp: signatureData.timestamp,
      nonceStr: signatureData.nonceStr,
      signature: signatureData.signature
    });
    return new Promise((resolve, reject) => {
      wx.ready(() => {
        window.__wxConfig__ = true;
        resolve(true);
      });
      wx.error((err) => {
        throw new Error(`\u5FAE\u4FE1config\u521D\u59CB\u5316\u5931\u8D25:${err}`);
      });
    });
  }
  async function initWxWrokConfig(corpId, agentId, debug = false) {
    if (!window.wx) {
      await remoteLoad("https://res.wx.qq.com/wwopen/js/jsapi/jweixin-1.0.0.js");
    }
    const params = {
      corpId,
      agentId,
      url: location.href.split("#")[0]
    };
    const res = await WxworkJsApiSignature(params).catch((err) => {
      throw new Error("\u83B7\u53D6\u5FAE\u4FE1JS-SDK\u7B7E\u540D\u5931\u8D25");
    });
    const signatureData = res.data;
    wx.config({
      beta: true,
      debug: debug || false,
      jsApiList: _jsApiList,
      appId: corpId,
      timestamp: signatureData.timestamp,
      nonceStr: signatureData.nonceStr,
      signature: signatureData.signature
    });
    return new Promise((resolve, reject) => {
      wx.ready(async () => {
        const res2 = await AgentJsApiSignature(params).catch((err) => {
          throw new Error("\u83B7\u53D6\u4F01\u4E1A\u5FAE\u4FE1JS-SDK\u7B7E\u540D\u5931\u8D25");
        });
        const agentSignatureData = res2.data;
        wx.agentConfig({
          corpid: corpId,
          agentid: agentId,
          timestamp: agentSignatureData.timestamp,
          nonceStr: agentSignatureData.nonceStr,
          signature: agentSignatureData.signature,
          jsApiList: _jsApiList,
          success() {
            window.__wxConfig__ = true;
            resolve(true);
          },
          fail(err) {
            throw new Error(`\u4F01\u5FAE\u5E94\u7528\u521D\u59CB\u5316\u5931\u8D25:${err.errMsg}`);
          }
        });
      });
      wx.error((err) => {
        throw new Error(`\u5FAE\u4FE1config\u521D\u59CB\u5316\u5931\u8D25:${err}`);
      });
    });
  }
  async function wxCheckJsApi(apiList) {
    return new Promise((resolve) => {
      wx.checkJsApi({
        jsApiList: apiList,
        success: function(res) {
          const {
            checkResult
          } = res;
          resolve(checkResult);
        }
      });
    });
  }
  return {
    initWeChatConfig,
    initWxWrokConfig,
    wxCheckJsApi,
    isWx,
    isWxwork,
    isMiniProgram
  };
}
const defaultHeaders = {
  common: {
    Accept: "application/json, text/plain, */*"
  },
  delete: {},
  get: {},
  head: {},
  post: {
    "Content-Type": "application/x-www-form-urlencoded"
  },
  put: {
    "Content-Type": "application/x-www-form-urlencoded"
  },
  patch: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
};
const key = "3c795988673006361073d4899d373583";
const api = {
  ip: "https://restapi.amap.com/v3/ip",
  geo: "https://restapi.amap.com/v3/geocode/geo",
  regeo: "https://restapi.amap.com/v3/geocode/regeo",
  district: "https://restapi.amap.com/v3/config/district",
  keywordsSearch: "https://restapi.amap.com/v5/place/text",
  aroundSearch: "https://restapi.amap.com/v5/place/around"
};
const createFn = (url2) => {
  return (params, config = {}) => {
    axios.defaults.headers = defaultHeaders;
    return axios.get(url2, __spreadProps(__spreadValues({}, config), {
      params: __spreadProps(__spreadValues({}, params), {
        key
      })
    })).then((rs) => rs.data);
  };
};
const fn = {};
Object.keys(api).forEach((key2) => {
  fn[key2] = createFn(api[key2]);
});
const AUTO_COMPLETE_SELECT = "autoCompleteSelect";
const SET_MARKER = "setMarker";
const EVENT_TYPE = {
  AUTO_COMPLETE_SELECT,
  SET_MARKER
};
function useAmapJsApi(options = {}) {
  const {
    elIds = {},
    mapConfig = {},
    plugins: plugins2 = [],
    callback: callback2
  } = options;
  const {
    container: containerElId,
    search: searchElId
  } = elIds;
  if (!containerElId) {
    throw new Error("\u5FC5\u987B\u4F20\u5165\u5730\u56FE\u5BB9\u5668id");
  }
  const map = shallowRef(null);
  let AMap = null;
  const geocoder = ref(null);
  const autoComplete = ref(null);
  const marker = ref(null);
  ref([]);
  const location2 = ref({
    address: "",
    lnglat: null,
    regeocode: {},
    localCity: {}
  });
  const config = __spreadValues({
    zoom: 11
  }, mapConfig);
  if (inBrowser$1) {
    window._AMapSecurityConfig = {
      securityJsCode: "84d429a2ddf02b70bee754263757e3a8"
    };
  }
  async function initMap() {
    if (!inBrowser$1) {
      return;
    }
    if (!window.AMapLoader) {
      await remoteLoad("https://webapi.amap.com/loader.js");
    }
    AMap = await window.AMapLoader.load({
      key: "22cbea3b00cb73af8c1a75567377fbf0",
      version: "2.0",
      plugins: ["AMap.Marker"]
    });
    map.value = new AMap.Map(containerElId, config);
    map.value.on("click", function(ev) {
      setSingleMarker(ev.lnglat);
    });
    const _plugins = ["AMap.Geocoder", "AMap.CitySearch", "AMap.Geolocation", "AMap.AutoComplete"];
    _plugins.push(...plugins2);
    AMap.plugin(_plugins, async () => {
      geocoder.value = new AMap.Geocoder({
        city: ""
      });
      const {
        city
      } = await getLocalCity();
      autoCompleteInit(city);
    });
  }
  const setSingleMarker = async (lnglat, customAddress) => {
    const _lnglat = translateLnglat(lnglat);
    if (marker.value) {
      map.value.remove(marker.value);
    }
    await getAddressByLnglat(_lnglat);
    if (customAddress) {
      location2.value.address = customAddress;
    }
    marker.value = new AMap.Marker({
      position: _lnglat,
      title: location2.value.address
    });
    map.value.add(marker.value);
    setMarkerText(location2.value.address);
    handleCallback(EVENT_TYPE.SET_MARKER);
  };
  const getAddressByLnglat = (lnglat) => {
    return new Promise((resolve, reject) => {
      geocoder.value.getAddress(lnglat, (status, result) => {
        if (status === "complete" && result.info === "OK") {
          location2.value.regeocode = result.regeocode;
          location2.value.address = result.regeocode.formattedAddress;
          location2.value.lnglat = lnglat;
          resolve(location2.value);
        } else {
          reject(result);
        }
      });
    });
  };
  const setCenter = (lnglat, zoom2 = 16) => {
    const _lnglat = translateLnglat(lnglat);
    map.value.setCenter(_lnglat);
    map.value.setZoom(zoom2);
  };
  function setMarkerText(text) {
    let content = `
    <div style="background-color: #fc9153;color:#fff;padding:0 5px;">
      <p>${text}</p>
    <div>
  `;
    let infoWindow = new AMap.InfoWindow({
      isCustom: true,
      content,
      offset: new AMap.Pixel(16, -50)
    });
    infoWindow.open(map.value, marker.value.getPosition());
  }
  function getLocalCity() {
    return new Promise((resolve, reject) => {
      const citySerach = new AMap.CitySearch();
      citySerach.getLocalCity((status, result) => {
        if (status === "complete" && result.info === "OK") {
          location2.value.localCity = {
            city: result.city,
            province: result.province,
            adcode: result.adcode,
            rectangle: result.rectangle
          };
          resolve({
            city: result.city,
            province: result.province,
            adcode: result.adcode,
            rectangle: result.rectangle
          });
        } else {
          reject(result);
        }
      });
    });
  }
  function autoCompleteInit(city) {
    autoComplete.value = new AMap.AutoComplete({
      city,
      input: searchElId
    });
    if (searchElId) {
      autoComplete.value.on("select", async (data22) => {
        const {
          poi
        } = data22;
        await setSingleMarker(poi.location, poi.address);
        setCenter(poi.location);
        handleCallback(EVENT_TYPE.AUTO_COMPLETE_SELECT);
      });
    }
  }
  function handleCallback(event) {
    if (callback2) {
      callback2(event);
    }
  }
  function translateLnglat(val) {
    if (Array.isArray(val)) {
      return new AMap.LngLat(val[0], val[1]);
    } else {
      return val;
    }
  }
  return {
    EVENT_TYPE,
    map,
    AMap,
    autoComplete,
    geocoder,
    location: location2,
    marker,
    setSingleMarker,
    getAddressByLnglat,
    initMap,
    setCenter,
    translateLnglat
  };
}
var base = "";
var index$y = "";
var index$x = "";
var index$w = "";
var index$v = "";
var index$u = "";
var index$t = "";
var index$s = "";
var index$r = "";
var index$q = "";
function _extends$o() {
  _extends$o = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$o.apply(this, arguments);
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var a = Object.defineProperty({}, "__esModule", {
    value: true
  });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
function _extends$n() {
  return _extends$n = Object.assign || function(a) {
    for (var b, c = 1; c < arguments.length; c++)
      for (var d in b = arguments[c], b)
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
    return a;
  }, _extends$n.apply(this, arguments);
}
var normalMerge = ["attrs", "props", "domProps"], toArrayMerge = ["class", "style", "directives"], functionalMerge = ["on", "nativeOn"], mergeJsxProps = function(a) {
  return a.reduce(function(c, a2) {
    for (var b in a2)
      if (!c[b])
        c[b] = a2[b];
      else if (normalMerge.indexOf(b) !== -1)
        c[b] = _extends$n({}, c[b], a2[b]);
      else if (toArrayMerge.indexOf(b) !== -1) {
        var d = c[b] instanceof Array ? c[b] : [c[b]], e = a2[b] instanceof Array ? a2[b] : [a2[b]];
        c[b] = d.concat(e);
      } else if (functionalMerge.indexOf(b) !== -1) {
        for (var f in a2[b])
          if (c[b][f]) {
            var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]], h = a2[b][f] instanceof Array ? a2[b][f] : [a2[b][f]];
            c[b][f] = g.concat(h);
          } else
            c[b][f] = a2[b][f];
      } else if (b == "hook")
        for (var i in a2[b])
          c[b][i] = c[b][i] ? mergeFn(c[b][i], a2[b][i]) : a2[b][i];
      else
        c[b] = a2[b];
    return c;
  }, {});
}, mergeFn = function(a, b) {
  return function() {
    a && a.apply(this, arguments), b && b.apply(this, arguments);
  };
};
var helper = mergeJsxProps;
var _mergeJSXProps = helper;
function gen(name, mods) {
  if (!mods) {
    return "";
  }
  if (typeof mods === "string") {
    return " " + name + "--" + mods;
  }
  if (Array.isArray(mods)) {
    return mods.reduce(function(ret, item) {
      return ret + gen(name, item);
    }, "");
  }
  return Object.keys(mods).reduce(function(ret, key2) {
    return ret + (mods[key2] ? gen(name, key2) : "");
  }, "");
}
function createBEM(name) {
  return function(el, mods) {
    if (el && typeof el !== "string") {
      mods = el;
      el = "";
    }
    el = el ? name + "__" + el : name;
    return "" + el + gen(el, mods);
  };
}
var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function assignKey(to, from, key2) {
  var val = from[key2];
  if (!isDef$1(val)) {
    return;
  }
  if (!hasOwnProperty$2.call(to, key2) || !isObject$2(val)) {
    to[key2] = val;
  } else {
    to[key2] = deepAssign(Object(to[key2]), from[key2]);
  }
}
function deepAssign(to, from) {
  Object.keys(from).forEach(function(key2) {
    assignKey(to, from, key2);
  });
  return to;
}
var defaultMessages = {
  name: "\u59D3\u540D",
  tel: "\u7535\u8BDD",
  save: "\u4FDD\u5B58",
  confirm: "\u786E\u8BA4",
  cancel: "\u53D6\u6D88",
  delete: "\u5220\u9664",
  complete: "\u5B8C\u6210",
  loading: "\u52A0\u8F7D\u4E2D...",
  telEmpty: "\u8BF7\u586B\u5199\u7535\u8BDD",
  nameEmpty: "\u8BF7\u586B\u5199\u59D3\u540D",
  nameInvalid: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u59D3\u540D",
  confirmDelete: "\u786E\u5B9A\u8981\u5220\u9664\u5417",
  telInvalid: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7",
  vanCalendar: {
    end: "\u7ED3\u675F",
    start: "\u5F00\u59CB",
    title: "\u65E5\u671F\u9009\u62E9",
    confirm: "\u786E\u5B9A",
    startEnd: "\u5F00\u59CB/\u7ED3\u675F",
    weekdays: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
    monthTitle: function monthTitle(year, month) {
      return year + "\u5E74" + month + "\u6708";
    },
    rangePrompt: function rangePrompt(maxRange) {
      return "\u9009\u62E9\u5929\u6570\u4E0D\u80FD\u8D85\u8FC7 " + maxRange + " \u5929";
    }
  },
  vanCascader: {
    select: "\u8BF7\u9009\u62E9"
  },
  vanContactCard: {
    addText: "\u6DFB\u52A0\u8054\u7CFB\u4EBA"
  },
  vanContactList: {
    addText: "\u65B0\u5EFA\u8054\u7CFB\u4EBA"
  },
  vanPagination: {
    prev: "\u4E0A\u4E00\u9875",
    next: "\u4E0B\u4E00\u9875"
  },
  vanPullRefresh: {
    pulling: "\u4E0B\u62C9\u5373\u53EF\u5237\u65B0...",
    loosing: "\u91CA\u653E\u5373\u53EF\u5237\u65B0..."
  },
  vanSubmitBar: {
    label: "\u5408\u8BA1\uFF1A"
  },
  vanCoupon: {
    unlimited: "\u65E0\u4F7F\u7528\u95E8\u69DB",
    discount: function discount(_discount) {
      return _discount + "\u6298";
    },
    condition: function condition(_condition) {
      return "\u6EE1" + _condition + "\u5143\u53EF\u7528";
    }
  },
  vanCouponCell: {
    title: "\u4F18\u60E0\u5238",
    tips: "\u6682\u65E0\u53EF\u7528",
    count: function count(_count) {
      return _count + "\u5F20\u53EF\u7528";
    }
  },
  vanCouponList: {
    empty: "\u6682\u65E0\u4F18\u60E0\u5238",
    exchange: "\u5151\u6362",
    close: "\u4E0D\u4F7F\u7528\u4F18\u60E0\u5238",
    enable: "\u53EF\u7528",
    disabled: "\u4E0D\u53EF\u7528",
    placeholder: "\u8BF7\u8F93\u5165\u4F18\u60E0\u7801"
  },
  vanAddressEdit: {
    area: "\u5730\u533A",
    postal: "\u90AE\u653F\u7F16\u7801",
    areaEmpty: "\u8BF7\u9009\u62E9\u5730\u533A",
    addressEmpty: "\u8BF7\u586B\u5199\u8BE6\u7EC6\u5730\u5740",
    postalEmpty: "\u90AE\u653F\u7F16\u7801\u683C\u5F0F\u4E0D\u6B63\u786E",
    defaultAddress: "\u8BBE\u4E3A\u9ED8\u8BA4\u6536\u8D27\u5730\u5740",
    telPlaceholder: "\u6536\u8D27\u4EBA\u624B\u673A\u53F7",
    namePlaceholder: "\u6536\u8D27\u4EBA\u59D3\u540D",
    areaPlaceholder: "\u9009\u62E9\u7701 / \u5E02 / \u533A"
  },
  vanAddressEditDetail: {
    label: "\u8BE6\u7EC6\u5730\u5740",
    placeholder: "\u8857\u9053\u95E8\u724C\u3001\u697C\u5C42\u623F\u95F4\u53F7\u7B49\u4FE1\u606F"
  },
  vanAddressList: {
    add: "\u65B0\u589E\u5730\u5740"
  }
};
var proto = Vue$1.prototype;
var defineReactive = Vue$1.util.defineReactive;
defineReactive(proto, "$vantLang", "zh-CN");
defineReactive(proto, "$vantMessages", {
  "zh-CN": defaultMessages
});
var locale$2 = {
  messages: function messages() {
    return proto.$vantMessages[proto.$vantLang];
  },
  use: function use(lang2, messages2) {
    var _this$add;
    proto.$vantLang = lang2;
    this.add((_this$add = {}, _this$add[lang2] = messages2, _this$add));
  },
  add: function add(messages2) {
    if (messages2 === void 0) {
      messages2 = {};
    }
    deepAssign(proto.$vantMessages, messages2);
  }
};
var camelizeRE = /-(\w)/g;
function camelize$1(str) {
  return str.replace(camelizeRE, function(_, c) {
    return c.toUpperCase();
  });
}
var SlotsMixin = {
  methods: {
    slots: function slots(name, props2) {
      if (name === void 0) {
        name = "default";
      }
      var $slots = this.$slots, $scopedSlots = this.$scopedSlots;
      var scopedSlot = $scopedSlots[name];
      if (scopedSlot) {
        return scopedSlot(props2);
      }
      return $slots[name];
    }
  }
};
function install$2(Vue2) {
  var name = this.name;
  Vue2.component(name, this);
  Vue2.component(camelize$1("-" + name), this);
}
function unifySlots(context2) {
  var scopedSlots = context2.scopedSlots || context2.data.scopedSlots || {};
  var slots2 = context2.slots();
  Object.keys(slots2).forEach(function(key2) {
    if (!scopedSlots[key2]) {
      scopedSlots[key2] = function() {
        return slots2[key2];
      };
    }
  });
  return scopedSlots;
}
function transformFunctionComponent(pure) {
  return {
    functional: true,
    props: pure.props,
    model: pure.model,
    render: function render28(h, context2) {
      return pure(h, context2.props, unifySlots(context2), context2);
    }
  };
}
function createComponent$B(name) {
  return function(sfc) {
    if (isFunction$2(sfc)) {
      sfc = transformFunctionComponent(sfc);
    }
    if (!sfc.functional) {
      sfc.mixins = sfc.mixins || [];
      sfc.mixins.push(SlotsMixin);
    }
    sfc.name = name;
    sfc.install = install$2;
    return sfc;
  };
}
function createI18N(name) {
  var prefix = camelize$1(name) + ".";
  return function(path) {
    var messages2 = locale$2.messages();
    var message2 = get(messages2, prefix + path) || get(messages2, path);
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return isFunction$2(message2) ? message2.apply(void 0, args) : message2;
  };
}
function createNamespace(name) {
  name = "van-" + name;
  return [createComponent$B(name), createBEM(name), createI18N(name)];
}
function isNumeric(val) {
  return /^\d+(\.\d+)?$/.test(val);
}
function addUnit(value9) {
  if (!isDef$1(value9)) {
    return void 0;
  }
  value9 = String(value9);
  return isNumeric(value9) ? value9 + "px" : value9;
}
var rootFontSize;
function getRootFontSize() {
  if (!rootFontSize) {
    var doc = document.documentElement;
    var fontSize = doc.style.fontSize || window.getComputedStyle(doc).fontSize;
    rootFontSize = parseFloat(fontSize);
  }
  return rootFontSize;
}
function convertRem(value9) {
  value9 = value9.replace(/rem/g, "");
  return +value9 * getRootFontSize();
}
function convertVw(value9) {
  value9 = value9.replace(/vw/g, "");
  return +value9 * window.innerWidth / 100;
}
function convertVh(value9) {
  value9 = value9.replace(/vh/g, "");
  return +value9 * window.innerHeight / 100;
}
function unitToPx(value9) {
  if (typeof value9 === "number") {
    return value9;
  }
  if (inBrowser) {
    if (value9.indexOf("rem") !== -1) {
      return convertRem(value9);
    }
    if (value9.indexOf("vw") !== -1) {
      return convertVw(value9);
    }
    if (value9.indexOf("vh") !== -1) {
      return convertVh(value9);
    }
  }
  return parseFloat(value9);
}
var inBrowser = typeof window !== "undefined";
var isServer$3 = Vue$1.prototype.$isServer;
function noop$1() {
}
function isDef$1(val) {
  return val !== void 0 && val !== null;
}
function isFunction$2(val) {
  return typeof val === "function";
}
function isObject$2(val) {
  return val !== null && typeof val === "object";
}
function isPromise(val) {
  return isObject$2(val) && isFunction$2(val.then) && isFunction$2(val.catch);
}
function get(object, path) {
  var keys = path.split(".");
  var result = object;
  keys.forEach(function(key2) {
    var _result$key;
    result = (_result$key = result[key2]) != null ? _result$key : "";
  });
  return result;
}
var BORDER = "van-hairline";
var BORDER_TOP = BORDER + "--top";
var BORDER_LEFT = BORDER + "--left";
var BORDER_BOTTOM = BORDER + "--bottom";
var BORDER_SURROUND = BORDER + "--surround";
var BORDER_TOP_BOTTOM = BORDER + "--top-bottom";
var context = {
  zIndex: 2e3,
  lockCount: 0,
  stack: [],
  find: function find(vm) {
    return this.stack.filter(function(item) {
      return item.vm === vm;
    })[0];
  },
  remove: function remove(vm) {
    var item = this.find(vm);
    if (!item)
      return;
    item.vm = null;
    item.overlay = null;
    var index2 = this.stack.indexOf(item);
    this.stack.splice(index2, 1);
  }
};
var inheritKey = ["ref", "key", "style", "class", "attrs", "refInFor", "nativeOn", "directives", "staticClass", "staticStyle"];
var mapInheritKey = {
  nativeOn: "on"
};
function inherit(context2, inheritListeners) {
  var result = inheritKey.reduce(function(obj, key2) {
    if (context2.data[key2]) {
      obj[mapInheritKey[key2] || key2] = context2.data[key2];
    }
    return obj;
  }, {});
  if (inheritListeners) {
    result.on = result.on || {};
    _extends$o(result.on, context2.data.on);
  }
  return result;
}
function emit$2(context2, eventName) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  var listeners3 = context2.listeners[eventName];
  if (listeners3) {
    if (Array.isArray(listeners3)) {
      listeners3.forEach(function(listener) {
        listener.apply(void 0, args);
      });
    } else {
      listeners3.apply(void 0, args);
    }
  }
}
function mount(Component2, data22) {
  var instance2 = new Vue$1({
    el: document.createElement("div"),
    props: Component2.props,
    render: function render28(h) {
      return h(Component2, _extends$o({
        props: this.$props
      }, data22));
    }
  });
  document.body.appendChild(instance2.$el);
  return instance2;
}
var supportsPassive = false;
if (!isServer$3) {
  try {
    var opts = {};
    Object.defineProperty(opts, "passive", {
      get: function get5() {
        supportsPassive = true;
      }
    });
    window.addEventListener("test-passive", null, opts);
  } catch (e) {
  }
}
function on$3(target, event, handler, passive) {
  if (passive === void 0) {
    passive = false;
  }
  if (!isServer$3) {
    target.addEventListener(event, handler, supportsPassive ? {
      capture: false,
      passive
    } : false);
  }
}
function off$3(target, event, handler) {
  if (!isServer$3) {
    target.removeEventListener(event, handler);
  }
}
function stopPropagation(event) {
  event.stopPropagation();
}
function preventDefault(event, isStopPropagation) {
  if (typeof event.cancelable !== "boolean" || event.cancelable) {
    event.preventDefault();
  }
  if (isStopPropagation) {
    stopPropagation(event);
  }
}
var _createNamespace$A = createNamespace("overlay"), createComponent$A = _createNamespace$A[0], bem$A = _createNamespace$A[1];
function preventTouchMove(event) {
  preventDefault(event, true);
}
function Overlay(h, props2, slots2, ctx) {
  var style6 = _extends$o({
    zIndex: props2.zIndex
  }, props2.customStyle);
  if (isDef$1(props2.duration)) {
    style6.animationDuration = props2.duration + "s";
  }
  return h("transition", {
    "attrs": {
      "name": "van-fade"
    }
  }, [h("div", _mergeJSXProps([{
    "directives": [{
      name: "show",
      value: props2.show
    }],
    "style": style6,
    "class": [bem$A(), props2.className],
    "on": {
      "touchmove": props2.lockScroll ? preventTouchMove : noop$1
    }
  }, inherit(ctx, true)]), [slots2.default == null ? void 0 : slots2.default()])]);
}
Overlay.props = {
  show: Boolean,
  zIndex: [Number, String],
  duration: [Number, String],
  className: null,
  customStyle: Object,
  lockScroll: {
    type: Boolean,
    default: true
  }
};
var Overlay$1 = createComponent$A(Overlay);
function removeNode$1(el) {
  var parent = el.parentNode;
  if (parent) {
    parent.removeChild(el);
  }
}
var defaultConfig$1 = {
  className: "",
  customStyle: {}
};
function mountOverlay(vm) {
  return mount(Overlay$1, {
    on: {
      click: function click2() {
        vm.$emit("click-overlay");
        if (vm.closeOnClickOverlay) {
          if (vm.onClickOverlay) {
            vm.onClickOverlay();
          } else {
            vm.close();
          }
        }
      }
    }
  });
}
function updateOverlay(vm) {
  var item = context.find(vm);
  if (item) {
    var el = vm.$el;
    var config = item.config, overlay = item.overlay;
    if (el && el.parentNode) {
      el.parentNode.insertBefore(overlay.$el, el);
    }
    _extends$o(overlay, defaultConfig$1, config, {
      show: true
    });
  }
}
function openOverlay(vm, config) {
  var item = context.find(vm);
  if (item) {
    item.config = config;
  } else {
    var overlay = mountOverlay(vm);
    context.stack.push({
      vm,
      config,
      overlay
    });
  }
  updateOverlay(vm);
}
function closeOverlay(vm) {
  var item = context.find(vm);
  if (item) {
    item.overlay.show = false;
  }
}
function removeOverlay(vm) {
  var item = context.find(vm);
  if (item) {
    removeNode$1(item.overlay.$el);
    context.remove(vm);
  }
}
function isWindow(val) {
  return val === window;
}
var overflowScrollReg = /scroll|auto/i;
function getScroller(el, root2) {
  if (root2 === void 0) {
    root2 = window;
  }
  var node2 = el;
  while (node2 && node2.tagName !== "HTML" && node2.tagName !== "BODY" && node2.nodeType === 1 && node2 !== root2) {
    var _window$getComputedSt = window.getComputedStyle(node2), overflowY = _window$getComputedSt.overflowY;
    if (overflowScrollReg.test(overflowY)) {
      return node2;
    }
    node2 = node2.parentNode;
  }
  return root2;
}
function getScrollTop(el) {
  var top = "scrollTop" in el ? el.scrollTop : el.pageYOffset;
  return Math.max(top, 0);
}
function setScrollTop(el, value9) {
  if ("scrollTop" in el) {
    el.scrollTop = value9;
  } else {
    el.scrollTo(el.scrollX, value9);
  }
}
function getRootScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}
function setRootScrollTop(value9) {
  setScrollTop(window, value9);
  setScrollTop(document.body, value9);
}
function getElementTop(el, scroller) {
  if (isWindow(el)) {
    return 0;
  }
  var scrollTop = scroller ? getScrollTop(scroller) : getRootScrollTop();
  return el.getBoundingClientRect().top + scrollTop;
}
function getVisibleHeight(el) {
  if (isWindow(el)) {
    return el.innerHeight;
  }
  return el.getBoundingClientRect().height;
}
function getVisibleTop(el) {
  if (isWindow(el)) {
    return 0;
  }
  return el.getBoundingClientRect().top;
}
function getDirection(x, y) {
  if (x > y) {
    return "horizontal";
  }
  if (y > x) {
    return "vertical";
  }
  return "";
}
var TouchMixin = {
  data: function data() {
    return {
      direction: ""
    };
  },
  methods: {
    touchStart: function touchStart(event) {
      this.resetTouchStatus();
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
    },
    touchMove: function touchMove(event) {
      var touch = event.touches[0];
      this.deltaX = touch.clientX < 0 ? 0 : touch.clientX - this.startX;
      this.deltaY = touch.clientY - this.startY;
      this.offsetX = Math.abs(this.deltaX);
      this.offsetY = Math.abs(this.deltaY);
      var LOCK_DIRECTION_DISTANCE = 10;
      if (!this.direction || this.offsetX < LOCK_DIRECTION_DISTANCE && this.offsetY < LOCK_DIRECTION_DISTANCE) {
        this.direction = getDirection(this.offsetX, this.offsetY);
      }
    },
    resetTouchStatus: function resetTouchStatus() {
      this.direction = "";
      this.deltaX = 0;
      this.deltaY = 0;
      this.offsetX = 0;
      this.offsetY = 0;
    },
    bindTouchEvent: function bindTouchEvent(el) {
      var onTouchStart4 = this.onTouchStart, onTouchMove4 = this.onTouchMove, onTouchEnd5 = this.onTouchEnd;
      on$3(el, "touchstart", onTouchStart4);
      on$3(el, "touchmove", onTouchMove4);
      if (onTouchEnd5) {
        on$3(el, "touchend", onTouchEnd5);
        on$3(el, "touchcancel", onTouchEnd5);
      }
    }
  }
};
function getElement(selector) {
  if (typeof selector === "string") {
    return document.querySelector(selector);
  }
  return selector();
}
function PortalMixin(_temp) {
  var _ref = _temp === void 0 ? {} : _temp, ref2 = _ref.ref, afterPortal = _ref.afterPortal;
  return {
    props: {
      getContainer: [String, Function]
    },
    watch: {
      getContainer: "portal"
    },
    mounted: function mounted12() {
      if (this.getContainer) {
        this.portal();
      }
    },
    methods: {
      portal: function portal() {
        var getContainer = this.getContainer;
        var el = ref2 ? this.$refs[ref2] : this.$el;
        var container;
        if (getContainer) {
          container = getElement(getContainer);
        } else if (this.$parent) {
          container = this.$parent.$el;
        }
        if (container && container !== el.parentNode) {
          container.appendChild(el);
        }
        if (afterPortal) {
          afterPortal.call(this);
        }
      }
    }
  };
}
var uid = 0;
function BindEventMixin(handler) {
  var key2 = "binded_" + uid++;
  function bind2() {
    if (!this[key2]) {
      handler.call(this, on$3, true);
      this[key2] = true;
    }
  }
  function unbind2() {
    if (this[key2]) {
      handler.call(this, off$3, false);
      this[key2] = false;
    }
  }
  return {
    mounted: bind2,
    activated: bind2,
    deactivated: unbind2,
    beforeDestroy: unbind2
  };
}
var CloseOnPopstateMixin = {
  mixins: [BindEventMixin(function(bind2, isBind) {
    this.handlePopstate(isBind && this.closeOnPopstate);
  })],
  props: {
    closeOnPopstate: Boolean
  },
  data: function data2() {
    return {
      bindStatus: false
    };
  },
  watch: {
    closeOnPopstate: function closeOnPopstate(val) {
      this.handlePopstate(val);
    }
  },
  methods: {
    onPopstate: function onPopstate() {
      this.close();
      this.shouldReopen = false;
    },
    handlePopstate: function handlePopstate(bind2) {
      if (this.$isServer) {
        return;
      }
      if (this.bindStatus !== bind2) {
        this.bindStatus = bind2;
        var action = bind2 ? on$3 : off$3;
        action(window, "popstate", this.onPopstate);
      }
    }
  }
};
var popupMixinProps = {
  transitionAppear: Boolean,
  value: Boolean,
  overlay: Boolean,
  overlayStyle: Object,
  overlayClass: String,
  closeOnClickOverlay: Boolean,
  zIndex: [Number, String],
  lockScroll: {
    type: Boolean,
    default: true
  },
  lazyRender: {
    type: Boolean,
    default: true
  }
};
function PopupMixin(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    mixins: [TouchMixin, CloseOnPopstateMixin, PortalMixin({
      afterPortal: function afterPortal() {
        if (this.overlay) {
          updateOverlay();
        }
      }
    })],
    provide: function provide3() {
      return {
        vanPopup: this
      };
    },
    props: popupMixinProps,
    data: function data22() {
      this.onReopenCallback = [];
      return {
        inited: this.value
      };
    },
    computed: {
      shouldRender: function shouldRender2() {
        return this.inited || !this.lazyRender;
      }
    },
    watch: {
      value: function value9(val) {
        var type = val ? "open" : "close";
        this.inited = this.inited || this.value;
        this[type]();
        if (!options.skipToggleEvent) {
          this.$emit(type);
        }
      },
      overlay: "renderOverlay"
    },
    mounted: function mounted12() {
      if (this.value) {
        this.open();
      }
    },
    activated: function activated2() {
      if (this.shouldReopen) {
        this.$emit("input", true);
        this.shouldReopen = false;
      }
    },
    beforeDestroy: function beforeDestroy4() {
      removeOverlay(this);
      if (this.opened) {
        this.removeLock();
      }
      if (this.getContainer) {
        removeNode$1(this.$el);
      }
    },
    deactivated: function deactivated() {
      if (this.value) {
        this.close();
        this.shouldReopen = true;
      }
    },
    methods: {
      open: function open3() {
        if (this.$isServer || this.opened) {
          return;
        }
        if (this.zIndex !== void 0) {
          context.zIndex = this.zIndex;
        }
        this.opened = true;
        this.renderOverlay();
        this.addLock();
        this.onReopenCallback.forEach(function(callback2) {
          callback2();
        });
      },
      addLock: function addLock() {
        if (this.lockScroll) {
          on$3(document, "touchstart", this.touchStart);
          on$3(document, "touchmove", this.onTouchMove);
          if (!context.lockCount) {
            document.body.classList.add("van-overflow-hidden");
          }
          context.lockCount++;
        }
      },
      removeLock: function removeLock() {
        if (this.lockScroll && context.lockCount) {
          context.lockCount--;
          off$3(document, "touchstart", this.touchStart);
          off$3(document, "touchmove", this.onTouchMove);
          if (!context.lockCount) {
            document.body.classList.remove("van-overflow-hidden");
          }
        }
      },
      close: function close3() {
        if (!this.opened) {
          return;
        }
        closeOverlay(this);
        this.opened = false;
        this.removeLock();
        this.$emit("input", false);
      },
      onTouchMove: function onTouchMove4(event) {
        this.touchMove(event);
        var direction = this.deltaY > 0 ? "10" : "01";
        var el = getScroller(event.target, this.$el);
        var scrollHeight = el.scrollHeight, offsetHeight = el.offsetHeight, scrollTop = el.scrollTop;
        var status = "11";
        if (scrollTop === 0) {
          status = offsetHeight >= scrollHeight ? "00" : "01";
        } else if (scrollTop + offsetHeight >= scrollHeight) {
          status = "10";
        }
        if (status !== "11" && this.direction === "vertical" && !(parseInt(status, 2) & parseInt(direction, 2))) {
          preventDefault(event, true);
        }
      },
      renderOverlay: function renderOverlay() {
        var _this = this;
        if (this.$isServer || !this.value) {
          return;
        }
        this.$nextTick(function() {
          _this.updateZIndex(_this.overlay ? 1 : 0);
          if (_this.overlay) {
            openOverlay(_this, {
              zIndex: context.zIndex++,
              duration: _this.duration,
              className: _this.overlayClass,
              customStyle: _this.overlayStyle
            });
          } else {
            closeOverlay(_this);
          }
        });
      },
      updateZIndex: function updateZIndex(value9) {
        if (value9 === void 0) {
          value9 = 0;
        }
        this.$el.style.zIndex = ++context.zIndex + value9;
      },
      onReopen: function onReopen(callback2) {
        this.onReopenCallback.push(callback2);
      }
    }
  };
}
function isRedundantNavigation(err) {
  return err.name === "NavigationDuplicated" || err.message && err.message.indexOf("redundant navigation") !== -1;
}
function route(router, config) {
  var to = config.to, url2 = config.url, replace = config.replace;
  if (to && router) {
    var promise = router[replace ? "replace" : "push"](to);
    if (promise && promise.catch) {
      promise.catch(function(err) {
        if (err && !isRedundantNavigation(err)) {
          throw err;
        }
      });
    }
  } else if (url2) {
    replace ? location.replace(url2) : location.href = url2;
  }
}
function functionalRoute(context2) {
  route(context2.parent && context2.parent.$router, context2.props);
}
var routeProps = {
  url: String,
  replace: Boolean,
  to: [String, Object]
};
var _createNamespace$z = createNamespace("info"), createComponent$z = _createNamespace$z[0], bem$z = _createNamespace$z[1];
function Info(h, props2, slots2, ctx) {
  var dot = props2.dot, info = props2.info;
  var showInfo = isDef$1(info) && info !== "";
  if (!dot && !showInfo) {
    return;
  }
  return h("div", _mergeJSXProps([{
    "class": bem$z({
      dot
    })
  }, inherit(ctx, true)]), [dot ? "" : props2.info]);
}
Info.props = {
  dot: Boolean,
  info: [Number, String]
};
var Info$1 = createComponent$z(Info);
var _createNamespace$y = createNamespace("icon"), createComponent$y = _createNamespace$y[0], bem$y = _createNamespace$y[1];
function isImage(name) {
  return name ? name.indexOf("/") !== -1 : false;
}
var LEGACY_MAP = {
  medel: "medal",
  "medel-o": "medal-o",
  "calender-o": "calendar-o"
};
function correctName(name) {
  return name && LEGACY_MAP[name] || name;
}
function Icon(h, props2, slots2, ctx) {
  var _props$badge;
  var name = correctName(props2.name);
  var imageIcon = isImage(name);
  return h(props2.tag, _mergeJSXProps([{
    "class": [props2.classPrefix, imageIcon ? "" : props2.classPrefix + "-" + name],
    "style": {
      color: props2.color,
      fontSize: addUnit(props2.size)
    }
  }, inherit(ctx, true)]), [slots2.default && slots2.default(), imageIcon && h("img", {
    "class": bem$y("image"),
    "attrs": {
      "src": name
    }
  }), h(Info$1, {
    "attrs": {
      "dot": props2.dot,
      "info": (_props$badge = props2.badge) != null ? _props$badge : props2.info
    }
  })]);
}
Icon.props = {
  dot: Boolean,
  name: String,
  size: [Number, String],
  info: [Number, String],
  badge: [Number, String],
  color: String,
  tag: {
    type: String,
    default: "i"
  },
  classPrefix: {
    type: String,
    default: bem$y()
  }
};
var _Icon = createComponent$y(Icon);
var _createNamespace$x = createNamespace("loading"), createComponent$x = _createNamespace$x[0], bem$x = _createNamespace$x[1];
function LoadingIcon(h, props2) {
  if (props2.type === "spinner") {
    var Spin = [];
    for (var i = 0; i < 12; i++) {
      Spin.push(h("i"));
    }
    return Spin;
  }
  return h("svg", {
    "class": bem$x("circular"),
    "attrs": {
      "viewBox": "25 25 50 50"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })]);
}
function LoadingText(h, props2, slots2) {
  if (slots2.default) {
    var _props$textColor;
    var style6 = {
      fontSize: addUnit(props2.textSize),
      color: (_props$textColor = props2.textColor) != null ? _props$textColor : props2.color
    };
    return h("span", {
      "class": bem$x("text"),
      "style": style6
    }, [slots2.default()]);
  }
}
function Loading(h, props2, slots2, ctx) {
  var color = props2.color, size2 = props2.size, type = props2.type;
  var style6 = {
    color
  };
  if (size2) {
    var iconSize = addUnit(size2);
    style6.width = iconSize;
    style6.height = iconSize;
  }
  return h("div", _mergeJSXProps([{
    "class": bem$x([type, {
      vertical: props2.vertical
    }])
  }, inherit(ctx, true)]), [h("span", {
    "class": bem$x("spinner", type),
    "style": style6
  }, [LoadingIcon(h, props2)]), LoadingText(h, props2, slots2)]);
}
Loading.props = {
  color: String,
  size: [Number, String],
  vertical: Boolean,
  textSize: [Number, String],
  textColor: String,
  type: {
    type: String,
    default: "circular"
  }
};
var Loading$1 = createComponent$x(Loading);
var _createNamespace$w = createNamespace("button"), createComponent$w = _createNamespace$w[0], bem$w = _createNamespace$w[1];
function Button(h, props2, slots2, ctx) {
  var _ref;
  var tag = props2.tag, icon = props2.icon, type = props2.type, color = props2.color, plain = props2.plain, disabled = props2.disabled, loading2 = props2.loading, hairline = props2.hairline, loadingText = props2.loadingText, iconPosition = props2.iconPosition;
  var style6 = {};
  if (color) {
    style6.color = plain ? color : "white";
    if (!plain) {
      style6.background = color;
    }
    if (color.indexOf("gradient") !== -1) {
      style6.border = 0;
    } else {
      style6.borderColor = color;
    }
  }
  function onClick8(event) {
    if (props2.loading) {
      event.preventDefault();
    }
    if (!loading2 && !disabled) {
      emit$2(ctx, "click", event);
      functionalRoute(ctx);
    }
  }
  function onTouchstart(event) {
    emit$2(ctx, "touchstart", event);
  }
  var classes = [bem$w([type, props2.size, {
    plain,
    loading: loading2,
    disabled,
    hairline,
    block: props2.block,
    round: props2.round,
    square: props2.square
  }]), (_ref = {}, _ref[BORDER_SURROUND] = hairline, _ref)];
  function renderIcon() {
    if (loading2) {
      return slots2.loading ? slots2.loading() : h(Loading$1, {
        "class": bem$w("loading"),
        "attrs": {
          "size": props2.loadingSize,
          "type": props2.loadingType,
          "color": "currentColor"
        }
      });
    }
    if (slots2.icon) {
      return h("div", {
        "class": bem$w("icon")
      }, [slots2.icon()]);
    }
    if (icon) {
      return h(_Icon, {
        "attrs": {
          "name": icon,
          "classPrefix": props2.iconPrefix
        },
        "class": bem$w("icon")
      });
    }
  }
  function renderContent() {
    var content = [];
    if (iconPosition === "left") {
      content.push(renderIcon());
    }
    var text;
    if (loading2) {
      text = loadingText;
    } else {
      text = slots2.default ? slots2.default() : props2.text;
    }
    if (text) {
      content.push(h("span", {
        "class": bem$w("text")
      }, [text]));
    }
    if (iconPosition === "right") {
      content.push(renderIcon());
    }
    return content;
  }
  return h(tag, _mergeJSXProps([{
    "style": style6,
    "class": classes,
    "attrs": {
      "type": props2.nativeType,
      "disabled": disabled
    },
    "on": {
      "click": onClick8,
      "touchstart": onTouchstart
    }
  }, inherit(ctx)]), [h("div", {
    "class": bem$w("content")
  }, [renderContent()])]);
}
Button.props = _extends$o({}, routeProps, {
  text: String,
  icon: String,
  color: String,
  block: Boolean,
  plain: Boolean,
  round: Boolean,
  square: Boolean,
  loading: Boolean,
  hairline: Boolean,
  disabled: Boolean,
  iconPrefix: String,
  nativeType: String,
  loadingText: String,
  loadingType: String,
  tag: {
    type: String,
    default: "button"
  },
  type: {
    type: String,
    default: "default"
  },
  size: {
    type: String,
    default: "normal"
  },
  loadingSize: {
    type: String,
    default: "20px"
  },
  iconPosition: {
    type: String,
    default: "left"
  }
});
var _Button = createComponent$w(Button);
function flattenVNodes(vnodes) {
  var result = [];
  function traverse(vnodes2) {
    vnodes2.forEach(function(vnode) {
      result.push(vnode);
      if (vnode.componentInstance) {
        traverse(vnode.componentInstance.$children.map(function(item) {
          return item.$vnode;
        }));
      }
      if (vnode.children) {
        traverse(vnode.children);
      }
    });
  }
  traverse(vnodes);
  return result;
}
function sortChildren(children3, parent) {
  var componentOptions = parent.$vnode.componentOptions;
  if (!componentOptions || !componentOptions.children) {
    return;
  }
  var vnodes = flattenVNodes(componentOptions.children);
  children3.sort(function(a, b) {
    return vnodes.indexOf(a.$vnode) - vnodes.indexOf(b.$vnode);
  });
}
function ChildrenMixin(_parent, options) {
  var _inject, _computed;
  if (options === void 0) {
    options = {};
  }
  var indexKey = options.indexKey || "index";
  return {
    inject: (_inject = {}, _inject[_parent] = {
      default: null
    }, _inject),
    computed: (_computed = {
      parent: function parent() {
        if (this.disableBindRelation) {
          return null;
        }
        return this[_parent];
      }
    }, _computed[indexKey] = function() {
      this.bindRelation();
      if (this.parent) {
        return this.parent.children.indexOf(this);
      }
      return null;
    }, _computed),
    watch: {
      disableBindRelation: function disableBindRelation(val) {
        if (!val) {
          this.bindRelation();
        }
      }
    },
    mounted: function mounted12() {
      this.bindRelation();
    },
    beforeDestroy: function beforeDestroy4() {
      var _this = this;
      if (this.parent) {
        this.parent.children = this.parent.children.filter(function(item) {
          return item !== _this;
        });
      }
    },
    methods: {
      bindRelation: function bindRelation() {
        if (!this.parent || this.parent.children.indexOf(this) !== -1) {
          return;
        }
        var children3 = [].concat(this.parent.children, [this]);
        sortChildren(children3, this.parent);
        this.parent.children = children3;
      }
    }
  };
}
function ParentMixin(parent) {
  return {
    provide: function provide3() {
      var _ref;
      return _ref = {}, _ref[parent] = this, _ref;
    },
    data: function data22() {
      return {
        children: []
      };
    }
  };
}
var _createNamespace$v = createNamespace("goods-action"), createComponent$v = _createNamespace$v[0], bem$v = _createNamespace$v[1];
var GoodsAction = createComponent$v({
  mixins: [ParentMixin("vanGoodsAction")],
  props: {
    safeAreaInsetBottom: {
      type: Boolean,
      default: true
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "class": bem$v({
        unfit: !this.safeAreaInsetBottom
      })
    }, [this.slots()]);
  }
});
var _createNamespace$u = createNamespace("goods-action-button"), createComponent$u = _createNamespace$u[0], bem$u = _createNamespace$u[1];
var GoodsActionButton = createComponent$u({
  mixins: [ChildrenMixin("vanGoodsAction")],
  props: _extends$o({}, routeProps, {
    type: String,
    text: String,
    icon: String,
    color: String,
    loading: Boolean,
    disabled: Boolean
  }),
  computed: {
    isFirst: function isFirst() {
      var prev4 = this.parent && this.parent.children[this.index - 1];
      return !prev4 || prev4.$options.name !== this.$options.name;
    },
    isLast: function isLast() {
      var next3 = this.parent && this.parent.children[this.index + 1];
      return !next3 || next3.$options.name !== this.$options.name;
    }
  },
  methods: {
    onClick: function onClick(event) {
      this.$emit("click", event);
      route(this.$router, this);
    }
  },
  render: function render2() {
    var h = arguments[0];
    return h(_Button, {
      "class": bem$u([{
        first: this.isFirst,
        last: this.isLast
      }, this.type]),
      "attrs": {
        "size": "large",
        "type": this.type,
        "icon": this.icon,
        "color": this.color,
        "loading": this.loading,
        "disabled": this.disabled
      },
      "on": {
        "click": this.onClick
      }
    }, [this.slots() || this.text]);
  }
});
var _createNamespace$t = createNamespace("dialog"), createComponent$t = _createNamespace$t[0], bem$t = _createNamespace$t[1], t$5 = _createNamespace$t[2];
var VanDialog = createComponent$t({
  mixins: [PopupMixin()],
  props: {
    title: String,
    theme: String,
    width: [Number, String],
    message: String,
    className: null,
    callback: Function,
    beforeClose: Function,
    messageAlign: String,
    cancelButtonText: String,
    cancelButtonColor: String,
    confirmButtonText: String,
    confirmButtonColor: String,
    showCancelButton: Boolean,
    overlay: {
      type: Boolean,
      default: true
    },
    allowHtml: {
      type: Boolean,
      default: true
    },
    transition: {
      type: String,
      default: "van-dialog-bounce"
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    closeOnPopstate: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    }
  },
  data: function data3() {
    return {
      loading: {
        confirm: false,
        cancel: false
      }
    };
  },
  methods: {
    onClickOverlay: function onClickOverlay() {
      this.handleAction("overlay");
    },
    handleAction: function handleAction(action) {
      var _this = this;
      this.$emit(action);
      if (!this.value) {
        return;
      }
      if (this.beforeClose) {
        this.loading[action] = true;
        this.beforeClose(action, function(state) {
          if (state !== false && _this.loading[action]) {
            _this.onClose(action);
          }
          _this.loading.confirm = false;
          _this.loading.cancel = false;
        });
      } else {
        this.onClose(action);
      }
    },
    onClose: function onClose(action) {
      this.close();
      if (this.callback) {
        this.callback(action);
      }
    },
    onOpened: function onOpened() {
      var _this2 = this;
      this.$emit("opened");
      this.$nextTick(function() {
        var _this2$$refs$dialog;
        (_this2$$refs$dialog = _this2.$refs.dialog) == null ? void 0 : _this2$$refs$dialog.focus();
      });
    },
    onClosed: function onClosed() {
      this.$emit("closed");
    },
    onKeydown: function onKeydown(event) {
      var _this3 = this;
      if (event.key === "Escape" || event.key === "Enter") {
        if (event.target !== this.$refs.dialog) {
          return;
        }
        var onEventType = {
          Enter: this.showConfirmButton ? function() {
            return _this3.handleAction("confirm");
          } : noop$1,
          Escape: this.showCancelButton ? function() {
            return _this3.handleAction("cancel");
          } : noop$1
        };
        onEventType[event.key]();
        this.$emit("keydown", event);
      }
    },
    genRoundButtons: function genRoundButtons() {
      var _this4 = this;
      var h = this.$createElement;
      return h(GoodsAction, {
        "class": bem$t("footer")
      }, [this.showCancelButton && h(GoodsActionButton, {
        "attrs": {
          "size": "large",
          "type": "warning",
          "text": this.cancelButtonText || t$5("cancel"),
          "color": this.cancelButtonColor,
          "loading": this.loading.cancel
        },
        "class": bem$t("cancel"),
        "on": {
          "click": function click2() {
            _this4.handleAction("cancel");
          }
        }
      }), this.showConfirmButton && h(GoodsActionButton, {
        "attrs": {
          "size": "large",
          "type": "danger",
          "text": this.confirmButtonText || t$5("confirm"),
          "color": this.confirmButtonColor,
          "loading": this.loading.confirm
        },
        "class": bem$t("confirm"),
        "on": {
          "click": function click2() {
            _this4.handleAction("confirm");
          }
        }
      })]);
    },
    genButtons: function genButtons() {
      var _this5 = this, _ref;
      var h = this.$createElement;
      var multiple2 = this.showCancelButton && this.showConfirmButton;
      return h("div", {
        "class": [BORDER_TOP, bem$t("footer")]
      }, [this.showCancelButton && h(_Button, {
        "attrs": {
          "size": "large",
          "loading": this.loading.cancel,
          "text": this.cancelButtonText || t$5("cancel")
        },
        "class": bem$t("cancel"),
        "style": {
          color: this.cancelButtonColor
        },
        "on": {
          "click": function click2() {
            _this5.handleAction("cancel");
          }
        }
      }), this.showConfirmButton && h(_Button, {
        "attrs": {
          "size": "large",
          "loading": this.loading.confirm,
          "text": this.confirmButtonText || t$5("confirm")
        },
        "class": [bem$t("confirm"), (_ref = {}, _ref[BORDER_LEFT] = multiple2, _ref)],
        "style": {
          color: this.confirmButtonColor
        },
        "on": {
          "click": function click2() {
            _this5.handleAction("confirm");
          }
        }
      })]);
    },
    genContent: function genContent(hasTitle, messageSlot) {
      var h = this.$createElement;
      if (messageSlot) {
        return h("div", {
          "class": bem$t("content")
        }, [messageSlot]);
      }
      var message2 = this.message, messageAlign = this.messageAlign;
      if (message2) {
        var _bem, _domProps;
        var data22 = {
          class: bem$t("message", (_bem = {
            "has-title": hasTitle
          }, _bem[messageAlign] = messageAlign, _bem)),
          domProps: (_domProps = {}, _domProps[this.allowHtml ? "innerHTML" : "textContent"] = message2, _domProps)
        };
        return h("div", {
          "class": bem$t("content", {
            isolated: !hasTitle
          })
        }, [h("div", _mergeJSXProps([{}, data22]))]);
      }
    }
  },
  render: function render3() {
    var h = arguments[0];
    if (!this.shouldRender) {
      return;
    }
    var message2 = this.message;
    var messageSlot = this.slots();
    var title2 = this.slots("title") || this.title;
    var Title2 = title2 && h("div", {
      "class": bem$t("header", {
        isolated: !message2 && !messageSlot
      })
    }, [title2]);
    return h("transition", {
      "attrs": {
        "name": this.transition
      },
      "on": {
        "afterEnter": this.onOpened,
        "afterLeave": this.onClosed
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "attrs": {
        "role": "dialog",
        "aria-labelledby": this.title || message2,
        "tabIndex": 0
      },
      "class": [bem$t([this.theme]), this.className],
      "style": {
        width: addUnit(this.width)
      },
      "ref": "dialog",
      "on": {
        "keydown": this.onKeydown
      }
    }, [Title2, this.genContent(title2, messageSlot), this.theme === "round-button" ? this.genRoundButtons() : this.genButtons()])]);
  }
});
var instance$4;
function isInDocument$1(element) {
  return document.body.contains(element);
}
function initInstance$1() {
  if (instance$4) {
    instance$4.$destroy();
  }
  instance$4 = new (Vue$1.extend(VanDialog))({
    el: document.createElement("div"),
    propsData: {
      lazyRender: false
    }
  });
  instance$4.$on("input", function(value9) {
    instance$4.value = value9;
  });
}
function Dialog$1(options) {
  if (isServer$3) {
    return Promise.resolve();
  }
  return new Promise(function(resolve, reject) {
    if (!instance$4 || !isInDocument$1(instance$4.$el)) {
      initInstance$1();
    }
    _extends$o(instance$4, Dialog$1.currentOptions, options, {
      resolve,
      reject
    });
  });
}
Dialog$1.defaultOptions = {
  value: true,
  title: "",
  width: "",
  theme: null,
  message: "",
  overlay: true,
  className: "",
  allowHtml: true,
  lockScroll: true,
  transition: "van-dialog-bounce",
  beforeClose: null,
  overlayClass: "",
  overlayStyle: null,
  messageAlign: "",
  getContainer: "body",
  cancelButtonText: "",
  cancelButtonColor: null,
  confirmButtonText: "",
  confirmButtonColor: null,
  showConfirmButton: true,
  showCancelButton: false,
  closeOnPopstate: true,
  closeOnClickOverlay: false,
  callback: function callback(action) {
    instance$4[action === "confirm" ? "resolve" : "reject"](action);
  }
};
Dialog$1.alert = Dialog$1;
Dialog$1.confirm = function(options) {
  return Dialog$1(_extends$o({
    showCancelButton: true
  }, options));
};
Dialog$1.close = function() {
  if (instance$4) {
    instance$4.value = false;
  }
};
Dialog$1.setDefaultOptions = function(options) {
  _extends$o(Dialog$1.currentOptions, options);
};
Dialog$1.resetDefaultOptions = function() {
  Dialog$1.currentOptions = _extends$o({}, Dialog$1.defaultOptions);
};
Dialog$1.resetDefaultOptions();
Dialog$1.install = function() {
  Vue$1.use(VanDialog);
};
Dialog$1.Component = VanDialog;
Vue$1.prototype.$dialog = Dialog$1;
var index$p = "";
var lockCount = 0;
function lockClick(lock) {
  if (lock) {
    if (!lockCount) {
      document.body.classList.add("van-toast--unclickable");
    }
    lockCount++;
  } else {
    lockCount--;
    if (!lockCount) {
      document.body.classList.remove("van-toast--unclickable");
    }
  }
}
var _createNamespace$s = createNamespace("toast"), createComponent$s = _createNamespace$s[0], bem$s = _createNamespace$s[1];
var VueToast = createComponent$s({
  mixins: [PopupMixin()],
  props: {
    icon: String,
    className: null,
    iconPrefix: String,
    loadingType: String,
    forbidClick: Boolean,
    closeOnClick: Boolean,
    message: [Number, String],
    type: {
      type: String,
      default: "text"
    },
    position: {
      type: String,
      default: "middle"
    },
    transition: {
      type: String,
      default: "van-fade"
    },
    lockScroll: {
      type: Boolean,
      default: false
    }
  },
  data: function data4() {
    return {
      clickable: false
    };
  },
  mounted: function mounted() {
    this.toggleClickable();
  },
  destroyed: function destroyed() {
    this.toggleClickable();
  },
  watch: {
    value: "toggleClickable",
    forbidClick: "toggleClickable"
  },
  methods: {
    onClick: function onClick2() {
      if (this.closeOnClick) {
        this.close();
      }
    },
    toggleClickable: function toggleClickable() {
      var clickable = this.value && this.forbidClick;
      if (this.clickable !== clickable) {
        this.clickable = clickable;
        lockClick(clickable);
      }
    },
    onAfterEnter: function onAfterEnter() {
      this.$emit("opened");
      if (this.onOpened) {
        this.onOpened();
      }
    },
    onAfterLeave: function onAfterLeave() {
      this.$emit("closed");
    },
    genIcon: function genIcon() {
      var h = this.$createElement;
      var icon = this.icon, type = this.type, iconPrefix = this.iconPrefix, loadingType = this.loadingType;
      var hasIcon = icon || type === "success" || type === "fail";
      if (hasIcon) {
        return h(_Icon, {
          "class": bem$s("icon"),
          "attrs": {
            "classPrefix": iconPrefix,
            "name": icon || type
          }
        });
      }
      if (type === "loading") {
        return h(Loading$1, {
          "class": bem$s("loading"),
          "attrs": {
            "type": loadingType
          }
        });
      }
    },
    genMessage: function genMessage() {
      var h = this.$createElement;
      var type = this.type, message2 = this.message;
      if (!isDef$1(message2) || message2 === "") {
        return;
      }
      if (type === "html") {
        return h("div", {
          "class": bem$s("text"),
          "domProps": {
            "innerHTML": message2
          }
        });
      }
      return h("div", {
        "class": bem$s("text")
      }, [message2]);
    }
  },
  render: function render4() {
    var _ref;
    var h = arguments[0];
    return h("transition", {
      "attrs": {
        "name": this.transition
      },
      "on": {
        "afterEnter": this.onAfterEnter,
        "afterLeave": this.onAfterLeave
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "class": [bem$s([this.position, (_ref = {}, _ref[this.type] = !this.icon, _ref)]), this.className],
      "on": {
        "click": this.onClick
      }
    }, [this.genIcon(), this.genMessage()])]);
  }
});
var defaultOptions$1 = {
  icon: "",
  type: "text",
  mask: false,
  value: true,
  message: "",
  className: "",
  overlay: false,
  onClose: null,
  onOpened: null,
  duration: 2e3,
  iconPrefix: void 0,
  position: "middle",
  transition: "van-fade",
  forbidClick: false,
  loadingType: void 0,
  getContainer: "body",
  overlayStyle: null,
  closeOnClick: false,
  closeOnClickOverlay: false
};
var defaultOptionsMap = {};
var queue = [];
var multiple = false;
var currentOptions = _extends$o({}, defaultOptions$1);
function parseOptions$1(message2) {
  if (isObject$2(message2)) {
    return message2;
  }
  return {
    message: message2
  };
}
function isInDocument(element) {
  return document.body.contains(element);
}
function createInstance() {
  if (isServer$3) {
    return {};
  }
  queue = queue.filter(function(item) {
    return !item.$el.parentNode || isInDocument(item.$el);
  });
  if (!queue.length || multiple) {
    var toast = new (Vue$1.extend(VueToast))({
      el: document.createElement("div")
    });
    toast.$on("input", function(value9) {
      toast.value = value9;
    });
    queue.push(toast);
  }
  return queue[queue.length - 1];
}
function transformOptions(options) {
  return _extends$o({}, options, {
    overlay: options.mask || options.overlay,
    mask: void 0,
    duration: void 0
  });
}
function Toast(options) {
  if (options === void 0) {
    options = {};
  }
  var toast = createInstance();
  if (toast.value) {
    toast.updateZIndex();
  }
  options = parseOptions$1(options);
  options = _extends$o({}, currentOptions, defaultOptionsMap[options.type || currentOptions.type], options);
  options.clear = function() {
    toast.value = false;
    if (options.onClose) {
      options.onClose();
      options.onClose = null;
    }
    if (multiple && !isServer$3) {
      toast.$on("closed", function() {
        clearTimeout(toast.timer);
        queue = queue.filter(function(item) {
          return item !== toast;
        });
        removeNode$1(toast.$el);
        toast.$destroy();
      });
    }
  };
  _extends$o(toast, transformOptions(options));
  clearTimeout(toast.timer);
  if (options.duration > 0) {
    toast.timer = setTimeout(function() {
      toast.clear();
    }, options.duration);
  }
  return toast;
}
var createMethod = function createMethod2(type) {
  return function(options) {
    return Toast(_extends$o({
      type
    }, parseOptions$1(options)));
  };
};
["loading", "success", "fail"].forEach(function(method) {
  Toast[method] = createMethod(method);
});
Toast.clear = function(all) {
  if (queue.length) {
    if (all) {
      queue.forEach(function(toast) {
        toast.clear();
      });
      queue = [];
    } else if (!multiple) {
      queue[0].clear();
    } else {
      queue.shift().clear();
    }
  }
};
Toast.setDefaultOptions = function(type, options) {
  if (typeof type === "string") {
    defaultOptionsMap[type] = options;
  } else {
    _extends$o(currentOptions, type);
  }
};
Toast.resetDefaultOptions = function(type) {
  if (typeof type === "string") {
    defaultOptionsMap[type] = null;
  } else {
    currentOptions = _extends$o({}, defaultOptions$1);
    defaultOptionsMap = {};
  }
};
Toast.allowMultiple = function(value9) {
  if (value9 === void 0) {
    value9 = true;
  }
  multiple = value9;
};
Toast.install = function() {
  Vue$1.use(VueToast);
};
Vue$1.prototype.$toast = Toast;
const ajax$2 = (config) => new AjaxConfig(config);
const SEND_VERIFY_CODE = ajax$2().get("/oauth/sendVerifyCode");
const IDENTITY_PROXY_LOGIN = ajax$2().post("/oauth/identityProxy/login").format("url");
const IDENTITY_USER = ajax$2().post("/consumerservice/identityUser/pageFindByCriteria");
const CREATE_IDENTITY_USER = ajax$2().post("/consumerservice/identityUser/create");
const sendVerifyCode = (params) => {
  return new Promise((resolve, reject) => {
    request(SEND_VERIFY_CODE, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const identityProxyLogin = (params) => {
  return new Promise((resolve, reject) => {
    request(IDENTITY_PROXY_LOGIN, __spreadValues({
      userQsStringufy: true
    }, params)).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const getIdentityUserList = (params) => {
  return new Promise((resolve, reject) => {
    request(IDENTITY_USER, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const addIdentityUserList = (params) => {
  return new Promise((resolve, reject) => {
    request(CREATE_IDENTITY_USER, params).then((res) => {
      if (res.status) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
const OUTER_TOKEN = "outerToken";
const EXPIRY_TIME = 6 * 60 * 60 * 1e3;
function validatorPhone(val) {
  return /^1[3-9]\d{9}$/.test(val);
}
function useExternalUser(userInfoKey = "currentUser") {
  const isSend = ref(true);
  const count3 = ref(0);
  const intervalId = ref(null);
  async function sendCode(phone) {
    if (!validatorPhone(phone)) {
      return;
    }
    isSend.value = false;
    count3.value = 60;
    sendVerifyCode({
      mobile: phone
    });
    intervalId.value = setInterval(() => {
      count3.value = count3.value - 1;
      if (count3.value == 0) {
        clearInterval(intervalId.value);
        isSend.value = true;
      }
    }, 1e3);
  }
  async function login(params) {
    const res = await identityProxyLogin(params);
    if (res.status) {
      sessionStorage.setItem("Oauth2-AccessToken", res.data.token);
      cacheOuterToken(res.data.token);
      await addIdentityUserList({
        mobile: "86" + params.identifier
      });
      return res.data.token;
    } else {
      return null;
    }
  }
  async function checkStatus() {
    let currentUserInfo = JSON.parse(sessionStorage.getItem(userInfoKey));
    if (currentUserInfo.loginUserCategory == "IDENTITY_PROXY") {
      const isLoading = Toast.loading({
        duration: 0,
        mask: true,
        message: "\u6B63\u5728\u52A0\u8F7D..."
      });
      let mobile = currentUserInfo.mobile.slice(2);
      const data22 = await getIdentityUserList({
        mobile,
        pageNo: 1,
        pageSize: 20
      });
      isLoading.clear();
      if (data22.data.records == 0 || data22.data.records.length > 0 && data22.data.records[0].status != 1) {
        Dialog$1.confirm({
          title: "\u6E29\u99A8\u63D0\u793A",
          showCancelButton: false,
          confirmButtonText: "\u6211\u77E5\u9053\u4E86",
          message: "\u64CD\u4F5C\u5931\u8D25\uFF0C\u60A8\u7684\u624B\u673A\u53F7\u662F\u5931\u6548\u72B6\u6001\uFF0C\u8BF7\u8054\u7CFB\u7ECF\u9500\u5546\u7CFB\u7EDF\u7BA1\u7406\u5458\u6216\u5B89\u88C5\u8D1F\u8D23\u4EBA\u6FC0\u6D3B\u3002"
        }).then(() => {
        });
        return false;
      }
    }
    return true;
  }
  return {
    isSend,
    count: count3,
    sendCode,
    login,
    checkStatus
  };
}
function getOuterToken() {
  const tokenData = JSON.parse(localStorage.getItem(OUTER_TOKEN));
  if (!tokenData) {
    return null;
  }
  const now = new Date();
  const expiryDate = new Date(tokenData.expiryDate);
  if (now > expiryDate) {
    localStorage.removeItem(OUTER_TOKEN);
    return null;
  }
  sessionStorage.setItem("Oauth2-AccessToken", tokenData.token);
  return tokenData.token;
}
function cacheOuterToken(token) {
  const now = new Date();
  const expiryDate = new Date(now.getTime() + EXPIRY_TIME);
  localStorage.setItem(OUTER_TOKEN, JSON.stringify({
    token,
    expiryDate: expiryDate.toISOString()
  }));
}
function removeOuterToken() {
  localStorage.removeItem(OUTER_TOKEN);
}
function hasOuterToken() {
  return !!localStorage.getItem(OUTER_TOKEN);
}
const HookFunction = {
  useDictData,
  useModal,
  useVForm,
  useVModel,
  useAmapJsApi,
  webApi: fn,
  useWxJsSdk,
  useExternalUser,
  getOuterToken,
  removeOuterToken,
  hasOuterToken
};
var __glob_6_0 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  useDictData,
  useModal,
  useVForm,
  useVModel,
  useAmapJsApi,
  webApi: fn,
  useWxJsSdk,
  useExternalUser,
  getOuterToken,
  removeOuterToken,
  hasOuterToken,
  "default": HookFunction
});
var initMixins$1 = {
  props: {
    autoHideAfterBlur: {
      type: [Boolean, Number],
      default: false
    },
    hidePosition: {
      type: Boolean,
      default: false
    },
    poiParams: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "\u8F93\u5165\u5730\u5740\u5173\u952E\u5B57\u540E\u6309\u56DE\u8F66\u641C\u7D22"
    },
    value: {
      type: String,
      default: ""
    }
  },
  created() {
    this.searchTxt = this.value;
  },
  data() {
    return {
      visible: false,
      loading: false,
      searchTxt: "",
      searchCity: "",
      searchCityList: [],
      position: null,
      searchList: [],
      selection: null
    };
  },
  computed: {
    cityList() {
      return this.searchCityList.filter((x) => x.value !== this.searchCity);
    }
  },
  watch: {
    value(v) {
      if (v !== this.searchTxt) {
        this.searchTxt = v;
      }
    },
    searchTxt(v) {
      this.$emit("input", v);
    }
  },
  methods: {
    addressSelect(item) {
      if (item) {
        this.searchTxt = item.pname + item.cityname + item.adname + item.address + item.name;
      } else {
        this.searchTxt = "";
      }
      item.formatAddress = this.searchTxt;
      this.selection = item;
      this.$emit("change", item);
      this.visible = false;
    },
    searchCityChange(city) {
      this.searchCity = city;
      this.searchAction();
    },
    async searchAction() {
      if (this.disabled)
        return;
      this.loading = true;
      const rs = await fn.keywordsSearch(__spreadValues({
        keywords: this.searchTxt,
        region: !this.hidePosition ? this.searchCity : null
      }, this.poiParams));
      this.loading = false;
      if (rs.status === "1") {
        this.searchList = rs.pois;
      }
    },
    async inputFocus() {
      if (this.disabled)
        return;
      clearTimeout(this.timer);
      this.timer = null;
      this.visible = true;
      if (this.position)
        return;
      const session = sessionStorage.getItem("AMAP_IP_POSITION");
      if (session) {
        this.initPosition(JSON.parse(session));
        return;
      }
      this.loading = true;
      const rs = await fn.ip();
      this.loading = false;
      if (rs.status === "1") {
        this.initPosition(rs);
        sessionStorage.setItem("AMAP_IP_POSITION", JSON.stringify(rs));
      }
    },
    initPosition(obj) {
      this.position = obj;
      this.searchCity = this.position.city;
      this.searchCityList = [{
        label: this.position.city,
        value: this.position.city
      }, {
        label: this.position.province,
        value: this.position.province
      }, {
        label: "\u5168\u56FD",
        value: ""
      }];
    },
    inputBlur() {
      if (!this.autoHideAfterBlur)
        return;
      const type = typeof this.autoHideAfterBlur;
      this.timer = setTimeout(() => {
        this.visible = false;
      }, type === "boolean" ? 3e3 : this.autoHideAfterBlur);
    }
  }
};
var render$15 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("el-popover", {
    attrs: {
      "placement": "bottom-start",
      "width": "450",
      "visible-arrow": false,
      "trigger": "manual"
    },
    model: {
      value: _vm.visible,
      callback: function($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "op-address-input",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c("el-input", {
    attrs: {
      "placeholder": _vm.placeholder,
      "clearable": _vm.clearable,
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.inputFocus,
      "blur": _vm.inputBlur,
      "clear": function($event) {
        return _vm.addressSelect();
      }
    },
    nativeOn: {
      "keypress": function($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.searchAction.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchTxt,
      callback: function($$v) {
        _vm.searchTxt = $$v;
      },
      expression: "searchTxt"
    }
  }, [_c("el-button", {
    attrs: {
      "slot": "append",
      "icon": "el-icon-position"
    },
    on: {
      "click": _vm.searchAction
    },
    slot: "append"
  })], 1)], 1), _c("div", {
    staticClass: "op-address-input"
  }, [_c("div", {
    staticClass: "result-panel"
  }, [_c("div", {
    staticClass: "close-panel",
    on: {
      "click": function($event) {
        _vm.visible = false;
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-close"
  })]), _c("div", {
    staticClass: "position-panel"
  }, [!_vm.position && _vm.loading ? _c("div", [_vm._v("\u6B63\u5728\u67E5\u8BE2\u60A8\u7684\u7F51\u7EDC\u5730\u5740\uFF0C\u8BF7\u7A0D\u5019...")]) : !_vm.position && !_vm.loading ? _c("div", [_vm._v("\u65E0\u6CD5\u5B9A\u4F4D\uFF0C\u5F53\u524D\u7EC4\u4EF6\u641C\u7D22\u529F\u80FD\u4E0D\u53EF\u7528\u6216\u641C\u7D22\u4E0D\u7CBE\u786E\uFF0C\u8BF7\u624B\u52A8\u586B\u5199...")]) : !_vm.hidePosition ? _c("div", [_vm._v(" \u60A8\u5F53\u524D\u641C\u7D22\u7684\u662F "), _c("span", {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("[" + _vm._s(_vm.searchCity || "\u5168\u56FD") + "]")]), _vm._v(" \u5185\u7684\u5730\u5740\uFF0C\u70B9\u51FB\u5207\u6362\u5230\uFF1A "), _vm._l(_vm.cityList, function(city) {
    return _c("el-button", {
      key: city.label,
      staticClass: "city-selection",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.searchCityChange(city.value);
        }
      }
    }, [_vm._v(" " + _vm._s(city.label) + " ")]);
  })], 2) : _vm._e()]), _c("div", {
    staticClass: "result-list"
  }, [!_vm.searchList.length ? _c("div", {
    staticClass: "tips"
  }, [_vm._v(" \u8F93\u5165\u5730\u5740\u5173\u952E\u5B57\u540E\u6309\u56DE\u8F66\u641C\u7D22... "), (_vm.hidePosition || _vm.searchCity === "") && JSON.stringify(_vm.poiParams) === "{}" ? _c("span", [_c("br"), _vm._v(" \u641C\u7D22\u7684\u8303\u56F4\u592A\u5927\uFF0C\u9700\u8981\u591A\u8F93\u5165\u4E00\u4E9B\u5173\u952E\u8BCD\u624D\u80FD\u641C\u7D22\u51FA\u6765... ")]) : _vm._e()]) : _vm._e(), _vm._l(_vm.searchList, function(item) {
    return _c("div", {
      key: item.id,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.addressSelect(item);
        }
      }
    }, [_c("div", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _c("div", {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.pname) + _vm._s(item.cityname) + _vm._s(item.adname) + " " + _vm._s(item.address))])]);
  })], 2)])])]);
};
var staticRenderFns$14 = [];
render$15._withStripped = true;
var index_vue_vue_type_style_index_0_lang$e = "";
function normalizeComponent(scriptExports, render28, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render28) {
    options.render = render28;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context2) {
      context2 = context2 || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context2 && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context2 = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context2);
      }
      if (context2 && context2._registeredComponents) {
        context2._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context2) {
        hook.call(context2);
        return originalRender(h, context2);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __vue2_script$16 = {
  name: "OpAddressInput",
  mixins: [initMixins$1]
};
const __cssModules$16 = {};
var __component__$16 = /* @__PURE__ */ normalizeComponent(__vue2_script$16, render$15, staticRenderFns$14, false, __vue2_injectStyles$16, null, null, null);
function __vue2_injectStyles$16(context2) {
  for (let o in __cssModules$16) {
    this[o] = __cssModules$16[o];
  }
}
__component__$16.options.__file = "packages/op-address-input/src/pc/index.vue";
var AddressInput = /* @__PURE__ */ function() {
  return __component__$16.exports;
}();
AddressInput.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(AddressInput.name, prefix);
  Vue2.component(comName, AddressInput);
};
var __glob_6_1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": AddressInput
});
var render$14 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div");
};
var staticRenderFns$13 = [];
render$14._withStripped = true;
const __vue2_script$15 = {
  name: "OpAppCodeSelect"
};
const __cssModules$15 = {};
var __component__$15 = /* @__PURE__ */ normalizeComponent(__vue2_script$15, render$14, staticRenderFns$13, false, __vue2_injectStyles$15, null, null, null);
function __vue2_injectStyles$15(context2) {
  for (let o in __cssModules$15) {
    this[o] = __cssModules$15[o];
  }
}
__component__$15.options.__file = "packages/op-appcode-select/src/pc/index.vue";
var PcAppCodeSelect = /* @__PURE__ */ function() {
  return __component__$15.exports;
}();
var render$13 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div");
};
var staticRenderFns$12 = [];
render$13._withStripped = true;
const __vue2_script$14 = {
  name: "OpAppCodeSelect"
};
const __cssModules$14 = {};
var __component__$14 = /* @__PURE__ */ normalizeComponent(__vue2_script$14, render$13, staticRenderFns$12, false, __vue2_injectStyles$14, null, null, null);
function __vue2_injectStyles$14(context2) {
  for (let o in __cssModules$14) {
    this[o] = __cssModules$14[o];
  }
}
__component__$14.options.__file = "packages/op-appcode-select/src/mobile/index.vue";
var MobileAppCodeSelect = /* @__PURE__ */ function() {
  return __component__$14.exports;
}();
const AppCodeSelect = {};
AppCodeSelect.install = (Vue2) => {
  if (isPCWidth()) {
    Vue2.component(PcAppCodeSelect.name, PcAppCodeSelect);
  } else {
    Vue2.component(MobileAppCodeSelect.name, MobileAppCodeSelect);
  }
};
var __glob_6_2 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": AppCodeSelect
});
function getBrandCategoryData(filtersFunc) {
  const brandCategoryData = ref([]);
  const flatData = ref([]);
  const getBrandCategory = async function() {
    try {
      const res = await getBrandCategoryList();
      if (res.status && res.data) {
        const resData = res.data.map((item) => {
          const children3 = item.children.map((child) => {
            return {
              brandCode: item.code,
              brandName: item.name,
              categoryCode: child.code,
              categoryName: child.name,
              pid: child.pid,
              id: child.id,
              brandId: item.id,
              brandCategoryCode: item.code + "-" + child.code,
              brandCategoryName: item.name + "-" + child.name
            };
          });
          return {
            code: item.code,
            id: item.id,
            name: item.name,
            pid: item.pid,
            children: children3
          };
        });
        brandCategoryData.value = filtersFunc ? filtersFunc(resData) : resData;
        flatData.value = brandCategoryData.value.reduce((prev4, next3) => {
          if (next3.children && Array.isArray(next3.children)) {
            prev4.push(...next3.children);
          }
          return prev4;
        }, []);
      }
    } catch (error) {
      /* @__PURE__ */ console.log(error, "\u83B7\u53D6\u54C1\u724C\u54C1\u7C7B\u5931\u8D25");
    }
  };
  return {
    brandCategoryData,
    flatData,
    getBrandCategory
  };
}
function useSelect$3(flatData, props2) {
  const currentVal = ref([]);
  const echoList = ref([]);
  const singleValue = ref("");
  const activeName = ref("");
  const {
    value: value9
  } = toRefs(props2);
  const [internalValue, setInnerValue] = useVModel(value9, [], props2.onChange, "change");
  const selection = computed(() => {
    return flatData.value.filter((item) => currentVal.value.includes(item.brandCategoryCode));
  });
  watch(() => value9.value, (nval, oval) => {
    if (oval.length === 0 && nval) {
      initData();
    }
  });
  const initData = () => {
    let seletion = [...value9.value];
    currentVal.value = seletion;
    if (!props2.multiple) {
      singleValue.value = seletion.length ? seletion[0] : "";
    }
    echoList.value = JSON.parse(JSON.stringify(selection.value));
    activeName.value = Array.from(new Set([...selection.value.map((item) => item.brandName), ...props2.openPannel]));
  };
  const handleSingleSelect = (val) => {
    if (val) {
      currentVal.value = [val];
    }
  };
  const removeItem = (obj, index2, immediate = true) => {
    currentVal.value.splice(index2, 1);
    if (immediate) {
      echoList.value.splice(index2, 1);
    }
  };
  const handleSubmit = () => {
    echoList.value = JSON.parse(JSON.stringify(selection.value));
    setInnerValue(currentVal.value, selection.value);
  };
  return {
    currentVal,
    selection,
    echoList,
    singleValue,
    activeName,
    initData,
    handleSubmit,
    handleSingleSelect,
    removeItem,
    setInnerValue
  };
}
var render$12 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "field-pannel",
    class: {
      "field-pannel--disabled": _vm.disabled
    },
    on: {
      "click": function() {
        return _vm.$emit("open");
      }
    }
  }, [_vm.list.length ? _vm._l(_vm.list, function(item, index2) {
    return _c("div", {
      key: item[_vm.config.value],
      staticClass: "field-pannel__tag",
      style: {
        backgroundColor: _vm.color
      }
    }, [_c("span", [_vm._v(_vm._s(item[_vm.config.label]))]), _vm.closable && !_vm.disabled ? _c("div", {
      staticClass: "close",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return function() {
            return _vm.$emit("close", item, index2);
          }.apply(null, arguments);
        }
      }
    }, [_c("svg-icon", {
      staticClass: "icon",
      attrs: {
        "icon-class": "close"
      }
    })], 1) : _vm._e()]);
  }) : [_c("div", {
    staticClass: "placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))])]], 2);
};
var staticRenderFns$11 = [];
render$12._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$f = "";
const __vue2_script$13 = {
  name: "FieldPannel",
  props: {
    placeholder: {
      type: String,
      default: "\u8BF7\u9009\u62E9"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => {
        return {
          label: "label",
          value: "value"
        };
      }
    },
    color: {
      type: String,
      default: "var(--tag-color)"
    }
  }
};
const __cssModules$13 = {};
var __component__$13 = /* @__PURE__ */ normalizeComponent(__vue2_script$13, render$12, staticRenderFns$11, false, __vue2_injectStyles$13, "1b82d641", null, null);
function __vue2_injectStyles$13(context2) {
  for (let o in __cssModules$13) {
    this[o] = __cssModules$13[o];
  }
}
__component__$13.options.__file = "src/components/common/FieldPannel/index.vue";
var FieldPannel = /* @__PURE__ */ function() {
  return __component__$13.exports;
}();
var props$a = {
  modal: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: "\u8BF7\u9009\u62E9"
  },
  disabled: {
    type: Boolean,
    default: false
  },
  multiple: {
    type: Boolean,
    default: false
  },
  value: {
    type: Array,
    default: () => []
  },
  filtersFunc: {
    type: [Function, null],
    default: null
  },
  openPannel: {
    type: Array,
    default: () => []
  },
  onChange: {
    type: Function,
    default: null
  }
};
var render$11 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "brand-category"
  }, [_vm.modal ? _c("field-pannel", {
    attrs: {
      "list": _vm.echoList,
      "disabled": _vm.disabled,
      "closable": "",
      "config": {
        label: "brandCategoryName",
        value: "brandCategoryCode"
      }
    },
    on: {
      "open": _vm.open,
      "close": _vm.removeItem
    }
  }) : _c("div", {
    staticClass: "brand-category-chooseArea"
  }, [_vm.multiple ? [_c("el-select", {
    staticClass: "brand-category-chooseArea__select",
    attrs: {
      "multiple": "",
      "placeholder": "\u8BF7\u9009\u62E9",
      "clearable": "",
      "disabled": _vm.disabled,
      "filterable": ""
    },
    on: {
      "change": _vm.changeBrandCategory
    },
    model: {
      value: _vm.currentVal,
      callback: function($$v) {
        _vm.currentVal = $$v;
      },
      expression: "currentVal"
    }
  }, _vm._l(_vm.flatData, function(item) {
    return _c("el-option", {
      key: item.brandCategoryCode,
      attrs: {
        "label": item.brandCategoryName,
        "value": item.brandCategoryCode
      }
    });
  }), 1)] : [_c("el-select", {
    staticClass: "brand-category-chooseArea__select",
    attrs: {
      "placeholder": "\u8BF7\u9009\u62E9",
      "disabled": _vm.disabled,
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBrandCategory
    },
    model: {
      value: _vm.singleValue,
      callback: function($$v) {
        _vm.singleValue = $$v;
      },
      expression: "singleValue"
    }
  }, _vm._l(_vm.flatData, function(item) {
    return _c("el-option", {
      key: item.brandCategoryCode,
      attrs: {
        "label": item.brandCategoryName,
        "value": item.brandCategoryCode
      }
    });
  }), 1)]], 2), _c("el-dialog", {
    attrs: {
      "title": "\u9009\u62E9\u54C1\u724C\u54C1\u7C7B",
      "append-to-body": "",
      "visible": _vm.visible,
      "width": "70vw",
      "top": "8vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event;
      },
      "close": _vm.close
    }
  }, [_c("el-container", [_c("el-main", {
    staticClass: "brand-category-chooseArea"
  }, [_c("el-card", {
    style: "height:" + (_vm.height + 82) + "px;overflow: auto;"
  }, [_c("el-collapse", {
    model: {
      value: _vm.activeName,
      callback: function($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, _vm._l(_vm.brandCategoryData, function(brandCategory) {
    return _c("el-collapse-item", {
      key: brandCategory.code,
      attrs: {
        "title": brandCategory.name,
        "name": brandCategory.name
      }
    }, [_vm.multiple ? [_c("el-checkbox-group", {
      model: {
        value: _vm.currentVal,
        callback: function($$v) {
          _vm.currentVal = $$v;
        },
        expression: "currentVal"
      }
    }, _vm._l(brandCategory.children, function(item) {
      return _c("el-checkbox", {
        key: item.id,
        staticClass: "brand-category-chooseArea__checkbox",
        attrs: {
          "label": item.brandCategoryCode
        },
        on: {
          "change": function(val) {
            return _vm.changeBrandCategory(val, item);
          }
        }
      }, [_vm._v(" " + _vm._s(item.brandCategoryName) + " ")]);
    }), 1)] : [_c("el-radio-group", {
      model: {
        value: _vm.singleValue,
        callback: function($$v) {
          _vm.singleValue = $$v;
        },
        expression: "singleValue"
      }
    }, _vm._l(brandCategory.children, function(item) {
      return _c("el-radio", {
        key: item.id,
        staticClass: "brand-category-chooseArea__radio",
        attrs: {
          "label": item.brandCategoryCode
        },
        on: {
          "change": function(val) {
            return _vm.changeBrandCategory(val, item);
          }
        }
      }, [_vm._v(" " + _vm._s(item.brandCategoryName) + " ")]);
    }), 1)]], 2);
  }), 1)], 1)], 1), _vm.multiple ? _c("el-aside", {
    staticClass: "brand-category-choosed",
    attrs: {
      "width": "250px"
    }
  }, [_c("el-card", [_c("div", {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("\u5DF2\u9009\u62E9")])]), _c("div", {
    style: "height:" + (_vm.height - 18) + "px;overflow: auto;"
  }, _vm._l(_vm.selection, function(item, index2) {
    return _c("div", {
      key: item.brandCategoryCode
    }, [_c("el-tag", {
      staticClass: "brand-category-choosed__tag",
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.removeItem(item, index2, false);
        }
      }
    }, [_vm._v(" " + _vm._s(item.brandCategoryName) + " ")])], 1);
  }), 0)])], 1) : _vm._e()], 1), _c("el-footer", {
    staticClass: "brand-category-button"
  }, [_c("el-button", {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\u53D6 \u6D88")]), _c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\u786E \u5B9A")])], 1)], 1)], 1);
};
var staticRenderFns$10 = [];
render$11._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$e = "";
const __vue2_script$12 = defineComponent({
  name: "OpBrandCategorySelect",
  components: {
    FieldPannel
  },
  props: __spreadValues({}, props$a),
  setup(props2) {
    const height = ref(500);
    const {
      brandCategoryData,
      flatData,
      getBrandCategory
    } = getBrandCategoryData(props2.filtersFunc);
    const {
      currentVal,
      selection,
      echoList,
      singleValue,
      activeName,
      initData,
      handleSingleSelect,
      removeItem,
      setInnerValue,
      handleSubmit
    } = useSelect$3(flatData, props2);
    const {
      visible: visible2,
      open: open3,
      close: close3
    } = useModal(props2);
    onMounted(() => {
      getBrandCategory().then(() => {
        initData();
      });
    });
    const changeBrandCategory = (val) => {
      if (!props2.multiple) {
        handleSingleSelect(val);
      }
      if (!props2.modal) {
        setInnerValue(currentVal.value, selection.value);
      }
    };
    const save2 = () => {
      handleSubmit();
      close3();
    };
    return {
      brandCategoryData,
      flatData,
      currentVal,
      selection,
      echoList,
      singleValue,
      activeName,
      height,
      visible: visible2,
      getBrandCategory,
      initData,
      removeItem,
      changeBrandCategory,
      open: open3,
      save: save2,
      close: close3
    };
  }
});
const __cssModules$12 = {};
var __component__$12 = /* @__PURE__ */ normalizeComponent(__vue2_script$12, render$11, staticRenderFns$10, false, __vue2_injectStyles$12, "43587743", null, null);
function __vue2_injectStyles$12(context2) {
  for (let o in __cssModules$12) {
    this[o] = __cssModules$12[o];
  }
}
__component__$12.options.__file = "packages/op-brand-category-select/src/pc/index.vue";
var BrandCategorySelect$1 = /* @__PURE__ */ function() {
  return __component__$12.exports;
}();
var render$10 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "brand-category"
  }, [_c("field-pannel", {
    attrs: {
      "list": _vm.echoList,
      "disabled": _vm.disabled,
      "config": {
        label: "brandCategoryName",
        value: "brandCategoryCode"
      }
    },
    on: {
      "open": _vm.open
    }
  }), _c("van-popup", {
    attrs: {
      "value": _vm.visible,
      "round": "",
      "position": "bottom",
      "close-on-click-overlay": false
    }
  }, [_c("van-nav-bar", {
    attrs: {
      "title": ""
    },
    on: {
      "click-left": _vm.close,
      "click-right": _vm.save
    },
    scopedSlots: _vm._u([{
      key: "left",
      fn: function() {
        return [_c("p", {}, [_vm._v("\u53D6\u6D88")])];
      },
      proxy: true
    }, {
      key: "right",
      fn: function() {
        return [_c("span", {}, [_vm._v("\u786E\u8BA4")])];
      },
      proxy: true
    }])
  }), _c("div", {
    style: "height:" + (_vm.height + 82) + "px;overflow: auto;"
  }, [_c("van-collapse", {
    model: {
      value: _vm.activeName,
      callback: function($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, _vm._l(_vm.brandCategoryData, function(brandCategory) {
    return _c("van-collapse-item", {
      key: brandCategory.code,
      attrs: {
        "title": brandCategory.name,
        "name": brandCategory.name
      }
    }, [_vm.multiple ? [_c("van-checkbox-group", {
      attrs: {
        "direction": "horizontal"
      },
      model: {
        value: _vm.currentVal,
        callback: function($$v) {
          _vm.currentVal = $$v;
        },
        expression: "currentVal"
      }
    }, _vm._l(brandCategory.children, function(item) {
      return _c("van-checkbox", {
        key: item.id,
        attrs: {
          "name": item.brandCategoryCode,
          "shape": "square",
          "icon-size": "14px"
        }
      }, [_vm._v(" " + _vm._s(item.brandCategoryName) + " ")]);
    }), 1)] : [_c("van-radio-group", {
      attrs: {
        "direction": "horizontal"
      },
      on: {
        "change": function(val) {
          return _vm.changeBrandCategory(val);
        }
      },
      model: {
        value: _vm.singleValue,
        callback: function($$v) {
          _vm.singleValue = $$v;
        },
        expression: "singleValue"
      }
    }, _vm._l(brandCategory.children, function(item) {
      return _c("van-radio", {
        key: item.id,
        attrs: {
          "name": item.brandCategoryCode,
          "icon-size": "14px"
        }
      }, [_vm._v(" " + _vm._s(item.brandCategoryName) + " ")]);
    }), 1)]], 2);
  }), 1), _c("div", {
    staticStyle: {
      "height": "100px"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns$$ = [];
render$10._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$d = "";
const __vue2_script$11 = defineComponent({
  name: "OpBrandCategorySelect",
  components: {
    FieldPannel
  },
  props: __spreadValues({}, props$a),
  setup(props2) {
    const height = ref(500);
    const {
      brandCategoryData,
      flatData,
      getBrandCategory
    } = getBrandCategoryData(props2.filtersFunc);
    const {
      currentVal,
      selection,
      echoList,
      singleValue,
      activeName,
      initData,
      handleSingleSelect,
      handleSubmit
    } = useSelect$3(flatData, props2);
    const {
      visible: visible2,
      open: open3,
      close: close3
    } = useModal(props2);
    onMounted(() => {
      getBrandCategory().then(() => {
        initData();
      });
    });
    const changeBrandCategory = (val) => {
      if (!props2.multiple) {
        handleSingleSelect(val);
      }
    };
    const save2 = () => {
      handleSubmit();
      close3();
    };
    return {
      brandCategoryData,
      flatData,
      currentVal,
      selection,
      echoList,
      singleValue,
      height,
      visible: visible2,
      activeName,
      initData,
      getBrandCategory,
      changeBrandCategory,
      open: open3,
      close: close3,
      save: save2
    };
  }
});
const __cssModules$11 = {};
var __component__$11 = /* @__PURE__ */ normalizeComponent(__vue2_script$11, render$10, staticRenderFns$$, false, __vue2_injectStyles$11, "6ca8a8b2", null, null);
function __vue2_injectStyles$11(context2) {
  for (let o in __cssModules$11) {
    this[o] = __cssModules$11[o];
  }
}
__component__$11.options.__file = "packages/op-brand-category-select/src/mobile/index.vue";
var MobileBrandCategorySelect = /* @__PURE__ */ function() {
  return __component__$11.exports;
}();
BrandCategorySelect$1.install = (Vue2) => {
  if (isPCWidth()) {
    Vue2.component(BrandCategorySelect$1.name, BrandCategorySelect$1);
  } else {
    Vue2.component(MobileBrandCategorySelect.name, MobileBrandCategorySelect);
  }
};
var __glob_6_3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": BrandCategorySelect$1
});
function getChannelData() {
  const channelData = ref([]);
  const flatData = ref([]);
  function setCascaderData(tree, code = "", label = "") {
    tree.forEach((i) => {
      const _code = code + i.dictValue;
      const _label = label + "-" + i.dictLabel;
      if (Array.isArray(i.children) && i.children.length > 0) {
        setCascaderData(i.children, _code, _label);
      } else {
        delete i.children;
        flatData.value.push(__spreadValues({
          label: _label.substring(1),
          value: _code
        }, i));
      }
    });
    return tree;
  }
  const getChannel = async () => {
    const res = await getChannelList();
    if (res.status && res.data) {
      channelData.value = setCascaderData(res.data);
    }
  };
  return {
    channelData,
    flatData,
    getChannel
  };
}
function useSelect$2(props2) {
  const {
    value: value9
  } = toRefs(props2);
  const [internalValue, setInnerValue] = useVModel(value9, "", props2.onChange, "change");
  const selected = ref([]);
  const lastValue = ref("");
  const initData = () => {
    if (!value9.value || value9.value.length === 0) {
      return;
    }
    if (props2.multiple) {
      selected.value = value9.value.map((item) => item.split(""));
    } else {
      selected.value = value9.value[0].split("");
      lastValue.value = selected.value[2];
    }
  };
  const handleSelect = (val, options) => {
    if (props2.multiple) {
      const _vals = val.map((item) => item.join(""));
      setInnerValue(_vals, val);
    } else {
      const _val = [val.join("")];
      setInnerValue(_val, val);
      lastValue.value = val[2];
    }
  };
  return {
    selected,
    lastValue,
    initData,
    handleSelect
  };
}
var props$9 = {
  value: {
    type: Array,
    default: () => []
  },
  multiple: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  onChange: {
    type: [Function, null],
    default: null
  },
  placeholder: {
    type: String,
    default: "\u8BF7\u9009\u62E9\u6E20\u9053"
  }
};
var render$$ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "channel"
  }, [_c("el-cascader", {
    staticClass: "channel__selector",
    attrs: {
      "expand-trigger": "click",
      "props": _vm.cascaderProps,
      "options": _vm.channelData,
      "collapse-tags": "",
      "separator": "-",
      "clearable": "",
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "popper-class": "channel__selector-popup"
    },
    on: {
      "change": _vm.handleSelect
    },
    model: {
      value: _vm.selected,
      callback: function($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1);
};
var staticRenderFns$_ = [];
render$$._withStripped = true;
var index_vue_vue_type_style_index_0_lang$d = "";
const __vue2_script$10 = defineComponent({
  name: "OpChannelSelect",
  props: __spreadValues({}, props$9),
  setup(props2) {
    const {
      channelData,
      getChannel
    } = getChannelData();
    const {
      selected,
      initData,
      handleSelect
    } = useSelect$2(props2);
    const cascaderProps = reactive({
      label: "dictLabel",
      children: "children",
      disabled: "disabled",
      value: "dictValue",
      multiple: props2.multiple
    });
    onMounted(() => {
      getChannel().then(() => {
        initData();
      });
    });
    return {
      channelData,
      cascaderProps,
      selected,
      initData,
      handleSelect,
      getChannel
    };
  }
});
const __cssModules$10 = {};
var __component__$10 = /* @__PURE__ */ normalizeComponent(__vue2_script$10, render$$, staticRenderFns$_, false, __vue2_injectStyles$10, null, null, null);
function __vue2_injectStyles$10(context2) {
  for (let o in __cssModules$10) {
    this[o] = __cssModules$10[o];
  }
}
__component__$10.options.__file = "packages/op-channel-select/src/pc/index.vue";
var OpChannelSelect = /* @__PURE__ */ function() {
  return __component__$10.exports;
}();
var render$_ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "channel"
  }, [_c("field-pannel", {
    attrs: {
      "list": _vm.viewList
    },
    on: {
      "open": _vm.open
    }
  }), _c("van-popup", {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: _vm.visible,
      callback: function($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("van-cascader", {
    attrs: {
      "field-names": _vm.cascaderProps,
      "title": "\u8BF7\u9009\u62E9\u6E20\u9053",
      "options": _vm.channelData
    },
    on: {
      "close": _vm.close,
      "finish": _vm.onFinish
    },
    model: {
      value: _vm.lastValue,
      callback: function($$v) {
        _vm.lastValue = $$v;
      },
      expression: "lastValue"
    }
  })], 1)], 1);
};
var staticRenderFns$Z = [];
render$_._withStripped = true;
var index_vue_vue_type_style_index_0_lang$c = "";
const __vue2_script$$ = defineComponent({
  name: "OpChannelSelect",
  components: {
    FieldPannel
  },
  props: __spreadValues({}, props$9),
  setup(props2) {
    const {
      channelData,
      flatData,
      getChannel
    } = getChannelData();
    const {
      selected,
      lastValue,
      initData,
      handleSelect
    } = useSelect$2(props2);
    const {
      visible: visible2,
      open: open3,
      close: close3
    } = useModal(props2);
    const cascaderProps = reactive({
      text: "dictLabel",
      children: "children",
      value: "dictValue"
    });
    onMounted(() => {
      getChannel().then(() => {
        initData();
      });
    });
    const onFinish = ({
      selectedOptions
    }) => {
      const _val = selectedOptions.map((item) => item.dictValue);
      handleSelect(_val, selectedOptions);
      visible2.value = false;
    };
    const viewList = computed(() => {
      if (flatData.value && flatData.value.length > 0) {
        return flatData.value.filter((x) => props2.value.includes(x.value));
      } else {
        return [];
      }
    });
    return {
      channelData,
      cascaderProps,
      selected,
      viewList,
      visible: visible2,
      lastValue,
      initData,
      handleSelect,
      getChannel,
      open: open3,
      close: close3,
      onFinish
    };
  }
});
const __cssModules$$ = {};
var __component__$$ = /* @__PURE__ */ normalizeComponent(__vue2_script$$, render$_, staticRenderFns$Z, false, __vue2_injectStyles$$, null, null, null);
function __vue2_injectStyles$$(context2) {
  for (let o in __cssModules$$) {
    this[o] = __cssModules$$[o];
  }
}
__component__$$.options.__file = "packages/op-channel-select/src/mobile/index.vue";
var MobileChannelSelect = /* @__PURE__ */ function() {
  return __component__$$.exports;
}();
OpChannelSelect.install = (Vue2) => {
  if (isPCWidth()) {
    Vue2.component(OpChannelSelect.name, OpChannelSelect);
  } else {
    Vue2.component(MobileChannelSelect.name, MobileChannelSelect);
  }
};
var __glob_6_4 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpChannelSelect
});
var loading$1 = "";
var loading = { exports: {} };
var popup = {};
var merge = {};
merge.__esModule = true;
merge.default = function(target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value9 = source[prop];
        if (value9 !== void 0) {
          target[prop] = value9;
        }
      }
    }
  }
  return target;
};
var popupManager = {};
var dom = {};
dom.__esModule = true;
dom.isInContainer = dom.getScrollContainer = dom.isScroll = dom.getStyle = dom.once = dom.off = dom.on = void 0;
var _typeof$7 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
dom.hasClass = hasClass$2;
dom.addClass = addClass$2;
dom.removeClass = removeClass$2;
dom.setStyle = setStyle$1;
var _vue$6 = Vue$1;
var _vue2$6 = _interopRequireDefault$7(_vue$6);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var isServer$2 = _vue2$6.default.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer$2 ? 0 : Number(document.documentMode);
var trim$1 = function trim(string) {
  return (string || "").replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, "");
};
var camelCase = function camelCase2(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, "Moz$1");
};
var on$2 = dom.on = function() {
  if (!isServer$2 && document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent("on" + event, handler);
      }
    };
  }
}();
var off$2 = dom.off = function() {
  if (!isServer$2 && document.removeEventListener) {
    return function(element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event) {
        element.detachEvent("on" + event, handler);
      }
    };
  }
}();
dom.once = function once(el, event, fn2) {
  var listener = function listener2() {
    if (fn2) {
      fn2.apply(this, arguments);
    }
    off$2(el, event, listener2);
  };
  on$2(el, event, listener);
};
function hasClass$2(el, cls) {
  if (!el || !cls)
    return false;
  if (cls.indexOf(" ") !== -1)
    throw new Error("className should not contain space.");
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (" " + el.className + " ").indexOf(" " + cls + " ") > -1;
  }
}
function addClass$2(el, cls) {
  if (!el)
    return;
  var curClass = el.className;
  var classes = (cls || "").split(" ");
  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName)
      continue;
    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass$2(el, clsName)) {
      curClass += " " + clsName;
    }
  }
  if (!el.classList) {
    el.setAttribute("class", curClass);
  }
}
function removeClass$2(el, cls) {
  if (!el || !cls)
    return;
  var classes = cls.split(" ");
  var curClass = " " + el.className + " ";
  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName)
      continue;
    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass$2(el, clsName)) {
      curClass = curClass.replace(" " + clsName + " ", " ");
    }
  }
  if (!el.classList) {
    el.setAttribute("class", trim$1(curClass));
  }
}
var getStyle = dom.getStyle = ieVersion < 9 ? function(element, styleName) {
  if (isServer$2)
    return;
  if (!element || !styleName)
    return null;
  styleName = camelCase(styleName);
  if (styleName === "float") {
    styleName = "styleFloat";
  }
  try {
    switch (styleName) {
      case "opacity":
        try {
          return element.filters.item("alpha").opacity / 100;
        } catch (e) {
          return 1;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function(element, styleName) {
  if (isServer$2)
    return;
  if (!element || !styleName)
    return null;
  styleName = camelCase(styleName);
  if (styleName === "float") {
    styleName = "cssFloat";
  }
  try {
    var computed2 = document.defaultView.getComputedStyle(element, "");
    return element.style[styleName] || computed2 ? computed2[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};
function setStyle$1(element, styleName, value9) {
  if (!element || !styleName)
    return;
  if ((typeof styleName === "undefined" ? "undefined" : _typeof$7(styleName)) === "object") {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle$1(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === "opacity" && ieVersion < 9) {
      element.style.filter = isNaN(value9) ? "" : "alpha(opacity=" + value9 * 100 + ")";
    } else {
      element.style[styleName] = value9;
    }
  }
}
var isScroll = dom.isScroll = function isScroll2(el, vertical2) {
  if (isServer$2)
    return;
  var determinedDirection = vertical2 !== null && vertical2 !== void 0;
  var overflow = determinedDirection ? vertical2 ? getStyle(el, "overflow-y") : getStyle(el, "overflow-x") : getStyle(el, "overflow");
  return overflow.match(/(scroll|auto|overlay)/);
};
dom.getScrollContainer = function getScrollContainer(el, vertical2) {
  if (isServer$2)
    return;
  var parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical2)) {
      return parent;
    }
    parent = parent.parentNode;
  }
  return parent;
};
dom.isInContainer = function isInContainer(el, container) {
  if (isServer$2 || !el || !container)
    return false;
  var elRect = el.getBoundingClientRect();
  var containerRect = void 0;
  if ([window, document, document.documentElement, null, void 0].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }
  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
};
popupManager.__esModule = true;
var _vue$5 = Vue$1;
var _vue2$5 = _interopRequireDefault$6(_vue$5);
var _dom$1 = dom;
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var hasModal$1 = false;
var hasInitZIndex$1 = false;
var zIndex$1 = void 0;
var getModal$1 = function getModal() {
  if (_vue2$5.default.prototype.$isServer)
    return;
  var modalDom = PopupManager$1.modalDom;
  if (modalDom) {
    hasModal$1 = true;
  } else {
    hasModal$1 = false;
    modalDom = document.createElement("div");
    PopupManager$1.modalDom = modalDom;
    modalDom.addEventListener("touchmove", function(event) {
      event.preventDefault();
      event.stopPropagation();
    });
    modalDom.addEventListener("click", function() {
      PopupManager$1.doOnModalClick && PopupManager$1.doOnModalClick();
    });
  }
  return modalDom;
};
var instances$1 = {};
var PopupManager$1 = {
  modalFade: true,
  getInstance: function getInstance(id) {
    return instances$1[id];
  },
  register: function register(id, instance2) {
    if (id && instance2) {
      instances$1[id] = instance2;
    }
  },
  deregister: function deregister(id) {
    if (id) {
      instances$1[id] = null;
      delete instances$1[id];
    }
  },
  nextZIndex: function nextZIndex() {
    return PopupManager$1.zIndex++;
  },
  modalStack: [],
  doOnModalClick: function doOnModalClick() {
    var topItem = PopupManager$1.modalStack[PopupManager$1.modalStack.length - 1];
    if (!topItem)
      return;
    var instance2 = PopupManager$1.getInstance(topItem.id);
    if (instance2 && instance2.closeOnClickModal) {
      instance2.close();
    }
  },
  openModal: function openModal(id, zIndex2, dom2, modalClass, modalFade) {
    if (_vue2$5.default.prototype.$isServer)
      return;
    if (!id || zIndex2 === void 0)
      return;
    this.modalFade = modalFade;
    var modalStack = this.modalStack;
    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }
    var modalDom = getModal$1();
    (0, _dom$1.addClass)(modalDom, "v-modal");
    if (this.modalFade && !hasModal$1) {
      (0, _dom$1.addClass)(modalDom, "v-modal-enter");
    }
    if (modalClass) {
      var classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(function(item2) {
        return (0, _dom$1.addClass)(modalDom, item2);
      });
    }
    setTimeout(function() {
      (0, _dom$1.removeClass)(modalDom, "v-modal-enter");
    }, 200);
    if (dom2 && dom2.parentNode && dom2.parentNode.nodeType !== 11) {
      dom2.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }
    if (zIndex2) {
      modalDom.style.zIndex = zIndex2;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = "";
    this.modalStack.push({
      id,
      zIndex: zIndex2,
      modalClass
    });
  },
  closeModal: function closeModal(id) {
    var modalStack = this.modalStack;
    var modalDom = getModal$1();
    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function(item) {
            return (0, _dom$1.removeClass)(modalDom, item);
          });
        }
        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }
    if (modalStack.length === 0) {
      if (this.modalFade) {
        (0, _dom$1.addClass)(modalDom, "v-modal-leave");
      }
      setTimeout(function() {
        if (modalStack.length === 0) {
          if (modalDom.parentNode)
            modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = "none";
          PopupManager$1.modalDom = void 0;
        }
        (0, _dom$1.removeClass)(modalDom, "v-modal-leave");
      }, 200);
    }
  }
};
Object.defineProperty(PopupManager$1, "zIndex", {
  configurable: true,
  get: function get2() {
    if (!hasInitZIndex$1) {
      zIndex$1 = zIndex$1 || (_vue2$5.default.prototype.$ELEMENT || {}).zIndex || 2e3;
      hasInitZIndex$1 = true;
    }
    return zIndex$1;
  },
  set: function set(value9) {
    zIndex$1 = value9;
  }
});
var getTopPopup$1 = function getTopPopup() {
  if (_vue2$5.default.prototype.$isServer)
    return;
  if (PopupManager$1.modalStack.length > 0) {
    var topPopup = PopupManager$1.modalStack[PopupManager$1.modalStack.length - 1];
    if (!topPopup)
      return;
    var instance2 = PopupManager$1.getInstance(topPopup.id);
    return instance2;
  }
};
if (!_vue2$5.default.prototype.$isServer) {
  window.addEventListener("keydown", function(event) {
    if (event.keyCode === 27) {
      var topPopup = getTopPopup$1();
      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction("cancel") : topPopup.close();
      }
    }
  });
}
popupManager.default = PopupManager$1;
var scrollbarWidth = {};
scrollbarWidth.__esModule = true;
scrollbarWidth.default = function() {
  if (_vue2$4.default.prototype.$isServer)
    return 0;
  if (scrollBarWidth$1 !== void 0)
    return scrollBarWidth$1;
  var outer = document.createElement("div");
  outer.className = "el-scrollbar__wrap";
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.position = "absolute";
  outer.style.top = "-9999px";
  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = "scroll";
  var inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth$1 = widthNoScroll - widthWithScroll;
  return scrollBarWidth$1;
};
var _vue$4 = Vue$1;
var _vue2$4 = _interopRequireDefault$5(_vue$4);
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var scrollBarWidth$1 = void 0;
popup.__esModule = true;
popup.PopupManager = void 0;
var _vue$3 = Vue$1;
var _vue2$3 = _interopRequireDefault$4(_vue$3);
var _merge = merge;
var _merge2 = _interopRequireDefault$4(_merge);
var _popupManager = popupManager;
var _popupManager2 = _interopRequireDefault$4(_popupManager);
var _scrollbarWidth = scrollbarWidth;
var _scrollbarWidth2 = _interopRequireDefault$4(_scrollbarWidth);
var _dom = dom;
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var idSeed = 1;
var scrollBarWidth = void 0;
popup.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },
  beforeMount: function beforeMount() {
    this._popupId = "popup-" + idSeed++;
    _popupManager2.default.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    _popupManager2.default.deregister(this._popupId);
    _popupManager2.default.closeModal(this._popupId);
    this.restoreBodyStyle();
  },
  data: function data5() {
    return {
      opened: false,
      bodyPaddingRight: null,
      computedBodyPaddingRight: 0,
      withoutHiddenClass: true,
      rendered: false
    };
  },
  watch: {
    visible: function visible(val) {
      var _this = this;
      if (val) {
        if (this._opening)
          return;
        if (!this.rendered) {
          this.rendered = true;
          _vue2$3.default.nextTick(function() {
            _this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },
  methods: {
    open: function open(options) {
      var _this2 = this;
      if (!this.rendered) {
        this.rendered = true;
      }
      var props2 = (0, _merge2.default)({}, this.$props || this, options);
      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);
      var openDelay = Number(props2.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(function() {
          _this2._openTimer = null;
          _this2.doOpen(props2);
        }, openDelay);
      } else {
        this.doOpen(props2);
      }
    },
    doOpen: function doOpen(props2) {
      if (this.$isServer)
        return;
      if (this.willOpen && !this.willOpen())
        return;
      if (this.opened)
        return;
      this._opening = true;
      var dom2 = this.$el;
      var modal = props2.modal;
      var zIndex2 = props2.zIndex;
      if (zIndex2) {
        _popupManager2.default.zIndex = zIndex2;
      }
      if (modal) {
        if (this._closing) {
          _popupManager2.default.closeModal(this._popupId);
          this._closing = false;
        }
        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? void 0 : dom2, props2.modalClass, props2.modalFade);
        if (props2.lockScroll) {
          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, "el-popup-parent--hidden");
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, "paddingRight"), 10);
          }
          scrollBarWidth = (0, _scrollbarWidth2.default)();
          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          var bodyOverflowY = (0, _dom.getStyle)(document.body, "overflowY");
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === "scroll") && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + "px";
          }
          (0, _dom.addClass)(document.body, "el-popup-parent--hidden");
        }
      }
      if (getComputedStyle(dom2).position === "static") {
        dom2.style.position = "absolute";
      }
      dom2.style.zIndex = _popupManager2.default.nextZIndex();
      this.opened = true;
      this.onOpen && this.onOpen();
      this.doAfterOpen();
    },
    doAfterOpen: function doAfterOpen() {
      this._opening = false;
    },
    close: function close() {
      var _this3 = this;
      if (this.willClose && !this.willClose())
        return;
      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);
      var closeDelay = Number(this.closeDelay);
      if (closeDelay > 0) {
        this._closeTimer = setTimeout(function() {
          _this3._closeTimer = null;
          _this3.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose: function doClose() {
      this._closing = true;
      this.onClose && this.onClose();
      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }
      this.opened = false;
      this.doAfterClose();
    },
    doAfterClose: function doAfterClose() {
      _popupManager2.default.closeModal(this._popupId);
      this._closing = false;
    },
    restoreBodyStyle: function restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight;
        (0, _dom.removeClass)(document.body, "el-popup-parent--hidden");
      }
      this.withoutHiddenClass = true;
    }
  }
};
popup.PopupManager = _popupManager2.default;
var afterLeave = {};
afterLeave.__esModule = true;
afterLeave.default = function(instance2, callback2) {
  var speed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300;
  var once2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  if (!instance2 || !callback2)
    throw new Error("instance & callback is required");
  var called = false;
  var afterLeaveCallback = function afterLeaveCallback2() {
    if (called)
      return;
    called = true;
    if (callback2) {
      callback2.apply(null, arguments);
    }
  };
  if (once2) {
    instance2.$once("after-leave", afterLeaveCallback);
  } else {
    instance2.$on("after-leave", afterLeaveCallback);
  }
  setTimeout(function() {
    afterLeaveCallback();
  }, speed + 100);
};
(function(module) {
  module.exports = function(modules) {
    var installedModules = {};
    function __webpack_require__(moduleId) {
      if (installedModules[moduleId]) {
        return installedModules[moduleId].exports;
      }
      var module2 = installedModules[moduleId] = {
        i: moduleId,
        l: false,
        exports: {}
      };
      modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
      module2.l = true;
      return module2.exports;
    }
    __webpack_require__.m = modules;
    __webpack_require__.c = installedModules;
    __webpack_require__.d = function(exports, name, getter) {
      if (!__webpack_require__.o(exports, name)) {
        Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
      }
    };
    __webpack_require__.r = function(exports) {
      if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module"
        });
      }
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
    };
    __webpack_require__.t = function(value9, mode) {
      if (mode & 1)
        value9 = __webpack_require__(value9);
      if (mode & 8)
        return value9;
      if (mode & 4 && typeof value9 === "object" && value9 && value9.__esModule)
        return value9;
      var ns = Object.create(null);
      __webpack_require__.r(ns);
      Object.defineProperty(ns, "default", {
        enumerable: true,
        value: value9
      });
      if (mode & 2 && typeof value9 != "string")
        for (var key2 in value9)
          __webpack_require__.d(ns, key2, function(key3) {
            return value9[key3];
          }.bind(null, key2));
      return ns;
    };
    __webpack_require__.n = function(module2) {
      var getter = module2 && module2.__esModule ? function getDefault() {
        return module2["default"];
      } : function getModuleExports() {
        return module2;
      };
      __webpack_require__.d(getter, "a", getter);
      return getter;
    };
    __webpack_require__.o = function(object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    __webpack_require__.p = "/dist/";
    return __webpack_require__(__webpack_require__.s = 71);
  }({
    0: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.d(__webpack_exports__, "a", function() {
        return normalizeComponent2;
      });
      function normalizeComponent2(scriptExports, render28, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
        var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
        if (render28) {
          options.render = render28;
          options.staticRenderFns = staticRenderFns2;
          options._compiled = true;
        }
        if (functionalTemplate) {
          options.functional = true;
        }
        if (scopeId) {
          options._scopeId = "data-v-" + scopeId;
        }
        var hook;
        if (moduleIdentifier) {
          hook = function(context2) {
            context2 = context2 || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
            if (!context2 && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
              context2 = __VUE_SSR_CONTEXT__;
            }
            if (injectStyles) {
              injectStyles.call(this, context2);
            }
            if (context2 && context2._registeredComponents) {
              context2._registeredComponents.add(moduleIdentifier);
            }
          };
          options._ssrRegister = hook;
        } else if (injectStyles) {
          hook = shadowMode ? function() {
            injectStyles.call(this, this.$root.$options.shadowRoot);
          } : injectStyles;
        }
        if (hook) {
          if (options.functional) {
            options._injectStyles = hook;
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context2) {
              hook.call(context2);
              return originalRender(h, context2);
            };
          } else {
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
        }
        return {
          exports: scriptExports,
          options
        };
      }
    },
    13: function(module2, exports) {
      module2.exports = popup;
    },
    2: function(module2, exports) {
      module2.exports = dom;
    },
    41: function(module2, exports) {
      module2.exports = afterLeave;
    },
    7: function(module2, exports) {
      module2.exports = Vue$1;
    },
    71: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      var external_vue_ = __webpack_require__(7);
      var external_vue_default = /* @__PURE__ */ __webpack_require__.n(external_vue_);
      var render28 = function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("transition", {
          attrs: {
            name: "el-loading-fade"
          },
          on: {
            "after-leave": _vm.handleAfterLeave
          }
        }, [_c("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }],
          staticClass: "el-loading-mask",
          class: [_vm.customClass, {
            "is-fullscreen": _vm.fullscreen
          }],
          style: {
            backgroundColor: _vm.background || ""
          }
        }, [_c("div", {
          staticClass: "el-loading-spinner"
        }, [!_vm.spinner ? _c("svg", {
          staticClass: "circular",
          attrs: {
            viewBox: "25 25 50 50"
          }
        }, [_c("circle", {
          staticClass: "path",
          attrs: {
            cx: "50",
            cy: "50",
            r: "20",
            fill: "none"
          }
        })]) : _c("i", {
          class: _vm.spinner
        }), _vm.text ? _c("p", {
          staticClass: "el-loading-text"
        }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()])])]);
      };
      var staticRenderFns2 = [];
      render28._withStripped = true;
      var loadingvue_type_script_lang_js_ = {
        data: function data22() {
          return {
            text: null,
            spinner: null,
            background: null,
            fullscreen: true,
            visible: false,
            customClass: ""
          };
        },
        methods: {
          handleAfterLeave: function handleAfterLeave() {
            this.$emit("after-leave");
          },
          setText: function setText(text) {
            this.text = text;
          }
        }
      };
      var src_loadingvue_type_script_lang_js_ = loadingvue_type_script_lang_js_;
      var componentNormalizer = __webpack_require__(0);
      var component = Object(componentNormalizer["a"])(src_loadingvue_type_script_lang_js_, render28, staticRenderFns2, false, null, null, null);
      component.options.__file = "packages/loading/src/loading.vue";
      var loading2 = component.exports;
      var dom_ = __webpack_require__(2);
      var popup_ = __webpack_require__(13);
      var after_leave_ = __webpack_require__(41);
      var after_leave_default = /* @__PURE__ */ __webpack_require__.n(after_leave_);
      var Mask = external_vue_default.a.extend(loading2);
      var loadingDirective = {};
      loadingDirective.install = function(Vue2) {
        if (Vue2.prototype.$isServer)
          return;
        var toggleLoading = function toggleLoading2(el, binding) {
          if (binding.value) {
            Vue2.nextTick(function() {
              if (binding.modifiers.fullscreen) {
                el.originalPosition = Object(dom_["getStyle"])(document.body, "position");
                el.originalOverflow = Object(dom_["getStyle"])(document.body, "overflow");
                el.maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
                Object(dom_["addClass"])(el.mask, "is-fullscreen");
                insertDom(document.body, el, binding);
              } else {
                Object(dom_["removeClass"])(el.mask, "is-fullscreen");
                if (binding.modifiers.body) {
                  el.originalPosition = Object(dom_["getStyle"])(document.body, "position");
                  ["top", "left"].forEach(function(property) {
                    var scroll = property === "top" ? "scrollTop" : "scrollLeft";
                    el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] - parseInt(Object(dom_["getStyle"])(document.body, "margin-" + property), 10) + "px";
                  });
                  ["height", "width"].forEach(function(property) {
                    el.maskStyle[property] = el.getBoundingClientRect()[property] + "px";
                  });
                  insertDom(document.body, el, binding);
                } else {
                  el.originalPosition = Object(dom_["getStyle"])(el, "position");
                  insertDom(el, el, binding);
                }
              }
            });
          } else {
            after_leave_default()(el.instance, function(_) {
              if (!el.instance.hiding)
                return;
              el.domVisible = false;
              var target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
              Object(dom_["removeClass"])(target, "el-loading-parent--relative");
              Object(dom_["removeClass"])(target, "el-loading-parent--hidden");
              el.instance.hiding = false;
            }, 300, true);
            el.instance.visible = false;
            el.instance.hiding = true;
          }
        };
        var insertDom = function insertDom2(parent, el, binding) {
          if (!el.domVisible && Object(dom_["getStyle"])(el, "display") !== "none" && Object(dom_["getStyle"])(el, "visibility") !== "hidden") {
            Object.keys(el.maskStyle).forEach(function(property) {
              el.mask.style[property] = el.maskStyle[property];
            });
            if (el.originalPosition !== "absolute" && el.originalPosition !== "fixed") {
              Object(dom_["addClass"])(parent, "el-loading-parent--relative");
            }
            if (binding.modifiers.fullscreen && binding.modifiers.lock) {
              Object(dom_["addClass"])(parent, "el-loading-parent--hidden");
            }
            el.domVisible = true;
            parent.appendChild(el.mask);
            Vue2.nextTick(function() {
              if (el.instance.hiding) {
                el.instance.$emit("after-leave");
              } else {
                el.instance.visible = true;
              }
            });
            el.domInserted = true;
          } else if (el.domVisible && el.instance.hiding === true) {
            el.instance.visible = true;
            el.instance.hiding = false;
          }
        };
        Vue2.directive("loading", {
          bind: function bind2(el, binding, vnode) {
            var textExr = el.getAttribute("element-loading-text");
            var spinnerExr = el.getAttribute("element-loading-spinner");
            var backgroundExr = el.getAttribute("element-loading-background");
            var customClassExr = el.getAttribute("element-loading-custom-class");
            var vm = vnode.context;
            var mask = new Mask({
              el: document.createElement("div"),
              data: {
                text: vm && vm[textExr] || textExr,
                spinner: vm && vm[spinnerExr] || spinnerExr,
                background: vm && vm[backgroundExr] || backgroundExr,
                customClass: vm && vm[customClassExr] || customClassExr,
                fullscreen: !!binding.modifiers.fullscreen
              }
            });
            el.instance = mask;
            el.mask = mask.$el;
            el.maskStyle = {};
            binding.value && toggleLoading(el, binding);
          },
          update: function update2(el, binding) {
            el.instance.setText(el.getAttribute("element-loading-text"));
            if (binding.oldValue !== binding.value) {
              toggleLoading(el, binding);
            }
          },
          unbind: function unbind2(el, binding) {
            if (el.domInserted) {
              el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
              toggleLoading(el, {
                value: false,
                modifiers: binding.modifiers
              });
            }
            el.instance && el.instance.$destroy();
          }
        });
      };
      var directive = loadingDirective;
      var merge_ = __webpack_require__(9);
      var merge_default = /* @__PURE__ */ __webpack_require__.n(merge_);
      var LoadingConstructor = external_vue_default.a.extend(loading2);
      var defaults2 = {
        text: null,
        fullscreen: true,
        body: false,
        lock: false,
        customClass: ""
      };
      var fullscreenLoading = void 0;
      LoadingConstructor.prototype.originalPosition = "";
      LoadingConstructor.prototype.originalOverflow = "";
      LoadingConstructor.prototype.close = function() {
        var _this = this;
        if (this.fullscreen) {
          fullscreenLoading = void 0;
        }
        after_leave_default()(this, function(_) {
          var target = _this.fullscreen || _this.body ? document.body : _this.target;
          Object(dom_["removeClass"])(target, "el-loading-parent--relative");
          Object(dom_["removeClass"])(target, "el-loading-parent--hidden");
          if (_this.$el && _this.$el.parentNode) {
            _this.$el.parentNode.removeChild(_this.$el);
          }
          _this.$destroy();
        }, 300);
        this.visible = false;
      };
      var src_addStyle = function addStyle(options, parent, instance2) {
        var maskStyle = {};
        if (options.fullscreen) {
          instance2.originalPosition = Object(dom_["getStyle"])(document.body, "position");
          instance2.originalOverflow = Object(dom_["getStyle"])(document.body, "overflow");
          maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
        } else if (options.body) {
          instance2.originalPosition = Object(dom_["getStyle"])(document.body, "position");
          ["top", "left"].forEach(function(property) {
            var scroll = property === "top" ? "scrollTop" : "scrollLeft";
            maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + "px";
          });
          ["height", "width"].forEach(function(property) {
            maskStyle[property] = options.target.getBoundingClientRect()[property] + "px";
          });
        } else {
          instance2.originalPosition = Object(dom_["getStyle"])(parent, "position");
        }
        Object.keys(maskStyle).forEach(function(property) {
          instance2.$el.style[property] = maskStyle[property];
        });
      };
      var src_Loading = function Loading2() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (external_vue_default.a.prototype.$isServer)
          return;
        options = merge_default()({}, defaults2, options);
        if (typeof options.target === "string") {
          options.target = document.querySelector(options.target);
        }
        options.target = options.target || document.body;
        if (options.target !== document.body) {
          options.fullscreen = false;
        } else {
          options.body = true;
        }
        if (options.fullscreen && fullscreenLoading) {
          return fullscreenLoading;
        }
        var parent = options.body ? document.body : options.target;
        var instance2 = new LoadingConstructor({
          el: document.createElement("div"),
          data: options
        });
        src_addStyle(options, parent, instance2);
        if (instance2.originalPosition !== "absolute" && instance2.originalPosition !== "fixed") {
          Object(dom_["addClass"])(parent, "el-loading-parent--relative");
        }
        if (options.fullscreen && options.lock) {
          Object(dom_["addClass"])(parent, "el-loading-parent--hidden");
        }
        parent.appendChild(instance2.$el);
        external_vue_default.a.nextTick(function() {
          instance2.visible = true;
        });
        if (options.fullscreen) {
          fullscreenLoading = instance2;
        }
        return instance2;
      };
      var src2 = src_Loading;
      __webpack_exports__["default"] = {
        install: function install2(Vue2) {
          Vue2.use(directive);
          Vue2.prototype.$loading = src2;
        },
        directive,
        service: src2
      };
    },
    9: function(module2, exports) {
      module2.exports = merge;
    }
  });
})(loading);
var _Loading = /* @__PURE__ */ getDefaultExportFromCjs(loading.exports);
var props$8 = {
  value: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  },
  multiple: {
    type: Boolean,
    default: false
  },
  onFocus: {
    type: Function,
    default: null
  },
  onChange: {
    type: Function,
    default: null
  }
};
var render$Z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "classify-select"
  }, [_c("el-select", {
    staticClass: "classify-select__selector",
    attrs: {
      "placeholder": "\u8BF7\u9009\u62E9\u4E8B\u4E1A\u7EBF",
      "filterable": "",
      "multiple": _vm.multiple,
      "clearable": "",
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.handleFocus,
      "change": _vm.handleSelect
    },
    model: {
      value: _vm.currentVal,
      callback: function($$v) {
        _vm.currentVal = $$v;
      },
      expression: "currentVal"
    }
  }, _vm._l(_vm.ROOT_market_classify, function(item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1);
};
var staticRenderFns$Y = [];
render$Z._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$c = "";
const __vue2_script$_ = defineComponent({
  name: "OpClassifySelect",
  props: __spreadValues({}, props$8),
  setup(props2) {
    const {
      ROOT_market_classify,
      getDictData
    } = useDictData(["ROOT_market_classify"]);
    const currentVal = props2.multiple ? ref([]) : ref("");
    const {
      value: value9
    } = toRefs(props2);
    const [internalValue, setInnerValue] = useVModel(value9, [], props2.onChange, "change");
    getDictData();
    const currentSelection = computed(() => {
      if (props2.multiple) {
        return ROOT_market_classify.value.filter((x) => currentVal.value.includes(x.value));
      } else {
        return ROOT_market_classify.value.filter((x) => currentVal.value === x.value);
      }
    });
    onMounted(() => {
      if (props2.multiple) {
        currentVal.value = props2.value;
      } else {
        currentVal.value = props2.value && props2.value.length > 0 ? props2.value[0] : "";
      }
    });
    const handleFocus = () => {
      if (props2.onFocus && typeof props2.onFocus === "function") {
        props2.onFocus();
      }
    };
    const handleSelect = (val) => {
      if (props2.multiple) {
        setInnerValue(val, currentSelection.value);
      } else {
        setInnerValue(val ? [val] : [], currentSelection.value);
      }
    };
    return {
      ROOT_market_classify,
      currentVal,
      handleFocus,
      handleSelect
    };
  }
});
const __cssModules$_ = {};
var __component__$_ = /* @__PURE__ */ normalizeComponent(__vue2_script$_, render$Z, staticRenderFns$Y, false, __vue2_injectStyles$_, "074c4543", null, null);
function __vue2_injectStyles$_(context2) {
  for (let o in __cssModules$_) {
    this[o] = __cssModules$_[o];
  }
}
__component__$_.options.__file = "packages/op-classify-select/src/pc/index.vue";
var OpClassifySelect = /* @__PURE__ */ function() {
  return __component__$_.exports;
}();
var render$Y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "classify-select"
  }, [_c("field-pannel", {
    attrs: {
      "list": _vm.selection,
      "disabled": _vm.disabled,
      "config": {
        label: "label",
        value: "value"
      }
    },
    on: {
      "open": _vm.open
    }
  }), _c("van-popup", {
    attrs: {
      "value": _vm.visible,
      "round": "",
      "position": "bottom",
      "close-on-click-overlay": false
    }
  }, [_c("van-nav-bar", {
    attrs: {
      "title": ""
    },
    on: {
      "click-left": _vm.close,
      "click-right": _vm.save
    },
    scopedSlots: _vm._u([{
      key: "left",
      fn: function() {
        return [_c("span", [_vm._v("\u5173\u95ED")])];
      },
      proxy: true
    }, {
      key: "right",
      fn: function() {
        return [_c("span", [_vm._v("\u786E\u8BA4")])];
      },
      proxy: true
    }])
  }), _c("div", {
    staticClass: "checkbox-con",
    style: "max-height: " + _vm.height + "px; overflow-y: auto"
  }, [_vm.multiple ? _c("van-checkbox-group", {
    ref: "checkboxGroup",
    model: {
      value: _vm.currentVal,
      callback: function($$v) {
        _vm.currentVal = $$v;
      },
      expression: "currentVal"
    }
  }, [_c("van-cell-group", _vm._l(_vm.ROOT_market_classify, function(item) {
    return _c("van-cell", {
      key: item.value,
      attrs: {
        "clickable": "",
        "title": item.label
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleSelect(item);
        }
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c("van-checkbox", {
            attrs: {
              "shape": "square",
              "name": item.value
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)], 1) : _c("van-radio-group", {
    model: {
      value: _vm.currentVal,
      callback: function($$v) {
        _vm.currentVal = $$v;
      },
      expression: "currentVal"
    }
  }, [_c("van-cell-group", _vm._l(_vm.ROOT_market_classify, function(item) {
    return _c("van-cell", {
      key: item.value,
      attrs: {
        "clickable": "",
        "title": item.label
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleSelect(item);
        }
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c("van-radio", {
            attrs: {
              "shape": "round",
              "name": item.value
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns$X = [];
render$Y._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$b = "";
const __vue2_script$Z = defineComponent({
  name: "OpClassifySelect",
  components: {
    FieldPannel
  },
  props: __spreadValues({}, props$8),
  setup(props2) {
    const height = ref(500);
    const currentVal = props2.multiple ? ref([]) : ref("");
    const selection = ref([]);
    const {
      value: value9
    } = toRefs(props2);
    const {
      ROOT_market_classify,
      getDictData
    } = useDictData(["ROOT_market_classify"]);
    const {
      visible: visible2,
      open: open3,
      close: close3
    } = useModal(props2);
    const [internalValue, setInnerValue] = useVModel(value9, [], props2.onChange, "change");
    const currentSelection = computed(() => {
      if (props2.multiple) {
        return ROOT_market_classify.value.filter((x) => currentVal.value.includes(x.value));
      } else {
        return ROOT_market_classify.value.filter((x) => currentVal.value === x.value);
      }
    });
    const save2 = () => {
      selection.value = JSON.parse(JSON.stringify(currentSelection.value));
      if (props2.multiple) {
        setInnerValue(currentVal.value, currentSelection.value);
      } else {
        setInnerValue(currentVal.value ? [currentVal.valuel] : [], currentSelection.value);
      }
      close3();
    };
    const handleSelect = (item) => {
      if (props2.multiple) {
        const _index = currentVal.value.findIndex((x) => x === item.value);
        if (_index > -1) {
          currentVal.value.splice(_index, 1);
        } else {
          currentVal.value.push(item.value);
        }
      } else {
        currentVal.value = item.value;
      }
    };
    onMounted(() => {
      if (props2.multiple) {
        currentVal.value = props2.value;
      } else {
        currentVal.value = props2.value && props2.value.length > 0 ? props2.value[0] : "";
      }
    });
    getDictData();
    return {
      visible: visible2,
      height,
      ROOT_market_classify,
      currentVal,
      selection,
      handleSelect,
      open: open3,
      close: close3,
      save: save2
    };
  }
});
const __cssModules$Z = {};
var __component__$Z = /* @__PURE__ */ normalizeComponent(__vue2_script$Z, render$Y, staticRenderFns$X, false, __vue2_injectStyles$Z, "560576b2", null, null);
function __vue2_injectStyles$Z(context2) {
  for (let o in __cssModules$Z) {
    this[o] = __cssModules$Z[o];
  }
}
__component__$Z.options.__file = "packages/op-classify-select/src/mobile/index.vue";
var MobileClassifySelect = /* @__PURE__ */ function() {
  return __component__$Z.exports;
}();
OpClassifySelect.install = (Vue2) => {
  if (!Vue2.prototype.$loading) {
    Vue2.use(_Loading.directive);
    Vue2.prototype.$loading = _Loading.service;
  }
  if (isPCWidth()) {
    Vue2.component(OpClassifySelect.name, OpClassifySelect);
  } else {
    Vue2.component(MobileClassifySelect.name, MobileClassifySelect);
  }
};
var __glob_6_5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpClassifySelect
});
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t4, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    var t4 = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", $ = "Invalid Date", l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
    }, m = function(t5, e2, n2) {
      var r2 = String(t5);
      return !r2 || r2.length >= e2 ? t5 : "" + Array(e2 + 1 - r2.length).join(n2) + t5;
    }, g = {
      s: m,
      z: function(t5) {
        var e2 = -t5.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      },
      m: function t5(e2, n2) {
        if (e2.date() < n2.date())
          return -t5(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, f), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), f);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      },
      a: function(t5) {
        return t5 < 0 ? Math.ceil(t5) || 0 : Math.floor(t5);
      },
      p: function(t5) {
        return {
          M: f,
          y: c,
          w: o,
          d: a,
          D: d,
          h: u,
          m: s,
          s: i,
          ms: r,
          Q: h
        }[t5] || String(t5 || "").toLowerCase().replace(/s$/, "");
      },
      u: function(t5) {
        return t5 === void 0;
      }
    }, D = "en", v = {};
    v[D] = M;
    var p = function(t5) {
      return t5 instanceof _;
    }, S = function(t5, e2, n2) {
      var r2;
      if (!t5)
        return D;
      if (typeof t5 == "string")
        v[t5] && (r2 = t5), e2 && (v[t5] = e2, r2 = t5);
      else {
        var i2 = t5.name;
        v[i2] = t5, r2 = i2;
      }
      return !n2 && r2 && (D = r2), r2 || !n2 && D;
    }, w = function(t5, e2) {
      if (p(t5))
        return t5.clone();
      var n2 = typeof e2 == "object" ? e2 : {};
      return n2.date = t5, n2.args = arguments, new _(n2);
    }, O = g;
    O.l = S, O.i = p, O.w = function(t5, e2) {
      return w(t5, {
        locale: e2.$L,
        utc: e2.$u,
        x: e2.$x,
        $offset: e2.$offset
      });
    };
    var _ = function() {
      function M2(t5) {
        this.$L = S(t5.locale, null, true), this.parse(t5);
      }
      var m2 = M2.prototype;
      return m2.parse = function(t5) {
        this.$d = function(t6) {
          var e2 = t6.date, n2 = t6.utc;
          if (e2 === null)
            return new Date(NaN);
          if (O.u(e2))
            return new Date();
          if (e2 instanceof Date)
            return new Date(e2);
          if (typeof e2 == "string" && !/Z$/i.test(e2)) {
            var r2 = e2.match(l);
            if (r2) {
              var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
              return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
            }
          }
          return new Date(e2);
        }(t5), this.$x = t5.x || {}, this.init();
      }, m2.init = function() {
        var t5 = this.$d;
        this.$y = t5.getFullYear(), this.$M = t5.getMonth(), this.$D = t5.getDate(), this.$W = t5.getDay(), this.$H = t5.getHours(), this.$m = t5.getMinutes(), this.$s = t5.getSeconds(), this.$ms = t5.getMilliseconds();
      }, m2.$utils = function() {
        return O;
      }, m2.isValid = function() {
        return !(this.$d.toString() === $);
      }, m2.isSame = function(t5, e2) {
        var n2 = w(t5);
        return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
      }, m2.isAfter = function(t5, e2) {
        return w(t5) < this.startOf(e2);
      }, m2.isBefore = function(t5, e2) {
        return this.endOf(e2) < w(t5);
      }, m2.$g = function(t5, e2, n2) {
        return O.u(t5) ? this[e2] : this.set(n2, t5);
      }, m2.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m2.valueOf = function() {
        return this.$d.getTime();
      }, m2.startOf = function(t5, e2) {
        var n2 = this, r2 = !!O.u(e2) || e2, h2 = O.p(t5), $2 = function(t6, e3) {
          var i2 = O.w(n2.$u ? Date.UTC(n2.$y, e3, t6) : new Date(n2.$y, e3, t6), n2);
          return r2 ? i2 : i2.endOf(a);
        }, l2 = function(t6, e3) {
          return O.w(n2.toDate()[t6].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
        }, y2 = this.$W, M3 = this.$M, m3 = this.$D, g2 = "set" + (this.$u ? "UTC" : "");
        switch (h2) {
          case c:
            return r2 ? $2(1, 0) : $2(31, 11);
          case f:
            return r2 ? $2(1, M3) : $2(0, M3 + 1);
          case o:
            var D2 = this.$locale().weekStart || 0, v2 = (y2 < D2 ? y2 + 7 : y2) - D2;
            return $2(r2 ? m3 - v2 : m3 + (6 - v2), M3);
          case a:
          case d:
            return l2(g2 + "Hours", 0);
          case u:
            return l2(g2 + "Minutes", 1);
          case s:
            return l2(g2 + "Seconds", 2);
          case i:
            return l2(g2 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m2.endOf = function(t5) {
        return this.startOf(t5, false);
      }, m2.$set = function(t5, e2) {
        var n2, o2 = O.p(t5), h2 = "set" + (this.$u ? "UTC" : ""), $2 = (n2 = {}, n2[a] = h2 + "Date", n2[d] = h2 + "Date", n2[f] = h2 + "Month", n2[c] = h2 + "FullYear", n2[u] = h2 + "Hours", n2[s] = h2 + "Minutes", n2[i] = h2 + "Seconds", n2[r] = h2 + "Milliseconds", n2)[o2], l2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
        if (o2 === f || o2 === c) {
          var y2 = this.clone().set(d, 1);
          y2.$d[$2](l2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
        } else
          $2 && this.$d[$2](l2);
        return this.init(), this;
      }, m2.set = function(t5, e2) {
        return this.clone().$set(t5, e2);
      }, m2.get = function(t5) {
        return this[O.p(t5)]();
      }, m2.add = function(r2, h2) {
        var d2, $2 = this;
        r2 = Number(r2);
        var l2 = O.p(h2), y2 = function(t5) {
          var e2 = w($2);
          return O.w(e2.date(e2.date() + Math.round(t5 * r2)), $2);
        };
        if (l2 === f)
          return this.set(f, this.$M + r2);
        if (l2 === c)
          return this.set(c, this.$y + r2);
        if (l2 === a)
          return y2(1);
        if (l2 === o)
          return y2(7);
        var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t4, d2)[l2] || 1, m3 = this.$d.getTime() + r2 * M3;
        return O.w(m3, this);
      }, m2.subtract = function(t5, e2) {
        return this.add(-1 * t5, e2);
      }, m2.format = function(t5) {
        var e2 = this, n2 = this.$locale();
        if (!this.isValid())
          return n2.invalidDate || $;
        var r2 = t5 || "YYYY-MM-DDTHH:mm:ssZ", i2 = O.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, f2 = n2.months, h2 = function(t6, n3, i3, s3) {
          return t6 && (t6[n3] || t6(e2, r2)) || i3[n3].substr(0, s3);
        }, c2 = function(t6) {
          return O.s(s2 % 12 || 12, t6, "0");
        }, d2 = n2.meridiem || function(t6, e3, n3) {
          var r3 = t6 < 12 ? "AM" : "PM";
          return n3 ? r3.toLowerCase() : r3;
        }, l2 = {
          YY: String(this.$y).slice(-2),
          YYYY: this.$y,
          M: a2 + 1,
          MM: O.s(a2 + 1, 2, "0"),
          MMM: h2(n2.monthsShort, a2, f2, 3),
          MMMM: h2(f2, a2),
          D: this.$D,
          DD: O.s(this.$D, 2, "0"),
          d: String(this.$W),
          dd: h2(n2.weekdaysMin, this.$W, o2, 2),
          ddd: h2(n2.weekdaysShort, this.$W, o2, 3),
          dddd: o2[this.$W],
          H: String(s2),
          HH: O.s(s2, 2, "0"),
          h: c2(1),
          hh: c2(2),
          a: d2(s2, u2, true),
          A: d2(s2, u2, false),
          m: String(u2),
          mm: O.s(u2, 2, "0"),
          s: String(this.$s),
          ss: O.s(this.$s, 2, "0"),
          SSS: O.s(this.$ms, 3, "0"),
          Z: i2
        };
        return r2.replace(y, function(t6, e3) {
          return e3 || l2[t6] || i2.replace(":", "");
        });
      }, m2.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m2.diff = function(r2, d2, $2) {
        var l2, y2 = O.p(d2), M3 = w(r2), m3 = (M3.utcOffset() - this.utcOffset()) * e, g2 = this - M3, D2 = O.m(this, M3);
        return D2 = (l2 = {}, l2[c] = D2 / 12, l2[f] = D2, l2[h] = D2 / 3, l2[o] = (g2 - m3) / 6048e5, l2[a] = (g2 - m3) / 864e5, l2[u] = g2 / n, l2[s] = g2 / e, l2[i] = g2 / t4, l2)[y2] || g2, $2 ? D2 : O.a(D2);
      }, m2.daysInMonth = function() {
        return this.endOf(f).$D;
      }, m2.$locale = function() {
        return v[this.$L];
      }, m2.locale = function(t5, e2) {
        if (!t5)
          return this.$L;
        var n2 = this.clone(), r2 = S(t5, e2, true);
        return r2 && (n2.$L = r2), n2;
      }, m2.clone = function() {
        return O.w(this.$d, this);
      }, m2.toDate = function() {
        return new Date(this.valueOf());
      }, m2.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m2.toISOString = function() {
        return this.$d.toISOString();
      }, m2.toString = function() {
        return this.$d.toUTCString();
      }, M2;
    }(), b = _.prototype;
    return w.prototype = b, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function(t5) {
      b[t5[1]] = function(e2) {
        return this.$g(e2, t5[0], t5[1]);
      };
    }), w.extend = function(t5, e2) {
      return t5.$i || (t5(e2, _, w), t5.$i = true), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t5) {
      return w(1e3 * t5);
    }, w.en = v[D], w.Ls = v, w.p = {}, w;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
const dataFilter = (dataStr, pattern = "YYYY-MM-DD HH:mm:ss") => {
  if (dataStr) {
    return dayjs(Number(dataStr)).format(pattern);
  } else {
    return "";
  }
};
Vue$1.filter("dateFormat", dataFilter);
/**!
 * Sortable 1.15.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function(key2) {
        _defineProperty$1(target, key2, source[key2]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key2) {
        Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
      });
    }
  }
  return target;
}
function _typeof$6(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$6 = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$6 = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$6(obj);
}
function _defineProperty$1(obj, key2, value9) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value: value9,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value9;
  }
  return obj;
}
function _extends$m() {
  _extends$m = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$m.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$4(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
var version$1 = "1.15.0";
function userAgent(pattern) {
  if (typeof window !== "undefined" && window.navigator) {
    return !!/* @__PURE__ */ navigator.userAgent.match(pattern);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
  capture: false,
  passive: false
};
function on$1(el, event, fn2) {
  el.addEventListener(event, fn2, !IE11OrLess && captureMode);
}
function off$1(el, event, fn2) {
  el.removeEventListener(event, fn2, !IE11OrLess && captureMode);
}
function matches(el, selector) {
  if (!selector)
    return;
  selector[0] === ">" && (selector = selector.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(el, selector, ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx)
        break;
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass$1(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? "add" : "remove"](name);
    } else {
      var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name + " ", " ");
      el.className = (className + (state ? " " + name : "")).replace(R_SPACE, " ");
    }
  }
}
function css(el, prop, val) {
  var style6 = el && el.style;
  if (style6) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, "");
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style6) && prop.indexOf("webkit") === -1) {
        prop = "-webkit-" + prop;
      }
      style6[prop] = val + (typeof val === "string" ? "" : "px");
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = "";
  if (typeof el === "string") {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, "transform");
      if (transform && transform !== "none") {
        appliedTransforms = transform + " " + appliedTransforms;
      }
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return matrixFn && new matrixFn(appliedTransforms);
}
function find2(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }
    return list;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window)
    return;
  var elRect, top, left, bottom, right, height, width;
  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    container = container || el.parentNode;
    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, "transform") !== "none" || relativeToNonStaticParent && css(container, "position") !== "static")) {
          var containerRect = container.getBoundingClientRect();
          top -= containerRect.top + parseInt(css(container, "border-top-width"));
          left -= containerRect.left + parseInt(css(container, "border-left-width"));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
      } while (container = container.parentNode);
    }
  }
  if (undoScale && el !== window) {
    var elMatrix = matrix(container || el), scaleX2 = elMatrix && elMatrix.a, scaleY2 = elMatrix && elMatrix.d;
    if (elMatrix) {
      top /= scaleY2;
      left /= scaleX2;
      width /= scaleX2;
      height /= scaleY2;
      bottom = top + height;
      right = left + width;
    }
  }
  return {
    top,
    left,
    bottom,
    right,
    width,
    height
  };
}
function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
  while (parent) {
    var parentSideVal = getRect(parent)[parentSide], visible2 = void 0;
    if (parentSide === "top" || parentSide === "left") {
      visible2 = elSideVal >= parentSideVal;
    } else {
      visible2 = elSideVal <= parentSideVal;
    }
    if (!visible2)
      return parent;
    if (parent === getWindowScrollingElement())
      break;
    parent = getParentAutoScrollElement(parent, false);
  }
  return false;
}
function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0, i = 0, children3 = el.children;
  while (i < children3.length) {
    if (children3[i].style.display !== "none" && children3[i] !== Sortable.ghost && (includeDragEl || children3[i] !== Sortable.dragged) && closest(children3[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children3[i];
      }
      currentChild++;
    }
    i++;
  }
  return null;
}
function lastChild(el, selector) {
  var last = el.lastElementChild;
  while (last && (last === Sortable.ghost || css(last, "display") === "none" || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }
  return last || null;
}
function index$o(el, selector) {
  var index2 = 0;
  if (!el || !el.parentNode) {
    return -1;
  }
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index2++;
    }
  }
  return index2;
}
function getRelativeScrollOffset(el) {
  var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el), scaleX2 = elMatrix.a, scaleY2 = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX2;
      offsetTop += el.scrollTop * scaleY2;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}
function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i))
      continue;
    for (var key2 in obj) {
      if (obj.hasOwnProperty(key2) && obj[key2] === arr[i][key2])
        return Number(i);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  if (!el || !el.getBoundingClientRect)
    return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
        if (!elem.getBoundingClientRect || elem === document.body)
          return getWindowScrollingElement();
        if (gotSelf || includeSelf)
          return elem;
        gotSelf = true;
      }
    }
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend$1(dst, src2) {
  if (dst && src2) {
    for (var key2 in src2) {
      if (src2.hasOwnProperty(key2)) {
        dst[key2] = src2[key2];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle$1(callback2, ms) {
  return function() {
    if (!_throttleTimeout) {
      var args = arguments, _this = this;
      if (args.length === 1) {
        callback2.call(_this, args[0]);
      } else {
        callback2.apply(_this, args);
      }
      _throttleTimeout = setTimeout(function() {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}
function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}
function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
var expando = "Sortable" + new Date().getTime();
function AnimationStateManager() {
  var animationStates = [], animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation)
        return;
      var children3 = [].slice.call(this.el.children);
      children3.forEach(function(child) {
        if (css(child, "display") === "none" || child === Sortable.ghost)
          return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread2$1({}, animationStates[animationStates.length - 1].rect);
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target
      }), 1);
    },
    animateAll: function animateAll(callback2) {
      var _this = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback2 === "function")
          callback2();
        return;
      }
      var animating = false, animationTime = 0;
      animationStates.forEach(function(state) {
        var time = 0, target = state.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target, true);
        if (targetMatrix) {
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target.toRect = toRect;
        if (target.thisAnimationDuration) {
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        }
        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;
          if (!time) {
            time = _this.options.animation;
          }
          _this.animate(target, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function() {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback2 === "function")
          callback2();
      } else {
        animationCallbackId = setTimeout(function() {
          if (typeof callback2 === "function")
            callback2();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, "transition", "");
        css(target, "transform", "");
        var elMatrix = matrix(this.el), scaleX2 = elMatrix && elMatrix.a, scaleY2 = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX2 || 1), translateY = (currentRect.top - toRect.top) / (scaleY2 || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
        this.forRepaintDummy = repaint(target);
        css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
        css(target, "transform", "translate3d(0,0,0)");
        typeof target.animated === "number" && clearTimeout(target.animated);
        target.animated = setTimeout(function() {
          css(target, "transition", "");
          css(target, "transform", "");
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target) {
  return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount2(plugin) {
    for (var option2 in defaults) {
      if (defaults.hasOwnProperty(option2) && !(option2 in plugin)) {
        plugin[option2] = defaults[option2];
      }
    }
    plugins.forEach(function(p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;
    this.eventCanceled = false;
    evt.cancel = function() {
      _this.eventCanceled = true;
    };
    var eventNameGlobal = eventName + "Global";
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName])
        return;
      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2$1({
          sortable
        }, evt));
      }
      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2$1({
          sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
    plugins.forEach(function(plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault)
        return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;
      _extends$m(defaults2, initialized.defaults);
    });
    for (var option2 in sortable.options) {
      if (!sortable.options.hasOwnProperty(option2))
        continue;
      var modified = this.modifyOption(sortable, option2, sortable.options[option2]);
      if (typeof modified !== "undefined") {
        sortable.options[option2] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function(plugin) {
      if (typeof plugin.eventProperties !== "function")
        return;
      _extends$m(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value9) {
    var modifiedValue;
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName])
        return;
      if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value9);
      }
    });
    return modifiedValue;
  }
};
function dispatchEvent$1(_ref) {
  var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl2 && rootEl2[expando];
  if (!sortable)
    return;
  var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent(name, true, true);
  }
  evt.to = toEl || rootEl2;
  evt.from = fromEl || rootEl2;
  evt.item = targetEl || rootEl2;
  evt.clone = cloneEl2;
  evt.oldIndex = oldIndex2;
  evt.newIndex = newIndex2;
  evt.oldDraggableIndex = oldDraggableIndex2;
  evt.newDraggableIndex = newDraggableIndex2;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
  var allEventProperties = _objectSpread2$1(_objectSpread2$1({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
  for (var option2 in allEventProperties) {
    evt[option2] = allEventProperties[option2];
  }
  if (rootEl2) {
    rootEl2.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}
var _excluded$4 = ["evt"];
var pluginEvent2 = function pluginEvent3(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data22 = _objectWithoutProperties(_ref, _excluded$4);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2$1({
    dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    dragStarted: moved,
    putSortable,
    activeSortable: Sortable.active,
    originalEvent,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable,
        name,
        originalEvent
      });
    }
  }, data22));
};
function _dispatchEvent(info) {
  dispatchEvent$1(_objectSpread2$1({
    putSortable,
    cloneEl,
    targetEl: dragEl,
    rootEl,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex
  }, info));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, ghostRelativeParent, ghostRelativeParentInitialScroll = [], _silent = false, savedInputChecked = [];
var documentExists = typeof document !== "undefined", PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float", supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div"), supportCssPointerEvents = function() {
  if (!documentExists)
    return;
  if (IE11OrLess) {
    return false;
  }
  var el = document.createElement("x");
  el.style.cssText = "pointer-events:auto";
  return el.style.pointerEvents === "auto";
}(), _detectDirection = function _detectDirection2(el, options) {
  var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
  if (elCSS.display === "flex") {
    return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  }
  if (elCSS.display === "grid") {
    return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  }
  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
    var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
    return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
  }
  return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical2) {
  var dragElS1Opp = vertical2 ? dragRect.left : dragRect.top, dragElS2Opp = vertical2 ? dragRect.right : dragRect.bottom, dragElOppLength = vertical2 ? dragRect.width : dragRect.height, targetS1Opp = vertical2 ? targetRect.left : targetRect.top, targetS2Opp = vertical2 ? targetRect.right : targetRect.bottom, targetOppLength = vertical2 ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, _detectNearestEmptySortable = function _detectNearestEmptySortable2(x, y) {
  var ret;
  sortables.some(function(sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable))
      return;
    var rect = getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
}, _prepareGroup = function _prepareGroup2(options) {
  function toFn(value9, pull) {
    return function(to, from, dragEl2, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
      if (value9 == null && (pull || sameGroup)) {
        return true;
      } else if (value9 == null || value9 === false) {
        return false;
      } else if (pull && value9 === "clone") {
        return value9;
      } else if (typeof value9 === "function") {
        return toFn(value9(to, from, dragEl2, evt), pull)(to, from, dragEl2, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value9 === true || typeof value9 === "string" && value9 === otherGroup || value9.join && value9.indexOf(otherGroup) > -1;
      }
    };
  }
  var group = {};
  var originalGroup = options.group;
  if (!originalGroup || _typeof$6(originalGroup) != "object") {
    originalGroup = {
      name: originalGroup
    };
  }
  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
}, _hideGhostForTarget = function _hideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "none");
  }
}, _unhideGhostForTarget = function _unhideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "");
  }
};
if (documentExists && !ChromeForAndroid) {
  document.addEventListener("click", function(evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      var event = {};
      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el;
  this.options = options = _extends$m({}, options);
  el[expando] = this;
  var defaults2 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: false,
    invertedSwapThreshold: null,
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData2(dataTransfer, dragEl2) {
      dataTransfer.setData("Text", dragEl2.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window && !Safari,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults2);
  for (var name in defaults2) {
    !(name in options) && (options[name] = defaults2[name]);
  }
  _prepareGroup(options);
  for (var fn2 in this) {
    if (fn2.charAt(0) === "_" && typeof this[fn2] === "function") {
      this[fn2] = this[fn2].bind(this);
    }
  }
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    this.options.touchStartThreshold = 1;
  }
  if (options.supportPointer) {
    on$1(el, "pointerdown", this._onTapStart);
  } else {
    on$1(el, "mousedown", this._onTapStart);
    on$1(el, "touchstart", this._onTapStart);
  }
  if (this.nativeDraggable) {
    on$1(el, "dragover", this);
    on$1(el, "dragenter", this);
  }
  sortables.push(this.el);
  options.store && options.store.get && this.sort(options.store.get(this) || []);
  _extends$m(this, AnimationStateManager());
}
Sortable.prototype = {
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(evt) {
    if (!evt.cancelable)
      return;
    var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
    _saveInputCheckedState(el);
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return;
    }
    if (originalTarget.isContentEditable) {
      return;
    }
    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === "SELECT") {
      return;
    }
    target = closest(target, options.draggable, el, false);
    if (target && target.animated) {
      return;
    }
    if (lastDownEl === target) {
      return;
    }
    oldIndex = index$o(target);
    oldDraggableIndex = index$o(target, options.draggable);
    if (typeof filter === "function") {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: "filter",
          targetEl: target,
          toEl: el,
          fromEl: el
        });
        pluginEvent2("filter", _this, {
          evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    } else if (filter) {
      filter = filter.split(",").some(function(criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: "filter",
            targetEl: target,
            fromEl: el,
            toEl: el
          });
          pluginEvent2("filter", _this, {
            evt
          });
          return true;
        }
      });
      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }
    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(evt, touch, target) {
    var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style["will-change"] = "all";
      dragStartFn = function dragStartFn2() {
        pluginEvent2("delayEnded", _this, {
          evt
        });
        if (Sortable.eventCanceled) {
          _this._onDrop();
          return;
        }
        _this._disableDelayedDragEvents();
        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        }
        _this._triggerDragStart(evt, touch);
        _dispatchEvent({
          sortable: _this,
          name: "choose",
          originalEvent: evt
        });
        toggleClass$1(dragEl, options.chosenClass, true);
      };
      options.ignore.split(",").forEach(function(criteria) {
        find2(dragEl, criteria.trim(), _disableDraggable);
      });
      on$1(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
      on$1(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
      on$1(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
      on$1(ownerDocument, "mouseup", _this._onDrop);
      on$1(ownerDocument, "touchend", _this._onDrop);
      on$1(ownerDocument, "touchcancel", _this._onDrop);
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent2("delayStart", this, {
        evt
      });
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        on$1(ownerDocument, "mouseup", _this._disableDelayedDrag);
        on$1(ownerDocument, "touchend", _this._disableDelayedDrag);
        on$1(ownerDocument, "touchcancel", _this._disableDelayedDrag);
        on$1(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
        on$1(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
        options.supportPointer && on$1(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
    var touch = e.touches ? e.touches[0] : e;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off$1(ownerDocument, "mouseup", this._disableDelayedDrag);
    off$1(ownerDocument, "touchend", this._disableDelayedDrag);
    off$1(ownerDocument, "touchcancel", this._disableDelayedDrag);
    off$1(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
    off$1(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
    off$1(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(evt, touch) {
    touch = touch || evt.pointerType == "touch" && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on$1(document, "pointermove", this._onTouchMove);
      } else if (touch) {
        on$1(document, "touchmove", this._onTouchMove);
      } else {
        on$1(document, "mousemove", this._onTouchMove);
      }
    } else {
      on$1(dragEl, "dragend", this);
      on$1(rootEl, "dragstart", this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function() {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {
    }
  },
  _dragStarted: function _dragStarted(fallback2, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent2("dragStarted", this, {
        evt
      });
      if (this.nativeDraggable) {
        on$1(document, "dragover", _checkOutsideTargetEl);
      }
      var options = this.options;
      !fallback2 && toggleClass$1(dragEl, options.dragClass, false);
      toggleClass$1(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback2 && this._appendGhost();
      _dispatchEvent({
        sortable: this,
        name: "start",
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;
      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent)
          break;
        parent = target;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target);
      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target,
              rootEl: parent
            });
            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }
          target = parent;
        } while (parent = parent.parentNode);
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(evt) {
    if (tapEvt) {
      var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX2 = ghostEl && ghostMatrix && ghostMatrix.a, scaleY2 = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX2 || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX2 || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY2 || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY2 || 1);
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, "webkitTransform", cssMatrix);
        css(ghostEl, "mozTransform", cssMatrix);
        css(ghostEl, "msTransform", cssMatrix);
        css(ghostEl, "transform", cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
      if (PositionGhostAbsolutely) {
        ghostRelativeParent = container;
        while (css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document)
            ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass$1(ghostEl, options.ghostClass, false);
      toggleClass$1(ghostEl, options.fallbackClass, true);
      toggleClass$1(ghostEl, options.dragClass, true);
      css(ghostEl, "transition", "");
      css(ghostEl, "transform", "");
      css(ghostEl, "box-sizing", "border-box");
      css(ghostEl, "margin", 0);
      css(ghostEl, "top", rect.top);
      css(ghostEl, "left", rect.left);
      css(ghostEl, "width", rect.width);
      css(ghostEl, "height", rect.height);
      css(ghostEl, "opacity", "0.8");
      css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
      css(ghostEl, "zIndex", "100000");
      css(ghostEl, "pointerEvents", "none");
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl);
      css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
    }
  },
  _onDragStart: function _onDragStart(evt, fallback2) {
    var _this = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent2("dragStart", this, {
      evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent2("setupClone", this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.removeAttribute("id");
      cloneEl.draggable = false;
      cloneEl.style["will-change"] = "";
      this._hideClone();
      toggleClass$1(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }
    _this.cloneId = _nextTick(function() {
      pluginEvent2("clone", _this);
      if (Sortable.eventCanceled)
        return;
      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this._hideClone();
      _dispatchEvent({
        sortable: _this,
        name: "clone"
      });
    });
    !fallback2 && toggleClass$1(dragEl, options.dragClass, true);
    if (fallback2) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      off$1(document, "mouseup", _this._onDrop);
      off$1(document, "touchend", _this._onDrop);
      off$1(document, "touchcancel", _this._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = "move";
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }
      on$1(document, "drop", _this);
      css(dragEl, "transform", "translateZ(0)");
    }
    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback2, evt));
    on$1(document, "selectstart", _this);
    moved = true;
    if (Safari) {
      css(document.body, "user-select", "none");
    }
  },
  _onDragOver: function _onDragOver(evt) {
    var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical2, _this = this, completedFired = false;
    if (_silent)
      return;
    function dragOverEvent(name, extra) {
      pluginEvent2(name, _this, _objectSpread2$1({
        evt,
        isOwner,
        axis: vertical2 ? "vertical" : "horizontal",
        revert,
        dragRect,
        targetRect,
        canSort,
        fromSortable,
        target,
        completed,
        onMove: function onMove(target2, after2) {
          return _onMove(rootEl, el, dragEl, dragRect, target2, getRect(target2), evt, after2);
        },
        changed
      }, extra));
    }
    function capture() {
      dragOverEvent("dragOverAnimationCapture");
      _this.captureAnimationState();
      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }
    function completed(insertion) {
      dragOverEvent("dragOverCompleted", {
        insertion
      });
      if (insertion) {
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }
        if (_this !== fromSortable) {
          toggleClass$1(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass$1(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        }
        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }
        _this.animateAll(function() {
          dragOverEvent("dragOverAnimationComplete");
          _this._ignoreWhileAnimating = null;
        });
        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }
      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      }
      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }
    function changed() {
      newIndex = index$o(dragEl);
      newDraggableIndex = index$o(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this,
        name: "change",
        toEl: el,
        newIndex,
        newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target = closest(target, options.draggable, el, true);
    dragOverEvent("dragOver");
    if (Sortable.eventCanceled)
      return completedFired;
    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical2 = this._getDirection(evt, target) === "vertical";
      dragRect = getRect(dragEl);
      dragOverEvent("dragOverValid");
      if (Sortable.eventCanceled)
        return completedFired;
      if (revert) {
        parentEl = rootEl;
        capture();
        this._hideClone();
        dragOverEvent("revert");
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical2, this) && !elLastChild.animated) {
        if (elLastChild === dragEl) {
          return completed(false);
        }
        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }
        if (target) {
          targetRect = getRect(target);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          if (elLastChild && elLastChild.nextSibling) {
            el.insertBefore(dragEl, elLastChild.nextSibling);
          } else {
            el.appendChild(dragEl);
          }
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical2, this)) {
        var firstChild = getChild(el, 0, options, true);
        if (firstChild === dragEl) {
          return completed(false);
        }
        target = firstChild;
        targetRect = getRect(target);
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical2), side1 = vertical2 ? "top" : "left", scrolledPastTop = isScrolledPast(target, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction = _getSwapDirection(evt, target, targetRect, vertical2, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;
        if (direction !== 0) {
          var dragIndex = index$o(dragEl);
          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
        }
        if (direction === 0 || sibling === target) {
          return completed(false);
        }
        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling, after = false;
        after = direction === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          }
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode;
          if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off$1(document, "mousemove", this._onTouchMove);
    off$1(document, "touchmove", this._onTouchMove);
    off$1(document, "pointermove", this._onTouchMove);
    off$1(document, "dragover", nearestEmptyInsertDetectEvent);
    off$1(document, "mousemove", nearestEmptyInsertDetectEvent);
    off$1(document, "touchmove", nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off$1(ownerDocument, "mouseup", this._onDrop);
    off$1(ownerDocument, "touchend", this._onDrop);
    off$1(ownerDocument, "pointerup", this._onDrop);
    off$1(ownerDocument, "touchcancel", this._onDrop);
    off$1(document, "selectstart", this);
  },
  _onDrop: function _onDrop(evt) {
    var el = this.el, options = this.options;
    newIndex = index$o(dragEl);
    newDraggableIndex = index$o(dragEl, options.draggable);
    pluginEvent2("drop", this, {
      evt
    });
    parentEl = dragEl && dragEl.parentNode;
    newIndex = index$o(dragEl);
    newDraggableIndex = index$o(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);
    if (this.nativeDraggable) {
      off$1(document, "drop", this);
      off$1(el, "dragstart", this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, "user-select", "");
    }
    css(dragEl, "transform", "");
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") {
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off$1(dragEl, "dragend", this);
        }
        _disableDraggable(dragEl);
        dragEl.style["will-change"] = "";
        if (moved && !awaitingDragStarted) {
          toggleClass$1(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass$1(dragEl, this.options.chosenClass, false);
        _dispatchEvent({
          sortable: this,
          name: "unchoose",
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            _dispatchEvent({
              rootEl: parentEl,
              name: "add",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "remove",
              toEl: parentEl,
              originalEvent: evt
            });
            _dispatchEvent({
              rootEl: parentEl,
              name: "sort",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "sort",
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              _dispatchEvent({
                sortable: this,
                name: "update",
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: "sort",
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: "end",
            toEl: parentEl,
            originalEvent: evt
          });
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent2("nulling", this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function(el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(evt) {
    switch (evt.type) {
      case "drop":
      case "dragend":
        this._onDrop(evt);
        break;
      case "dragenter":
      case "dragover":
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case "selectstart":
        evt.preventDefault();
        break;
    }
  },
  toArray: function toArray() {
    var order = [], el, children3 = this.el.children, i = 0, n = children3.length, options = this.options;
    for (; i < n; i++) {
      el = children3[i];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  sort: function sort(order, useAnimation) {
    var items = {}, rootEl2 = this.el;
    this.toArray().forEach(function(id, i) {
      var el = rootEl2.children[i];
      if (closest(el, this.options.draggable, rootEl2, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function(id) {
      if (items[id]) {
        rootEl2.removeChild(items[id]);
        rootEl2.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },
  option: function option(name, value9) {
    var options = this.options;
    if (value9 === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value9);
      if (typeof modifiedValue !== "undefined") {
        options[name] = modifiedValue;
      } else {
        options[name] = value9;
      }
      if (name === "group") {
        _prepareGroup(options);
      }
    }
  },
  destroy: function destroy() {
    pluginEvent2("destroy", this);
    var el = this.el;
    el[expando] = null;
    off$1(el, "mousedown", this._onTapStart);
    off$1(el, "touchstart", this._onTapStart);
    off$1(el, "pointerdown", this._onTapStart);
    if (this.nativeDraggable) {
      off$1(el, "dragover", this);
      off$1(el, "dragenter", this);
    }
    Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
      el2.removeAttribute("draggable");
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent2("hideClone", this);
      if (Sortable.eventCanceled)
        return;
      css(cloneEl, "display", "none");
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable2) {
    if (putSortable2.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent2("showClone", this);
      if (Sortable.eventCanceled)
        return;
      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, "display", "");
      cloneHidden = false;
    }
  }
};
function _globalDragOver(evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = "move";
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent("move", {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent("move", true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl2;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsFirst(evt, vertical2, sortable) {
  var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var spacer = 10;
  return vertical2 ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function _ghostIsLast(evt, vertical2, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical2 ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function _getSwapDirection(evt, target, targetRect, vertical2, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical2 ? evt.clientY : evt.clientX, targetLength = vertical2 ? targetRect.height : targetRect.width, targetS1 = vertical2 ? targetRect.top : targetRect.left, targetS2 = vertical2 ? targetRect.bottom : targetRect.right, invert = false;
  if (!invertSwap) {
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}
function _getInsertDirection(target) {
  if (index$o(dragEl) < index$o(target)) {
    return 1;
  } else {
    return -1;
  }
}
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
  while (i--) {
    sum += str.charCodeAt(i);
  }
  return sum.toString(36);
}
function _saveInputCheckedState(root2) {
  savedInputChecked.length = 0;
  var inputs = root2.getElementsByTagName("input");
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn2) {
  return setTimeout(fn2, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}
if (documentExists) {
  on$1(document, "touchmove", function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}
Sortable.utils = {
  on: on$1,
  off: off$1,
  css,
  find: find2,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend$1,
  throttle: throttle$1,
  closest,
  toggleClass: toggleClass$1,
  clone,
  index: index$o,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild
};
Sortable.get = function(element) {
  return element[expando];
};
Sortable.mount = function() {
  for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins2[_key] = arguments[_key];
  }
  if (plugins2[0].constructor === Array)
    plugins2 = plugins2[0];
  plugins2.forEach(function(plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }
    if (plugin.utils)
      Sortable.utils = _objectSpread2$1(_objectSpread2$1({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
Sortable.create = function(el, options) {
  return new Sortable(el, options);
};
Sortable.version = version$1;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var fn2 in this) {
      if (fn2.charAt(0) === "_" && typeof this[fn2] === "function") {
        this[fn2] = this[fn2].bind(this);
      }
    }
  }
  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;
      if (this.sortable.nativeDraggable) {
        on$1(document, "dragover", this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on$1(document, "pointermove", this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on$1(document, "touchmove", this._handleFallbackAutoScroll);
        } else {
          on$1(document, "mousemove", this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop3() {
      if (this.sortable.nativeDraggable) {
        off$1(document, "dragover", this._handleAutoScroll);
      } else {
        off$1(document, "pointermove", this._handleFallbackAutoScroll);
        off$1(document, "touchmove", this._handleFallbackAutoScroll);
        off$1(document, "mousemove", this._handleFallbackAutoScroll);
      }
      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback2) {
      var _this = this;
      var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt;
      if (fallback2 || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback2);
        var ogElemScroller = getParentAutoScrollElement(elem, true);
        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval();
          pointerElemChangedInterval = setInterval(function() {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }
            autoScroll(evt, _this.options, newElem, fallback2);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends$m(AutoScroll, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function(autoScroll2) {
    clearInterval(autoScroll2.pid);
  });
  autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle$1(function(evt, options, rootEl2, isFallback) {
  if (!options.scroll)
    return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
  var scrollThisInstance = false, scrollCustomFn;
  if (scrollRootEl !== rootEl2) {
    scrollRootEl = rootEl2;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;
    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl2, true);
    }
  }
  var layersOut = 0;
  var currentParent = scrollEl;
  do {
    var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
    }
    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }
    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);
      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        autoScrolls[layersOut].pid = setInterval(function() {
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1);
          }
          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
          if (typeof scrollCustomFn === "function") {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") {
              return;
            }
          }
          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }
    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
  scrolling = scrollThisInstance;
}, 30);
var drop = function drop2(_ref) {
  var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent)
    return;
  var toSortable = putSortable2 || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent("spill");
    this.onSpill({
      dragEl: dragEl2,
      putSortable: putSortable2
    });
  }
};
function Revert() {
}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex2 = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex2;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable2) {
      putSortable2.captureAnimationState();
    }
    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl2, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl2);
    }
    this.sortable.animateAll();
    if (putSortable2) {
      putSortable2.animateAll();
    }
  },
  drop
};
_extends$m(Revert, {
  pluginName: "revertOnSpill"
});
function Remove() {
}
Remove.prototype = {
  onSpill: function onSpill2(_ref4) {
    var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
    var parentSortable = putSortable2 || this.sortable;
    parentSortable.captureAnimationState();
    dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
    parentSortable.animateAll();
  },
  drop
};
_extends$m(Remove, {
  pluginName: "removeOnSpill"
});
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }
  return global.console;
}
const console$1 = getConsole();
function cached(fn2) {
  const cache = Object.create(null);
  return function cachedFn(str) {
    const hit = cache[str];
    return hit || (cache[str] = fn2(str));
  };
}
const regex = /-(\w)/g;
const camelize = cached((str) => str.replace(regex, (_, c) => c ? c.toUpperCase() : ""));
function removeNode(node2) {
  if (node2.parentElement !== null) {
    node2.parentElement.removeChild(node2);
  }
}
function insertNodeAt(fatherNode, node2, position) {
  const refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node2, refNode);
}
function buildAttribute(object, propName, value9) {
  if (value9 === void 0) {
    return object;
  }
  object = object || {};
  object[propName] = value9;
  return object;
}
function computeVmIndex(vnodes, element) {
  return vnodes.map((elt) => elt.elm).indexOf(element);
}
function computeIndexes(slots2, children3, isTransition2, footerOffset) {
  if (!slots2) {
    return [];
  }
  const elmFromNodes = slots2.map((elt) => elt.elm);
  const footerIndex = children3.length - footerOffset;
  const rawIndexes = [...children3].map((elt, idx) => idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt));
  return isTransition2 ? rawIndexes.filter((ind) => ind !== -1) : rawIndexes;
}
function emit$1(evtName, evtData) {
  this.$nextTick(() => this.$emit(evtName.toLowerCase(), evtData));
}
function delegateAndEmit(evtName) {
  return (evtData) => {
    if (this.realList !== null) {
      this["onDrag" + evtName](evtData);
    }
    emit$1.call(this, evtName, evtData);
  };
}
function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}
function isTransition(slots2) {
  if (!slots2 || slots2.length !== 1) {
    return false;
  }
  const [{
    componentOptions
  }] = slots2;
  if (!componentOptions) {
    return false;
  }
  return isTransitionName(componentOptions.tag);
}
function getSlot(slot, scopedSlot, key2) {
  return slot[key2] || (scopedSlot[key2] ? scopedSlot[key2]() : void 0);
}
function computeChildrenAndOffsets(children3, slot, scopedSlot) {
  let headerOffset = 0;
  let footerOffset = 0;
  const header = getSlot(slot, scopedSlot, "header");
  if (header) {
    headerOffset = header.length;
    children3 = children3 ? [...header, ...children3] : [...header];
  }
  const footer = getSlot(slot, scopedSlot, "footer");
  if (footer) {
    footerOffset = footer.length;
    children3 = children3 ? [...children3, ...footer] : [...footer];
  }
  return {
    children: children3,
    headerOffset,
    footerOffset
  };
}
function getComponentAttributes($attrs, componentData) {
  let attributes = null;
  const update2 = (name, value9) => {
    attributes = buildAttribute(attributes, name, value9);
  };
  const attrs = Object.keys($attrs).filter((key2) => key2 === "id" || key2.startsWith("data-")).reduce((res, key2) => {
    res[key2] = $attrs[key2];
    return res;
  }, {});
  update2("attrs", attrs);
  if (!componentData) {
    return attributes;
  }
  const {
    on: on2,
    props: props2,
    attrs: componentDataAttrs
  } = componentData;
  update2("on", on2);
  update2("props", props2);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}
const eventsListened = ["Start", "Add", "Remove", "Update", "End"];
const eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
const readonlyProperties = ["Move", ...eventsListened, ...eventsToEmit].map((evt) => "on" + evt);
var draggingElement = null;
const props$7 = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: (original) => {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
const draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props$7,
  data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render(h) {
    const slots2 = this.$slots.default;
    this.transitionMode = isTransition(slots2);
    const {
      children: children3,
      headerOffset,
      footerOffset
    } = computeChildrenAndOffsets(slots2, this.$slots, this.$scopedSlots);
    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    const attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children3);
  },
  created() {
    if (this.list !== null && this.value !== null) {
      console$1.error("Value and list props are mutually exclusive! Please set one or another.");
    }
    if (this.element !== "div") {
      console$1.warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }
    if (this.options !== void 0) {
      console$1.warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted() {
    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();
    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error(`Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ${this.getTag()}`);
    }
    const optionsAdded = {};
    eventsListened.forEach((elt) => {
      optionsAdded["on" + elt] = delegateAndEmit.call(this, elt);
    });
    eventsToEmit.forEach((elt) => {
      optionsAdded["on" + elt] = emit$1.bind(this, elt);
    });
    const attributes = Object.keys(this.$attrs).reduce((res, key2) => {
      res[camelize(key2)] = this.$attrs[key2];
      return res;
    }, {});
    const options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: (evt, originalEvent) => {
        return this.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new Sortable(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy() {
    if (this._sortable !== void 0)
      this._sortable.destroy();
  },
  computed: {
    rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional() {
      const {
        fnOptions
      } = this._vnode;
      return fnOptions && fnOptions.functional;
    },
    getTag() {
      return this.tag || this.element;
    },
    updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        const value9 = camelize(property);
        if (readonlyProperties.indexOf(value9) === -1) {
          this._sortable.option(value9, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }
      const rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes() {
      this.$nextTick(() => {
        this.visibleIndexes = computeIndexes(this.getChildrenNodes(), this.rootContainer.children, this.transitionMode, this.footerOffset);
      });
    },
    getUnderlyingVm(htmlElt) {
      const index2 = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
      if (index2 === -1) {
        return null;
      }
      const element = this.realList[index2];
      return {
        index: index2,
        element
      };
    },
    getUnderlyingPotencialDraggableComponent({
      __vue__: vue
    }) {
      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0])
          return vue.$children[0];
        return vue;
      }
      return vue.$parent;
    },
    emitChanges(evt) {
      this.$nextTick(() => {
        this.$emit("change", evt);
      });
    },
    alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }
      const newList = [...this.value];
      onList(newList);
      this.$emit("input", newList);
    },
    spliceList() {
      const spliceList = (list) => list.splice(...arguments);
      this.alterList(spliceList);
    },
    updatePosition(oldIndex2, newIndex2) {
      const updatePosition = (list) => list.splice(newIndex2, 0, list.splice(oldIndex2, 1)[0]);
      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent({
      to,
      related
    }) {
      const component = this.getUnderlyingPotencialDraggableComponent(to);
      if (!component) {
        return {
          component
        };
      }
      const list = component.realList;
      const context2 = {
        list,
        component
      };
      if (to !== related && list && component.getUnderlyingVm) {
        const destination = component.getUnderlyingVm(related);
        if (destination) {
          return Object.assign(destination, context2);
        }
      }
      return context2;
    },
    getVmIndex(domIndex) {
      const indexes = this.visibleIndexes;
      const numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData(index2) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }
      var nodes = this.getChildrenNodes();
      nodes[index2].data = null;
      const transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = void 0;
    },
    onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd(evt) {
      const element = evt.item._underlying_vm_;
      if (element === void 0) {
        return;
      }
      removeNode(evt.item);
      const newIndex2 = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex2, 0, element);
      this.computeIndexes();
      const added = {
        element,
        newIndex: newIndex2
      };
      this.emitChanges({
        added
      });
    },
    onDragRemove(evt) {
      insertNodeAt(this.rootContainer, evt.item, evt.oldIndex);
      if (evt.pullMode === "clone") {
        removeNode(evt.clone);
        return;
      }
      const oldIndex2 = this.context.index;
      this.spliceList(oldIndex2, 1);
      const removed = {
        element: this.context.element,
        oldIndex: oldIndex2
      };
      this.resetTransitionData(oldIndex2);
      this.emitChanges({
        removed
      });
    },
    onDragUpdate(evt) {
      removeNode(evt.item);
      insertNodeAt(evt.from, evt.item, evt.oldIndex);
      const oldIndex2 = this.context.index;
      const newIndex2 = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex2, newIndex2);
      const moved2 = {
        element: this.context.element,
        oldIndex: oldIndex2,
        newIndex: newIndex2
      };
      this.emitChanges({
        moved: moved2
      });
    },
    updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }
      const domChildren = [...evt.to.children].filter((el) => el.style["display"] !== "none");
      const currentDOMIndex = domChildren.indexOf(evt.related);
      const currentIndex2 = relatedContext.component.getVmIndex(currentDOMIndex);
      const draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex2 : currentIndex2 + 1;
    },
    onDragMove(evt, originalEvent) {
      const onMove = this.move;
      if (!onMove || !this.realList) {
        return true;
      }
      const relatedContext = this.getRelatedContextFromMoveEvent(evt);
      const draggedContext = this.context;
      const futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex
      });
      const sendEvt = Object.assign({}, evt, {
        relatedContext,
        draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};
if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}
var render$X = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("el-dropdown", {
    attrs: {
      "trigger": "click"
    }
  }, [_vm._t("button", function() {
    return [_c("el-button", {
      attrs: {
        "size": "mini",
        "icon": "el-icon-s-tools config-icon"
      }
    })];
  }), _c("el-dropdown-menu", {
    staticClass: "drop-container",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c("el-checkbox-group", {
    staticClass: "column-display-checkbox",
    model: {
      value: _vm.displayColumns,
      callback: function($$v) {
        _vm.displayColumns = $$v;
      },
      expression: "displayColumns"
    }
  }, [_vm.opTableVNode ? [_c("draggable", {
    staticClass: "grid-area",
    attrs: {
      "ghost-class": "ghost",
      "draggable": ".movable",
      "group": "column"
    },
    model: {
      value: _vm.opTableVNode.columnList,
      callback: function($$v) {
        _vm.$set(_vm.opTableVNode, "columnList", $$v);
      },
      expression: "opTableVNode.columnList"
    }
  }, _vm._l(_vm.opTableVNode.columnList, function(item, index2) {
    return _c("el-checkbox", {
      key: item.prop + "-" + index2,
      class: !item.fixed ? "movable" : "no-drag",
      staticStyle: {
        "overflow": "hidden"
      },
      attrs: {
        "label": item.prop
      }
    }, [_c("span", [_vm._v(_vm._s(item.label))])]);
  }), 1)] : _vm._e()], 2), _c("div", {
    staticClass: "btn-area"
  }, [_c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("\u786E\u5B9A")])], 1)], 1)], 2);
};
var staticRenderFns$W = [];
render$X._withStripped = true;
var HeaderConfig_vue_vue_type_style_index_0_lang = "";
const __vue2_script$Y = {
  name: "OpTableHeaderConfig",
  components: {
    Draggable: draggableComponent
  },
  props: {
    routeNameId: Boolean,
    tableId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      displayColumns: [],
      opTableVNode: null,
      opTableVNodes: []
    };
  },
  computed: {
    _tableId({
      tableId,
      routeNameId
    }) {
      if (routeNameId && this.$route.name) {
        return this.$route.name + "_" + tableId;
      } else {
        return tableId;
      }
    }
  },
  watch: {
    _tableId() {
      this.getVNode();
      this.setDisplayColumns();
      this.$emit("ready", this.displayColumns, this._tableId);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getOpTableVNodes();
      this.getVNode();
      this.setDisplayColumns();
      this.$emit("ready", this.displayColumns, this._tableId);
    });
  },
  methods: {
    handleClick() {
      if (this.displayColumns.length == 0) {
        this.$message.error(`\u6700\u5C11\u4FDD\u7559\u4E00\u9879\uFF01`);
        return false;
      }
      this.opTableVNode.submitColumnDisplay(this.displayColumns);
      this.$emit("submit", this.displayColumns, this._tableId);
    },
    getOpTableVNodes() {
      const VNodes = [];
      getOpTableInParent(this);
      if (this.opTableVNode === null) {
        getOpTableInPage(this);
      }
      this.opTableVNodes = VNodes;
      function getOpTableInPage(vm) {
        if (!vm) {
          return null;
        }
        if (vm.identifier === "OpTable") {
          VNodes.push(vm);
        } else {
          if (vm.$children.length > 0) {
            for (let child of vm.$children) {
              if (child.identifier === "OpTable") {
                VNodes.push(child);
              }
            }
            if (VNodes.length === 0) {
              getOpTableInPage(vm.$parent);
            }
          }
        }
      }
      function getOpTableInParent(vm) {
        if (!vm) {
          return null;
        }
        if (vm.identifier === "OpTable") {
          VNodes.push(vm);
        } else {
          getOpTableInParent(vm.$parent);
        }
      }
    },
    getVNode() {
      if (this.opTableVNodes.length > 2) {
        if (!this.tableId) {
          /* @__PURE__ */ console.error("tableId is required!");
          return;
        }
        for (let vNode of this.opTableVNodes) {
          if (vNode._tableId.indexOf(this.tableId) > -1) {
            this.opTableVNode = vNode;
            break;
          }
        }
      } else if (this.opTableVNodes.length === 1) {
        this.opTableVNode = this.opTableVNodes[0];
      }
    },
    setDisplayColumns() {
      if (this.opTableVNode && this.opTableVNode.displayedColumnList) {
        this.displayColumns = [...this.opTableVNode.displayedColumnList];
      }
    }
  }
};
const __cssModules$Y = {};
var __component__$Y = /* @__PURE__ */ normalizeComponent(__vue2_script$Y, render$X, staticRenderFns$W, false, __vue2_injectStyles$Y, null, null, null);
function __vue2_injectStyles$Y(context2) {
  for (let o in __cssModules$Y) {
    this[o] = __cssModules$Y[o];
  }
}
__component__$Y.options.__file = "packages/op-table/src/HeaderConfig.vue";
var OpTableHeaderConfig = /* @__PURE__ */ function() {
  return __component__$Y.exports;
}();
var __vue2_script$X = {
  name: "OpColumn",
  components: {
    HeaderConfig: OpTableHeaderConfig
  },
  props: {
    template: {
      type: [Function, null],
      default: null
    },
    tooltipTemplate: {
      type: [Function, null],
      default: null
    },
    headerTooltip: {
      type: String,
      default: ""
    },
    toolTipPlacement: {
      type: [Function, null],
      default: null
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    formatDate: {
      type: String,
      default: ""
    },
    initDisplayedColumn: Boolean,
    initDisplayedColumnIndex: {
      type: Number,
      default: null
    },
    hidden: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: "center"
    }
  },
  data() {
    return {
      index: -1,
      modifyVal: ""
    };
  },
  computed: {
    expandRender({
      template
    }) {
      return template || "";
    }
  },
  render(h) {
    const controlType = ["index", "selection"];
    const tableObj = {
      props: __spreadValues({}, Object.assign({}, {
        align: this.align
      }, this.$attrs)),
      on: __spreadValues({}, this.$listeners)
    };
    if (!this.showTooltip && !this.$scopedSlots.default) {
      tableObj.props.showOverflowTooltip = true;
    }
    if (!controlType.includes(this.$attrs.type)) {
      tableObj.scopedSlots = {
        default: (columnProps) => {
          const currentKey = this.$attrs.prop;
          const originText = get$1(columnProps.row, currentKey || "")[0] || "";
          let text = "";
          const isStringText = typeof originText === "string";
          const handleClick = (val) => {
            return () => {
              if (val.$index === columnProps.$index && this.edit) {
                this.modifyVal = originText;
                this.index = val.$index;
              }
              this.$emit("columnClick", {
                scope: val,
                key: currentKey
              });
            };
          };
          const handleChangeText = () => {
            if (this.modifyVal !== originText) {
              this.$emit("textChange", {
                scope: columnProps,
                key: currentKey,
                val: this.modifyVal
              });
            }
            this.index = -1;
            this.modifyVal = "";
          };
          if (this.$attrs.type === "date") {
            text = dataFilter(originText, this.formatDate || "YYYY-MM-DD HH:mm:ss");
          } else {
            text = originText;
          }
          if (this.edit && isStringText) {
            if (columnProps.$index === this.index) {
              return h("el-input", {
                "attrs": {
                  "autofocus": true
                },
                "on": {
                  "blur": () => {
                    this.index = -1;
                    this.modifyVal = "";
                  }
                },
                "nativeOn": {
                  "keyup": (e) => {
                    if (e.keyCode === 13) {
                      handleChangeText();
                    }
                  }
                },
                "model": {
                  value: this.modifyVal,
                  callback: ($$v) => {
                    this.modifyVal = $$v;
                  }
                }
              });
            }
          }
          if (this.showTooltip) {
            let _width = this.$children[0].columnConfig.realWidth || this.$children[0].columnConfig.width;
            const $text = h("span", {
              class: "inline-span",
              style: {
                width: `${_width - 21}px`,
                verticalAlign: "middle"
              },
              on: this.edit ? {
                click: handleClick(columnProps)
              } : {}
            }, this.expandRender ? [this.expandRender(h, columnProps)] : text);
            const toolTipOptions = {
              props: {
                effect: "dark",
                placement: this.toolTipPlacement ? this.toolTipPlacement(columnProps) : "top",
                popperOptions: {
                  boundariesElement: "body"
                }
              }
            };
            const toolTipChildren = [];
            if (this.tooltipTemplate) {
              const $tooltipContent = h("div", {
                slot: "content"
              }, [this.tooltipTemplate(h, columnProps)]);
              toolTipChildren.push($tooltipContent);
            } else if (this.expandRender) {
              const $tooltipContent = h("div", {
                slot: "content"
              }, [this.expandRender(h, columnProps)]);
              toolTipChildren.push($tooltipContent);
            } else {
              toolTipOptions.props.content = text + "";
            }
            toolTipChildren.push($text);
            const $tooltip = h("el-tooltip", toolTipOptions, toolTipChildren);
            return $tooltip;
          } else if (this.$scopedSlots.default) {
            return h("div", [this.$scopedSlots.default(__spreadValues({}, columnProps))]);
          } else {
            const $text = this.expandRender ? h("div", {
              on: this.edit ? {
                click: handleClick(columnProps)
              } : {}
            }, [this.expandRender(h, columnProps)]) : h("span", {
              on: this.edit ? {
                click: handleClick(columnProps)
              } : {}
            }, text);
            return $text;
          }
        },
        header: (columnProps) => {
          const label = columnProps.column.label;
          if (this.initDisplayedColumn || this.initDisplayedColumnIndex != null && this.initDisplayedColumnIndex === columnProps.$index) {
            const dropdownVnode = h("header-config", {
              "style": "position:absolute;right:0;top:0"
            }, [h("i", {
              "slot": "button",
              "class": "el-icon-s-tools config-icon"
            })]);
            return h("div", {
              style: {
                position: "relative",
                width: "100%"
              }
            }, [label, dropdownVnode]);
          } else if (this.headerTooltip) {
            const tooltipVnode = h("span", [label, h("el-tooltip", {
              "style": "cursor:pointer",
              "attrs": {
                "effect": "dark",
                "content": this.headerTooltip,
                "placement": "top"
              }
            }, [h("svg", {
              "attrs": {
                "t": "1690254873478",
                "viewBox": "0 0 1024 1024",
                "version": "1.1",
                "xmlns": "http://www.w3.org/2000/svg",
                "p-id": "719",
                "width": "12",
                "height": "12"
              },
              "style": "margin-left: 2px;"
            }, [h("path", {
              "attrs": {
                "d": "M511.3 959.4C264 959.4 63.2 759 63.2 511.4S263.7 63.3 511.3 63.3s448.1 200.5 448.1 448.1-200.8 448-448.1 448z m0-836C296.9 123.4 123 297.2 123 511.7S296.8 900 511.3 900s388.3-173.8 388.3-388.3-173.9-388.3-388.3-388.3z",
                "fill": "#060001",
                "p-id": "720"
              }
            }), h("path", {
              "attrs": {
                "d": "M588.7 529.2c-40.3 23.5-53.3 61.6-51.6 98.6 0 12.6-10.2 22.8-22.8 22.8h-11.8c-12.9 0-23.2-10.6-22.8-23.5 0.5-15.8 2.1-36.6 6.7-52.7 7.4-24.5 22.7-57.6 51.6-78.1 50.7-33.6 79.6-68.1 76.2-103.7-5-50.7-40-77.5-93.7-80.9-50.5-1.4-86.1 21-106.7 67.2-8.5 19.1-31 27.5-49.9 18.5-13.1-6.3-19.2-21.6-14-35.2l0.8-2.1c27.9-71.8 87.9-106.7 179.9-103.7 91 5 142 56.7 145.8 130.2 5 52.3-21.9 100.7-87.7 142.6z m-86.4 239c-17.9 0-32.5-15.7-32.5-33.7v1c0-17.9 14.5-32.5 32.5-32.5 17.9 0 32.5 14.5 32.5 32.5v-1c-0.1 17.9-14.6 33.7-32.5 33.7z",
                "fill": "#060001",
                "p-id": "721"
              }
            })])])]);
            return tooltipVnode;
          } else if (this.$scopedSlots.header) {
            return h("div", [this.$scopedSlots.header(__spreadValues({}, columnProps))]);
          } else {
            return label;
          }
        }
      };
    }
    if (!this.hidden) {
      return h("el-table-column", tableObj);
    } else {
      return h("");
    }
  }
};
var Column_vue_vue_type_style_index_0_lang = "";
let __vue2_render$1, __vue2_staticRenderFns$1;
const __cssModules$X = {};
var __component__$X = /* @__PURE__ */ normalizeComponent(__vue2_script$X, __vue2_render$1, __vue2_staticRenderFns$1, false, __vue2_injectStyles$X, null, null, null);
function __vue2_injectStyles$X(context2) {
  for (let o in __cssModules$X) {
    this[o] = __cssModules$X[o];
  }
}
__component__$X.options.__file = "packages/op-table/src/Column.vue";
var OpColumn = /* @__PURE__ */ function() {
  return __component__$X.exports;
}();
OpColumn.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpColumn.name, prefix);
  Vue2.component(comName, OpColumn);
};
var __glob_6_6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpColumn
});
const ajax$1 = (config) => new AjaxConfig(config);
const getListByTreeByParentId = (params) => {
  return request(ajax$1().get("/bsplatform/catalog/listByTreeByParentId"), params);
};
const catalogDetail$1 = ({
  id
}) => {
  return request(ajax$1().get(`/bsplatform/catalog/${id}/detail`));
};
const getTreeMap = (treeArray, parentId) => {
  return treeArray.reduce((prev4, {
    label,
    value: value9,
    children: children3
  }) => {
    return __spreadValues(__spreadProps(__spreadValues({}, prev4), {
      [value9]: {
        label,
        value: value9,
        parentId
      }
    }), children3 && children3.length > 0 ? getTreeMap(children3, value9) : {});
  }, {});
};
const findNodeParentList = (treeArray, id) => {
  const treeMap = getTreeMap(treeArray);
  const result = [id];
  let node2 = treeMap[id];
  while (treeMap[node2.parentId]) {
    const parentNode = treeMap[node2.parentId];
    result.unshift(parentNode.value);
    node2 = parentNode;
  }
  return result;
};
var render$W = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "op-directory-tree"
  }, [_vm.searchBar ? _c("div", {
    staticClass: "op-directory-tree-search"
  }, [_c("el-input", {
    attrs: {
      "type": "search",
      "placeholder": "\u8BF7\u8F93\u5165\u76EE\u5F55\u540D\u79F0",
      "size": "mini"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.onSearch.apply(null, arguments);
      }
    },
    model: {
      value: _vm.keyword,
      callback: function($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }, [_c("el-button", {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.onSearch
    },
    slot: "append"
  })], 1)], 1) : _vm._e(), _c("el-tree", _vm._g(_vm._b({
    ref: "tree",
    staticClass: "op-directory-tree-content",
    attrs: {
      "data": _vm.treeData,
      "show-checkbox": "",
      "check-strictly": "",
      "node-key": "value",
      "default-expanded-keys": _vm.defaultExpandedKeys,
      "props": _vm.defaultProps
    },
    on: {
      "check-change": _vm.onCheckChange
    }
  }, "el-tree", _vm.$attrs, false), _vm.eleTreeEvents)), _vm.$slots.operate || _vm.$scopedSlots.operate ? _c("div", {
    staticClass: "op-directory-tree-operate"
  }, [_vm._t("operate", null, {
    "checkedNodes": _vm.checkedNodes,
    "refresh": _vm.refresh
  })], 2) : _vm._e()], 1);
};
var staticRenderFns$V = [];
render$W._withStripped = true;
var index_vue_vue_type_style_index_0_lang$b = "";
const __vue2_script$W = {
  name: "OpDirectoryTree",
  props: {
    rootId: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    searchBar: {
      type: Boolean,
      default: false
    },
    eleTreeEvents: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      treeData: [],
      loading: false,
      defaultProps: {
        children: "children",
        label: "label"
      },
      checkedNodes: [],
      keyword: "",
      treeInstance: null,
      rootNode: null
    };
  },
  computed: {
    defaultExpandedKeys() {
      if (this.$attrs.defaultExpandedKeys)
        return this.$attrs.defaultExpandedKeys;
      if (this.rootId)
        return [this.rootId];
      return [];
    }
  },
  watch: {
    checkedNodes(nextValue) {
      this.$emit("checkChange", nextValue);
    }
  },
  async mounted() {
    this.treeInstance = this.$refs.tree;
    await this.getRootNode();
    this.refresh();
  },
  methods: {
    async refresh(keyword) {
      const params = {
        parentId: this.rootId,
        name: this.keyword || keyword
      };
      this.loading = true;
      const res = await getListByTreeByParentId(params);
      this.loading = false;
      if (res.status) {
        this.$refs.tree.setCheckedKeys([]);
        this.checkedNodes = [];
        this.treeData = this.rootNode ? [__spreadProps(__spreadValues({}, this.rootNode), {
          children: res.data
        })] : res.data;
        this.$emit("treeChange", this.treeData);
      }
    },
    async getRootNode() {
      if (!this.rootId)
        return;
      this.loading = true;
      const res = await catalogDetail$1({
        id: this.rootId
      });
      this.loading = false;
      if (res.status && res.data) {
        const {
          name,
          id
        } = res.data;
        this.rootNode = {
          label: name,
          value: id
        };
      }
    },
    onCheckChange(item, checked2) {
      if (!this.multiple && checked2) {
        this.$refs.tree.setCheckedKeys([item.value]);
      }
      const nextCheckedNodes = this.$refs.tree.getCheckedNodes();
      if (nextCheckedNodes.map(({
        value: value9
      }) => value9).join() !== this.checkedNodes.map(({
        value: value9
      }) => value9).join()) {
        this.checkedNodes = nextCheckedNodes;
      }
    },
    getCheckedNodes() {
      return this.checkedNodes;
    },
    setCheckedKeys(checkedKeys) {
      this.$refs.tree.setCheckedKeys(checkedKeys);
    },
    onSearch() {
      this.refresh();
    },
    findNodeParentList(dataKey) {
      if (!this.$refs.tree.getNode(dataKey))
        return [];
      return findNodeParentList(this.treeData, dataKey);
    }
  }
};
const __cssModules$W = {};
var __component__$W = /* @__PURE__ */ normalizeComponent(__vue2_script$W, render$W, staticRenderFns$V, false, __vue2_injectStyles$W, null, null, null);
function __vue2_injectStyles$W(context2) {
  for (let o in __cssModules$W) {
    this[o] = __cssModules$W[o];
  }
}
__component__$W.options.__file = "packages/op-directory-tree/src/index.vue";
var DirectoryTree = /* @__PURE__ */ function() {
  return __component__$W.exports;
}();
DirectoryTree.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(DirectoryTree.name, prefix);
  Vue2.component(comName, DirectoryTree);
};
var __glob_6_7 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": DirectoryTree
});
const isServer$1 = Vue$1.prototype.$isServer;
const trim2 = function(string) {
  return (string || "").replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, "");
};
const on = function() {
  if (!isServer$1 && document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent("on" + event, handler);
      }
    };
  }
}();
const off = function() {
  if (!isServer$1 && document.removeEventListener) {
    return function(element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event) {
        element.detachEvent("on" + event, handler);
      }
    };
  }
}();
function hasClass$1(el, cls) {
  if (!el || !cls)
    return false;
  if (cls.indexOf(" ") !== -1)
    throw new Error("className should not contain space.");
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (" " + el.className + " ").indexOf(" " + cls + " ") > -1;
  }
}
function addClass$1(el, cls) {
  if (!el)
    return;
  var curClass = el.className;
  var classes = (cls || "").split(" ");
  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName)
      continue;
    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass$1(el, clsName)) {
      curClass += " " + clsName;
    }
  }
  if (!el.classList) {
    el.setAttribute("class", curClass);
  }
}
function removeClass$1(el, cls) {
  if (!el || !cls)
    return;
  var classes = cls.split(" ");
  var curClass = " " + el.className + " ";
  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName)
      continue;
    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass$1(el, clsName)) {
      curClass = curClass.replace(" " + clsName + " ", " ");
    }
  }
  if (!el.classList) {
    el.setAttribute("class", trim2(curClass));
  }
}
if (typeof /./ !== "function" && typeof Int8Array !== "object" && (Vue$1.prototype.$isServer || typeof document.childNodes !== "function"))
  ;
const isFirefox = function() {
  return !Vue$1.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};
function rafThrottle$1(fn2) {
  let locked = false;
  return function(...args) {
    if (locked)
      return;
    locked = true;
    window.requestAnimationFrame((_) => {
      fn2.apply(this, args);
      locked = false;
    });
  };
}
let hasModal = false;
let hasInitZIndex = false;
let zIndex;
const getModal2 = function() {
  if (Vue$1.prototype.$isServer)
    return;
  let modalDom = PopupManager.modalDom;
  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement("div");
    PopupManager.modalDom = modalDom;
    modalDom.addEventListener("touchmove", function(event) {
      event.preventDefault();
      event.stopPropagation();
    });
    modalDom.addEventListener("click", function() {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
    });
  }
  return modalDom;
};
const instances = {};
const PopupManager = {
  modalFade: true,
  getInstance: function(id) {
    return instances[id];
  },
  register: function(id, instance2) {
    if (id && instance2) {
      instances[id] = instance2;
    }
  },
  deregister: function(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },
  nextZIndex: function() {
    return PopupManager.zIndex++;
  },
  modalStack: [],
  doOnModalClick: function() {
    const topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topItem)
      return;
    const instance2 = PopupManager.getInstance(topItem.id);
    if (instance2 && instance2.closeOnClickModal) {
      instance2.close();
    }
  },
  openModal: function(id, zIndex2, dom2, modalClass, modalFade) {
    if (Vue$1.prototype.$isServer)
      return;
    if (!id || zIndex2 === void 0)
      return;
    this.modalFade = modalFade;
    const modalStack = this.modalStack;
    for (let i = 0, j = modalStack.length; i < j; i++) {
      const item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }
    const modalDom = getModal2();
    addClass$1(modalDom, "v-modal");
    if (this.modalFade && !hasModal) {
      addClass$1(modalDom, "v-modal-enter");
    }
    if (modalClass) {
      let classArr = modalClass.trim().split(/\s+/);
      classArr.forEach((item) => addClass$1(modalDom, item));
    }
    setTimeout(() => {
      removeClass$1(modalDom, "v-modal-enter");
    }, 200);
    if (dom2 && dom2.parentNode && dom2.parentNode.nodeType !== 11) {
      dom2.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }
    if (zIndex2) {
      modalDom.style.zIndex = zIndex2;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = "";
    this.modalStack.push({
      id,
      zIndex: zIndex2,
      modalClass
    });
  },
  closeModal: function(id) {
    const modalStack = this.modalStack;
    const modalDom = getModal2();
    if (modalStack.length > 0) {
      const topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          let classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach((item) => removeClass$1(modalDom, item));
        }
        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (let i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }
    if (modalStack.length === 0) {
      if (this.modalFade) {
        addClass$1(modalDom, "v-modal-leave");
      }
      setTimeout(() => {
        if (modalStack.length === 0) {
          if (modalDom.parentNode)
            modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = "none";
          PopupManager.modalDom = void 0;
        }
        removeClass$1(modalDom, "v-modal-leave");
      }, 200);
    }
  }
};
Object.defineProperty(PopupManager, "zIndex", {
  configurable: true,
  get() {
    if (!hasInitZIndex) {
      zIndex = zIndex || (Vue$1.prototype.$ELEMENT || {}).zIndex || 2e3;
      hasInitZIndex = true;
    }
    return zIndex;
  },
  set(value9) {
    zIndex = value9;
  }
});
const getTopPopup2 = function() {
  if (Vue$1.prototype.$isServer)
    return;
  if (PopupManager.modalStack.length > 0) {
    const topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup)
      return;
    const instance2 = PopupManager.getInstance(topPopup.id);
    return instance2;
  }
};
if (!Vue$1.prototype.$isServer) {
  window.addEventListener("keydown", function(event) {
    if (event.keyCode === 27) {
      const topPopup = getTopPopup2();
      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction("cancel") : topPopup.close();
      }
    }
  });
}
const version = "3.7.2";
const VERSION = version;
const _hasatob = typeof atob === "function";
const _hasbtoa = typeof btoa === "function";
const _hasBuffer = typeof Buffer === "function";
const _TD = typeof TextDecoder === "function" ? new TextDecoder() : void 0;
const _TE = typeof TextEncoder === "function" ? new TextEncoder() : void 0;
const b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const b64chs = Array.prototype.slice.call(b64ch);
const b64tab = ((a) => {
  let tab = {};
  a.forEach((c, i) => tab[c] = i);
  return tab;
})(b64chs);
const b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const _fromCC = String.fromCharCode.bind(String);
const _U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it, fn2 = (x) => x) => new Uint8Array(Array.prototype.slice.call(it, 0).map(fn2));
const _mkUriSafe = (src2) => src2.replace(/=/g, "").replace(/[+\/]/g, (m0) => m0 == "+" ? "-" : "_");
const _tidyB64 = (s) => s.replace(/[^A-Za-z0-9\+\/]/g, "");
const btoaPolyfill = (bin) => {
  let u32, c0, c1, c2, asc = "";
  const pad = bin.length % 3;
  for (let i = 0; i < bin.length; ) {
    if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255)
      throw new TypeError("invalid character found");
    u32 = c0 << 16 | c1 << 8 | c2;
    asc += b64chs[u32 >> 18 & 63] + b64chs[u32 >> 12 & 63] + b64chs[u32 >> 6 & 63] + b64chs[u32 & 63];
  }
  return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
const _btoa = _hasbtoa ? (bin) => btoa(bin) : _hasBuffer ? (bin) => Buffer.from(bin, "binary").toString("base64") : btoaPolyfill;
const _fromUint8Array = _hasBuffer ? (u8a) => Buffer.from(u8a).toString("base64") : (u8a) => {
  const maxargs = 4096;
  let strs = [];
  for (let i = 0, l = u8a.length; i < l; i += maxargs) {
    strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
  }
  return _btoa(strs.join(""));
};
const fromUint8Array = (u8a, urlsafe = false) => urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a);
const cb_utob = (c) => {
  if (c.length < 2) {
    var cc = c.charCodeAt(0);
    return cc < 128 ? c : cc < 2048 ? _fromCC(192 | cc >>> 6) + _fromCC(128 | cc & 63) : _fromCC(224 | cc >>> 12 & 15) + _fromCC(128 | cc >>> 6 & 63) + _fromCC(128 | cc & 63);
  } else {
    var cc = 65536 + (c.charCodeAt(0) - 55296) * 1024 + (c.charCodeAt(1) - 56320);
    return _fromCC(240 | cc >>> 18 & 7) + _fromCC(128 | cc >>> 12 & 63) + _fromCC(128 | cc >>> 6 & 63) + _fromCC(128 | cc & 63);
  }
};
const re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
const utob = (u) => u.replace(re_utob, cb_utob);
const _encode = _hasBuffer ? (s) => Buffer.from(s, "utf8").toString("base64") : _TE ? (s) => _fromUint8Array(_TE.encode(s)) : (s) => _btoa(utob(s));
const encode = (src2, urlsafe = false) => urlsafe ? _mkUriSafe(_encode(src2)) : _encode(src2);
const encodeURI = (src2) => encode(src2, true);
const re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const cb_btou = (cccc) => {
  switch (cccc.length) {
    case 4:
      var cp = (7 & cccc.charCodeAt(0)) << 18 | (63 & cccc.charCodeAt(1)) << 12 | (63 & cccc.charCodeAt(2)) << 6 | 63 & cccc.charCodeAt(3), offset = cp - 65536;
      return _fromCC((offset >>> 10) + 55296) + _fromCC((offset & 1023) + 56320);
    case 3:
      return _fromCC((15 & cccc.charCodeAt(0)) << 12 | (63 & cccc.charCodeAt(1)) << 6 | 63 & cccc.charCodeAt(2));
    default:
      return _fromCC((31 & cccc.charCodeAt(0)) << 6 | 63 & cccc.charCodeAt(1));
  }
};
const btou = (b) => b.replace(re_btou, cb_btou);
const atobPolyfill = (asc) => {
  asc = asc.replace(/\s+/g, "");
  if (!b64re.test(asc))
    throw new TypeError("malformed base64.");
  asc += "==".slice(2 - (asc.length & 3));
  let u24, bin = "", r1, r2;
  for (let i = 0; i < asc.length; ) {
    u24 = b64tab[asc.charAt(i++)] << 18 | b64tab[asc.charAt(i++)] << 12 | (r1 = b64tab[asc.charAt(i++)]) << 6 | (r2 = b64tab[asc.charAt(i++)]);
    bin += r1 === 64 ? _fromCC(u24 >> 16 & 255) : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
  }
  return bin;
};
const _atob = _hasatob ? (asc) => atob(_tidyB64(asc)) : _hasBuffer ? (asc) => Buffer.from(asc, "base64").toString("binary") : atobPolyfill;
const _toUint8Array = _hasBuffer ? (a) => _U8Afrom(Buffer.from(a, "base64")) : (a) => _U8Afrom(_atob(a), (c) => c.charCodeAt(0));
const toUint8Array = (a) => _toUint8Array(_unURI(a));
const _decode = _hasBuffer ? (a) => Buffer.from(a, "base64").toString("utf8") : _TD ? (a) => _TD.decode(_toUint8Array(a)) : (a) => btou(_atob(a));
const _unURI = (a) => _tidyB64(a.replace(/[-_]/g, (m0) => m0 == "-" ? "+" : "/"));
const decode = (src2) => _decode(_unURI(src2));
const isValid = (src2) => {
  if (typeof src2 !== "string")
    return false;
  const s = src2.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
const _noEnum = (v) => {
  return {
    value: v,
    enumerable: false,
    writable: true,
    configurable: true
  };
};
const extendString = function() {
  const _add = (name, body) => Object.defineProperty(String.prototype, name, _noEnum(body));
  _add("fromBase64", function() {
    return decode(this);
  });
  _add("toBase64", function(urlsafe) {
    return encode(this, urlsafe);
  });
  _add("toBase64URI", function() {
    return encode(this, true);
  });
  _add("toBase64URL", function() {
    return encode(this, true);
  });
  _add("toUint8Array", function() {
    return toUint8Array(this);
  });
};
const extendUint8Array = function() {
  const _add = (name, body) => Object.defineProperty(Uint8Array.prototype, name, _noEnum(body));
  _add("toBase64", function(urlsafe) {
    return fromUint8Array(this, urlsafe);
  });
  _add("toBase64URI", function() {
    return fromUint8Array(this, true);
  });
  _add("toBase64URL", function() {
    return fromUint8Array(this, true);
  });
};
const extendBuiltins = () => {
  extendString();
  extendUint8Array();
};
const gBase64 = {
  version,
  VERSION,
  atob: _atob,
  atobPolyfill,
  btoa: _btoa,
  btoaPolyfill,
  fromBase64: decode,
  toBase64: encode,
  encode,
  encodeURI,
  encodeURL: encodeURI,
  utob,
  btou,
  decode,
  isValid,
  fromUint8Array,
  toUint8Array,
  extendString,
  extendUint8Array,
  extendBuiltins
};
class FileUploadBase$1 {
  constructor() {
    this.ossPath = baseUrlInst.getBaseUrl().ossPath;
    this.cdnPath = baseUrlInst.getBaseUrl().cdnPath;
    this.props = null;
    this.opUpload = null;
  }
  setOssPath(ossPath) {
    this.ossPath = ossPath;
    return this;
  }
  setProps(props2) {
    this.props = props2;
    return this;
  }
  setOpUpload(opUpload) {
    this.opUpload = opUpload;
    return this;
  }
  handleSrc(file, config = {
    cdn: true,
    compress: false
  }) {
    const _config = Object.assign({
      cdn: true,
      compress: false
    }, config);
    let url2 = file[this.props.src] || (file == null ? void 0 : file.ossKey) || (file == null ? void 0 : file.path) || (file == null ? void 0 : file.url) || (file == null ? void 0 : file.src) || (file == null ? void 0 : file.name);
    if (!url2) {
      return "";
    }
    let formarUrl = "";
    if (_config && _config.cdn) {
      formarUrl = url2.substr(0, 4).toLowerCase() === "http" ? url2 : this.cdnPath + url2;
    } else {
      formarUrl = url2.substr(0, 4).toLowerCase() === "http" ? url2 : this.ossPath + url2;
    }
    if (_config && _config.compress) {
      if (formarUrl.indexOf("?") == -1) {
        formarUrl += "?x-oss-process=image/resize,m_lfit,h_100,w_100";
      }
    }
    return formatOssUrl(formarUrl);
  }
  async transferPrivateOss(formarUrl, name, callback2) {
    let url2 = formarUrl;
    let filePath;
    if (formarUrl.indexOf("-private-") != -1) {
      filePath = formarUrl.split("?")[0].split(".com/")[1];
      url2 = await this.opUpload.downloadPath(filePath, name, 1);
    }
    callback2(url2);
  }
  handleName(file) {
    return file[this.props.name] || file.filename || file.name || file.ossKey || file.path || "\u672A\u77E5\u540D\u79F0";
  }
  openPreview(file, open3 = true) {
    const previewUrl = `https://fileview.oppein.com/onlinePreview?url=${encodeURIComponent(gBase64.encode(this.handleSrc(file)))}`;
    if (open3) {
      window.open(previewUrl);
    } else {
      return previewUrl;
    }
  }
  judgSuffix(file) {
    const fileUrl = this.handleSrc(file);
    if (!fileUrl)
      return "";
    const _url = new URL(fileUrl);
    if (!URL)
      return "";
    if (!_url || !_url.pathname)
      return "";
    let fileExt = "";
    if (_url.pathname.split(".").length > 1) {
      fileExt = _url.pathname.split(".")[1] ? _url.pathname.split(".")[1].toLocaleUpperCase() : "";
    } else {
      fileExt = file.name.split(".")[1] ? file.name.split(".")[1].toLocaleUpperCase() : "";
    }
    let imgType = ["PNG", "JPG", "JPEG", "BMP", "GIF", "WEBP", "SVG", "TIFF"];
    let videpType = ["MP4", "MOV", "AVI", "TS", "RMVB"];
    let audioType = ["MP3", "WAV", "OGG"];
    let type = "";
    if (imgType.indexOf(fileExt) > -1) {
      type = "IMG";
    } else if (videpType.indexOf(fileExt) > -1) {
      type = "VIDEO";
    } else if (audioType.indexOf(fileExt) > -1) {
      type = "AUDIO";
    } else {
      type = fileExt;
    }
    return type;
  }
  getFileIcon(file) {
    const suffix = this.judgSuffix(file);
    const suffixIcons = {
      IMG: "icon-image",
      VIDEO: "icon-shipin",
      DOCX: "icon-word",
      DOC: "icon-word",
      WORD: "icon-word",
      PDF: "icon-pdf",
      EXCEL: "icon-Excel",
      PPT: "icon-ppt",
      XML: "icon-XML"
    };
    return suffixIcons[suffix] || "icon-file";
  }
}
var render$V = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", {
    attrs: {
      "name": "viewer-fade"
    }
  }, [_c("div", {
    ref: "el-image-viewer__wrapper",
    staticClass: "el-image-viewer__wrapper op-file-preview",
    style: {
      "z-index": _vm.viewerZIndex
    },
    attrs: {
      "tabindex": "-1"
    }
  }, [_c("div", {
    staticClass: "el-image-viewer__mask",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.handleMaskClick.apply(null, arguments);
      }
    }
  }), _c("span", {
    staticClass: "el-image-viewer__btn el-image-viewer__close",
    on: {
      "click": _vm.hide
    }
  }, [_c("i", {
    staticClass: "el-icon-close"
  })]), !_vm.isSingle ? [_c("span", {
    staticClass: "el-image-viewer__btn el-image-viewer__prev",
    class: {
      "is-disabled": !_vm.infinite && _vm.isFirst
    },
    on: {
      "click": _vm.prev
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-left"
  })]), _c("span", {
    staticClass: "el-image-viewer__btn el-image-viewer__next",
    class: {
      "is-disabled": !_vm.infinite && _vm.isLast
    },
    on: {
      "click": _vm.next
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-right"
  })])] : _vm._e(), _vm.judgSuffix === "IMG" ? _c("div", {
    staticClass: "el-image-viewer__btn el-image-viewer__actions"
  }, [_c("div", {
    staticClass: "el-image-viewer__actions__inner"
  }, [_c("i", {
    staticClass: "el-icon-zoom-out",
    on: {
      "click": function($event) {
        return _vm.handleActions("zoomOut");
      }
    }
  }), _c("i", {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.handleActions("zoomIn");
      }
    }
  }), _c("i", {
    staticClass: "el-image-viewer__actions__divider"
  }), _c("i", {
    class: _vm.mode.icon,
    on: {
      "click": _vm.toggleMode
    }
  }), _c("i", {
    staticClass: "el-image-viewer__actions__divider"
  }), _c("i", {
    staticClass: "el-icon-refresh-left",
    on: {
      "click": function($event) {
        return _vm.handleActions("anticlocelise");
      }
    }
  }), _c("i", {
    staticClass: "el-icon-refresh-right",
    on: {
      "click": function($event) {
        return _vm.handleActions("clocelise");
      }
    }
  })])]) : _vm._e(), _c("div", {
    staticClass: "el-image-viewer__canvas"
  }, _vm._l(_vm.urlList, function(url2, i) {
    return _c("div", {
      key: url2
    }, [i === _vm.index && _vm.judgSuffix === "IMG" ? _c("img", {
      ref: "img",
      refInFor: true,
      staticClass: "el-image-viewer__img",
      style: _vm.imgStyle,
      attrs: {
        "src": _vm.currentImg
      },
      on: {
        "load": _vm.handleImgLoad,
        "error": _vm.handleImgError,
        "mousedown": _vm.handleMouseDown
      }
    }) : i === _vm.index && _vm.judgSuffix === "VIDEO" ? _c("div", {
      ref: "img",
      refInFor: true,
      staticClass: "el-image-viewer__img preview-group-video",
      style: _vm.imgStyle
    }, [_c("video", {
      staticClass: "item-video",
      style: _vm.imgStyle,
      attrs: {
        "src": _vm.currentImg,
        "controls": "true"
      }
    }, [_vm._v("\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u89C6\u9891\u64AD\u653E")])]) : i === _vm.index && _vm.judgSuffix === "AUDIO" ? _c("audio", {
      attrs: {
        "controls": ""
      }
    }, [_c("source", {
      attrs: {
        "src": url2
      }
    })]) : i === _vm.index ? _c("div", {
      ref: "img",
      refInFor: true,
      staticClass: "preview-group-other el-image-viewer__img",
      style: _vm.imgStyle
    }, [_c("div", {
      staticClass: "other-box"
    }, [_c("i", {
      staticClass: "el-icon-info",
      staticStyle: {
        "font-size": "80px"
      }
    })]), _c("div", [_c("span", {
      staticClass: "preview-name"
    }, [_vm._v(_vm._s(_vm.currentFile.filename || _vm.currentFile.name))]), _vm._v(" \u9644\u4EF6\u4E0D\u652F\u6301\u76F4\u63A5\u9884\u89C8 "), _c("el-button", {
      attrs: {
        "type": "text",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.openPreview(url2);
        }
      }
    }, [_vm._v("\u70B9\u51FB\u53BB\u9884\u89C8")])], 1)]) : _vm._e()]);
  }), 0)], 2)]);
};
var staticRenderFns$U = [];
render$V._withStripped = true;
var index_vue_vue_type_style_index_0_lang$a = "";
const Mode = {
  CONTAIN: {
    name: "contain",
    icon: "el-icon-full-screen"
  },
  ORIGINAL: {
    name: "original",
    icon: "el-icon-c-scale-to-original"
  }
};
const mousewheelEventName = isFirefox() ? "DOMMouseScroll" : "mousewheel";
const __vue2_script$V = {
  name: "OpFilePcPreview",
  props: {
    urlList: {
      type: Array,
      default: () => []
    },
    fileList: {
      type: Array,
      default: () => []
    },
    zIndex: {
      type: Number,
      default: 3e3
    },
    onSwitch: {
      type: Function,
      default: () => {
      }
    },
    onClose: {
      type: Function,
      default: () => {
      }
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    fileUploadBase: {
      type: [Object, null],
      default: null
    },
    props: {
      type: Object,
      default: () => {
        return {
          name: "name",
          src: "ossKey"
        };
      }
    }
  },
  data() {
    return {
      index: this.initialIndex,
      fileUtils: null,
      isShow: false,
      infinite: true,
      loading: false,
      mode: Mode.CONTAIN,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      }
    };
  },
  computed: {
    isSingle() {
      return this.urlList.length <= 1;
    },
    isFirst() {
      return this.index === 0;
    },
    isLast() {
      return this.index === this.urlList.length - 1;
    },
    currentImg() {
      if (this.urlList[this.index]) {
        return formatOssUrl(this.urlList[this.index]);
      } else {
        return "";
      }
    },
    currentFile() {
      return this.fileList[this.index];
    },
    judgSuffix() {
      if (this.currentFile) {
        return this.fileUtils.judgSuffix({
          url: this.currentImg,
          name: this.currentFile.name
        });
      } else {
        return this.fileUtils.judgSuffix({
          url: this.currentImg
        });
      }
    },
    imgStyle() {
      const {
        scale: scale2,
        deg,
        offsetX,
        offsetY,
        enableTransition
      } = this.transform;
      const style6 = {
        transform: `scale(${scale2}) rotate(${deg}deg)`,
        transition: enableTransition ? "transform .3s" : "",
        "margin-left": `${offsetX}px`,
        "margin-top": `${offsetY}px`
      };
      const curSuffix = this.judgSuffix;
      if (this.mode === Mode.CONTAIN) {
        if (curSuffix === "VIDEO") {
          style6.maxHidth = "90vh";
        } else {
          style6.height = "90vh";
        }
      }
      return style6;
    },
    viewerZIndex() {
      const nextZIndex2 = PopupManager.nextZIndex();
      return this.zIndex > nextZIndex2 ? this.zIndex : nextZIndex2;
    }
  },
  watch: {
    index: {
      handler: function(val) {
        this.reset();
        this.onSwitch(val);
      }
    },
    currentImg() {
      this.$nextTick(() => {
        const $img = this.$refs.img[0];
        if (!$img.complete) {
          this.loading = true;
        }
      });
    }
  },
  created() {
    if (this.fileUploadBase) {
      this.fileUtils = this.fileUploadBase;
    } else {
      this.fileUtils = new FileUploadBase$1();
      this.fileUtils.setProps(this.props);
    }
  },
  mounted() {
    this.deviceSupportInstall();
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
    this.$refs["el-image-viewer__wrapper"].focus();
  },
  destroyed() {
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    hide() {
      this.deviceSupportUninstall();
      this.onClose();
    },
    deviceSupportInstall() {
      this._keyDownHandler = (e) => {
        e.stopPropagation();
        const keyCode = e.keyCode;
        switch (keyCode) {
          case 27:
            this.hide();
            break;
          case 32:
            this.toggleMode();
            break;
          case 37:
            this.prev();
            break;
          case 38:
            this.handleActions("zoomIn");
            break;
          case 39:
            this.next();
            break;
          case 40:
            this.handleActions("zoomOut");
            break;
        }
      };
      this._mouseWheelHandler = rafThrottle$1((e) => {
        const delta2 = e.wheelDelta ? e.wheelDelta : -e.detail;
        if (delta2 > 0) {
          this.handleActions("zoomIn", {
            zoomRate: 0.015,
            enableTransition: false
          });
        } else {
          this.handleActions("zoomOut", {
            zoomRate: 0.015,
            enableTransition: false
          });
        }
      });
      on(document, "keydown", this._keyDownHandler);
      on(document, mousewheelEventName, this._mouseWheelHandler);
    },
    deviceSupportUninstall() {
      off(document, "keydown", this._keyDownHandler);
      off(document, mousewheelEventName, this._mouseWheelHandler);
      this._keyDownHandler = null;
      this._mouseWheelHandler = null;
    },
    handleImgLoad() {
      this.loading = false;
    },
    handleImgError(e) {
      this.loading = false;
      e.target.alt = "\u52A0\u8F7D\u5931\u8D25";
    },
    handleMouseDown(e) {
      if (this.loading || e.button !== 0)
        return;
      const {
        offsetX,
        offsetY
      } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      this._dragHandler = rafThrottle$1((ev) => {
        this.transform.offsetX = offsetX + ev.pageX - startX;
        this.transform.offsetY = offsetY + ev.pageY - startY;
      });
      on(document, "mousemove", this._dragHandler);
      on(document, "mouseup", () => {
        off(document, "mousemove", this._dragHandler);
      });
      e.preventDefault();
    },
    handleMaskClick() {
      if (this.maskClosable) {
        this.hide();
      }
    },
    reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      };
    },
    toggleMode() {
      if (this.loading)
        return;
      const modeNames = Object.keys(Mode);
      const modeValues = Object.values(Mode);
      const index2 = modeValues.indexOf(this.mode);
      const nextIndex = (index2 + 1) % modeNames.length;
      this.mode = Mode[modeNames[nextIndex]];
      this.reset();
    },
    prev() {
      if (this.isFirst && !this.infinite)
        return;
      const len = this.urlList.length;
      this.index = (this.index - 1 + len) % len;
    },
    next() {
      if (this.isLast && !this.infinite)
        return;
      const len = this.urlList.length;
      this.index = (this.index + 1) % len;
    },
    handleActions(action, options = {}) {
      if (this.loading)
        return;
      const {
        zoomRate,
        rotateDeg,
        enableTransition
      } = __spreadValues({
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true
      }, options);
      const {
        transform
      } = this;
      switch (action) {
        case "zoomOut":
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case "zoomIn":
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case "clocelise":
          transform.deg += rotateDeg;
          break;
        case "anticlocelise":
          transform.deg -= rotateDeg;
          break;
      }
      transform.enableTransition = enableTransition;
    },
    async openPreview(orginUrl) {
      await this.fileUtils.transferPrivateOss(orginUrl, this.currentFile.filename || this.currentFile.name, (url2) => {
        this.fileUtils.openPreview({
          url: url2
        });
      });
    }
  }
};
const __cssModules$V = {};
var __component__$V = /* @__PURE__ */ normalizeComponent(__vue2_script$V, render$V, staticRenderFns$U, false, __vue2_injectStyles$V, null, null, null);
function __vue2_injectStyles$V(context2) {
  for (let o in __cssModules$V) {
    this[o] = __cssModules$V[o];
  }
}
__component__$V.options.__file = "packages/op-file-pc-preview/src/index.vue";
var OpFilePCPreview = /* @__PURE__ */ function() {
  return __component__$V.exports;
}();
OpFilePCPreview.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpFilePCPreview.name, prefix);
  Vue2.component(comName, OpFilePCPreview);
};
var __glob_6_8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpFilePCPreview
});
var render$U = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-wall-list-item"
  }, [_vm._l(_vm.previewList, function(item, index2) {
    return _c("div", {
      key: index2,
      staticClass: "list",
      style: {
        width: _vm.uploadSize + "px",
        height: _vm.uploadSize + "px"
      }
    }, [_c("div", {
      staticClass: "item-list-group"
    }, [_vm.fileUploadBase.judgSuffix(item) === "IMG" ? _c("img", {
      staticClass: "item-img",
      attrs: {
        "src": _vm.fileUploadBase.handleSrc(item, {
          compress: true
        })
      }
    }) : _vm.fileUploadBase.judgSuffix(item) === "VIDEO" ? _c("video", {
      staticClass: "item-video",
      attrs: {
        "src": _vm.fileUploadBase.handleSrc(item),
        "controls": "true"
      }
    }, [_vm._v(" \u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u89C6\u9891\u64AD\u653E ")]) : _vm.fileUploadBase.judgSuffix(item) !== "VIDEO" ? _c("i", {
      class: ["iconfont", "item-icon", _vm.fileUploadBase.getFileIcon(item)],
      style: {
        "font-size": _vm.uploadSize / 4 + "px"
      }
    }) : _vm._e()]), _c("div", {
      staticClass: "item-name",
      on: {
        "click": function($event) {
          return _vm.handleFileNameClick(item, index2);
        }
      }
    }, [_c("el-tooltip", {
      attrs: {
        "effect": "dark",
        "content": "" + _vm.fileUploadBase.handleName(item) + (_vm.hasOnFileNameClickFunction ? "" : "(\u70B9\u51FB\u540D\u79F0\u53EF\u4E0B\u8F7D)"),
        "placement": "top"
      }
    }, [_c("div", {
      staticClass: "op-nowrap op-pointer"
    }, [_vm._v(_vm._s(_vm.fileUploadBase.handleName(item)))])])], 1), _c("div", {
      staticClass: "item-btn-group"
    }, [_c("i", {
      staticClass: "el-icon-zoom-in zoom-in",
      on: {
        "click": function($event) {
          return _vm.previewFile(index2);
        }
      }
    }), _vm.isCanDownload(item) ? _c("i", {
      staticClass: "el-icon-download download",
      on: {
        "click": function($event) {
          return _vm.handleDownload(item);
        }
      }
    }) : _vm._e(), _vm.isCanDelete(item) ? _c("i", {
      staticClass: "el-icon-delete delete",
      on: {
        "click": function($event) {
          return _vm.deleteFile(index2);
        }
      }
    }) : _vm._e()])]);
  }), _c("div"), _vm.showViewer ? _c("OpFilePCPreview", {
    attrs: {
      "initial-index": _vm.viewerIndex,
      "file-upload-base": _vm.fileUploadBase,
      "url-list": _vm.urlList,
      "file-list": _vm.previewList,
      "on-close": _vm.closeViewer
    }
  }) : _vm._e()], 2);
};
var staticRenderFns$T = [];
render$U._withStripped = true;
var wallListItem_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$U = {
  name: "OpWallListItem",
  components: {
    OpFilePCPreview
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    fileUploadBase: {
      type: Object,
      default: () => {
        return {};
      }
    },
    uploadSize: {
      type: String,
      default: "108px"
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    isDownload: {
      type: Boolean,
      default: false
    },
    onFileNameClick: {
      type: [Function, null],
      default: null
    }
  },
  data() {
    return {
      showViewer: false,
      viewerIndex: 0,
      text: []
    };
  },
  computed: {
    previewList() {
      const list = (this.value || []).map((item) => {
        return __spreadValues({}, item);
      });
      this.$forceUpdate();
      return list;
    },
    urlList() {
      return this.previewList.reduce((cur, next3) => {
        const _newItem = __spreadValues({}, next3);
        cur.push(this.fileUploadBase.handleSrc(_newItem));
        return cur;
      }, []);
    },
    hasOnFileNameClickFunction() {
      return this.onFileNameClick && typeof this.onFileNameClick === "function";
    }
  },
  methods: {
    isCanDelete(item) {
      if (item.hasOwnProperty("isDelete")) {
        return item.isDelete;
      }
      return this.isDelete;
    },
    isCanDownload(item) {
      if (item.hasOwnProperty("isDownload")) {
        return item.isDownload;
      }
      return this.isDownload;
    },
    previewFile(index2) {
      this.showViewer = true;
      this.viewerIndex = index2;
    },
    deleteFile(index2) {
      let newValue = this.value;
      const currentFile = newValue[index2];
      newValue.splice(index2, 1);
      this.$emit("onRemove", currentFile, newValue);
      this.$emit("input", newValue);
    },
    handleDownload(item) {
      if (this.isCanDownload(item)) {
        this.$emit("ossDownLoad", item);
      }
    },
    handleFileNameClick(item, index2) {
      if (this.hasOnFileNameClickFunction) {
        this.onFileNameClick(this.value[index2], index2);
      } else if (this.isCanDownload(item)) {
        this.$emit("ossDownLoad", item);
      }
    },
    closeViewer() {
      this.showViewer = false;
    }
  }
};
const __cssModules$U = {};
var __component__$U = /* @__PURE__ */ normalizeComponent(__vue2_script$U, render$U, staticRenderFns$T, false, __vue2_injectStyles$U, "14de5ebc", null, null);
function __vue2_injectStyles$U(context2) {
  for (let o in __cssModules$U) {
    this[o] = __cssModules$U[o];
  }
}
__component__$U.options.__file = "packages/op-file-upload/src/pc/components/wall-list-item.vue";
var WallListItem = /* @__PURE__ */ function() {
  return __component__$U.exports;
}();
var render$T = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-text-item"
  }, [_vm._l(_vm.value, function(item, index2) {
    return _c("div", {
      key: index2,
      staticClass: "list"
    }, [_c("i", {
      class: ["iconfont", "item-icon", _vm.fileUploadBase.getFileIcon(item)],
      on: {
        "click": function($event) {
          return _vm.previewFile(index2);
        }
      }
    }), _c("span", {
      staticClass: "item-name",
      on: {
        "click": function($event) {
          return _vm.previewFile(index2);
        }
      }
    }, [_vm._v(_vm._s(_vm.fileUploadBase.handleName(item)))]), _vm.showprogress(item) ? _c("el-progress", {
      attrs: {
        "percentage": _vm.percentage(item.percentage),
        "color": _vm.showColor(item)
      }
    }) : _vm._e(), _c("div", {
      staticClass: "item-tight"
    }, [_vm.isPreview ? _c("i", {
      staticClass: "el-icon-zoom-in zoom-in",
      on: {
        "click": function($event) {
          return _vm.previewFile(index2);
        }
      }
    }) : _vm._e(), _vm.isDownload ? _c("i", {
      staticClass: "el-icon-download download",
      on: {
        "click": function($event) {
          return _vm.handleDownload(item);
        }
      }
    }) : _vm._e(), _vm.isPause && !item.isPause && item.checkpointId ? _c("i", {
      staticClass: "el-icon-video-pause pause",
      on: {
        "click": function($event) {
          return _vm.handlePause(item);
        }
      }
    }) : _vm._e(), _vm.isPause && item.isPause && item.checkpointId ? _c("i", {
      staticClass: "el-icon-video-play play",
      on: {
        "click": function($event) {
          return _vm.handleRecover(item);
        }
      }
    }) : _vm._e(), _vm.isDelete ? _c("i", {
      staticClass: "el-icon-delete delete",
      on: {
        "click": function($event) {
          return _vm.deleteFile(index2);
        }
      }
    }) : _vm._e()])], 1);
  }), _vm.showViewer ? _c("OpFilePCPreview", {
    attrs: {
      "initial-index": _vm.viewerIndex,
      "file-upload-base": _vm.fileUploadBase,
      "url-list": _vm.handleSrcList(),
      "file-list": _vm.value,
      "on-close": _vm.closeViewer
    }
  }) : _vm._e()], 2);
};
var staticRenderFns$S = [];
render$T._withStripped = true;
var textItem_vue_vue_type_style_index_0_lang = "";
const __vue2_script$T = {
  name: "TextItem",
  components: {
    OpFilePCPreview
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    fileUploadBase: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    isDownload: {
      type: Boolean,
      default: false
    },
    isPause: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showViewer: false,
      viewerIndex: 0
    };
  },
  created() {
  },
  methods: {
    percentage(p) {
      return Number(((p || 0) * 100).toFixed(0));
    },
    previewFile(index2) {
      if (!this.isPreview)
        return;
      this.showViewer = true;
      this.viewerIndex = index2;
    },
    deleteFile(index2) {
      const currentFile = this.value[index2];
      this.value.splice(index2, 1);
      this.$emit("input", this.value);
      this.$forceUpdate();
      this.$emit("onRemove", currentFile, this.value);
    },
    handleDownload(item) {
      this.$emit("ossDownLoad", item);
    },
    handlePause(item) {
      this.$emit("handlePause", item);
      this.$set(item, "isPause", true);
    },
    handleRecover(item) {
      this.$emit("handleRecover", item);
      this.$set(item, "isPause", false);
    },
    handleSrcList() {
      return this.value.reduce((cur, next3) => {
        cur.push(this.fileUploadBase.handleSrc(next3));
        return cur;
      }, []);
    },
    closeViewer() {
      this.showViewer = false;
    },
    showprogress(item) {
      return item.uploadId;
    },
    showColor(item) {
      let color = item.isPause ? "#e6a23c" : "#1989fa";
      return color;
    }
  }
};
const __cssModules$T = {};
var __component__$T = /* @__PURE__ */ normalizeComponent(__vue2_script$T, render$T, staticRenderFns$S, false, __vue2_injectStyles$T, null, null, null);
function __vue2_injectStyles$T(context2) {
  for (let o in __cssModules$T) {
    this[o] = __cssModules$T[o];
  }
}
__component__$T.options.__file = "packages/op-file-upload/src/pc/components/text-item.vue";
var TextItem = /* @__PURE__ */ function() {
  return __component__$T.exports;
}();
function broadcast(componentName, eventName, params) {
  this.$children.forEach((child) => {
    var name = child.$options.componentName;
    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
var Emitter = {
  methods: {
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params);
    }
  }
};
var initMixins = {
  mixins: [Emitter],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    onDownload: {
      type: Function
    },
    valueType: {
      type: String,
      default: "array"
    }
  },
  data() {
    return {
      opUpload: null,
      fileUploadBase: null,
      acceptTips: "\u4F60\u9009\u62E9\u7684\u6587\u4EF6\u4E0D\u7B26\u5408\u4E0A\u4F20\u89C4\u5219"
    };
  },
  computed: {
    _value: {
      get() {
        if (this.valueType === "text") {
          return this.value ? JSON.parse(this.value) : [];
        } else {
          return this.value ? this.value.map((item) => item) : [];
        }
      },
      set(val) {
        if (this.valueType === "text") {
          this.$emit("input", JSON.stringify(val || []));
        } else {
          this.$emit("input", val);
        }
        if (isPCWidth()) {
          this.dispatch("ElFormItem", "el.form.change", val);
        }
      }
    }
  },
  methods: {
    init() {
      this.fileUploadBase = new FileUploadBase$1();
      this.fileUploadBase.setProps(this.props);
      const oauth2AccessToken = getOauth2AccessToken();
      const apigateway = baseUrlInst.getBaseUrl().apigateway;
      if (!oauth2AccessToken || !apigateway) {
        throw new Error("\u4E0A\u4F20\u7EC4\u4EF6\u521D\u59CB\u5316\u5931\u8D25, \u8BF7\u68C0\u6D4B\u662F\u5426\u914D\u7F6E\u5B8C\u6574");
      }
      const _code = getAppCode();
      this.opUpload = new OssUpload({
        appCode: this.appCode || _code.appCode,
        subAppCode: this.subAppCode || _code.subAppCode,
        baseURL: apigateway,
        token: oauth2AccessToken
      });
      this.fileUploadBase.setOpUpload(this.opUpload);
    },
    async ossDownLoad(item) {
      if (!this.opUpload) {
        throw new Error("Oss\u5B9E\u4F8B\u672A\u751F\u6210");
      }
      let fileName = item.filename || item.name || item.ossKey || item.path;
      let filePath = item.path || item.ossKey || item.name;
      let fileUrl = item.url;
      if (fileUrl && fileUrl.indexOf("-private-") != -1) {
        this.fileUploadBase.transferPrivateOss(fileUrl, fileName, (url2) => {
          window.open(url2);
        });
        return;
      }
      if (fileUrl && fileUrl.indexOf("http") === 0) {
        window.open(fileUrl);
        return;
      }
      const downResult = await this.opUpload.downloadPath(filePath, fileName, this.authType || 0);
      if (this.onDownload) {
        this.onDownload(item, downResult);
        return;
      } else {
        window.open(downResult);
      }
    },
    async ossUpload(file) {
      const {
        subAppCode,
        appCode
      } = getAppCode();
      if (!this.businessType) {
        throw new Error("\u4E0A\u4F20\u6587\u4EF6\u5FC5\u987B\u5B9A\u4E49businessType");
      }
      this.loading = true;
      const resData = await this.opUpload.uploadFile(file, {
        sysPlatform: this.sysPlatForm || appCode,
        businessType: this.businessType
      }, this.authType);
      this.loading = false;
      return resData;
    },
    async ossMultiPartUpload(file, checkpointId, callback2) {
      const {
        subAppCode,
        appCode
      } = getAppCode();
      if (!this.businessType) {
        throw new Error("\u4E0A\u4F20\u6587\u4EF6\u5FC5\u987B\u5B9A\u4E49businessType");
      }
      this.loading = true;
      const resData = await this.opUpload.multipartUpload(file, {
        sysPlatform: this.sysPlatForm || appCode,
        businessType: this.businessType
      }, callback2, checkpointId, this.authType);
      this.loading = false;
      return resData;
    },
    ossPause() {
      if (this.opUpload.__OSS)
        this.opUpload.__OSS.cancel();
    }
  },
  created() {
    if (inBrowser$1) {
      this.init();
    }
  }
};
var render$S = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-upload"
  }, [_vm.listType === "wall-list" ? _c("WallListItem", {
    attrs: {
      "upload-size": _vm.uploadSize,
      "is-delete": _vm.isDelete && _vm.isUpload,
      "is-download": _vm.isDownload,
      "file-upload-base": _vm.fileUploadBase,
      "on-file-name-click": _vm.onFileNameClick
    },
    on: {
      "ossDownLoad": _vm.ossDownLoad,
      "onRemove": _vm.onRemove
    },
    model: {
      value: _vm._value,
      callback: function($$v) {
        _vm._value = $$v;
      },
      expression: "_value"
    }
  }) : _vm._e(), _vm.isUpload ? _c("el-upload", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "elUpload",
    staticClass: "op-upload-active",
    attrs: {
      "element-loading-text": "\u6587\u4EF6\u4E0A\u4F20\u4E2D",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)",
      "action": "",
      "http-request": _vm.handleUploadFile,
      "list-type": _vm.listType,
      "file-list": _vm._value,
      "show-file-list": false,
      "accept": _vm.accept,
      "before-upload": _vm.beforeUpload,
      "multiple": _vm.multiple,
      "limit": _vm.getMaxLength,
      "on-exceed": _vm.onExceed,
      "on-success": _vm.onSuccess,
      "disabled": _vm.isMaxlength
    }
  }, [_vm.listType === "wall-list" ? _c("div", {
    staticClass: "op-upload-item",
    class: _vm.isMaxlength ? "op-upload-disabled" : "",
    style: {
      width: _vm.uploadSize + "px",
      height: _vm.uploadSize + "px"
    }
  }, [_c("i", {
    staticClass: "el-icon-plus",
    style: {
      "font-size": _vm.uploadSize / 5 + "px"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  })]) : _vm.listType === "text" || _vm.listType === "picture" ? _c("el-button", {
    ref: "elUploadButton",
    class: _vm.isMaxlength ? "op-upload-disabled" : "",
    attrs: {
      "slot": "default",
      "color": "#fc9153",
      "size": "mini",
      "type": "primary",
      "disabled": _vm.isMaxlength
    },
    slot: "default"
  }, [_vm._v(" \u70B9\u51FB\u4E0A\u4F20 ")]) : _vm._e()], 1) : _vm._e(), _vm.listType === "text" ? _c("TextItem", {
    attrs: {
      "upload-size": _vm.uploadSize,
      "is-delete": _vm.isDelete && _vm.isUpload,
      "is-download": _vm.isDownload,
      "is-pause": _vm.isPause,
      "is-preview": _vm.isPreview,
      "file-upload-base": _vm.fileUploadBase
    },
    on: {
      "onContinueUpload": _vm.handleUploadFile,
      "ossDownLoad": _vm.ossDownLoad,
      "onRemove": _vm.onRemove,
      "handlePause": _vm.handlePause,
      "handleRecover": _vm.handleRecover
    },
    model: {
      value: _vm._value,
      callback: function($$v) {
        _vm._value = $$v;
      },
      expression: "_value"
    }
  }) : _vm._e(), !_vm.value.length && !_vm.isUpload ? _c("div", {
    staticClass: "no-data-tips"
  }, [_vm._v("\u6682\u65E0\u9644\u4EF6")]) : _vm._e(), _c("input", {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })], 1);
};
var staticRenderFns$R = [];
render$S._withStripped = true;
var index_vue_vue_type_style_index_0_lang$9 = "";
const __vue2_script$S = {
  name: "OpFileUpload",
  components: {
    WallListItem,
    TextItem
  },
  mixins: [initMixins],
  props: {
    props: {
      type: Object,
      default: () => {
        return {
          name: "name",
          src: "ossKey"
        };
      }
    },
    listType: {
      type: String,
      default: "wall-list"
    },
    size: {
      type: String,
      default: "small"
    },
    accept: {
      type: String,
      default: "*"
    },
    maxSize: {
      type: Number,
      default: 50
    },
    maxLength: {
      type: [Number, String],
      default: 0
    },
    multiple: {
      type: Boolean,
      default: false
    },
    sysPlatForm: {
      type: String
    },
    businessType: {
      type: String,
      require: true
    },
    isDelete: {
      type: Boolean,
      default: true
    },
    isDownload: {
      type: Boolean,
      default: true
    },
    isUpload: {
      type: Boolean,
      default: true
    },
    isPause: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: true
    },
    onSuccess: {
      type: Function,
      default: () => {
      }
    },
    onRemove: {
      type: Function,
      default: () => {
      }
    },
    authType: {
      type: [Number, String],
      default: 0
    },
    signatureOption: {
      type: Object,
      default: () => null
    },
    onFileNameClick: {
      type: [Function, null],
      default: null
    },
    multiPart: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      sizeConfig: {
        medium: "148",
        small: "128",
        mini: "108"
      },
      fileData: {}
    };
  },
  computed: {
    uploadSize() {
      const size2 = this.sizeConfig[this.size];
      return size2 ? size2 : "108";
    },
    isMaxlength() {
      return +this.maxLength > 0 && +this.maxLength === this.value.length;
    },
    getMaxLength() {
      return this.maxLength ? +this.maxLength : 0;
    }
  },
  methods: {
    beforeUpload(res) {
      let fileType = res.name.split(".")[res.name.split(".").length - 1].toLocaleUpperCase();
      let acceptList = this.accept.split(",").reduce((accumulator, list) => {
        accumulator.push(list.toLocaleUpperCase());
        return accumulator;
      }, []);
      if (this.accept && this.accept !== "*") {
        if (!acceptList.includes(fileType)) {
          this.$message.info(this.acceptTips);
          this.$emit("onError");
          return false;
        }
      }
      if (res.size / 1024 / 1024 > this.maxSize) {
        this.$message.info(`\u4E0A\u4F20\u6587\u4EF6\u4E0D\u80FD\u8D85\u8FC7${this.maxSize}M`);
        this.$emit("onError");
        return false;
      }
      if (+this.maxLength && this.value.length >= this.maxLength) {
        this.$message.info(`\u6587\u4EF6\u6700\u5927\u4E0A\u4F20\u6570\u91CF\u9650\u5236\u4E3A${this.maxLength}`);
        this.$emit("onError");
        return false;
      }
      return true;
    },
    async handleUploadFile(file) {
      this.$emit("onStart", file);
      let fileData = null;
      if (this.multiPart && this.listType === "text") {
        fileData = await this.uploadMultiPart(file);
      } else {
        fileData = await this.uploadFile(file);
      }
      this.$emit("onSuccess", fileData, file, this.value);
    },
    async uploadFile(file) {
      try {
        const resData = await this.ossUpload(file);
        if (!resData || !resData.status) {
          return;
        }
        let fileData = {
          id: resData.id || "",
          name: resData.filename,
          suffix: resData.suffix,
          ossKey: resData.name,
          path: resData.name,
          uid: resData.uid,
          size: resData.size,
          file,
          url: resData.signatureUrl || resData.name,
          filename: resData.filename,
          fullPath: resData.url,
          isDelete: true,
          isDownload: true
        };
        fileData[this.props.name] = resData.filename;
        fileData[this.props.src] = resData.signatureUrl || resData.name;
        this._value = [...this._value, fileData];
        return fileData;
      } catch (error) {
        this.$message.error("\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25");
        this.loading = false;
        this.$emit("onError");
        return null;
      }
    },
    async uploadMultiPart(file, checkpointId = "") {
      const handleCheckPointFile = (info) => {
        let existFile = this._value.find((x) => x.checkpointId && x.checkpointId === info.checkpointId);
        if (existFile) {
          existFile = Object.assign(existFile, info);
        } else {
          this._value = [...this._value, info];
        }
      };
      try {
        const resData = await this.ossMultiPartUpload(file, checkpointId, handleCheckPointFile);
        if (!resData || !resData.status) {
          return;
        }
        let fileData = {
          id: resData.id || "",
          name: resData.filename,
          suffix: resData.suffix,
          ossKey: resData.name,
          path: resData.name,
          uid: resData.uid,
          size: resData.size,
          file,
          url: resData.signatureUrl || resData.name,
          filename: resData.filename,
          fullPath: resData.url,
          isPause: false,
          isDelete: true,
          isDownload: true
        };
        fileData[this.props.name] = resData.filename;
        fileData[this.props.src] = resData.signatureUrl || resData.name;
        const removeCheckPointList = this._value.filter((x) => !x.checkpointId || x.uid !== resData.uid);
        this._value = [...removeCheckPointList, fileData];
        return fileData;
      } catch (error) {
        this.$message.error("\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25");
        this.loading = false;
        this.$emit("onError");
        return null;
      }
    },
    handlePause(item) {
      this.ossPause();
    },
    handleRecover(item) {
      if (item.uploadId) {
        if (!item.file.file.name) {
          this.$confirm("\u6587\u4EF6\u4E22\u5931\uFF0C\u8BF7\u9009\u62E9\u540C\u4E00\u4EFD\u6587\u4EF6", "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            showCancelButton: false,
            closeOnClickModal: false,
            showClose: false,
            type: "warning"
          }).then(() => {
            this.fileData = item;
            this.openFileSelection();
          });
        } else {
          this.uploadMultiPart(item.file, item.checkpointId);
        }
      }
    },
    openFileSelection() {
      this.$set(this.fileData, "isPause", true);
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      if (this.fileData.filename != selectedFile.name) {
        this.$message.error("\u6587\u4EF6\u4E0D\u5339\u914D\uFF0C\u8BF7\u9009\u62E9\u540C\u4E00\u4EFD\u6587\u4EF6");
        return;
      }
      this.fileData.file = {
        file: selectedFile,
        filename: "file"
      };
      if (selectedFile) {
        this.$set(this.fileData, "isPause", false);
        this.uploadMultiPart(this.fileData.file, this.fileData.checkpointId);
      }
    },
    onExceed() {
      this.$message.info(`\u6587\u4EF6\u6700\u5927\u4E0A\u4F20\u6570\u91CF\u9650\u5236\u4E3A${this.maxLength}`);
    }
  }
};
const __cssModules$S = {};
var __component__$S = /* @__PURE__ */ normalizeComponent(__vue2_script$S, render$S, staticRenderFns$R, false, __vue2_injectStyles$S, null, null, null);
function __vue2_injectStyles$S(context2) {
  for (let o in __cssModules$S) {
    this[o] = __cssModules$S[o];
  }
}
__component__$S.options.__file = "packages/op-file-upload/src/pc/index.vue";
var FileUpload = /* @__PURE__ */ function() {
  return __component__$S.exports;
}();
var index$n = "";
var index$m = "";
var index$l = "";
var index$k = "";
var _createNamespace$r = createNamespace("image-preview"), createComponent$r = _createNamespace$r[0], bem$r = _createNamespace$r[1];
function isHidden(el) {
  var style6 = window.getComputedStyle(el);
  var hidden2 = style6.display === "none";
  var parentHidden = el.offsetParent === null && style6.position !== "fixed";
  return hidden2 || parentHidden;
}
var prev = Date.now();
function fallback(fn2) {
  var curr = Date.now();
  var ms = Math.max(0, 16 - (curr - prev));
  var id = setTimeout(fn2, ms);
  prev = curr + ms;
  return id;
}
var root$1 = isServer$3 ? global : window;
var iRaf = root$1.requestAnimationFrame || fallback;
function raf(fn2) {
  return iRaf.call(root$1, fn2);
}
function doubleRaf(fn2) {
  raf(function() {
    raf(fn2);
  });
}
function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
function trimExtraChar(value9, _char, regExp) {
  var index2 = value9.indexOf(_char);
  var prefix = "";
  if (index2 === -1) {
    return value9;
  }
  if (_char === "-" && index2 !== 0) {
    return value9.slice(0, index2);
  }
  if (_char === "." && value9.match(/^(\.|-\.)/)) {
    prefix = index2 ? "-0" : "0";
  }
  return prefix + value9.slice(0, index2 + 1) + value9.slice(index2).replace(regExp, "");
}
function formatNumber(value9, allowDot, allowMinus) {
  if (allowDot === void 0) {
    allowDot = true;
  }
  if (allowMinus === void 0) {
    allowMinus = true;
  }
  if (allowDot) {
    value9 = trimExtraChar(value9, ".", /\./g);
  } else {
    value9 = value9.split(".")[0];
  }
  if (allowMinus) {
    value9 = trimExtraChar(value9, "-", /-/g);
  } else {
    value9 = value9.replace(/-/, "");
  }
  var regExp = allowDot ? /[^-0-9.]/g : /[^-0-9]/g;
  return value9.replace(regExp, "");
}
var _createNamespace$q = createNamespace("swipe"), createComponent$q = _createNamespace$q[0], bem$q = _createNamespace$q[1];
var Swipe = createComponent$q({
  mixins: [TouchMixin, ParentMixin("vanSwipe"), BindEventMixin(function(bind2, isBind) {
    bind2(window, "resize", this.resize, true);
    bind2(window, "orientationchange", this.resize, true);
    bind2(window, "visibilitychange", this.onVisibilityChange);
    if (isBind) {
      this.initialize();
    } else {
      this.clear();
    }
  })],
  props: {
    width: [Number, String],
    height: [Number, String],
    autoplay: [Number, String],
    vertical: Boolean,
    lazyRender: Boolean,
    indicatorColor: String,
    loop: {
      type: Boolean,
      default: true
    },
    duration: {
      type: [Number, String],
      default: 500
    },
    touchable: {
      type: Boolean,
      default: true
    },
    initialSwipe: {
      type: [Number, String],
      default: 0
    },
    showIndicators: {
      type: Boolean,
      default: true
    },
    stopPropagation: {
      type: Boolean,
      default: true
    }
  },
  data: function data6() {
    return {
      rect: null,
      offset: 0,
      active: 0,
      deltaX: 0,
      deltaY: 0,
      swiping: false,
      computedWidth: 0,
      computedHeight: 0
    };
  },
  watch: {
    children: function children() {
      this.initialize();
    },
    initialSwipe: function initialSwipe() {
      this.initialize();
    },
    autoplay: function autoplay(_autoplay) {
      if (_autoplay > 0) {
        this.autoPlay();
      } else {
        this.clear();
      }
    }
  },
  computed: {
    count: function count2() {
      return this.children.length;
    },
    maxCount: function maxCount() {
      return Math.ceil(Math.abs(this.minOffset) / this.size);
    },
    delta: function delta() {
      return this.vertical ? this.deltaY : this.deltaX;
    },
    size: function size() {
      return this[this.vertical ? "computedHeight" : "computedWidth"];
    },
    trackSize: function trackSize() {
      return this.count * this.size;
    },
    activeIndicator: function activeIndicator() {
      return (this.active + this.count) % this.count;
    },
    isCorrectDirection: function isCorrectDirection() {
      var expect = this.vertical ? "vertical" : "horizontal";
      return this.direction === expect;
    },
    trackStyle: function trackStyle() {
      var style6 = {
        transitionDuration: (this.swiping ? 0 : this.duration) + "ms",
        transform: "translate" + (this.vertical ? "Y" : "X") + "(" + this.offset + "px)"
      };
      if (this.size) {
        var mainAxis = this.vertical ? "height" : "width";
        var crossAxis = this.vertical ? "width" : "height";
        style6[mainAxis] = this.trackSize + "px";
        style6[crossAxis] = this[crossAxis] ? this[crossAxis] + "px" : "";
      }
      return style6;
    },
    indicatorStyle: function indicatorStyle() {
      return {
        backgroundColor: this.indicatorColor
      };
    },
    minOffset: function minOffset() {
      return (this.vertical ? this.rect.height : this.rect.width) - this.size * this.count;
    }
  },
  mounted: function mounted2() {
    this.bindTouchEvent(this.$refs.track);
  },
  methods: {
    initialize: function initialize(active2) {
      if (active2 === void 0) {
        active2 = +this.initialSwipe;
      }
      if (!this.$el || isHidden(this.$el)) {
        return;
      }
      clearTimeout(this.timer);
      var rect = {
        width: this.$el.offsetWidth,
        height: this.$el.offsetHeight
      };
      this.rect = rect;
      this.swiping = true;
      this.active = active2;
      this.computedWidth = +this.width || rect.width;
      this.computedHeight = +this.height || rect.height;
      this.offset = this.getTargetOffset(active2);
      this.children.forEach(function(swipe) {
        swipe.offset = 0;
      });
      this.autoPlay();
    },
    resize: function resize() {
      this.initialize(this.activeIndicator);
    },
    onVisibilityChange: function onVisibilityChange() {
      if (document.hidden) {
        this.clear();
      } else {
        this.autoPlay();
      }
    },
    onTouchStart: function onTouchStart(event) {
      if (!this.touchable)
        return;
      this.clear();
      this.touchStartTime = Date.now();
      this.touchStart(event);
      this.correctPosition();
    },
    onTouchMove: function onTouchMove(event) {
      if (!this.touchable || !this.swiping)
        return;
      this.touchMove(event);
      if (this.isCorrectDirection) {
        preventDefault(event, this.stopPropagation);
        this.move({
          offset: this.delta
        });
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (!this.touchable || !this.swiping)
        return;
      var size2 = this.size, delta2 = this.delta;
      var duration = Date.now() - this.touchStartTime;
      var speed = delta2 / duration;
      var shouldSwipe = Math.abs(speed) > 0.25 || Math.abs(delta2) > size2 / 2;
      if (shouldSwipe && this.isCorrectDirection) {
        var offset = this.vertical ? this.offsetY : this.offsetX;
        var pace = 0;
        if (this.loop) {
          pace = offset > 0 ? delta2 > 0 ? -1 : 1 : 0;
        } else {
          pace = -Math[delta2 > 0 ? "ceil" : "floor"](delta2 / size2);
        }
        this.move({
          pace,
          emitChange: true
        });
      } else if (delta2) {
        this.move({
          pace: 0
        });
      }
      this.swiping = false;
      this.autoPlay();
    },
    getTargetActive: function getTargetActive(pace) {
      var active2 = this.active, count3 = this.count, maxCount2 = this.maxCount;
      if (pace) {
        if (this.loop) {
          return range(active2 + pace, -1, count3);
        }
        return range(active2 + pace, 0, maxCount2);
      }
      return active2;
    },
    getTargetOffset: function getTargetOffset(targetActive, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      var currentPosition = targetActive * this.size;
      if (!this.loop) {
        currentPosition = Math.min(currentPosition, -this.minOffset);
      }
      var targetOffset = offset - currentPosition;
      if (!this.loop) {
        targetOffset = range(targetOffset, this.minOffset, 0);
      }
      return targetOffset;
    },
    move: function move(_ref) {
      var _ref$pace = _ref.pace, pace = _ref$pace === void 0 ? 0 : _ref$pace, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0 : _ref$offset, emitChange = _ref.emitChange;
      var loop = this.loop, count3 = this.count, active2 = this.active, children3 = this.children, trackSize2 = this.trackSize, minOffset2 = this.minOffset;
      if (count3 <= 1) {
        return;
      }
      var targetActive = this.getTargetActive(pace);
      var targetOffset = this.getTargetOffset(targetActive, offset);
      if (loop) {
        if (children3[0] && targetOffset !== minOffset2) {
          var outRightBound = targetOffset < minOffset2;
          children3[0].offset = outRightBound ? trackSize2 : 0;
        }
        if (children3[count3 - 1] && targetOffset !== 0) {
          var outLeftBound = targetOffset > 0;
          children3[count3 - 1].offset = outLeftBound ? -trackSize2 : 0;
        }
      }
      this.active = targetActive;
      this.offset = targetOffset;
      if (emitChange && targetActive !== active2) {
        this.$emit("change", this.activeIndicator);
      }
    },
    prev: function prev2() {
      var _this = this;
      this.correctPosition();
      this.resetTouchStatus();
      doubleRaf(function() {
        _this.swiping = false;
        _this.move({
          pace: -1,
          emitChange: true
        });
      });
    },
    next: function next() {
      var _this2 = this;
      this.correctPosition();
      this.resetTouchStatus();
      doubleRaf(function() {
        _this2.swiping = false;
        _this2.move({
          pace: 1,
          emitChange: true
        });
      });
    },
    swipeTo: function swipeTo(index2, options) {
      var _this3 = this;
      if (options === void 0) {
        options = {};
      }
      this.correctPosition();
      this.resetTouchStatus();
      doubleRaf(function() {
        var targetIndex;
        if (_this3.loop && index2 === _this3.count) {
          targetIndex = _this3.active === 0 ? 0 : index2;
        } else {
          targetIndex = index2 % _this3.count;
        }
        if (options.immediate) {
          doubleRaf(function() {
            _this3.swiping = false;
          });
        } else {
          _this3.swiping = false;
        }
        _this3.move({
          pace: targetIndex - _this3.active,
          emitChange: true
        });
      });
    },
    correctPosition: function correctPosition() {
      this.swiping = true;
      if (this.active <= -1) {
        this.move({
          pace: this.count
        });
      }
      if (this.active >= this.count) {
        this.move({
          pace: -this.count
        });
      }
    },
    clear: function clear() {
      clearTimeout(this.timer);
    },
    autoPlay: function autoPlay() {
      var _this4 = this;
      var autoplay2 = this.autoplay;
      if (autoplay2 > 0 && this.count > 1) {
        this.clear();
        this.timer = setTimeout(function() {
          _this4.next();
          _this4.autoPlay();
        }, autoplay2);
      }
    },
    genIndicator: function genIndicator() {
      var _this5 = this;
      var h = this.$createElement;
      var count3 = this.count, activeIndicator2 = this.activeIndicator;
      var slot = this.slots("indicator");
      if (slot) {
        return slot;
      }
      if (this.showIndicators && count3 > 1) {
        return h("div", {
          "class": bem$q("indicators", {
            vertical: this.vertical
          })
        }, [Array.apply(void 0, Array(count3)).map(function(empty, index2) {
          return h("i", {
            "class": bem$q("indicator", {
              active: index2 === activeIndicator2
            }),
            "style": index2 === activeIndicator2 ? _this5.indicatorStyle : null
          });
        })]);
      }
    }
  },
  render: function render5() {
    var h = arguments[0];
    return h("div", {
      "class": bem$q()
    }, [h("div", {
      "ref": "track",
      "style": this.trackStyle,
      "class": bem$q("track", {
        vertical: this.vertical
      })
    }, [this.slots()]), this.genIndicator()]);
  }
});
var _createNamespace$p = createNamespace("image"), createComponent$p = _createNamespace$p[0], bem$p = _createNamespace$p[1];
var Image$1 = createComponent$p({
  props: {
    src: String,
    fit: String,
    alt: String,
    round: Boolean,
    width: [Number, String],
    height: [Number, String],
    radius: [Number, String],
    lazyLoad: Boolean,
    iconPrefix: String,
    showError: {
      type: Boolean,
      default: true
    },
    showLoading: {
      type: Boolean,
      default: true
    },
    errorIcon: {
      type: String,
      default: "photo-fail"
    },
    loadingIcon: {
      type: String,
      default: "photo"
    }
  },
  data: function data7() {
    return {
      loading: true,
      error: false
    };
  },
  watch: {
    src: function src() {
      this.loading = true;
      this.error = false;
    }
  },
  computed: {
    style: function style() {
      var style6 = {};
      if (isDef$1(this.width)) {
        style6.width = addUnit(this.width);
      }
      if (isDef$1(this.height)) {
        style6.height = addUnit(this.height);
      }
      if (isDef$1(this.radius)) {
        style6.overflow = "hidden";
        style6.borderRadius = addUnit(this.radius);
      }
      return style6;
    }
  },
  created: function created() {
    var $Lazyload = this.$Lazyload;
    if ($Lazyload && inBrowser) {
      $Lazyload.$on("loaded", this.onLazyLoaded);
      $Lazyload.$on("error", this.onLazyLoadError);
    }
  },
  beforeDestroy: function beforeDestroy2() {
    var $Lazyload = this.$Lazyload;
    if ($Lazyload) {
      $Lazyload.$off("loaded", this.onLazyLoaded);
      $Lazyload.$off("error", this.onLazyLoadError);
    }
  },
  methods: {
    onLoad: function onLoad(event) {
      this.loading = false;
      this.$emit("load", event);
    },
    onLazyLoaded: function onLazyLoaded(_ref) {
      var el = _ref.el;
      if (el === this.$refs.image && this.loading) {
        this.onLoad();
      }
    },
    onLazyLoadError: function onLazyLoadError(_ref2) {
      var el = _ref2.el;
      if (el === this.$refs.image && !this.error) {
        this.onError();
      }
    },
    onError: function onError(event) {
      this.error = true;
      this.loading = false;
      this.$emit("error", event);
    },
    onClick: function onClick3(event) {
      this.$emit("click", event);
    },
    genPlaceholder: function genPlaceholder() {
      var h = this.$createElement;
      if (this.loading && this.showLoading) {
        return h("div", {
          "class": bem$p("loading")
        }, [this.slots("loading") || h(_Icon, {
          "attrs": {
            "name": this.loadingIcon,
            "classPrefix": this.iconPrefix
          },
          "class": bem$p("loading-icon")
        })]);
      }
      if (this.error && this.showError) {
        return h("div", {
          "class": bem$p("error")
        }, [this.slots("error") || h(_Icon, {
          "attrs": {
            "name": this.errorIcon,
            "classPrefix": this.iconPrefix
          },
          "class": bem$p("error-icon")
        })]);
      }
    },
    genImage: function genImage() {
      var h = this.$createElement;
      var imgData = {
        class: bem$p("img"),
        attrs: {
          alt: this.alt
        },
        style: {
          objectFit: this.fit
        }
      };
      if (this.error) {
        return;
      }
      if (this.lazyLoad) {
        return h("img", _mergeJSXProps([{
          "ref": "image",
          "directives": [{
            name: "lazy",
            value: this.src
          }]
        }, imgData]));
      }
      return h("img", _mergeJSXProps([{
        "attrs": {
          "src": this.src
        },
        "on": {
          "load": this.onLoad,
          "error": this.onError
        }
      }, imgData]));
    }
  },
  render: function render6() {
    var h = arguments[0];
    return h("div", {
      "class": bem$p({
        round: this.round
      }),
      "style": this.style,
      "on": {
        "click": this.onClick
      }
    }, [this.genImage(), this.genPlaceholder(), this.slots()]);
  }
});
var _createNamespace$o = createNamespace("swipe-item"), createComponent$o = _createNamespace$o[0], bem$o = _createNamespace$o[1];
var SwipeItem = createComponent$o({
  mixins: [ChildrenMixin("vanSwipe")],
  data: function data8() {
    return {
      offset: 0,
      inited: false,
      mounted: false
    };
  },
  mounted: function mounted3() {
    var _this = this;
    this.$nextTick(function() {
      _this.mounted = true;
    });
  },
  computed: {
    style: function style2() {
      var style6 = {};
      var _this$parent = this.parent, size2 = _this$parent.size, vertical2 = _this$parent.vertical;
      if (size2) {
        style6[vertical2 ? "height" : "width"] = size2 + "px";
      }
      if (this.offset) {
        style6.transform = "translate" + (vertical2 ? "Y" : "X") + "(" + this.offset + "px)";
      }
      return style6;
    },
    shouldRender: function shouldRender() {
      var index2 = this.index, inited2 = this.inited, parent = this.parent, mounted12 = this.mounted;
      if (!parent.lazyRender || inited2) {
        return true;
      }
      if (!mounted12) {
        return false;
      }
      var active2 = parent.activeIndicator;
      var maxActive = parent.count - 1;
      var prevActive = active2 === 0 && parent.loop ? maxActive : active2 - 1;
      var nextActive = active2 === maxActive && parent.loop ? 0 : active2 + 1;
      var shouldRender2 = index2 === active2 || index2 === prevActive || index2 === nextActive;
      if (shouldRender2) {
        this.inited = true;
      }
      return shouldRender2;
    }
  },
  render: function render7() {
    var h = arguments[0];
    return h("div", {
      "class": bem$o(),
      "style": this.style,
      "on": _extends$o({}, this.$listeners)
    }, [this.shouldRender && this.slots()]);
  }
});
function getDistance(touches) {
  return Math.sqrt(Math.pow(touches[0].clientX - touches[1].clientX, 2) + Math.pow(touches[0].clientY - touches[1].clientY, 2));
}
var ImagePreviewItem = {
  mixins: [TouchMixin],
  props: {
    src: String,
    show: Boolean,
    active: Number,
    minZoom: [Number, String],
    maxZoom: [Number, String],
    rootWidth: Number,
    rootHeight: Number
  },
  data: function data9() {
    return {
      scale: 1,
      moveX: 0,
      moveY: 0,
      moving: false,
      zooming: false,
      imageRatio: 0,
      displayWidth: 0,
      displayHeight: 0
    };
  },
  computed: {
    vertical: function vertical() {
      var rootWidth = this.rootWidth, rootHeight = this.rootHeight;
      var rootRatio = rootHeight / rootWidth;
      return this.imageRatio > rootRatio;
    },
    imageStyle: function imageStyle() {
      var scale2 = this.scale;
      var style6 = {
        transitionDuration: this.zooming || this.moving ? "0s" : ".3s"
      };
      if (scale2 !== 1) {
        var offsetX = this.moveX / scale2;
        var offsetY = this.moveY / scale2;
        style6.transform = "scale(" + scale2 + ", " + scale2 + ") translate(" + offsetX + "px, " + offsetY + "px)";
      }
      return style6;
    },
    maxMoveX: function maxMoveX() {
      if (this.imageRatio) {
        var displayWidth = this.vertical ? this.rootHeight / this.imageRatio : this.rootWidth;
        return Math.max(0, (this.scale * displayWidth - this.rootWidth) / 2);
      }
      return 0;
    },
    maxMoveY: function maxMoveY() {
      if (this.imageRatio) {
        var displayHeight = this.vertical ? this.rootHeight : this.rootWidth * this.imageRatio;
        return Math.max(0, (this.scale * displayHeight - this.rootHeight) / 2);
      }
      return 0;
    }
  },
  watch: {
    active: "resetScale",
    show: function show(val) {
      if (!val) {
        this.resetScale();
      }
    }
  },
  mounted: function mounted4() {
    this.bindTouchEvent(this.$el);
  },
  methods: {
    resetScale: function resetScale() {
      this.setScale(1);
      this.moveX = 0;
      this.moveY = 0;
    },
    setScale: function setScale(scale2) {
      scale2 = range(scale2, +this.minZoom, +this.maxZoom);
      if (scale2 !== this.scale) {
        this.scale = scale2;
        this.$emit("scale", {
          scale: this.scale,
          index: this.active
        });
      }
    },
    toggleScale: function toggleScale() {
      var scale2 = this.scale > 1 ? 1 : 2;
      this.setScale(scale2);
      this.moveX = 0;
      this.moveY = 0;
    },
    onTouchStart: function onTouchStart2(event) {
      var touches = event.touches;
      var _this$offsetX = this.offsetX, offsetX = _this$offsetX === void 0 ? 0 : _this$offsetX;
      this.touchStart(event);
      this.touchStartTime = new Date();
      this.fingerNum = touches.length;
      this.startMoveX = this.moveX;
      this.startMoveY = this.moveY;
      this.moving = this.fingerNum === 1 && this.scale !== 1;
      this.zooming = this.fingerNum === 2 && !offsetX;
      if (this.zooming) {
        this.startScale = this.scale;
        this.startDistance = getDistance(event.touches);
      }
    },
    onTouchMove: function onTouchMove2(event) {
      var touches = event.touches;
      this.touchMove(event);
      if (this.moving || this.zooming) {
        preventDefault(event, true);
      }
      if (this.moving) {
        var moveX = this.deltaX + this.startMoveX;
        var moveY = this.deltaY + this.startMoveY;
        this.moveX = range(moveX, -this.maxMoveX, this.maxMoveX);
        this.moveY = range(moveY, -this.maxMoveY, this.maxMoveY);
      }
      if (this.zooming && touches.length === 2) {
        var distance = getDistance(touches);
        var scale2 = this.startScale * distance / this.startDistance;
        this.setScale(scale2);
      }
    },
    onTouchEnd: function onTouchEnd2(event) {
      var stopPropagation2 = false;
      if (this.moving || this.zooming) {
        stopPropagation2 = true;
        if (this.moving && this.startMoveX === this.moveX && this.startMoveY === this.moveY) {
          stopPropagation2 = false;
        }
        if (!event.touches.length) {
          if (this.zooming) {
            this.moveX = range(this.moveX, -this.maxMoveX, this.maxMoveX);
            this.moveY = range(this.moveY, -this.maxMoveY, this.maxMoveY);
            this.zooming = false;
          }
          this.moving = false;
          this.startMoveX = 0;
          this.startMoveY = 0;
          this.startScale = 1;
          if (this.scale < 1) {
            this.resetScale();
          }
        }
      }
      preventDefault(event, stopPropagation2);
      this.checkTap();
      this.resetTouchStatus();
    },
    checkTap: function checkTap() {
      var _this = this;
      if (this.fingerNum > 1) {
        return;
      }
      var _this$offsetX2 = this.offsetX, offsetX = _this$offsetX2 === void 0 ? 0 : _this$offsetX2, _this$offsetY = this.offsetY, offsetY = _this$offsetY === void 0 ? 0 : _this$offsetY;
      var deltaTime = new Date() - this.touchStartTime;
      var TAP_TIME = 250;
      var TAP_OFFSET = 5;
      if (offsetX < TAP_OFFSET && offsetY < TAP_OFFSET && deltaTime < TAP_TIME) {
        if (this.doubleTapTimer) {
          clearTimeout(this.doubleTapTimer);
          this.doubleTapTimer = null;
          this.toggleScale();
        } else {
          this.doubleTapTimer = setTimeout(function() {
            _this.$emit("close");
            _this.doubleTapTimer = null;
          }, TAP_TIME);
        }
      }
    },
    onLoad: function onLoad2(event) {
      var _event$target = event.target, naturalWidth = _event$target.naturalWidth, naturalHeight = _event$target.naturalHeight;
      this.imageRatio = naturalHeight / naturalWidth;
    }
  },
  render: function render8() {
    var h = arguments[0];
    var imageSlots = {
      loading: function loading2() {
        return h(Loading$1, {
          "attrs": {
            "type": "spinner"
          }
        });
      }
    };
    return h(SwipeItem, {
      "class": bem$r("swipe-item")
    }, [h(Image$1, {
      "attrs": {
        "src": this.src,
        "fit": "contain"
      },
      "class": bem$r("image", {
        vertical: this.vertical
      }),
      "style": this.imageStyle,
      "scopedSlots": imageSlots,
      "on": {
        "load": this.onLoad
      }
    })]);
  }
};
var VueImagePreview = createComponent$r({
  mixins: [TouchMixin, PopupMixin({
    skipToggleEvent: true
  }), BindEventMixin(function(bind2) {
    bind2(window, "resize", this.resize, true);
    bind2(window, "orientationchange", this.resize, true);
  })],
  props: {
    className: null,
    closeable: Boolean,
    asyncClose: Boolean,
    overlayStyle: Object,
    showIndicators: Boolean,
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loop: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: true
    },
    minZoom: {
      type: [Number, String],
      default: 1 / 3
    },
    maxZoom: {
      type: [Number, String],
      default: 3
    },
    transition: {
      type: String,
      default: "van-fade"
    },
    showIndex: {
      type: Boolean,
      default: true
    },
    swipeDuration: {
      type: [Number, String],
      default: 300
    },
    startPosition: {
      type: [Number, String],
      default: 0
    },
    overlayClass: {
      type: String,
      default: bem$r("overlay")
    },
    closeIcon: {
      type: String,
      default: "clear"
    },
    closeOnPopstate: {
      type: Boolean,
      default: true
    },
    closeIconPosition: {
      type: String,
      default: "top-right"
    }
  },
  data: function data10() {
    return {
      active: 0,
      rootWidth: 0,
      rootHeight: 0,
      doubleClickTimer: null
    };
  },
  mounted: function mounted5() {
    this.resize();
  },
  watch: {
    startPosition: "setActive",
    value: function value(val) {
      var _this = this;
      if (val) {
        this.setActive(+this.startPosition);
        this.$nextTick(function() {
          _this.resize();
          _this.$refs.swipe.swipeTo(+_this.startPosition, {
            immediate: true
          });
        });
      } else {
        this.$emit("close", {
          index: this.active,
          url: this.images[this.active]
        });
      }
    }
  },
  methods: {
    resize: function resize2() {
      if (this.$el && this.$el.getBoundingClientRect) {
        var rect = this.$el.getBoundingClientRect();
        this.rootWidth = rect.width;
        this.rootHeight = rect.height;
      }
    },
    emitClose: function emitClose() {
      if (!this.asyncClose) {
        this.$emit("input", false);
      }
    },
    emitScale: function emitScale(args) {
      this.$emit("scale", args);
    },
    setActive: function setActive(active2) {
      if (active2 !== this.active) {
        this.active = active2;
        this.$emit("change", active2);
      }
    },
    genIndex: function genIndex() {
      var h = this.$createElement;
      if (this.showIndex) {
        return h("div", {
          "class": bem$r("index")
        }, [this.slots("index", {
          index: this.active
        }) || this.active + 1 + " / " + this.images.length]);
      }
    },
    genCover: function genCover() {
      var h = this.$createElement;
      var cover = this.slots("cover");
      if (cover) {
        return h("div", {
          "class": bem$r("cover")
        }, [cover]);
      }
    },
    genImages: function genImages() {
      var _this2 = this;
      var h = this.$createElement;
      return h(Swipe, {
        "ref": "swipe",
        "attrs": {
          "lazyRender": true,
          "loop": this.loop,
          "duration": this.swipeDuration,
          "initialSwipe": this.startPosition,
          "showIndicators": this.showIndicators,
          "indicatorColor": "white"
        },
        "class": bem$r("swipe"),
        "on": {
          "change": this.setActive
        }
      }, [this.images.map(function(image) {
        return h(ImagePreviewItem, {
          "attrs": {
            "src": image,
            "show": _this2.value,
            "active": _this2.active,
            "maxZoom": _this2.maxZoom,
            "minZoom": _this2.minZoom,
            "rootWidth": _this2.rootWidth,
            "rootHeight": _this2.rootHeight
          },
          "on": {
            "scale": _this2.emitScale,
            "close": _this2.emitClose
          }
        });
      })]);
    },
    genClose: function genClose() {
      var h = this.$createElement;
      if (this.closeable) {
        return h(_Icon, {
          "attrs": {
            "role": "button",
            "name": this.closeIcon
          },
          "class": bem$r("close-icon", this.closeIconPosition),
          "on": {
            "click": this.emitClose
          }
        });
      }
    },
    onClosed: function onClosed2() {
      this.$emit("closed");
    },
    swipeTo: function swipeTo2(index2, options) {
      if (this.$refs.swipe) {
        this.$refs.swipe.swipeTo(index2, options);
      }
    }
  },
  render: function render9() {
    var h = arguments[0];
    return h("transition", {
      "attrs": {
        "name": this.transition
      },
      "on": {
        "afterLeave": this.onClosed
      }
    }, [this.shouldRender ? h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "class": [bem$r(), this.className]
    }, [this.genClose(), this.genImages(), this.genIndex(), this.genCover()]) : null]);
  }
});
var instance$3;
var defaultConfig = {
  loop: true,
  value: true,
  images: [],
  maxZoom: 3,
  minZoom: 1 / 3,
  onClose: null,
  onChange: null,
  className: "",
  showIndex: true,
  closeable: false,
  closeIcon: "clear",
  asyncClose: false,
  transition: "van-fade",
  getContainer: "body",
  overlayStyle: null,
  startPosition: 0,
  swipeDuration: 300,
  showIndicators: false,
  closeOnPopstate: true,
  closeIconPosition: "top-right"
};
var initInstance = function initInstance2() {
  instance$3 = new (Vue$1.extend(VueImagePreview))({
    el: document.createElement("div")
  });
  document.body.appendChild(instance$3.$el);
  instance$3.$on("change", function(index2) {
    if (instance$3.onChange) {
      instance$3.onChange(index2);
    }
  });
  instance$3.$on("scale", function(data22) {
    if (instance$3.onScale) {
      instance$3.onScale(data22);
    }
  });
};
var ImagePreview$1 = function ImagePreview(images, startPosition) {
  if (startPosition === void 0) {
    startPosition = 0;
  }
  if (isServer$3) {
    return;
  }
  if (!instance$3) {
    initInstance();
  }
  var options = Array.isArray(images) ? {
    images,
    startPosition
  } : images;
  _extends$o(instance$3, defaultConfig, options);
  instance$3.$once("input", function(show3) {
    instance$3.value = show3;
  });
  instance$3.$once("closed", function() {
    instance$3.images = [];
  });
  if (options.onClose) {
    instance$3.$off("close");
    instance$3.$once("close", options.onClose);
  }
  return instance$3;
};
ImagePreview$1.Component = VueImagePreview;
ImagePreview$1.install = function() {
  Vue$1.use(VueImagePreview);
};
var _ImagePreview = ImagePreview$1;
var _createNamespace$n = createNamespace("popup"), createComponent$n = _createNamespace$n[0], bem$n = _createNamespace$n[1];
var _Popup = createComponent$n({
  mixins: [PopupMixin()],
  props: {
    round: Boolean,
    duration: [Number, String],
    closeable: Boolean,
    transition: String,
    safeAreaInsetBottom: Boolean,
    closeIcon: {
      type: String,
      default: "cross"
    },
    closeIconPosition: {
      type: String,
      default: "top-right"
    },
    position: {
      type: String,
      default: "center"
    },
    overlay: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;
    var createEmitter = function createEmitter2(eventName) {
      return function(event) {
        return _this.$emit(eventName, event);
      };
    };
    this.onClick = createEmitter("click");
    this.onOpened = createEmitter("opened");
    this.onClosed = createEmitter("closed");
  },
  methods: {
    onClickCloseIcon: function onClickCloseIcon(event) {
      this.$emit("click-close-icon", event);
      this.close();
    }
  },
  render: function render10() {
    var _bem;
    var h = arguments[0];
    if (!this.shouldRender) {
      return;
    }
    var round = this.round, position = this.position, duration = this.duration;
    var isCenter = position === "center";
    var transitionName = this.transition || (isCenter ? "van-fade" : "van-popup-slide-" + position);
    var style6 = {};
    if (isDef$1(duration)) {
      var key2 = isCenter ? "animationDuration" : "transitionDuration";
      style6[key2] = duration + "s";
    }
    return h("transition", {
      "attrs": {
        "appear": this.transitionAppear,
        "name": transitionName
      },
      "on": {
        "afterEnter": this.onOpened,
        "afterLeave": this.onClosed
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "style": style6,
      "class": bem$n((_bem = {
        round
      }, _bem[position] = position, _bem["safe-area-inset-bottom"] = this.safeAreaInsetBottom, _bem)),
      "on": {
        "click": this.onClick
      }
    }, [this.slots(), this.closeable && h(_Icon, {
      "attrs": {
        "role": "button",
        "tabindex": "0",
        "name": this.closeIcon
      },
      "class": bem$n("close-icon", this.closeIconPosition),
      "on": {
        "click": this.onClickCloseIcon
      }
    })])]);
  }
});
var render$R = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "preview-popup"
  }, [_c("van-popup", {
    attrs: {
      "position": "right"
    },
    on: {
      "closed": _vm.closed
    },
    model: {
      value: _vm.show,
      callback: function($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c("div", {
    staticClass: "preview-popup__container"
  }, [_c("div", {
    staticClass: "header",
    on: {
      "click": function($event) {
        _vm.show = false;
      }
    }
  }, [_c("svg-icon", {
    staticStyle: {
      "float": "left",
      "margin-top": "14px",
      "margin-left": "6px"
    },
    attrs: {
      "icon-class": "back"
    }
  }), _vm._v(" " + _vm._s(_vm.fileName) + " ")], 1), _vm.type === "video" ? [_c("div", {
    staticClass: "showVideo"
  }, [_c("video", {
    attrs: {
      "src": "" + _vm.url,
      "controls": "controls",
      "controlsList": "nodownload"
    }
  }, [_vm._v("\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301 video \u6807\u7B7E\u3002")])])] : [_c("div", {
    staticClass: "iframe"
  }, [_c("iframe", {
    attrs: {
      "src": _vm.url,
      "frameborder": "0",
      "height": "100%",
      "width": "100%"
    }
  })])]], 2)])], 1);
};
var staticRenderFns$Q = [];
render$R._withStripped = true;
var popup_vue_vue_type_style_index_0_scope_true_lang$1 = "";
const __vue2_script$R = {
  name: "PreviewPopup",
  components: {
    [_Popup.name]: _Popup
  },
  props: {
    url: {
      type: String,
      default: ""
    },
    fileName: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "file"
    }
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    closed() {
      this.$emit("close");
    }
  }
};
const __cssModules$R = {};
var __component__$R = /* @__PURE__ */ normalizeComponent(__vue2_script$R, render$R, staticRenderFns$Q, false, __vue2_injectStyles$R, null, null, null);
function __vue2_injectStyles$R(context2) {
  for (let o in __cssModules$R) {
    this[o] = __cssModules$R[o];
  }
}
__component__$R.options.__file = "packages/op-file-upload/src/mobile/components/preview/popup.vue";
var Popup$2 = /* @__PURE__ */ function() {
  return __component__$R.exports;
}();
function CreateVueFunc(component, opts = {}) {
  const Construtor = Vue$1.extend(component);
  const {
    router,
    store
  } = opts;
  const CreateFunc = (options) => {
    let instance2 = null;
    const _params = {
      propsData: options
    };
    if (router) {
      _params.router = router;
    }
    if (store) {
      _params.store = store;
    }
    instance2 = new Construtor(_params);
    instance2.vm = instance2.$mount();
    document.body.appendChild(instance2.vm.$el);
    instance2.vm.$on("close", () => {
      document.body.removeChild(instance2.vm.$el);
      instance2.vm.$destroy();
    });
    return new Promise((resolve) => {
      instance2.vm.$on("returnValue", (val) => {
        resolve(val);
      });
    });
  };
  return CreateFunc;
}
var PreviewPopup = CreateVueFunc(Popup$2);
var render$Q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-mobile-wall-list"
  }, _vm._l(_vm.value, function(item, index2) {
    return _c("div", {
      key: index2,
      staticClass: "list",
      style: {
        width: _vm.uploadSize + "px",
        height: _vm.uploadSize + "px"
      }
    }, [_c("div", {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: item.uploading,
        expression: "item.uploading"
      }],
      staticClass: "item-view",
      attrs: {
        "element-loading-text": "\u4E0A\u4F20\u4E2D",
        "element-loading-spinner": "el-icon-loading"
      }
    }, [_vm.fileUploadBase.judgSuffix(item) === "IMG" ? _c("img", {
      key: index2,
      staticClass: "item-img",
      attrs: {
        "src": _vm.fileUploadBase.handleSrc(item, {
          compress: true
        })
      },
      on: {
        "click": function($event) {
          return _vm.handlePreviewImg(item);
        }
      }
    }) : _vm.fileUploadBase.judgSuffix(item) === "VIDEO" ? _c("div", {
      staticClass: "item-video",
      on: {
        "click": function($event) {
          return _vm.handlePreviewFile(item, "video");
        }
      }
    }, [_c("svg-icon", {
      attrs: {
        "icon-class": "video"
      }
    })], 1) : _vm.fileUploadBase.judgSuffix(_vm.fileUploadBase.handleSrc(item)) !== "VIDEO" ? _c("div", {
      staticClass: "item-file",
      on: {
        "click": function($event) {
          return _vm.handlePreviewFile(item, "file");
        }
      }
    }, [_c("svg-icon", {
      attrs: {
        "icon-class": "file"
      }
    })], 1) : _vm._e()]), !item.uploading ? [_c("div", {
      staticClass: "item-name",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleFileNameClick(item, index2);
        }
      }
    }, [_c("div", {
      staticClass: "op-nowrap op-pointer"
    }, [_vm._v(_vm._s(_vm.fileUploadBase.handleName(item)))])]), _c("div", {
      staticClass: "item-btn-group"
    }, [_vm.isCanDelete(item) ? _c("div", {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deleteFile(index2);
        }
      }
    }, [_c("svg-icon", {
      staticClass: "icons",
      attrs: {
        "icon-class": "close"
      }
    })], 1) : _vm._e()])] : _vm._e()], 2);
  }), 0);
};
var staticRenderFns$P = [];
render$Q._withStripped = true;
var wallList_vue_vue_type_style_index_0_scope_true_lang = "";
const __vue2_script$Q = {
  name: "OpWallListItem",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    fileUploadBase: {
      type: Object,
      default: () => {
        return {};
      }
    },
    uploadSize: {
      type: String,
      default: "108px"
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    isDownload: {
      type: Boolean,
      default: false
    },
    onFileNameClick: {
      type: [Function, null],
      default: null
    }
  },
  data() {
    return {
      showViewer: false,
      viewerIndex: 0
    };
  },
  computed: {
    imgList() {
      return (this.value || []).filter((item) => this.fileUploadBase.judgSuffix(item) === "IMG");
    },
    hasOnFileNameClickFunction() {
      return this.onFileNameClick && typeof this.onFileNameClick === "function";
    }
  },
  methods: {
    isCanDelete(item) {
      if (item.hasOwnProperty("isDelete")) {
        return item.isDelete;
      }
      return this.isDelete;
    },
    handlePreviewImg(item) {
      const index2 = this.imgList.findIndex((i) => i.ossKey === item.ossKey);
      _ImagePreview({
        images: this.imgList.map((img) => img.url.indexOf("http") !== -1 ? img.url : `${baseUrlInst.getBaseUrl().cdnPath}${img.path}`),
        startPosition: index2
      });
    },
    handlePreviewFile(item, type) {
      let _url = type === "file" ? this.fileUploadBase.openPreview(item, false) : this.fileUploadBase.handleSrc(item);
      const _name = this.fileUploadBase.handleName(item);
      PreviewPopup({
        url: _url,
        fileName: _name,
        type
      });
    },
    deleteFile(index2) {
      let newValue = this.value;
      const currentFile = newValue[index2];
      newValue.splice(index2, 1);
      this.$emit("onRemove", currentFile, newValue);
      this.$emit("input", newValue);
    },
    handleFileNameClick(item, index2) {
      if (this.hasOnFileNameClickFunction) {
        this.onFileNameClick(this.value[index2], index2);
      }
    }
  }
};
const __cssModules$Q = {};
var __component__$Q = /* @__PURE__ */ normalizeComponent(__vue2_script$Q, render$Q, staticRenderFns$P, false, __vue2_injectStyles$Q, null, null, null);
function __vue2_injectStyles$Q(context2) {
  for (let o in __cssModules$Q) {
    this[o] = __cssModules$Q[o];
  }
}
__component__$Q.options.__file = "packages/op-file-upload/src/mobile/components/wall-list.vue";
var WallList = /* @__PURE__ */ function() {
  return __component__$Q.exports;
}();
var isWeb = typeof window !== "undefined" && "onload" in window;
typeof process !== "undefined" && !!(process.versions && process.versions.node);
typeof WXEnvironment !== "undefined" && WXEnvironment.platform !== "Web";
var isMiniApp = typeof my !== "undefined" && my !== null && typeof my.alert !== "undefined";
var isByteDanceMicroApp = typeof tt !== "undefined" && tt !== null && typeof tt.showToast !== "undefined";
var isBaiduSmartProgram = typeof swan !== "undefined" && swan !== null && typeof swan.showToast !== "undefined";
var isKuaiShouMiniProgram = typeof ks !== "undefined" && ks !== null && typeof ks.showToast !== "undefined";
var isWeChatMiniProgram = !isByteDanceMicroApp && typeof wx !== "undefined" && wx !== null && (typeof wx.request !== "undefined" || typeof wx.miniProgram !== "undefined");
isMiniApp && isWeb && my.isFRM;
var ua = typeof navigator === "object" ? navigator.userAgent || navigator.swuserAgent : "";
/.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(ua) && isWeb && typeof WindVane !== "undefined" && typeof WindVane.call !== "undefined";
function isUndef$2(type) {
  return type === "undefined";
}
var isDingdingMiniapp$2 = !isUndef$2(typeof dd) && dd !== null && !isUndef$2(typeof dd.alert);
var CONTAINER_NAME$3 = {
  WECHAT: "wechatMiniProgram",
  ALIPAY: "aliMiniApp",
  BYTE: "bytedanceMicroApp",
  WEB: "web",
  BAIDU: "baiduSmartProgram",
  KWAI: "kuaishouMiniProgram"
};
function _extends$l() {
  _extends$l = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$l.apply(this, arguments);
}
function promisify$5(api2) {
  return function(arg) {
    return new Promise(function(resolve, reject) {
      var promisifyArg = arg;
      api2(_extends$l({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === "function") {
            promisifyArg.success(res);
          }
          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === "function") {
            promisifyArg.onSuccess(res);
          }
          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === "function") {
            promisifyArg.fail(res);
          }
          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === "function") {
            promisifyArg.onFail(res);
          }
          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === "function") {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === "function") {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}
var _excluded$3 = ["_ext"];
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends$k() {
  _extends$k = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$k.apply(this, arguments);
}
var styleIn$3 = function styleIn(options, baseName) {
  var _ref = options || {}, _ref$_ext = _ref._ext, _ext = _ref$_ext === void 0 ? {} : _ref$_ext, rest = _objectWithoutPropertiesLoose$3(_ref, _excluded$3);
  return _extends$k({}, rest, _ext[baseName] || {});
};
function _extends$j() {
  _extends$j = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$j.apply(this, arguments);
}
var normalize$3 = {
  chooseImage: function chooseImage(api2, containerName) {
    var formatResponse3 = function formatResponse4(res) {
      return _extends$j({}, res, {
        tempFiles: res.tempFiles || res.files,
        tempFilePaths: res.tempFilePaths
      });
    };
    return function(args) {
      args = styleIn$3(args, containerName);
      return promisify$5(api2)(_extends$j({}, args, {
        count: args.count || 1,
        success: function success(res) {
          args.success && args.success(formatResponse3(res));
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse3);
    };
  },
  compressImage: function compressImage(api2, containerName) {
    var formatResponse3 = function formatResponse4(res) {
      return {
        tempFilePath: res.tempFilePath || (res.filePaths || [])[0] || (res.apFilePaths || [])[0] || ""
      };
    };
    return function(args) {
      args = styleIn$3(args, containerName);
      return promisify$5(api2)(_extends$j({}, args, {
        success: function success(res) {
          args.success && args.success(formatResponse3(res));
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse3);
    };
  },
  getImageInfo: function getImageInfo(api2, containerName) {
    return function(args) {
      return promisify$5(api2)(styleIn$3(args, containerName));
    };
  },
  previewImage: function previewImage(api2, containerName) {
    return function(args) {
      return promisify$5(api2)(styleIn$3(args, containerName));
    };
  },
  saveImage: function saveImage(api2, containerName) {
    return function(args) {
      return promisify$5(api2)(styleIn$3(args, containerName));
    };
  }
};
var chooseImage$b = normalize$3.chooseImage(function(args) {
  return isDingdingMiniapp$2 ? dd.chooseImage(args) : my.chooseImage(args);
}, CONTAINER_NAME$3.ALIPAY);
var chooseImage$c = chooseImage$b;
var compressImage$a = normalize$3.compressImage(function(args) {
  if (isDingdingMiniapp$2) {
    args.filePaths = [args.src];
  } else {
    args.apFilePaths = [args.src];
  }
  args && typeof args.quality === "number" && (args.compressLevel = args.quality);
  return isDingdingMiniapp$2 ? dd.compressImage(args) : my.compressImage(args);
}, CONTAINER_NAME$3.ALIPAY);
var compressImage$b = compressImage$a;
var getImageInfo$a = normalize$3.getImageInfo(function(args) {
  return isDingdingMiniapp$2 ? dd.getImageInfo(args) : my.getImageInfo(args);
}, CONTAINER_NAME$3.ALIPAY);
var getImageInfo$b = getImageInfo$a;
var previewImage$a = normalize$3.previewImage(function(args) {
  return isDingdingMiniapp$2 ? dd.previewImage(args) : my.previewImage(args);
}, CONTAINER_NAME$3.ALIPAY);
var previewImage$b = previewImage$a;
var saveImage$a = normalize$3.saveImage(function(args) {
  return isDingdingMiniapp$2 ? dd.saveImage(args) : my.saveImage(args);
}, CONTAINER_NAME$3.ALIPAY);
var saveImage$b = saveImage$a;
var aliMiniAppModule$1 = {
  chooseImage: chooseImage$c,
  compressImage: compressImage$b,
  getImageInfo: getImageInfo$b,
  previewImage: previewImage$b,
  saveImage: saveImage$b
};
var constant$1 = {};
constant$1.__esModule = true;
constant$1.CONTAINER_NAME = void 0;
var CONTAINER_NAME$2 = {
  WECHAT: "wechatMiniProgram",
  ALIPAY: "aliMiniApp",
  BYTE: "bytedanceMicroApp",
  WEB: "web",
  BAIDU: "baiduSmartProgram",
  KWAI: "kuaishouMiniProgram"
};
constant$1.CONTAINER_NAME = CONTAINER_NAME$2;
var common$1 = {};
var promisify$4 = {};
promisify$4.__esModule = true;
promisify$4.promisify = promisify$3;
function _extends$i() {
  _extends$i = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$i.apply(this, arguments);
}
function promisify$3(api2) {
  return function(arg) {
    return new Promise(function(resolve, reject) {
      var promisifyArg = arg;
      api2(_extends$i({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === "function") {
            promisifyArg.success(res);
          }
          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === "function") {
            promisifyArg.onSuccess(res);
          }
          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === "function") {
            promisifyArg.fail(res);
          }
          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === "function") {
            promisifyArg.onFail(res);
          }
          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === "function") {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === "function") {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}
var styleOptions$1 = {};
styleOptions$1.__esModule = true;
styleOptions$1.styleIn = styleOptions$1.styleOut = void 0;
var _excluded$2 = ["_ext"];
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends$h() {
  _extends$h = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$h.apply(this, arguments);
}
var styleOut$1 = function styleOut(output, originalInput, originalOutput) {
  return _extends$h({}, output, {
    _original: {
      input: _extends$h({}, originalInput),
      output: _extends$h({}, originalOutput)
    }
  });
};
styleOptions$1.styleOut = styleOut$1;
var styleIn$2 = function styleIn2(options, baseName) {
  var _ref = options || {}, _ref$_ext = _ref._ext, _ext = _ref$_ext === void 0 ? {} : _ref$_ext, rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$2);
  return _extends$h({}, rest, _ext[baseName] || {});
};
styleOptions$1.styleIn = styleIn$2;
common$1.__esModule = true;
common$1.normalize = void 0;
var _promisify$1 = promisify$4;
var _styleOptions$1 = styleOptions$1;
function _extends$g() {
  _extends$g = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$g.apply(this, arguments);
}
var normalize$2 = {
  chooseVideo: function chooseVideo(api2, containerName) {
    var formatResponse3 = function formatResponse4(res) {
      return _extends$g({}, res, {
        tempFilePath: res.tempFilePath || res.filePath
      });
    };
    return function(args) {
      args = (0, _styleOptions$1.styleIn)(args, containerName);
      return (0, _promisify$1.promisify)(api2)(_extends$g({}, args, {
        success: function success(res) {
          args.success && args.success(formatResponse3(res));
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse3);
    };
  },
  chooseMedia: function chooseMedia(api2, containerName) {
    var formatResponse3 = function formatResponse4(res) {
      return _extends$g({}, res, {
        tempFiles: (res.tempFiles || res.files).map(function(item) {
          return _extends$g({}, item, {
            tempFilePath: item.tempFilePath || item.path
          });
        })
      });
    };
    return function(args) {
      if (args === void 0) {
        args = {};
      }
      args = (0, _styleOptions$1.styleIn)(_extends$g({
        count: 9,
        sizeType: ["original", "compressed"],
        sourceType: ["camera", "album"],
        mediaType: ["image", "video"],
        maxDuration: 60
      }, args), containerName);
      return (0, _promisify$1.promisify)(api2)(_extends$g({}, args, {
        success: function success(res) {
          args.success && args.success(formatResponse3(res));
        },
        fail: function fail(res) {
          args.fail && args.fail(res);
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse3);
    };
  }
};
common$1.normalize = normalize$2;
var default_1$1 = void 0;
var _constant$1 = constant$1;
var _common$1 = common$1;
function inputCreateAndAppend$1(multiple2, accept) {
  var inputElement = document.createElement("INPUT");
  inputElement.name = "file";
  inputElement.id = "input-" + Math.random() * 1e8;
  inputElement.type = "file";
  multiple2 && inputElement.setAttribute("multiple", "multiple");
  inputElement.style.display = "none";
  accept && inputElement.setAttribute("accept", accept);
  document.body.appendChild(inputElement);
  return inputElement;
}
var chooseMedia$d = _common$1.normalize.chooseMedia(function(args) {
  if (args === void 0) {
    args = {};
  }
  var _args = args, _args$count = _args.count, count3 = _args$count === void 0 ? 9 : _args$count, _args$success = _args.success, success = _args$success === void 0 ? function() {
  } : _args$success, _args$fail = _args.fail, fail = _args$fail === void 0 ? function() {
  } : _args$fail, _args$complete = _args.complete, complete = _args$complete === void 0 ? function() {
  } : _args$complete;
  try {
    var inputElement = inputCreateAndAppend$1(count3 > 1, args.accept);
    var files = [];
    inputElement.addEventListener("change", function(e) {
      files = e.target.files && Array.from(e.target.files).slice(0, count3);
      var res = {
        tempFiles: files.map(function(file) {
          return {
            tempFilePath: window.URL.createObjectURL(file),
            size: file.size
          };
        }),
        files
      };
      success(res);
      complete(res);
      inputElement.remove && inputElement.remove();
    }, false);
    var MouseEvents = document.createEvent("MouseEvents");
    MouseEvents.initEvent("click", true, true);
    inputElement.dispatchEvent(MouseEvents);
  } catch (e) {
    fail(e);
    complete(e);
  }
}, _constant$1.CONTAINER_NAME.WEB);
var _default$1 = chooseMedia$d;
default_1$1 = _default$1;
var chooseImage$9 = normalize$3.chooseImage(function(args) {
  if (args === void 0) {
    args = {};
  }
  var _args = args, _args$count = _args.count, count3 = _args$count === void 0 ? 1 : _args$count, _args$success = _args.success, success = _args$success === void 0 ? function() {
  } : _args$success, _args$fail = _args.fail, fail = _args$fail === void 0 ? function() {
  } : _args$fail, _args$complete = _args.complete, complete = _args$complete === void 0 ? function() {
  } : _args$complete;
  default_1$1({
    count: count3,
    accept: "image/*"
  }).then(function(res) {
    var result = {
      tempFilePaths: res.tempFiles.map(function(item) {
        return item.tempFilePath;
      }),
      tempFiles: res.tempFiles.map(function(item) {
        return {
          path: item.tempFilePath,
          size: item.size
        };
      }),
      files: res.files
    };
    success(result);
    complete(result);
  }).catch(function(e) {
    fail(e);
    complete(e);
  });
}, CONTAINER_NAME$3.WEB);
var chooseImage$a = chooseImage$9;
var compressImage$8 = function compressImage2() {
  throw new Error("Uni API: compressImage\u4E0D\u652F\u6301");
};
var compressImage$9 = compressImage$8;
var getImageInfo$8 = normalize$3.getImageInfo(function(args) {
  var image = new Image();
  image.src = args.src;
  if (image.naturalWidth) {
    var res = {
      width: image.naturalWidth,
      height: image.naturalHeight,
      path: args.src
    };
    args.success(res);
    args.complete(res);
  } else {
    var setImageInfo = function setImageInfo2() {
      var res2 = {
        width: image.width,
        height: image.height,
        path: args.src
      };
      args.success(res2);
      args.complete(res2);
    };
    if (image.complete) {
      setImageInfo();
    } else {
      var checkTimer = null;
      var clear2 = function clear3() {
        clearInterval(checkTimer);
        checkTimer = null;
      };
      checkTimer = setInterval(function() {
        if (image.width > 0 || image.height > 0) {
          setImageInfo();
          clear2();
        }
      }, 40);
      image.onload = function() {
        if (checkTimer) {
          setImageInfo();
          clear2();
        }
      };
      image.onabort = image.onerror = function(e) {
        args.fail(e);
        args.complete(e);
        clear2();
      };
    }
  }
}, CONTAINER_NAME$3.WEB);
var getImageInfo$9 = getImageInfo$8;
var clsPrefix = "__universal_preview_image";
var styles = ("." + clsPrefix + " {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  text-align: center;\n  background: #000;\n  box-sizing: border-box;\n  outline: none;\n  overflow: hidden;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix + "_pageindex {\n  position: absolute;\n  top: 12px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  color: #fff;\n  font-size: 16px;\n  z-index: 2;\n}\n." + clsPrefix + "_swiper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n." + clsPrefix + "_item {\n  max-height: 70%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 100%;\n  position: relative;\n  transition-property: transform;\n  overflow: hidden;\n}\n." + clsPrefix + "_img {\n  width: 100%;\n}\n@keyframes " + clsPrefix + "_fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes " + clsPrefix + "_fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}").replace(/\n/g, "");
var styleElement = null;
var previewImage$8 = normalize$3.previewImage(function(args) {
  var _ref = args || {}, _ref$urls = _ref.urls, urls = _ref$urls === void 0 ? [] : _ref$urls;
  var _ref2 = args || {}, _ref2$current = _ref2.current, current = _ref2$current === void 0 ? 0 : _ref2$current;
  if (Object.prototype.toString.call(urls) !== "[object Array]") {
    throw new Error("the arguments must contain urls that type is a Array");
  }
  if (urls.length <= 0) {
    throw new Error("the urls`s length is at least 1");
  }
  if (!Number.isSafeInteger(current)) {
    throw new Error("the current must be a safe integer");
  }
  current = Math.min(Math.max(current, 0), urls.length - 1);
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.innerHTML = styles;
    document.body.appendChild(styleElement);
  }
  var containerEle = document.createElement("div");
  containerEle.className = clsPrefix;
  containerEle.style.animationName = clsPrefix + "_fadeIn";
  containerEle.addEventListener("click", function() {
    containerEle && (containerEle.style.animationName = clsPrefix + "_fadeOut");
    setTimeout(function() {
      containerEle && document.body.removeChild(containerEle);
      containerEle = null;
    }, 300);
  });
  var pageIndexEle = document.createElement("div");
  pageIndexEle.className = clsPrefix + "_pageindex";
  pageIndexEle.innerText = current + 1 + "/" + urls.length;
  containerEle.appendChild(pageIndexEle);
  var swiperEle = document.createElement("div");
  swiperEle.className = clsPrefix + "_swiper";
  var damp = 1;
  var clientWidth = document.documentElement.clientWidth;
  var startX = 0;
  swiperEle.addEventListener("touchstart", function(e) {
    if (e.touches.length > 1) {
      e.stopPropagation();
      e.preventDefault();
    }
    startX = e.targetTouches[0].pageX;
  });
  swiperEle.addEventListener("touchmove", function(e) {
    if (e.touches.length > 1) {
      e.stopPropagation();
      e.preventDefault();
    }
    var moveX = e.targetTouches[0].pageX - startX;
    swiperEle.style.transform = "translateX(" + (-clientWidth * current + moveX * damp) + "px)";
  });
  swiperEle.addEventListener("touchend", function(e) {
    var endX = e.changedTouches[0].pageX - startX;
    if (Math.abs(endX * damp) > clientWidth / 5) {
      current = endX < 0 ? Math.min(current + 1, urls.length - 1) : Math.max(current - 1, 0);
    }
    pageIndexEle.innerText = current + 1 + "/" + urls.length;
    var transitionDuration = 300;
    swiperEle.style.transitionDuration = transitionDuration + "ms";
    swiperEle.style.transform = "translateX(" + -clientWidth * current + "px)";
    setTimeout(function() {
      swiperEle.style.transitionDuration = "0ms";
    }, transitionDuration);
  });
  swiperEle.style.transform = "translateX(" + -clientWidth * current + "px)";
  containerEle.appendChild(swiperEle);
  urls.forEach(function(url2) {
    var swiperItemEle = document.createElement("div");
    swiperItemEle.className = clsPrefix + "_item";
    swiperItemEle.addEventListener("click", function(e) {
      e.stopPropagation();
      containerEle && (containerEle.style.animationName = clsPrefix + "_fadeOut");
      setTimeout(function() {
        containerEle && document.body.removeChild(containerEle);
        containerEle = null;
      }, 300);
    });
    swiperEle.appendChild(swiperItemEle);
    var imageEle = document.createElement("img");
    imageEle.className = clsPrefix + "_img";
    imageEle.src = url2;
    swiperItemEle.appendChild(imageEle);
    swiperItemEle.addEventListener("touchstart", function(e) {
      if (e.touches.length > 1) {
        e.stopPropagation();
        e.preventDefault();
        var point1 = e.touches[0];
        var point2 = e.touches[1];
        var xLen = Math.abs(point2.pageX - point1.pageX);
        var yLen = Math.abs(point2.pageY - point1.pageY);
        swiperItemEle.touchDistance = Math.sqrt(xLen * xLen + yLen * yLen);
      } else {
        swiperItemEle.touched = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };
      }
    });
    swiperItemEle.addEventListener("touchmove", function(e) {
      if (e.touches.length > 1) {
        e.stopPropagation();
        e.preventDefault();
        var xLen = Math.abs(e.touches[0].pageX - e.touches[1].pageX);
        var yLen = Math.abs(e.touches[1].pageY - e.touches[1].pageY);
        var touchDistance = Math.sqrt(xLen * xLen + yLen * yLen);
        if (swiperItemEle.touchDistance) {
          var pinchScale = (swiperItemEle.previousPinchScale || 1) + (touchDistance - swiperItemEle.touchDistance) / swiperItemEle.touchDistance;
          var imageScale = Math.max(1, pinchScale);
          imageEle.style.transform = "scale(" + imageScale + ")";
          swiperItemEle.previousPinchScale = imageScale;
        }
        swiperItemEle.touchDistance = touchDistance;
      } else if (swiperItemEle.previousPinchScale > 1) {
        e.stopPropagation();
        var x = (swiperItemEle.preX || 0) + (e.touches[0].pageX - swiperItemEle.touched.x);
        var y = (swiperItemEle.preY || 0) + (e.touches[0].pageY - swiperItemEle.touched.y);
        imageEle.style.transform = "scale(" + swiperItemEle.previousPinchScale + ") translate(" + x + "px, " + y + "px)";
        swiperItemEle.preX = x;
        swiperItemEle.preY = y;
        swiperItemEle.touched = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };
      }
    });
  });
  document.body.appendChild(containerEle);
}, CONTAINER_NAME$3.WEB);
var previewImage$9 = previewImage$8;
var saveImage$8 = function saveImage2() {
  throw new Error("Uni API: saveImage\u4E0D\u652F\u6301");
};
var saveImage$9 = saveImage$8;
var webModule$1 = {
  chooseImage: chooseImage$a,
  compressImage: compressImage$9,
  getImageInfo: getImageInfo$9,
  previewImage: previewImage$9,
  saveImage: saveImage$9
};
var chooseImage$7 = normalize$3.chooseImage(function(args) {
  return wx.chooseImage(args);
}, CONTAINER_NAME$3.WECHAT);
var chooseImage$8 = chooseImage$7;
var compressImage$6 = normalize$3.compressImage(function(args) {
  args && typeof args.quality === "number" && (args.quality = args.quality * 33);
  return wx.compressImage(args);
}, CONTAINER_NAME$3.WECHAT);
var compressImage$7 = compressImage$6;
var getImageInfo$6 = normalize$3.getImageInfo(function(args) {
  return wx.getImageInfo(args);
}, CONTAINER_NAME$3.WECHAT);
var getImageInfo$7 = getImageInfo$6;
function _extends$f() {
  _extends$f = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$f.apply(this, arguments);
}
var previewImage$6 = normalize$3.previewImage(function(args) {
  wx.previewImage(_extends$f({}, args, {
    current: typeof args.current === "number" ? args.urls[args.current] : args.urls[0]
  }));
}, CONTAINER_NAME$3.WECHAT);
var previewImage$7 = previewImage$6;
function _extends$e() {
  _extends$e = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$e.apply(this, arguments);
}
var saveImage$6 = normalize$3.saveImage(function(args) {
  wx.saveImageToPhotosAlbum(_extends$e({}, args, {
    filePath: args.url
  }));
}, CONTAINER_NAME$3.WECHAT);
var saveImage$7 = saveImage$6;
var weChatModule$1 = {
  chooseImage: chooseImage$8,
  compressImage: compressImage$7,
  getImageInfo: getImageInfo$7,
  previewImage: previewImage$7,
  saveImage: saveImage$7
};
var chooseImage$5 = normalize$3.chooseImage(function(args) {
  return tt.chooseImage(args);
}, CONTAINER_NAME$3.BYTE);
var chooseImage$6 = chooseImage$5;
var compressImage$4 = normalize$3.compressImage(function(args) {
  args && typeof args.quality === "number" && (args.quality = args.quality * 33);
  return tt.compressImage(args);
}, CONTAINER_NAME$3.BYTE);
var compressImage$5 = compressImage$4;
var getImageInfo$4 = normalize$3.getImageInfo(function(args) {
  return tt.getImageInfo(args);
}, CONTAINER_NAME$3.BYTE);
var getImageInfo$5 = getImageInfo$4;
function _extends$d() {
  _extends$d = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$d.apply(this, arguments);
}
var previewImage$4 = normalize$3.previewImage(function(args) {
  tt.previewImage(_extends$d({}, args, {
    current: typeof args.current === "number" ? args.urls[args.current] : args.urls[0]
  }));
}, CONTAINER_NAME$3.BYTE);
var previewImage$5 = previewImage$4;
function _extends$c() {
  _extends$c = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$c.apply(this, arguments);
}
var saveImage$4 = normalize$3.saveImage(function(args) {
  tt.saveImageToPhotosAlbum(_extends$c({}, args, {
    filePath: args.url
  }));
}, CONTAINER_NAME$3.BYTE);
var saveImage$5 = saveImage$4;
var bytedanceModule$1 = {
  chooseImage: chooseImage$6,
  compressImage: compressImage$5,
  getImageInfo: getImageInfo$5,
  previewImage: previewImage$5,
  saveImage: saveImage$5
};
var chooseImage$3 = normalize$3.chooseImage(function(args) {
  return ks.chooseImage(args);
}, CONTAINER_NAME$3.KWAI);
var chooseImage$4 = chooseImage$3;
var compressImage$2 = normalize$3.compressImage(function(args) {
  args && typeof args.quality === "number" && (args.quality *= 33);
  return ks.compressImage(args);
}, CONTAINER_NAME$3.KWAI);
var compressImage$3 = compressImage$2;
var getImageInfo$2 = normalize$3.getImageInfo(function(args) {
  return ks.getImageInfo(args);
}, CONTAINER_NAME$3.KWAI);
var getImageInfo$3 = getImageInfo$2;
function _extends$b() {
  _extends$b = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$b.apply(this, arguments);
}
var previewImage$2 = normalize$3.previewImage(function(args) {
  ks.previewImage(_extends$b({}, args, {
    current: typeof args.current === "number" ? args.urls[args.current] : args.urls[0]
  }));
}, CONTAINER_NAME$3.KWAI);
var previewImage$3 = previewImage$2;
function _extends$a() {
  _extends$a = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$a.apply(this, arguments);
}
var saveImage$2 = normalize$3.saveImage(function(args) {
  ks.saveImageToPhotosAlbum(_extends$a({}, args, {
    filePath: args.url
  }));
}, CONTAINER_NAME$3.KWAI);
var saveImage$3 = saveImage$2;
var kuaiShouModule$1 = {
  chooseImage: chooseImage$4,
  compressImage: compressImage$3,
  getImageInfo: getImageInfo$3,
  previewImage: previewImage$3,
  saveImage: saveImage$3
};
var chooseImage$1 = normalize$3.chooseImage(function(args) {
  return swan.chooseImage(args);
}, CONTAINER_NAME$3.BAIDU);
var chooseImage$2 = chooseImage$1;
var compressImage3 = normalize$3.compressImage(function(args) {
  args && typeof args.quality === "number" && (args.quality *= 33);
  return swan.compressImage(args);
}, CONTAINER_NAME$3.BAIDU);
var compressImage$1 = compressImage3;
var getImageInfo2 = normalize$3.getImageInfo(function(args) {
  return swan.getImageInfo(args);
}, CONTAINER_NAME$3.BAIDU);
var getImageInfo$1 = getImageInfo2;
function _extends$9() {
  _extends$9 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$9.apply(this, arguments);
}
var previewImage2 = normalize$3.previewImage(function(args) {
  swan.previewImage(_extends$9({}, args, {
    current: typeof args.current === "number" ? args.urls[args.current] : args.urls[0]
  }));
}, CONTAINER_NAME$3.BAIDU);
var previewImage$1 = previewImage2;
function _extends$8() {
  _extends$8 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$8.apply(this, arguments);
}
var saveImage3 = normalize$3.saveImage(function(args) {
  swan.saveImageToPhotosAlbum(_extends$8({}, args, {
    filePath: args.url
  }));
}, CONTAINER_NAME$3.BAIDU);
var saveImage$1 = saveImage3;
var baiDuModule$1 = {
  chooseImage: chooseImage$2,
  compressImage: compressImage$1,
  getImageInfo: getImageInfo$1,
  previewImage: previewImage$1,
  saveImage: saveImage$1
};
var chooseImage2 = function chooseImage3(args) {
  if (isWeb) {
    return webModule$1.chooseImage(args);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule$1.chooseImage(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule$1.chooseImage(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule$1.chooseImage(args);
  } else if (isMiniApp) {
    return aliMiniAppModule$1.chooseImage(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule$1.chooseImage(args);
  } else {
    throw new Error("Uni API\uFF1AchooseImage\u6682\u4E0D\u652F\u6301");
  }
};
function isUndef$1(type) {
  return type === "undefined";
}
var isDingdingMiniapp$1 = !isUndef$1(typeof dd) && dd !== null && !isUndef$1(typeof dd.alert);
var CONTAINER_NAME$1 = {
  WECHAT: "wechatMiniProgram",
  ALIPAY: "aliMiniApp",
  BYTE: "bytedanceMicroApp",
  WEB: "web",
  BAIDU: "baiduSmartProgram",
  KWAI: "kuaishouMiniProgram"
};
function _extends$7() {
  _extends$7 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$7.apply(this, arguments);
}
function promisify$2(api2) {
  return function(arg) {
    return new Promise(function(resolve, reject) {
      var promisifyArg = arg;
      api2(_extends$7({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === "function") {
            promisifyArg.success(res);
          }
          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === "function") {
            promisifyArg.onSuccess(res);
          }
          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === "function") {
            promisifyArg.fail(res);
          }
          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === "function") {
            promisifyArg.onFail(res);
          }
          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === "function") {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === "function") {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}
var _excluded$1 = ["_ext"];
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends$6() {
  _extends$6 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$6.apply(this, arguments);
}
var styleIn$1 = function styleIn3(options, baseName) {
  var _ref = options || {}, _ref$_ext = _ref._ext, _ext = _ref$_ext === void 0 ? {} : _ref$_ext, rest = _objectWithoutPropertiesLoose$1(_ref, _excluded$1);
  return _extends$6({}, rest, _ext[baseName] || {});
};
function _extends$5() {
  _extends$5 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
var normalize$1 = {
  chooseVideo: function chooseVideo2(api2, containerName) {
    var formatResponse3 = function formatResponse4(res) {
      return _extends$5({}, res, {
        tempFilePath: res.tempFilePath || res.filePath
      });
    };
    return function(args) {
      args = styleIn$1(args, containerName);
      return promisify$2(api2)(_extends$5({}, args, {
        success: function success(res) {
          args.success && args.success(formatResponse3(res));
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse3);
    };
  },
  chooseMedia: function chooseMedia2(api2, containerName) {
    var formatResponse3 = function formatResponse4(res) {
      return _extends$5({}, res, {
        tempFiles: (res.tempFiles || res.files).map(function(item) {
          return _extends$5({}, item, {
            tempFilePath: item.tempFilePath || item.path
          });
        })
      });
    };
    return function(args) {
      if (args === void 0) {
        args = {};
      }
      args = styleIn$1(_extends$5({
        count: 9,
        sizeType: ["original", "compressed"],
        sourceType: ["camera", "album"],
        mediaType: ["image", "video"],
        maxDuration: 60
      }, args), containerName);
      return promisify$2(api2)(_extends$5({}, args, {
        success: function success(res) {
          args.success && args.success(formatResponse3(res));
        },
        fail: function fail(res) {
          args.fail && args.fail(res);
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse3);
    };
  }
};
var chooseVideo$b = normalize$1.chooseVideo(function(args) {
  return isDingdingMiniapp$1 ? dd.chooseVideo(args) : my.chooseVideo(args);
}, CONTAINER_NAME$1.ALIPAY);
var chooseVideo$c = chooseVideo$b;
var createVideoContext$6 = function(id) {
  return isDingdingMiniapp$1 ? dd.createVideoContext(id) : my.createVideoContext(id);
};
var miniappEnvApp = {};
miniappEnvApp.__esModule = true;
miniappEnvApp.isDingdingMiniapp = void 0;
function isUndef(type) {
  return type === "undefined";
}
var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);
miniappEnvApp.isDingdingMiniapp = isDingdingMiniapp;
var constant = {};
constant.__esModule = true;
constant.CONTAINER_NAME = void 0;
var CONTAINER_NAME = {
  WECHAT: "wechatMiniProgram",
  ALIPAY: "aliMiniApp",
  BYTE: "bytedanceMicroApp",
  WEB: "web",
  BAIDU: "baiduSmartProgram",
  KWAI: "kuaishouMiniProgram"
};
constant.CONTAINER_NAME = CONTAINER_NAME;
var common = {};
var promisify$1 = {};
promisify$1.__esModule = true;
promisify$1.promisify = promisify;
function _extends$4() {
  _extends$4 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
function promisify(api2) {
  return function(arg) {
    return new Promise(function(resolve, reject) {
      var promisifyArg = arg;
      api2(_extends$4({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === "function") {
            promisifyArg.success(res);
          }
          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === "function") {
            promisifyArg.onSuccess(res);
          }
          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === "function") {
            promisifyArg.fail(res);
          }
          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === "function") {
            promisifyArg.onFail(res);
          }
          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === "function") {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === "function") {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}
var styleOptions = {};
styleOptions.__esModule = true;
styleOptions.styleIn = styleOptions.styleOut = void 0;
var _excluded = ["_ext"];
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends$3() {
  _extends$3 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
var styleOut2 = function styleOut3(output, originalInput, originalOutput) {
  return _extends$3({}, output, {
    _original: {
      input: _extends$3({}, originalInput),
      output: _extends$3({}, originalOutput)
    }
  });
};
styleOptions.styleOut = styleOut2;
var styleIn4 = function styleIn5(options, baseName) {
  var _ref = options || {}, _ref$_ext = _ref._ext, _ext = _ref$_ext === void 0 ? {} : _ref$_ext, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return _extends$3({}, rest, _ext[baseName] || {});
};
styleOptions.styleIn = styleIn4;
common.__esModule = true;
common.normalize = normalize;
var _promisify = promisify$1;
var _styleOptions = styleOptions;
function _extends$2() {
  _extends$2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
var formatResponse = function formatResponse2(res) {
  return _extends$2({}, res, {
    tapIndex: res.tapIndex != void 0 ? res.tapIndex : res.index
  });
};
function normalize(api2, containerName) {
  return function(args) {
    args = (0, _styleOptions.styleIn)(args, containerName);
    return (0, _promisify.promisify)(api2)(_extends$2({}, args, {
      success: function success(res) {
        args.success && args.success(formatResponse(res));
      },
      complete: function complete(res) {
        args.complete && args.complete(res);
      }
    })).then(formatResponse);
  };
}
var default_1 = void 0;
var _miniappEnvApp = miniappEnvApp;
var _constant = constant;
var _common = common;
var showActionSheet = function showActionSheet2(args) {
  args.items = args.itemList;
  _miniappEnvApp.isDingdingMiniapp ? dd.showActionSheet(args) : my.showActionSheet(args);
};
var _default2 = (0, _common.normalize)(showActionSheet, _constant.CONTAINER_NAME.ALIPAY);
default_1 = _default2;
function _extends$1() {
  _extends$1 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var chooseMedia$b = normalize$1.chooseMedia(function(args) {
  var mediaType = args.mediaType;
  var imageFn = function imageFn2() {
    return my.chooseImage(_extends$1({}, args, {
      success: function success(res) {
        var result = {
          type: "image",
          tempFiles: res.tempFiles.map(function(i) {
            return _extends$1({}, i, {
              tempFilePath: i.path
            });
          })
        };
        args.success(result);
      }
    }));
  };
  var videoFn = function videoFn2() {
    return my.chooseVideo(_extends$1({}, args, {
      success: function success(res) {
        var result = {
          type: "video",
          tempFiles: [res]
        };
        args.success(result);
      }
    }));
  };
  if (mediaType.length === 1 && mediaType[0] === "image") {
    imageFn();
  } else if (mediaType.length === 1 && mediaType[0] === "video") {
    videoFn();
  } else {
    default_1({
      itemList: ["\u56FE\u7247", "\u89C6\u9891"]
    }).then(function(res) {
      if (res.tapIndex === 0) {
        imageFn();
      } else if (res.tapIndex === 1) {
        videoFn();
      } else {
        return Promise.reject({
          errMsg: "\u7528\u6237\u53D6\u6D88\u9009\u62E9"
        });
      }
    });
  }
}, CONTAINER_NAME$1.ALIPAY);
var chooseMedia$c = chooseMedia$b;
var aliMiniAppModule = {
  chooseVideo: chooseVideo$c,
  createVideoContext: createVideoContext$6,
  chooseMedia: chooseMedia$c
};
function inputCreateAndAppend(multiple2, accept) {
  var inputElement = document.createElement("INPUT");
  inputElement.name = "file";
  inputElement.id = "input-" + Math.random() * 1e8;
  inputElement.type = "file";
  multiple2 && inputElement.setAttribute("multiple", "multiple");
  inputElement.style.display = "none";
  accept && inputElement.setAttribute("accept", accept);
  document.body.appendChild(inputElement);
  return inputElement;
}
var chooseMedia$9 = normalize$1.chooseMedia(function(args) {
  if (args === void 0) {
    args = {};
  }
  var _args = args, _args$count = _args.count, count3 = _args$count === void 0 ? 9 : _args$count, _args$success = _args.success, success = _args$success === void 0 ? function() {
  } : _args$success, _args$fail = _args.fail, fail = _args$fail === void 0 ? function() {
  } : _args$fail, _args$complete = _args.complete, complete = _args$complete === void 0 ? function() {
  } : _args$complete;
  try {
    var inputElement = inputCreateAndAppend(count3 > 1, args.accept);
    var files = [];
    inputElement.addEventListener("change", function(e) {
      files = e.target.files && Array.from(e.target.files).slice(0, count3);
      var res = {
        tempFiles: files.map(function(file) {
          return {
            tempFilePath: window.URL.createObjectURL(file),
            size: file.size
          };
        }),
        files
      };
      success(res);
      complete(res);
      inputElement.remove && inputElement.remove();
    }, false);
    var MouseEvents = document.createEvent("MouseEvents");
    MouseEvents.initEvent("click", true, true);
    inputElement.dispatchEvent(MouseEvents);
  } catch (e) {
    fail(e);
    complete(e);
  }
}, CONTAINER_NAME$1.WEB);
var chooseMedia$a = chooseMedia$9;
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var chooseVideo$9 = normalize$1.chooseVideo(function(args) {
  if (args === void 0) {
    args = {};
  }
  var _args = args, _args$success = _args.success, success = _args$success === void 0 ? function() {
  } : _args$success, _args$fail = _args.fail, fail = _args$fail === void 0 ? function() {
  } : _args$fail, _args$complete = _args.complete, complete = _args$complete === void 0 ? function() {
  } : _args$complete;
  chooseMedia$a({
    count: 1,
    accept: "video/*"
  }).then(function(res) {
    var result = _extends({}, res.tempFiles[0], {
      files: res.files
    });
    success(result);
    complete(result);
  }).catch(function(e) {
    fail(e);
    complete(e);
  });
}, CONTAINER_NAME$1.WEB);
var chooseVideo$a = chooseVideo$9;
var createVideoContext$4 = function createVideoContext() {
  throw new Error("@uni/apis: createVideoContext\u4E0D\u652F\u6301");
};
var createVideoContext$5 = createVideoContext$4;
var webModule = {
  chooseVideo: chooseVideo$a,
  createVideoContext: createVideoContext$5,
  chooseMedia: chooseMedia$a
};
var chooseVideo$7 = normalize$1.chooseVideo(function(args) {
  return wx.chooseVideo(args);
}, CONTAINER_NAME$1.WECHAT);
var chooseVideo$8 = chooseVideo$7;
var createVideoContext$3 = function(id, context2) {
  return context2 ? wx.createVideoContext(id, context2) : wx.createVideoContext(id);
};
var chooseMedia$7 = normalize$1.chooseMedia(function(args) {
  return wx.canIUse("chooseMedia") ? wx.chooseMedia(args) : wx.chooseImage(args);
}, CONTAINER_NAME$1.WECHAT);
var chooseMedia$8 = chooseMedia$7;
var weChatModule = {
  chooseVideo: chooseVideo$8,
  createVideoContext: createVideoContext$3,
  chooseMedia: chooseMedia$8
};
var chooseVideo$5 = normalize$1.chooseVideo(function(args) {
  return tt.chooseVideo(args);
}, CONTAINER_NAME$1.BYTE);
var chooseVideo$6 = chooseVideo$5;
var createVideoContext$2 = function(id, context2) {
  return context2 ? tt.createVideoContext(id, context2) : tt.createVideoContext(id);
};
var chooseMedia$5 = normalize$1.chooseMedia(function(args) {
  return tt.chooseImage(args);
}, CONTAINER_NAME$1.BYTE);
var chooseMedia$6 = chooseMedia$5;
var bytedanceModule = {
  chooseVideo: chooseVideo$6,
  createVideoContext: createVideoContext$2,
  chooseMedia: chooseMedia$6
};
var chooseVideo$3 = normalize$1.chooseVideo(function(args) {
  return swan.chooseVideo(args);
}, CONTAINER_NAME$1.BAIDU);
var chooseVideo$4 = chooseVideo$3;
var createVideoContext$1 = function(id) {
  return swan.createVideoContext(id);
};
var chooseMedia$3 = normalize$1.chooseMedia(function(args) {
  return swan.canIUse("chooseMedia") ? swan.chooseMedia(args) : swan.chooseImage(args);
}, CONTAINER_NAME$1.BAIDU);
var chooseMedia$4 = chooseMedia$3;
var baiDuModule = {
  chooseVideo: chooseVideo$4,
  createVideoContext: createVideoContext$1,
  chooseMedia: chooseMedia$4
};
var chooseVideo$1 = normalize$1.chooseVideo(function(args) {
  return ks.chooseVideo(args);
}, CONTAINER_NAME$1.KWAI);
var chooseVideo$2 = chooseVideo$1;
var createVideoContext2 = function(id, context2) {
  return context2 ? ks.createVideoContext(id, context2) : ks.createVideoContext(id);
};
var chooseMedia$1 = normalize$1.chooseMedia(function(args) {
  return ks.canIUse("chooseMedia") ? ks.chooseMedia(args) : ks.chooseImage(args);
}, CONTAINER_NAME$1.KWAI);
var chooseMedia$2 = chooseMedia$1;
var kuaiShouModule = {
  chooseVideo: chooseVideo$2,
  createVideoContext: createVideoContext2,
  chooseMedia: chooseMedia$2
};
var chooseVideo3 = function chooseVideo4(args) {
  if (isWeb) {
    return webModule.chooseVideo(args);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.chooseVideo(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.chooseVideo(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.chooseVideo(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.chooseVideo(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.chooseVideo(args);
  } else {
    throw new Error("@uni/apis\uFF1AchooseVideo\u6682\u4E0D\u652F\u6301");
  }
};
var chooseMedia3 = function chooseMedia4(args) {
  if (isWeb) {
    return webModule.chooseMedia(args);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.chooseMedia(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.chooseMedia(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.chooseMedia(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.chooseMedia(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.chooseMedia(args);
  } else {
    throw new Error("@uni/apis\uFF1AchooseMedia\u6682\u4E0D\u652F\u6301");
  }
};
const getLocalImgData = (localId, index2, fileName) => {
  return new Promise((resolve, reject) => {
    wx.getLocalImgData({
      localId,
      success: (res) => {
        const localData = res.localData;
        const _fileName = fileName || `${dataFilter(new Date().getTime(), "YYYY-MM-DD-HH-mm-ss")}_${index2}.jpg`;
        const _file = dataURLtoFile(localData, _fileName);
        resolve(_file);
      },
      fail: (error) => {
        /* @__PURE__ */ console.log("getLocalImageData", error);
        reject(error);
      }
    });
  });
};
function wxChooseImage(count3, options = {}) {
  const {
    sourceType,
    sizeType
  } = options;
  return new Promise((resolve, reject) => {
    wx.ready(() => {
      wx.chooseImage({
        count: count3 || 9,
        sizeType: sizeType || ["original", "compressed"],
        sourceType: sourceType || ["album", "camera"],
        success: async (res) => {
          const localIds = res.localIds;
          const fileList = [];
          for (let index2 in localIds) {
            if (localIds[index2] && typeof localIds[index2] === "string") {
              const _file = await getLocalImgData(localIds[index2], index2);
              fileList.push(_file);
            }
          }
          resolve(fileList);
        },
        fail: (error) => {
          /* @__PURE__ */ console.log("chooseImage", error);
          reject(error);
        }
      });
    });
  });
}
class H5Plus {
  constructor() {
  }
  camera(noFormat) {
    return new Promise((resolve, reject) => {
      const cmr = window.plus.camera.getCamera();
      const res = cmr.supportedImageResolutions[0];
      const fmt = cmr.supportedImageFormats[0];
      const df = {
        resolution: res,
        format: fmt
      };
      if (noFormat) {
        delete df.format;
      }
      cmr.captureImage((path) => {
        resolve([path]);
      }, (error) => {
        reject({
          status: false,
          message: `captureImage\uFF1A${JSON.stringify(error)}`
        });
        if (error && error.code == 11 && error.message && error.message.toLocaleLowerCase().indexOf("permission") > -1) {
          alert("\u5F53\u524D\u5E94\u7528\u65E0\u6CD5\u8BBF\u95EE\u76F8\u673A\uFF0C\u8BF7\u5728\u624B\u673A\u8BBE\u7F6E\u4E2D\u6253\u5F00\u6B64\u5E94\u7528\u7684\u76F8\u673A\u4F7F\u7528\u6743\u9650\uFF01");
        }
      }, df);
    });
  }
  video(duration) {
    return new Promise((resolve, reject) => {
      const cmr = window.plus.camera.getCamera();
      const res = cmr.supportedImageResolutions[0];
      const fmt = cmr.supportedImageFormats[0];
      cmr.startVideoCapture((path) => {
        resolve([path]);
      }, (error) => {
        reject({
          status: false,
          message: `startVideoCapture ${JSON.stringify(error)}`
        });
        if (error && error.code == 11) {
          alert("\u5F53\u524D\u5E94\u7528\u65E0\u6CD5\u8BBF\u95EE\u76F8\u673A\uFF0C\u8BF7\u5728\u624B\u673A\u8BBE\u7F6E\u4E2D\u6253\u5F00\u6B64\u5E94\u7528\u7684\u76F8\u673A\u4F7F\u7528\u6743\u9650\uFF01");
        }
      }, {
        resolution: res,
        format: fmt,
        videoMaximumDuration: duration || 15
      });
    });
  }
  pickImg() {
    return new Promise((resolve, reject) => {
      window.plus.gallery.pick((e) => {
        resolve(e.files);
      }, (e) => {
        reject({
          status: false,
          message: `pickImg\uFF1A${JSON.stringify(e)}`
        });
      }, {
        filter: "image",
        multiple: true
      });
    });
  }
  pickVideo() {
    return new Promise((resolve, reject) => {
      window.plus.gallery.pick((e) => {
        resolve(e.files);
      }, (e) => {
        reject({
          status: false,
          message: `pickVideo\uFF1A${JSON.stringify(e)}`
        });
      }, {
        filter: "video",
        multiple: true
      });
    });
  }
}
var H5Plus$1 = new H5Plus();
class PlusUpload {
  constructor() {
  }
  compressVideo(path) {
    if (!window.plus.zip.compressVideo) {
      Promise.resolve(path);
      return;
    }
    let compressPath = "_doc/video-" + new Date().format("yyyyMMddhhmmss") + "-compress.mp4";
    return new Promise((resolve) => {
      window.plus.zip.compressVideo({
        src: path,
        filename: compressPath,
        quality: "medium"
      }, function(event) {
        resolve(event);
      }, function() {
        resolve(path);
      });
    });
  }
  async handleFileByPath(paths, compress) {
    let files = [];
    let _paths = paths;
    for (let path of _paths) {
      let newPath = path;
      if (compress) {
        const res = await this.compressVideo(path);
        if (res && res.tempFilePath) {
          newPath = res.tempFilePath;
        }
      }
      const _item = await this.getTemFile(newPath);
      if (_item.status) {
        files.push(_item.data);
      }
    }
    return files;
  }
  async appCamera(type, maxLength, duration) {
    try {
      if (type === "camera") {
        const path = await H5Plus$1.camera(true);
        return await this.handleFileByPath(path);
      } else if (type === "video") {
        const path = await H5Plus$1.video(duration);
        return await this.handleFileByPath(path, true);
      } else if (type === "pickImg") {
        const path = await H5Plus$1.pickImg();
        return await this.handleFileByPath(path);
      } else if (type === "pickVideo") {
        const path = await H5Plus$1.pickVideo();
        return await this.handleFileByPath(path, true);
      } else {
        const path = await H5Plus$1.camera(true);
        return await this.handleFileByPath(path);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
  getTemFile(url2) {
    return new Promise((resolve, reject) => {
      try {
        window.plus.io.resolveLocalFileSystemURL(url2, (entry) => {
          entry.file((file) => {
            let reader = new window.plus.io.FileReader();
            let fileReaderTime = 0;
            let fileReaderInterval = null;
            let isEnterLoadEnd = false;
            reader.onloadstart = async (e) => {
              fileReaderInterval = setInterval(() => {
                fileReaderTime++;
                if (fileReaderTime > 15 && !isEnterLoadEnd) {
                  clearInterval(fileReaderInterval);
                  reader.abort();
                  reject({
                    status: false,
                    message: "\u6587\u4EF6\u592A\u5927\uFF0C\u8BFB\u53D6\u5931\u8D25\uFF0C\u8BF7\u51CF\u5C11\u5F55\u50CF\u65F6\u95F4\uFF0C\u91CD\u65B0\u4E0A\u4F20\u5F55\u50CF"
                  });
                }
              }, 1e3);
            };
            reader.onload = async (e) => {
            };
            reader.onloadend = async (e) => {
              try {
                isEnterLoadEnd = true;
                clearInterval(fileReaderInterval);
                const fileInfo = dataURLtoFile(e.target.result, file.name);
                resolve({
                  status: true,
                  message: "success",
                  data: fileInfo
                });
              } catch (e2) {
                reject({
                  status: false,
                  message: `onloadend\u5931\u8D25\uFF1A${JSON.stringify(e2)}`
                });
              }
            };
            reader.onprogress = async (e) => {
            };
            reader.onabort = async (e) => {
            };
            reader.onerror = async (e) => {
            };
            reader.readAsDataURL(file);
          });
        }, (e) => {
          reject({
            status: false,
            message: `\u83B7\u53D6\u64CD\u4F5C\u6587\u4EF6\u6216\u76EE\u5F55\u5BF9\u8C61\u5931\u8D25\uFF1A${JSON.stringify(e)}`
          });
        });
      } catch (e) {
        reject({
          status: false,
          message: `getTemFile-error\uFF1A${JSON.stringify(e)}`
        });
      }
    });
  }
}
var render$P = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "action-popup"
  }, [_c("van-popup", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "position": "bottom",
      "close-on-popstate": "",
      "close-on-click-overlay": !_vm.loading,
      "element-loading-text": "\u6587\u4EF6\u5904\u7406\u4E2D",
      "element-loading-spinner": "el-icon-loading"
    },
    on: {
      "closed": _vm.closed
    },
    model: {
      value: _vm.show,
      callback: function($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c("div", {
    staticClass: "action-popup__container"
  }, _vm._l(_vm.actionList, function(item) {
    return _c("div", {
      key: item.type,
      staticClass: "action-popup__item",
      on: {
        "click": function($event) {
          return _vm.uploadActions(item.type);
        }
      }
    }, [_c("div", {
      staticClass: "icons-wrap"
    }, [_c("svg-icon", {
      staticClass: "icon",
      attrs: {
        "icon-class": item.svg
      }
    })], 1), _c("div", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.label))])]);
  }), 0)])], 1);
};
var staticRenderFns$O = [];
render$P._withStripped = true;
var popup_vue_vue_type_style_index_0_scope_true_lang = "";
const appUploader = new PlusUpload();
const __vue2_script$P = {
  name: "ActionPopup",
  components: {
    [_Popup.name]: _Popup
  },
  props: {
    actionsType: {
      type: Array,
      default: () => ["camera", "video", "pickImg", "pickVideo"]
    },
    maxDuration: {
      type: Number,
      default: 15
    },
    acitonContent: {
      type: [Object, null],
      default: null
    }
  },
  data() {
    return {
      show: true,
      loading: false,
      checkWxChooseImage: false,
      maxLength: 9
    };
  },
  computed: {
    actionList() {
      const actionMap = {
        camera: {
          label: "\u62CD\u7167",
          type: "camera",
          svg: "takePhoto"
        },
        video: {
          label: "\u89C6\u9891\u5F55\u50CF",
          type: "video",
          svg: "takeVideo"
        },
        pickImg: {
          label: "\u9009\u62E9\u56FE\u7247",
          type: "pickImg",
          svg: "album"
        },
        pickVideo: {
          label: "\u9009\u62E9\u89C6\u9891",
          type: "pickVideo",
          svg: "pickVideo"
        },
        pickMedia: {
          label: "\u9009\u62E9\u6587\u4EF6",
          type: "pickMedia",
          svg: "filePackage"
        }
      };
      return (this.actionsType || []).reduce((prev4, next3) => {
        if (actionMap[next3]) {
          prev4.push(actionMap[next3]);
        }
        return prev4;
      }, []);
    }
  },
  methods: {
    async miniProgramAndWebUploader(type) {
      let fileInfo = {};
      if (type === "camera") {
        fileInfo = await chooseImage2({
          count: 1,
          sourceType: ["camera"]
        });
      } else if (type === "video") {
        fileInfo = await chooseVideo3({
          count: 1,
          sourceType: ["camera"],
          compressed: true,
          maxDuration: this.maxDuration
        });
      } else if (type === "pickImg") {
        fileInfo = await chooseImage2({
          count: this.maxLength,
          sourceType: ["album"]
        });
      } else if (type === "pickVideo") {
        fileInfo = await chooseVideo3({
          count: this.maxLength,
          sourceType: ["album"],
          compressed: true,
          maxDuration: this.maxDuration
        });
      } else if (type === "pickMedia") {
        fileInfo = await chooseMedia3({
          count: this.maxLength,
          sourceType: ["album"],
          compressed: true,
          maxDuration: this.maxDuration
        });
      }
      return fileInfo;
    },
    async uploadActions(type) {
      let fileInfo = {};
      if (window && window.wx && !this.checkWxChooseImage) {
        if (window && window.__wxConfig__) {
          this.checkWxChooseImage = true;
        }
      }
      try {
        if (isH5plus()) {
          if (type === "pickMedia") {
            fileInfo = await this.miniProgramAndWebUploader(type);
          } else {
            this.loading = true;
            fileInfo.files = await appUploader.appCamera(type, 0, this.maxDuration);
          }
        } else if (this.checkWxChooseImage && (type === "camera" || type === "pickImg")) {
          let sourceType = ["camera"];
          if (type.indexOf("pick") > -1) {
            sourceType = ["album"];
          }
          fileInfo.files = await wxChooseImage(this.maxLength, {
            sourceType
          });
        } else {
          fileInfo = await this.miniProgramAndWebUploader(type);
        }
        this.$emit("returnValue", {
          status: true,
          data: fileInfo
        });
        this.loading = false;
        this.show = false;
      } catch (error) {
        this.$emit("returnValue", {
          status: false,
          data: error
        });
        this.loading = false;
        this.show = false;
      }
    },
    closed() {
      this.$emit("close");
    }
  }
};
const __cssModules$P = {};
var __component__$P = /* @__PURE__ */ normalizeComponent(__vue2_script$P, render$P, staticRenderFns$O, false, __vue2_injectStyles$P, null, null, null);
function __vue2_injectStyles$P(context2) {
  for (let o in __cssModules$P) {
    this[o] = __cssModules$P[o];
  }
}
__component__$P.options.__file = "packages/op-file-upload/src/mobile/components/actions/popup.vue";
var Popup$1 = /* @__PURE__ */ function() {
  return __component__$P.exports;
}();
var ActionPupop = CreateVueFunc(Popup$1);
var render$O = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-mobile-upload"
  }, [_c("div", [_vm.isUpload && _vm.listType === "text" ? _c("div", {
    staticClass: "upload-button",
    on: {
      "click": _vm.handleUpload,
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c("svg-icon", {
    staticClass: "icons",
    attrs: {
      "icon-class": "upload"
    }
  }), _c("span", {
    staticClass: "text"
  }, [_vm._v("\u4E0A\u4F20")])], 1) : _vm._e()]), _c("WallList", {
    attrs: {
      "upload-size": _vm.uploadSize,
      "is-delete": _vm.isDelete && _vm.isUpload,
      "is-download": _vm.isDownload,
      "file-upload-base": _vm.fileUploadBase,
      "on-file-name-click": _vm.onFileNameClick
    },
    on: {
      "ossDownLoad": _vm.ossDownLoad,
      "onRemove": _vm.handleRemove
    },
    model: {
      value: _vm.uploadList,
      callback: function($$v) {
        _vm.uploadList = $$v;
      },
      expression: "uploadList"
    }
  }), _vm.isUpload && _vm.listType === "wall-list" ? _c("div", {
    staticClass: "upload"
  }, [_c("div", {
    staticClass: "op-upload-item",
    style: {
      width: _vm.uploadSize + "px",
      height: _vm.uploadSize + "px"
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_c("svg-icon", {
    attrs: {
      "icon-class": "plus"
    }
  })], 1)]) : _vm._e()], 1);
};
var staticRenderFns$N = [];
render$O._withStripped = true;
var index_vue_vue_type_style_index_0_lang$8 = "";
const __vue2_script$O = {
  name: "OpFileUpload",
  components: {
    WallList
  },
  mixins: [initMixins],
  props: {
    props: {
      type: Object,
      default: () => {
        return {
          name: "name",
          src: "ossKey"
        };
      }
    },
    listType: {
      type: String,
      default: "wall-list"
    },
    size: {
      type: String,
      default: "small"
    },
    accept: {
      type: String,
      default: "*"
    },
    maxSize: {
      type: Number,
      default: 50
    },
    maxLength: {
      type: [Number, String],
      default: 0
    },
    multiple: {
      type: Boolean,
      default: false
    },
    maxDuration: {
      type: Number,
      default: 15
    },
    actionsType: {
      type: [Array, null],
      default: null
    },
    sysPlatForm: {
      type: String
    },
    businessType: {
      type: String,
      require: true
    },
    isDelete: {
      type: Boolean,
      default: true
    },
    isDownload: {
      type: Boolean,
      default: true
    },
    isUpload: {
      type: Boolean,
      default: true
    },
    onSuccess: {
      type: Function,
      default: () => {
      }
    },
    onRemove: {
      type: Function,
      default: () => {
      }
    },
    authType: {
      type: [Number, String],
      default: 0
    },
    signatureOption: {
      type: Object,
      default: () => null
    },
    onFileNameClick: {
      type: [Function, null],
      default: null
    },
    multiPart: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      acceptTips: "\u4F60\u9009\u62E9\u7684\u6587\u4EF6\u4E0D\u7B26\u5408\u4E0A\u4F20\u89C4\u5219",
      sizeConfig: {
        medium: "96",
        small: "80",
        mini: "64"
      },
      uploadList: []
    };
  },
  computed: {
    uploadSize() {
      const size2 = this.sizeConfig[this.size];
      return size2 ? size2 : "64";
    }
  },
  created() {
    this.uploadList = this.value.map((item) => item);
  },
  methods: {
    update(value9) {
      const _value = value9 || this.value;
      this.uploadList = _value.map((item) => item);
    },
    checkSizeAndAccept(res) {
      let fileType = res.name.split(".")[res.name.split(".").length - 1].toLocaleUpperCase();
      let acceptList = this.accept.split(",").reduce((accumulator, list) => {
        accumulator.push(list.toLocaleUpperCase());
        return accumulator;
      }, []);
      if (this.accept && this.accept !== "*") {
        if (!acceptList.includes(fileType)) {
          this.$message.info(this.acceptTips);
          this.$emit("onError");
          return false;
        }
      }
      if (res.size / 1024 / 1024 > this.maxSize) {
        this.$message.info(`\u4E0A\u4F20\u6587\u4EF6\u4E0D\u80FD\u8D85\u8FC7${this.maxSize}M`);
        this.$emit("onError");
        return false;
      }
      return true;
    },
    checkLength(files) {
      const _length = files.length;
      if (+this.maxLength && this.uploadList.length + _length > this.maxLength) {
        this.$message.info(`\u6587\u4EF6\u6700\u5927\u4E0A\u4F20\u6570\u91CF\u9650\u5236\u4E3A${this.maxLength}`);
        this.$emit("onError");
        return false;
      }
      return true;
    },
    async handleUpload() {
      const actionProps = {
        maxLength: this.maxLength - this._value.length,
        maxDuration: this.maxDuration
      };
      if (this.actionsType) {
        actionProps.actionsType = this.actionsType;
      }
      const val = await ActionPupop(actionProps);
      const {
        status,
        data: data22
      } = val;
      if (status) {
        if (!this.checkLength(data22.files)) {
          return;
        }
        const _files = data22.files.reduce((prev4, next3) => {
          if (this.checkSizeAndAccept(next3)) {
            const _item = {};
            _item.file = next3;
            _item.uploading = true;
            _item.uploaded = false;
            prev4.push(_item);
          }
          return prev4;
        }, []);
        this.uploadList.push(..._files);
        this.$emit("onStart", _files);
        for (let item of _files) {
          try {
            if (this.multiPart) {
              const {
                fileData: uploadedFile,
                checkpointId
              } = await this.uploadMultiPart({
                file: item.file
              });
              item.uploading = false;
              item.uploaded = true;
              for (let key2 in uploadedFile) {
                this.$set(item, key2, uploadedFile[key2]);
              }
              this.$emit("onSuccess", uploadedFile, item, this._value);
              if (this.onSuccess) {
                this.onSuccess(uploadedFile, item, this._value);
              }
              const removeCheckPointList = this._value.filter((x) => !x.checkpointId || x.uid !== uploadedFile.uid);
              this._value = [...removeCheckPointList, uploadedFile];
            } else {
              const uploadedFile = await this.uploadFile({
                file: item.file
              });
              item.uploading = false;
              item.uploaded = true;
              for (let key2 in uploadedFile) {
                this.$set(item, key2, uploadedFile[key2]);
              }
              this.$emit("onSuccess", uploadedFile, item, this._value);
              if (this.onSuccess) {
                this.onSuccess(uploadedFile, item, this._value);
              }
              this._value = [...this._value, item];
            }
          } catch (error) {
            this.$emit("onError");
          }
        }
      }
    },
    async uploadFile(file) {
      try {
        const resData = await this.ossUpload(file);
        if (!resData.status) {
          return;
        }
        let fileData = {
          id: resData.id || "",
          name: resData.filename,
          suffix: resData.suffix,
          ossKey: resData.name,
          path: resData.name,
          uid: resData.uid,
          size: resData.size,
          file,
          url: resData.signatureUrl || resData.name,
          filename: resData.filename,
          fullPath: resData.url,
          isDelete: true,
          isDownload: true
        };
        fileData[this.props.name] = resData.filename;
        fileData[this.props.src] = resData.signatureUrl || resData.name;
        return fileData;
      } catch (error) {
        this.loading = false;
        throw new Error("\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25");
      }
    },
    async uploadMultiPart(file, checkpointId = "") {
      const handleCheckPointFile = (info) => {
        let existFile = this._value.find((x) => x.checkpointId && x.checkpointId === info.checkpointId);
        if (existFile) {
          existFile = Object.assign(existFile, info);
        } else {
          this._value = [...this._value, info];
        }
      };
      try {
        const resData = await this.ossMultiPartUpload(file, checkpointId, handleCheckPointFile);
        if (!resData || !resData.status) {
          return;
        }
        let fileData = {
          id: resData.id || "",
          name: resData.filename,
          suffix: resData.suffix,
          ossKey: resData.name,
          path: resData.name,
          uid: resData.uid,
          size: resData.size,
          file,
          url: resData.signatureUrl || resData.name,
          filename: resData.filename,
          fullPath: resData.url,
          isPause: false,
          isDelete: true,
          isDownload: true
        };
        fileData[this.props.name] = resData.filename;
        fileData[this.props.src] = resData.signatureUrl || resData.name;
        return {
          fileData,
          checkpointId: resData.checkpointId
        };
      } catch (error) {
        this.$message.error("\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25");
        this.loading = false;
      }
    },
    handleRemove(currentFile, newVal) {
      this._value = [...newVal];
      if (this.onRemove) {
        this.onRemove(currentFile, newVal);
      }
    }
  }
};
const __cssModules$O = {};
var __component__$O = /* @__PURE__ */ normalizeComponent(__vue2_script$O, render$O, staticRenderFns$N, false, __vue2_injectStyles$O, null, null, null);
function __vue2_injectStyles$O(context2) {
  for (let o in __cssModules$O) {
    this[o] = __cssModules$O[o];
  }
}
__component__$O.options.__file = "packages/op-file-upload/src/mobile/index.vue";
var MobileFileUpload = /* @__PURE__ */ function() {
  return __component__$O.exports;
}();
FileUpload.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  if (!Vue2.prototype.$loading) {
    Vue2.use(_Loading.directive);
    Vue2.prototype.$loading = _Loading.service;
  }
  const comName = changeComPrefix(FileUpload.name, prefix);
  if (isPCWidth()) {
    Vue2.component(comName, FileUpload);
  } else {
    Vue2.component(comName, MobileFileUpload);
  }
};
var __glob_6_9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": FileUpload
});
let node$c = document.getElementById("icon-album");
let wrap$c = document.getElementById("svg-sprite-component-wrap");
if (!wrap$c) {
  wrap$c = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$c.id = "svg-sprite-component-wrap";
  wrap$c.style.setProperty("display", "none");
  document.body.appendChild(wrap$c);
}
if (!node$c) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$c.appendChild(symbol);
  symbol.setAttribute("t", "1650252824876");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "11595");
  symbol.setAttribute("id", "icon-album");
  symbol.innerHTML = `<path d="M291.2 171.712c-65.877333 0-119.466667 53.610667-119.466667 119.488s53.589333 119.488 119.466667 119.488 119.488-53.610667 119.488-119.488C410.688 225.301333 357.077333 171.712 291.2 171.712z" p-id="11596"></path><path d="M855.466667 0 168.533333 0C75.605333 0 0 75.605333 0 168.554667L0 806.4l0 0.021333L0 855.466667C0 948.352 75.605333 1024 168.533333 1024l686.976 0C948.352 1024 1024 948.352 1024 855.466667L1024 168.554667C1024 75.605333 948.394667 0 855.466667 0zM981.269333 632.192l-282.432-282.453333c-8-8-22.165333-8-30.165333 0L389.333333 629.034667l-95.317333-95.296c-8-8.042667-22.186667-8.042667-30.186667 0L42.688 754.901333 42.688 168.554667c0-69.397333 56.448-125.866667 125.845333-125.866667l686.933333 0c69.376 0 125.802667 56.469333 125.802667 125.866667L981.269333 632.192z" p-id="11597"></path>`;
}
let node$b = document.getElementById("icon-back");
let wrap$b = document.getElementById("svg-sprite-component-wrap");
if (!wrap$b) {
  wrap$b = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$b.id = "svg-sprite-component-wrap";
  wrap$b.style.setProperty("display", "none");
  document.body.appendChild(wrap$b);
}
if (!node$b) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$b.appendChild(symbol);
  symbol.setAttribute("t", "1650013298578");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "9002");
  symbol.setAttribute("id", "icon-back");
  symbol.innerHTML = `<path d="M393.390114 512.023536l347.948667-336.348468c20.50808-19.85828 20.50808-51.997258 0-71.792093-20.507056-19.826558-53.778834-19.826558-74.28589 0L281.990954 476.135164c-20.476357 19.826558-20.476357 51.981908 0 71.746044l385.061936 372.236839c10.285251 9.91379 23.728424 14.869662 37.173644 14.869662 13.446243 0 26.889417-4.956895 37.112246-14.901385 20.50808-19.826558 20.50808-51.919487 0-71.746044L393.390114 512.023536" p-id="9003"></path>`;
}
let node$a = document.getElementById("icon-close");
let wrap$a = document.getElementById("svg-sprite-component-wrap");
if (!wrap$a) {
  wrap$a = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$a.id = "svg-sprite-component-wrap";
  wrap$a.style.setProperty("display", "none");
  document.body.appendChild(wrap$a);
}
if (!node$a) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$a.appendChild(symbol);
  symbol.setAttribute("t", "1649984046629");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "4116");
  symbol.setAttribute("id", "icon-close");
  symbol.innerHTML = `<path d="M947.203161 512c0 240.351818-194.845925 435.19413-435.20858 435.19413-240.351818 0-435.199548-194.842312-435.199548-435.19413 0-240.350011 194.845925-435.192324 435.199548-435.192324 240.364461-0.001806 435.20858 194.840506 435.20858 435.192324zM511.994581 0C229.230924 0 0 229.238149 0 512 0 794.770882 229.230924 1024 511.994581 1024c282.774494 0 512.005419-229.229118 512.005419-512C1024 229.238149 794.769076 0 511.994581 0z" fill="#ffffff" p-id="4117"></path><path d="M511.994581 566.305794c54.314825 54.302182 108.62062 108.617007 162.924608 162.922802 14.989815 14.991622 39.303336 14.991622 54.303988 0 15.002459-15.002459 15.002459-39.314173 0-54.303988-54.303988-54.314825-108.607976-108.617007-162.91377-162.922802 54.305794-54.302182 108.609783-108.607976 162.91377-162.911964 15.002459-15.000653 15.002459-39.312367 0-54.303988-15.000653-15.000653-39.314173-15.000653-54.303988 0-54.303988 54.303988-108.609783 108.607976-162.924608 162.91377l-162.91377-162.91377c-14.989815-15.000653-39.303336-15.000653-54.303988 0-14.989815 14.991622-14.989815 39.303336 0 54.303988l162.91377 162.911964c-54.303988 54.305794-108.609783 108.607976-162.91377 162.922802-14.989815 14.991622-14.989815 39.303336 0 54.303988 15.000653 14.991622 39.314173 14.991622 54.303988 0 54.305794-54.305794 108.607976-108.62062 162.91377-162.922802z" fill="#ffffff" p-id="4118"></path>`;
}
let node$9 = document.getElementById("icon-file");
let wrap$9 = document.getElementById("svg-sprite-component-wrap");
if (!wrap$9) {
  wrap$9 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$9.id = "svg-sprite-component-wrap";
  wrap$9.style.setProperty("display", "none");
  document.body.appendChild(wrap$9);
}
if (!node$9) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$9.appendChild(symbol);
  symbol.setAttribute("t", "1649988278311");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "5007");
  symbol.setAttribute("id", "icon-file");
  symbol.innerHTML = `<path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z m0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z" p-id="5008" fill="#515151"></path>`;
}
let node$8 = document.getElementById("icon-filePackage");
let wrap$8 = document.getElementById("svg-sprite-component-wrap");
if (!wrap$8) {
  wrap$8 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$8.id = "svg-sprite-component-wrap";
  wrap$8.style.setProperty("display", "none");
  document.body.appendChild(wrap$8);
}
if (!node$8) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$8.appendChild(symbol);
  symbol.setAttribute("t", "1650252924968");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "14200");
  symbol.setAttribute("id", "icon-filePackage");
  symbol.innerHTML = `<path d="M855.04 385.024q19.456 2.048 38.912 10.24t33.792 23.04 21.504 37.376 2.048 54.272q-2.048 8.192-8.192 40.448t-14.336 74.24-18.432 86.528-19.456 76.288q-5.12 18.432-14.848 37.888t-25.088 35.328-36.864 26.112-51.2 10.24l-567.296 0q-21.504 0-44.544-9.216t-42.496-26.112-31.744-40.96-12.288-53.76l0-439.296q0-62.464 33.792-97.792t95.232-35.328l503.808 0q22.528 0 46.592 8.704t43.52 24.064 31.744 35.84 12.288 44.032l0 11.264-53.248 0q-40.96 0-95.744-0.512t-116.736-0.512-115.712-0.512-92.672-0.512l-47.104 0q-26.624 0-41.472 16.896t-23.04 44.544q-8.192 29.696-18.432 62.976t-18.432 61.952q-10.24 33.792-20.48 65.536-2.048 8.192-2.048 13.312 0 17.408 11.776 29.184t29.184 11.776q31.744 0 43.008-39.936l54.272-198.656q133.12 1.024 243.712 1.024l286.72 0z" p-id="14201"></path>`;
}
let node$7 = document.getElementById("icon-loading");
let wrap$7 = document.getElementById("svg-sprite-component-wrap");
if (!wrap$7) {
  wrap$7 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$7.id = "svg-sprite-component-wrap";
  wrap$7.style.setProperty("display", "none");
  document.body.appendChild(wrap$7);
}
if (!node$7) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$7.appendChild(symbol);
  symbol.setAttribute("t", "1649999401129");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "7024");
  symbol.setAttribute("id", "icon-loading");
  symbol.innerHTML = `<path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#ff7f26" opacity=".3" p-id="7025"></path>`;
}
let node$6 = document.getElementById("icon-pickVideo");
let wrap$6 = document.getElementById("svg-sprite-component-wrap");
if (!wrap$6) {
  wrap$6 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$6.id = "svg-sprite-component-wrap";
  wrap$6.style.setProperty("display", "none");
  document.body.appendChild(wrap$6);
}
if (!node$6) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$6.appendChild(symbol);
  symbol.setAttribute("t", "1650252908459");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "13324");
  symbol.setAttribute("id", "icon-pickVideo");
  symbol.innerHTML = `<path d="M825.6 892.8 198.4 892.8C124.16 892.8 64 832.64 64 758.4L64 265.6C64 191.36 124.16 131.2 198.4 131.2L377.6 131.2 198.4 310.4l44.8 0 179.2-179.2L601.6 131.2 422.4 310.4l44.8 0 179.2-179.2L825.6 131.2 691.2 310.4l44.8 0 129.408-172.48C920.064 154.944 960 205.312 960 265.6l0 492.736C960 832.64 899.84 892.8 825.6 892.8zM870.4 355.2 153.6 355.2l0 345.28c0 56.768 48.128 102.72 107.52 102.72l501.76 0c59.392 0 107.52-46.016 107.52-102.72L870.4 355.2zM422.4 757.504 422.4 401.152l0.448-0.448L602.24 579.328l-179.456 178.624L422.4 757.504z" p-id="13325"></path>`;
}
let node$5 = document.getElementById("icon-plus");
let wrap$5 = document.getElementById("svg-sprite-component-wrap");
if (!wrap$5) {
  wrap$5 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$5.id = "svg-sprite-component-wrap";
  wrap$5.style.setProperty("display", "none");
  document.body.appendChild(wrap$5);
}
if (!node$5) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$5.appendChild(symbol);
  symbol.setAttribute("t", "1649409934763");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "2198");
  symbol.setAttribute("id", "icon-plus");
  symbol.innerHTML = `<path d="M474 152m8 0l60 0q8 0 8 8l0 704q0 8-8 8l-60 0q-8 0-8-8l0-704q0-8 8-8Z" p-id="2199"></path><path d="M168 474m8 0l672 0q8 0 8 8l0 60q0 8-8 8l-672 0q-8 0-8-8l0-60q0-8 8-8Z" p-id="2200"></path>`;
}
let node$4 = document.getElementById("icon-takePhoto");
let wrap$4 = document.getElementById("svg-sprite-component-wrap");
if (!wrap$4) {
  wrap$4 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$4.id = "svg-sprite-component-wrap";
  wrap$4.style.setProperty("display", "none");
  document.body.appendChild(wrap$4);
}
if (!node$4) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$4.appendChild(symbol);
  symbol.setAttribute("t", "1650252791065");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "10674");
  symbol.setAttribute("id", "icon-takePhoto");
  symbol.innerHTML = `<path d="M510.3 408.3c-80.8 0-146.6 65.7-146.6 146.6s65.7 146.6 146.6 146.6 146.6-65.7 146.6-146.6-65.8-146.6-146.6-146.6z" fill p-id="10675"></path><path d="M810.2 277.7h-28.8c-7.9 0-15.3-4.3-19.2-11.2L721 193.3c-13.8-24.5-39.8-39.8-68-39.8H367.6c-28.2 0-54.2 15.2-68 39.8l-41.1 73.2c-3.9 6.9-11.2 11.2-19.2 11.2h-28.8c-81.6 0-148 66.4-148 148v298.2c0 81.6 66.4 148 148 148h599.7c81.6 0 148-66.4 148-148V425.7c0-81.6-66.4-148-148-148zM510.3 757.4c-111.7 0-202.6-90.9-202.6-202.6s90.9-202.6 202.6-202.6 202.6 90.9 202.6 202.6S622 757.4 510.3 757.4z" fill p-id="10676"></path>`;
}
let node$3 = document.getElementById("icon-takeVideo");
let wrap$3 = document.getElementById("svg-sprite-component-wrap");
if (!wrap$3) {
  wrap$3 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$3.id = "svg-sprite-component-wrap";
  wrap$3.style.setProperty("display", "none");
  document.body.appendChild(wrap$3);
}
if (!node$3) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$3.appendChild(symbol);
  symbol.setAttribute("t", "1650252863737");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1087 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "13168");
  symbol.setAttribute("id", "icon-takeVideo");
  symbol.innerHTML = `<path d="M768 415.744q0 5.12-10.752 17.92t-23.04 30.208-23.04 37.888-10.752 41.984 10.752 41.472 23.04 36.352 23.04 27.136 10.752 13.824l0 107.52q0 17.408-12.8 39.424t-31.744 41.472-41.984 32.256-43.52 12.8l-508.928 0q-27.648 0-50.688-9.728t-40.448-27.136-27.136-40.96-9.728-51.2l0-441.344q0-20.48 9.216-42.496t26.112-40.448 39.936-30.72 50.688-12.288l508.928 0q27.648 0 51.712 9.728t41.984 26.624 28.16 40.448 10.24 50.176l0 89.088zM1086.464 319.488l0 467.968q0 22.528-11.776 39.936t-35.328 17.408q-8.192 0-20.992-6.144t-25.6-14.336-24.064-16.384-16.384-13.312q-13.312-11.264-40.448-38.912t-54.784-62.464-48.64-71.68-20.992-67.584 22.528-70.144 54.272-77.312 66.56-70.144 58.368-48.64q9.216-6.144 25.088-14.848t28.16-8.704q27.648 0 35.84 15.36t8.192 37.888l0 2.048z" p-id="13169"></path>`;
}
let node$2 = document.getElementById("icon-transition-up");
let wrap$2 = document.getElementById("svg-sprite-component-wrap");
if (!wrap$2) {
  wrap$2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$2.id = "svg-sprite-component-wrap";
  wrap$2.style.setProperty("display", "none");
  document.body.appendChild(wrap$2);
}
if (!node$2) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$2.appendChild(symbol);
  symbol.setAttribute("t", "1630636934998");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 2048 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "6877");
  symbol.setAttribute("id", "icon-transition-up");
  symbol.innerHTML = `
  <path d="M0 1024L1024 0l1024 1024H0z" fill="#CCCCCC" p-id="6878"></path>
`;
}
let node$1 = document.getElementById("icon-upload");
let wrap$1 = document.getElementById("svg-sprite-component-wrap");
if (!wrap$1) {
  wrap$1 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap$1.id = "svg-sprite-component-wrap";
  wrap$1.style.setProperty("display", "none");
  document.body.appendChild(wrap$1);
}
if (!node$1) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap$1.appendChild(symbol);
  symbol.setAttribute("t", "1650013691220");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "9835");
  symbol.setAttribute("id", "icon-upload");
  symbol.innerHTML = `<path d="M576 631.466667V725.333333h170.666667c59.733333-8.533333 106.666667-64 106.666666-128 0-72.533333-55.466667-128-128-128-17.066667 0-29.866667 4.266667-42.666666 8.533334V469.333333c0-93.866667-76.8-170.666667-170.666667-170.666666s-170.666667 76.8-170.666667 170.666666c0 17.066667 4.266667 29.866667 4.266667 46.933334-8.533333-4.266667-17.066667-4.266667-25.6-4.266667C260.266667 512 213.333333 558.933333 213.333333 618.666667S260.266667 725.333333 320 725.333333h170.666667v-93.866666l-46.933334 46.933333L384 618.666667l149.333333-149.333334 149.333334 149.333334-59.733334 59.733333-46.933333-46.933333z m0 93.866666v85.333334h-85.333333v-85.333334h-42.666667v85.333334h-128C213.333333 810.666667 128 725.333333 128 618.666667c0-85.333333 55.466667-157.866667 128-183.466667C273.066667 311.466667 379.733333 213.333333 512 213.333333c110.933333 0 209.066667 72.533333 243.2 170.666667 102.4 12.8 183.466667 102.4 183.466667 213.333333s-85.333333 200.533333-192 213.333334h-128v-85.333334h-42.666667z" fill="#ffffff" p-id="9836"></path>`;
}
let node = document.getElementById("icon-video");
let wrap = document.getElementById("svg-sprite-component-wrap");
if (!wrap) {
  wrap = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  wrap.id = "svg-sprite-component-wrap";
  wrap.style.setProperty("display", "none");
  document.body.appendChild(wrap);
}
if (!node) {
  let symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
  wrap.appendChild(symbol);
  symbol.setAttribute("t", "1650004241971");
  symbol.setAttribute("class", "icon");
  symbol.setAttribute("viewBox", "0 0 1024 1024");
  symbol.setAttribute("version", "1.1");
  symbol.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  symbol.setAttribute("p-id", "8201");
  symbol.setAttribute("id", "icon-video");
  symbol.innerHTML = `<path d="M512 653.784194c-52.199845 0-94.525873 42.319874-94.525873 94.51818 0 52.212152 42.326028 94.525873 94.525873 94.525873 52.198306 0 94.51818-42.31372 94.51818-94.525873C606.51818 696.104068 564.198306 653.784194 512 653.784194L512 653.784194zM976.734002 929.474143 808.219119 929.474143c130.533458-92.787416 215.780897-245.131578 215.780897-417.474143 0-282.763774-229.236241-512.000015-512.000015-512.000015S-1.5e-05 229.236226-1.5e-05 512 229.236226 1024.000015 512 1024.000015l0.035385 0 464.698618 0c26.106076 0 47.266013-21.159937 47.266013-47.266013C1024.000015 950.63408 1002.840078 929.474143 976.734002 929.474143L976.734002 929.474143zM512.035385 929.474143l-0.035385 0-0.018461 0C281.423763 929.467989 94.524319 742.56393 94.524319 512s186.911752-417.475681 417.475681-417.475681S929.474143 281.43607 929.474143 512C929.474143 742.545468 742.588545 929.451066 512.035385 929.474143L512.035385 929.474143zM275.689934 417.474127c-52.198306 0-94.51818 42.326028-94.51818 94.525873 0 52.198306 42.31372 94.51818 94.51818 94.51818 52.212152 0 94.525873-42.319874 94.525873-94.51818C370.215806 459.800155 327.889778 417.474127 275.689934 417.474127L275.689934 417.474127zM551.379883 519.878438c0-21.749166-17.626101-39.387575-39.379883-39.387575-21.749166 0-39.387575 17.638409-39.387575 39.387575 0 21.743012 17.638409 39.381421 39.387575 39.381421C533.749166 559.259859 551.379883 541.62145 551.379883 519.878438L551.379883 519.878438zM740.43009 417.474127c-52.198306 0-94.524334 42.326028-94.524334 94.525873 0 52.198306 42.31372 94.51818 94.524334 94.51818 52.205999 0 94.519719-42.319874 94.519719-94.51818C834.949809 459.800155 792.629934 417.474127 740.43009 417.474127L740.43009 417.474127zM512 181.171753c-52.199845 0-94.525873 42.319874-94.525873 94.51818 0 52.212152 42.326028 94.525873 94.525873 94.525873 52.198306 0 94.51818-42.31372 94.51818-94.525873C606.51818 223.491627 564.198306 181.171753 512 181.171753L512 181.171753zM512 181.171753" p-id="8202"></path>`;
}
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
var render$N = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isExternal ? _c("div", _vm._g({
    staticClass: "svg-external-icon svg-icon",
    style: _vm.styleExternalIcon
  }, _vm.$listeners)) : _c("svg", _vm._g({
    class: _vm.svgClass,
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm.$listeners), [_c("use", {
    attrs: {
      "xlink:href": _vm.iconName
    }
  })]);
};
var staticRenderFns$M = [];
render$N._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$a = "";
const __vue2_script$N = {
  name: "SvgIcon",
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ""
    }
  },
  computed: {
    isExternal() {
      return isExternal(this.iconClass);
    },
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return "svg-icon " + this.className;
      } else {
        return "svg-icon";
      }
    },
    styleExternalIcon() {
      return {
        mask: `url(${this.iconClass}) no-repeat 50% 50%`,
        "-webkit-mask": `url(${this.iconClass}) no-repeat 50% 50%`
      };
    }
  }
};
const __cssModules$N = {};
var __component__$N = /* @__PURE__ */ normalizeComponent(__vue2_script$N, render$N, staticRenderFns$M, false, __vue2_injectStyles$N, "55903a0c", null, null);
function __vue2_injectStyles$N(context2) {
  for (let o in __cssModules$N) {
    this[o] = __cssModules$N[o];
  }
}
__component__$N.options.__file = "src/components/common/SvgIcon/index.vue";
var SvgIcon = /* @__PURE__ */ function() {
  return __component__$N.exports;
}();
const OpIcons = {};
OpIcons.install = (Vue2) => {
  Vue2.component("SvgIcon", SvgIcon);
};
var __glob_6_10 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpIcons
});
var props$6 = {
  url: {
    type: String,
    required: true
  },
  title: String,
  width: {
    type: String,
    default: "80%"
  },
  height: {
    type: String,
    default: "700px"
  },
  showFooter: {
    type: Boolean,
    default: false
  },
  onMessage: Function
};
var render$M = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("el-dialog", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "iframe-dialog",
    attrs: {
      "element-loading-text": "\u9875\u9762\u52A0\u8F7D\u4E2D",
      "visible": _vm.visible,
      "width": _vm.width,
      "title": _vm.title,
      "close-on-click-modal": false,
      "destroy-on-close": "",
      "custom-class": "iframe-dialog-content",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event;
      },
      "closed": _vm.closeDialog
    }
  }, [_c("div", {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm.url ? [_c("iframe", {
    ref: "iframeRef",
    attrs: {
      "src": _vm.url,
      "frameborder": "0",
      "width": "100%",
      "height": _vm.height
    },
    on: {
      "load": _vm.handleLoad
    }
  })] : _vm._e()], 2), _vm.showFooter ? _c("div", {
    staticClass: "iframe-dialog__footer"
  }, [_c("el-button", {
    attrs: {
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("\u5173\u95ED")])], 1) : _vm._e()]);
};
var staticRenderFns$L = [];
render$M._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$9 = "";
var index_vue_vue_type_style_index_1_lang = "";
const __vue2_script$M = {
  name: "IframeDialog",
  props: props$6,
  data() {
    return {
      visible: true,
      loading: true
    };
  },
  created() {
  },
  methods: {
    handlePostMessage(ev) {
      this.onMessage(ev, this.closeDialog, this.$refs.iframeRef.contentWindow);
    },
    submit(data22) {
      this.$emit("returnValue", data22);
      this.closeDialog();
    },
    handleLoad() {
      this.loading = false;
      window.addEventListener("message", this.handlePostMessage);
    },
    closeDialog() {
      window.removeEventListener("message", this.handlePostMessage);
      this.visible = false;
      this.$emit("close");
    }
  }
};
const __cssModules$M = {};
var __component__$M = /* @__PURE__ */ normalizeComponent(__vue2_script$M, render$M, staticRenderFns$L, false, __vue2_injectStyles$M, "7baf3697", null, null);
function __vue2_injectStyles$M(context2) {
  for (let o in __cssModules$M) {
    this[o] = __cssModules$M[o];
  }
}
__component__$M.options.__file = "packages/op-iframe-dialog/src/pc/index.vue";
var Dialog = /* @__PURE__ */ function() {
  return __component__$M.exports;
}();
var render$L = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "iframe-popup"
  }, [_c("van-popup", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    style: {
      height: "90%"
    },
    attrs: {
      "position": "bottom",
      "close-on-popstate": "",
      "close-on-click-overlay": !_vm.loading,
      "element-loading-text": "\u9875\u9762\u52A0\u8F7D\u4E2D",
      "element-loading-spinner": "el-icon-loading"
    },
    on: {
      "closed": _vm.closeDialog
    },
    model: {
      value: _vm.visible,
      callback: function($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "iframe-popup__container"
  }, [_vm.url ? [_c("iframe", {
    ref: "iframeRef",
    attrs: {
      "src": _vm.url,
      "frameborder": "0",
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": _vm.handleLoad
    }
  })] : _vm._e()], 2)])], 1);
};
var staticRenderFns$K = [];
render$L._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$8 = "";
const __vue2_script$L = {
  name: "IframeDialog",
  props: props$6,
  data() {
    return {
      visible: true,
      loading: true
    };
  },
  created() {
  },
  methods: {
    handlePostMessage(ev) {
      this.onMessage(ev, this.closeDialog, this.$refs.iframeRef.contentWindow);
    },
    submit(data22) {
      this.$emit("returnValue", data22);
      this.closeDialog();
    },
    handleLoad() {
      this.loading = false;
      window.addEventListener("message", this.handlePostMessage);
    },
    closeDialog() {
      window.removeEventListener("message", this.handlePostMessage);
      this.visible = false;
      this.$emit("close");
    }
  }
};
const __cssModules$L = {};
var __component__$L = /* @__PURE__ */ normalizeComponent(__vue2_script$L, render$L, staticRenderFns$K, false, __vue2_injectStyles$L, "12279e06", null, null);
function __vue2_injectStyles$L(context2) {
  for (let o in __cssModules$L) {
    this[o] = __cssModules$L[o];
  }
}
__component__$L.options.__file = "packages/op-iframe-dialog/src/mobile/index.vue";
var Popup = /* @__PURE__ */ function() {
  return __component__$L.exports;
}();
const OpIframeDialog = {};
OpIframeDialog.install = (Vue2, opt = {}) => {
  if (isPCWidth()) {
    Vue2.prototype.$createOpIframeDialog = CreateVueFunc(Dialog);
  } else {
    Vue2.prototype.$createOpIframeDialog = CreateVueFunc(Popup);
  }
};
var __glob_6_11 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpIframeDialog
});
/*!
 * Viewer.js v1.10.2
 * https://fengyuanchen.github.io/viewerjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2021-10-22T13:59:51.046Z
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key2) {
        _defineProperty(target, key2, source[key2]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key2) {
        Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
      });
    }
  }
  return target;
}
function _typeof$5(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$5 = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$5 = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$5(obj);
}
function _classCallCheck(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props2) {
  for (var i = 0; i < props2.length; i++) {
    var descriptor = props2[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key2, value9) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value: value9,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value9;
  }
  return obj;
}
var DEFAULTS = {
  backdrop: true,
  button: true,
  navbar: true,
  title: true,
  toolbar: true,
  className: "",
  container: "body",
  filter: null,
  fullscreen: true,
  inheritedAttributes: ["crossOrigin", "decoding", "isMap", "loading", "referrerPolicy", "sizes", "srcset", "useMap"],
  initialViewIndex: 0,
  inline: false,
  interval: 5e3,
  keyboard: true,
  focus: true,
  loading: true,
  loop: true,
  minWidth: 200,
  minHeight: 100,
  movable: true,
  rotatable: true,
  scalable: true,
  zoomable: true,
  zoomOnTouch: true,
  zoomOnWheel: true,
  slideOnTouch: true,
  toggleOnDblclick: true,
  tooltip: true,
  transition: true,
  zIndex: 2015,
  zIndexInline: 0,
  zoomRatio: 0.1,
  minZoomRatio: 0.01,
  maxZoomRatio: 100,
  url: "src",
  ready: null,
  show: null,
  shown: null,
  hide: null,
  hidden: null,
  view: null,
  viewed: null,
  move: null,
  moved: null,
  rotate: null,
  rotated: null,
  scale: null,
  scaled: null,
  zoom: null,
  zoomed: null,
  play: null,
  stop: null
};
var TEMPLATE = '<div class="viewer-container" tabindex="-1" touch-action="none"><div class="viewer-canvas"></div><div class="viewer-footer"><div class="viewer-title"></div><div class="viewer-toolbar"></div><div class="viewer-navbar"><ul class="viewer-list" role="navigation"></ul></div></div><div class="viewer-tooltip" role="alert" aria-hidden="true"></div><div class="viewer-button" data-viewer-action="mix" role="button"></div><div class="viewer-player"></div></div>';
var IS_BROWSER = typeof window !== "undefined" && typeof window.document !== "undefined";
var WINDOW = IS_BROWSER ? window : {};
var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? "ontouchstart" in WINDOW.document.documentElement : false;
var HAS_POINTER_EVENT = IS_BROWSER ? "PointerEvent" in WINDOW : false;
var NAMESPACE = "viewer";
var ACTION_MOVE = "move";
var ACTION_SWITCH = "switch";
var ACTION_ZOOM = "zoom";
var CLASS_ACTIVE = "".concat(NAMESPACE, "-active");
var CLASS_CLOSE = "".concat(NAMESPACE, "-close");
var CLASS_FADE = "".concat(NAMESPACE, "-fade");
var CLASS_FIXED = "".concat(NAMESPACE, "-fixed");
var CLASS_FULLSCREEN = "".concat(NAMESPACE, "-fullscreen");
var CLASS_FULLSCREEN_EXIT = "".concat(NAMESPACE, "-fullscreen-exit");
var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
var CLASS_HIDE_MD_DOWN = "".concat(NAMESPACE, "-hide-md-down");
var CLASS_HIDE_SM_DOWN = "".concat(NAMESPACE, "-hide-sm-down");
var CLASS_HIDE_XS_DOWN = "".concat(NAMESPACE, "-hide-xs-down");
var CLASS_IN = "".concat(NAMESPACE, "-in");
var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
var CLASS_LOADING = "".concat(NAMESPACE, "-loading");
var CLASS_MOVE = "".concat(NAMESPACE, "-move");
var CLASS_OPEN = "".concat(NAMESPACE, "-open");
var CLASS_SHOW = "".concat(NAMESPACE, "-show");
var CLASS_TRANSITION = "".concat(NAMESPACE, "-transition");
var EVENT_CLICK = "click";
var EVENT_DBLCLICK = "dblclick";
var EVENT_DRAG_START = "dragstart";
var EVENT_FOCUSIN = "focusin";
var EVENT_KEY_DOWN = "keydown";
var EVENT_LOAD = "load";
var EVENT_ERROR = "error";
var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? "touchend touchcancel" : "mouseup";
var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? "touchmove" : "mousemove";
var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? "touchstart" : "mousedown";
var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? "pointerdown" : EVENT_TOUCH_START;
var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? "pointermove" : EVENT_TOUCH_MOVE;
var EVENT_POINTER_UP = HAS_POINTER_EVENT ? "pointerup pointercancel" : EVENT_TOUCH_END;
var EVENT_RESIZE = "resize";
var EVENT_TRANSITION_END = "transitionend";
var EVENT_WHEEL = "wheel";
var EVENT_READY = "ready";
var EVENT_SHOW = "show";
var EVENT_SHOWN = "shown";
var EVENT_HIDE = "hide";
var EVENT_HIDDEN = "hidden";
var EVENT_VIEW = "view";
var EVENT_VIEWED = "viewed";
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_ROTATE = "rotate";
var EVENT_ROTATED = "rotated";
var EVENT_SCALE = "scale";
var EVENT_SCALED = "scaled";
var EVENT_ZOOM = "zoom";
var EVENT_ZOOMED = "zoomed";
var EVENT_PLAY = "play";
var EVENT_STOP = "stop";
var DATA_ACTION = "".concat(NAMESPACE, "Action");
var REGEXP_SPACES = /\s\s*/;
var BUTTONS = ["zoom-in", "zoom-out", "one-to-one", "reset", "prev", "play", "next", "rotate-left", "rotate-right", "flip-horizontal", "flip-vertical"];
function isString$1(value9) {
  return typeof value9 === "string";
}
var isNaN$1 = Number.isNaN || WINDOW.isNaN;
function isNumber(value9) {
  return typeof value9 === "number" && !isNaN$1(value9);
}
function isUndefined(value9) {
  return typeof value9 === "undefined";
}
function isObject$1(value9) {
  return _typeof$5(value9) === "object" && value9 !== null;
}
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function isPlainObject(value9) {
  if (!isObject$1(value9)) {
    return false;
  }
  try {
    var _constructor = value9.constructor;
    var prototype = _constructor.prototype;
    return _constructor && prototype && hasOwnProperty$1.call(prototype, "isPrototypeOf");
  } catch (error) {
    return false;
  }
}
function isFunction$1(value9) {
  return typeof value9 === "function";
}
function forEach(data22, callback2) {
  if (data22 && isFunction$1(callback2)) {
    if (Array.isArray(data22) || isNumber(data22.length)) {
      var length = data22.length;
      var i;
      for (i = 0; i < length; i += 1) {
        if (callback2.call(data22, data22[i], i, data22) === false) {
          break;
        }
      }
    } else if (isObject$1(data22)) {
      Object.keys(data22).forEach(function(key2) {
        callback2.call(data22, data22[key2], key2, data22);
      });
    }
  }
  return data22;
}
var assign = Object.assign || function assign2(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (isObject$1(obj) && args.length > 0) {
    args.forEach(function(arg) {
      if (isObject$1(arg)) {
        Object.keys(arg).forEach(function(key2) {
          obj[key2] = arg[key2];
        });
      }
    });
  }
  return obj;
};
var REGEXP_SUFFIX = /^(?:width|height|left|top|marginLeft|marginTop)$/;
function setStyle(element, styles2) {
  var style6 = element.style;
  forEach(styles2, function(value9, property) {
    if (REGEXP_SUFFIX.test(property) && isNumber(value9)) {
      value9 += "px";
    }
    style6[property] = value9;
  });
}
function escapeHTMLEntities(value9) {
  return isString$1(value9) ? value9.replace(/&(?!amp;|quot;|#39;|lt;|gt;)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : value9;
}
function hasClass(element, value9) {
  if (!element || !value9) {
    return false;
  }
  return element.classList ? element.classList.contains(value9) : element.className.indexOf(value9) > -1;
}
function addClass(element, value9) {
  if (!element || !value9) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function(elem) {
      addClass(elem, value9);
    });
    return;
  }
  if (element.classList) {
    element.classList.add(value9);
    return;
  }
  var className = element.className.trim();
  if (!className) {
    element.className = value9;
  } else if (className.indexOf(value9) < 0) {
    element.className = "".concat(className, " ").concat(value9);
  }
}
function removeClass(element, value9) {
  if (!element || !value9) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function(elem) {
      removeClass(elem, value9);
    });
    return;
  }
  if (element.classList) {
    element.classList.remove(value9);
    return;
  }
  if (element.className.indexOf(value9) >= 0) {
    element.className = element.className.replace(value9, "");
  }
}
function toggleClass(element, value9, added) {
  if (!value9) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function(elem) {
      toggleClass(elem, value9, added);
    });
    return;
  }
  if (added) {
    addClass(element, value9);
  } else {
    removeClass(element, value9);
  }
}
var REGEXP_HYPHENATE = /([a-z\d])([A-Z])/g;
function hyphenate(value9) {
  return value9.replace(REGEXP_HYPHENATE, "$1-$2").toLowerCase();
}
function getData(element, name) {
  if (isObject$1(element[name])) {
    return element[name];
  }
  if (element.dataset) {
    return element.dataset[name];
  }
  return element.getAttribute("data-".concat(hyphenate(name)));
}
function setData(element, name, data22) {
  if (isObject$1(data22)) {
    element[name] = data22;
  } else if (element.dataset) {
    element.dataset[name] = data22;
  } else {
    element.setAttribute("data-".concat(hyphenate(name)), data22);
  }
}
var onceSupported = function() {
  var supported = false;
  if (IS_BROWSER) {
    var once2 = false;
    var listener = function listener2() {
    };
    var options = Object.defineProperty({}, "once", {
      get: function get5() {
        supported = true;
        return once2;
      },
      set: function set4(value9) {
        once2 = value9;
      }
    });
    WINDOW.addEventListener("test", listener, options);
    WINDOW.removeEventListener("test", listener, options);
  }
  return supported;
}();
function removeListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function(event) {
    if (!onceSupported) {
      var listeners3 = element.listeners;
      if (listeners3 && listeners3[event] && listeners3[event][listener]) {
        handler = listeners3[event][listener];
        delete listeners3[event][listener];
        if (Object.keys(listeners3[event]).length === 0) {
          delete listeners3[event];
        }
        if (Object.keys(listeners3).length === 0) {
          delete element.listeners;
        }
      }
    }
    element.removeEventListener(event, handler, options);
  });
}
function addListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var _handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function(event) {
    if (options.once && !onceSupported) {
      var _element$listeners = element.listeners, listeners3 = _element$listeners === void 0 ? {} : _element$listeners;
      _handler = function handler() {
        delete listeners3[event][listener];
        element.removeEventListener(event, _handler, options);
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        listener.apply(element, args);
      };
      if (!listeners3[event]) {
        listeners3[event] = {};
      }
      if (listeners3[event][listener]) {
        element.removeEventListener(event, listeners3[event][listener], options);
      }
      listeners3[event][listener] = _handler;
      element.listeners = listeners3;
    }
    element.addEventListener(event, _handler, options);
  });
}
function dispatchEvent(element, type, data22, options) {
  var event;
  if (isFunction$1(Event) && isFunction$1(CustomEvent)) {
    event = new CustomEvent(type, _objectSpread2({
      bubbles: true,
      cancelable: true,
      detail: data22
    }, options));
  } else {
    event = document.createEvent("CustomEvent");
    event.initCustomEvent(type, true, true, data22);
  }
  return element.dispatchEvent(event);
}
function getOffset(element) {
  var box = element.getBoundingClientRect();
  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
function getTransforms(_ref) {
  var rotate2 = _ref.rotate, scaleX2 = _ref.scaleX, scaleY2 = _ref.scaleY, translateX = _ref.translateX, translateY = _ref.translateY;
  var values = [];
  if (isNumber(translateX) && translateX !== 0) {
    values.push("translateX(".concat(translateX, "px)"));
  }
  if (isNumber(translateY) && translateY !== 0) {
    values.push("translateY(".concat(translateY, "px)"));
  }
  if (isNumber(rotate2) && rotate2 !== 0) {
    values.push("rotate(".concat(rotate2, "deg)"));
  }
  if (isNumber(scaleX2) && scaleX2 !== 1) {
    values.push("scaleX(".concat(scaleX2, ")"));
  }
  if (isNumber(scaleY2) && scaleY2 !== 1) {
    values.push("scaleY(".concat(scaleY2, ")"));
  }
  var transform = values.length ? values.join(" ") : "none";
  return {
    WebkitTransform: transform,
    msTransform: transform,
    transform
  };
}
function getImageNameFromURL(url2) {
  return isString$1(url2) ? decodeURIComponent(url2.replace(/^.*\//, "").replace(/[?&#].*$/, "")) : "";
}
var IS_SAFARI = WINDOW.navigator && /(Macintosh|iPhone|iPod|iPad).*AppleWebKit/i.test(WINDOW.navigator.userAgent);
function getImageNaturalSizes(image, options, callback2) {
  var newImage = document.createElement("img");
  if (image.naturalWidth && !IS_SAFARI) {
    callback2(image.naturalWidth, image.naturalHeight);
    return newImage;
  }
  var body = document.body || document.documentElement;
  newImage.onload = function() {
    callback2(newImage.width, newImage.height);
    if (!IS_SAFARI) {
      body.removeChild(newImage);
    }
  };
  forEach(options.inheritedAttributes, function(name) {
    var value9 = image.getAttribute(name);
    if (value9 !== null) {
      newImage.setAttribute(name, value9);
    }
  });
  newImage.src = image.src;
  if (!IS_SAFARI) {
    newImage.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;";
    body.appendChild(newImage);
  }
  return newImage;
}
function getResponsiveClass(type) {
  switch (type) {
    case 2:
      return CLASS_HIDE_XS_DOWN;
    case 3:
      return CLASS_HIDE_SM_DOWN;
    case 4:
      return CLASS_HIDE_MD_DOWN;
    default:
      return "";
  }
}
function getMaxZoomRatio(pointers) {
  var pointers2 = _objectSpread2({}, pointers);
  var ratios = [];
  forEach(pointers, function(pointer, pointerId) {
    delete pointers2[pointerId];
    forEach(pointers2, function(pointer2) {
      var x1 = Math.abs(pointer.startX - pointer2.startX);
      var y1 = Math.abs(pointer.startY - pointer2.startY);
      var x2 = Math.abs(pointer.endX - pointer2.endX);
      var y2 = Math.abs(pointer.endY - pointer2.endY);
      var z1 = Math.sqrt(x1 * x1 + y1 * y1);
      var z2 = Math.sqrt(x2 * x2 + y2 * y2);
      var ratio = (z2 - z1) / z1;
      ratios.push(ratio);
    });
  });
  ratios.sort(function(a, b) {
    return Math.abs(a) < Math.abs(b);
  });
  return ratios[0];
}
function getPointer(_ref2, endOnly) {
  var pageX = _ref2.pageX, pageY = _ref2.pageY;
  var end = {
    endX: pageX,
    endY: pageY
  };
  return endOnly ? end : _objectSpread2({
    timeStamp: Date.now(),
    startX: pageX,
    startY: pageY
  }, end);
}
function getPointersCenter(pointers) {
  var pageX = 0;
  var pageY = 0;
  var count3 = 0;
  forEach(pointers, function(_ref3) {
    var startX = _ref3.startX, startY = _ref3.startY;
    pageX += startX;
    pageY += startY;
    count3 += 1;
  });
  pageX /= count3;
  pageY /= count3;
  return {
    pageX,
    pageY
  };
}
var render$K = {
  render: function render11() {
    this.initContainer();
    this.initViewer();
    this.initList();
    this.renderViewer();
  },
  initBody: function initBody() {
    var ownerDocument = this.element.ownerDocument;
    var body = ownerDocument.body || ownerDocument.documentElement;
    this.body = body;
    this.scrollbarWidth = window.innerWidth - ownerDocument.documentElement.clientWidth;
    this.initialBodyPaddingRight = body.style.paddingRight;
    this.initialBodyComputedPaddingRight = window.getComputedStyle(body).paddingRight;
  },
  initContainer: function initContainer() {
    this.containerData = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  },
  initViewer: function initViewer() {
    var options = this.options, parent = this.parent;
    var viewerData;
    if (options.inline) {
      viewerData = {
        width: Math.max(parent.offsetWidth, options.minWidth),
        height: Math.max(parent.offsetHeight, options.minHeight)
      };
      this.parentData = viewerData;
    }
    if (this.fulled || !viewerData) {
      viewerData = this.containerData;
    }
    this.viewerData = assign({}, viewerData);
  },
  renderViewer: function renderViewer() {
    if (this.options.inline && !this.fulled) {
      setStyle(this.viewer, this.viewerData);
    }
  },
  initList: function initList() {
    var _this = this;
    var element = this.element, options = this.options, list = this.list;
    var items = [];
    list.innerHTML = "";
    forEach(this.images, function(image, index2) {
      var src2 = image.src;
      var alt = image.alt || getImageNameFromURL(src2);
      var url2 = _this.getImageURL(image);
      if (src2 || url2) {
        var item = document.createElement("li");
        var img = document.createElement("img");
        forEach(options.inheritedAttributes, function(name) {
          var value9 = image.getAttribute(name);
          if (value9 !== null) {
            img.setAttribute(name, value9);
          }
        });
        img.src = src2 || url2;
        img.alt = alt;
        img.setAttribute("data-original-url", url2 || src2);
        item.setAttribute("data-index", index2);
        item.setAttribute("data-viewer-action", "view");
        item.setAttribute("role", "button");
        if (options.keyboard) {
          item.setAttribute("tabindex", 0);
        }
        item.appendChild(img);
        list.appendChild(item);
        items.push(item);
      }
    });
    this.items = items;
    forEach(items, function(item) {
      var image = item.firstElementChild;
      var onLoad3;
      var onError2;
      setData(image, "filled", true);
      if (options.loading) {
        addClass(item, CLASS_LOADING);
      }
      addListener(image, EVENT_LOAD, onLoad3 = function onLoad4(event) {
        removeListener(image, EVENT_ERROR, onError2);
        if (options.loading) {
          removeClass(item, CLASS_LOADING);
        }
        _this.loadImage(event);
      }, {
        once: true
      });
      addListener(image, EVENT_ERROR, onError2 = function onError3() {
        removeListener(image, EVENT_LOAD, onLoad3);
        if (options.loading) {
          removeClass(item, CLASS_LOADING);
        }
      }, {
        once: true
      });
    });
    if (options.transition) {
      addListener(element, EVENT_VIEWED, function() {
        addClass(list, CLASS_TRANSITION);
      }, {
        once: true
      });
    }
  },
  renderList: function renderList() {
    var index2 = this.index;
    var item = this.items[index2];
    if (!item) {
      return;
    }
    var next3 = item.nextElementSibling;
    var gutter = parseInt(window.getComputedStyle(next3 || item).marginLeft, 10);
    var offsetWidth = item.offsetWidth;
    var outerWidth = offsetWidth + gutter;
    setStyle(this.list, assign({
      width: outerWidth * this.length - gutter
    }, getTransforms({
      translateX: (this.viewerData.width - offsetWidth) / 2 - outerWidth * index2
    })));
  },
  resetList: function resetList() {
    var list = this.list;
    list.innerHTML = "";
    removeClass(list, CLASS_TRANSITION);
    setStyle(list, getTransforms({
      translateX: 0
    }));
  },
  initImage: function initImage(done) {
    var _this2 = this;
    var options = this.options, image = this.image, viewerData = this.viewerData;
    var footerHeight = this.footer.offsetHeight;
    var viewerWidth = viewerData.width;
    var viewerHeight = Math.max(viewerData.height - footerHeight, footerHeight);
    var oldImageData = this.imageData || {};
    var sizingImage;
    this.imageInitializing = {
      abort: function abort() {
        sizingImage.onload = null;
      }
    };
    sizingImage = getImageNaturalSizes(image, options, function(naturalWidth, naturalHeight) {
      var aspectRatio = naturalWidth / naturalHeight;
      var width = viewerWidth;
      var height = viewerHeight;
      _this2.imageInitializing = false;
      if (viewerHeight * aspectRatio > viewerWidth) {
        height = viewerWidth / aspectRatio;
      } else {
        width = viewerHeight * aspectRatio;
      }
      width = Math.min(width * 0.9, naturalWidth);
      height = Math.min(height * 0.9, naturalHeight);
      var left = (viewerWidth - width) / 2;
      var top = (viewerHeight - height) / 2;
      var imageData = {
        left,
        top,
        x: left,
        y: top,
        width,
        height,
        oldRatio: 1,
        ratio: width / naturalWidth,
        aspectRatio,
        naturalWidth,
        naturalHeight
      };
      var initialImageData = assign({}, imageData);
      if (options.rotatable) {
        imageData.rotate = oldImageData.rotate || 0;
        initialImageData.rotate = 0;
      }
      if (options.scalable) {
        imageData.scaleX = oldImageData.scaleX || 1;
        imageData.scaleY = oldImageData.scaleY || 1;
        initialImageData.scaleX = 1;
        initialImageData.scaleY = 1;
      }
      _this2.imageData = imageData;
      _this2.initialImageData = initialImageData;
      if (done) {
        done();
      }
    });
  },
  renderImage: function renderImage(done) {
    var _this3 = this;
    var image = this.image, imageData = this.imageData;
    setStyle(image, assign({
      width: imageData.width,
      height: imageData.height,
      marginLeft: imageData.x,
      marginTop: imageData.y
    }, getTransforms(imageData)));
    if (done) {
      if ((this.viewing || this.moving || this.rotating || this.scaling || this.zooming) && this.options.transition && hasClass(image, CLASS_TRANSITION)) {
        var onTransitionEnd2 = function onTransitionEnd3() {
          _this3.imageRendering = false;
          done();
        };
        this.imageRendering = {
          abort: function abort() {
            removeListener(image, EVENT_TRANSITION_END, onTransitionEnd2);
          }
        };
        addListener(image, EVENT_TRANSITION_END, onTransitionEnd2, {
          once: true
        });
      } else {
        done();
      }
    }
  },
  resetImage: function resetImage() {
    if (this.viewing || this.viewed) {
      var image = this.image;
      if (this.viewing) {
        this.viewing.abort();
      }
      image.parentNode.removeChild(image);
      this.image = null;
    }
  }
};
var events = {
  bind: function bind() {
    var options = this.options, viewer2 = this.viewer, canvas = this.canvas;
    var document2 = this.element.ownerDocument;
    addListener(viewer2, EVENT_CLICK, this.onClick = this.click.bind(this));
    addListener(viewer2, EVENT_DRAG_START, this.onDragStart = this.dragstart.bind(this));
    addListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown = this.pointerdown.bind(this));
    addListener(document2, EVENT_POINTER_MOVE, this.onPointerMove = this.pointermove.bind(this));
    addListener(document2, EVENT_POINTER_UP, this.onPointerUp = this.pointerup.bind(this));
    addListener(document2, EVENT_KEY_DOWN, this.onKeyDown = this.keydown.bind(this));
    addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
    if (options.zoomable && options.zoomOnWheel) {
      addListener(viewer2, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
        passive: false,
        capture: true
      });
    }
    if (options.toggleOnDblclick) {
      addListener(canvas, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
    }
  },
  unbind: function unbind() {
    var options = this.options, viewer2 = this.viewer, canvas = this.canvas;
    var document2 = this.element.ownerDocument;
    removeListener(viewer2, EVENT_CLICK, this.onClick);
    removeListener(viewer2, EVENT_DRAG_START, this.onDragStart);
    removeListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown);
    removeListener(document2, EVENT_POINTER_MOVE, this.onPointerMove);
    removeListener(document2, EVENT_POINTER_UP, this.onPointerUp);
    removeListener(document2, EVENT_KEY_DOWN, this.onKeyDown);
    removeListener(window, EVENT_RESIZE, this.onResize);
    if (options.zoomable && options.zoomOnWheel) {
      removeListener(viewer2, EVENT_WHEEL, this.onWheel, {
        passive: false,
        capture: true
      });
    }
    if (options.toggleOnDblclick) {
      removeListener(canvas, EVENT_DBLCLICK, this.onDblclick);
    }
  }
};
var handlers = {
  click: function click(event) {
    var options = this.options, imageData = this.imageData;
    var target = event.target;
    var action = getData(target, DATA_ACTION);
    if (!action && target.localName === "img" && target.parentElement.localName === "li") {
      target = target.parentElement;
      action = getData(target, DATA_ACTION);
    }
    if (IS_TOUCH_DEVICE && event.isTrusted && target === this.canvas) {
      clearTimeout(this.clickCanvasTimeout);
    }
    switch (action) {
      case "mix":
        if (this.played) {
          this.stop();
        } else if (options.inline) {
          if (this.fulled) {
            this.exit();
          } else {
            this.full();
          }
        } else {
          this.hide();
        }
        break;
      case "hide":
        this.hide();
        break;
      case "view":
        this.view(getData(target, "index"));
        break;
      case "zoom-in":
        this.zoom(0.1, true);
        break;
      case "zoom-out":
        this.zoom(-0.1, true);
        break;
      case "one-to-one":
        this.toggle();
        break;
      case "reset":
        this.reset();
        break;
      case "prev":
        this.prev(options.loop);
        break;
      case "play":
        this.play(options.fullscreen);
        break;
      case "next":
        this.next(options.loop);
        break;
      case "rotate-left":
        this.rotate(-90);
        break;
      case "rotate-right":
        this.rotate(90);
        break;
      case "flip-horizontal":
        this.scaleX(-imageData.scaleX || -1);
        break;
      case "flip-vertical":
        this.scaleY(-imageData.scaleY || -1);
        break;
      default:
        if (this.played) {
          this.stop();
        }
    }
  },
  dblclick: function dblclick(event) {
    event.preventDefault();
    if (this.viewed && event.target === this.image) {
      if (IS_TOUCH_DEVICE && event.isTrusted) {
        clearTimeout(this.doubleClickImageTimeout);
      }
      this.toggle(event);
    }
  },
  load: function load() {
    var _this = this;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = false;
    }
    var element = this.element, options = this.options, image = this.image, index2 = this.index, viewerData = this.viewerData;
    removeClass(image, CLASS_INVISIBLE);
    if (options.loading) {
      removeClass(this.canvas, CLASS_LOADING);
    }
    image.style.cssText = "height:0;" + "margin-left:".concat(viewerData.width / 2, "px;") + "margin-top:".concat(viewerData.height / 2, "px;") + "max-width:none!important;position:relative;width:0;";
    this.initImage(function() {
      toggleClass(image, CLASS_MOVE, options.movable);
      toggleClass(image, CLASS_TRANSITION, options.transition);
      _this.renderImage(function() {
        _this.viewed = true;
        _this.viewing = false;
        if (isFunction$1(options.viewed)) {
          addListener(element, EVENT_VIEWED, options.viewed, {
            once: true
          });
        }
        dispatchEvent(element, EVENT_VIEWED, {
          originalImage: _this.images[index2],
          index: index2,
          image
        }, {
          cancelable: false
        });
      });
    });
  },
  loadImage: function loadImage(event) {
    var image = event.target;
    var parent = image.parentNode;
    var parentWidth = parent.offsetWidth || 30;
    var parentHeight = parent.offsetHeight || 50;
    var filled = !!getData(image, "filled");
    getImageNaturalSizes(image, this.options, function(naturalWidth, naturalHeight) {
      var aspectRatio = naturalWidth / naturalHeight;
      var width = parentWidth;
      var height = parentHeight;
      if (parentHeight * aspectRatio > parentWidth) {
        if (filled) {
          width = parentHeight * aspectRatio;
        } else {
          height = parentWidth / aspectRatio;
        }
      } else if (filled) {
        height = parentWidth / aspectRatio;
      } else {
        width = parentHeight * aspectRatio;
      }
      setStyle(image, assign({
        width,
        height
      }, getTransforms({
        translateX: (parentWidth - width) / 2,
        translateY: (parentHeight - height) / 2
      })));
    });
  },
  keydown: function keydown(event) {
    var options = this.options;
    if (!options.keyboard) {
      return;
    }
    var keyCode = event.keyCode || event.which || event.charCode;
    switch (keyCode) {
      case 13:
        if (this.viewer.contains(event.target)) {
          this.click(event);
        }
        break;
    }
    if (!this.fulled) {
      return;
    }
    switch (keyCode) {
      case 27:
        if (this.played) {
          this.stop();
        } else if (options.inline) {
          if (this.fulled) {
            this.exit();
          }
        } else {
          this.hide();
        }
        break;
      case 32:
        if (this.played) {
          this.stop();
        }
        break;
      case 37:
        this.prev(options.loop);
        break;
      case 38:
        event.preventDefault();
        this.zoom(options.zoomRatio, true);
        break;
      case 39:
        this.next(options.loop);
        break;
      case 40:
        event.preventDefault();
        this.zoom(-options.zoomRatio, true);
        break;
      case 48:
      case 49:
        if (event.ctrlKey) {
          event.preventDefault();
          this.toggle();
        }
        break;
    }
  },
  dragstart: function dragstart(event) {
    if (event.target.localName === "img") {
      event.preventDefault();
    }
  },
  pointerdown: function pointerdown(event) {
    var options = this.options, pointers = this.pointers;
    var buttons = event.buttons, button2 = event.button;
    if (!this.viewed || this.showing || this.viewing || this.hiding || (event.type === "mousedown" || event.type === "pointerdown" && event.pointerType === "mouse") && (isNumber(buttons) && buttons !== 1 || isNumber(button2) && button2 !== 0 || event.ctrlKey)) {
      return;
    }
    event.preventDefault();
    if (event.changedTouches) {
      forEach(event.changedTouches, function(touch) {
        pointers[touch.identifier] = getPointer(touch);
      });
    } else {
      pointers[event.pointerId || 0] = getPointer(event);
    }
    var action = options.movable ? ACTION_MOVE : false;
    if (options.zoomOnTouch && options.zoomable && Object.keys(pointers).length > 1) {
      action = ACTION_ZOOM;
    } else if (options.slideOnTouch && (event.pointerType === "touch" || event.type === "touchstart") && this.isSwitchable()) {
      action = ACTION_SWITCH;
    }
    if (options.transition && (action === ACTION_MOVE || action === ACTION_ZOOM)) {
      removeClass(this.image, CLASS_TRANSITION);
    }
    this.action = action;
  },
  pointermove: function pointermove(event) {
    var pointers = this.pointers, action = this.action;
    if (!this.viewed || !action) {
      return;
    }
    event.preventDefault();
    if (event.changedTouches) {
      forEach(event.changedTouches, function(touch) {
        assign(pointers[touch.identifier] || {}, getPointer(touch, true));
      });
    } else {
      assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
    }
    this.change(event);
  },
  pointerup: function pointerup(event) {
    var _this2 = this;
    var options = this.options, action = this.action, pointers = this.pointers;
    var pointer;
    if (event.changedTouches) {
      forEach(event.changedTouches, function(touch) {
        pointer = pointers[touch.identifier];
        delete pointers[touch.identifier];
      });
    } else {
      pointer = pointers[event.pointerId || 0];
      delete pointers[event.pointerId || 0];
    }
    if (!action) {
      return;
    }
    event.preventDefault();
    if (options.transition && (action === ACTION_MOVE || action === ACTION_ZOOM)) {
      addClass(this.image, CLASS_TRANSITION);
    }
    this.action = false;
    if (IS_TOUCH_DEVICE && action !== ACTION_ZOOM && pointer && Date.now() - pointer.timeStamp < 500) {
      clearTimeout(this.clickCanvasTimeout);
      clearTimeout(this.doubleClickImageTimeout);
      if (options.toggleOnDblclick && this.viewed && event.target === this.image) {
        if (this.imageClicked) {
          this.imageClicked = false;
          this.doubleClickImageTimeout = setTimeout(function() {
            dispatchEvent(_this2.image, EVENT_DBLCLICK);
          }, 50);
        } else {
          this.imageClicked = true;
          this.doubleClickImageTimeout = setTimeout(function() {
            _this2.imageClicked = false;
          }, 500);
        }
      } else {
        this.imageClicked = false;
        if (options.backdrop && options.backdrop !== "static" && event.target === this.canvas) {
          this.clickCanvasTimeout = setTimeout(function() {
            dispatchEvent(_this2.canvas, EVENT_CLICK);
          }, 50);
        }
      }
    }
  },
  resize: function resize3() {
    var _this3 = this;
    if (!this.isShown || this.hiding) {
      return;
    }
    if (this.fulled) {
      this.close();
      this.initBody();
      this.open();
    }
    this.initContainer();
    this.initViewer();
    this.renderViewer();
    this.renderList();
    if (this.viewed) {
      this.initImage(function() {
        _this3.renderImage();
      });
    }
    if (this.played) {
      if (this.options.fullscreen && this.fulled && !(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
        this.stop();
        return;
      }
      forEach(this.player.getElementsByTagName("img"), function(image) {
        addListener(image, EVENT_LOAD, _this3.loadImage.bind(_this3), {
          once: true
        });
        dispatchEvent(image, EVENT_LOAD);
      });
    }
  },
  wheel: function wheel(event) {
    var _this4 = this;
    if (!this.viewed) {
      return;
    }
    event.preventDefault();
    if (this.wheeling) {
      return;
    }
    this.wheeling = true;
    setTimeout(function() {
      _this4.wheeling = false;
    }, 50);
    var ratio = Number(this.options.zoomRatio) || 0.1;
    var delta2 = 1;
    if (event.deltaY) {
      delta2 = event.deltaY > 0 ? 1 : -1;
    } else if (event.wheelDelta) {
      delta2 = -event.wheelDelta / 120;
    } else if (event.detail) {
      delta2 = event.detail > 0 ? 1 : -1;
    }
    this.zoom(-delta2 * ratio, true, event);
  }
};
var methods = {
  show: function show2() {
    var immediate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var element = this.element, options = this.options;
    if (options.inline || this.showing || this.isShown || this.showing) {
      return this;
    }
    if (!this.ready) {
      this.build();
      if (this.ready) {
        this.show(immediate);
      }
      return this;
    }
    if (isFunction$1(options.show)) {
      addListener(element, EVENT_SHOW, options.show, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_SHOW) === false || !this.ready) {
      return this;
    }
    if (this.hiding) {
      this.transitioning.abort();
    }
    this.showing = true;
    this.open();
    var viewer2 = this.viewer;
    removeClass(viewer2, CLASS_HIDE);
    viewer2.setAttribute("role", "dialog");
    viewer2.setAttribute("aria-labelledby", this.title.id);
    viewer2.setAttribute("aria-modal", true);
    viewer2.removeAttribute("aria-hidden");
    if (options.transition && !immediate) {
      var shown2 = this.shown.bind(this);
      this.transitioning = {
        abort: function abort() {
          removeListener(viewer2, EVENT_TRANSITION_END, shown2);
          removeClass(viewer2, CLASS_IN);
        }
      };
      addClass(viewer2, CLASS_TRANSITION);
      viewer2.initialOffsetWidth = viewer2.offsetWidth;
      addListener(viewer2, EVENT_TRANSITION_END, shown2, {
        once: true
      });
      addClass(viewer2, CLASS_IN);
    } else {
      addClass(viewer2, CLASS_IN);
      this.shown();
    }
    return this;
  },
  hide: function hide() {
    var _this = this;
    var immediate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var element = this.element, options = this.options;
    if (options.inline || this.hiding || !(this.isShown || this.showing)) {
      return this;
    }
    if (isFunction$1(options.hide)) {
      addListener(element, EVENT_HIDE, options.hide, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_HIDE) === false) {
      return this;
    }
    if (this.showing) {
      this.transitioning.abort();
    }
    this.hiding = true;
    if (this.played) {
      this.stop();
    } else if (this.viewing) {
      this.viewing.abort();
    }
    var viewer2 = this.viewer, image = this.image;
    var hideImmediately = function hideImmediately2() {
      removeClass(viewer2, CLASS_IN);
      _this.hidden();
    };
    if (options.transition && !immediate) {
      var onViewerTransitionEnd = function onViewerTransitionEnd2(event) {
        if (event && event.target === viewer2) {
          removeListener(viewer2, EVENT_TRANSITION_END, onViewerTransitionEnd2);
          _this.hidden();
        }
      };
      var onImageTransitionEnd = function onImageTransitionEnd2() {
        if (hasClass(viewer2, CLASS_TRANSITION)) {
          addListener(viewer2, EVENT_TRANSITION_END, onViewerTransitionEnd);
          removeClass(viewer2, CLASS_IN);
        } else {
          hideImmediately();
        }
      };
      this.transitioning = {
        abort: function abort() {
          if (_this.viewed && hasClass(image, CLASS_TRANSITION)) {
            removeListener(image, EVENT_TRANSITION_END, onImageTransitionEnd);
          } else if (hasClass(viewer2, CLASS_TRANSITION)) {
            removeListener(viewer2, EVENT_TRANSITION_END, onViewerTransitionEnd);
          }
        }
      };
      if (this.viewed && hasClass(image, CLASS_TRANSITION)) {
        addListener(image, EVENT_TRANSITION_END, onImageTransitionEnd, {
          once: true
        });
        this.zoomTo(0, false, null, true);
      } else {
        onImageTransitionEnd();
      }
    } else {
      hideImmediately();
    }
    return this;
  },
  view: function view() {
    var _this2 = this;
    var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.initialViewIndex;
    index2 = Number(index2) || 0;
    if (this.hiding || this.played || index2 < 0 || index2 >= this.length || this.viewed && index2 === this.index) {
      return this;
    }
    if (!this.isShown) {
      this.index = index2;
      return this.show();
    }
    if (this.viewing) {
      this.viewing.abort();
    }
    var element = this.element, options = this.options, title2 = this.title, canvas = this.canvas;
    var item = this.items[index2];
    var img = item.querySelector("img");
    var url2 = getData(img, "originalUrl");
    var alt = img.getAttribute("alt");
    var image = document.createElement("img");
    forEach(options.inheritedAttributes, function(name) {
      var value9 = img.getAttribute(name);
      if (value9 !== null) {
        image.setAttribute(name, value9);
      }
    });
    image.src = url2;
    image.alt = alt;
    if (isFunction$1(options.view)) {
      addListener(element, EVENT_VIEW, options.view, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_VIEW, {
      originalImage: this.images[index2],
      index: index2,
      image
    }) === false || !this.isShown || this.hiding || this.played) {
      return this;
    }
    var activeItem = this.items[this.index];
    if (activeItem) {
      removeClass(activeItem, CLASS_ACTIVE);
      activeItem.removeAttribute("aria-selected");
    }
    addClass(item, CLASS_ACTIVE);
    item.setAttribute("aria-selected", true);
    if (options.focus) {
      item.focus();
    }
    this.image = image;
    this.viewed = false;
    this.index = index2;
    this.imageData = {};
    addClass(image, CLASS_INVISIBLE);
    if (options.loading) {
      addClass(canvas, CLASS_LOADING);
    }
    canvas.innerHTML = "";
    canvas.appendChild(image);
    this.renderList();
    title2.innerHTML = "";
    var onViewed = function onViewed2() {
      var imageData = _this2.imageData;
      var render28 = Array.isArray(options.title) ? options.title[1] : options.title;
      title2.innerHTML = escapeHTMLEntities(isFunction$1(render28) ? render28.call(_this2, image, imageData) : "".concat(alt, " (").concat(imageData.naturalWidth, " \xD7 ").concat(imageData.naturalHeight, ")"));
    };
    var onLoad3;
    var onError2;
    addListener(element, EVENT_VIEWED, onViewed, {
      once: true
    });
    this.viewing = {
      abort: function abort() {
        removeListener(element, EVENT_VIEWED, onViewed);
        if (image.complete) {
          if (_this2.imageRendering) {
            _this2.imageRendering.abort();
          } else if (_this2.imageInitializing) {
            _this2.imageInitializing.abort();
          }
        } else {
          image.src = "";
          removeListener(image, EVENT_LOAD, onLoad3);
          if (_this2.timeout) {
            clearTimeout(_this2.timeout);
          }
        }
      }
    };
    if (image.complete) {
      this.load();
    } else {
      addListener(image, EVENT_LOAD, onLoad3 = function onLoad4() {
        removeListener(image, EVENT_ERROR, onError2);
        _this2.load();
      }, {
        once: true
      });
      addListener(image, EVENT_ERROR, onError2 = function onError3() {
        removeListener(image, EVENT_LOAD, onLoad3);
        if (_this2.timeout) {
          clearTimeout(_this2.timeout);
          _this2.timeout = false;
        }
        removeClass(image, CLASS_INVISIBLE);
        if (options.loading) {
          removeClass(_this2.canvas, CLASS_LOADING);
        }
      }, {
        once: true
      });
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(function() {
        removeClass(image, CLASS_INVISIBLE);
        _this2.timeout = false;
      }, 1e3);
    }
    return this;
  },
  prev: function prev3() {
    var loop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var index2 = this.index - 1;
    if (index2 < 0) {
      index2 = loop ? this.length - 1 : 0;
    }
    this.view(index2);
    return this;
  },
  next: function next2() {
    var loop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var maxIndex = this.length - 1;
    var index2 = this.index + 1;
    if (index2 > maxIndex) {
      index2 = loop ? 0 : maxIndex;
    }
    this.view(index2);
    return this;
  },
  move: function move2(x) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : x;
    var imageData = this.imageData;
    this.moveTo(isUndefined(x) ? x : imageData.x + Number(x), isUndefined(y) ? y : imageData.y + Number(y));
    return this;
  },
  moveTo: function moveTo(x) {
    var _this3 = this;
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : x;
    var _originalEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var element = this.element, options = this.options, imageData = this.imageData;
    x = Number(x);
    y = Number(y);
    if (this.viewed && !this.played && options.movable) {
      var oldX = imageData.x;
      var oldY = imageData.y;
      var changed = false;
      if (isNumber(x)) {
        changed = true;
      } else {
        x = oldX;
      }
      if (isNumber(y)) {
        changed = true;
      } else {
        y = oldY;
      }
      if (changed) {
        if (isFunction$1(options.move)) {
          addListener(element, EVENT_MOVE, options.move, {
            once: true
          });
        }
        if (dispatchEvent(element, EVENT_MOVE, {
          x,
          y,
          oldX,
          oldY,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }
        imageData.x = x;
        imageData.y = y;
        imageData.left = x;
        imageData.top = y;
        this.moving = true;
        this.renderImage(function() {
          _this3.moving = false;
          if (isFunction$1(options.moved)) {
            addListener(element, EVENT_MOVED, options.moved, {
              once: true
            });
          }
          dispatchEvent(element, EVENT_MOVED, {
            x,
            y,
            oldX,
            oldY,
            originalEvent: _originalEvent
          }, {
            cancelable: false
          });
        });
      }
    }
    return this;
  },
  rotate: function rotate(degree) {
    this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    return this;
  },
  rotateTo: function rotateTo(degree) {
    var _this4 = this;
    var element = this.element, options = this.options, imageData = this.imageData;
    degree = Number(degree);
    if (isNumber(degree) && this.viewed && !this.played && options.rotatable) {
      var oldDegree = imageData.rotate;
      if (isFunction$1(options.rotate)) {
        addListener(element, EVENT_ROTATE, options.rotate, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_ROTATE, {
        degree,
        oldDegree
      }) === false) {
        return this;
      }
      imageData.rotate = degree;
      this.rotating = true;
      this.renderImage(function() {
        _this4.rotating = false;
        if (isFunction$1(options.rotated)) {
          addListener(element, EVENT_ROTATED, options.rotated, {
            once: true
          });
        }
        dispatchEvent(element, EVENT_ROTATED, {
          degree,
          oldDegree
        }, {
          cancelable: false
        });
      });
    }
    return this;
  },
  scaleX: function scaleX(_scaleX) {
    this.scale(_scaleX, this.imageData.scaleY);
    return this;
  },
  scaleY: function scaleY(_scaleY) {
    this.scale(this.imageData.scaleX, _scaleY);
    return this;
  },
  scale: function scale(scaleX2) {
    var _this5 = this;
    var scaleY2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scaleX2;
    var element = this.element, options = this.options, imageData = this.imageData;
    scaleX2 = Number(scaleX2);
    scaleY2 = Number(scaleY2);
    if (this.viewed && !this.played && options.scalable) {
      var oldScaleX = imageData.scaleX;
      var oldScaleY = imageData.scaleY;
      var changed = false;
      if (isNumber(scaleX2)) {
        changed = true;
      } else {
        scaleX2 = oldScaleX;
      }
      if (isNumber(scaleY2)) {
        changed = true;
      } else {
        scaleY2 = oldScaleY;
      }
      if (changed) {
        if (isFunction$1(options.scale)) {
          addListener(element, EVENT_SCALE, options.scale, {
            once: true
          });
        }
        if (dispatchEvent(element, EVENT_SCALE, {
          scaleX: scaleX2,
          scaleY: scaleY2,
          oldScaleX,
          oldScaleY
        }) === false) {
          return this;
        }
        imageData.scaleX = scaleX2;
        imageData.scaleY = scaleY2;
        this.scaling = true;
        this.renderImage(function() {
          _this5.scaling = false;
          if (isFunction$1(options.scaled)) {
            addListener(element, EVENT_SCALED, options.scaled, {
              once: true
            });
          }
          dispatchEvent(element, EVENT_SCALED, {
            scaleX: scaleX2,
            scaleY: scaleY2,
            oldScaleX,
            oldScaleY
          }, {
            cancelable: false
          });
        });
      }
    }
    return this;
  },
  zoom: function zoom(ratio) {
    var hasTooltip = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _originalEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var imageData = this.imageData;
    ratio = Number(ratio);
    if (ratio < 0) {
      ratio = 1 / (1 - ratio);
    } else {
      ratio = 1 + ratio;
    }
    this.zoomTo(imageData.width * ratio / imageData.naturalWidth, hasTooltip, _originalEvent);
    return this;
  },
  zoomTo: function zoomTo(ratio) {
    var _this6 = this;
    var hasTooltip = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _originalEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var _zoomable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var element = this.element, options = this.options, pointers = this.pointers, imageData = this.imageData;
    var x = imageData.x, y = imageData.y, width = imageData.width, height = imageData.height, naturalWidth = imageData.naturalWidth, naturalHeight = imageData.naturalHeight;
    ratio = Math.max(0, ratio);
    if (isNumber(ratio) && this.viewed && !this.played && (_zoomable || options.zoomable)) {
      if (!_zoomable) {
        var minZoomRatio = Math.max(0.01, options.minZoomRatio);
        var maxZoomRatio = Math.min(100, options.maxZoomRatio);
        ratio = Math.min(Math.max(ratio, minZoomRatio), maxZoomRatio);
      }
      if (_originalEvent && options.zoomRatio >= 0.055 && ratio > 0.95 && ratio < 1.05) {
        ratio = 1;
      }
      var newWidth = naturalWidth * ratio;
      var newHeight = naturalHeight * ratio;
      var offsetWidth = newWidth - width;
      var offsetHeight = newHeight - height;
      var oldRatio = imageData.ratio;
      if (isFunction$1(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_ZOOM, {
        ratio,
        oldRatio,
        originalEvent: _originalEvent
      }) === false) {
        return this;
      }
      this.zooming = true;
      if (_originalEvent) {
        var offset = getOffset(this.viewer);
        var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY
        };
        imageData.x -= offsetWidth * ((center.pageX - offset.left - x) / width);
        imageData.y -= offsetHeight * ((center.pageY - offset.top - y) / height);
      } else {
        imageData.x -= offsetWidth / 2;
        imageData.y -= offsetHeight / 2;
      }
      imageData.left = imageData.x;
      imageData.top = imageData.y;
      imageData.width = newWidth;
      imageData.height = newHeight;
      imageData.oldRatio = oldRatio;
      imageData.ratio = ratio;
      this.renderImage(function() {
        _this6.zooming = false;
        if (isFunction$1(options.zoomed)) {
          addListener(element, EVENT_ZOOMED, options.zoomed, {
            once: true
          });
        }
        dispatchEvent(element, EVENT_ZOOMED, {
          ratio,
          oldRatio,
          originalEvent: _originalEvent
        }, {
          cancelable: false
        });
      });
      if (hasTooltip) {
        this.tooltip();
      }
    }
    return this;
  },
  play: function play() {
    var _this7 = this;
    var fullscreen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!this.isShown || this.played) {
      return this;
    }
    var element = this.element, options = this.options;
    if (isFunction$1(options.play)) {
      addListener(element, EVENT_PLAY, options.play, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_PLAY) === false) {
      return this;
    }
    var player = this.player;
    var onLoad3 = this.loadImage.bind(this);
    var list = [];
    var total = 0;
    var index2 = 0;
    this.played = true;
    this.onLoadWhenPlay = onLoad3;
    if (fullscreen) {
      this.requestFullscreen(fullscreen);
    }
    addClass(player, CLASS_SHOW);
    forEach(this.items, function(item, i) {
      var img = item.querySelector("img");
      var image = document.createElement("img");
      image.src = getData(img, "originalUrl");
      image.alt = img.getAttribute("alt");
      image.referrerPolicy = img.referrerPolicy;
      total += 1;
      addClass(image, CLASS_FADE);
      toggleClass(image, CLASS_TRANSITION, options.transition);
      if (hasClass(item, CLASS_ACTIVE)) {
        addClass(image, CLASS_IN);
        index2 = i;
      }
      list.push(image);
      addListener(image, EVENT_LOAD, onLoad3, {
        once: true
      });
      player.appendChild(image);
    });
    if (isNumber(options.interval) && options.interval > 0) {
      var play2 = function play3() {
        _this7.playing = setTimeout(function() {
          removeClass(list[index2], CLASS_IN);
          index2 += 1;
          index2 = index2 < total ? index2 : 0;
          addClass(list[index2], CLASS_IN);
          play3();
        }, options.interval);
      };
      if (total > 1) {
        play2();
      }
    }
    return this;
  },
  stop: function stop() {
    var _this8 = this;
    if (!this.played) {
      return this;
    }
    var element = this.element, options = this.options;
    if (isFunction$1(options.stop)) {
      addListener(element, EVENT_STOP, options.stop, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_STOP) === false) {
      return this;
    }
    var player = this.player;
    this.played = false;
    clearTimeout(this.playing);
    forEach(player.getElementsByTagName("img"), function(image) {
      removeListener(image, EVENT_LOAD, _this8.onLoadWhenPlay);
    });
    removeClass(player, CLASS_SHOW);
    player.innerHTML = "";
    this.exitFullscreen();
    return this;
  },
  full: function full() {
    var _this9 = this;
    var options = this.options, viewer2 = this.viewer, image = this.image, list = this.list;
    if (!this.isShown || this.played || this.fulled || !options.inline) {
      return this;
    }
    this.fulled = true;
    this.open();
    addClass(this.button, CLASS_FULLSCREEN_EXIT);
    if (options.transition) {
      removeClass(list, CLASS_TRANSITION);
      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
    }
    addClass(viewer2, CLASS_FIXED);
    viewer2.setAttribute("role", "dialog");
    viewer2.setAttribute("aria-labelledby", this.title.id);
    viewer2.setAttribute("aria-modal", true);
    viewer2.removeAttribute("style");
    setStyle(viewer2, {
      zIndex: options.zIndex
    });
    if (options.focus) {
      this.enforceFocus();
    }
    this.initContainer();
    this.viewerData = assign({}, this.containerData);
    this.renderList();
    if (this.viewed) {
      this.initImage(function() {
        _this9.renderImage(function() {
          if (options.transition) {
            setTimeout(function() {
              addClass(image, CLASS_TRANSITION);
              addClass(list, CLASS_TRANSITION);
            }, 0);
          }
        });
      });
    }
    return this;
  },
  exit: function exit() {
    var _this10 = this;
    var options = this.options, viewer2 = this.viewer, image = this.image, list = this.list;
    if (!this.isShown || this.played || !this.fulled || !options.inline) {
      return this;
    }
    this.fulled = false;
    this.close();
    removeClass(this.button, CLASS_FULLSCREEN_EXIT);
    if (options.transition) {
      removeClass(list, CLASS_TRANSITION);
      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
    }
    if (options.focus) {
      this.clearEnforceFocus();
    }
    viewer2.removeAttribute("role");
    viewer2.removeAttribute("aria-labelledby");
    viewer2.removeAttribute("aria-modal");
    removeClass(viewer2, CLASS_FIXED);
    setStyle(viewer2, {
      zIndex: options.zIndexInline
    });
    this.viewerData = assign({}, this.parentData);
    this.renderViewer();
    this.renderList();
    if (this.viewed) {
      this.initImage(function() {
        _this10.renderImage(function() {
          if (options.transition) {
            setTimeout(function() {
              addClass(image, CLASS_TRANSITION);
              addClass(list, CLASS_TRANSITION);
            }, 0);
          }
        });
      });
    }
    return this;
  },
  tooltip: function tooltip() {
    var _this11 = this;
    var options = this.options, tooltipBox = this.tooltipBox, imageData = this.imageData;
    if (!this.viewed || this.played || !options.tooltip) {
      return this;
    }
    tooltipBox.textContent = "".concat(Math.round(imageData.ratio * 100), "%");
    if (!this.tooltipping) {
      if (options.transition) {
        if (this.fading) {
          dispatchEvent(tooltipBox, EVENT_TRANSITION_END);
        }
        addClass(tooltipBox, CLASS_SHOW);
        addClass(tooltipBox, CLASS_FADE);
        addClass(tooltipBox, CLASS_TRANSITION);
        tooltipBox.removeAttribute("aria-hidden");
        tooltipBox.initialOffsetWidth = tooltipBox.offsetWidth;
        addClass(tooltipBox, CLASS_IN);
      } else {
        addClass(tooltipBox, CLASS_SHOW);
        tooltipBox.removeAttribute("aria-hidden");
      }
    } else {
      clearTimeout(this.tooltipping);
    }
    this.tooltipping = setTimeout(function() {
      if (options.transition) {
        addListener(tooltipBox, EVENT_TRANSITION_END, function() {
          removeClass(tooltipBox, CLASS_SHOW);
          removeClass(tooltipBox, CLASS_FADE);
          removeClass(tooltipBox, CLASS_TRANSITION);
          tooltipBox.setAttribute("aria-hidden", true);
          _this11.fading = false;
        }, {
          once: true
        });
        removeClass(tooltipBox, CLASS_IN);
        _this11.fading = true;
      } else {
        removeClass(tooltipBox, CLASS_SHOW);
        tooltipBox.setAttribute("aria-hidden", true);
      }
      _this11.tooltipping = false;
    }, 1e3);
    return this;
  },
  toggle: function toggle() {
    var _originalEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    if (this.imageData.ratio === 1) {
      this.zoomTo(this.imageData.oldRatio, true, _originalEvent);
    } else {
      this.zoomTo(1, true, _originalEvent);
    }
    return this;
  },
  reset: function reset() {
    if (this.viewed && !this.played) {
      this.imageData = assign({}, this.initialImageData);
      this.renderImage();
    }
    return this;
  },
  update: function update() {
    var _this12 = this;
    var element = this.element, options = this.options, isImg = this.isImg;
    if (isImg && !element.parentNode) {
      return this.destroy();
    }
    var images = [];
    forEach(isImg ? [element] : element.querySelectorAll("img"), function(image) {
      if (isFunction$1(options.filter)) {
        if (options.filter.call(_this12, image)) {
          images.push(image);
        }
      } else if (_this12.getImageURL(image)) {
        images.push(image);
      }
    });
    if (!images.length) {
      return this;
    }
    this.images = images;
    this.length = images.length;
    if (this.ready) {
      var changedIndexes = [];
      forEach(this.items, function(item, i) {
        var img = item.querySelector("img");
        var image = images[i];
        if (image && img) {
          if (image.src !== img.src || image.alt !== img.alt) {
            changedIndexes.push(i);
          }
        } else {
          changedIndexes.push(i);
        }
      });
      setStyle(this.list, {
        width: "auto"
      });
      this.initList();
      if (this.isShown) {
        if (this.length) {
          if (this.viewed) {
            var changedIndex = changedIndexes.indexOf(this.index);
            if (changedIndex >= 0) {
              this.viewed = false;
              this.view(Math.max(Math.min(this.index - changedIndex, this.length - 1), 0));
            } else {
              var activeItem = this.items[this.index];
              addClass(activeItem, CLASS_ACTIVE);
              activeItem.setAttribute("aria-selected", true);
            }
          }
        } else {
          this.image = null;
          this.viewed = false;
          this.index = 0;
          this.imageData = {};
          this.canvas.innerHTML = "";
          this.title.innerHTML = "";
        }
      }
    } else {
      this.build();
    }
    return this;
  },
  destroy: function destroy2() {
    var element = this.element, options = this.options;
    if (!element[NAMESPACE]) {
      return this;
    }
    this.destroyed = true;
    if (this.ready) {
      if (this.played) {
        this.stop();
      }
      if (options.inline) {
        if (this.fulled) {
          this.exit();
        }
        this.unbind();
      } else if (this.isShown) {
        if (this.viewing) {
          if (this.imageRendering) {
            this.imageRendering.abort();
          } else if (this.imageInitializing) {
            this.imageInitializing.abort();
          }
        }
        if (this.hiding) {
          this.transitioning.abort();
        }
        this.hidden();
      } else if (this.showing) {
        this.transitioning.abort();
        this.hidden();
      }
      this.ready = false;
      this.viewer.parentNode.removeChild(this.viewer);
    } else if (options.inline) {
      if (this.delaying) {
        this.delaying.abort();
      } else if (this.initializing) {
        this.initializing.abort();
      }
    }
    if (!options.inline) {
      removeListener(element, EVENT_CLICK, this.onStart);
    }
    element[NAMESPACE] = void 0;
    return this;
  }
};
var others = {
  getImageURL: function getImageURL(image) {
    var url2 = this.options.url;
    if (isString$1(url2)) {
      url2 = image.getAttribute(url2);
    } else if (isFunction$1(url2)) {
      url2 = url2.call(this, image);
    } else {
      url2 = "";
    }
    return url2;
  },
  enforceFocus: function enforceFocus() {
    var _this = this;
    this.clearEnforceFocus();
    addListener(document, EVENT_FOCUSIN, this.onFocusin = function(event) {
      var viewer2 = _this.viewer;
      var target = event.target;
      if (target !== document && target !== viewer2 && !viewer2.contains(target) && (target.getAttribute("tabindex") === null || target.getAttribute("aria-modal") !== "true")) {
        viewer2.focus();
      }
    });
  },
  clearEnforceFocus: function clearEnforceFocus() {
    if (this.onFocusin) {
      removeListener(document, EVENT_FOCUSIN, this.onFocusin);
      this.onFocusin = null;
    }
  },
  open: function open2() {
    var body = this.body;
    addClass(body, CLASS_OPEN);
    body.style.paddingRight = "".concat(this.scrollbarWidth + (parseFloat(this.initialBodyComputedPaddingRight) || 0), "px");
  },
  close: function close2() {
    var body = this.body;
    removeClass(body, CLASS_OPEN);
    body.style.paddingRight = this.initialBodyPaddingRight;
  },
  shown: function shown() {
    var element = this.element, options = this.options, viewer2 = this.viewer;
    this.fulled = true;
    this.isShown = true;
    this.render();
    this.bind();
    this.showing = false;
    if (options.focus) {
      viewer2.focus();
      this.enforceFocus();
    }
    if (isFunction$1(options.shown)) {
      addListener(element, EVENT_SHOWN, options.shown, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_SHOWN) === false) {
      return;
    }
    if (this.ready && this.isShown && !this.hiding) {
      this.view(this.index);
    }
  },
  hidden: function hidden() {
    var element = this.element, options = this.options, viewer2 = this.viewer;
    if (options.fucus) {
      this.clearEnforceFocus();
    }
    this.fulled = false;
    this.viewed = false;
    this.isShown = false;
    this.close();
    this.unbind();
    addClass(viewer2, CLASS_HIDE);
    viewer2.removeAttribute("role");
    viewer2.removeAttribute("aria-labelledby");
    viewer2.removeAttribute("aria-modal");
    viewer2.setAttribute("aria-hidden", true);
    this.resetList();
    this.resetImage();
    this.hiding = false;
    if (!this.destroyed) {
      if (isFunction$1(options.hidden)) {
        addListener(element, EVENT_HIDDEN, options.hidden, {
          once: true
        });
      }
      dispatchEvent(element, EVENT_HIDDEN, null, {
        cancelable: false
      });
    }
  },
  requestFullscreen: function requestFullscreen(options) {
    var document2 = this.element.ownerDocument;
    if (this.fulled && !(document2.fullscreenElement || document2.webkitFullscreenElement || document2.mozFullScreenElement || document2.msFullscreenElement)) {
      var documentElement = document2.documentElement;
      if (documentElement.requestFullscreen) {
        if (isPlainObject(options)) {
          documentElement.requestFullscreen(options);
        } else {
          documentElement.requestFullscreen();
        }
      } else if (documentElement.webkitRequestFullscreen) {
        documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (documentElement.mozRequestFullScreen) {
        documentElement.mozRequestFullScreen();
      } else if (documentElement.msRequestFullscreen) {
        documentElement.msRequestFullscreen();
      }
    }
  },
  exitFullscreen: function exitFullscreen() {
    var document2 = this.element.ownerDocument;
    if (this.fulled && (document2.fullscreenElement || document2.webkitFullscreenElement || document2.mozFullScreenElement || document2.msFullscreenElement)) {
      if (document2.exitFullscreen) {
        document2.exitFullscreen();
      } else if (document2.webkitExitFullscreen) {
        document2.webkitExitFullscreen();
      } else if (document2.mozCancelFullScreen) {
        document2.mozCancelFullScreen();
      } else if (document2.msExitFullscreen) {
        document2.msExitFullscreen();
      }
    }
  },
  change: function change(event) {
    var options = this.options, pointers = this.pointers;
    var pointer = pointers[Object.keys(pointers)[0]];
    if (!pointer) {
      return;
    }
    var offsetX = pointer.endX - pointer.startX;
    var offsetY = pointer.endY - pointer.startY;
    switch (this.action) {
      case ACTION_MOVE:
        this.move(offsetX, offsetY, event);
        break;
      case ACTION_ZOOM:
        this.zoom(getMaxZoomRatio(pointers), false, event);
        break;
      case ACTION_SWITCH: {
        this.action = "switched";
        var absoluteOffsetX = Math.abs(offsetX);
        if (absoluteOffsetX > 1 && absoluteOffsetX > Math.abs(offsetY)) {
          this.pointers = {};
          if (offsetX > 1) {
            this.prev(options.loop);
          } else if (offsetX < -1) {
            this.next(options.loop);
          }
        }
        break;
      }
    }
    forEach(pointers, function(p) {
      p.startX = p.endX;
      p.startY = p.endY;
    });
  },
  isSwitchable: function isSwitchable() {
    var imageData = this.imageData, viewerData = this.viewerData;
    return this.length > 1 && imageData.x >= 0 && imageData.y >= 0 && imageData.width <= viewerData.width && imageData.height <= viewerData.height;
  }
};
var AnotherViewer = WINDOW.Viewer;
var getUniqueID = function(id) {
  return function() {
    id += 1;
    return id;
  };
}(-1);
var Viewer = /* @__PURE__ */ function() {
  function Viewer2(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Viewer2);
    if (!element || element.nodeType !== 1) {
      throw new Error("The first argument is required and must be an element.");
    }
    this.element = element;
    this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
    this.action = false;
    this.fading = false;
    this.fulled = false;
    this.hiding = false;
    this.imageClicked = false;
    this.imageData = {};
    this.index = this.options.initialViewIndex;
    this.isImg = false;
    this.isShown = false;
    this.length = 0;
    this.moving = false;
    this.played = false;
    this.playing = false;
    this.pointers = {};
    this.ready = false;
    this.rotating = false;
    this.scaling = false;
    this.showing = false;
    this.timeout = false;
    this.tooltipping = false;
    this.viewed = false;
    this.viewing = false;
    this.wheeling = false;
    this.zooming = false;
    this.id = getUniqueID();
    this.init();
  }
  _createClass(Viewer2, [{
    key: "init",
    value: function init2() {
      var _this = this;
      var element = this.element, options = this.options;
      if (element[NAMESPACE]) {
        return;
      }
      element[NAMESPACE] = this;
      if (options.focus && !options.keyboard) {
        options.focus = false;
      }
      var isImg = element.localName === "img";
      var images = [];
      forEach(isImg ? [element] : element.querySelectorAll("img"), function(image) {
        if (isFunction$1(options.filter)) {
          if (options.filter.call(_this, image)) {
            images.push(image);
          }
        } else if (_this.getImageURL(image)) {
          images.push(image);
        }
      });
      this.isImg = isImg;
      this.length = images.length;
      this.images = images;
      this.initBody();
      if (isUndefined(document.createElement(NAMESPACE).style.transition)) {
        options.transition = false;
      }
      if (options.inline) {
        var count3 = 0;
        var progress = function progress2() {
          count3 += 1;
          if (count3 === _this.length) {
            var timeout;
            _this.initializing = false;
            _this.delaying = {
              abort: function abort() {
                clearTimeout(timeout);
              }
            };
            timeout = setTimeout(function() {
              _this.delaying = false;
              _this.build();
            }, 0);
          }
        };
        this.initializing = {
          abort: function abort() {
            forEach(images, function(image) {
              if (!image.complete) {
                removeListener(image, EVENT_LOAD, progress);
              }
            });
          }
        };
        forEach(images, function(image) {
          if (image.complete) {
            progress();
          } else {
            addListener(image, EVENT_LOAD, progress, {
              once: true
            });
          }
        });
      } else {
        addListener(element, EVENT_CLICK, this.onStart = function(_ref) {
          var target = _ref.target;
          if (target.localName === "img" && (!isFunction$1(options.filter) || options.filter.call(_this, target))) {
            _this.view(_this.images.indexOf(target));
          }
        });
      }
    }
  }, {
    key: "build",
    value: function build() {
      if (this.ready) {
        return;
      }
      var element = this.element, options = this.options;
      var parent = element.parentNode;
      var template = document.createElement("div");
      template.innerHTML = TEMPLATE;
      var viewer2 = template.querySelector(".".concat(NAMESPACE, "-container"));
      var title2 = viewer2.querySelector(".".concat(NAMESPACE, "-title"));
      var toolbar = viewer2.querySelector(".".concat(NAMESPACE, "-toolbar"));
      var navbar = viewer2.querySelector(".".concat(NAMESPACE, "-navbar"));
      var button2 = viewer2.querySelector(".".concat(NAMESPACE, "-button"));
      var canvas = viewer2.querySelector(".".concat(NAMESPACE, "-canvas"));
      this.parent = parent;
      this.viewer = viewer2;
      this.title = title2;
      this.toolbar = toolbar;
      this.navbar = navbar;
      this.button = button2;
      this.canvas = canvas;
      this.footer = viewer2.querySelector(".".concat(NAMESPACE, "-footer"));
      this.tooltipBox = viewer2.querySelector(".".concat(NAMESPACE, "-tooltip"));
      this.player = viewer2.querySelector(".".concat(NAMESPACE, "-player"));
      this.list = viewer2.querySelector(".".concat(NAMESPACE, "-list"));
      viewer2.id = "".concat(NAMESPACE).concat(this.id);
      title2.id = "".concat(NAMESPACE, "Title").concat(this.id);
      addClass(title2, !options.title ? CLASS_HIDE : getResponsiveClass(Array.isArray(options.title) ? options.title[0] : options.title));
      addClass(navbar, !options.navbar ? CLASS_HIDE : getResponsiveClass(options.navbar));
      toggleClass(button2, CLASS_HIDE, !options.button);
      if (options.keyboard) {
        button2.setAttribute("tabindex", 0);
      }
      if (options.backdrop) {
        addClass(viewer2, "".concat(NAMESPACE, "-backdrop"));
        if (!options.inline && options.backdrop !== "static") {
          setData(canvas, DATA_ACTION, "hide");
        }
      }
      if (isString$1(options.className) && options.className) {
        options.className.split(REGEXP_SPACES).forEach(function(className) {
          addClass(viewer2, className);
        });
      }
      if (options.toolbar) {
        var list = document.createElement("ul");
        var custom = isPlainObject(options.toolbar);
        var zoomButtons = BUTTONS.slice(0, 3);
        var rotateButtons = BUTTONS.slice(7, 9);
        var scaleButtons = BUTTONS.slice(9);
        if (!custom) {
          addClass(toolbar, getResponsiveClass(options.toolbar));
        }
        forEach(custom ? options.toolbar : BUTTONS, function(value9, index2) {
          var deep = custom && isPlainObject(value9);
          var name = custom ? hyphenate(index2) : value9;
          var show3 = deep && !isUndefined(value9.show) ? value9.show : value9;
          if (!show3 || !options.zoomable && zoomButtons.indexOf(name) !== -1 || !options.rotatable && rotateButtons.indexOf(name) !== -1 || !options.scalable && scaleButtons.indexOf(name) !== -1) {
            return;
          }
          var size2 = deep && !isUndefined(value9.size) ? value9.size : value9;
          var click2 = deep && !isUndefined(value9.click) ? value9.click : value9;
          var item = document.createElement("li");
          if (options.keyboard) {
            item.setAttribute("tabindex", 0);
          }
          item.setAttribute("role", "button");
          addClass(item, "".concat(NAMESPACE, "-").concat(name));
          if (!isFunction$1(click2)) {
            setData(item, DATA_ACTION, name);
          }
          if (isNumber(show3)) {
            addClass(item, getResponsiveClass(show3));
          }
          if (["small", "large"].indexOf(size2) !== -1) {
            addClass(item, "".concat(NAMESPACE, "-").concat(size2));
          } else if (name === "play") {
            addClass(item, "".concat(NAMESPACE, "-large"));
          }
          if (isFunction$1(click2)) {
            addListener(item, EVENT_CLICK, click2);
          }
          list.appendChild(item);
        });
        toolbar.appendChild(list);
      } else {
        addClass(toolbar, CLASS_HIDE);
      }
      if (!options.rotatable) {
        var rotates = toolbar.querySelectorAll('li[class*="rotate"]');
        addClass(rotates, CLASS_INVISIBLE);
        forEach(rotates, function(rotate2) {
          toolbar.appendChild(rotate2);
        });
      }
      if (options.inline) {
        addClass(button2, CLASS_FULLSCREEN);
        setStyle(viewer2, {
          zIndex: options.zIndexInline
        });
        if (window.getComputedStyle(parent).position === "static") {
          setStyle(parent, {
            position: "relative"
          });
        }
        parent.insertBefore(viewer2, element.nextSibling);
      } else {
        addClass(button2, CLASS_CLOSE);
        addClass(viewer2, CLASS_FIXED);
        addClass(viewer2, CLASS_FADE);
        addClass(viewer2, CLASS_HIDE);
        setStyle(viewer2, {
          zIndex: options.zIndex
        });
        var container = options.container;
        if (isString$1(container)) {
          container = element.ownerDocument.querySelector(container);
        }
        if (!container) {
          container = this.body;
        }
        container.appendChild(viewer2);
      }
      if (options.inline) {
        this.render();
        this.bind();
        this.isShown = true;
      }
      this.ready = true;
      if (isFunction$1(options.ready)) {
        addListener(element, EVENT_READY, options.ready, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_READY) === false) {
        this.ready = false;
        return;
      }
      if (this.ready && options.inline) {
        this.view(this.index);
      }
    }
  }], [{
    key: "noConflict",
    value: function noConflict() {
      window.Viewer = AnotherViewer;
      return Viewer2;
    }
  }, {
    key: "setDefaults",
    value: function setDefaults(options) {
      assign(DEFAULTS, isPlainObject(options) && options);
    }
  }]);
  return Viewer2;
}();
assign(Viewer.prototype, render$K, events, handlers, methods, others);
var render$J = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-image-preview",
    attrs: {
      "id": _vm.id
    }
  }, [_vm._t("default")], 2);
};
var staticRenderFns$J = [];
render$J._withStripped = true;
var index_vue_vue_type_style_index_0_lang$7 = "";
const __vue2_script$K = {
  name: "OpImagePreview",
  props: {
    id: {
      type: String,
      default: "preview"
    },
    options: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      viewer: null
    };
  },
  mounted() {
    this.init();
  },
  destroyed() {
    if (this.viewer) {
      this.viewer.destroy();
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const el = document.getElementById(this.id);
        const defaultOptions2 = {
          zIndex: 4e3,
          inheritedAttributes: ["data-custom-title", "data-location", "data-upload-time", "data-ignore"],
          viewed(event) {
            const image = event.detail.image;
            const location2 = image.getAttribute("data-location");
            const uploadTime = image.getAttribute("data-upload-time");
            const customTitle = image.getAttribute("data-custom-title");
            const defaultTitle = `${image.alt} (${image.naturalWidth} \xD7 ${image.naturalHeight})`;
            let htmlText = `<p>${customTitle || defaultTitle}</p>`;
            if (location2) {
              htmlText += `<p>${location2}</p>`;
            }
            if (uploadTime) {
              const _time = dataFilter(Number(uploadTime), "YYYY-MM-DD HH:mm");
              htmlText += `<p>${_time}</p>`;
            }
            this.viewer.title.innerHTML = htmlText;
          },
          filter(image) {
            const ignore = image.getAttribute("data-ignore");
            return !ignore;
          }
        };
        const options = Object.assign(defaultOptions2, this.options);
        if (el) {
          if (this.viewer) {
            this.viewer.update();
          } else {
            this.viewer = new Viewer(el, options);
          }
        }
      });
    },
    show(index2 = 0) {
      this.update();
      this.viewer.view(index2);
      this.viewer.show();
    },
    update() {
      if (this.viewer.images.length === 0) {
        this.viewer.update();
      }
    },
    forceUpdate() {
      this.viewer.update();
    }
  }
};
const __cssModules$K = {};
var __component__$K = /* @__PURE__ */ normalizeComponent(__vue2_script$K, render$J, staticRenderFns$J, false, __vue2_injectStyles$K, null, null, null);
function __vue2_injectStyles$K(context2) {
  for (let o in __cssModules$K) {
    this[o] = __cssModules$K[o];
  }
}
__component__$K.options.__file = "packages/op-image-preview/src/index.vue";
var ImagePreview2 = /* @__PURE__ */ function() {
  return __component__$K.exports;
}();
var viewer = "";
ImagePreview2.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(ImagePreview2.name, prefix);
  Vue2.component(comName, ImagePreview2);
};
var __glob_6_12 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": ImagePreview2
});
var props$5 = {
  value: {
    type: String,
    default: ""
  },
  optionFilter: {
    type: [Function, null],
    defualt: null
  },
  infiniteStr: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: false
  },
  onChange: {
    type: [Function, null],
    default: null
  },
  onValError: {
    type: [Function, null],
    default: null
  },
  precision: {
    type: Number,
    default: 2
  },
  max: {
    type: Number,
    default: 0
  },
  min: {
    type: Number,
    default: 0
  }
};
const GE = "ge";
const LE = "le";
const LT = "lt";
const GT = "gt";
const GTLT = "gtlt";
const GTLE = "gtle";
const GELT = "gelt";
const GELE = "gele";
const NUMBER_RXP = /^[\d|.]$/;
const INFINITE = "";
const OPTIONS = [{
  label: "< x",
  value: GT
}, {
  label: "\u2264 x",
  value: GE
}, {
  label: "x <",
  value: LT
}, {
  label: "x \u2264",
  value: LE
}, {
  label: "< x <",
  value: GTLT
}, {
  label: "< x \u2264",
  value: GTLE
}, {
  label: "\u2264 x <",
  value: GELT
}, {
  label: "\u2264 x <",
  value: GELE
}];
function shouldHasMin(type) {
  return type && (type.indexOf(GE) > -1 || type.indexOf(GT) > -1);
}
function shouldHasMax(type) {
  return type && (type.indexOf(LT) > -1 || type.indexOf(LE) > -1);
}
let currentToken = null;
let stack = [];
function emit(token) {
  stack.push(token);
}
function closeTag(c) {
  if (c.match(NUMBER_RXP)) {
    currentToken.value += c;
    return closeTag;
  } else if (c === ")") {
    currentToken.type = LT;
    emit(currentToken);
    return data11;
  } else if (c === "]") {
    currentToken.type = LE;
    emit(currentToken);
    return data11;
  } else {
    return closeTag;
  }
}
function openTag(c) {
  if (c.match(NUMBER_RXP)) {
    currentToken.value += c;
    return openTag;
  } else if (c === "(") {
    currentToken.type = GT;
    return openTag;
  } else if (c === "[") {
    currentToken.type = GE;
    return openTag;
  } else if (c === ",") {
    emit(currentToken);
    currentToken = {
      type: "",
      value: ""
    };
    return closeTag;
  } else {
    return openTag;
  }
}
function data11(c) {
  if (c === "(" || c === "[") {
    currentToken = {
      type: "",
      value: ""
    };
    return openTag(c);
  } else {
    return data11;
  }
}
function toObject$1(array) {
  const _obj = {
    type: "",
    value: []
  };
  for (let item of array) {
    if (item.value) {
      _obj.type += item.type;
    }
    _obj.value.push(item.value);
  }
  return _obj;
}
function setInfinite(infiniteStr) {
  const _i = infiniteStr || INFINITE;
  stack.forEach((x) => {
    if (x.value === _i) {
      x.value = "";
    }
  });
}
function parseStr(str, infiniteStr) {
  stack = [];
  let state = data11;
  for (const c of str) {
    state = state(c);
  }
  setInfinite(infiniteStr);
  return stack;
}
function parseStrToObj(str, infiniteStr) {
  const array = parseStr(str, infiniteStr);
  return toObject$1(array);
}
function objectRender(obj, infiniteStr) {
  const {
    type,
    value: value9 = []
  } = obj;
  const first = value9[0] === 0 ? value9[0] : value9[0] || infiniteStr || INFINITE;
  const second = value9[1] || infiniteStr || INFINITE;
  if (type === GT) {
    return `(${first},${second})`;
  } else if (type === GE) {
    return `[${first},${second})`;
  } else if (type === LT) {
    return `(${first},${second})`;
  } else if (type === LE) {
    return `(${first},${second}]`;
  } else if (type === GTLT) {
    return `(${first},${second})`;
  } else if (type === GTLE) {
    return `(${first},${second}]`;
  } else if (type === GELT) {
    return `[${first},${second})`;
  } else if (type === GELE) {
    return `[${first},${second}]`;
  }
}
function useIntervalsVal(props2) {
  const options = ref([]);
  const minDiasbled = ref(false);
  const maxDiasbled = ref(false);
  options.value = props2.optionFilter ? props2.optionFilter(JSON.parse(JSON.stringify(OPTIONS))) : OPTIONS;
  const {
    value: value9
  } = toRefs(props2);
  const intervalsVal = ref({
    type: "",
    value: ["", ""]
  });
  const [internalValue, setInnerValue] = useVModel(value9, "", props2.onChange, "change");
  const text = computed(() => {
    if (intervalsVal.value.type && intervalsVal.value.value.some((x) => !!x)) {
      const signLabel = options.value.filter((x) => x.value === intervalsVal.value.type);
      return `${intervalsVal.value.value[0]} ${signLabel[0].label} ${intervalsVal.value.value[1]}`;
    } else {
      return "";
    }
  });
  const handleSignChange = (val) => {
    if (val === GT || val === GE) {
      maxDiasbled.value = true;
      minDiasbled.value = false;
      intervalsVal.value.value[1] = "";
    } else if (val === LT || val === LE) {
      minDiasbled.value = true;
      maxDiasbled.value = false;
      intervalsVal.value.value[0] = "";
    } else {
      maxDiasbled.value = false;
      minDiasbled.value = false;
    }
  };
  const handleError = (type) => {
    let message2 = "";
    const [min, max] = intervalsVal.value.value;
    const hasMinAndMaxVal = min && max && intervalsVal.value.type;
    const judgeMaxLessThanMin = hasMinAndMaxVal && Number(max) <= Number(min);
    props2.min && min && shouldHasMin(intervalsVal.value.type) && min < props2.min;
    props2.max && max && shouldHasMax(intervalsVal.value.type) && max > props2.max;
    if (shouldHasMax(intervalsVal.value.type) && !max) {
      message2 = `\u5FC5\u987B\u586B\u5165\u6700\u5927\u503C\uFF0C\u5E76\u4E14\u503C\u4E0D\u80FD\u5C0F\u4E8E\u7B49\u4E8E0`;
    }
    if (judgeMaxLessThanMin) {
      if (type === "min") {
        intervalsVal.value.value = ["", max];
      } else if (type === "max") {
        intervalsVal.value.value = [min, ""];
      } else if (type === "sign") {
        intervalsVal.value.value = ["", ""];
      }
      message2 = "\u6700\u5C0F\u503C\u4E0D\u80FD\u5927\u4E8E\u6700\u5927\u503C";
    }
    if (props2.onValError && message2) {
      props2.onValError(intervalsVal.value, {
        type: intervalsVal.value.type,
        value: [min, max]
      }, message2);
    }
  };
  watch(() => value9.value, (nval, oval) => {
    if ((!oval || oval.type) && nval) {
      const _obj = parseStrToObj(nval, props2.infiniteStr);
      if (_obj.value.every((x) => !x)) {
        intervalsVal.value.value = _obj.value;
      } else {
        intervalsVal.value = _obj;
      }
      handleSignChange(intervalsVal.value.type);
    }
  }, {
    immediate: true
  });
  return {
    options,
    intervalsVal,
    text,
    minDiasbled,
    maxDiasbled,
    setInnerValue,
    handleSignChange,
    handleError
  };
}
var render$I = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-intervals-select"
  }, [!_vm.disabled ? [_c("el-input-number", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.minDiasbled,
      expression: "!minDiasbled"
    }],
    staticClass: "control",
    attrs: {
      "controls": false,
      "disabled": _vm.minDiasbled,
      "precision": _vm.precision,
      "min": _vm.min ? _vm.min : -Infinity,
      "placeholder": "\n    \u8BF7\u8F93\u5165\u6570\u503C",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.handleChange("min");
      }
    },
    model: {
      value: _vm.intervalsVal.value[0],
      callback: function($$v) {
        _vm.$set(_vm.intervalsVal.value, 0, $$v);
      },
      expression: "intervalsVal.value[0]"
    }
  }), _c("el-select", {
    staticClass: "control",
    attrs: {
      "clearable": "",
      "placeholder": "\u9009\u62E9\u5173\u7CFB\u7B26\u53F7"
    },
    on: {
      "change": _vm.handleSignSelect
    },
    model: {
      value: _vm.intervalsVal.type,
      callback: function($$v) {
        _vm.$set(_vm.intervalsVal, "type", $$v);
      },
      expression: "intervalsVal.type"
    }
  }, _vm._l(_vm.options, function(item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1), _c("el-input-number", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.maxDiasbled,
      expression: "!maxDiasbled"
    }],
    staticClass: "control",
    attrs: {
      "controls": false,
      "precision": _vm.precision,
      "disabled": _vm.maxDiasbled,
      "max": _vm.max ? _vm.max : Infinity,
      "clearable": "",
      "placeholder": "\u8BF7\u8F93\u5165\u6570\u503C"
    },
    on: {
      "change": function($event) {
        return _vm.handleChange("max");
      }
    },
    model: {
      value: _vm.intervalsVal.value[1],
      callback: function($$v) {
        _vm.$set(_vm.intervalsVal.value, 1, $$v);
      },
      expression: "intervalsVal.value[1]"
    }
  })] : [_c("div", [_vm._v(_vm._s(_vm.text))])]], 2);
};
var staticRenderFns$I = [];
render$I._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$7 = "";
const __vue2_script$J = defineComponent({
  name: "OpIntervalsSelect",
  props: __spreadValues({}, props$5),
  setup(props2) {
    const {
      options,
      intervalsVal,
      minDiasbled,
      maxDiasbled,
      text,
      setInnerValue,
      handleSignChange,
      handleError
    } = useIntervalsVal(props2);
    const handleSignSelect = (val) => {
      handleSignChange(val);
      handleChange("sign");
    };
    const handleChange = (type) => {
      let str = "";
      handleError(type);
      if (intervalsVal.value.type) {
        str = objectRender(intervalsVal.value, props2.infiniteStr);
      }
      setInnerValue(str, intervalsVal.value);
    };
    return {
      intervalsVal,
      options,
      minDiasbled,
      maxDiasbled,
      text,
      handleChange,
      handleSignSelect
    };
  }
});
const __cssModules$J = {};
var __component__$J = /* @__PURE__ */ normalizeComponent(__vue2_script$J, render$I, staticRenderFns$I, false, __vue2_injectStyles$J, "ef08a2e6", null, null);
function __vue2_injectStyles$J(context2) {
  for (let o in __cssModules$J) {
    this[o] = __cssModules$J[o];
  }
}
__component__$J.options.__file = "packages/op-intervals-select/src/pc/index.vue";
var PcComponent$1 = /* @__PURE__ */ function() {
  return __component__$J.exports;
}();
var render$H = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_vm._v(_vm._s(_vm.text))]);
};
var staticRenderFns$H = [];
render$H._withStripped = true;
const __vue2_script$I = defineComponent({
  name: "OpIntervalsSelect",
  props: __spreadValues({}, props$5),
  setup(props2) {
    const {
      text
    } = useIntervalsVal(props2);
    return {
      text
    };
  }
});
const __cssModules$I = {};
var __component__$I = /* @__PURE__ */ normalizeComponent(__vue2_script$I, render$H, staticRenderFns$H, false, __vue2_injectStyles$I, null, null, null);
function __vue2_injectStyles$I(context2) {
  for (let o in __cssModules$I) {
    this[o] = __cssModules$I[o];
  }
}
__component__$I.options.__file = "packages/op-intervals-select/src/mobile/index.vue";
var MobileComponent$1 = /* @__PURE__ */ function() {
  return __component__$I.exports;
}();
const Component$1 = {};
Component$1.install = (Vue2) => {
  if (isPCWidth()) {
    Vue2.component(PcComponent$1.name, PcComponent$1);
  } else {
    Vue2.component(MobileComponent$1.name, MobileComponent$1);
  }
};
var __glob_6_13 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": Component$1
});
var render$G = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "addressPosition"
  }, [_c("div", {
    style: {
      height: _vm.height
    },
    attrs: {
      "id": "amapContainer"
    }
  }), _c("div", {
    staticClass: "search"
  }, [_c("op-address-input", {
    attrs: {
      "auto-hide-after-blur": 100,
      "clearable": ""
    },
    on: {
      "change": _vm.addressChange
    },
    model: {
      value: _vm.keywords,
      callback: function($$v) {
        _vm.keywords = $$v;
      },
      expression: "keywords"
    }
  })], 1)]);
};
var staticRenderFns$G = [];
render$G._withStripped = true;
var main_vue_vue_type_style_index_0_scoped_true_lang = "";
var main_vue_vue_type_style_index_1_lang = "";
const __vue2_script$H = defineComponent({
  name: "OpMap",
  props: {
    lnglat: {
      type: [Array, null]
    },
    address: {
      type: String
    },
    height: {
      type: String,
      default: "500px"
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const keywords = ref("");
    const {
      map,
      location: location2,
      initMap,
      setSingleMarker,
      setCenter
    } = useAmapJsApi({
      elIds: {
        container: "amapContainer"
      },
      callback: handleEvent2
    });
    function handleEvent2(event) {
      if (event === EVENT_TYPE.SET_MARKER) {
        emit2("set-marker", location2.value);
      }
    }
    async function addressChange(val) {
      await setSingleMarker(val.location.split(","), val.formatAddress);
      setCenter(val.location.split(","));
    }
    onMounted(() => {
      initMap().then(async () => {
        if (props2.lnglat && props2.lnglat[0] && props2.lnglat[1]) {
          await setSingleMarker(props2.lnglat, props2.address);
          setCenter(props2.lnglat);
        }
      });
    });
    return {
      map,
      keywords,
      addressChange
    };
  }
});
const __cssModules$H = {};
var __component__$H = /* @__PURE__ */ normalizeComponent(__vue2_script$H, render$G, staticRenderFns$G, false, __vue2_injectStyles$H, "1e1e32c4", null, null);
function __vue2_injectStyles$H(context2) {
  for (let o in __cssModules$H) {
    this[o] = __cssModules$H[o];
  }
}
__component__$H.options.__file = "packages/op-map-select/src/main.vue";
var OpMap = /* @__PURE__ */ function() {
  return __component__$H.exports;
}();
var render$F = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("el-dialog", {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": _vm.width,
      "title": "\u5730\u56FE\u9009\u62E9"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event;
      },
      "close": _vm.closed
    }
  }, [_c("op-map", {
    attrs: {
      "lnglat": _vm.lnglat,
      "height": _vm.height
    },
    on: {
      "set-marker": _vm.handleMark
    }
  }), _c("div", {
    staticClass: "btn-area"
  }, [_c("el-button", {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\u786E\u5B9A")]), _c("el-button", {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("\u53D6\u6D88")])], 1)], 1)], 1);
};
var staticRenderFns$F = [];
render$F._withStripped = true;
var DialogMap_vue_vue_type_style_index_0_scoped_true_lang = "";
const ERROR_TYPE = {
  NO_LOCATION: {
    type: "no_location",
    message: "\u6CA1\u6709\u9009\u62E9\u4F4D\u7F6E"
  }
};
const __vue2_script$G = {
  name: "OpDialogMap",
  components: {
    OpMap
  },
  props: {
    lnglat: {
      type: [Array, null]
    },
    address: {
      type: String
    },
    height: {
      type: String,
      default: "500px"
    },
    width: {
      type: String,
      default: "80%"
    },
    onError: {
      type: [Function, null],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      locationData: null
    };
  },
  created() {
    this.dialogVisible = true;
  },
  methods: {
    closed() {
      this.$emit("close");
    },
    handleMark(val) {
      this.locationData = val;
    },
    submit() {
      if (!this.locationData && this.onError) {
        this.onError({
          type: ERROR_TYPE.NO_LOCATION.type,
          message: ERROR_TYPE.NO_LOCATION.message,
          data: this.locationData
        }, this.closed);
        return;
      }
      this.$emit("submit", this.locationData);
      this.dialogVisible = false;
    }
  }
};
const __cssModules$G = {};
var __component__$G = /* @__PURE__ */ normalizeComponent(__vue2_script$G, render$F, staticRenderFns$F, false, __vue2_injectStyles$G, "72c818bf", null, null);
function __vue2_injectStyles$G(context2) {
  for (let o in __cssModules$G) {
    this[o] = __cssModules$G[o];
  }
}
__component__$G.options.__file = "packages/op-map-select/src/DialogMap.vue";
var DialogMap = /* @__PURE__ */ function() {
  return __component__$G.exports;
}();
const DialogMapConstrutor = Vue$1.extend(DialogMap);
let instance$2 = null;
const DialogMapFnc = (options) => {
  instance$2 = new DialogMapConstrutor({
    propsData: options
  });
  instance$2.vm = instance$2.$mount();
  document.body.appendChild(instance$2.vm.$el);
  const amapResultDom = document.querySelector(".amap-sug-result");
  instance$2.vm.$on("close", () => {
    document.body.removeChild(instance$2.vm.$el);
    if (amapResultDom) {
      document.body.removeChild(amapResultDom);
    }
    instance$2.vm.$destroy();
  });
  return new Promise((resolve) => {
    instance$2.vm.$on("submit", (val) => {
      resolve(val);
    });
  });
};
DialogMap.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(DialogMap.name, prefix);
  Vue2.component(comName, DialogMap);
  Vue2.prototype.$mapSelect = DialogMapFnc;
};
var __glob_6_14 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  DialogMapFnc,
  "default": DialogMap
});
function getMarketLine() {
  const options = ref([]);
  const flatData = ref([]);
  const treeData = ref([]);
  function setCascaderData(tree) {
    tree.forEach((i) => {
      if (Array.isArray(i.children) && i.children.length > 0) {
        setCascaderData(i.children);
      } else {
        flatData.value.push({
          label: i.name,
          value: i.id
        });
        delete i.children;
      }
    });
    return tree;
  }
  const getData2 = async (classify) => {
    if (!classify) {
      options.value = [];
      return [];
    }
    const res = await getMarketLineList({
      orgBelongMarketClassify: classify
    });
    if (res.status && res.data) {
      options.value = setCascaderData(res.data);
    }
    return options.value;
  };
  const getTreeData = async (classifys = []) => {
    const res = await getMarketLineTree();
    const _classifys = classifys.map((item) => item.toLocaleUpperCase());
    if (res.status && res.data) {
      treeData.value = res.data.filter((item) => _classifys.includes(item.belongMarketClassify));
    }
    return treeData.value;
  };
  return {
    options,
    flatData,
    treeData,
    getData: getData2,
    getTreeData
  };
}
function useSelect$1(props2) {
  const {
    value: value9
  } = toRefs(props2);
  const [internalValue, setInnerValue] = useVModel(value9, "", props2.onChange, "change");
  const selected = ref([]);
  const lastValue = ref("");
  function checkIsMultipleVal(val) {
    return val && val.some((x) => Array.isArray(x));
  }
  const initData = (options) => {
    if (!value9.value || value9.value.length === 0) {
      return;
    }
  };
  const handleSelect = (val) => {
    if (checkIsMultipleVal(val)) {
      const _vals = val.map((item) => item[item.length - 1]);
      setInnerValue(_vals, val);
    } else {
      const _vals = [val[val.length - 1]];
      setInnerValue(_vals, val);
      lastValue.value = val[val.length - 1];
    }
  };
  return {
    selected,
    lastValue,
    initData,
    handleSelect
  };
}
var props$4 = {
  value: {
    type: Array,
    default: () => []
  },
  multiple: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  onChange: {
    type: [Function, null],
    default: null
  },
  classify: {
    type: String,
    default: ""
  }
};
var render$E = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "market-line"
  }, [_c("el-cascader", {
    staticClass: "market-line__selector",
    attrs: {
      "expand-trigger": "click",
      "props": _vm.cascaderProps,
      "options": _vm.options,
      "separator": "-",
      "clearable": "",
      "placeholder": "\u8BF7\u9009\u62E9\u6240\u5C5E\u7EBF\u522B",
      "collapse-tags": "",
      "show-all-levels": false,
      "disabled": _vm.disabled,
      "popper-class": "market-line__selector-popup"
    },
    on: {
      "change": _vm.handleSelect
    },
    model: {
      value: _vm.selected,
      callback: function($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1);
};
var staticRenderFns$E = [];
render$E._withStripped = true;
var index_vue_vue_type_style_index_0_lang$6 = "";
const __vue2_script$F = defineComponent({
  name: "OpMarketLineSelect",
  props: __spreadValues({}, props$4),
  setup(props2) {
    const {
      options,
      getData: getData2
    } = getMarketLine();
    const {
      selected,
      initData,
      handleSelect
    } = useSelect$1(props2);
    const cascaderProps = reactive({
      label: "name",
      children: "children",
      disabled: "disabled",
      value: "id",
      multiple: props2.multiple
    });
    onMounted(() => {
      getData2(props2.classify).then((options2) => {
        initData(options2);
      });
    });
    return {
      options,
      cascaderProps,
      selected,
      initData,
      getData: getData2,
      handleSelect
    };
  }
});
const __cssModules$F = {};
var __component__$F = /* @__PURE__ */ normalizeComponent(__vue2_script$F, render$E, staticRenderFns$E, false, __vue2_injectStyles$F, null, null, null);
function __vue2_injectStyles$F(context2) {
  for (let o in __cssModules$F) {
    this[o] = __cssModules$F[o];
  }
}
__component__$F.options.__file = "packages/op-market-line-select/src/pc/index.vue";
var Selector$2 = /* @__PURE__ */ function() {
  return __component__$F.exports;
}();
var render$D = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "channel"
  }, [_c("field-pannel", {
    attrs: {
      "list": _vm.viewList
    },
    on: {
      "open": _vm.open
    }
  }), _c("van-popup", {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: _vm.visible,
      callback: function($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("van-cascader", {
    attrs: {
      "field-names": _vm.cascaderProps,
      "title": "\u8BF7\u9009\u62E9\u6E20\u9053",
      "options": _vm.options
    },
    on: {
      "close": _vm.close,
      "finish": _vm.onFinish
    },
    model: {
      value: _vm.lastValue,
      callback: function($$v) {
        _vm.lastValue = $$v;
      },
      expression: "lastValue"
    }
  })], 1)], 1);
};
var staticRenderFns$D = [];
render$D._withStripped = true;
var index_vue_vue_type_style_index_0_lang$5 = "";
const __vue2_script$E = defineComponent({
  name: "OpMarketLineSelect",
  components: {
    FieldPannel
  },
  props: __spreadValues({}, props$4),
  setup(props2) {
    const {
      getData: getData2,
      flatData,
      options
    } = getMarketLine();
    const {
      selected,
      lastValue,
      initData,
      handleSelect
    } = useSelect$1(props2);
    const {
      visible: visible2,
      open: open3,
      close: close3
    } = useModal(props2);
    const cascaderProps = reactive({
      text: "name",
      children: "children",
      value: "id"
    });
    onMounted(() => {
      getData2(props2.classify).then(() => {
        initData();
      });
    });
    const onFinish = ({
      selectedOptions
    }) => {
      /* @__PURE__ */ console.log(selectedOptions);
      const _val = selectedOptions.map((item) => item.id);
      handleSelect(_val, selectedOptions);
      visible2.value = false;
    };
    const viewList = computed(() => {
      if (flatData.value && flatData.value.length > 0) {
        return flatData.value.filter((x) => props2.value.includes(x.value));
      } else {
        return [];
      }
    });
    return {
      options,
      cascaderProps,
      selected,
      viewList,
      visible: visible2,
      lastValue,
      initData,
      handleSelect,
      open: open3,
      close: close3,
      onFinish
    };
  }
});
const __cssModules$E = {};
var __component__$E = /* @__PURE__ */ normalizeComponent(__vue2_script$E, render$D, staticRenderFns$D, false, __vue2_injectStyles$E, null, null, null);
function __vue2_injectStyles$E(context2) {
  for (let o in __cssModules$E) {
    this[o] = __cssModules$E[o];
  }
}
__component__$E.options.__file = "packages/op-market-line-select/src/mobile/index.vue";
var MobileSelector$1 = /* @__PURE__ */ function() {
  return __component__$E.exports;
}();
Selector$2.install = (Vue2) => {
  if (isPCWidth()) {
    Vue2.component(Selector$2.name, Selector$2);
  } else {
    Vue2.component(MobileSelector$1.name, MobileSelector$1);
  }
};
var __glob_6_15 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": Selector$2
});
function getMarketUserData$1(props2) {
  const loading2 = ref(false);
  const tableData = ref([]);
  const total = ref(0);
  const params = ref({
    pageNo: 1,
    pageSize: 20
  });
  const buildObject = (arr) => {
    const obj = {};
    for (let i = 0; i < arr.length; i++) {
      const {
        key: key2,
        value: value9
      } = arr[i];
      obj[key2] = value9;
    }
    return obj;
  };
  const initParams = (str) => {
    if (props2.defaultSearchConfig && props2.defaultSearchConfig.formItem && props2.defaultSearchConfig.formItem.length) {
      let defaultSearchConfig = props2.defaultSearchConfig;
      if (str == "clear") {
        defaultSearchConfig.formItem.map((item) => {
          if (item.type) {
            return item.value = null;
          }
        });
      }
      let paramsObj = buildObject(defaultSearchConfig.formItem);
      params.value = Object.assign(params.value, paramsObj);
      params.value.pageNo = 1;
    }
  };
  const onSearch = (str) => {
    initParams(str);
    getMarketUser(params.value);
  };
  const getMarketUser = function(paramsVal) {
    return new Promise((resolve, reject) => {
      try {
        loading2.value = true;
        getMarketSearch(paramsVal).then((res) => {
          if (res.status && res.data && Array.isArray(res.data.records)) {
            resolve(res.data);
            loading2.value = false;
            tableData.value = res.data.records;
            total.value = res.data.total;
          }
        });
      } catch (error) {
        /* @__PURE__ */ console.log(error, "\u83B7\u53D6\u6570\u636E\u5931\u8D25");
      }
    });
  };
  return {
    loading: loading2,
    tableData,
    total,
    params,
    initParams,
    onSearch,
    getMarketUser
  };
}
function variablesAndMethodsCollect$1(emit2, props2) {
  const {
    visible: visible2,
    close: close3,
    open: open3
  } = useModal(props2);
  const currentVal = ref([]);
  const selected = ref([]);
  const params = ref({
    pageNo: 1,
    pageSize: 20
  });
  const singleValue = ref("");
  const searchConfig = ref(null);
  const multipleTable = ref(null);
  const {
    value: value9
  } = toRefs(props2);
  const [internalValue, setInnerValue] = useVModel(value9, [], () => {
  }, "change");
  const removeSelected = (item, index2) => {
    currentVal.value.splice(index2, 1);
    setInnerValue(currentVal.value);
  };
  const rowClick = (row) => {
    multipleTable.value.toggleRowSelection(row);
  };
  const removeDialogSelected = (item, index2) => {
    multipleTable.value.selection.splice(index2, 1);
    selected.value = multipleTable.value.selection;
  };
  const handleCurrent = (val) => {
    if (val && !props2.multiple) {
      singleValue.value = val;
      selected.value = [val];
    }
  };
  const handleSelectionChange = (val) => {
    if (props2.multiple) {
      selected.value = val;
    }
  };
  const submit2 = () => {
    currentVal.value = selected.value;
    setInnerValue(selected.value);
    /* @__PURE__ */ console.log(selected);
    close3();
  };
  return {
    currentVal,
    selected,
    params,
    singleValue,
    searchConfig,
    visible: visible2,
    multipleTable,
    removeSelected,
    rowClick,
    removeDialogSelected,
    handleCurrent,
    handleSelectionChange,
    close: close3,
    submit: submit2,
    open: open3
  };
}
var props$3 = {
  title: {
    type: String,
    default: "\u5546\u573A\u9009\u62E9"
  },
  placeholder: {
    type: String,
    default: "\u8BF7\u9009\u62E9\u5546\u573A"
  },
  disabled: {
    type: Boolean,
    default: false
  },
  multiple: {
    type: Boolean,
    default: true
  },
  defaultSearchConfig: {
    type: Object,
    default: () => ({
      labelWidth: "50px",
      align: "right",
      formItem: [{
        type: "input",
        label: "\u5173\u952E\u5B57",
        labelWidth: "60px",
        value: null,
        key: "keyword",
        placeholder: "\u5173\u952E\u5B57",
        span: 4
      }, {
        type: "select",
        label: "\u54C1\u724C",
        key: "brandName",
        value: null,
        clearable: true,
        multiple: true,
        span: 6,
        options: [{
          value: 1,
          label: "1"
        }, {
          value: 2,
          label: "3"
        }]
      }]
    })
  },
  tableHead: {
    type: Array,
    default: () => [{
      label: "\u5546\u573A\u7F16\u7801",
      value: "no",
      "min-width": "50"
    }, {
      label: "\u5546\u573A\u540D\u79F0",
      value: "name",
      "min-width": "100"
    }, {
      label: "\u5546\u573A\u7B80\u79F0",
      value: "simpleName",
      "min-width": "50"
    }]
  },
  value: {
    type: Array,
    default: () => []
  }
};
var render$C = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "market-select"
  }, [_c("div", {
    on: {
      "click": _vm.showDialog
    }
  }, [_c("div", {
    staticClass: "el-input el-input--mini",
    class: {
      "is-disabled": _vm.disabled
    }
  }, [_c("div", {
    staticClass: "el-input__inner"
  }, [_vm.currentVal.length ? _vm._l(_vm.currentVal, function(item, index2) {
    return _c("el-tag", {
      key: item.id,
      staticClass: "mr-5 tag",
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "size": "mini",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.removeSelected(item, index2);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }) : [_c("div", {
    staticStyle: {
      "color": "#c0c4cc"
    }
  }, [_vm._v(_vm._s(_vm.placeholder))])]], 2)])]), _c("el-dialog", {
    attrs: {
      "title": _vm.title,
      "append-to-body": "",
      "visible": _vm.visible,
      "width": "1200px",
      "top": "8vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("el-container", [_c("el-main", {
    staticClass: "market-select-chooseArea"
  }, [_c("div", {
    staticClass: "market-select-chooseArea__search"
  }, [_vm.searchConfig ? _c("el-form", {
    ref: "form",
    attrs: {
      "label-width": _vm.searchConfig.labelWidth,
      "label-position": _vm.searchConfig.align
    }
  }, [_c("el-row", [_vm._l(_vm.searchConfig.formItem, function(formItem) {
    return _c("el-col", {
      key: formItem.key,
      attrs: {
        "span": formItem.span
      }
    }, [_c("el-form-item", {
      attrs: {
        "label": formItem.label,
        "label-width": formItem.labelWidth
      }
    }, [formItem.type == "input" ? _c("el-input", {
      attrs: {
        "placeholder": formItem.placeholder
      },
      model: {
        value: formItem.value,
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v);
        },
        expression: "formItem.value"
      }
    }) : formItem.type === "select" ? _c("el-select", {
      attrs: {
        "disabled": formItem.disabled,
        "clearable": formItem.clearable,
        "multiple": formItem.multiple,
        "filterable": formItem.filterable
      },
      model: {
        value: formItem.value,
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v);
        },
        expression: "formItem.value"
      }
    }, _vm._l(formItem.options, function(o) {
      return _c("el-option", {
        key: o.value,
        attrs: {
          "label": o.label,
          "value": o.value,
          "disabled": o.disabled
        }
      });
    }), 1) : _vm._e()], 1)], 1);
  }), _c("el-col", {
    attrs: {
      "span": 5
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_vm._v("\u641C\u7D22")]), _c("el-button", {
    on: {
      "click": function($event) {
        return _vm.onSearch("clear");
      }
    }
  }, [_vm._v("\u91CD\u7F6E")])], 1)], 1)], 2)], 1) : _vm._e()], 1), _vm.visible ? _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "multipleTable",
    attrs: {
      "border": "",
      "data": _vm.tableData,
      "row-key": "id",
      "height": _vm.height
    },
    on: {
      "row-click": _vm.rowClick,
      "selection-change": _vm.handleSelectionChange,
      "current-change": _vm.handleCurrent
    }
  }, [_vm.multiple ? _c("el-table-column", {
    attrs: {
      "type": "selection",
      "width": "55",
      "reserve-selection": true
    }
  }) : _c("el-table-column", {
    attrs: {
      "label": "",
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c("el-radio", {
          staticStyle: {
            "padding-left": "10px",
            "margin-right": "-25px"
          },
          attrs: {
            "label": scope.row.id
          },
          model: {
            value: _vm.singleValue.id,
            callback: function($$v) {
              _vm.$set(_vm.singleValue, "id", $$v);
            },
            expression: "singleValue.id"
          }
        }, [_vm._v("\xA0")])];
      }
    }], null, false, 2886113683)
  }), _vm._l(_vm.tableHead, function(item) {
    return _c("el-table-column", {
      key: item.id,
      attrs: {
        "label": item.label,
        "align": "center",
        "min-width": item.width
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[item.value]))];
        }
      }], null, true)
    });
  })], 2) : _vm._e(), _c("el-pagination", {
    staticClass: "market-select-chooseArea__pagination",
    attrs: {
      "current-page": _vm.params.pageNo,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.params.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "pageNo", $event);
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "pageNo", $event);
      },
      "update:pageSize": function($event) {
        return _vm.$set(_vm.params, "pageSize", $event);
      },
      "update:page-size": function($event) {
        return _vm.$set(_vm.params, "pageSize", $event);
      },
      "current-change": function($event) {
        return _vm.getMarketUser(_vm.params);
      },
      "size-change": function($event) {
        return _vm.getMarketUser(_vm.params);
      }
    }
  })], 1), _vm.multiple ? _c("el-aside", {
    staticClass: "market-select-choosed",
    attrs: {
      "width": "250px"
    }
  }, [_c("el-card", {
    staticClass: "box-card"
  }, [_c("div", {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("\u5DF2\u9009\u62E9")])]), _c("div", {
    style: "height:" + (_vm.height - 24) + "px;overflow: auto;"
  }, _vm._l(_vm.selected, function(item, index2) {
    return _c("div", {
      key: item.id
    }, [_c("el-tag", {
      staticClass: "market-select-choosed__tag",
      attrs: {
        "size": "medium",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.removeDialogSelected(item, index2);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 0)])], 1) : _vm._e()], 1), _c("el-footer", {
    staticClass: "market-select-button"
  }, [_c("el-button", {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\u53D6 \u6D88")]), _c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\u786E \u5B9A")])], 1)], 1)], 1);
};
var staticRenderFns$C = [];
render$C._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$6 = "";
const __vue2_script$D = defineComponent({
  name: "OpMarketSelect",
  props: __spreadValues({}, props$3),
  setup(props2, {
    emit: emit2
  }) {
    const height = ref(500);
    const {
      loading: loading2,
      tableData,
      total,
      getMarketUser,
      initParams,
      onSearch,
      params
    } = getMarketUserData$1(props2);
    const {
      visible: visible2,
      currentVal,
      selected,
      singleValue,
      searchConfig,
      removeSelected,
      multipleTable,
      rowClick,
      removeDialogSelected,
      handleCurrent,
      handleSelectionChange,
      close: close3,
      submit: submit2
    } = variablesAndMethodsCollect$1(emit2, props2);
    onMounted(() => {
      currentVal.value = props2.value;
    });
    const showDialog = () => {
      visible2.value = true;
      initParams();
      getMarketUser(params.value);
      nextTick(() => {
        if (props2.value && props2.value.length > 0) {
          multipleTable.value.selection.push(...props2.value);
          selected.value = props2.value;
          if (!props2.multiple) {
            singleValue.value = props2.value && props2.value.length && props2.value[0];
          }
        }
      });
      searchConfig.value = __spreadValues({}, props2.defaultSearchConfig);
    };
    return {
      multipleTable,
      height,
      loading: loading2,
      tableData,
      total,
      visible: visible2,
      currentVal,
      searchConfig,
      params,
      selected,
      singleValue,
      getMarketUser,
      removeSelected,
      showDialog,
      onSearch,
      rowClick,
      removeDialogSelected,
      handleCurrent,
      handleSelectionChange,
      close: close3,
      submit: submit2,
      initParams
    };
  }
});
const __cssModules$D = {};
var __component__$D = /* @__PURE__ */ normalizeComponent(__vue2_script$D, render$C, staticRenderFns$C, false, __vue2_injectStyles$D, "6869a6fb", null, null);
function __vue2_injectStyles$D(context2) {
  for (let o in __cssModules$D) {
    this[o] = __cssModules$D[o];
  }
}
__component__$D.options.__file = "packages/op-market-select/src/pc/index.vue";
var MarketSelect$1 = /* @__PURE__ */ function() {
  return __component__$D.exports;
}();
var render$B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "market-select"
  }, [_c("field-pannel", {
    attrs: {
      "list": _vm.currentVal,
      "disabled": _vm.disabled,
      "config": {
        label: "name",
        value: "id"
      }
    },
    on: {
      "open": _vm.open
    }
  }), _c("van-popup", {
    attrs: {
      "value": _vm.visible,
      "position": "bottom"
    },
    on: {
      "open": _vm.showDialog,
      "close": function($event) {
        _vm.selected = [];
        _vm.visible = false;
      },
      "click-overlay": function($event) {
        _vm.selected = [];
        _vm.visible = false;
      }
    }
  }, [_c("div", {
    staticClass: "market-select-chooseArea"
  }, [_c("van-search", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u5546\u573A\u540D\u79F0"
    },
    on: {
      "search": _vm.onRefresh
    },
    model: {
      value: _vm.params.searchStr,
      callback: function($$v) {
        _vm.$set(_vm.params, "searchStr", $$v);
      },
      expression: "params.searchStr"
    }
  }), _c("div", {
    style: "height: " + _vm.height + "px; overflow: auto"
  }, [_c("van-pull-refresh", {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: _vm.refreshing,
      callback: function($$v) {
        _vm.refreshing = $$v;
      },
      expression: "refreshing"
    }
  }, [_c("van-list", {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "\u6CA1\u6709\u66F4\u591A\u4E86",
      "immediate-check": false
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: _vm.loading,
      callback: function($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, [_vm.multiple ? [_c("van-checkbox-group", {
    on: {
      "change": _vm.changeShop
    },
    model: {
      value: _vm.currentIdVal,
      callback: function($$v) {
        _vm.currentIdVal = $$v;
      },
      expression: "currentIdVal"
    }
  }, [_c("van-cell-group", _vm._l(_vm.shopList, function(item, index2) {
    return _c("van-cell", {
      key: item.id,
      attrs: {
        "clickable": "",
        "title": item.no + "--" + item.name
      },
      on: {
        "click": function($event) {
          return _vm.toggle(item, index2);
        }
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c("van-checkbox", {
            ref: "checkboxes" + index2,
            refInFor: true,
            attrs: {
              "name": item.id,
              "icon-size": "14px",
              "shape": "square",
              "checked-color": "#fc9153"
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)], 1)] : [_c("van-radio-group", {
    on: {
      "change": _vm.changeShop
    },
    model: {
      value: _vm.singleValue,
      callback: function($$v) {
        _vm.singleValue = $$v;
      },
      expression: "singleValue"
    }
  }, [_c("van-cell-group", _vm._l(_vm.shopList, function(item, index2) {
    return _c("van-cell", {
      key: item.id,
      attrs: {
        "clickable": "",
        "title": item.name
      },
      on: {
        "click": function($event) {
          return _vm.toggle(item, index2);
        }
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c("van-radio", {
            attrs: {
              "name": item.id,
              "icon-size": "14px",
              "checked-color": "#fc9153"
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)], 1)]], 2)], 1)], 1), _c("div", {
    staticClass: "market-select-choosed"
  }, [_vm._v(" \u5F53\u524D\u5546\u573A\uFF1A "), _vm._l(_vm.selected, function(shop, index2) {
    return _c("span", {
      key: shop.id,
      staticClass: "market-select-choosed__tag"
    }, [_vm._v(" " + _vm._s(shop.no + "--" + shop.name) + _vm._s(index2 !== _vm.selected.length - 1 ? "\uFF0C" : "") + " ")]);
  })], 2), _c("van-button", {
    staticClass: "market-select-button",
    attrs: {
      "type": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v("\u786E\u8BA4")])], 1)])], 1);
};
var staticRenderFns$B = [];
render$B._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$5 = "";
const __vue2_script$C = defineComponent({
  name: "OpMarketSelect",
  components: {
    FieldPannel
  },
  props: __spreadValues({}, props$3),
  setup(props2, {
    emit: emit2
  }) {
    const refreshing = ref(false);
    const finished = ref(false);
    const currentIdVal = ref([]);
    const shopList = ref([]);
    const {
      loading: loading2,
      total,
      params,
      getMarketUser,
      initParams
    } = getMarketUserData$1(props2);
    const {
      visible: visible2,
      singleValue,
      selected,
      open: open3,
      submit: submit2,
      currentVal
    } = variablesAndMethodsCollect$1(emit2, props2);
    const height = ref(200);
    const {
      $refs
    } = proxyGetCurrentInstance();
    onMounted(() => {
      height.value = window.innerHeight - 60 - 54 * 2 - 100;
      currentVal.value = props2.value;
      initParams();
      getMarketUserMobile();
    });
    const getMarketUserMobile = () => {
      getMarketUser(params.value, props2.isVirtual).then((res) => {
        if (Array.isArray(res.records)) {
          shopList.value = params.value.pageNo === 1 ? res.records : shopList.value.concat(res.records);
          refreshing.value = false;
          finished.value = shopList.value.length >= total.value;
          loading2.value = false;
        } else {
          refreshing.value = false;
          loading2.value = false;
          finished.value = true;
        }
      });
    };
    const showDialog = () => {
      if (!props2.disabled) {
        visible2.value = true;
        nextTick(() => {
          if (props2.value && props2.value.length > 0) {
            selected.value = props2.value;
            currentIdVal.value = props2.value.length && props2.value.map((i) => i.id) || [];
            singleValue.value = props2.multiple ? "" : props2.value[0].id;
          }
        });
      }
    };
    const onLoad3 = () => {
      if (loading2.value) {
        params.value.pageNo++;
        getMarketUserMobile();
      }
    };
    const onRefresh = () => {
      params.value.pageNo = 1;
      getMarketUserMobile();
    };
    const toggle5 = (item, index2) => {
      if (props2.multiple) {
        nextTick(() => {
          $refs[`checkboxes${Number(index2)}`] && $refs[`checkboxes${Number(index2)}`][0].toggle();
        });
      } else {
        singleValue.value = item.id;
        selected.value = [item];
      }
    };
    const changeShop = (val) => {
      if (props2.multiple) {
        selected.value = [];
        if (val) {
          selected.value = val.map((item) => {
            return shopList.value.find((data22) => data22.id == item);
          });
        }
      }
    };
    return {
      visible: visible2,
      currentVal,
      singleValue,
      currentIdVal,
      params,
      selected,
      loading: loading2,
      total,
      refreshing,
      finished,
      height,
      shopList,
      getMarketUser,
      open: open3,
      onLoad: onLoad3,
      onRefresh,
      toggle: toggle5,
      changeShop,
      submit: submit2,
      initParams,
      showDialog,
      getMarketUserMobile
    };
  }
});
const __cssModules$C = {};
var __component__$C = /* @__PURE__ */ normalizeComponent(__vue2_script$C, render$B, staticRenderFns$B, false, __vue2_injectStyles$C, "41ab3c6a", null, null);
function __vue2_injectStyles$C(context2) {
  for (let o in __cssModules$C) {
    this[o] = __cssModules$C[o];
  }
}
__component__$C.options.__file = "packages/op-market-select/src/mobile/index.vue";
var MobileMarketSelect = /* @__PURE__ */ function() {
  return __component__$C.exports;
}();
MarketSelect$1.install = (Vue2) => {
  if (!Vue2.prototype.$loading) {
    Vue2.use(_Loading.directive);
    Vue2.prototype.$loading = _Loading.service;
  }
  if (isPCWidth()) {
    Vue2.component(MarketSelect$1.name, MarketSelect$1);
  } else {
    Vue2.component(MobileMarketSelect.name, MobileMarketSelect);
  }
};
var __glob_6_16 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": MarketSelect$1
});
var render$A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "card"
  }, [_vm.head ? _c("el-card", {
    staticClass: "card__head op_card_head",
    attrs: {
      "shadow": "never"
    }
  }, [_vm._t("head")], 2) : _vm._e(), _vm.content ? _c("el-card", {
    staticClass: "card__content",
    attrs: {
      "shadow": "never"
    }
  }, [_vm._t("content")], 2) : _vm._e(), _vm.foot ? _c("el-card", {
    staticClass: "card__foot",
    attrs: {
      "shadow": "never"
    }
  }, [_vm._t("foot")], 2) : _vm._e()], 1);
};
var staticRenderFns$A = [];
render$A._withStripped = true;
var NormalCard_vue_vue_type_style_index_0_lang = "";
const __vue2_script$B = {
  computed: {
    head() {
      return !!this.$slots.head;
    },
    content() {
      return !!this.$slots.content;
    },
    foot() {
      return !!this.$slots.foot;
    }
  }
};
const __cssModules$B = {};
var __component__$B = /* @__PURE__ */ normalizeComponent(__vue2_script$B, render$A, staticRenderFns$A, false, __vue2_injectStyles$B, null, null, null);
function __vue2_injectStyles$B(context2) {
  for (let o in __cssModules$B) {
    this[o] = __cssModules$B[o];
  }
}
__component__$B.options.__file = "src/components/common/NormalCard.vue";
var Card = /* @__PURE__ */ function() {
  return __component__$B.exports;
}();
const ajax = (config) => new AjaxConfig(config);
const getCommodityPages = (params) => {
  return request(ajax().post("/bsplatform/commodity/pageCriteriaQuery"), params);
};
const getDepartmentListByConToPost = (params) => {
  return request(ajax().post("/ucenterapi/internal/department/getDepartmentListByConToPost"), params);
};
const catalogCreate = (params) => {
  return request(ajax().post("/bsplatform/catalog/create"), params);
};
const catalogDetail = ({
  id
}) => {
  return request(ajax().get(`/bsplatform/catalog/${id}/detail`));
};
const catalogDelete = ({
  id
}) => {
  return request(ajax().delete(`/bsplatform/catalog/${id}/delete`));
};
const catalogTree = (params) => {
  return request(ajax().get("/bsplatform/catalog/listByTreeByParentId"), params);
};
const catalogModify = (params) => {
  return request(ajax().post("/bsplatform/catalog/modify"), params);
};
const getApplicableSystem = (params) => {
  return request(ajax().get("/bsplatform/app/listAll"), params);
};
const pageTagConfigQuery = (params) => {
  return request(ajax().post("/bsplatform/tag/pageCriteriaQuery"), params);
};
const querySelectedTagSet = (params) => {
  return request(ajax().post("/bsplatform/tagObject/querySelectedTagSet"), params);
};
const batchTagging = (params) => {
  return request(ajax().post("/bsplatform/tagObject/batchTagging"), params);
};
const batchTagPage = (params) => {
  return request(ajax().post("/bsplatform/tag/value/pageCriteriaQuery"), params);
};
var render$z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("el-dialog", {
    attrs: {
      "title": _vm.title,
      "append-to-body": "",
      "visible": _vm.dialogVisible,
      "width": "50%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("Card", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }]
  }, [_c("div", {
    staticClass: "tag-select",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c("el-row", {
    attrs: {
      "gutter": 20
    }
  }, [_c("el-col", {
    staticClass: "tag",
    attrs: {
      "span": 24
    }
  }, [_c("el-card", {
    staticClass: "box-card"
  }, [_c("div", {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("\u914D\u7F6E\u6807\u7B7E\uFF1A")])]), _c("div", _vm._l(_vm.selectList, function(item, index2) {
    return _c("el-tag", {
      key: index2,
      attrs: {
        "type": "success",
        "size": "medium",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleAddClose(item, index2);
        }
      }
    }, [_c("span", [_vm._v(_vm._s(item.valueName))]), _c("span", {
      staticStyle: {
        "color": "#ababab"
      }
    }, [_vm._v("\uFF08" + _vm._s(item.tagName) + "\uFF09")])]);
  }), 1)])], 1), _c("el-col", {
    staticClass: "search",
    attrs: {
      "span": 14
    }
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165",
      "size": "medium",
      "clearable": ""
    },
    model: {
      value: _vm.searchObj.name,
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "name", $$v);
      },
      expression: "searchObj.name"
    }
  }, [_c("span", {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_vm._v("\u6807\u7B7E\u5206\u7C7B")]), _c("el-button", {
    attrs: {
      "slot": "append",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1), _c("el-col", {
    attrs: {
      "span": 24
    }
  }, [_c("el-row", [_c("div", {
    staticClass: "tag-list"
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "label-width": "120px",
      "size": "mini"
    }
  }, _vm._l(_vm.listData, function(item, index2) {
    return _c("el-col", {
      key: index2,
      staticClass: "search",
      attrs: {
        "span": 24
      }
    }, [item.inputType === "MULTIPLE" ? [_c("el-form-item", {
      attrs: {
        "label": item.name + "\uFF1A"
      }
    }, [_c("el-checkbox-group", {
      on: {
        "change": function($event) {
          return _vm.checkChange(_vm.form[item.code], item.code);
        }
      },
      model: {
        value: _vm.form[item.code],
        callback: function($$v) {
          _vm.$set(_vm.form, item.code, $$v);
        },
        expression: "form[item.code]"
      }
    }, _vm._l(item.tagValues, function(it, idx) {
      return _c("el-checkbox", {
        key: idx,
        attrs: {
          "label": it.valueCode
        }
      }, [_vm._v(" " + _vm._s(it.value) + " ")]);
    }), 1)], 1)] : [_c("el-form-item", {
      attrs: {
        "label": item.name + "\uFF1A"
      }
    }, [_c("el-radio-group", {
      on: {
        "change": function($event) {
          return _vm.radioChange(_vm.form[item.code][0], item.code);
        }
      },
      model: {
        value: _vm.form[item.code][0],
        callback: function($$v) {
          _vm.$set(_vm.form[item.code], 0, $$v);
        },
        expression: "form[item.code][0]"
      }
    }, _vm._l(item.tagValues, function(it, idx) {
      return _c("el-radio", {
        key: idx,
        attrs: {
          "label": it.valueCode
        }
      }, [_vm._v(" " + _vm._s(it.value) + " ")]);
    }), 1)], 1)]], 2);
  }), 1), _c("el-col", {
    attrs: {
      "span": 24
    }
  }, [_vm.pages > _vm.searchObj.pageNo ? _c("div", {
    staticClass: "more op-padding-bottom-20",
    on: {
      "click": function($event) {
        return _vm.more();
      }
    }
  }, [_vm._v("\u52A0\u8F7D\u66F4\u591A")]) : _vm._e()])], 1)])], 1)], 1)], 1)]), _c("span", {
    staticClass: "dialog-footer op-text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("\u53D6 \u6D88")]), _c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\u786E \u5B9A")])], 1)], 1);
};
var staticRenderFns$z = [];
render$z._withStripped = true;
var TagSelect_vue_vue_type_style_index_0_lang = "";
const __vue2_script$A = {
  components: {
    Card
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      title: "\u6807\u7B7E\u914D\u7F6E",
      form: {},
      formCopy: {},
      listData: [],
      selectList: [],
      pages: 1,
      searchObj: {
        name: "",
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.selectList = [];
      this.searchObj.name = "";
    },
    async initData(data22) {
      this.dialogVisible = true;
      if (data22) {
        this.selectList = deepClone(data22);
      }
      this.search();
    },
    setDefaultTag() {
    },
    search() {
      this.searchObj.pageNo = 1;
      this.formCopy = {};
      this.listData = [];
      this.pages = 1;
      this.pageTagConfigQueryData();
    },
    more() {
      this.searchObj.pageNo += 1;
      this.pageTagConfigQueryData();
    },
    pageTagConfigQueryData() {
      this.loading = true;
      let params = __spreadValues({
        applicableBusinessType: "catalog",
        appCode: "MTDS"
      }, this.searchObj);
      pageTagConfigQuery(params).then((res) => {
        if (res.data) {
          this.loading = false;
          this.$set(this.$data, "pages", Number(res.data.pages));
          res.data.records.forEach((item) => {
            this.$set(this.form, item.code, []);
            this.selectList.forEach((it) => {
              if (it.tagCode === item.code) {
                this.form[item.code].push(it.valueCode);
              }
            });
            this.listData.push(item);
          });
          this.formCopy = deepClone(this.form);
        }
      });
    },
    checkChange(value9, code) {
      Object.keys(this.formCopy).forEach((key2) => {
        if (code === key2) {
          if (value9.length > this.formCopy[key2].length) {
            let selected = {};
            this.listData.map((item) => {
              if (item.code === key2) {
                item.tagValues.map((it) => {
                  if (it.valueCode === value9[value9.length - 1]) {
                    selected = {
                      tagName: item.name,
                      tagCode: item.code,
                      valueName: it.value,
                      valueCode: it.valueCode
                    };
                    this.selectList.push(selected);
                  }
                });
              }
            });
          } else {
            this.formCopy[key2].map((item) => {
              if (!value9.some((it) => it === item)) {
                let index2 = this.selectList.findIndex((el) => {
                  return el.tagCode === code && el.valueCode === item;
                });
                this.selectList.splice(index2, 1);
              }
            });
          }
        }
      });
      this.formCopy = deepClone(this.form);
    },
    radioChange(value9, code) {
      Object.keys(this.formCopy).forEach((key2) => {
        if (code === key2) {
          if (value9) {
            let selected = {};
            let index2 = this.selectList.findIndex((el) => {
              return el.tagCode === code;
            });
            if (index2 !== -1) {
              this.selectList.splice(index2, 1);
            }
            this.listData.map((item) => {
              if (item.code === key2) {
                item.tagValues.map((it) => {
                  if (it.valueCode === value9) {
                    selected = {
                      tagName: item.name,
                      tagCode: item.code,
                      valueName: it.value,
                      valueCode: it.valueCode
                    };
                    this.selectList.push(selected);
                  }
                });
              }
            });
          }
        }
      });
      this.formCopy = deepClone(this.form);
    },
    handleAddClose(item, index2) {
      this.selectList.splice(index2, 1);
      Object.keys(this.form).forEach((key2) => {
        if (item.tagCode === key2) {
          if (Array.isArray(this.form[key2])) {
            this.form[key2].splice(this.form[key2].indexOf(item.valueCode), 1);
          } else {
            this.form[key2] = "";
          }
        }
      });
      this.formCopy = deepClone(this.form);
    },
    save() {
      this.$emit("saveTag", this.selectList);
      this.handleClose();
    }
  }
};
const __cssModules$A = {};
var __component__$A = /* @__PURE__ */ normalizeComponent(__vue2_script$A, render$z, staticRenderFns$z, false, __vue2_injectStyles$A, null, null, null);
function __vue2_injectStyles$A(context2) {
  for (let o in __cssModules$A) {
    this[o] = __cssModules$A[o];
  }
}
__component__$A.options.__file = "packages/op-menu-select/src/TagSelect.vue";
var TagSelect$1 = /* @__PURE__ */ function() {
  return __component__$A.exports;
}();
var render$y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("el-dialog", {
    attrs: {
      "title": "\u76EE\u5F55\u7BA1\u7406",
      "visible": _vm.dialogVisible,
      "width": "70%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("Card", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }]
  }, [_c("div", {
    staticClass: "op-menu-select",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c("DirectoryTree", _vm._b({
    ref: "tree",
    staticClass: "op-menu-select-tree",
    attrs: {
      "root-id": _vm.rootId
    },
    on: {
      "checkChange": _vm.onTreeChcekChange,
      "treeChange": _vm.onTreeChange
    },
    scopedSlots: _vm._u([{
      key: "operate",
      fn: function(ref2) {
        var checkedNodes = ref2.checkedNodes;
        return [_c("el-button", {
          attrs: {
            "type": "text",
            "disabled": checkedNodes.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.onTreeOperate(checkedNodes, "edit");
            }
          }
        }, [_c("span", [_vm._v("\u7F16\u8F91")])]), _c("el-button", {
          attrs: {
            "type": "text",
            "disabled": checkedNodes.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.onTreeOperate(checkedNodes, "delete");
            }
          }
        }, [_c("span", [_vm._v("\u5220\u9664")])]), _c("el-button", {
          attrs: {
            "type": "text",
            "disabled": checkedNodes.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.onTreeOperate(checkedNodes, "add");
            }
          }
        }, [_c("span", [_vm._v("\u6DFB\u52A0\u5B50\u76EE\u5F55")])])];
      }
    }])
  }, "DirectoryTree", _vm.treeProps, false)), _vm.checkedNodes.length > 0 ? _c("el-form", {
    ref: "paramsRef",
    staticClass: "op-menu-select-form",
    attrs: {
      "disabled": _vm.type === "view",
      "model": _vm.params,
      "inline": true,
      "rules": _vm.rules,
      "size": "mini",
      "label-width": "120px"
    }
  }, [_c("el-row", {
    staticStyle: {
      "flex-wrap": "wrap"
    },
    attrs: {
      "type": "flex"
    }
  }, [_c("el-col", {
    attrs: {
      "span": 12
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u9002\u7528\u7CFB\u7EDF",
      "prop": "applicableSystem"
    }
  }, [_c("el-select", {
    staticStyle: {
      "width": "92%"
    },
    attrs: {
      "disabled": "",
      "placeholder": "\u8BF7\u9009\u62E9",
      "size": "mini",
      "clearable": ""
    },
    model: {
      value: _vm.params.applicableSystem,
      callback: function($$v) {
        _vm.$set(_vm.params, "applicableSystem", $$v);
      },
      expression: "params.applicableSystem"
    }
  }, _vm._l(_vm.applicableSystemList, function(item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        "label": item.appName,
        "value": item.appCode
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      "span": 12
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u9002\u7528\u5BF9\u8C61",
      "prop": "applicableType"
    }
  }, [_c("el-select", {
    staticStyle: {
      "width": "92%"
    },
    attrs: {
      "placeholder": "\u8BF7\u9009\u62E9",
      "size": "mini",
      "clearable": ""
    },
    model: {
      value: _vm.params.applicableType,
      callback: function($$v) {
        _vm.$set(_vm.params, "applicableType", $$v);
      },
      expression: "params.applicableType"
    }
  }, [_c("el-option", {
    attrs: {
      "label": "\u5546\u54C1",
      "value": "commodity"
    }
  })], 1)], 1)], 1), _c("el-col", {
    attrs: {
      "span": 12
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u76EE\u5F55\u540D\u79F0",
      "prop": "name"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.params.name,
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v);
      },
      expression: "params.name"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      "span": 12
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u76EE\u5F55ID",
      "prop": "id"
    }
  }, [_c("el-input", {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.params.id,
      callback: function($$v) {
        _vm.$set(_vm.params, "id", $$v);
      },
      expression: "params.id"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      "span": 12
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u4E0A\u7EA7\u76EE\u5F55",
      "prop": "parentIds"
    }
  }, [_c("el-cascader", {
    staticStyle: {
      "width": "92%"
    },
    attrs: {
      "disabled": "",
      "props": {
        checkStrictly: true
      },
      "options": _vm.catalogOptions
    },
    model: {
      value: _vm.params.parentIds,
      callback: function($$v) {
        _vm.$set(_vm.params, "parentIds", $$v);
      },
      expression: "params.parentIds"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      "span": 12
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u6807\u7B7E\u914D\u7F6E"
    }
  }, [_vm._l(_vm.tagSets, function(item) {
    return _c("el-tag", {
      key: item.tagCode,
      staticClass: "op-margin-left-5 op-margin-bottom-5",
      attrs: {
        "size": "small",
        "type": "success"
      }
    }, [_vm._v(" " + _vm._s(item.valueName) + " ")]);
  }), _c("el-button", {
    staticStyle: {
      "padding": "4px 6px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.configTag
    }
  })], 2)], 1), _c("el-col", {
    attrs: {
      "span": 12
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u76EE\u5F55\u526F\u6807\u9898",
      "prop": "subtitle"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.params.subtitle,
      callback: function($$v) {
        _vm.$set(_vm.params, "subtitle", $$v);
      },
      expression: "params.subtitle"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      "span": 12
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u76EE\u5F55\u56FE\u7247"
    }
  }, [_c("FileUpload", {
    attrs: {
      "is-upload": _vm.isHandle !== 3,
      "multiple": false,
      "accept": _vm.acceptList
    },
    model: {
      value: _vm.uploadList,
      callback: function($$v) {
        _vm.uploadList = $$v;
      },
      expression: "uploadList"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      "span": 24
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u6307\u5B9A\u6392\u5E8F",
      "prop": "relaCommodityIdString"
    }
  }, [_c("el-input", {
    staticStyle: {
      "width": "200%"
    },
    attrs: {
      "placeholder": "\u591A\u4E2A\u4F7F\u7528,\u9694\u5F00"
    },
    model: {
      value: _vm.params.relaCommodityIdString,
      callback: function($$v) {
        _vm.$set(_vm.params, "relaCommodityIdString", $$v);
      },
      expression: "params.relaCommodityIdString"
    }
  })], 1)], 1), _vm.type !== "view" ? _c("el-col", {
    staticClass: "text-align",
    attrs: {
      "span": 24
    }
  }, [_c("el-button", {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("\u53D6 \u6D88")]), _c("el-button", {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\u786E \u5B9A")])], 1) : _vm._e()], 1)], 1) : _c("div", {
    staticClass: "el-table__empty-text"
  }, [_vm._v("\u8BF7\u9009\u62E9\u76EE\u5F55")])], 1)]), _c("tag-select", {
    ref: "tagSelectRef",
    on: {
      "saveTag": _vm.saveTag
    }
  })], 1);
};
var staticRenderFns$y = [];
render$y._withStripped = true;
var index_vue_vue_type_style_index_0_lang$4 = "";
const __vue2_script$z = {
  name: "OpMenuSelect",
  components: {
    DirectoryTree,
    Card,
    FileUpload,
    TagSelect: TagSelect$1
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    rootId: {
      type: String,
      required: true
    },
    applicableSystem: {
      type: String,
      required: true
    },
    treeProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      type: "add",
      showCommodity: true,
      loading: false,
      btnLoading: false,
      tableLoading: false,
      params: {
        applicableSystem: void 0,
        applicableType: void 0,
        name: void 0,
        id: void 0,
        parentIds: [],
        subtitle: void 0,
        relaCommodityIdString: void 0,
        pageNo: 1,
        pageSize: 10
      },
      acceptList: ".jpg, .jpeg, .png, .gif",
      isHandle: 1,
      uploadList: [],
      tagSets: [],
      catalogOptions: [],
      multipleSelection: [],
      commodityListData: [],
      total: 0,
      tableHeight: 450,
      searchParams: {
        name: void 0,
        orgId: void 0,
        pageNo: 1,
        pageSize: 10
      },
      orgIdList: [],
      applicableSystemList: [],
      rules: {
        applicableSystem: [{
          required: true,
          message: "\u8BF7\u8F93\u5165\u9002\u7528\u7CFB\u7EDF",
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: "\u8BF7\u8F93\u5165\u76EE\u5F55\u540D\u79F0",
          trigger: "blur"
        }]
      },
      checkedNodes: []
    };
  },
  watch: {
    visible(nextValue) {
      this.dialogVisible = nextValue;
    },
    dialogVisible(nextValue) {
      this.$emit("update:visible", nextValue);
    }
  },
  mounted() {
    this.getApplicableSystemList();
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    formatterorgId(row) {
      let txt = "";
      this.orgIdList.forEach((item) => {
        if (item.id === row.orgId) {
          txt = item.name;
        }
      });
      if (row.orgId == 1) {
        txt = "\u6B27\u6D3E\u96C6\u56E2";
      }
      return txt;
    },
    filterStatus(data22) {
      let txt = "";
      switch (data22) {
        case "ENABLE":
          txt = "\u542F\u7528";
          break;
        case "DISABLE":
          txt = "\u505C\u7528";
          break;
      }
      return txt;
    },
    async initData(data22) {
      switch (data22.type) {
        case "add":
          this.showCommodity = false;
          break;
        case "edit":
          this.getCatalogDetail(data22.id);
          break;
        case "view":
          this.isHandle = 3;
          this.getCatalogDetail(data22.id);
          break;
      }
      this.type = data22.type;
    },
    configTag() {
      this.$refs.tagSelectRef.initData(this.tagSets);
    },
    saveTag(data22) {
      this.tagSets = data22;
    },
    saveCommodity() {
      let ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.params.relaCommodityIdString = ids.join(",");
    },
    resetState() {
      Object.keys(this.params).forEach((key2) => {
        if (key2 === "parentIds") {
          this.params[key2] = [];
        } else if (key2 === "pageNo") {
          this.params[key2] = 1;
        } else if (key2 === "pageSize") {
          this.params[key2] = 10;
        } else {
          this.params[key2] = void 0;
        }
      });
      this.uploadList = [];
      this.tagSets = [];
      this.multipleSelection = [];
      this.showCommodity = true;
      this.isHandle = 1;
      this.btnLoading = false;
      this.loading = false;
    },
    handleClose() {
      this.resetState();
      this.$refs.tree.setCheckedKeys([]);
      this.dialogVisible = false;
    },
    onRemove(file) {
      let uid2 = Object.prototype.hasOwnProperty.call(file, "uid") ? file.uid : "";
      let id = Object.prototype.hasOwnProperty.call(file, "id") ? file.id : "";
      if (this.uploadList.length) {
        this.uploadList.forEach((item, index2) => {
          if (item["uid"] === uid2 && !!item["uid"] || item["id"] === id && !!item["id"]) {
            this.uploadList.splice(index2, 1);
          }
        });
      }
    },
    handlePicChange(file) {
      const self2 = this;
      let push = false;
      if (this.uploadList.length) {
        this.uploadList.forEach((item, index2) => {
          if (item.uid === file.uid) {
            this.uploadList.slice(index2, 1);
          } else {
            push = true;
          }
        });
        if (push) {
          this.uploadList.push(file);
        }
      } else {
        this.uploadList.push(file);
      }
      this.params.productPictures = self2.uploadList.map((e) => {
        return {
          suffix: e.suffix,
          name: e.name,
          path: e.path,
          uploadDt: e.uid,
          size: e.size,
          ossKey: e.ossKey,
          url: e.url
        };
      });
    },
    toSearch() {
      this.getData(1);
    },
    handleCurrentChange(val) {
      this.searchParams.pageNo = val;
      this.getData(this.searchParams.pageNo);
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.getData(this.searchParams.pageNo);
    },
    getData(pageNo = 1) {
      this.searchParams.pageNo = pageNo;
      this.getCommodity();
    },
    getDepartmentList() {
      getDepartmentListByConToPost({
        departmentParentId: 1
      }).then((res) => {
        if (res.status) {
          this.orgIdList = res.data;
        }
      }).catch(() => {
      });
    },
    getApplicableSystemList() {
      getApplicableSystem().then((res) => {
        if (res.status) {
          this.applicableSystemList = res.data;
        }
      }).catch(() => {
      });
    },
    getCatalogTree() {
      catalogTree({
        parentId: this.rootId
      }).then((res) => {
        if (res.status) {
          this.catalogOptions = res.data;
        }
      }).catch(() => {
      });
    },
    getCommodity() {
      this.tableLoading = true;
      for (const key2 in this.searchParams) {
        if (this.searchParams[key2] === "") {
          this.searchParams[key2] = void 0;
        }
      }
      getCommodityPages(this.searchParams).then((res) => {
        let data22 = [];
        if (res && res.data && res.data.records && res.data.records.length) {
          data22 = res.data.records;
        }
        this.total = Number(res && res.data && res.data.total) || 0;
        this.commodityListData = data22;
        this.tableLoading = false;
      }).catch(() => {
      });
    },
    getCatalogDetail(id) {
      catalogDetail({
        id
      }).then((res) => {
        if (res.status) {
          let data22 = res.data;
          Object.keys(this.params).forEach((key2) => {
            if (key2 === "pageNo" || key2 === "pageSize")
              ;
            else if (key2 === "relaCommodityIdString") {
              this.params[key2] = data22.relaCommodityIds;
            } else if (key2 === "parentIds") {
              this.params[key2] = data22.parentIds.slice(data22.parentIds.indexOf(this.rootId));
            } else if (data22[key2]) {
              this.params[key2] = data22[key2];
            }
          });
          this.uploadList = Array.isArray(data22.pictures) ? data22.pictures : [];
          this.tagSets = Array.isArray(data22.tagSets) ? data22.tagSets : [];
        }
      });
    },
    toggleSelection() {
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((row) => {
          this.$nextTick(() => {
            this.$refs.tableRef.toggleRowSelection(row);
          });
        });
      } else {
        this.$nextTick(() => {
          this.$refs.tableRef.clearSelection();
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    closeTag(index2) {
      let row = this.multipleSelection.splice(index2, 1);
      this.commodityListData.forEach((item) => {
        if (item.id === row[0].id) {
          this.$refs.tableRef.toggleRowSelection(item, false);
        }
      });
    },
    save() {
      this.$refs.paramsRef.validate((valid) => {
        if (valid) {
          let tagSets = this.tagSets.map((item) => {
            return {
              tagCode: item.tagCode,
              valueCode: item.valueCode
            };
          });
          let ids = this.params.relaCommodityIdString ? this.params.relaCommodityIdString.split(",") : [];
          let parentId = this.params.parentIds[this.params.parentIds.length - 1];
          let param = {
            id: this.params.id,
            applicableSystem: this.params.applicableSystem,
            name: this.params.name,
            subtitle: this.params.subtitle ? this.params.subtitle : "",
            relaCommodityIds: ids.length > 0 ? ids : void 0,
            pictures: this.uploadList,
            parentId,
            tagSets
          };
          this.btnLoading = true;
          if (this.type === "add") {
            catalogCreate(param).then((res) => {
              if (res.status) {
                this.$message.success("\u65B0\u589E\u6210\u529F");
                this.$refs.tree.refresh();
                this.handleClose();
              }
            });
          } else {
            catalogModify(param).then((res) => {
              if (res.status) {
                this.$message.success("\u7F16\u8F91\u6210\u529F");
                this.$refs.tree.refresh();
                this.handleClose();
              }
            });
          }
        }
      });
    },
    onTreeChcekChange(checkedNodes) {
      this.checkedNodes = checkedNodes;
      if (checkedNodes.length > 0) {
        const [{
          value: value9
        }] = checkedNodes;
        this.initData({
          type: "view",
          id: value9
        });
      }
    },
    onTreeOperate(checkedNodes, type) {
      const [checkedNode] = checkedNodes;
      const {
        value: value9
      } = checkedNode;
      const handleMap = {
        edit: () => this.initData({
          type,
          id: value9
        }),
        delete: () => this.deleteTree(checkedNode),
        add: () => {
          this.resetState();
          this.initData({
            type
          });
          this.params.parentIds = this.$refs.tree.findNodeParentList(value9);
          this.params.applicableSystem = this.applicableSystem;
        }
      };
      handleMap[type]();
    },
    deleteTree({
      label,
      value: value9
    }) {
      this.$confirm(`\u672C\u6B21\u64CD\u4F5C\u5C06\u5220\u9664${label}\u53CA\u5176\u6240\u6709\u4E0B\u7EA7\u76EE\u5F55\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u7EE7\u7EED\uFF1F`, "\u63D0\u793A", {
        confirmButtonText: "\u786E\u5B9A",
        cancelButtonText: "\u53D6\u6D88",
        type: "warning"
      }).then(() => {
        catalogDelete({
          id: value9
        }).then((res) => {
          if (res.status) {
            this.$refs.tree.refresh();
            this.$message({
              type: "success",
              message: "\u5220\u9664\u6210\u529F!"
            });
          }
        });
      });
    },
    onTreeChange(treeData) {
      this.catalogOptions = treeData;
    }
  }
};
const __cssModules$z = {};
var __component__$z = /* @__PURE__ */ normalizeComponent(__vue2_script$z, render$y, staticRenderFns$y, false, __vue2_injectStyles$z, null, null, null);
function __vue2_injectStyles$z(context2) {
  for (let o in __cssModules$z) {
    this[o] = __cssModules$z[o];
  }
}
__component__$z.options.__file = "packages/op-menu-select/src/index.vue";
var MenuSelect = /* @__PURE__ */ function() {
  return __component__$z.exports;
}();
MenuSelect.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(MenuSelect.name, prefix);
  Vue2.component(comName, MenuSelect);
};
var __glob_6_17 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": MenuSelect
});
var message$1 = "";
var message = { exports: {} };
var types = {};
types.__esModule = true;
types.isDefined = types.isUndefined = types.isFunction = void 0;
var _typeof$4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
types.isString = isString;
types.isObject = isObject;
types.isHtmlElement = isHtmlElement;
var _vue$2 = Vue$1;
var _vue2$2 = _interopRequireDefault$3(_vue$2);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function isString(obj) {
  return Object.prototype.toString.call(obj) === "[object String]";
}
function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}
function isHtmlElement(node2) {
  return node2 && node2.nodeType === Node.ELEMENT_NODE;
}
var isFunction = function isFunction2(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
};
if (typeof /./ !== "function" && (typeof Int8Array === "undefined" ? "undefined" : _typeof$4(Int8Array)) !== "object" && (_vue2$2.default.prototype.$isServer || typeof document.childNodes !== "function")) {
  types.isFunction = isFunction = function isFunction3(obj) {
    return typeof obj === "function" || false;
  };
}
types.isFunction = isFunction;
types.isUndefined = function isUndefined2(val) {
  return val === void 0;
};
types.isDefined = function isDefined(val) {
  return val !== void 0 && val !== null;
};
var vdom = {};
var util = {};
util.__esModule = true;
util.isEmpty = util.isEqual = util.arrayEquals = util.looseEqual = util.capitalize = util.kebabCase = util.autoprefixer = util.isFirefox = util.isEdge = util.isIE = util.coerceTruthyValueToArray = util.arrayFind = util.arrayFindIndex = util.escapeRegexpString = util.valueEquals = util.generateId = util.getValueByPath = void 0;
var _typeof$3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
util.noop = noop;
util.hasOwn = hasOwn;
util.toObject = toObject;
util.getPropByPath = getPropByPath;
util.rafThrottle = rafThrottle;
util.objToArray = objToArray;
var _vue$1 = Vue$1;
var _vue2$1 = _interopRequireDefault$2(_vue$1);
var _types = types;
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function noop() {
}
function hasOwn(obj, key2) {
  return hasOwnProperty.call(obj, key2);
}
function extend(to, _from) {
  for (var key2 in _from) {
    to[key2] = _from[key2];
  }
  return to;
}
function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
}
util.getValueByPath = function getValueByPath2(object, prop) {
  prop = prop || "";
  var paths = prop.split(".");
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current)
      break;
    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};
function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, ".$1");
  path = path.replace(/^\./, "");
  var keyArr = path.split(".");
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict)
      break;
    var key2 = keyArr[i];
    if (key2 in tempObj) {
      tempObj = tempObj[key2];
    } else {
      if (strict) {
        throw new Error("please transfer a valid prop path to form item!");
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
}
util.generateId = function generateId() {
  return Math.floor(Math.random() * 1e4);
};
util.valueEquals = function valueEquals(a, b) {
  if (a === b)
    return true;
  if (!(a instanceof Array))
    return false;
  if (!(b instanceof Array))
    return false;
  if (a.length !== b.length)
    return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i])
      return false;
  }
  return true;
};
util.escapeRegexpString = function escapeRegexpString() {
  var value9 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return String(value9).replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
};
var arrayFindIndex = util.arrayFindIndex = function arrayFindIndex2(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};
util.arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : void 0;
};
util.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};
util.isIE = function isIE() {
  return !_vue2$1.default.prototype.$isServer && !isNaN(Number(document.documentMode));
};
util.isEdge = function isEdge() {
  return !_vue2$1.default.prototype.$isServer && navigator.userAgent.indexOf("Edge") > -1;
};
util.isFirefox = function isFirefox2() {
  return !_vue2$1.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};
util.autoprefixer = function autoprefixer(style6) {
  if ((typeof style6 === "undefined" ? "undefined" : _typeof$3(style6)) !== "object")
    return style6;
  var rules = ["transform", "transition", "animation"];
  var prefixes = ["ms-", "webkit-"];
  rules.forEach(function(rule) {
    var value9 = style6[rule];
    if (rule && value9) {
      prefixes.forEach(function(prefix) {
        style6[prefix + rule] = value9;
      });
    }
  });
  return style6;
};
util.kebabCase = function kebabCase(str) {
  var hyphenateRE = /([^-])([A-Z])/g;
  return str.replace(hyphenateRE, "$1-$2").replace(hyphenateRE, "$1-$2").toLowerCase();
};
util.capitalize = function capitalize(str) {
  if (!(0, _types.isString)(str))
    return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};
var looseEqual = util.looseEqual = function looseEqual2(a, b) {
  var isObjectA = (0, _types.isObject)(a);
  var isObjectB = (0, _types.isObject)(b);
  if (isObjectA && isObjectB) {
    return JSON.stringify(a) === JSON.stringify(b);
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
};
var arrayEquals = util.arrayEquals = function arrayEquals2(arrayA, arrayB) {
  arrayA = arrayA || [];
  arrayB = arrayB || [];
  if (arrayA.length !== arrayB.length) {
    return false;
  }
  for (var i = 0; i < arrayA.length; i++) {
    if (!looseEqual(arrayA[i], arrayB[i])) {
      return false;
    }
  }
  return true;
};
util.isEqual = function isEqual(value1, value22) {
  if (Array.isArray(value1) && Array.isArray(value22)) {
    return arrayEquals(value1, value22);
  }
  return looseEqual(value1, value22);
};
var isEmpty = util.isEmpty = function isEmpty2(val) {
  if (val == null)
    return true;
  if (typeof val === "boolean")
    return false;
  if (typeof val === "number")
    return !val;
  if (val instanceof Error)
    return val.message === "";
  switch (Object.prototype.toString.call(val)) {
    case "[object String]":
    case "[object Array]":
      return !val.length;
    case "[object File]":
    case "[object Map]":
    case "[object Set]": {
      return !val.size;
    }
    case "[object Object]": {
      return !Object.keys(val).length;
    }
  }
  return false;
};
function rafThrottle(fn2) {
  var locked = false;
  return function() {
    var _this = this;
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (locked)
      return;
    locked = true;
    window.requestAnimationFrame(function(_) {
      fn2.apply(_this, args);
      locked = false;
    });
  };
}
function objToArray(obj) {
  if (Array.isArray(obj)) {
    return obj;
  }
  return isEmpty(obj) ? [] : [obj];
}
vdom.__esModule = true;
var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
vdom.isVNode = isVNode;
var _util$2 = util;
function isVNode(node2) {
  return node2 !== null && (typeof node2 === "undefined" ? "undefined" : _typeof$2(node2)) === "object" && (0, _util$2.hasOwn)(node2, "componentOptions");
}
(function(module) {
  module.exports = function(modules) {
    var installedModules = {};
    function __webpack_require__(moduleId) {
      if (installedModules[moduleId]) {
        return installedModules[moduleId].exports;
      }
      var module2 = installedModules[moduleId] = {
        i: moduleId,
        l: false,
        exports: {}
      };
      modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
      module2.l = true;
      return module2.exports;
    }
    __webpack_require__.m = modules;
    __webpack_require__.c = installedModules;
    __webpack_require__.d = function(exports, name, getter) {
      if (!__webpack_require__.o(exports, name)) {
        Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
      }
    };
    __webpack_require__.r = function(exports) {
      if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module"
        });
      }
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
    };
    __webpack_require__.t = function(value9, mode) {
      if (mode & 1)
        value9 = __webpack_require__(value9);
      if (mode & 8)
        return value9;
      if (mode & 4 && typeof value9 === "object" && value9 && value9.__esModule)
        return value9;
      var ns = Object.create(null);
      __webpack_require__.r(ns);
      Object.defineProperty(ns, "default", {
        enumerable: true,
        value: value9
      });
      if (mode & 2 && typeof value9 != "string")
        for (var key2 in value9)
          __webpack_require__.d(ns, key2, function(key3) {
            return value9[key3];
          }.bind(null, key2));
      return ns;
    };
    __webpack_require__.n = function(module2) {
      var getter = module2 && module2.__esModule ? function getDefault() {
        return module2["default"];
      } : function getModuleExports() {
        return module2;
      };
      __webpack_require__.d(getter, "a", getter);
      return getter;
    };
    __webpack_require__.o = function(object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    __webpack_require__.p = "/dist/";
    return __webpack_require__(__webpack_require__.s = 75);
  }({
    0: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.d(__webpack_exports__, "a", function() {
        return normalizeComponent2;
      });
      function normalizeComponent2(scriptExports, render28, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
        var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
        if (render28) {
          options.render = render28;
          options.staticRenderFns = staticRenderFns2;
          options._compiled = true;
        }
        if (functionalTemplate) {
          options.functional = true;
        }
        if (scopeId) {
          options._scopeId = "data-v-" + scopeId;
        }
        var hook;
        if (moduleIdentifier) {
          hook = function(context2) {
            context2 = context2 || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
            if (!context2 && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
              context2 = __VUE_SSR_CONTEXT__;
            }
            if (injectStyles) {
              injectStyles.call(this, context2);
            }
            if (context2 && context2._registeredComponents) {
              context2._registeredComponents.add(moduleIdentifier);
            }
          };
          options._ssrRegister = hook;
        } else if (injectStyles) {
          hook = shadowMode ? function() {
            injectStyles.call(this, this.$root.$options.shadowRoot);
          } : injectStyles;
        }
        if (hook) {
          if (options.functional) {
            options._injectStyles = hook;
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context2) {
              hook.call(context2);
              return originalRender(h, context2);
            };
          } else {
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
        }
        return {
          exports: scriptExports,
          options
        };
      }
    },
    13: function(module2, exports) {
      module2.exports = popup;
    },
    17: function(module2, exports) {
      module2.exports = types;
    },
    23: function(module2, exports) {
      module2.exports = vdom;
    },
    7: function(module2, exports) {
      module2.exports = Vue$1;
    },
    75: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      var external_vue_ = __webpack_require__(7);
      var external_vue_default = /* @__PURE__ */ __webpack_require__.n(external_vue_);
      var render28 = function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("transition", {
          attrs: {
            name: "el-message-fade"
          },
          on: {
            "after-leave": _vm.handleAfterLeave
          }
        }, [_c("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }],
          class: ["el-message", _vm.type && !_vm.iconClass ? "el-message--" + _vm.type : "", _vm.center ? "is-center" : "", _vm.showClose ? "is-closable" : "", _vm.customClass],
          style: _vm.positionStyle,
          attrs: {
            role: "alert"
          },
          on: {
            mouseenter: _vm.clearTimer,
            mouseleave: _vm.startTimer
          }
        }, [_vm.iconClass ? _c("i", {
          class: _vm.iconClass
        }) : _c("i", {
          class: _vm.typeClass
        }), _vm._t("default", [!_vm.dangerouslyUseHTMLString ? _c("p", {
          staticClass: "el-message__content"
        }, [_vm._v(_vm._s(_vm.message))]) : _c("p", {
          staticClass: "el-message__content",
          domProps: {
            innerHTML: _vm._s(_vm.message)
          }
        })]), _vm.showClose ? _c("i", {
          staticClass: "el-message__closeBtn el-icon-close",
          on: {
            click: _vm.close
          }
        }) : _vm._e()], 2)]);
      };
      var staticRenderFns2 = [];
      render28._withStripped = true;
      var typeMap = {
        success: "success",
        info: "info",
        warning: "warning",
        error: "error"
      };
      var mainvue_type_script_lang_js_ = {
        data: function data22() {
          return {
            visible: false,
            message: "",
            duration: 3e3,
            type: "info",
            iconClass: "",
            customClass: "",
            onClose: null,
            showClose: false,
            closed: false,
            verticalOffset: 20,
            timer: null,
            dangerouslyUseHTMLString: false,
            center: false
          };
        },
        computed: {
          typeClass: function typeClass() {
            return this.type && !this.iconClass ? "el-message__icon el-icon-" + typeMap[this.type] : "";
          },
          positionStyle: function positionStyle() {
            return {
              "top": this.verticalOffset + "px"
            };
          }
        },
        watch: {
          closed: function closed(newVal) {
            if (newVal) {
              this.visible = false;
            }
          }
        },
        methods: {
          handleAfterLeave: function handleAfterLeave() {
            this.$destroy(true);
            this.$el.parentNode.removeChild(this.$el);
          },
          close: function close3() {
            this.closed = true;
            if (typeof this.onClose === "function") {
              this.onClose(this);
            }
          },
          clearTimer: function clearTimer() {
            clearTimeout(this.timer);
          },
          startTimer: function startTimer() {
            var _this = this;
            if (this.duration > 0) {
              this.timer = setTimeout(function() {
                if (!_this.closed) {
                  _this.close();
                }
              }, this.duration);
            }
          },
          keydown: function keydown2(e) {
            if (e.keyCode === 27) {
              if (!this.closed) {
                this.close();
              }
            }
          }
        },
        mounted: function mounted12() {
          this.startTimer();
          document.addEventListener("keydown", this.keydown);
        },
        beforeDestroy: function beforeDestroy4() {
          document.removeEventListener("keydown", this.keydown);
        }
      };
      var src_mainvue_type_script_lang_js_ = mainvue_type_script_lang_js_;
      var componentNormalizer = __webpack_require__(0);
      var component = Object(componentNormalizer["a"])(src_mainvue_type_script_lang_js_, render28, staticRenderFns2, false, null, null, null);
      component.options.__file = "packages/message/src/main.vue";
      var main = component.exports;
      var popup_ = __webpack_require__(13);
      var vdom_ = __webpack_require__(23);
      var types_ = __webpack_require__(17);
      var _extends2 = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key2 in source) {
            if (Object.prototype.hasOwnProperty.call(source, key2)) {
              target[key2] = source[key2];
            }
          }
        }
        return target;
      };
      var MessageConstructor = external_vue_default.a.extend(main);
      var instance2 = void 0;
      var instances2 = [];
      var seed = 1;
      var main_Message = function Message(options) {
        if (external_vue_default.a.prototype.$isServer)
          return;
        options = options || {};
        if (typeof options === "string") {
          options = {
            message: options
          };
        }
        var userOnClose = options.onClose;
        var id = "message_" + seed++;
        options.onClose = function() {
          Message.close(id, userOnClose);
        };
        instance2 = new MessageConstructor({
          data: options
        });
        instance2.id = id;
        if (Object(vdom_["isVNode"])(instance2.message)) {
          instance2.$slots.default = [instance2.message];
          instance2.message = null;
        }
        instance2.$mount();
        document.body.appendChild(instance2.$el);
        var verticalOffset = options.offset || 20;
        instances2.forEach(function(item) {
          verticalOffset += item.$el.offsetHeight + 16;
        });
        instance2.verticalOffset = verticalOffset;
        instance2.visible = true;
        instance2.$el.style.zIndex = popup_["PopupManager"].nextZIndex();
        instances2.push(instance2);
        return instance2;
      };
      ["success", "warning", "info", "error"].forEach(function(type) {
        main_Message[type] = function(options) {
          if (Object(types_["isObject"])(options) && !Object(vdom_["isVNode"])(options)) {
            return main_Message(_extends2({}, options, {
              type
            }));
          }
          return main_Message({
            type,
            message: options
          });
        };
      });
      main_Message.close = function(id, userOnClose) {
        var len = instances2.length;
        var index2 = -1;
        var removedHeight = void 0;
        for (var i = 0; i < len; i++) {
          if (id === instances2[i].id) {
            removedHeight = instances2[i].$el.offsetHeight;
            index2 = i;
            if (typeof userOnClose === "function") {
              userOnClose(instances2[i]);
            }
            instances2.splice(i, 1);
            break;
          }
        }
        if (len <= 1 || index2 === -1 || index2 > instances2.length - 1)
          return;
        for (var _i = index2; _i < len - 1; _i++) {
          var dom2 = instances2[_i].$el;
          dom2.style["top"] = parseInt(dom2.style["top"], 10) - removedHeight - 16 + "px";
        }
      };
      main_Message.closeAll = function() {
        for (var i = instances2.length - 1; i >= 0; i--) {
          instances2[i].close();
        }
      };
      var src_main = main_Message;
      __webpack_exports__["default"] = src_main;
    }
  });
})(message);
var _Message = /* @__PURE__ */ getDefaultExportFromCjs(message.exports);
var render$x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-mobile-user"
  }, [_c("div", {
    staticClass: "op-mobile-user__header"
  }, [_c("van-nav-bar", {
    attrs: {
      "title": _vm.title,
      "left-text": "\u8FD4\u56DE",
      "right-text": _vm.rightText,
      "left-arrow": ""
    },
    on: {
      "click-right": function($event) {
        return _vm.$emit("click-right");
      },
      "click-left": function($event) {
        return _vm.$emit("click-left");
      }
    }
  }), _c("van-search", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u641C\u7D22\u5173\u952E\u8BCD"
    },
    on: {
      "clear": _vm.onSearch,
      "search": _vm.onSearch
    },
    model: {
      value: _vm.searchStr,
      callback: function($$v) {
        _vm.searchStr = $$v;
      },
      expression: "searchStr"
    }
  })], 1), _c("van-pull-refresh", {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: _vm.loading,
      callback: function($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, [_c("van-list", {
    staticStyle: {
      "margin-bottom": "60px"
    },
    attrs: {
      "immediate-check": false,
      "finished": _vm.finished,
      "finished-text": "\u6CA1\u6709\u66F4\u591A\u4E86"
    },
    on: {
      "load": _vm.onLoadMore
    },
    model: {
      value: _vm.moreLoading,
      callback: function($$v) {
        _vm.moreLoading = $$v;
      },
      expression: "moreLoading"
    }
  }, [_vm.single ? [_c("van-radio-group", {
    model: {
      value: _vm.userIds,
      callback: function($$v) {
        _vm.userIds = $$v;
      },
      expression: "userIds"
    }
  }, _vm._l(_vm.data, function(item, index2) {
    return _c("van-cell", {
      key: index2,
      attrs: {
        "title": item.name,
        "value": item.job,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index2);
        }
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function() {
          return [_c("van-radio", {
            ref: "checkboxes",
            refInFor: true,
            attrs: {
              "name": item.id
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)] : [_c("van-checkbox-group", {
    model: {
      value: _vm.userIds,
      callback: function($$v) {
        _vm.userIds = $$v;
      },
      expression: "userIds"
    }
  }, _vm._l(_vm.data, function(item, index2) {
    return _c("van-cell", {
      key: index2,
      attrs: {
        "title": item.name,
        "value": item.job,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index2);
        }
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function() {
          return [_c("van-checkbox", {
            ref: "checkboxes",
            refInFor: true,
            attrs: {
              "name": item.id
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)]], 2)], 1), _c("div", {
    staticClass: "popup__footer"
  }, [_c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("\u786E\u5B9A")])], 1)], 1);
};
var staticRenderFns$x = [];
render$x._withStripped = true;
var OpSelector_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
const __vue2_script$y = defineComponent({
  name: "CommonSelector",
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    data: Array,
    title: String,
    rightText: String,
    single: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          pageNo: 1,
          pageSize: 50,
          total: 0
        };
      }
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const searchStr = ref(null);
    const userIds = ref([]);
    const paging = reactive({
      pageNo: 1,
      pageSize: 20,
      total: 0
    });
    const checkboxes = ref(null);
    const moreLoading = ref(false);
    const checked2 = ref(false);
    const selects = ref([]);
    const count3 = ref(1);
    const {
      data: data22,
      pagination,
      loading: loading2
    } = toRefs(props2);
    watch(() => loading2.value, (nval) => {
      let _loading = null;
      if (nval) {
        moreLoading.value = true;
        _loading = Toast.loading();
      } else {
        moreLoading.value = false;
        _loading && _loading.close();
      }
    });
    watch(() => userIds.value, (nval) => {
      selects.value = data22.value.filter((_item) => nval.includes(_item.id));
    });
    watch(() => pagination.value.pageNo, (nval) => {
      paging.pageNo = nval;
    });
    const finished = computed(() => {
      return data22.value.length === pagination.value.total;
    });
    function loadData() {
      const _params = Object.assign({
        querys: {
          name: searchStr.value
        }
      }, paging);
      emit2("load", _params);
    }
    const onSearch = () => {
      paging.pageNo = 1;
      loadData();
    };
    const toggle5 = (index2) => {
      checkboxes.value[index2].toggle();
    };
    const onRefresh = async () => {
      paging.pageNo = 1;
      emit2("update:data", []);
      loadData();
    };
    const onLoadMore = async () => {
      paging.pageNo += 1;
      if (paging.pageNo > 1 && !finished.value) {
        loadData();
      }
    };
    const reset2 = () => {
      searchStr.value = null;
      paging.pageNo = 1;
      emit2("reset");
    };
    const onShow = (initSelectors) => {
      if (!initSelectors) {
        selects.value = [...props2.value];
        userIds.value = selects.value.map((item) => item.id);
      } else {
        selects.value = initSelectors;
      }
      reset2();
      loadData();
    };
    const onConfirm = () => {
      emit2("input", selects.value);
      emit2("confirm", selects.value);
    };
    return {
      searchStr,
      userIds,
      moreLoading,
      finished,
      checked: checked2,
      selects,
      count: count3,
      checkboxes,
      onSearch,
      onRefresh,
      onLoadMore,
      reset: reset2,
      toggle: toggle5,
      onShow,
      onConfirm
    };
  }
});
const __cssModules$y = {};
var __component__$y = /* @__PURE__ */ normalizeComponent(__vue2_script$y, render$x, staticRenderFns$x, false, __vue2_injectStyles$y, "4c927804", null, null);
function __vue2_injectStyles$y(context2) {
  for (let o in __cssModules$y) {
    this[o] = __cssModules$y[o];
  }
}
__component__$y.options.__file = "src/components/common/SelectorDialog/src/mobile/OpSelector.vue";
var CommonSelector$1 = /* @__PURE__ */ function() {
  return __component__$y.exports;
}();
var render$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-selector-dialog"
  }, [!_vm.isDialog ? _c("div", {
    staticClass: "el-select",
    staticStyle: {
      "width": "100%",
      "min-width": "180px"
    }
  }, [!_vm.isDialog ? _c("field-pannel", {
    attrs: {
      "list": _vm.selectors,
      "disabled": _vm.disabled,
      "closable": "",
      "config": {
        label: "name",
        value: "id"
      }
    },
    on: {
      "close": _vm.handleRemove,
      "open": _vm.showDialog
    }
  }) : _vm._e()], 1) : _vm._e(), _c("van-popup", {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: _vm.dialogVisible,
      callback: function($$v) {
        _vm.dialogVisible = $$v;
      },
      expression: "dialogVisible"
    }
  }, [_c("CommonSelector", {
    ref: "selector",
    staticStyle: {
      "width": "100%",
      "height": "100vh"
    },
    attrs: {
      "data": _vm.data,
      "pagination": _vm.pagination,
      "title": _vm.currentTitle,
      "right-text": _vm.rightText,
      "loading": _vm.loading,
      "single": _vm.single
    },
    on: {
      "update:data": function($event) {
        _vm.data = $event;
      },
      "load": function($event) {
        return _vm.$emit("load", $event);
      },
      "before-leave": _vm.handleClose,
      "confirm": function($event) {
        _vm.dialogVisible = false;
      },
      "click-left": function($event) {
        _vm.dialogVisible = false;
      },
      "click-right": function($event) {
        return _vm.$emit("click-right");
      }
    },
    model: {
      value: _vm.selectors,
      callback: function($$v) {
        _vm.selectors = $$v;
      },
      expression: "selectors"
    }
  })], 1), _vm._t("modal")], 2);
};
var staticRenderFns$w = [];
render$w._withStripped = true;
var OpSelectorDialog_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
const __vue2_script$x = defineComponent({
  name: "SelectorDialog",
  components: {
    CommonSelector: CommonSelector$1,
    FieldPannel
  },
  props: {
    loading: Boolean,
    value: String,
    title: String,
    rightText: String,
    disabled: {
      type: Boolean,
      default: false
    },
    single: {
      type: Boolean,
      default: false
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    config: Object,
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          pageNo: 1,
          pageSize: 50,
          total: 0
        };
      }
    }
  },
  setup(props2) {
    const {
      config,
      value: value9
    } = toRefs(props2);
    const selectors = ref([]);
    const popupTitle = ref("");
    const {
      getArrayValFromVForm,
      setValToVForm
    } = useVForm(config);
    const initValue = () => {
      if (Object.keys(config.value).length > 0) {
        const _list = getArrayValFromVForm(value9.value, props2.nameConfig);
        if (!arrayEquals$1(_list, selectors.value)) {
          selectors.value = _list;
        }
      }
    };
    const [internalValue, setInnerValue] = useVModel(value9, "", () => {
    }, "onChange");
    onMounted(() => {
      initValue();
    });
    watch(() => selectors.value, (nval) => {
      const names = nval.map((i) => i.name).join(",");
      setInnerValue(names, nval);
      setValToVForm(nval);
    });
    watch(value9, (val, oval) => {
      if (!oval && val) {
        initValue();
      }
    });
    watch(config, (c) => {
      initValue();
      popupTitle.value = props2.title;
    });
    return {
      selectors,
      popupTitle
    };
  },
  data() {
    return {
      inputSuffixHeight: 30,
      defaultExpandedKeys: ["-1"],
      dialogVisible: false,
      currentDemension: null,
      activeName: "org"
    };
  },
  computed: {
    currentTitle: {
      get: function() {
        return this.popupTitle;
      },
      set: function(val) {
        this.popupTitle = val;
      }
    }
  },
  methods: {
    showDialog() {
      if (this.disabled) {
        return;
      }
      this.dialogVisible = true;
      setTimeout(() => {
        this.$refs.selector.onShow();
      });
    },
    handleClose(done) {
      this.$refs.selector.onHide();
      done && done();
    },
    handleRemove(item) {
      this.selectors.remove(item);
      this.$emit("onConfirm", this.selectors);
    },
    clear() {
      this.selectors = [];
    },
    calcInputSuffixHeight() {
      if (!this.$refs.tagSpans)
        return;
      if (this.$refs.tagSpans.offsetHeight) {
        this.inputSuffixHeight = this.$refs.tagSpans.offsetHeight + 5;
      } else {
        this.inputSuffixHeight = 30;
      }
    }
  }
});
const __cssModules$x = {};
var __component__$x = /* @__PURE__ */ normalizeComponent(__vue2_script$x, render$w, staticRenderFns$w, false, __vue2_injectStyles$x, "b904d634", null, null);
function __vue2_injectStyles$x(context2) {
  for (let o in __cssModules$x) {
    this[o] = __cssModules$x[o];
  }
}
__component__$x.options.__file = "src/components/common/SelectorDialog/src/mobile/OpSelectorDialog.vue";
var OpSelectorDialogMobile = /* @__PURE__ */ function() {
  return __component__$x.exports;
}();
var render$v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("el-container", {
    staticClass: "op-selector",
    staticStyle: {
      "background": "#fff",
      "width": "100%",
      "border": "1px solid #eee"
    }
  }, [_c("el-container", [_c("el-header", {
    staticStyle: {
      "height": "auto"
    }
  }, [_c("el-row", {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("el-input", {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": _vm.searchPlaceholder,
      "prefix-icon": "el-icon-search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.search.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchStr,
      callback: function($$v) {
        _vm.searchStr = $$v;
      },
      expression: "searchStr"
    }
  })], 1), _c("el-col", {
    attrs: {
      "span": 10
    }
  }, [_vm._t("search", function() {
    return [_c("div", [_vm._v("\xA0")])];
  })], 2), _c("el-col", {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 8
    }
  }, [_c("el-button", {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-search",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\u67E5\u8BE2")]), _c("el-button", {
    attrs: {
      "size": "small",
      "disabled": _vm.loading,
      "icon": "el-icon-refresh"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("\u91CD\u7F6E")]), _vm._t("rightAction", null, {
    "params": _vm.getQueryFilter
  })], 2)], 1)], 1), _c("el-main", {
    staticStyle: {
      "padding": "0"
    }
  }, [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "selectorTable",
    staticClass: "selector-table",
    attrs: {
      "data": _vm.data,
      "stripe": "",
      "border": "",
      "height": "450",
      "highlight-current-row": _vm.single,
      "reserve-selectio": true,
      "size": "small"
    },
    on: {
      "row-click": _vm.handleRowClick,
      "select": _vm.handleTableSelect,
      "select-all": _vm.handleAllTableSelect
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._t("empty", null, {
          "params": _vm.getQueryFilter
        })];
      },
      proxy: true
    }], null, true)
  }, [!_vm.single ? _c("el-table-column", {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "45"
    }
  }) : _vm._e(), _vm.single ? _c("el-table-column", {
    attrs: {
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c("el-radio", {
          staticClass: "form-radio",
          attrs: {
            "label": scope.row[_vm.checkedStatusKey]
          },
          model: {
            value: _vm.selectedId,
            callback: function($$v) {
              _vm.selectedId = $$v;
            },
            expression: "selectedId"
          }
        })];
      }
    }], null, false, 1068065652)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      "type": "index",
      "width": "60",
      "align": "center",
      "label": "\u5E8F\u53F7"
    }
  }), _vm._l(_vm.tableColumns, function(column, index2) {
    return _c("el-table-column", {
      key: index2,
      attrs: {
        "prop": column.prop,
        "label": column.label,
        "width": column.width
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [column.type == "timestamp" ? _c("div", {
            staticClass: "cell"
          }, [_vm._v(" " + _vm._s(_vm._f("dateformat")(scope.row[column.prop], "YYYY-MM-DD HH:mm:ss")) + " ")]) : _c("div", {
            staticClass: "cell"
          }, [_vm._v(_vm._s(scope.row[column.prop]))])];
        }
      }], null, true)
    });
  })], 2)], 1), _c("el-footer", {
    attrs: {
      "height": "50px"
    }
  }, [_c("el-row", {
    staticStyle: {
      "height": "50px",
      "align-items": "center"
    },
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c("el-pagination", {
    attrs: {
      "small": "",
      "disabled": _vm.loading,
      "current-page": _vm.pagination.pageNo,
      "page-sizes": [20, 50, 100, 200, 300],
      "page-size": _vm.pagination.pageSize,
      "pager-count": 5,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pagination.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1), _c("el-aside", {
    staticClass: "select-aside",
    attrs: {
      "width": "170px"
    }
  }, [_c("el-header", {
    staticClass: "select-header"
  }, [_c("span", {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\u5DF2\u9009\u62E9")])]), _c("div", {
    staticClass: "select-tree-div"
  }, _vm._l(_vm.selectedPreview, function(item) {
    return _c("el-tag", {
      key: item[_vm.checkedStatusKey],
      staticClass: "item",
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.removeItem(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.previewName) + " ")]);
  }), 1)], 1)], 1);
};
var staticRenderFns$v = [];
render$v._withStripped = true;
var OpSelector_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$w = defineComponent({
  name: "CommonSelector",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    checkedStatusKey: {
      type: String,
      default: "id"
    },
    tableColumns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    data: Array,
    single: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          pageNo: 1,
          pageSize: 50,
          total: 0
        };
      }
    },
    quickSearchProps: {
      type: [String, Array],
      required: true
    },
    nameConfig: Array
  },
  setup(props2, {
    emit: emit2
  }) {
    const selectorTable = ref(null);
    const {
      data: data22
    } = toRefs(props2);
    const selectedPreview = computed(() => {
      if (selects.value && selects.value.length > 0) {
        return selects.value.map((item) => {
          if (props2.nameConfig && Array.isArray(props2.nameConfig) && props2.nameConfig.length > 0) {
            item.previewName = props2.nameConfig.reduce((prev4, next3) => {
              prev4 += `${prev4 ? "-" : ""}${item[next3]}`;
              return prev4;
            }, "");
          } else {
            item.previewName = item.name;
          }
          return item;
        });
      } else {
        return [];
      }
    });
    const onShow = (initSelectors) => {
      if (!initSelectors) {
        selects.value = [...props2.value];
        syncCheckedStatus();
      } else {
        selects.value = initSelectors;
      }
      reset2();
    };
    const onHide = (sure) => {
      if (sure) {
        emit2("input", selects.value);
      }
    };
    const searchStr = ref(null);
    let paging = ref({
      pageNo: 1,
      pageSize: 20
    });
    const cachePaging = __spreadValues({}, paging.value);
    const getQueryFilter = computed(() => {
      let queryFilter = __spreadValues({
        querys: {}
      }, paging.value);
      if (props2.quickSearchProps && props2.quickSearchProps.constructor == String && searchStr.value) {
        let params = props2.quickSearchProps.split(",");
        params.forEach((item) => {
          let query = {
            [item]: searchStr.value
          };
          queryFilter.querys = Object.assign(queryFilter.querys, query);
        });
      }
      return queryFilter;
    });
    function load2() {
      emit2("load", getQueryFilter.value);
    }
    const search = () => {
      paging.value = __spreadValues({}, cachePaging);
      paging.value.pageNo = 1;
      load2();
    };
    const handleSizeChange = (size2) => {
      paging.value.pageSize = size2;
      load2();
    };
    const handleCurrentChange = (currentPage) => {
      paging.value.pageNo = currentPage;
      load2();
    };
    const reset2 = () => {
      searchStr.value = null;
      paging.value.pageNo = 1;
      emit2("reset", getQueryFilter.value);
    };
    const selectedId = ref(null);
    const selects = ref([]);
    const curSelectedRowIds = computed(() => {
      if (selects.value && selects.value.length > 0) {
        return selects.value.map((item) => item[props2.checkedStatusKey]);
      } else {
        return [];
      }
    });
    const handleRowClick = (row) => {
      if (props2.single) {
        selects.value = [row];
        selectedId.value = row[props2.checkedStatusKey];
      } else {
        if (!selectorTable.value || !selectorTable.value.selection) {
          throw "\u672A\u83B7\u53D6\u5230\u6570\u636E\u5217\u8868\uFF0C\u65E0\u6CD5\u9009\u62E9\u6570\u636E\u3002";
        }
        let _tag = true;
        selectorTable.value.selection.forEach((m) => {
          if (m === row) {
            selectorTable.value.toggleRowSelection(row, false);
            _tag = false;
          }
        });
        _tag && selectorTable.value.toggleRowSelection(row);
        const index2 = selects.value.findIndex((item) => item[props2.checkedStatusKey] === row[props2.checkedStatusKey]);
        if (index2 !== -1) {
          selects.value.splice(index2, 1);
        } else {
          selects.value.push(row);
        }
      }
    };
    const handleTableSelect = (selection, val) => {
      const index2 = selects.value.findIndex((item) => item[props2.checkedStatusKey] === val[props2.checkedStatusKey]);
      if (index2 !== -1) {
        selects.value.splice(index2, 1);
      } else {
        selects.value.push(val);
      }
    };
    const handleAllTableSelect = (val) => {
      const currentTableData = data22.value;
      if (val.length === currentTableData.length) {
        selects.value = [...selects.value, ...currentTableData];
        selects.value = selects.value.filter((item, index2, self2) => {
          return self2.findIndex((n) => n[props2.checkedStatusKey] === item[props2.checkedStatusKey]) === index2;
        });
      } else {
        selects.value = selects.value.filter((item) => {
          return currentTableData.findIndex((n) => n[props2.checkedStatusKey] === item[props2.checkedStatusKey]) === -1;
        });
      }
    };
    const removeItem = (item) => {
      selects.value.remove(item);
      syncCheckedStatus();
    };
    function syncCheckedStatus() {
      selectedId.value = null;
      if (props2.single) {
        selects.value.length === 1 && (selectedId.value = selects.value[0][props2.checkedStatusKey]);
      } else {
        if (!selectorTable.value || !selectorTable.value.selection) {
          throw "\u672A\u83B7\u53D6\u5230\u6570\u636E\u5217\u8868\uFF0C\u65E0\u6CD5\u9009\u62E9\u6570\u636E\u3002";
        }
        selectorTable.value.clearSelection();
        selects.value.length > 0 && nextTick(() => {
          data22.value.some((n) => {
            if (curSelectedRowIds.value.indexOf(n[props2.checkedStatusKey]) > -1) {
              selectorTable.value.toggleRowSelection(n, true);
            }
          });
        });
      }
    }
    watch(() => data22.value, (newVal) => {
      if (newVal && newVal.length > 0) {
        syncCheckedStatus();
      }
    });
    return {
      selectorTable,
      searchStr,
      getQueryFilter,
      paging,
      search,
      reset: reset2,
      handleCurrentChange,
      handleSizeChange,
      selectedId,
      selects,
      selectedPreview,
      curSelectedRowIds,
      onHide,
      onShow,
      handleRowClick,
      handleTableSelect,
      handleAllTableSelect,
      removeItem
    };
  }
});
const __cssModules$w = {};
var __component__$w = /* @__PURE__ */ normalizeComponent(__vue2_script$w, render$v, staticRenderFns$v, false, __vue2_injectStyles$w, "13e26f0d", null, null);
function __vue2_injectStyles$w(context2) {
  for (let o in __cssModules$w) {
    this[o] = __cssModules$w[o];
  }
}
__component__$w.options.__file = "src/components/common/SelectorDialog/src/pc/OpSelector.vue";
var CommonSelector = /* @__PURE__ */ function() {
  return __component__$w.exports;
}();
var render$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-selector-dialog"
  }, [_c("field-pannel", {
    attrs: {
      "list": _vm.selectors,
      "disabled": _vm.disabled,
      "closable": "",
      "config": {
        label: "name",
        value: _vm.checkedStatusKey
      }
    },
    on: {
      "close": _vm.handleRemove,
      "open": _vm.showDialog
    }
  }), _c("el-dialog", {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "width": _vm.width,
      "height": _vm.height,
      "top": "6vh",
      "before-close": _vm.handleClose,
      "close-on-click-modal": false,
      "append-to-body": _vm.appendToBody
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-container", {
    staticStyle: {
      "height": "68vh"
    }
  }, [_c("el-aside", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasSlot,
      expression: "hasSlot"
    }],
    staticClass: "left-aside",
    attrs: {
      "width": "280px"
    }
  }, [_c("div", {
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "overflow-y": "auto"
    }
  }, [_vm._t("modal")], 2)]), _c("CommonSelector", {
    ref: "opSelector",
    attrs: {
      "loading": _vm.loading,
      "data": _vm.data,
      "pagination": _vm.pagination,
      "table-columns": _vm.tableColumns,
      "quick-search-props": _vm.quickSearchProps,
      "single": _vm.single,
      "checked-status-key": _vm.checkedStatusKey,
      "search-placeholder": _vm.placeholder,
      "name-config": _vm.nameConfig
    },
    on: {
      "load": _vm.load,
      "reset": _vm.reset
    },
    scopedSlots: _vm._u([{
      key: "rightAction",
      fn: function(ref2) {
        var params = ref2.params;
        return [_vm._t("rightAction", null, {
          "params": params
        })];
      }
    }, {
      key: "search",
      fn: function() {
        return [_vm._t("search")];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function(ref2) {
        var params = ref2.params;
        return [_vm._t("empty", null, {
          "params": params
        })];
      }
    }], null, true),
    model: {
      value: _vm.selectors,
      callback: function($$v) {
        _vm.selectors = $$v;
      },
      expression: "selectors"
    }
  })], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.handleDialogSure
    }
  }, [_vm._v("\u786E \u5B9A")]), _c("el-button", {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleDialogCancel
    }
  }, [_vm._v("\u53D6 \u6D88")])], 1)], 1)], 1);
};
var staticRenderFns$u = [];
render$u._withStripped = true;
var OpSelectorDialog_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$v = defineComponent({
  name: "SelectorDialog",
  components: {
    CommonSelector,
    FieldPannel
  },
  props: {
    loading: Boolean,
    value: String,
    title: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false
    },
    single: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    width: {
      type: [String, Number],
      default: "60%"
    },
    height: {
      type: [String, Number],
      default: "60vh"
    },
    config: Object,
    tableColumns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          pageNo: 1,
          pageSize: 50,
          total: 0
        };
      }
    },
    checkedStatusKey: {
      type: String,
      default: "id"
    },
    quickSearchProps: {
      type: String,
      required: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    nameConfig: Array
  },
  setup(props2, {
    emit: emit2
  }) {
    const opSelector = ref(null);
    const dialogVisible = ref(false);
    const selectors = ref([]);
    const {
      config,
      value: value9
    } = toRefs(props2);
    const hasSlot = computed(() => {
      const {
        slots: slots2
      } = proxyGetCurrentInstance();
      const keys = Object.keys(slots2);
      return slots2 && keys.length > 0 && keys.includes("modal");
    });
    const {
      getArrayValFromVForm,
      setValToVForm
    } = useVForm(config);
    const initValue = () => {
      if (Object.keys(config.value).length > 0) {
        const _list = getArrayValFromVForm(value9.value, props2.nameConfig);
        if (!arrayEquals$1(_list, selectors.value)) {
          selectors.value = _list;
        }
      }
    };
    const [internalValue, setInnerValue] = useVModel(value9, "", () => {
    }, "onChange");
    onMounted(() => {
      initValue();
    });
    watch(() => selectors.value, (nval) => {
      const names = nval.map((i) => i.name).join(",");
      setInnerValue(names, nval);
      setValToVForm(nval);
    });
    watch(value9, (val, oval) => {
      if (!oval && val) {
        initValue();
      }
    });
    watch(config, (c) => {
      initValue();
    });
    const showDialog = async () => {
      if (props2.disabled) {
        return;
      }
      dialogVisible.value = true;
      initValue();
      setTimeout(() => {
        opSelector.value.onShow();
      }, 16);
    };
    const handleClose = (done) => {
      opSelector.value.onHide();
      done && done();
    };
    const handleDialogSure = () => {
      dialogVisible.value = false;
      opSelector.value.onHide(true);
      emit2("onConfirm", selectors.value);
    };
    const handleDialogCancel = () => {
      dialogVisible.value = false;
      opSelector.value.onHide();
    };
    const handleRemove = (item) => {
      const removeItem = selectors.value.find((x) => x[props2.checkedStatusKey] === item[props2.checkedStatusKey]);
      selectors.value.remove(removeItem);
      emit2("onConfirm", selectors.value);
    };
    const load2 = (param, cb) => {
      emit2("load", param, cb);
    };
    const reset2 = (params) => {
      emit2("reset", params);
    };
    return {
      selectors,
      dialogVisible,
      opSelector,
      hasSlot,
      showDialog,
      handleClose,
      handleDialogSure,
      handleDialogCancel,
      handleRemove,
      load: load2,
      reset: reset2
    };
  }
});
const __cssModules$v = {};
var __component__$v = /* @__PURE__ */ normalizeComponent(__vue2_script$v, render$u, staticRenderFns$u, false, __vue2_injectStyles$v, "347a78b5", null, null);
function __vue2_injectStyles$v(context2) {
  for (let o in __cssModules$v) {
    this[o] = __cssModules$v[o];
  }
}
__component__$v.options.__file = "src/components/common/SelectorDialog/src/pc/OpSelectorDialog.vue";
var OpSelectorDialogPC = /* @__PURE__ */ function() {
  return __component__$v.exports;
}();
let OpSelectorDialog = isPCWidth() ? OpSelectorDialogPC : OpSelectorDialogMobile;
var render$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("SelectorDialog", {
    attrs: {
      "title": "\u9009\u62E9\u7EC4\u7EC7",
      "placeholder": "\u8BF7\u8F93\u5165\u540D\u79F0\u3001\u7F16\u7801\u3001\u8DEF\u5F84\u641C\u7D22",
      "single": _vm.single,
      "data": _vm.tableData,
      "config": _vm.config,
      "loading": _vm.loading,
      "checked-status-key": "id",
      "right-text": "\u9009\u62E9\u90E8\u95E8",
      "width": "80%",
      "table-columns": _vm.tableColumns,
      "pagination": _vm.pagination,
      "append-to-body": _vm.appendToBody,
      "quick-search-props": "name,code"
    },
    on: {
      "update:data": function($event) {
        _vm.tableData = $event;
      },
      "load": _vm.loadData,
      "reset": _vm.reset,
      "click-right": function($event) {
        return _vm.$refs.opOrgsTree.showPopup();
      },
      "onConfirm": _vm.onConfirm
    },
    scopedSlots: _vm._u([{
      key: "modal",
      fn: function() {
        return [_c("op-orgs-tree", {
          ref: "opOrgsTree",
          on: {
            "node-click": _vm.handleNodeClick
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.userVals,
      callback: function($$v) {
        _vm.userVals = $$v;
      },
      expression: "userVals"
    }
  });
};
var staticRenderFns$t = [];
render$t._withStripped = true;
const __vue2_script$u = defineComponent({
  name: "OpOrgDialogSelector",
  components: {
    SelectorDialog: OpSelectorDialog
  },
  props: {
    value: String,
    placeholder: String,
    single: Boolean,
    config: Object,
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const tableData = ref([]);
    const loading2 = ref(false);
    const departmentIdList = ref([]);
    const opOrgsTree = ref(null);
    const pagination = ref({
      pageNo: 1,
      pageSize: 20,
      total: 0
    });
    const userVals = computed({
      get() {
        return props2.value;
      },
      set(newValue) {
        emit2("input", newValue);
      }
    });
    const tableColumns = ref([{
      prop: "name",
      label: "\u540D\u79F0",
      width: 150
    }, {
      prop: "no",
      label: "\u7F16\u7801",
      width: 100
    }, {
      prop: "parentIdsName",
      label: "\u8DEF\u5F84"
    }]);
    function getChildrenIds(data22) {
      if (data22.children) {
        data22.children.forEach((element) => {
          departmentIdList.value.push(element.id);
          getChildrenIds(element);
        });
      }
    }
    const loadData = async (param) => {
      let searchStr = "";
      if (param.querys && param.querys.name) {
        searchStr = param.querys["name"];
      }
      if (param) {
        pagination.value.pageNo = param.pageNo || 1;
        pagination.value.pageSize = param.pageSize || 20;
      }
      let _params = {
        searchStr,
        orgType: "OPPEIN",
        type: "oppein",
        pageNo: pagination.value.pageNo,
        orgId: "1",
        pageSize: pagination.value.pageSize
      };
      if (departmentIdList.value.length > 0 && departmentIdList.value[0] !== "-1") {
        _params.parentId = departmentIdList.value[0];
      }
      if (!searchStr && departmentIdList.value.length === 0) {
        _Message.warning("\u8BF7\u8F93\u5165\u540D\u79F0\u3001\u7F16\u7801\u3001\u8DEF\u5F84\u641C\u7D22\u6216\u9009\u62E9\u7EC4\u7EC7\u67B6\u6784\u540E\u641C\u7D22");
        return;
      }
      loading2.value = true;
      const {
        status,
        data: data22
      } = await getDepartmentPageListByConToPost(_params);
      loading2.value = false;
      if (status) {
        if (!isPCWidth() && data22.current > 1) {
          tableData.value = [...tableData.value, ...data22.records];
        } else {
          tableData.value = data22.records;
        }
        pagination.value.pageSize = data22.size;
        pagination.value.total = data22.total;
      }
    };
    const handleNodeClick = (org) => {
      pagination.value.pageNo = 1;
      departmentIdList.value = [org.id];
      getChildrenIds(org);
      loadData(pagination.value);
    };
    const onConfirm = (users) => {
      emit2("onConfirm", users);
    };
    const reset2 = (param) => {
      tableData.value = [];
      departmentIdList.value = [];
    };
    return {
      tableData,
      loading: loading2,
      pagination,
      tableColumns,
      userVals,
      opOrgsTree,
      loadData,
      handleNodeClick,
      onConfirm,
      reset: reset2
    };
  }
});
const __cssModules$u = {};
var __component__$u = /* @__PURE__ */ normalizeComponent(__vue2_script$u, render$t, staticRenderFns$t, false, __vue2_injectStyles$u, null, null, null);
function __vue2_injectStyles$u(context2) {
  for (let o in __cssModules$u) {
    this[o] = __cssModules$u[o];
  }
}
__component__$u.options.__file = "packages/op-org-dialog-selector/src/index.vue";
var Selector$1 = /* @__PURE__ */ function() {
  return __component__$u.exports;
}();
var index$j = "";
var _createNamespace$m = createNamespace("notify"), createComponent$m = _createNamespace$m[0], bem$m = _createNamespace$m[1];
function Notify$1(h, props2, slots2, ctx) {
  var style6 = {
    color: props2.color,
    background: props2.background
  };
  return h(_Popup, _mergeJSXProps([{
    "attrs": {
      "value": props2.value,
      "position": "top",
      "overlay": false,
      "duration": 0.2,
      "lockScroll": false
    },
    "style": style6,
    "class": [bem$m([props2.type]), props2.className]
  }, inherit(ctx, true)]), [(slots2.default == null ? void 0 : slots2.default()) || props2.message]);
}
Notify$1.props = _extends$o({}, popupMixinProps, {
  color: String,
  message: [Number, String],
  duration: [Number, String],
  className: null,
  background: String,
  getContainer: [String, Function],
  type: {
    type: String,
    default: "danger"
  }
});
var VanNotify = createComponent$m(Notify$1);
var timer;
var instance$1;
function parseOptions(message2) {
  return isObject$2(message2) ? message2 : {
    message: message2
  };
}
function Notify(options) {
  if (isServer$3) {
    return;
  }
  if (!instance$1) {
    instance$1 = mount(VanNotify, {
      on: {
        click: function click2(event) {
          if (instance$1.onClick) {
            instance$1.onClick(event);
          }
        },
        close: function close3() {
          if (instance$1.onClose) {
            instance$1.onClose();
          }
        },
        opened: function opened() {
          if (instance$1.onOpened) {
            instance$1.onOpened();
          }
        }
      }
    });
  }
  options = _extends$o({}, Notify.currentOptions, parseOptions(options));
  _extends$o(instance$1, options);
  clearTimeout(timer);
  if (options.duration && options.duration > 0) {
    timer = setTimeout(Notify.clear, options.duration);
  }
  return instance$1;
}
function defaultOptions() {
  return {
    type: "danger",
    value: true,
    message: "",
    color: void 0,
    background: void 0,
    duration: 3e3,
    className: "",
    onClose: null,
    onClick: null,
    onOpened: null
  };
}
Notify.clear = function() {
  if (instance$1) {
    instance$1.value = false;
  }
};
Notify.currentOptions = defaultOptions();
Notify.setDefaultOptions = function(options) {
  _extends$o(Notify.currentOptions, options);
};
Notify.resetDefaultOptions = function() {
  Notify.currentOptions = defaultOptions();
};
Notify.install = function() {
  Vue$1.use(VanNotify);
};
Notify.Component = VanNotify;
Vue$1.prototype.$notify = Notify;
const OrganizationalStructureList = "OrganizationalStructureList";
const OrganizationalStructureList_expires = "OrganizationalStructureList_expires";
function useOrgsTree() {
  const {
    root: root2
  } = proxyGetCurrentInstance();
  const orgs = ref([]);
  const loadOrgTree = async () => {
    const cacheVal = getCacheData();
    if (cacheVal) {
      orgs.value = cacheVal;
      return;
    }
    const res = await getOrganizationalStructureList({
      orgType: "OPPEIN",
      type: "department"
    });
    const departmentList = tile2nest(res.data.departmentList, "id", "superiorId", "children");
    orgs.value = [{
      name: "\u6B27\u6D3E\u5BB6\u5C45\u96C6\u56E2",
      id: "1",
      superiorId: "-1",
      children: departmentList
    }];
    cacheData(orgs.value);
  };
  function cacheData(tree) {
    root2.$data[OrganizationalStructureList] = tree;
    root2.$data[OrganizationalStructureList_expires] = new Date().valueOf();
  }
  function getCacheData() {
    const _val = root2.$data[OrganizationalStructureList];
    const _expries = root2.$data[OrganizationalStructureList_expires];
    if (_val && new Date().valueOf() - _expries < 60 * 60 * 1e3 * 2) {
      return _val;
    } else {
      return null;
    }
  }
  return {
    orgs,
    loadOrgTree
  };
}
var render$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("van-popup", {
    staticStyle: {
      "height": "100vh",
      "width": "100%"
    },
    attrs: {
      "position": "bottom"
    },
    model: {
      value: _vm.dialogVisible,
      callback: function($$v) {
        _vm.dialogVisible = $$v;
      },
      expression: "dialogVisible"
    }
  }, [_c("van-nav-bar", {
    attrs: {
      "title": "\u9009\u62E9\u90E8\u95E8",
      "fixed": "",
      "left-text": "\u8FD4\u56DE",
      "left-arrow": ""
    },
    on: {
      "click-right": function($event) {
        return _vm.$emit("click-right");
      },
      "click-left": function($event) {
        _vm.dialogVisible = false;
      }
    }
  }), _c("el-tree", {
    staticStyle: {
      "margin": "40px 0 60px"
    },
    attrs: {
      "data": _vm.orgs,
      "default-expand-all": false,
      "highlight-current": "",
      "default-expanded-keys": ["-1"],
      "node-key": "id",
      "check-strictly": "",
      "props": {
        children: "children",
        label: "name",
        isLeaf: "leaf"
      }
    },
    on: {
      "node-click": _vm.handleRowClick
    }
  }), _c("div", {
    staticClass: "popup__footer"
  }, [_c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handelConfirm
    }
  }, [_vm._v("\u786E\u5B9A")])], 1)], 1);
};
var staticRenderFns$s = [];
render$s._withStripped = true;
var OpOrgsTree_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$t = defineComponent({
  name: "OpOrgsTree",
  setup(props2, {
    emit: emit2
  }) {
    const {
      orgs,
      loadOrgTree
    } = useOrgsTree();
    const dialogVisible = ref(false);
    const currentNode = ref(null);
    const selectors = ref([]);
    const showPopup = async () => {
      currentNode.value = null;
      dialogVisible.value = true;
      await loadOrgTree();
    };
    const handleRowClick = (node2) => {
      currentNode.value = node2;
    };
    const handelConfirm = () => {
      if (!currentNode.value)
        return Notify("\u8BF7\u9009\u62E9\u4E00\u9879\uFF01");
      emit2("node-click", currentNode.value);
      dialogVisible.value = false;
    };
    return {
      orgs,
      dialogVisible,
      loadOrgTree,
      currentNode,
      selectors,
      showPopup,
      handleRowClick,
      handelConfirm
    };
  }
});
const __cssModules$t = {};
var __component__$t = /* @__PURE__ */ normalizeComponent(__vue2_script$t, render$s, staticRenderFns$s, false, __vue2_injectStyles$t, "ed2cdd96", null, null);
function __vue2_injectStyles$t(context2) {
  for (let o in __cssModules$t) {
    this[o] = __cssModules$t[o];
  }
}
__component__$t.options.__file = "packages/op-orgs-tree/src/mobile/OpOrgsTree.vue";
var OpOrgsTreeMobile = /* @__PURE__ */ function() {
  return __component__$t.exports;
}();
var render$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_vm.supportFilter ? _c("div", {
    staticClass: "tree-header"
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u8FC7\u6EE4\u6761\u4EF6",
      "clearable": ""
    },
    model: {
      value: _vm.filterText,
      callback: function($$v) {
        _vm.filterText = $$v;
      },
      expression: "filterText"
    }
  }, [_c("i", {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })]), _c("div", {
    class: _vm.isIeExplorer ? "tree-button-group is-ie-explorer flex" : "tree-button-group flex"
  }, [_c("i", {
    staticClass: "el-icon-refresh",
    class: {
      "icon-spin": _vm.loading
    },
    attrs: {
      "title": "\u5237\u65B0"
    },
    on: {
      "click": _vm.refresh
    }
  })])], 1) : _vm._e(), _c("el-tree", {
    ref: "elTree",
    style: {
      background: _vm.supportFilter ? "#fafafa" : ""
    },
    attrs: {
      "data": _vm.data,
      "props": _vm.defaultProps,
      "default-expand-all": _vm.defaultExpandAll,
      "filter-node-method": _vm.filterNode,
      "load": _vm.load,
      "lazy": _vm.lazy,
      "show-checkbox": _vm.showCheckbox,
      "accordion": _vm.accordion,
      "node-key": _vm.nodeKey,
      "default-expanded-keys": _vm.defaultExpandedKeys,
      "highlight-current": _vm.highlightCurrent,
      "render-after-expand": _vm.renderAfterExpand,
      "render-content": _vm.renderContent,
      "check-on-click-node": _vm.checkOnClickNode,
      "auto-expand-parent": _vm.autoExpandParent,
      "check-strictly": _vm.checkStrictly,
      "current-node-key": _vm.currentNodeKey,
      "indent": _vm.indent,
      "icon-class": _vm.iconClass,
      "draggable": _vm.draggable,
      "allow-drag": _vm.allowDrag,
      "allow-drop": _vm.allowDrop,
      "expand-on-click-node": _vm.expandOnClickNode,
      "default-checked-keys": _vm.defaultCheckedKeys
    },
    on: {
      "node-click": _vm.handleNodeClick,
      "node-contextmenu": _vm.nodeContextmenu,
      "check-change": _vm.checkChange,
      "check": _vm.check,
      "current-change": _vm.currentChange,
      "node-expand": _vm.nodeExpand,
      "node-collapse": _vm.nodeCollapse,
      "node-drag-start": _vm.nodeDragStart,
      "node-drag-enter": _vm.nodeDragEnter,
      "node-drag-leave": _vm.nodeDragLeave,
      "node-drag-over": _vm.nodeDragOver,
      "node-drag-end": _vm.nodeDragEnd,
      "node-drop": _vm.nodeDrop
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref2) {
        var node2 = ref2.node;
        return _vm._t("default", function() {
          return [_c("span", {
            staticClass: "custom-tree-node"
          }, [_c("span", {
            staticClass: "el-tree-node__label show-ellipsis",
            class: {
              "full-width": !_vm.showMoreButton
            },
            attrs: {
              "title": node2.label
            }
          }, [_vm._v(_vm._s(node2.label))]), _vm.showMoreButton ? _c("i", {
            staticClass: "icon-more",
            attrs: {
              "title": "\u66F4\u591A\u64CD\u4F5C"
            }
          }) : _vm._e()])];
        }, {
          "node": node2,
          "data": _vm.data
        });
      }
    }], null, true)
  })], 1);
};
var staticRenderFns$r = [];
render$r._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$4 = "";
const __vue2_script$s = {
  name: "BaseTree",
  props: {
    data: Array,
    load: {
      type: Function
    },
    lazy: {
      type: Boolean,
      default: false
    },
    accordion: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default: function() {
        return {
          children: "children",
          label: "label"
        };
      }
    },
    supportFilter: {
      type: Boolean,
      default: false
    },
    showMoreButton: {
      type: Boolean,
      default: true
    },
    iconClass: {
      type: String
    },
    nodeKey: {
      type: String
    },
    defaultExpandedKeys: {
      type: Array
    },
    highlightCurrent: {
      type: Boolean,
      default: false
    },
    renderAfterExpand: {
      type: Boolean,
      default: true
    },
    renderContent: {
      type: Function
    },
    checkOnClickNode: {
      type: Boolean,
      default: false
    },
    autoExpandParent: {
      type: Boolean,
      default: true
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    currentNodeKey: {
      type: [String, Number]
    },
    indent: {
      type: Number,
      default: 16
    },
    draggable: {
      type: Boolean,
      default: false
    },
    allowDrag: {
      type: Function
    },
    allowDrop: {
      type: Function
    },
    expandOnClickNode: {
      type: Boolean,
      default: true
    },
    defaultCheckedKeys: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      filterText: "",
      isExpand: this.defaultExpandAll,
      isCanShowCode: false,
      isIeExplorer: false,
      loading: false,
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  watch: {
    filterText(val) {
      this.$refs.elTree.filter(val);
    },
    defaultCheckedKeys(val) {
      this.$refs.elTree.setCheckedKeys(val);
    },
    props(val) {
      this.defaultProps = val;
    }
  },
  mounted() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.isIeExplorer = true;
    }
  },
  methods: {
    filterNode(value9, data22) {
      if (!value9)
        return true;
      return data22[this.props.label].indexOf(value9) !== -1;
    },
    handleNodeClick(data22, node2, nodeComponent) {
      this.$emit("node-click", data22, node2, nodeComponent);
    },
    nodeContextmenu(event, data22, node2, nodeComponent) {
      this.$emit("node-contextmenu", event, data22, node2, nodeComponent);
    },
    checkChange(data22, isChecked, hasChildChecked) {
      this.$emit("check-change", data22, isChecked, hasChildChecked);
    },
    check(data22, checkedObj) {
      this.$emit("check", data22, checkedObj);
    },
    currentChange(data22, node2) {
      this.$emit("current-change", data22, node2);
    },
    nodeExpand(data22, node2, nodeComponent) {
      this.$emit("node-expand", data22, node2, nodeComponent);
    },
    nodeCollapse(data22, node2, nodeComponent) {
      this.$emit("node-collapse", data22, node2, nodeComponent);
    },
    nodeDragStart(node2, event) {
      this.$emit("node-drag-start", node2, event);
    },
    nodeDragEnter(dragNode, enterNode, event) {
      this.$emit("node-drag-enter", dragNode, enterNode, event);
    },
    nodeDragLeave(dragNode, enterNode, event) {
      this.$emit("node-drag-leave", dragNode, enterNode, event);
    },
    nodeDragOver(dragNode, enterNode, event) {
      this.$emit("node-drag-over", dragNode, enterNode, event);
    },
    nodeDragEnd(dragNode, endNode, position, event) {
      this.$emit("node-drag-end", dragNode, endNode, position, event);
    },
    nodeDrop(dragNode, endNode, position, event) {
      this.$emit("node-drop", dragNode, endNode, position, event);
    },
    handleExpandCollapse() {
      this.isExpand = !this.isExpand;
      let elTree = this.$refs.elTree;
      for (var i = 0; i < elTree.store._getAllNodes().length; i++) {
        elTree.store._getAllNodes()[i].expanded = this.isExpand;
      }
    },
    getNode(key2) {
      return this.$refs.elTree.getNode(key2);
    },
    setCheckedNodes(nodes) {
      return this.$refs.elTree.setCheckedNodes(nodes);
    },
    elTreeRef() {
      return this.$refs.elTree;
    },
    refresh() {
      this.loading = true;
      this.$emit("refresh", () => {
        this.loading = false;
        this.isExpand = this.defaultExpandAll;
      });
      setTimeout(() => {
        this.loading = false;
        this.isExpand = this.defaultExpandAll;
      }, 5e3);
    },
    showCode() {
      this.isCanShowCode = !this.isCanShowCode;
      this.$emit("is-show-code", this.isCanShowCode);
    }
  }
};
const __cssModules$s = {};
var __component__$s = /* @__PURE__ */ normalizeComponent(__vue2_script$s, render$r, staticRenderFns$r, false, __vue2_injectStyles$s, "49a8b6b6", null, null);
function __vue2_injectStyles$s(context2) {
  for (let o in __cssModules$s) {
    this[o] = __cssModules$s[o];
  }
}
__component__$s.options.__file = "src/components/common/BaseTree/index.vue";
var BaseTree = /* @__PURE__ */ function() {
  return __component__$s.exports;
}();
var render$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-orgs-tree"
  }, [_c("base-tree", {
    ref: "tree",
    staticClass: "org-tree",
    attrs: {
      "load": _vm.loadOrgTree,
      "data": _vm.orgs,
      "default-expand-all": false,
      "highlight-current": true,
      "props": {
        children: "children",
        label: "name",
        isLeaf: "leaf"
      },
      "node-key": _vm.nodeKey,
      "default-expanded-keys": ["-1"],
      "accordion": ""
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1);
};
var staticRenderFns$q = [];
render$q._withStripped = true;
const __vue2_script$r = defineComponent({
  name: "OpOrgsTree",
  components: {
    BaseTree
  },
  props: {
    nodeKey: {
      type: String,
      default: "id"
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const {
      orgs,
      loadOrgTree
    } = useOrgsTree();
    const handleNodeClick = (item) => {
      emit2("node-click", item);
    };
    loadOrgTree();
    return {
      orgs,
      loadOrgTree,
      handleNodeClick
    };
  }
});
const __cssModules$r = {};
var __component__$r = /* @__PURE__ */ normalizeComponent(__vue2_script$r, render$q, staticRenderFns$q, false, __vue2_injectStyles$r, null, null, null);
function __vue2_injectStyles$r(context2) {
  for (let o in __cssModules$r) {
    this[o] = __cssModules$r[o];
  }
}
__component__$r.options.__file = "packages/op-orgs-tree/src/pc/OpOrgsTree.vue";
var OpOrgsTreePC = /* @__PURE__ */ function() {
  return __component__$r.exports;
}();
let OpOrgsTree = {};
OpOrgsTree.install = (Vue2, opt = {}) => {
  let component = isPCWidth() ? OpOrgsTreePC : OpOrgsTreeMobile;
  Vue2.component(component.name, component);
};
var __glob_6_21 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpOrgsTree
});
const OpFormMap = {};
const install$1 = function(Vue2) {
  Vue2.directive("form", {
    bind: function(el, binding, vnode) {
      const inst = vnode.context;
      if (inst && !inst.hasOwnProperty("watchMap")) {
        inst["watchMap"] = new Map();
      }
    }
  });
};
if (window.Vue) {
  window["op-form-map"] = OpFormMap;
  Vue.use(install$1);
}
OpFormMap.install = install$1;
Array.prototype.remove = function(item) {
  let index2 = this.findIndex((v) => v === item);
  if (index2 > -1) {
    this.splice(index2, 1);
  }
};
Array.prototype.unique = function(arg) {
  const res = new Map();
  return this.filter((m) => {
    if (arg) {
      return !res.has(m[arg]) && res.set(m[arg], 1);
    } else {
      return !res.has(m) && res.set(m, 1);
    }
  });
};
Array.prototype.trim = function() {
  return this.filter((m) => m !== "");
};
Array.prototype.groupByKey = function(key2) {
  let res = {};
  this.forEach((m) => {
    let group = res[m[key2]];
    if (!group) {
      group = [];
      res[m[key2]] = group;
    }
    group.push(m);
  });
  return res;
};
Array.prototype.groupByKey = function(key2) {
  let res = {};
  this.forEach((m) => {
    let group = res[m[key2]];
    if (!group) {
      group = [];
      res[m[key2]] = group;
    }
    group.push(m);
  });
  return res;
};
Array.prototype.extractByKey = function(key2) {
  let set4 = new Set();
  this.forEach((m) => {
    if (key2 && m[key2]) {
      set4.add(m[key2]);
    }
  });
  return Array.from(set4);
};
Selector$1.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(Selector$1.name, prefix);
  Vue2.use(OpOrgsTree);
  Vue2.component(comName, Selector$1);
  Vue2.use(OpFormMap);
};
var __glob_6_18 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": Selector$1
});
var render$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("SelectorDialog", {
    attrs: {
      "title": "\u9009\u62E9\u7ECF\u8425\u6743",
      "placeholder": "\u8F93\u5165\u5546\u573A\u540D\u79F0\u3001\u7EC4\u7EC7\u7F16\u7801",
      "single": _vm.single,
      "data": _vm.tableData,
      "config": _vm.config,
      "loading": _vm.loading,
      "checked-status-key": "id",
      "table-columns": _vm.tableColumns,
      "pagination": _vm.pagination,
      "append-to-body": _vm.appendToBody,
      "name-config": _vm.nameConfig,
      "width": "80%",
      "quick-search-props": "name,account"
    },
    on: {
      "update:data": function($event) {
        _vm.tableData = $event;
      },
      "load": _vm.loadData,
      "reset": _vm.reset,
      "onConfirm": _vm.onConfirm
    },
    scopedSlots: _vm._u([{
      key: "search",
      fn: function() {
        return [_c("el-row", {
          staticStyle: {
            "margin": "10px 0"
          },
          attrs: {
            "gutter": 10
          }
        }, [_c("el-col", {
          attrs: {
            "span": 4
          }
        }, [_c("el-input", {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "clearable": "",
            "size": "small",
            "placeholder": "\u8BF7\u8F93\u5165k3\u7F16\u7801"
          },
          model: {
            value: _vm.searchParams.k3Code,
            callback: function($$v) {
              _vm.$set(_vm.searchParams, "k3Code", $$v);
            },
            expression: "searchParams.k3Code"
          }
        })], 1), _c("el-col", {
          attrs: {
            "span": 4
          }
        }, [_c("el-input", {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "\u8BF7\u8F93\u5165k3\u540D\u79F0"
          },
          model: {
            value: _vm.searchParams.k3Name,
            callback: function($$v) {
              _vm.$set(_vm.searchParams, "k3Name", $$v);
            },
            expression: "searchParams.k3Name"
          }
        })], 1), _c("el-col", {
          attrs: {
            "span": 4
          }
        }, [_c("el-input", {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "\u8BF7\u8F93\u5165\u6CD5\u4EBA\u540D\u79F0"
          },
          model: {
            value: _vm.searchParams.orgLegalPersonName,
            callback: function($$v) {
              _vm.$set(_vm.searchParams, "orgLegalPersonName", $$v);
            },
            expression: "searchParams.orgLegalPersonName"
          }
        })], 1), _c("el-col", {
          attrs: {
            "span": 4
          }
        }, [_c("el-select", {
          attrs: {
            "placeholder": "\u8BF7\u9009\u62E9\u5E02\u573A\u7EA7\u522B",
            "clearable": ""
          },
          model: {
            value: _vm.searchParams.orgMarketRank,
            callback: function($$v) {
              _vm.$set(_vm.searchParams, "orgMarketRank", $$v);
            },
            expression: "searchParams.orgMarketRank"
          }
        }, _vm._l(_vm.ROOT_MARKETLEVEL, function(item) {
          return _c("el-option", {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          });
        }), 1)], 1), _c("el-col", {
          attrs: {
            "span": 6
          }
        }, [_c("op-market-line-select", {
          attrs: {
            "classify": _vm.classify,
            "multiple": ""
          },
          model: {
            value: _vm.searchParams.lineIdList,
            callback: function($$v) {
              _vm.$set(_vm.searchParams, "lineIdList", $$v);
            },
            expression: "searchParams.lineIdList"
          }
        })], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.orgRightVals,
      callback: function($$v) {
        _vm.orgRightVals = $$v;
      },
      expression: "orgRightVals"
    }
  });
};
var staticRenderFns$p = [];
render$p._withStripped = true;
const __vue2_script$q = defineComponent({
  name: "OpOrgRightSelect",
  components: {
    SelectorDialog: OpSelectorDialog
  },
  props: {
    value: String,
    single: {
      type: Boolean,
      default: true
    },
    config: Object,
    appendToBody: {
      type: Boolean,
      default: false
    },
    nameConfig: {
      type: Array,
      default: () => []
    },
    defaultParams: {
      type: Object,
      default: () => {
      }
    },
    classify: {
      type: String,
      default: "OP-YG0"
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const {
      ROOT_MARKETLEVEL,
      getDictData
    } = useDictData(["ROOT_MARKETLEVEL"]);
    getDictData();
    const tableData = ref([]);
    const loading2 = ref(false);
    const pagination = ref({
      pageNo: 1,
      pageSize: 10,
      total: 0,
      showTotal: true
    });
    const searchParams = reactive({
      k3Code: "",
      k3Name: "",
      orgLegalPersonName: "",
      lineIdList: [],
      orgMarketRank: ""
    });
    const orgRightVals = computed({
      get() {
        return props2.value;
      },
      set(newValue) {
        emit2("input", newValue);
      }
    });
    const tableColumns = ref([{
      prop: "orgK3Name",
      label: "k3\u5BA2\u6237\u540D\u79F0",
      width: "200"
    }, {
      prop: "orgK3Code",
      label: "k3\u5BA2\u6237\u7F16\u7801",
      width: "140"
    }, {
      prop: "orgName",
      label: "\u5546\u573A\u540D\u79F0",
      width: "120"
    }, {
      prop: "orgNo",
      label: "\u7EC4\u7EC7\u7F16\u7801",
      width: "120"
    }, {
      prop: "orgBelongMarketClassifyName",
      label: "\u6240\u5C5E\u4E8B\u4E1A\u7EBF",
      width: "150"
    }, {
      prop: "orgMarketRank",
      label: "\u5E02\u573A\u7EA7\u522B",
      width: "80"
    }, {
      prop: "orgBelongClassifyName",
      label: "\u6240\u5C5E\u7EBF\u522B",
      width: "120"
    }, {
      prop: "orgBelongClassifySalesName",
      label: "\u6240\u5C5E\u7ECF\u9500\u90E8",
      width: "150"
    }, {
      prop: "orgLegalPersonName",
      label: "\u6CD5\u4EBA",
      width: "80"
    }, {
      prop: "orgStoreAdminName",
      label: "\u5546\u573A\u7BA1\u7406\u5458",
      width: "120"
    }]);
    const reset2 = async () => {
      tableData.value = [];
      searchParams.k3Code = "";
      searchParams.k3Name = "";
      searchParams.lineIdList = [];
      searchParams.orgLegalPersonName = "";
      searchParams.orgMarketRank = "";
    };
    const loadData = async (param) => {
      let searchStr = "";
      if (param.querys && param.querys.name) {
        searchStr = param.querys["name"];
      }
      if (param) {
        pagination.value.pageNo = param.pageNo || 1;
        pagination.value.pageSize = param.pageSize || 10;
      }
      const defaultParams = props2.defaultParams || {};
      let _params = __spreadValues(__spreadValues({
        searchStr,
        pageNo: pagination.value.pageNo,
        pageSize: pagination.value.pageSize
      }, searchParams), defaultParams);
      loading2.value = true;
      const {
        status,
        data: data22
      } = await getOrgRightList(_params);
      loading2.value = false;
      tableData.value = data22.records.map((item) => {
        item.id = item.orgMarketManageRightCode;
        item.name = item.orgName;
        return item;
      });
      pagination.value.total = data22.total;
    };
    const onConfirm = (users) => {
      emit2("onConfirm", users);
    };
    return {
      tableData,
      loading: loading2,
      searchParams,
      pagination,
      tableColumns,
      orgRightVals,
      ROOT_MARKETLEVEL,
      loadData,
      reset: reset2,
      onConfirm
    };
  }
});
const __cssModules$q = {};
var __component__$q = /* @__PURE__ */ normalizeComponent(__vue2_script$q, render$p, staticRenderFns$p, false, __vue2_injectStyles$q, null, null, null);
function __vue2_injectStyles$q(context2) {
  for (let o in __cssModules$q) {
    this[o] = __cssModules$q[o];
  }
}
__component__$q.options.__file = "packages/op-org-right-select/src/index.vue";
var OpOrgRightSelect = /* @__PURE__ */ function() {
  return __component__$q.exports;
}();
OpOrgRightSelect.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpOrgRightSelect.name, prefix);
  Vue2.component(comName, OpOrgRightSelect);
  Vue2.use(Selector$2);
  Vue2.use(OpFormMap);
};
var __glob_6_19 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpOrgRightSelect
});
function getOptionsData(api2, params) {
  const options = ref([]);
  const flatData = ref([]);
  function setCascaderData(tree) {
    tree.forEach((i) => {
      if (Array.isArray(i.children) && i.children.length > 0) {
        setCascaderData(i.children);
      } else {
        flatData.value.push({
          label: i.name,
          value: i.id
        });
        delete i.children;
      }
    });
    return tree;
  }
  const getData2 = async () => {
    const res = await api2(__spreadValues({}, params));
    if (res.status) {
      options.value = setCascaderData(res.data);
    }
    return options.value;
  };
  return {
    options,
    flatData,
    getData: getData2
  };
}
function useSelect(props2, mapConfig = {
  id: "id"
}) {
  const {
    value: value9
  } = toRefs(props2);
  const [internalValue, setInnerValue] = useVModel(value9, "", props2.onChange, "change");
  const selected = ref([]);
  const lastValue = ref("");
  function checkIsMultipleVal(val) {
    return val && val.some((x) => Array.isArray(x));
  }
  const initData = (options) => {
    if (!value9.value || value9.value.length === 0) {
      return;
    }
    const arr = revertTree2List(options, value9.value[0], mapConfig);
    selected.value = arr;
  };
  const handleSelect = (val, item) => {
    if (checkIsMultipleVal(val)) {
      const _vals = val.map((item2) => item2[item2.length - 1]);
      setInnerValue(_vals, val, item);
    } else {
      const _vals = [val[val.length - 1]];
      setInnerValue(_vals, val, item);
      lastValue.value = val[val.length - 1];
    }
  };
  return {
    selected,
    lastValue,
    initData,
    handleSelect
  };
}
var props$2 = {
  value: {
    type: Array,
    default: () => []
  },
  multiple: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  onChange: {
    type: [Function, null],
    default: null
  }
};
var render$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "org-selector"
  }, [_c("el-cascader", {
    ref: "orgSelector",
    staticClass: "selector",
    attrs: {
      "expand-trigger": "click",
      "props": _vm.cascaderProps,
      "options": _vm.options,
      "separator": "-",
      "clearable": "",
      "collapse-tags": "",
      "show-all-levels": false,
      "disabled": _vm.disabled || _vm.loading,
      "popper-class": "selector-popup"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.selected,
      callback: function($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1);
};
var staticRenderFns$o = [];
render$o._withStripped = true;
var index_vue_vue_type_style_index_0_lang$3 = "";
const __vue2_script$p = defineComponent({
  name: "OpOrgSelector",
  props: __spreadValues({}, props$2),
  setup(props2) {
    const loading2 = ref(false);
    const params = reactive({
      orgType: "OPPEIN",
      type: "oppein"
    });
    const {
      options,
      getData: getData2
    } = getOptionsData(getUcOrganizationTree, params);
    const orgSelector = ref(null);
    const {
      selected,
      initData,
      handleSelect
    } = useSelect(props2);
    const cascaderProps = reactive({
      label: "name",
      children: "children",
      disabled: "disabled",
      value: "id",
      multiple: props2.multiple,
      checkStrictly: true
    });
    const handleChange = (val) => {
      const item = orgSelector.value.getCheckedNodes(true);
      handleSelect(val, item);
    };
    onMounted(() => {
      loading2.value = true;
      getData2().then((options2) => {
        initData(options2);
        loading2.value = false;
      });
    });
    return {
      orgSelector,
      loading: loading2,
      options,
      cascaderProps,
      selected,
      initData,
      handleChange
    };
  }
});
const __cssModules$p = {};
var __component__$p = /* @__PURE__ */ normalizeComponent(__vue2_script$p, render$o, staticRenderFns$o, false, __vue2_injectStyles$p, null, null, null);
function __vue2_injectStyles$p(context2) {
  for (let o in __cssModules$p) {
    this[o] = __cssModules$p[o];
  }
}
__component__$p.options.__file = "packages/op-org-selector/src/pc/index.vue";
var Selector = /* @__PURE__ */ function() {
  return __component__$p.exports;
}();
var render$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "channel"
  }, [_c("field-pannel", {
    attrs: {
      "list": _vm.viewList
    },
    on: {
      "open": _vm.open
    }
  }), _c("van-popup", {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: _vm.visible,
      callback: function($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("van-cascader", {
    attrs: {
      "field-names": _vm.cascaderProps,
      "title": "\u8BF7\u9009\u62E9\u6E20\u9053",
      "options": _vm.options
    },
    on: {
      "close": _vm.close,
      "finish": _vm.onFinish
    },
    model: {
      value: _vm.lastValue,
      callback: function($$v) {
        _vm.lastValue = $$v;
      },
      expression: "lastValue"
    }
  })], 1)], 1);
};
var staticRenderFns$n = [];
render$n._withStripped = true;
var index_vue_vue_type_style_index_0_lang$2 = "";
const __vue2_script$o = defineComponent({
  name: "OpOrgSelector",
  components: {
    FieldPannel
  },
  props: __spreadValues({}, props$2),
  setup(props2) {
    const params = reactive({
      orgType: "OPPEIN"
    });
    const {
      getData: getData2,
      flatData,
      options
    } = getOptionsData(getUcOrganizationTree, params);
    const {
      selected,
      lastValue,
      initData,
      handleSelect
    } = useSelect(props2);
    const {
      visible: visible2,
      open: open3,
      close: close3
    } = useModal(props2);
    const cascaderProps = reactive({
      text: "name",
      children: "children",
      value: "id"
    });
    onMounted(() => {
      getData2().then(() => {
        initData();
      });
    });
    const onFinish = ({
      selectedOptions
    }) => {
      const _val = selectedOptions.map((item) => item.id);
      handleSelect(_val, selectedOptions);
      visible2.value = false;
    };
    const viewList = computed(() => {
      if (flatData.value && flatData.value.length > 0) {
        return flatData.value.filter((x) => props2.value.includes(x.value));
      } else {
        return [];
      }
    });
    return {
      options,
      cascaderProps,
      selected,
      viewList,
      visible: visible2,
      lastValue,
      initData,
      handleSelect,
      open: open3,
      close: close3,
      onFinish
    };
  }
});
const __cssModules$o = {};
var __component__$o = /* @__PURE__ */ normalizeComponent(__vue2_script$o, render$n, staticRenderFns$n, false, __vue2_injectStyles$o, null, null, null);
function __vue2_injectStyles$o(context2) {
  for (let o in __cssModules$o) {
    this[o] = __cssModules$o[o];
  }
}
__component__$o.options.__file = "packages/op-org-selector/src/mobile/index.vue";
var MobileSelector = /* @__PURE__ */ function() {
  return __component__$o.exports;
}();
Selector.install = (Vue2) => {
  if (isPCWidth()) {
    Vue2.component(Selector.name, Selector);
  } else {
    Vue2.component(MobileSelector.name, MobileSelector);
  }
};
var __glob_6_20 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": Selector
});
var index$i = "";
var index$h = "";
function isIOS$1() {
  return isServer$3 ? false : /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}
var isIOS = isIOS$1();
function resetScroll() {
  if (isIOS) {
    setRootScrollTop(getRootScrollTop());
  }
}
var cellProps = {
  icon: String,
  size: String,
  center: Boolean,
  isLink: Boolean,
  required: Boolean,
  iconPrefix: String,
  titleStyle: null,
  titleClass: null,
  valueClass: null,
  labelClass: null,
  title: [Number, String],
  value: [Number, String],
  label: [Number, String],
  arrowDirection: String,
  border: {
    type: Boolean,
    default: true
  },
  clickable: {
    type: Boolean,
    default: null
  }
};
var _createNamespace$l = createNamespace("cell"), createComponent$l = _createNamespace$l[0], bem$l = _createNamespace$l[1];
function Cell(h, props2, slots2, ctx) {
  var _props$clickable;
  var icon = props2.icon, size2 = props2.size, title2 = props2.title, label = props2.label, value9 = props2.value, isLink = props2.isLink;
  var showTitle = slots2.title || isDef$1(title2);
  function Label() {
    var showLabel = slots2.label || isDef$1(label);
    if (showLabel) {
      return h("div", {
        "class": [bem$l("label"), props2.labelClass]
      }, [slots2.label ? slots2.label() : label]);
    }
  }
  function Title2() {
    if (showTitle) {
      return h("div", {
        "class": [bem$l("title"), props2.titleClass],
        "style": props2.titleStyle
      }, [slots2.title ? slots2.title() : h("span", [title2]), Label()]);
    }
  }
  function Value() {
    var showValue = slots2.default || isDef$1(value9);
    if (showValue) {
      return h("div", {
        "class": [bem$l("value", {
          alone: !showTitle
        }), props2.valueClass]
      }, [slots2.default ? slots2.default() : h("span", [value9])]);
    }
  }
  function LeftIcon() {
    if (slots2.icon) {
      return slots2.icon();
    }
    if (icon) {
      return h(_Icon, {
        "class": bem$l("left-icon"),
        "attrs": {
          "name": icon,
          "classPrefix": props2.iconPrefix
        }
      });
    }
  }
  function RightIcon() {
    var rightIconSlot = slots2["right-icon"];
    if (rightIconSlot) {
      return rightIconSlot();
    }
    if (isLink) {
      var arrowDirection = props2.arrowDirection;
      return h(_Icon, {
        "class": bem$l("right-icon"),
        "attrs": {
          "name": arrowDirection ? "arrow-" + arrowDirection : "arrow"
        }
      });
    }
  }
  function onClick8(event) {
    emit$2(ctx, "click", event);
    functionalRoute(ctx);
  }
  var clickable = (_props$clickable = props2.clickable) != null ? _props$clickable : isLink;
  var classes = {
    clickable,
    center: props2.center,
    required: props2.required,
    borderless: !props2.border
  };
  if (size2) {
    classes[size2] = size2;
  }
  return h("div", _mergeJSXProps([{
    "class": bem$l(classes),
    "attrs": {
      "role": clickable ? "button" : null,
      "tabindex": clickable ? 0 : null
    },
    "on": {
      "click": onClick8
    }
  }, inherit(ctx)]), [LeftIcon(), Title2(), Value(), RightIcon(), slots2.extra == null ? void 0 : slots2.extra()]);
}
Cell.props = _extends$o({}, cellProps, routeProps);
var _Cell = createComponent$l(Cell);
var _createNamespace$k = createNamespace("field"), createComponent$k = _createNamespace$k[0], bem$k = _createNamespace$k[1];
var _Field = createComponent$k({
  inheritAttrs: false,
  provide: function provide() {
    return {
      vanField: this
    };
  },
  inject: {
    vanForm: {
      default: null
    }
  },
  props: _extends$o({}, cellProps, {
    name: String,
    rules: Array,
    disabled: {
      type: Boolean,
      default: null
    },
    readonly: {
      type: Boolean,
      default: null
    },
    autosize: [Boolean, Object],
    leftIcon: String,
    rightIcon: String,
    clearable: Boolean,
    formatter: Function,
    maxlength: [Number, String],
    labelWidth: [Number, String],
    labelClass: null,
    labelAlign: String,
    inputAlign: String,
    placeholder: String,
    errorMessage: String,
    errorMessageAlign: String,
    showWordLimit: Boolean,
    value: {
      type: [Number, String],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: Boolean,
      default: null
    },
    colon: {
      type: Boolean,
      default: null
    },
    clearTrigger: {
      type: String,
      default: "focus"
    },
    formatTrigger: {
      type: String,
      default: "onChange"
    }
  }),
  data: function data12() {
    return {
      focused: false,
      validateFailed: false,
      validateMessage: ""
    };
  },
  watch: {
    value: function value2() {
      this.updateValue(this.value);
      this.resetValidation();
      this.validateWithTrigger("onChange");
      this.$nextTick(this.adjustSize);
    }
  },
  mounted: function mounted6() {
    this.updateValue(this.value, this.formatTrigger);
    this.$nextTick(this.adjustSize);
    if (this.vanForm) {
      this.vanForm.addField(this);
    }
  },
  beforeDestroy: function beforeDestroy3() {
    if (this.vanForm) {
      this.vanForm.removeField(this);
    }
  },
  computed: {
    showClear: function showClear() {
      var readonly = this.getProp("readonly");
      if (this.clearable && !readonly) {
        var hasValue = isDef$1(this.value) && this.value !== "";
        var trigger = this.clearTrigger === "always" || this.clearTrigger === "focus" && this.focused;
        return hasValue && trigger;
      }
    },
    showError: function showError() {
      if (this.error !== null) {
        return this.error;
      }
      if (this.vanForm && this.vanForm.showError && this.validateFailed) {
        return true;
      }
    },
    listeners: function listeners() {
      return _extends$o({}, this.$listeners, {
        blur: this.onBlur,
        focus: this.onFocus,
        input: this.onInput,
        click: this.onClickInput,
        keypress: this.onKeypress
      });
    },
    labelStyle: function labelStyle() {
      var labelWidth = this.getProp("labelWidth");
      if (labelWidth) {
        return {
          width: addUnit(labelWidth)
        };
      }
    },
    formValue: function formValue() {
      if (this.children && (this.$scopedSlots.input || this.$slots.input)) {
        return this.children.value;
      }
      return this.value;
    }
  },
  methods: {
    focus: function focus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    blur: function blur() {
      if (this.$refs.input) {
        this.$refs.input.blur();
      }
    },
    runValidator: function runValidator(value9, rule) {
      return new Promise(function(resolve) {
        var returnVal = rule.validator(value9, rule);
        if (isPromise(returnVal)) {
          return returnVal.then(resolve);
        }
        resolve(returnVal);
      });
    },
    isEmptyValue: function isEmptyValue(value9) {
      if (Array.isArray(value9)) {
        return !value9.length;
      }
      if (value9 === 0) {
        return false;
      }
      return !value9;
    },
    runSyncRule: function runSyncRule(value9, rule) {
      if (rule.required && this.isEmptyValue(value9)) {
        return false;
      }
      if (rule.pattern && !rule.pattern.test(value9)) {
        return false;
      }
      return true;
    },
    getRuleMessage: function getRuleMessage(value9, rule) {
      var message2 = rule.message;
      if (isFunction$2(message2)) {
        return message2(value9, rule);
      }
      return message2;
    },
    runRules: function runRules(rules) {
      var _this = this;
      return rules.reduce(function(promise, rule) {
        return promise.then(function() {
          if (_this.validateFailed) {
            return;
          }
          var value9 = _this.formValue;
          if (rule.formatter) {
            value9 = rule.formatter(value9, rule);
          }
          if (!_this.runSyncRule(value9, rule)) {
            _this.validateFailed = true;
            _this.validateMessage = _this.getRuleMessage(value9, rule);
            return;
          }
          if (rule.validator) {
            return _this.runValidator(value9, rule).then(function(result) {
              if (result === false) {
                _this.validateFailed = true;
                _this.validateMessage = _this.getRuleMessage(value9, rule);
              }
            });
          }
        });
      }, Promise.resolve());
    },
    validate: function validate(rules) {
      var _this2 = this;
      if (rules === void 0) {
        rules = this.rules;
      }
      return new Promise(function(resolve) {
        if (!rules) {
          resolve();
        }
        _this2.resetValidation();
        _this2.runRules(rules).then(function() {
          if (_this2.validateFailed) {
            resolve({
              name: _this2.name,
              message: _this2.validateMessage
            });
          } else {
            resolve();
          }
        });
      });
    },
    validateWithTrigger: function validateWithTrigger(trigger) {
      if (this.vanForm && this.rules) {
        var defaultTrigger = this.vanForm.validateTrigger === trigger;
        var rules = this.rules.filter(function(rule) {
          if (rule.trigger) {
            return rule.trigger === trigger;
          }
          return defaultTrigger;
        });
        if (rules.length) {
          this.validate(rules);
        }
      }
    },
    resetValidation: function resetValidation() {
      if (this.validateFailed) {
        this.validateFailed = false;
        this.validateMessage = "";
      }
    },
    updateValue: function updateValue(value9, trigger) {
      if (trigger === void 0) {
        trigger = "onChange";
      }
      value9 = isDef$1(value9) ? String(value9) : "";
      var maxlength = this.maxlength;
      if (isDef$1(maxlength) && value9.length > maxlength) {
        if (this.value && this.value.length === +maxlength) {
          value9 = this.value;
        } else {
          value9 = value9.slice(0, maxlength);
        }
      }
      if (this.type === "number" || this.type === "digit") {
        var isNumber2 = this.type === "number";
        value9 = formatNumber(value9, isNumber2, isNumber2);
      }
      if (this.formatter && trigger === this.formatTrigger) {
        value9 = this.formatter(value9);
      }
      var input2 = this.$refs.input;
      if (input2 && value9 !== input2.value) {
        input2.value = value9;
      }
      if (value9 !== this.value) {
        this.$emit("input", value9);
      }
    },
    onInput: function onInput(event) {
      if (event.target.composing) {
        return;
      }
      this.updateValue(event.target.value);
    },
    onFocus: function onFocus(event) {
      this.focused = true;
      this.$emit("focus", event);
      this.$nextTick(this.adjustSize);
      if (this.getProp("readonly")) {
        this.blur();
      }
    },
    onBlur: function onBlur(event) {
      if (this.getProp("readonly")) {
        return;
      }
      this.focused = false;
      this.updateValue(this.value, "onBlur");
      this.$emit("blur", event);
      this.validateWithTrigger("onBlur");
      this.$nextTick(this.adjustSize);
      resetScroll();
    },
    onClick: function onClick4(event) {
      this.$emit("click", event);
    },
    onClickInput: function onClickInput(event) {
      this.$emit("click-input", event);
    },
    onClickLeftIcon: function onClickLeftIcon(event) {
      this.$emit("click-left-icon", event);
    },
    onClickRightIcon: function onClickRightIcon(event) {
      this.$emit("click-right-icon", event);
    },
    onClear: function onClear(event) {
      preventDefault(event);
      this.$emit("input", "");
      this.$emit("clear", event);
    },
    onKeypress: function onKeypress(event) {
      var ENTER_CODE = 13;
      if (event.keyCode === ENTER_CODE) {
        var submitOnEnter = this.getProp("submitOnEnter");
        if (!submitOnEnter && this.type !== "textarea") {
          preventDefault(event);
        }
        if (this.type === "search") {
          this.blur();
        }
      }
      this.$emit("keypress", event);
    },
    adjustSize: function adjustSize() {
      var input2 = this.$refs.input;
      if (!(this.type === "textarea" && this.autosize) || !input2) {
        return;
      }
      var scrollTop = getRootScrollTop();
      input2.style.height = "auto";
      var height = input2.scrollHeight;
      if (isObject$2(this.autosize)) {
        var _this$autosize = this.autosize, maxHeight = _this$autosize.maxHeight, minHeight = _this$autosize.minHeight;
        if (maxHeight) {
          height = Math.min(height, maxHeight);
        }
        if (minHeight) {
          height = Math.max(height, minHeight);
        }
      }
      if (height) {
        input2.style.height = height + "px";
        setRootScrollTop(scrollTop);
      }
    },
    genInput: function genInput() {
      var h = this.$createElement;
      var type = this.type;
      var disabled = this.getProp("disabled");
      var readonly = this.getProp("readonly");
      var inputSlot = this.slots("input");
      var inputAlign = this.getProp("inputAlign");
      if (inputSlot) {
        return h("div", {
          "class": bem$k("control", [inputAlign, "custom"]),
          "on": {
            "click": this.onClickInput
          }
        }, [inputSlot]);
      }
      var inputProps = {
        ref: "input",
        class: bem$k("control", inputAlign),
        domProps: {
          value: this.value
        },
        attrs: _extends$o({}, this.$attrs, {
          name: this.name,
          disabled,
          readonly,
          placeholder: this.placeholder
        }),
        on: this.listeners,
        directives: [{
          name: "model",
          value: this.value
        }]
      };
      if (type === "textarea") {
        return h("textarea", _mergeJSXProps([{}, inputProps]));
      }
      var inputType = type;
      var inputMode;
      if (type === "number") {
        inputType = "text";
        inputMode = "decimal";
      }
      if (type === "digit") {
        inputType = "tel";
        inputMode = "numeric";
      }
      return h("input", _mergeJSXProps([{
        "attrs": {
          "type": inputType,
          "inputmode": inputMode
        }
      }, inputProps]));
    },
    genLeftIcon: function genLeftIcon() {
      var h = this.$createElement;
      var showLeftIcon = this.slots("left-icon") || this.leftIcon;
      if (showLeftIcon) {
        return h("div", {
          "class": bem$k("left-icon"),
          "on": {
            "click": this.onClickLeftIcon
          }
        }, [this.slots("left-icon") || h(_Icon, {
          "attrs": {
            "name": this.leftIcon,
            "classPrefix": this.iconPrefix
          }
        })]);
      }
    },
    genRightIcon: function genRightIcon() {
      var h = this.$createElement;
      var slots2 = this.slots;
      var showRightIcon = slots2("right-icon") || this.rightIcon;
      if (showRightIcon) {
        return h("div", {
          "class": bem$k("right-icon"),
          "on": {
            "click": this.onClickRightIcon
          }
        }, [slots2("right-icon") || h(_Icon, {
          "attrs": {
            "name": this.rightIcon,
            "classPrefix": this.iconPrefix
          }
        })]);
      }
    },
    genWordLimit: function genWordLimit() {
      var h = this.$createElement;
      if (this.showWordLimit && this.maxlength) {
        var count3 = (this.value || "").length;
        return h("div", {
          "class": bem$k("word-limit")
        }, [h("span", {
          "class": bem$k("word-num")
        }, [count3]), "/", this.maxlength]);
      }
    },
    genMessage: function genMessage2() {
      var h = this.$createElement;
      if (this.vanForm && this.vanForm.showErrorMessage === false) {
        return;
      }
      var message2 = this.errorMessage || this.validateMessage;
      if (message2) {
        var errorMessageAlign = this.getProp("errorMessageAlign");
        return h("div", {
          "class": bem$k("error-message", errorMessageAlign)
        }, [message2]);
      }
    },
    getProp: function getProp(key2) {
      if (isDef$1(this[key2])) {
        return this[key2];
      }
      if (this.vanForm && isDef$1(this.vanForm[key2])) {
        return this.vanForm[key2];
      }
    },
    genLabel: function genLabel() {
      var h = this.$createElement;
      var colon = this.getProp("colon") ? ":" : "";
      if (this.slots("label")) {
        return [this.slots("label"), colon];
      }
      if (this.label) {
        return h("span", [this.label + colon]);
      }
    }
  },
  render: function render12() {
    var _bem;
    var h = arguments[0];
    var slots2 = this.slots;
    var disabled = this.getProp("disabled");
    var labelAlign = this.getProp("labelAlign");
    var scopedSlots = {
      icon: this.genLeftIcon
    };
    var Label = this.genLabel();
    if (Label) {
      scopedSlots.title = function() {
        return Label;
      };
    }
    var extra = this.slots("extra");
    if (extra) {
      scopedSlots.extra = function() {
        return extra;
      };
    }
    return h(_Cell, {
      "attrs": {
        "icon": this.leftIcon,
        "size": this.size,
        "center": this.center,
        "border": this.border,
        "isLink": this.isLink,
        "required": this.required,
        "clickable": this.clickable,
        "titleStyle": this.labelStyle,
        "valueClass": bem$k("value"),
        "titleClass": [bem$k("label", labelAlign), this.labelClass],
        "arrowDirection": this.arrowDirection
      },
      "scopedSlots": scopedSlots,
      "class": bem$k((_bem = {
        error: this.showError,
        disabled
      }, _bem["label-" + labelAlign] = labelAlign, _bem["min-height"] = this.type === "textarea" && !this.autosize, _bem)),
      "on": {
        "click": this.onClick
      }
    }, [h("div", {
      "class": bem$k("body")
    }, [this.genInput(), this.showClear && h(_Icon, {
      "attrs": {
        "name": "clear"
      },
      "class": bem$k("clear"),
      "on": {
        "touchstart": this.onClear
      }
    }), this.genRightIcon(), slots2("button") && h("div", {
      "class": bem$k("button")
    }, [slots2("button")])]), this.genWordLimit(), this.genMessage()]);
  }
});
var _createNamespace$j = createNamespace("form"), createComponent$j = _createNamespace$j[0], bem$j = _createNamespace$j[1];
var _Form = createComponent$j({
  props: {
    colon: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    labelWidth: [Number, String],
    labelAlign: String,
    inputAlign: String,
    scrollToError: Boolean,
    validateFirst: Boolean,
    errorMessageAlign: String,
    submitOnEnter: {
      type: Boolean,
      default: true
    },
    validateTrigger: {
      type: String,
      default: "onBlur"
    },
    showError: {
      type: Boolean,
      default: true
    },
    showErrorMessage: {
      type: Boolean,
      default: true
    }
  },
  provide: function provide2() {
    return {
      vanForm: this
    };
  },
  data: function data13() {
    return {
      fields: []
    };
  },
  methods: {
    getFieldsByNames: function getFieldsByNames(names) {
      if (names) {
        return this.fields.filter(function(field) {
          return names.indexOf(field.name) !== -1;
        });
      }
      return this.fields;
    },
    validateSeq: function validateSeq(names) {
      var _this = this;
      return new Promise(function(resolve, reject) {
        var errors = [];
        var fields = _this.getFieldsByNames(names);
        fields.reduce(function(promise, field) {
          return promise.then(function() {
            if (!errors.length) {
              return field.validate().then(function(error) {
                if (error) {
                  errors.push(error);
                }
              });
            }
          });
        }, Promise.resolve()).then(function() {
          if (errors.length) {
            reject(errors);
          } else {
            resolve();
          }
        });
      });
    },
    validateFields: function validateFields(names) {
      var _this2 = this;
      return new Promise(function(resolve, reject) {
        var fields = _this2.getFieldsByNames(names);
        Promise.all(fields.map(function(item) {
          return item.validate();
        })).then(function(errors) {
          errors = errors.filter(function(item) {
            return item;
          });
          if (errors.length) {
            reject(errors);
          } else {
            resolve();
          }
        });
      });
    },
    validate: function validate2(name) {
      if (name && !Array.isArray(name)) {
        return this.validateField(name);
      }
      return this.validateFirst ? this.validateSeq(name) : this.validateFields(name);
    },
    validateField: function validateField(name) {
      var matched = this.fields.filter(function(item) {
        return item.name === name;
      });
      if (matched.length) {
        return new Promise(function(resolve, reject) {
          matched[0].validate().then(function(error) {
            if (error) {
              reject(error);
            } else {
              resolve();
            }
          });
        });
      }
      return Promise.reject();
    },
    resetValidation: function resetValidation2(name) {
      if (name && !Array.isArray(name)) {
        name = [name];
      }
      var fields = this.getFieldsByNames(name);
      fields.forEach(function(item) {
        item.resetValidation();
      });
    },
    scrollToField: function scrollToField(name, options) {
      this.fields.some(function(item) {
        if (item.name === name) {
          item.$el.scrollIntoView(options);
          return true;
        }
        return false;
      });
    },
    addField: function addField(field) {
      this.fields.push(field);
      sortChildren(this.fields, this);
    },
    removeField: function removeField(field) {
      this.fields = this.fields.filter(function(item) {
        return item !== field;
      });
    },
    getValues: function getValues() {
      return this.fields.reduce(function(form2, field) {
        form2[field.name] = field.formValue;
        return form2;
      }, {});
    },
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      this.submit();
    },
    submit: function submit() {
      var _this3 = this;
      var values = this.getValues();
      this.validate().then(function() {
        _this3.$emit("submit", values);
      }).catch(function(errors) {
        _this3.$emit("failed", {
          values,
          errors
        });
        if (_this3.scrollToError) {
          _this3.scrollToField(errors[0].name);
        }
      });
    }
  },
  render: function render13() {
    var h = arguments[0];
    return h("form", {
      "class": bem$j(),
      "on": {
        "submit": this.onSubmit
      }
    }, [this.slots()]);
  }
});
var phoneIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAABPdJREFUeF7tm1Fu4jAQhj0q91h6ksJJ2h4ilngqfUJKDlFuUnqS5iLIK69AYilJnQwxGfLl2WPGM/98HjtBHM+kIyCTXj2Ldwhg4iJAAAhg4hGY+PLVBNhsNvPZbDZ3zj2FEBYTi2ftnPsSkbooip3FtasEUFXVWwhhbXHhA/hci8i2KIr3AeYebMpeAqiqahFC+HDOxcrnOYmAiKwtiaCzACLyHx4evsl6awR23vulhRh1FkBZlp/Ouant9X1y+eq93/YxzGnTSQDs+Z1SU+/3++VqtYqN4mifTgIoyzKi/+K+H/e+2BGPdqUDOBZCiLF4biHi6CnQVQDhUhxFZGn1GKTVxaEnig3xj23RQkOYLIBD5x/3/x+P9z55Hm3Ax2jfEpvRN4PJiSvL8sU5F5V+/my9969jTEwun1pORrX3/jGXH31+BwH0idqZTdvReOx0RAAIIC0CbAHNcYIA9ACNt6NsAWmAMT0KAkAACGC6hJXOQwAIAAGURWTaHAJAAAhguoSVzkMACAABlEVk2hwCQAAIYLqElc5DAAgAAZRFZNocAkAACGC6hJXOQwAIAAGURWTaHAJAAAhguoSVzkMACAABlEVk2hwCQAAIYLqElc5DAAgAAZRFZNocAkAACGC6hJXOQwAIAAGURWTaHAJAAAhguoSVzkMACAABlEVk2hwCQAAIYLqElc5DAAgAAZRFZNocAkAACGC6hJXOQwAIAAGURWTaHAJAAAhguoSVzkMACAABlEVk2hwCQAAIYLqElc5DAAgAAZRFZNocAkAACGC6hJXOQwAIAAGURWTaHAJAAAhguoSVzkMACAABlEVk2hwCQAAIYLqElc5DAAgAAZRFZNocAkAACGC6hJXOQwAIAAGURWTaHAJAAAhguoSVzkMACAABlEVk2nzqBNiJyLvpDCqdDyHMnXMfl6bx3oty+kHNk50ry/KlaZGDemh8cgRgPIFa9xGANoLG7RGA8QRq3UcA2ggat0cAxhOodX8KApj8MTCKJITwOdVj4NZzE8hNoBaVlu2nfhMIATYbCHCLCj5U3iL+tojURVHsbujHNz1ApugfEh/v3v8l/+SpRWRbFEXWdxNsARmbwLZgnwhh571fZtKjQwAZBVCWZTxunVf+pVy/eu+3OUSAADIJoOMbydp7/4gA2iNwjdfB2U4BVVW9hRDWqUnd7/ePq9WqTh3fdxwEyEeA2PjF7xKSHhFZ5jgZIIBMAoAASbrvNMjaFrBounO/5RkcAmQiQExy6ikgF/6jTwggowAOwY5HwfghZtPDPUDiRmBqCziuKYpgNps9XzoRiMiam8DE7Mcr9NShLWfwbMfAc18PQpjHz7J5F5Cayf/HmRZAvyVf32oSPUBVVU0deNb99vrp0884CQG0LDLblas+VcPM0LI9jr44kreANpXfovEaJpX9Zm05mt6sP0pdSbIAfjmDx/v2+DHGV2zGUn/8DsY9hRDim8mmt5PZ3kj2jWVXAfD/wA6RzvUyqoNLP4Z2EkDLlzgaH+7SNudNpCaAnQTw27WnxpE7sx1983eMd2cBnIjgt+vYO8tp8nJG3/idrqSXAI4iaLqOTQ7VfQ2MH6S+5vj+4Jph6y2AoxPHT7NF5M+hI76mf6OeS0SOn6F/WUu8agsYdVZwrlME1ATo9GsMHl0EEMDoUpLXIQSQN96j+zUEMLqU5HXoLwWVXb0xtud4AAAAAElFTkSuQmCC";
var codeIcon = "data:image/png;base64,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";
var render$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("van-dialog", {
    attrs: {
      "use-slot": "",
      "close-on-click-overlay": true,
      "show-confirm-button": false,
      "show-cancel-button": false
    },
    on: {
      "closed": _vm.handleClose
    },
    model: {
      value: _vm.showStatus,
      callback: function($$v) {
        _vm.showStatus = $$v;
      },
      expression: "showStatus"
    }
  }, [_c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "content_title"
  }, [_vm._v("\u9A8C\u8BC1\u7801\u767B\u5F55")]), _c("van-form", {
    attrs: {
      "show-error": false
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c("div", {
    staticClass: "content_text"
  }, [_c("div", {
    staticClass: "content_text_item"
  }, [_c("van-field", {
    attrs: {
      "clearable": "",
      "left-icon": _vm.phoneIcon,
      "placeholder": "\u8BF7\u8F93\u5165\u624B\u673A\u53F7",
      "rules": [{
        validator: _vm.validatorPhone,
        message: "\u8BF7\u8F93\u516511\u4F4D\u624B\u673A\u53F7"
      }]
    },
    model: {
      value: _vm.searchParams.phone,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "phone", $$v);
      },
      expression: "searchParams.phone"
    }
  })], 1), _c("div", {
    staticClass: "content_text_item"
  }, [_c("van-field", {
    attrs: {
      "left-icon": _vm.codeIcon,
      "clearable": "",
      "placeholder": "\u8BF7\u8F93\u5165\u77ED\u4FE1\u9A8C\u8BC1\u7801",
      "rules": [{
        required: true,
        message: "\u8BF7\u8F93\u5165\u77ED\u4FE1\u9A8C\u8BC1\u7801"
      }]
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_vm.isSend ? _c("div", {
          staticClass: "content_text_item_send",
          on: {
            "click": function($event) {
              return _vm.sendCode(_vm.searchParams.phone);
            }
          }
        }, [_vm._v("\u53D1\u9001\u9A8C\u8BC1\u7801")]) : _c("div", {
          staticClass: "content_text_item_count"
        }, [_vm._v(_vm._s(_vm.count) + "s")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.searchParams.code,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "code", $$v);
      },
      expression: "searchParams.code"
    }
  })], 1)]), _c("div", {
    staticClass: "content_footer"
  }, [_c("van-button", {
    staticClass: "content_footer_btn",
    attrs: {
      "round": "",
      "loading": _vm.btnLoading,
      "color": "#f08519",
      "block": "",
      "native-type": "submit"
    }
  }, [_vm._v("\u7ACB\u5373\u767B\u5F55")])], 1)])], 1)])], 1);
};
var staticRenderFns$m = [];
render$m._withStripped = true;
var Popup_vue_vue_type_style_index_0_scoped_true_lang = "";
var Popup_vue_vue_type_style_index_1_lang = "";
Vue$1.use(Dialog$1);
Vue$1.use(_Form);
Vue$1.use(_Field);
const __vue2_script$n = defineComponent({
  name: "OuterLogin",
  setup(props2, {
    emit: emit2
  }) {
    const showStatus = ref(true);
    const {
      login,
      isSend,
      count: count3,
      sendCode
    } = useExternalUser();
    const searchParams = ref({
      phone: "",
      code: ""
    });
    const btnLoading = ref(false);
    function validatorPhone2(val) {
      return /^1[3-9]\d{9}$/.test(val);
    }
    function handleClose() {
      showStatus.value = false;
      emit2("close");
    }
    async function onSubmit2() {
      btnLoading.value = true;
      const params = {
        identifier: searchParams.value.phone,
        credential: searchParams.value.code,
        countryCode: "86"
      };
      const token = await login(params);
      btnLoading.value = false;
      if (token) {
        Toast("\u767B\u5F55\u6210\u529F\uFF01");
        emit2("submit", {
          status: !!token,
          token
        });
        handleClose();
      }
    }
    return {
      phoneIcon,
      codeIcon,
      showStatus,
      searchParams,
      validatorPhone: validatorPhone2,
      isSend,
      count: count3,
      btnLoading,
      sendCode,
      onSubmit: onSubmit2,
      handleClose
    };
  }
});
const __cssModules$n = {};
var __component__$n = /* @__PURE__ */ normalizeComponent(__vue2_script$n, render$m, staticRenderFns$m, false, __vue2_injectStyles$n, "5bd68901", null, null);
function __vue2_injectStyles$n(context2) {
  for (let o in __cssModules$n) {
    this[o] = __cssModules$n[o];
  }
}
__component__$n.options.__file = "packages/op-outer-login/src/Popup.vue";
var OuterLogin = /* @__PURE__ */ function() {
  return __component__$n.exports;
}();
const PopupConstructor = Vue$1.extend(OuterLogin);
let instance = null;
const OuterLoginFunc = (options) => {
  if (getOuterToken()) {
    return Promise.resolve({
      status: true,
      token: getOuterToken()
    });
  }
  instance = new PopupConstructor({
    propsData: options
  });
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.$on("close", () => {
    document.body.removeChild(instance.vm.$el);
    instance.vm.$destroy();
  });
  return new Promise((resolve) => {
    instance.vm.$on("submit", (val) => {
      resolve(val);
    });
  });
};
OuterLogin.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OuterLogin.name, prefix);
  Vue2.component(comName, OuterLogin);
  Vue2.prototype.$outerLogin = OuterLoginFunc;
};
var __glob_6_22 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  OuterLoginFunc,
  "default": OuterLogin
});
var render$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("SelectorDialog", {
    attrs: {
      "title": "\u9009\u62E9\u5C97\u4F4D",
      "search-placeholder": "\u5C97\u4F4D\u540D\u79F0",
      "placeholder": _vm.placeholder,
      "single": _vm.single,
      "data": _vm.tableData,
      "config": _vm.config,
      "loading": _vm.loading,
      "width": "80%",
      "checked-status-key": "id",
      "right-text": "\u9009\u62E9\u90E8\u95E8",
      "table-columns": _vm.tableColumns,
      "pagination": _vm.pagination,
      "append-to-body": _vm.appendToBody,
      "quick-search-props": "name,account,email"
    },
    on: {
      "update:data": function($event) {
        _vm.tableData = $event;
      },
      "load": _vm.loadData,
      "click-right": function($event) {
        return _vm.$refs.opOrgsTree.showPopup();
      },
      "onConfirm": _vm.onConfirm
    },
    scopedSlots: _vm._u([{
      key: "modal",
      fn: function() {
        return [_c("op-orgs-tree", {
          ref: "opOrgsTree",
          on: {
            "node-click": _vm.handleNodeClick
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.userVals,
      callback: function($$v) {
        _vm.userVals = $$v;
      },
      expression: "userVals"
    }
  });
};
var staticRenderFns$l = [];
render$l._withStripped = true;
const __vue2_script$m = defineComponent({
  name: "OpPositionSelector",
  components: {
    SelectorDialog: OpSelectorDialog
  },
  props: {
    value: String,
    placeholder: String,
    single: Boolean,
    config: Object,
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const tableData = ref([]);
    const loading2 = ref(false);
    const departmentIdList = ref([]);
    const opOrgsTree = ref(null);
    const pagination = ref({
      pageNo: 1,
      pageSize: 20,
      total: 0,
      showTotal: true
    });
    const userVals = computed({
      get() {
        return props2.value;
      },
      set(newValue) {
        emit2("input", newValue);
      }
    });
    const tableColumns = ref([{
      prop: "name",
      label: "\u540D\u79F0"
    }, {
      prop: "no",
      label: "\u7F16\u7801"
    }, {
      prop: "orgName",
      label: "\u6240\u5C5E\u7EC4\u7EC7"
    }]);
    function getChildrenIds(data22) {
      if (data22.children) {
        data22.children.forEach((element) => {
          departmentIdList.value.push(element.id);
          getChildrenIds(element);
        });
      }
    }
    const loadData = async (param) => {
      loading2.value = true;
      let searchStr = "";
      if (param.querys && param.querys.name) {
        searchStr = param.querys["name"];
      }
      let _params = {
        searchStr,
        orgId: "1",
        pageNo: pagination.value.pageNo,
        pageSize: pagination.value.pageSize
      };
      if (departmentIdList.value.length > 0 && departmentIdList.value[0] !== "-1") {
        _params.departmentId = departmentIdList.value[0];
      }
      const {
        status,
        data: data22
      } = await getPositionPageListByConToPost(_params);
      loading2.value = false;
      if (status) {
        if (!isPCWidth() && data22.current > 1) {
          tableData.value = [...tableData.value, ...data22.records];
        } else {
          tableData.value = data22.records;
        }
        pagination.value.pageSize = data22.size;
        pagination.value.total = data22.total;
      }
    };
    const handleNodeClick = (org) => {
      pagination.value.pageNo = 1;
      departmentIdList.value = [org.id];
      getChildrenIds(org);
      loadData(pagination.value);
    };
    const onConfirm = (users) => {
      emit2("onConfirm", users);
    };
    return {
      tableData,
      loading: loading2,
      pagination,
      tableColumns,
      userVals,
      opOrgsTree,
      loadData,
      handleNodeClick,
      onConfirm
    };
  }
});
const __cssModules$m = {};
var __component__$m = /* @__PURE__ */ normalizeComponent(__vue2_script$m, render$l, staticRenderFns$l, false, __vue2_injectStyles$m, null, null, null);
function __vue2_injectStyles$m(context2) {
  for (let o in __cssModules$m) {
    this[o] = __cssModules$m[o];
  }
}
__component__$m.options.__file = "packages/op-position-selector/src/OpPositionSelector.vue";
var OpPositionSelector = /* @__PURE__ */ function() {
  return __component__$m.exports;
}();
OpPositionSelector.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpPositionSelector.name, prefix);
  Vue2.use(OpOrgsTree);
  Vue2.use(OpFormMap);
  Vue2.component(comName, OpPositionSelector);
};
var __glob_6_23 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpPositionSelector
});
const COUNTRY = 0;
const PROVINCE = 1;
const CITY = 2;
const AREA = 3;
const COUNTY = 4;
var render$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "region-selector",
    style: _vm.gridColumn
  }, [_vm.selectShow(_vm.regionType.COUNTRY) ? _c("el-select", {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "disabled": _vm.selectDisable(_vm.regionType.COUNTRY),
      "size": "mini",
      "placeholder": "\u9009\u62E9\u56FD\u5BB6"
    },
    on: {
      "change": function($event) {
        return _vm.selectChange($event, _vm.regionType.COUNTRY);
      },
      "visible-change": function($event) {
        return _vm.showSelct($event, _vm.regionType.COUNTRY);
      }
    },
    model: {
      value: _vm.selectCode[_vm.regionType.COUNTRY],
      callback: function($$v) {
        _vm.$set(_vm.selectCode, _vm.regionType.COUNTRY, $$v);
      },
      expression: "selectCode[regionType.COUNTRY]"
    }
  }, _vm._l(_vm.options[_vm.regionType.COUNTRY], function(item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    });
  }), 1) : _vm._e(), _c("el-select", {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "disabled": _vm.selectDisable(_vm.regionType.PROVINCE),
      "size": "mini",
      "placeholder": _vm.selectCode[0] == "1" ? "\u9009\u62E9\u7701\u4EFD" : "\u9009\u62E9\u57CE\u5E02"
    },
    on: {
      "change": function($event) {
        return _vm.selectChange($event, _vm.regionType.PROVINCE);
      },
      "visible-change": function($event) {
        return _vm.showSelct($event, _vm.regionType.PROVINCE);
      }
    },
    model: {
      value: _vm.selectCode[_vm.regionType.PROVINCE],
      callback: function($$v) {
        _vm.$set(_vm.selectCode, _vm.regionType.PROVINCE, $$v);
      },
      expression: "selectCode[regionType.PROVINCE]"
    }
  }, _vm._l(_vm.options[_vm.regionType.PROVINCE], function(item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    });
  }), 1), _vm.selectShow(_vm.regionType.CITY) ? _c("el-select", {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": "\u9009\u62E9\u57CE\u5E02",
      "disabled": _vm.selectDisable(_vm.regionType.CITY)
    },
    on: {
      "change": function($event) {
        return _vm.selectChange($event, _vm.regionType.CITY);
      },
      "visible-change": function($event) {
        return _vm.showSelct($event, _vm.regionType.CITY);
      }
    },
    model: {
      value: _vm.selectCode[_vm.regionType.CITY],
      callback: function($$v) {
        _vm.$set(_vm.selectCode, _vm.regionType.CITY, $$v);
      },
      expression: "selectCode[regionType.CITY]"
    }
  }, _vm._l(_vm.options[_vm.regionType.CITY], function(item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    });
  }), 1) : _vm._e(), _vm.selectShow(_vm.regionType.AREA) ? _c("el-select", {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": "\u9009\u62E9\u533A",
      "disabled": _vm.selectDisable(_vm.regionType.AREA)
    },
    on: {
      "change": function($event) {
        return _vm.selectChange($event, _vm.regionType.AREA);
      },
      "visible-change": function($event) {
        return _vm.showSelct($event, _vm.regionType.AREA);
      }
    },
    model: {
      value: _vm.selectCode[_vm.regionType.AREA],
      callback: function($$v) {
        _vm.$set(_vm.selectCode, _vm.regionType.AREA, $$v);
      },
      expression: "selectCode[regionType.AREA]"
    }
  }, _vm._l(_vm.options[_vm.regionType.AREA], function(item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    });
  }), 1) : _vm._e(), _vm.selectShow(_vm.regionType.COUNTY) ? _c("el-select", {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": "\u9009\u62E9\u53BF/\u8857\u9053",
      "disabled": _vm.selectDisable(_vm.regionType.COUNTY)
    },
    on: {
      "change": function($event) {
        return _vm.selectChange($event, _vm.regionType.COUNTY);
      },
      "visible-change": function($event) {
        return _vm.showSelct($event, _vm.regionType.COUNTY);
      }
    },
    model: {
      value: _vm.selectCode[_vm.regionType.COUNTY],
      callback: function($$v) {
        _vm.$set(_vm.selectCode, _vm.regionType.COUNTY, $$v);
      },
      expression: "selectCode[regionType.COUNTY]"
    }
  }, _vm._l(_vm.options[_vm.regionType.COUNTY], function(item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    });
  }), 1) : _vm._e()], 1);
};
var staticRenderFns$k = [];
render$k._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$3 = "";
const __vue2_script$l = {
  name: "OpRegionSelect",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    disabledLength: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: "1"
    },
    type: {
      type: Number,
      default: COUNTY
    },
    isShowCountry: {
      type: Boolean,
      default: false
    },
    mutipleVal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      regionType: {
        COUNTRY,
        PROVINCE,
        CITY,
        AREA,
        COUNTY
      },
      options: {
        [COUNTRY]: [],
        [PROVINCE]: [],
        [CITY]: [],
        [AREA]: [],
        [COUNTY]: []
      },
      selectCode: {
        [COUNTRY]: "",
        [PROVINCE]: "",
        [CITY]: "",
        [AREA]: "",
        [COUNTY]: ""
      },
      code: ""
    };
  },
  computed: {
    gridColumn() {
      let columns = this.type;
      if (this.isShowCountry) {
        columns += 1;
      }
      return `grid-template-columns: repeat(${columns}, minmax(0, 1fr));`;
    }
  },
  watch: {
    value(v) {
      if (this.value) {
        if (this.mutipleVal) {
          const valList = this.value.split(",");
          const lastVal = valList[valList.length - 1];
          if (lastVal !== this.code)
            this.getDefaultCode(lastVal);
        } else {
          if (this.value !== this.code)
            this.getDefaultCode(this.value);
        }
      } else {
        this.getDefaultCode("1");
      }
    }
  },
  mounted() {
    if (this.value) {
      if (this.mutipleVal) {
        const valList = this.value.split(",");
        const lastVal = valList[valList.length - 1];
        this.getDefaultCode(lastVal);
      } else {
        this.getDefaultCode(this.value);
      }
    } else {
      this.getDefaultCode("1");
    }
  },
  methods: {
    selectShow(type) {
      if (type == COUNTRY) {
        return this.isShowCountry;
      }
      if (this.type > type - 1 && this.selectCode[COUNTRY] == "1") {
        return true;
      } else {
        return false;
      }
    },
    selectDisable(type) {
      if (this.disabled)
        return true;
      if (type == COUNTRY) {
        return this.disabledLength > COUNTRY;
      } else {
        return !this.selectCode[type - 1] || this.disabledLength > type;
      }
    },
    showSelct(e, a) {
      if (e) {
        if (this.options[a].length > 1) {
          if (a * 1) {
            if (this.options[a][0].pid === this.selectCode[a - 1])
              return false;
          } else {
            return false;
          }
        }
        if (a * 1) {
          getRegionListByPid({
            regionPid: this.selectCode[a - 1]
          }).then((res) => {
            this.options[a] = res.data;
          });
        } else {
          this.getCountryList();
        }
      } else {
        if (a) {
          this.returnChooseData(a);
        }
      }
    },
    returnChooseData(a) {
      let code = "";
      let options = "";
      for (let k in this.selectCode) {
        if (this.selectCode[k]) {
          code = this.selectCode[k];
          options = this.options[k];
        }
      }
      const pidsData = options && options.filter((y) => {
        return y.id === code;
      })[0];
      let pids = getData$1(["pids"], pidsData);
      let pidsName = getData$1(["pidsName"], pidsData);
      this.$emit("chooseRegionData", {
        pids,
        pidsName
      });
    },
    selectChange(e, a) {
      for (let c in this.selectCode) {
        if (c * 1 > a * 1) {
          this.selectCode[c] = "";
          this.options[c] = [];
        }
      }
      this.code = this.selectCode[a];
      if (this.mutipleVal) {
        let _codeList = [];
        for (let key2 in this.selectCode) {
          if (this.selectCode[key2]) {
            _codeList.push(this.selectCode[key2]);
          }
        }
        this.$emit("input", _codeList.join(","));
      } else {
        this.$emit("input", this.code);
      }
      this.$forceUpdate();
    },
    getDefaultCode(code) {
      this.selectCode = {
        0: "",
        1: "",
        2: "",
        3: "",
        4: ""
      };
      getUCRegionById({
        regionId: code
      }).then((res) => {
        if (res.data && res.data.pids) {
          let pids = res.data.pids.split(",");
          let pidsName = res.data.pidsName.split(".");
          res.data.pids.split(",").forEach((e, i) => {
            this.selectCode[i] = pids[i];
            this.options[i] = [{
              id: pids[i],
              name: pidsName[i],
              pids: pids.slice(0, i + 1).join(),
              pidsName: res.data.pidsName
            }];
          });
          this.code = code;
        } else {
          this.getDefaultCode("1");
        }
      }).catch(() => {
      });
    },
    getCountryList() {
      getRegionCountryListByPid().then((res) => {
        this.options[0] = res.data;
      });
    }
  }
};
const __cssModules$l = {};
var __component__$l = /* @__PURE__ */ normalizeComponent(__vue2_script$l, render$k, staticRenderFns$k, false, __vue2_injectStyles$l, "3ec691b3", null, null);
function __vue2_injectStyles$l(context2) {
  for (let o in __cssModules$l) {
    this[o] = __cssModules$l[o];
  }
}
__component__$l.options.__file = "packages/op-region-select/src/pc/index.vue";
var RegionSelect = /* @__PURE__ */ function() {
  return __component__$l.exports;
}();
var index$g = "";
var index$f = "";
var index$e = "";
var index$d = "";
var _createNamespace$i = createNamespace("tab"), createComponent$i = _createNamespace$i[0], bem$i = _createNamespace$i[1];
var Tab = createComponent$i({
  mixins: [ChildrenMixin("vanTabs")],
  props: _extends$o({}, routeProps, {
    dot: Boolean,
    name: [Number, String],
    info: [Number, String],
    badge: [Number, String],
    title: String,
    titleStyle: null,
    titleClass: null,
    disabled: Boolean
  }),
  data: function data14() {
    return {
      inited: false
    };
  },
  computed: {
    computedName: function computedName() {
      var _this$name;
      return (_this$name = this.name) != null ? _this$name : this.index;
    },
    isActive: function isActive() {
      var active2 = this.computedName === this.parent.currentName;
      if (active2) {
        this.inited = true;
      }
      return active2;
    }
  },
  watch: {
    title: function title() {
      this.parent.setLine();
      this.parent.scrollIntoView();
    },
    inited: function inited(val) {
      var _this = this;
      if (this.parent.lazyRender && val) {
        this.$nextTick(function() {
          _this.parent.$emit("rendered", _this.computedName, _this.title);
        });
      }
    }
  },
  render: function render14(h) {
    var slots2 = this.slots, parent = this.parent, isActive2 = this.isActive;
    var slotContent = slots2();
    if (!slotContent && !parent.animated) {
      return;
    }
    var show3 = parent.scrollspy || isActive2;
    var shouldRender2 = this.inited || parent.scrollspy || !parent.lazyRender;
    var Content2 = shouldRender2 ? slotContent : h();
    if (parent.animated) {
      return h("div", {
        "attrs": {
          "role": "tabpanel",
          "aria-hidden": !isActive2
        },
        "class": bem$i("pane-wrapper", {
          inactive: !isActive2
        })
      }, [h("div", {
        "class": bem$i("pane")
      }, [Content2])]);
    }
    return h("div", {
      "directives": [{
        name: "show",
        value: show3
      }],
      "attrs": {
        "role": "tabpanel"
      },
      "class": bem$i("pane")
    }, [Content2]);
  }
});
function scrollLeftTo(scroller, to, duration) {
  var count3 = 0;
  var from = scroller.scrollLeft;
  var frames = duration === 0 ? 1 : Math.round(duration * 1e3 / 16);
  function animate() {
    scroller.scrollLeft += (to - from) / frames;
    if (++count3 < frames) {
      raf(animate);
    }
  }
  animate();
}
function scrollTopTo(scroller, to, duration, callback2) {
  var current = getScrollTop(scroller);
  var isDown = current < to;
  var frames = duration === 0 ? 1 : Math.round(duration * 1e3 / 16);
  var step = (to - current) / frames;
  function animate() {
    current += step;
    if (isDown && current > to || !isDown && current < to) {
      current = to;
    }
    setScrollTop(scroller, current);
    if (isDown && current < to || !isDown && current > to) {
      raf(animate);
    } else if (callback2) {
      raf(callback2);
    }
  }
  animate();
}
function callInterceptor(options) {
  var interceptor = options.interceptor, args = options.args, done = options.done;
  if (interceptor) {
    var returnVal = interceptor.apply(void 0, args);
    if (isPromise(returnVal)) {
      returnVal.then(function(value9) {
        if (value9) {
          done();
        }
      }).catch(noop$1);
    } else if (returnVal) {
      done();
    }
  } else {
    done();
  }
}
var _createNamespace$h = createNamespace("tab"), createComponent$h = _createNamespace$h[0], bem$h = _createNamespace$h[1];
var Title = createComponent$h({
  props: {
    dot: Boolean,
    type: String,
    info: [Number, String],
    color: String,
    title: String,
    isActive: Boolean,
    disabled: Boolean,
    scrollable: Boolean,
    activeColor: String,
    inactiveColor: String
  },
  computed: {
    style: function style3() {
      var style6 = {};
      var color = this.color, isActive2 = this.isActive;
      var isCard = this.type === "card";
      if (color && isCard) {
        style6.borderColor = color;
        if (!this.disabled) {
          if (isActive2) {
            style6.backgroundColor = color;
          } else {
            style6.color = color;
          }
        }
      }
      var titleColor = isActive2 ? this.activeColor : this.inactiveColor;
      if (titleColor) {
        style6.color = titleColor;
      }
      return style6;
    }
  },
  methods: {
    onClick: function onClick5() {
      this.$emit("click");
    },
    genText: function genText() {
      var h = this.$createElement;
      var Text = h("span", {
        "class": bem$h("text", {
          ellipsis: !this.scrollable
        })
      }, [this.slots() || this.title]);
      if (this.dot || isDef$1(this.info) && this.info !== "") {
        return h("span", {
          "class": bem$h("text-wrapper")
        }, [Text, h(Info$1, {
          "attrs": {
            "dot": this.dot,
            "info": this.info
          }
        })]);
      }
      return Text;
    }
  },
  render: function render15() {
    var h = arguments[0];
    return h("div", {
      "attrs": {
        "role": "tab",
        "aria-selected": this.isActive
      },
      "class": [bem$h({
        active: this.isActive,
        disabled: this.disabled
      })],
      "style": this.style,
      "on": {
        "click": this.onClick
      }
    }, [this.genText()]);
  }
});
var _createNamespace$g = createNamespace("sticky"), createComponent$g = _createNamespace$g[0], bem$g = _createNamespace$g[1];
var Sticky = createComponent$g({
  mixins: [BindEventMixin(function(bind2, isBind) {
    if (!this.scroller) {
      this.scroller = getScroller(this.$el);
    }
    if (this.observer) {
      var method = isBind ? "observe" : "unobserve";
      this.observer[method](this.$el);
    }
    bind2(this.scroller, "scroll", this.onScroll, true);
    this.onScroll();
  })],
  props: {
    zIndex: [Number, String],
    container: null,
    offsetTop: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data15() {
    return {
      fixed: false,
      height: 0,
      transform: 0
    };
  },
  computed: {
    offsetTopPx: function offsetTopPx() {
      return unitToPx(this.offsetTop);
    },
    style: function style4() {
      if (!this.fixed) {
        return;
      }
      var style6 = {};
      if (isDef$1(this.zIndex)) {
        style6.zIndex = this.zIndex;
      }
      if (this.offsetTopPx && this.fixed) {
        style6.top = this.offsetTopPx + "px";
      }
      if (this.transform) {
        style6.transform = "translate3d(0, " + this.transform + "px, 0)";
      }
      return style6;
    }
  },
  watch: {
    fixed: function fixed(isFixed) {
      this.$emit("change", isFixed);
    }
  },
  created: function created2() {
    var _this = this;
    if (!isServer$3 && window.IntersectionObserver) {
      this.observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio > 0) {
          _this.onScroll();
        }
      }, {
        root: document.body
      });
    }
  },
  methods: {
    onScroll: function onScroll() {
      var _this2 = this;
      if (isHidden(this.$el)) {
        return;
      }
      this.height = this.$el.offsetHeight;
      var container = this.container, offsetTopPx3 = this.offsetTopPx;
      var scrollTop = getScrollTop(window);
      var topToPageTop = getElementTop(this.$el);
      var emitScrollEvent = function emitScrollEvent2() {
        _this2.$emit("scroll", {
          scrollTop,
          isFixed: _this2.fixed
        });
      };
      if (container) {
        var bottomToPageTop = topToPageTop + container.offsetHeight;
        if (scrollTop + offsetTopPx3 + this.height > bottomToPageTop) {
          var distanceToBottom = this.height + scrollTop - bottomToPageTop;
          if (distanceToBottom < this.height) {
            this.fixed = true;
            this.transform = -(distanceToBottom + offsetTopPx3);
          } else {
            this.fixed = false;
          }
          emitScrollEvent();
          return;
        }
      }
      if (scrollTop + offsetTopPx3 > topToPageTop) {
        this.fixed = true;
        this.transform = 0;
      } else {
        this.fixed = false;
      }
      emitScrollEvent();
    }
  },
  render: function render16() {
    var h = arguments[0];
    var fixed2 = this.fixed;
    var style6 = {
      height: fixed2 ? this.height + "px" : null
    };
    return h("div", {
      "style": style6
    }, [h("div", {
      "class": bem$g({
        fixed: fixed2
      }),
      "style": this.style
    }, [this.slots()])]);
  }
});
var _createNamespace$f = createNamespace("tabs"), createComponent$f = _createNamespace$f[0], bem$f = _createNamespace$f[1];
var MIN_SWIPE_DISTANCE = 50;
var Content = createComponent$f({
  mixins: [TouchMixin],
  props: {
    count: Number,
    duration: [Number, String],
    animated: Boolean,
    swipeable: Boolean,
    currentIndex: Number
  },
  computed: {
    style: function style5() {
      if (this.animated) {
        return {
          transform: "translate3d(" + -1 * this.currentIndex * 100 + "%, 0, 0)",
          transitionDuration: this.duration + "s"
        };
      }
    },
    listeners: function listeners2() {
      if (this.swipeable) {
        return {
          touchstart: this.touchStart,
          touchmove: this.touchMove,
          touchend: this.onTouchEnd,
          touchcancel: this.onTouchEnd
        };
      }
    }
  },
  methods: {
    onTouchEnd: function onTouchEnd3() {
      var direction = this.direction, deltaX = this.deltaX, currentIndex2 = this.currentIndex;
      if (direction === "horizontal" && this.offsetX >= MIN_SWIPE_DISTANCE) {
        if (deltaX > 0 && currentIndex2 !== 0) {
          this.$emit("change", currentIndex2 - 1);
        } else if (deltaX < 0 && currentIndex2 !== this.count - 1) {
          this.$emit("change", currentIndex2 + 1);
        }
      }
    },
    genChildren: function genChildren() {
      var h = this.$createElement;
      if (this.animated) {
        return h("div", {
          "class": bem$f("track"),
          "style": this.style
        }, [this.slots()]);
      }
      return this.slots();
    }
  },
  render: function render17() {
    var h = arguments[0];
    return h("div", {
      "class": bem$f("content", {
        animated: this.animated
      }),
      "on": _extends$o({}, this.listeners)
    }, [this.genChildren()]);
  }
});
var _createNamespace$e = createNamespace("tabs"), createComponent$e = _createNamespace$e[0], bem$e = _createNamespace$e[1];
var Tabs = createComponent$e({
  mixins: [ParentMixin("vanTabs"), BindEventMixin(function(bind2) {
    if (!this.scroller) {
      this.scroller = getScroller(this.$el);
    }
    bind2(window, "resize", this.resize, true);
    if (this.scrollspy) {
      bind2(this.scroller, "scroll", this.onScroll, true);
    }
  })],
  inject: {
    vanPopup: {
      default: null
    }
  },
  model: {
    prop: "active"
  },
  props: {
    color: String,
    border: Boolean,
    sticky: Boolean,
    animated: Boolean,
    swipeable: Boolean,
    scrollspy: Boolean,
    background: String,
    lineWidth: [Number, String],
    lineHeight: [Number, String],
    beforeChange: Function,
    titleActiveColor: String,
    titleInactiveColor: String,
    type: {
      type: String,
      default: "line"
    },
    active: {
      type: [Number, String],
      default: 0
    },
    ellipsis: {
      type: Boolean,
      default: true
    },
    duration: {
      type: [Number, String],
      default: 0.3
    },
    offsetTop: {
      type: [Number, String],
      default: 0
    },
    lazyRender: {
      type: Boolean,
      default: true
    },
    swipeThreshold: {
      type: [Number, String],
      default: 5
    }
  },
  data: function data16() {
    return {
      position: "",
      currentIndex: null,
      lineStyle: {
        backgroundColor: this.color
      }
    };
  },
  computed: {
    scrollable: function scrollable() {
      return this.children.length > this.swipeThreshold || !this.ellipsis;
    },
    navStyle: function navStyle() {
      return {
        borderColor: this.color,
        background: this.background
      };
    },
    currentName: function currentName() {
      var activeTab = this.children[this.currentIndex];
      if (activeTab) {
        return activeTab.computedName;
      }
    },
    offsetTopPx: function offsetTopPx2() {
      return unitToPx(this.offsetTop);
    },
    scrollOffset: function scrollOffset() {
      if (this.sticky) {
        return this.offsetTopPx + this.tabHeight;
      }
      return 0;
    }
  },
  watch: {
    color: "setLine",
    active: function active(name) {
      if (name !== this.currentName) {
        this.setCurrentIndexByName(name);
      }
    },
    children: function children2() {
      var _this = this;
      this.setCurrentIndexByName(this.active);
      this.setLine();
      this.$nextTick(function() {
        _this.scrollIntoView(true);
      });
    },
    currentIndex: function currentIndex() {
      this.scrollIntoView();
      this.setLine();
      if (this.stickyFixed && !this.scrollspy) {
        setRootScrollTop(Math.ceil(getElementTop(this.$el) - this.offsetTopPx));
      }
    },
    scrollspy: function scrollspy(val) {
      if (val) {
        on$3(this.scroller, "scroll", this.onScroll, true);
      } else {
        off$3(this.scroller, "scroll", this.onScroll);
      }
    }
  },
  mounted: function mounted7() {
    var _this2 = this;
    this.init();
    if (this.vanPopup) {
      this.vanPopup.onReopen(function() {
        _this2.setLine();
      });
    }
  },
  activated: function activated() {
    this.init();
    this.setLine();
  },
  methods: {
    resize: function resize4() {
      this.setLine();
    },
    init: function init() {
      var _this3 = this;
      this.$nextTick(function() {
        _this3.inited = true;
        _this3.tabHeight = getVisibleHeight(_this3.$refs.wrap);
        _this3.scrollIntoView(true);
      });
    },
    setLine: function setLine() {
      var _this4 = this;
      var shouldAnimate = this.inited;
      this.$nextTick(function() {
        var titles = _this4.$refs.titles;
        if (!titles || !titles[_this4.currentIndex] || _this4.type !== "line" || isHidden(_this4.$el)) {
          return;
        }
        var title2 = titles[_this4.currentIndex].$el;
        var lineWidth = _this4.lineWidth, lineHeight = _this4.lineHeight;
        var left = title2.offsetLeft + title2.offsetWidth / 2;
        var lineStyle = {
          width: addUnit(lineWidth),
          backgroundColor: _this4.color,
          transform: "translateX(" + left + "px) translateX(-50%)"
        };
        if (shouldAnimate) {
          lineStyle.transitionDuration = _this4.duration + "s";
        }
        if (isDef$1(lineHeight)) {
          var height = addUnit(lineHeight);
          lineStyle.height = height;
          lineStyle.borderRadius = height;
        }
        _this4.lineStyle = lineStyle;
      });
    },
    setCurrentIndexByName: function setCurrentIndexByName(name) {
      var matched = this.children.filter(function(tab) {
        return tab.computedName === name;
      });
      var defaultIndex = (this.children[0] || {}).index || 0;
      this.setCurrentIndex(matched.length ? matched[0].index : defaultIndex);
    },
    setCurrentIndex: function setCurrentIndex(currentIndex2) {
      var newIndex2 = this.findAvailableTab(currentIndex2);
      if (!isDef$1(newIndex2)) {
        return;
      }
      var newTab = this.children[newIndex2];
      var newName = newTab.computedName;
      var shouldEmitChange = this.currentIndex !== null;
      this.currentIndex = newIndex2;
      if (newName !== this.active) {
        this.$emit("input", newName);
        if (shouldEmitChange) {
          this.$emit("change", newName, newTab.title);
        }
      }
    },
    findAvailableTab: function findAvailableTab(index2) {
      var diff = index2 < this.currentIndex ? -1 : 1;
      while (index2 >= 0 && index2 < this.children.length) {
        if (!this.children[index2].disabled) {
          return index2;
        }
        index2 += diff;
      }
    },
    onClick: function onClick6(item, index2) {
      var _this5 = this;
      var _this$children$index = this.children[index2], title2 = _this$children$index.title, disabled = _this$children$index.disabled, computedName2 = _this$children$index.computedName;
      if (disabled) {
        this.$emit("disabled", computedName2, title2);
      } else {
        callInterceptor({
          interceptor: this.beforeChange,
          args: [computedName2],
          done: function done() {
            _this5.setCurrentIndex(index2);
            _this5.scrollToCurrentContent();
          }
        });
        this.$emit("click", computedName2, title2);
        route(item.$router, item);
      }
    },
    scrollIntoView: function scrollIntoView(immediate) {
      var titles = this.$refs.titles;
      if (!this.scrollable || !titles || !titles[this.currentIndex]) {
        return;
      }
      var nav = this.$refs.nav;
      var title2 = titles[this.currentIndex].$el;
      var to = title2.offsetLeft - (nav.offsetWidth - title2.offsetWidth) / 2;
      scrollLeftTo(nav, to, immediate ? 0 : +this.duration);
    },
    onSticktScroll: function onSticktScroll(params) {
      this.stickyFixed = params.isFixed;
      this.$emit("scroll", params);
    },
    scrollTo: function scrollTo(name) {
      var _this6 = this;
      this.$nextTick(function() {
        _this6.setCurrentIndexByName(name);
        _this6.scrollToCurrentContent(true);
      });
    },
    scrollToCurrentContent: function scrollToCurrentContent(immediate) {
      var _this7 = this;
      if (immediate === void 0) {
        immediate = false;
      }
      if (this.scrollspy) {
        var target = this.children[this.currentIndex];
        var el = target == null ? void 0 : target.$el;
        if (el) {
          var to = getElementTop(el, this.scroller) - this.scrollOffset;
          this.lockScroll = true;
          scrollTopTo(this.scroller, to, immediate ? 0 : +this.duration, function() {
            _this7.lockScroll = false;
          });
        }
      }
    },
    onScroll: function onScroll2() {
      if (this.scrollspy && !this.lockScroll) {
        var index2 = this.getCurrentIndexOnScroll();
        this.setCurrentIndex(index2);
      }
    },
    getCurrentIndexOnScroll: function getCurrentIndexOnScroll() {
      var children3 = this.children;
      for (var index2 = 0; index2 < children3.length; index2++) {
        var top = getVisibleTop(children3[index2].$el);
        if (top > this.scrollOffset) {
          return index2 === 0 ? 0 : index2 - 1;
        }
      }
      return children3.length - 1;
    }
  },
  render: function render18() {
    var _this8 = this, _ref;
    var h = arguments[0];
    var type = this.type, animated = this.animated, scrollable2 = this.scrollable;
    var Nav = this.children.map(function(item, index2) {
      var _item$badge;
      return h(Title, {
        "ref": "titles",
        "refInFor": true,
        "attrs": {
          "type": type,
          "dot": item.dot,
          "info": (_item$badge = item.badge) != null ? _item$badge : item.info,
          "title": item.title,
          "color": _this8.color,
          "isActive": index2 === _this8.currentIndex,
          "disabled": item.disabled,
          "scrollable": scrollable2,
          "activeColor": _this8.titleActiveColor,
          "inactiveColor": _this8.titleInactiveColor
        },
        "style": item.titleStyle,
        "class": item.titleClass,
        "scopedSlots": {
          default: function _default5() {
            return item.slots("title");
          }
        },
        "on": {
          "click": function click2() {
            _this8.onClick(item, index2);
          }
        }
      });
    });
    var Wrap = h("div", {
      "ref": "wrap",
      "class": [bem$e("wrap", {
        scrollable: scrollable2
      }), (_ref = {}, _ref[BORDER_TOP_BOTTOM] = type === "line" && this.border, _ref)]
    }, [h("div", {
      "ref": "nav",
      "attrs": {
        "role": "tablist"
      },
      "class": bem$e("nav", [type, {
        complete: this.scrollable
      }]),
      "style": this.navStyle
    }, [this.slots("nav-left"), Nav, type === "line" && h("div", {
      "class": bem$e("line"),
      "style": this.lineStyle
    }), this.slots("nav-right")])]);
    return h("div", {
      "class": bem$e([type])
    }, [this.sticky ? h(Sticky, {
      "attrs": {
        "container": this.$el,
        "offsetTop": this.offsetTop
      },
      "on": {
        "scroll": this.onSticktScroll
      }
    }, [Wrap]) : Wrap, h(Content, {
      "attrs": {
        "count": this.children.length,
        "animated": animated,
        "duration": this.duration,
        "swipeable": this.swipeable,
        "currentIndex": this.currentIndex
      },
      "on": {
        "change": this.setCurrentIndex
      }
    }, [this.slots()])]);
  }
});
var _createNamespace$d = createNamespace("cascader"), createComponent$d = _createNamespace$d[0], bem$d = _createNamespace$d[1], t$4 = _createNamespace$d[2];
var _Cascader = createComponent$d({
  props: {
    title: String,
    value: [Number, String],
    fieldNames: Object,
    placeholder: String,
    activeColor: String,
    options: {
      type: Array,
      default: function _default3() {
        return [];
      }
    },
    closeable: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data: function data17() {
    return {
      tabs: [],
      activeTab: 0
    };
  },
  computed: {
    textKey: function textKey() {
      var _this$fieldNames;
      return ((_this$fieldNames = this.fieldNames) == null ? void 0 : _this$fieldNames.text) || "text";
    },
    valueKey: function valueKey() {
      var _this$fieldNames2;
      return ((_this$fieldNames2 = this.fieldNames) == null ? void 0 : _this$fieldNames2.value) || "value";
    },
    childrenKey: function childrenKey() {
      var _this$fieldNames3;
      return ((_this$fieldNames3 = this.fieldNames) == null ? void 0 : _this$fieldNames3.children) || "children";
    }
  },
  watch: {
    options: {
      deep: true,
      handler: "updateTabs"
    },
    value: function value3(_value) {
      var _this = this;
      if (_value || _value === 0) {
        var values = this.tabs.map(function(tab) {
          var _tab$selectedOption;
          return (_tab$selectedOption = tab.selectedOption) == null ? void 0 : _tab$selectedOption[_this.valueKey];
        });
        if (values.indexOf(_value) !== -1) {
          return;
        }
      }
      this.updateTabs();
    }
  },
  created: function created3() {
    this.updateTabs();
  },
  methods: {
    getSelectedOptionsByValue: function getSelectedOptionsByValue(options, value9) {
      for (var i = 0; i < options.length; i++) {
        var option2 = options[i];
        if (option2[this.valueKey] === value9) {
          return [option2];
        }
        if (option2[this.childrenKey]) {
          var selectedOptions = this.getSelectedOptionsByValue(option2[this.childrenKey], value9);
          if (selectedOptions) {
            return [option2].concat(selectedOptions);
          }
        }
      }
    },
    updateTabs: function updateTabs() {
      var _this2 = this;
      if (this.value || this.value === 0) {
        var selectedOptions = this.getSelectedOptionsByValue(this.options, this.value);
        if (selectedOptions) {
          var optionsCursor = this.options;
          this.tabs = selectedOptions.map(function(option2) {
            var tab = {
              options: optionsCursor,
              selectedOption: option2
            };
            var next3 = optionsCursor.filter(function(item) {
              return item[_this2.valueKey] === option2[_this2.valueKey];
            });
            if (next3.length) {
              optionsCursor = next3[0][_this2.childrenKey];
            }
            return tab;
          });
          if (optionsCursor) {
            this.tabs.push({
              options: optionsCursor,
              selectedOption: null
            });
          }
          this.$nextTick(function() {
            _this2.activeTab = _this2.tabs.length - 1;
          });
          return;
        }
      }
      this.tabs = [{
        options: this.options,
        selectedOption: null
      }];
    },
    onSelect: function onSelect(option2, tabIndex) {
      var _this3 = this;
      this.tabs[tabIndex].selectedOption = option2;
      if (this.tabs.length > tabIndex + 1) {
        this.tabs = this.tabs.slice(0, tabIndex + 1);
      }
      if (option2[this.childrenKey]) {
        var nextTab = {
          options: option2[this.childrenKey],
          selectedOption: null
        };
        if (this.tabs[tabIndex + 1]) {
          this.$set(this.tabs, tabIndex + 1, nextTab);
        } else {
          this.tabs.push(nextTab);
        }
        this.$nextTick(function() {
          _this3.activeTab++;
        });
      }
      var selectedOptions = this.tabs.map(function(tab) {
        return tab.selectedOption;
      }).filter(function(item) {
        return !!item;
      });
      var eventParams = {
        value: option2[this.valueKey],
        tabIndex,
        selectedOptions
      };
      this.$emit("input", option2[this.valueKey]);
      this.$emit("change", eventParams);
      if (!option2[this.childrenKey]) {
        this.$emit("finish", eventParams);
      }
    },
    onClose: function onClose2() {
      this.$emit("close");
    },
    renderHeader: function renderHeader() {
      var h = this.$createElement;
      if (this.showHeader) {
        return h("div", {
          "class": bem$d("header")
        }, [h("h2", {
          "class": bem$d("title")
        }, [this.slots("title") || this.title]), this.closeable ? h(_Icon, {
          "attrs": {
            "name": "cross"
          },
          "class": bem$d("close-icon"),
          "on": {
            "click": this.onClose
          }
        }) : null]);
      }
    },
    renderOptions: function renderOptions(options, selectedOption, tabIndex) {
      var _this4 = this;
      var h = this.$createElement;
      var renderOption = function renderOption2(option2) {
        var isSelected = selectedOption && option2[_this4.valueKey] === selectedOption[_this4.valueKey];
        var Text = _this4.slots("option", {
          option: option2,
          selected: isSelected
        }) || h("span", [option2[_this4.textKey]]);
        return h("li", {
          "class": bem$d("option", {
            selected: isSelected
          }),
          "style": {
            color: isSelected ? _this4.activeColor : null
          },
          "on": {
            "click": function click2() {
              _this4.onSelect(option2, tabIndex);
            }
          }
        }, [Text, isSelected ? h(_Icon, {
          "attrs": {
            "name": "success"
          },
          "class": bem$d("selected-icon")
        }) : null]);
      };
      return h("ul", {
        "class": bem$d("options")
      }, [options.map(renderOption)]);
    },
    renderTab: function renderTab(item, tabIndex) {
      var h = this.$createElement;
      var options = item.options, selectedOption = item.selectedOption;
      var title2 = selectedOption ? selectedOption[this.textKey] : this.placeholder || t$4("select");
      return h(Tab, {
        "attrs": {
          "title": title2,
          "titleClass": bem$d("tab", {
            unselected: !selectedOption
          })
        }
      }, [this.renderOptions(options, selectedOption, tabIndex)]);
    },
    renderTabs: function renderTabs() {
      var _this5 = this;
      var h = this.$createElement;
      return h(Tabs, {
        "attrs": {
          "animated": true,
          "swipeable": true,
          "swipeThreshold": 0,
          "color": this.activeColor
        },
        "class": bem$d("tabs"),
        "model": {
          value: _this5.activeTab,
          callback: function callback2($$v) {
            _this5.activeTab = $$v;
          }
        }
      }, [this.tabs.map(this.renderTab)]);
    }
  },
  render: function render19() {
    var h = arguments[0];
    return h("div", {
      "class": bem$d()
    }, [this.renderHeader(), this.renderTabs()]);
  }
});
var render$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "address-wraper"
  }, [_c("div", {
    staticClass: "control",
    style: {
      color: _vm.textColor
    },
    on: {
      "click": function($event) {
        _vm.showArea = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.showName ? _vm.showName : "\u8BF7\u9009\u62E9\u6240\u5728\u5730\u533A"))]), _c("van-popup", {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: _vm.showArea,
      callback: function($$v) {
        _vm.showArea = $$v;
      },
      expression: "showArea"
    }
  }, [_c("van-cascader", {
    ref: "cascader",
    attrs: {
      "field-names": {
        text: "name",
        value: "id",
        children: "children"
      },
      "options": _vm.options,
      "active-color": "var(--primary-color)",
      "show-header": false
    },
    on: {
      "change": _vm.changeArea
    },
    model: {
      value: _vm.code,
      callback: function($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  })], 1)], 1);
};
var staticRenderFns$j = [];
render$j._withStripped = true;
var index_vue_vue_type_style_index_0_lang$1 = "";
const __vue2_script$k = {
  name: "OpRegionSelect",
  components: {
    [_Cascader.name]: _Cascader,
    [_Popup.name]: _Popup
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: "1"
    },
    type: {
      type: Number,
      default: COUNTY
    },
    isShowCountry: {
      type: Boolean,
      default: false
    },
    mutipleVal: {
      type: Boolean,
      default: false
    },
    showRegExp: {
      type: String,
      default: "/"
    }
  },
  data() {
    return {
      options: [],
      code: "",
      areaName: "",
      showArea: false
    };
  },
  computed: {
    inputVal: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    showName({
      areaName,
      isShowCountry
    }) {
      if (isShowCountry) {
        return areaName ? areaName.replace(/\./g, this.showRegExp) : "";
      } else {
        const _name = (areaName || "").replace("\u4E2D\u56FD.", "");
        return _name ? _name.replace(/\./g, this.showRegExp) : "";
      }
    },
    textColor({
      showName
    }) {
      return showName ? "var(--main-text-color)" : "var(--placeholder-color)";
    }
  },
  mounted() {
    if (this.value) {
      if (this.mutipleVal) {
        const valList = this.value.split(",");
        const lastVal = valList[valList.length - 1];
        this.initCodeToOptions(lastVal);
      } else {
        this.initCodeToOptions(this.value);
      }
    } else {
      const _id = this.isShowCountry ? "" : "1";
      this.getOptions(_id).then((list) => {
        this.options = list;
      });
    }
  },
  methods: {
    async changeArea({
      selectedOptions,
      tabIndex,
      value: value9
    }) {
      let currentType = tabIndex;
      if (!this.isShowCountry)
        currentType += 1;
      if (currentType >= this.type) {
        this.setValue(selectedOptions[tabIndex]);
        return;
      }
      if (selectedOptions[tabIndex].children && selectedOptions[tabIndex].children.length > 0) {
        return;
      }
      const _list = await this.getOptions(value9);
      if (_list.length > 0) {
        selectedOptions[tabIndex].children = _list;
      } else {
        this.setValue(selectedOptions[tabIndex]);
      }
    },
    async getOptions(code) {
      let list = [];
      if (code) {
        const res = await getRegionListByPid({
          regionPid: code
        });
        list = res.data;
      } else {
        const res = await getRegionCountryListByPid();
        list = res.data.map((item) => {
          item.children = null;
          return item;
        });
      }
      return list;
    },
    setValue(selector) {
      this.inputVal = this.handleCode(selector);
      this.areaName = selector.pidsName;
      this.$emit("chooseRegionData", {
        pids: selector.pids,
        pidsName: selector.pidsName
      });
      this.showArea = false;
    },
    handleCode(selector) {
      let _val = "";
      if (this.mutipleVal) {
        _val = selector.pids;
      } else {
        _val = selector.id;
      }
      return _val;
    },
    initCodeToOptions(code) {
      this.code = code;
      getUCRegionById({
        regionId: code
      }).then((res) => {
        const selector = res.data;
        this.areaName = selector.pidsName;
        const pidsList = selector.pids.split(",");
        const optionsPromise = pidsList.map((pid) => this.getOptions(pid));
        optionsPromise.pop();
        if (this.isShowCountry) {
          optionsPromise.unshift(this.getOptions());
          pidsList.unshift("");
        }
        Promise.all(optionsPromise).then((resList) => {
          resList.forEach((res2, index2) => {
            const nextId = pidsList[index2 + 1];
            if (index2 === 0) {
              this.options = res2;
            }
            if (nextId) {
              const nextOption = res2.filter((x) => x.id === nextId);
              nextOption[0].children = resList[index2 + 1] || null;
            }
          });
        });
      }).catch(() => {
      });
    }
  }
};
const __cssModules$k = {};
var __component__$k = /* @__PURE__ */ normalizeComponent(__vue2_script$k, render$j, staticRenderFns$j, false, __vue2_injectStyles$k, null, null, null);
function __vue2_injectStyles$k(context2) {
  for (let o in __cssModules$k) {
    this[o] = __cssModules$k[o];
  }
}
__component__$k.options.__file = "packages/op-region-select/src/mobile/index.vue";
var MobileRegionSelect = /* @__PURE__ */ function() {
  return __component__$k.exports;
}();
RegionSelect.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(RegionSelect.name, prefix);
  if (isPCWidth()) {
    Vue2.component(comName, RegionSelect);
  } else {
    Vue2.component(comName, MobileRegionSelect);
  }
};
var __glob_6_24 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": RegionSelect
});
var render$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("SelectorDialog", {
    attrs: {
      "title": "\u9009\u62E9\u89D2\u8272",
      "placeholder": "\u8BF7\u8F93\u5165\u7F16\u7801\u3001\u89D2\u8272\u540D\u641C\u7D22",
      "single": _vm.single,
      "data": _vm.tableData,
      "config": _vm.config,
      "loading": _vm.loading,
      "checked-status-key": "id",
      "table-columns": _vm.tableColumns,
      "pagination": _vm.pagination,
      "append-to-body": _vm.appendToBody,
      "quick-search-props": "name,code"
    },
    on: {
      "update:data": function($event) {
        _vm.tableData = $event;
      },
      "load": _vm.loadData,
      "reset": _vm.reset,
      "onConfirm": _vm.onConfirm
    },
    model: {
      value: _vm.userVals,
      callback: function($$v) {
        _vm.userVals = $$v;
      },
      expression: "userVals"
    }
  });
};
var staticRenderFns$i = [];
render$i._withStripped = true;
const __vue2_script$j = defineComponent({
  name: "OpRoleSelector",
  components: {
    SelectorDialog: OpSelectorDialog
  },
  props: {
    value: String,
    single: Boolean,
    config: Object,
    appendToBody: {
      type: Boolean,
      default: false
    },
    platformType: {
      type: String,
      default: "ASSP"
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const tableData = ref([]);
    const loading2 = ref(false);
    const pagination = ref({
      pageNo: 1,
      pageSize: 20,
      total: 0,
      showTotal: true
    });
    const userVals = computed({
      get() {
        return props2.value;
      },
      set(newValue) {
        emit2("input", newValue);
      }
    });
    const tableColumns = ref([{
      prop: "name",
      label: "\u540D\u79F0",
      width: "260"
    }, {
      prop: "code",
      label: "\u7F16\u7801"
    }]);
    const reset2 = async (param) => {
      loadData(param);
    };
    const loadData = async (param) => {
      loading2.value = true;
      let searchStr = "";
      if (param && param.querys && param.querys.name) {
        searchStr = param.querys["name"];
      }
      if (param) {
        pagination.value.pageNo = param.pageNo || 1;
        pagination.value.pageSize = param.pageSize || 20;
      }
      let _params = {
        searchStr,
        rolePlatformType: props2.platformType,
        pageNo: pagination.value.pageNo,
        pageSize: pagination.value.pageSize
      };
      const {
        status,
        data: data22
      } = await getRolePageListByConToPost(_params);
      loading2.value = false;
      if (status) {
        if (!isPCWidth() && data22.current > 1) {
          tableData.value = [...tableData.value, ...data22.records];
        } else {
          tableData.value = data22.records;
        }
        pagination.value.pageSize = data22.size;
        pagination.value.total = data22.total;
      }
    };
    const onConfirm = (users) => {
      emit2("onConfirm", users);
    };
    return {
      tableData,
      loading: loading2,
      pagination,
      tableColumns,
      userVals,
      loadData,
      onConfirm,
      reset: reset2
    };
  }
});
const __cssModules$j = {};
var __component__$j = /* @__PURE__ */ normalizeComponent(__vue2_script$j, render$i, staticRenderFns$i, false, __vue2_injectStyles$j, null, null, null);
function __vue2_injectStyles$j(context2) {
  for (let o in __cssModules$j) {
    this[o] = __cssModules$j[o];
  }
}
__component__$j.options.__file = "packages/op-role-selector/src/OpRoleSelector.vue";
var OpRoleSelector = /* @__PURE__ */ function() {
  return __component__$j.exports;
}();
OpRoleSelector.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  Vue2.use(OpFormMap);
  const comName = changeComPrefix(OpRoleSelector.name, prefix);
  Vue2.component(comName, OpRoleSelector);
};
var __glob_6_25 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpRoleSelector
});
function getMarketUserData(props2) {
  const loading2 = ref(false);
  const tableData = ref([]);
  const total = ref(0);
  const params = ref({
    pageNo: 1,
    pageSize: 20
  });
  const buildObject = (arr) => {
    const obj = {};
    for (let i = 0; i < arr.length; i++) {
      const {
        key: key2,
        value: value9
      } = arr[i];
      obj[key2] = value9;
    }
    return obj;
  };
  const initParams = (str) => {
    if (props2.defaultSearchConfig && props2.defaultSearchConfig.formItem && props2.defaultSearchConfig.formItem.length) {
      let defaultSearchConfig = props2.defaultSearchConfig;
      if (str == "clear") {
        defaultSearchConfig.formItem.map((item) => {
          if (item.type) {
            return item.value = null;
          }
        });
      }
      let paramsObj = buildObject(defaultSearchConfig.formItem);
      params.value = Object.assign(params.value, paramsObj);
      params.value.pageNo = 1;
    }
  };
  const onSearch = (str) => {
    initParams(str);
    getMarketUser(params.value, props2.isVirtual);
  };
  const getMarketUser = function(paramsVal, isVirtual) {
    return new Promise((resolve, reject) => {
      try {
        loading2.value = true;
        let res = null;
        if (isVirtual) {
          getShopVirtualList(paramsVal).then((res2) => {
            if (res2.status && res2.data && Array.isArray(res2.data.records)) {
              resolve(res2.data);
              const record = res2.data.records || [];
              total.value = res2.data.total || 0;
              loading2.value = false;
              tableData.value = record;
            } else {
              loading2.value = false;
            }
          });
        } else {
          getShopPageList(paramsVal).then((res2) => {
            if (res2.status && res2.data && Array.isArray(res2.data.records)) {
              const record = res2.data.records || [];
              total.value = res2.data.total || 0;
              loading2.value = false;
              tableData.value = record;
            } else {
              loading2.value = false;
            }
          });
        }
      } catch (err) {
        /* @__PURE__ */ console.log(err, "\u83B7\u53D6\u95E8\u5E97\u5931\u8D25");
      }
    });
  };
  return {
    loading: loading2,
    tableData,
    total,
    params,
    initParams,
    onSearch,
    getMarketUser
  };
}
function variablesAndMethodsCollect(emit2, props2) {
  const currentVal = ref([]);
  const selected = ref([]);
  const singleValue = ref("");
  const searchConfig = ref(null);
  const multipleTable = ref(null);
  const {
    visible: visible2,
    close: close3,
    open: open3
  } = useModal(props2);
  const {
    value: value9
  } = toRefs(props2);
  const [internalValue, setInnerValue] = useVModel(value9, [], () => {
  }, "change");
  const removeSelected = (item, index2) => {
    currentVal.value.splice(index2, 1);
    setInnerValue(currentVal.value);
  };
  const rowClick = (row) => {
    multipleTable.value.toggleRowSelection(row);
  };
  const removeDialogSelected = (item, index2) => {
    multipleTable.value.selection.splice(index2, 1);
    selected.value = multipleTable.value.selection;
  };
  const handleCurrent = (val) => {
    if (val && !props2.multiple) {
      singleValue.value = val;
      selected.value = [val];
    }
  };
  const handleSelectionChange = (val) => {
    if (props2.multiple) {
      selected.value = val;
    }
  };
  const submit2 = () => {
    setInnerValue(selected.value);
    currentVal.value = selected.value;
    close3();
  };
  return {
    currentVal,
    selected,
    singleValue,
    searchConfig,
    multipleTable,
    visible: visible2,
    removeSelected,
    close: close3,
    submit: submit2,
    rowClick,
    removeDialogSelected,
    handleCurrent,
    handleSelectionChange,
    open: open3
  };
}
var props$1 = {
  title: {
    type: String,
    default: "\u95E8\u5E97\u9009\u62E9"
  },
  placeholder: {
    type: String,
    default: "\u8BF7\u9009\u62E9\u95E8\u5E97"
  },
  disabled: {
    type: Boolean,
    default: false
  },
  multiple: {
    type: Boolean,
    default: true
  },
  defaultSearchConfig: {
    type: Object,
    default: () => ({
      labelWidth: "50px",
      align: "right",
      formItem: [{
        key: "orgId",
        value: "c2a6fcf3ba7342729fd0c2c20e420526"
      }, {
        type: "input",
        label: "\u5173\u952E\u5B57",
        labelWidth: "60px",
        value: null,
        key: "searchStr",
        placeholder: "999",
        span: 4
      }, {
        type: "select",
        label: "\u54C1\u724C",
        key: "brandName",
        value: null,
        clearable: true,
        multiple: true,
        span: 6,
        options: [{
          value: 1,
          label: "1"
        }, {
          value: 2,
          label: "3"
        }]
      }]
    })
  },
  tableHead: {
    type: Array,
    default: () => [{
      label: "\u5546\u573A\u7F16\u7801",
      value: "orgNo",
      width: "50"
    }, {
      label: "\u5546\u573A\u540D\u79F0",
      value: "orgName",
      width: "50"
    }, {
      label: "\u95E8\u5E97\u7F16\u7801",
      value: "shopNo",
      width: "50"
    }, {
      label: "\u95E8\u5E97\u540D\u79F0",
      value: "shopName",
      width: "50"
    }, {
      label: "\u95E8\u5E97\u5730\u5740",
      value: "shopLocationAddress",
      width: "100"
    }]
  },
  value: {
    type: Array,
    default: () => []
  },
  isVirtual: {
    type: Boolean,
    default: true
  }
};
var render$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "shop-select"
  }, [_c("div", {
    on: {
      "click": _vm.showDialog
    }
  }, [_c("div", {
    staticClass: "el-input el-input--mini",
    class: {
      "is-disabled": _vm.disabled
    }
  }, [_c("div", {
    staticClass: "el-input__inner"
  }, [_vm.currentVal.length ? _vm._l(_vm.currentVal, function(item, index2) {
    return _c("el-tag", {
      key: item.shopId,
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "size": "mini",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.removeSelected(item, index2);
        }
      }
    }, [_vm._v(" " + _vm._s(item.shopName) + " ")]);
  }) : [_c("div", {
    staticStyle: {
      "color": "#c0c4cc"
    }
  }, [_vm._v(_vm._s(_vm.placeholder))])]], 2)])]), _c("el-dialog", {
    attrs: {
      "title": _vm.title,
      "append-to-body": "",
      "visible": _vm.visible,
      "width": "1200px",
      "top": "8vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("el-container", [_c("el-main", {
    staticClass: "shop-select-chooseArea"
  }, [_c("div", {
    staticClass: "shop-select-chooseArea__search"
  }, [_vm.searchConfig ? _c("el-form", {
    ref: "form",
    attrs: {
      "label-width": _vm.searchConfig.labelWidth,
      "label-position": _vm.searchConfig.align
    }
  }, [_c("el-row", [_vm._l(_vm.searchConfig.formItem, function(formItem) {
    return _c("el-col", {
      key: formItem.key,
      attrs: {
        "span": formItem.span
      }
    }, [_c("el-form-item", {
      attrs: {
        "label": formItem.label,
        "label-width": formItem.labelWidth
      }
    }, [formItem.type == "input" ? _c("el-input", {
      attrs: {
        "placeholder": formItem.placeholder
      },
      model: {
        value: formItem.value,
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v);
        },
        expression: "formItem.value"
      }
    }) : formItem.type === "select" ? _c("el-select", {
      attrs: {
        "disabled": formItem.disabled,
        "clearable": formItem.clearable,
        "multiple": formItem.multiple,
        "filterable": formItem.filterable
      },
      model: {
        value: formItem.value,
        callback: function($$v) {
          _vm.$set(formItem, "value", $$v);
        },
        expression: "formItem.value"
      }
    }, _vm._l(formItem.options, function(o) {
      return _c("el-option", {
        key: o.value,
        attrs: {
          "label": o.label,
          "value": o.value,
          "disabled": o.disabled
        }
      });
    }), 1) : _vm._e()], 1)], 1);
  }), _c("el-col", {
    attrs: {
      "span": 5
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_vm._v("\u641C\u7D22")]), _c("el-button", {
    on: {
      "click": function($event) {
        return _vm.onSearch("clear");
      }
    }
  }, [_vm._v("\u91CD\u7F6E")])], 1)], 1)], 2)], 1) : _vm._e()], 1), _vm.visible ? _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "multipleTable",
    attrs: {
      "border": "",
      "data": _vm.tableData,
      "row-key": "shopId",
      "height": _vm.height
    },
    on: {
      "row-click": _vm.rowClick,
      "selection-change": _vm.handleSelectionChange,
      "current-change": _vm.handleCurrent
    }
  }, [_vm.multiple ? _c("el-table-column", {
    attrs: {
      "type": "selection",
      "width": "55",
      "reserve-selection": true
    }
  }) : _c("el-table-column", {
    attrs: {
      "label": "",
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c("el-radio", {
          staticStyle: {
            "padding-left": "10px",
            "margin-right": "-25px"
          },
          attrs: {
            "label": scope.row.shopId
          },
          model: {
            value: _vm.singleValue.shopId,
            callback: function($$v) {
              _vm.$set(_vm.singleValue, "shopId", $$v);
            },
            expression: "singleValue.shopId"
          }
        }, [_vm._v("\xA0")])];
      }
    }], null, false, 1303182291)
  }), _vm._l(_vm.tableHead, function(item) {
    return _c("el-table-column", {
      key: item.id,
      attrs: {
        "label": item.label,
        "align": "center",
        "min-width": item.width
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[item.value]))];
        }
      }], null, true)
    });
  })], 2) : _vm._e(), _c("el-pagination", {
    staticClass: "shop-select-chooseArea__pagination",
    attrs: {
      "current-page": _vm.params.pageNo,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.params.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "pageNo", $event);
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "pageNo", $event);
      },
      "update:pageSize": function($event) {
        return _vm.$set(_vm.params, "pageSize", $event);
      },
      "update:page-size": function($event) {
        return _vm.$set(_vm.params, "pageSize", $event);
      },
      "current-change": function($event) {
        return _vm.getMarketUser(_vm.params, _vm.isVirtual);
      },
      "size-change": function($event) {
        return _vm.getMarketUser(_vm.params, _vm.isVirtual);
      }
    }
  })], 1), _vm.multiple ? _c("el-aside", {
    staticClass: "shop-select-choosed",
    attrs: {
      "width": "250px"
    }
  }, [_c("el-card", [_c("div", {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("\u5DF2\u9009\u62E9")])]), _c("div", {
    style: "height:" + (_vm.height - 24) + "px;overflow: auto;"
  }, _vm._l(_vm.selected, function(item, index2) {
    return _c("div", {
      key: item.id
    }, [_c("el-tag", {
      staticClass: "shop-select-choosed__tag",
      attrs: {
        "size": "medium",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.removeDialogSelected(item, index2);
        }
      }
    }, [_vm._v(_vm._s(item.shopName))])], 1);
  }), 0)])], 1) : _vm._e()], 1), _c("el-footer", {
    staticClass: "shop-select-button"
  }, [_c("el-button", {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\u53D6 \u6D88")]), _c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\u786E \u5B9A")])], 1)], 1)], 1);
};
var staticRenderFns$h = [];
render$h._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$2 = "";
const __vue2_script$i = defineComponent({
  name: "OpShopSelect",
  props: __spreadValues({}, props$1),
  setup(props2, {
    emit: emit2
  }) {
    const height = ref(500);
    const {
      loading: loading2,
      tableData,
      total,
      params,
      getMarketUser,
      initParams,
      onSearch
    } = getMarketUserData(props2);
    const {
      currentVal,
      selected,
      singleValue,
      searchConfig,
      multipleTable,
      visible: visible2,
      removeSelected,
      submit: submit2,
      rowClick,
      removeDialogSelected,
      handleCurrent,
      handleSelectionChange,
      close: close3
    } = variablesAndMethodsCollect(emit2, props2);
    onMounted(() => {
      currentVal.value = props2.value;
    });
    const showDialog = () => {
      if (!props2.disabled) {
        visible2.value = true;
        searchConfig.value = __spreadValues({}, props2.defaultSearchConfig);
        initParams();
        getMarketUser(params.value, props2.isVirtual);
        nextTick(() => {
          if (props2.value && props2.value.length > 0) {
            selected.value = props2.value;
            multipleTable.value.selection.push(...props2.value);
            singleValue.value = props2.value[0];
          }
        });
      }
    };
    return {
      height,
      currentVal,
      selected,
      params,
      singleValue,
      searchConfig,
      multipleTable,
      loading: loading2,
      tableData,
      total,
      visible: visible2,
      getMarketUser,
      showDialog,
      onSearch,
      close: close3,
      submit: submit2,
      rowClick,
      removeDialogSelected,
      handleCurrent,
      handleSelectionChange,
      removeSelected,
      initParams
    };
  }
});
const __cssModules$i = {};
var __component__$i = /* @__PURE__ */ normalizeComponent(__vue2_script$i, render$h, staticRenderFns$h, false, __vue2_injectStyles$i, "e9f1a096", null, null);
function __vue2_injectStyles$i(context2) {
  for (let o in __cssModules$i) {
    this[o] = __cssModules$i[o];
  }
}
__component__$i.options.__file = "packages/op-shop-select/src/pc/index.vue";
var ShopSelect = /* @__PURE__ */ function() {
  return __component__$i.exports;
}();
var render$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "shop-select"
  }, [_c("field-pannel", {
    attrs: {
      "list": _vm.currentVal,
      "disabled": _vm.disabled,
      "config": {
        label: "shopName",
        value: "shopId"
      }
    },
    on: {
      "open": _vm.open
    }
  }), _c("van-popup", {
    attrs: {
      "value": _vm.visible,
      "position": "bottom"
    },
    on: {
      "open": _vm.showDialog,
      "close": function($event) {
        _vm.selected = [];
        _vm.visible = false;
      },
      "click-overlay": function($event) {
        _vm.selected = [];
        _vm.visible = false;
      }
    }
  }, [_c("div", {
    staticClass: "shop-select-chooseArea"
  }, [_c("van-search", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u95E8\u5E97\u540D\u79F0"
    },
    on: {
      "search": _vm.onRefresh
    },
    model: {
      value: _vm.params.searchStr,
      callback: function($$v) {
        _vm.$set(_vm.params, "searchStr", $$v);
      },
      expression: "params.searchStr"
    }
  }), _c("div", {
    style: "height: " + _vm.height + "px; overflow: auto"
  }, [_c("van-pull-refresh", {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: _vm.refreshing,
      callback: function($$v) {
        _vm.refreshing = $$v;
      },
      expression: "refreshing"
    }
  }, [_c("van-list", {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "\u6CA1\u6709\u66F4\u591A\u4E86",
      "immediate-check": false
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: _vm.loading,
      callback: function($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, [_vm.multiple ? [_c("van-checkbox-group", {
    on: {
      "change": _vm.changeShop
    },
    model: {
      value: _vm.currentIdVal,
      callback: function($$v) {
        _vm.currentIdVal = $$v;
      },
      expression: "currentIdVal"
    }
  }, [_c("van-cell-group", _vm._l(_vm.shopList, function(item, index2) {
    return _c("van-cell", {
      key: item.shopId,
      attrs: {
        "clickable": "",
        "title": item.shopName
      },
      on: {
        "click": function($event) {
          return _vm.toggle(item, index2);
        }
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c("van-checkbox", {
            ref: "checkboxes" + index2,
            refInFor: true,
            attrs: {
              "name": item.shopId,
              "icon-size": "14px",
              "shape": "square",
              "checked-color": "#fc9153"
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)], 1)] : [_c("van-radio-group", {
    on: {
      "change": _vm.changeShop
    },
    model: {
      value: _vm.singleValue,
      callback: function($$v) {
        _vm.singleValue = $$v;
      },
      expression: "singleValue"
    }
  }, [_c("van-cell-group", _vm._l(_vm.tableData, function(item, index2) {
    return _c("van-cell", {
      key: item.shopId,
      attrs: {
        "clickable": "",
        "title": item.shopName
      },
      on: {
        "click": function($event) {
          return _vm.toggle(item, index2);
        }
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c("van-radio", {
            attrs: {
              "name": item.shopId,
              "icon-size": "14px",
              "checked-color": "#fc9153"
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)], 1)]], 2)], 1)], 1), _c("div", {
    staticClass: "shop-select-choosed"
  }, [_vm._v(" \u5F53\u524D\u95E8\u5E97\uFF1A "), _vm._l(_vm.selected, function(shop, index2) {
    return _c("span", {
      key: shop.shopId,
      staticClass: "shop-select-choosed__tag"
    }, [_vm._v(" " + _vm._s(shop.shopName) + _vm._s(index2 !== _vm.selected.length - 1 ? "\uFF0C" : "") + " ")]);
  })], 2), _c("van-button", {
    staticClass: "shop-select-button",
    attrs: {
      "type": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v("\u786E\u8BA4")])], 1)])], 1);
};
var staticRenderFns$g = [];
render$g._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
const __vue2_script$h = defineComponent({
  name: "OpShopSelect",
  components: {
    FieldPannel
  },
  props: __spreadValues({}, props$1),
  setup(props2, {
    emit: emit2
  }) {
    const height = ref(200);
    const refreshing = ref(false);
    const finished = ref(false);
    const currentIdVal = ref([]);
    const shopList = ref([]);
    const {
      $refs
    } = proxyGetCurrentInstance();
    const {
      loading: loading2,
      total,
      params,
      getMarketUser,
      initParams
    } = getMarketUserData(props2);
    const {
      visible: visible2,
      singleValue,
      selected,
      open: open3,
      submit: submit2,
      currentVal
    } = variablesAndMethodsCollect(emit2, props2);
    toRefs(props2);
    onMounted(() => {
      height.value = window.innerHeight - 60 - 54 * 2 - 100;
      currentVal.value = props2.value;
      initParams();
      getMarketUserMobile();
    });
    const getMarketUserMobile = () => {
      getMarketUser(params.value, props2.isVirtual).then((res) => {
        if (Array.isArray(res.records)) {
          shopList.value = params.value.pageNo === 1 ? res.records : shopList.value.concat(res.records);
          refreshing.value = false;
          finished.value = shopList.value.length >= total.value;
          loading2.value = false;
        } else {
          refreshing.value = false;
          loading2.value = false;
          finished.value = true;
        }
      });
    };
    const showDialog = () => {
      if (!props2.disabled) {
        visible2.value = true;
        nextTick(() => {
          if (props2.value && props2.value.length > 0) {
            selected.value = props2.value;
            currentIdVal.value = props2.value.length && props2.value.map((i) => i.shopId) || [];
            singleValue.value = props2.multiple ? "" : props2.value[0].shopId;
          }
        });
      }
    };
    const onLoad3 = () => {
      if (loading2.value) {
        params.value.pageNo++;
        getMarketUserMobile();
      }
    };
    const onRefresh = () => {
      params.value.pageNo = 1;
      getMarketUserMobile();
    };
    const toggle5 = (item, index2) => {
      if (props2.multiple) {
        nextTick(() => {
          $refs[`checkboxes${Number(index2)}`] && $refs[`checkboxes${Number(index2)}`][0].toggle();
        });
      } else {
        singleValue.value = item.shopId;
        selected.value = [item];
      }
    };
    const changeShop = (val) => {
      if (props2.multiple) {
        selected.value = [];
        if (val) {
          selected.value = val.map((item) => {
            return shopList.value.find((data22) => data22.shopId == item);
          });
        }
      }
    };
    return {
      visible: visible2,
      currentVal,
      singleValue,
      currentIdVal,
      params,
      selected,
      loading: loading2,
      total,
      refreshing,
      finished,
      height,
      shopList,
      getMarketUser,
      open: open3,
      onLoad: onLoad3,
      onRefresh,
      toggle: toggle5,
      changeShop,
      submit: submit2,
      initParams,
      showDialog,
      getMarketUserMobile
    };
  }
});
const __cssModules$h = {};
var __component__$h = /* @__PURE__ */ normalizeComponent(__vue2_script$h, render$g, staticRenderFns$g, false, __vue2_injectStyles$h, "5481d824", null, null);
function __vue2_injectStyles$h(context2) {
  for (let o in __cssModules$h) {
    this[o] = __cssModules$h[o];
  }
}
__component__$h.options.__file = "packages/op-shop-select/src/mobile/index.vue";
var MobileShopSelect = /* @__PURE__ */ function() {
  return __component__$h.exports;
}();
ShopSelect.install = (Vue2) => {
  if (!Vue2.prototype.$loading) {
    Vue2.use(_Loading.directive);
    Vue2.prototype.$loading = _Loading.service;
  }
  /* @__PURE__ */ console.log(isPCWidth());
  if (isPCWidth()) {
    Vue2.component(ShopSelect.name, ShopSelect);
  } else {
    Vue2.component(MobileShopSelect.name, MobileShopSelect);
  }
};
var __glob_6_26 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": ShopSelect
});
const OP_TABLE_STORE = "OP_TABLE_STORE";
class TableStore {
  constructor() {
    this.updateStore();
  }
  getDisplayedColumns(id) {
    return this.tableStore.displayColumnStore[id] || [];
  }
  updateDisplayedColumns(id, data22) {
    if (!id) {
      throw new Error("\u4F7F\u7528displayedColumns\u5FC5\u987B\u8981\u6709tableId");
    }
    this.updateStore();
    this.tableStore.displayColumnStore[id] = data22;
    localStorage.setItem(OP_TABLE_STORE, JSON.stringify(this.tableStore));
  }
  getColumns(id) {
    return this.tableStore.columnStore[id] || [];
  }
  updateColmns(id, data22) {
    if (!id) {
      return;
    }
    this.updateStore();
    this.tableStore.columnStore[id] = data22;
    localStorage.setItem(OP_TABLE_STORE, JSON.stringify(this.tableStore));
  }
  updateStore() {
    if (localStorage.getItem(OP_TABLE_STORE)) {
      this.tableStore = JSON.parse(localStorage.getItem(OP_TABLE_STORE));
    } else {
      this.tableStore = {};
    }
    if (!this.tableStore.displayColumnStore) {
      this.tableStore.displayColumnStore = {};
    }
    if (!this.tableStore.columnStore) {
      this.tableStore.columnStore = {};
    }
  }
}
var Table_vue_vue_type_style_index_0_lang = "";
const __vue2_script$g = {
  name: "OpTable",
  props: {
    routeNameId: Boolean,
    tableId: {
      type: String,
      default: ""
    },
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    bottomOffset: {
      type: Number,
      default: 60
    },
    updateToFix: {
      type: Number,
      default: 0
    },
    maxHeight: {
      type: Number,
      default: 0
    },
    treeProps: {
      type: Object,
      default: null
    },
    cellStyle: {
      type: [Function, String],
      default: null
    },
    defaultExpandAll: {
      type: Boolean,
      default: true
    },
    rowKey: {
      type: String,
      default: "id"
    },
    header: {
      type: Array,
      default: () => []
    },
    onSubmitHeaderConfig: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    const tableStore = new TableStore();
    return {
      columnList: [],
      forceRender: true,
      tableStore,
      propsColumnList: []
    };
  },
  computed: {
    _tableId({
      tableId,
      routeNameId
    }) {
      if (routeNameId && this.$route.name) {
        return this.$route.name + "_" + tableId;
      } else {
        return tableId;
      }
    },
    identifier() {
      return "OpTable";
    },
    displayedColumnList({
      tableStore,
      _tableId,
      columnList
    }) {
      const columns = tableStore.getDisplayedColumns(_tableId);
      if (columns.length === 0) {
        return columnList.filter((x) => x.init !== false).map((x) => x.prop);
      } else {
        return columns;
      }
    }
  },
  watch: {
    _tableId() {
      this.setColumnList();
      this.$nextTick(() => {
        if (this.$refs.myTable) {
          this.$refs.myTable.doLayout();
        }
      });
    },
    data() {
      this.$nextTick(() => {
        if (this.$refs.myTable) {
          this.$refs.myTable.doLayout();
        }
      });
    }
  },
  activated() {
    this.handleResize();
  },
  created() {
    this.columnList = this.tableStore.getColumns(this._tableId);
  },
  mounted() {
    this.setColumnList();
  },
  methods: {
    setColumnList() {
      const storeColumnList = this.tableStore.getColumns(this._tableId);
      const propColumnList = [];
      if (this.header.length > 0) {
        for (let column of this.header) {
          if (column.prop) {
            propColumnList.push({
              label: column.name,
              prop: column.prop,
              fixed: column.fixed || "",
              init: column.init
            });
          }
        }
      } else if (this.$slots.default) {
        for (let column of this.$slots.default) {
          if (!column.data)
            continue;
          const attrs = column.data.attrs;
          const propsData = column.componentOptions.propsData;
          if (attrs.prop && !propsData.hidden) {
            propColumnList.push({
              label: attrs.label,
              prop: attrs.prop,
              fixed: column.fixed || "",
              init: attrs.init
            });
          }
        }
      }
      this.propsColumnList = propColumnList;
      if (this._tableId) {
        if (storeColumnList.length === 0) {
          this.columnList = propColumnList;
          this.tableStore.updateColmns(this._tableId, this.columnList);
          return;
        }
        if (JSON.stringify(storeColumnList) !== JSON.stringify(propColumnList)) {
          let _currentDisplayColumn = this.tableStore.getDisplayedColumns(this._tableId);
          const newColumnList = propColumnList.filter((x) => !storeColumnList.some((y) => x.prop === y.prop));
          if (_currentDisplayColumn.length > 0) {
            _currentDisplayColumn = _currentDisplayColumn.filter((x) => storeColumnList.every((y) => x === y.prop));
            const newDisplayColumn = newColumnList.filter((x) => x.init !== false).map((x) => x.prop);
            const newDisplayColumnList = [..._currentDisplayColumn, ...newDisplayColumn];
            this.tableStore.updateDisplayedColumns(this._tableId, newDisplayColumnList);
          }
          let _columnList = [...storeColumnList, ...newColumnList];
          _columnList = _columnList.filter((x) => propColumnList.some((y) => x.prop === y.prop));
          this.tableStore.updateColmns(this._tableId, _columnList);
          this.columnList = _columnList;
          return;
        } else {
          this.columnList = storeColumnList;
        }
      } else {
        this.columnList = propColumnList;
      }
    },
    createColumnVnodes(vnodes) {
      if (!this.tableId) {
        return vnodes;
      }
      if (this.displayedColumnList.length === 0 || this.columnList.length === 0) {
        return vnodes;
      } else {
        const displayVnodes = [];
        const fixLeftVnodes = [];
        const fixRightVnodes = [];
        const _vnodes = [...vnodes];
        this.columnList.forEach((column, index2) => {
          const _index = _vnodes.findIndex((vnode) => vnode.data && vnode.data.attrs.prop === column.prop && this.displayedColumnList.some((x) => vnode.data.attrs.prop === x));
          const _vnode = _vnodes[_index];
          if (!_vnode)
            return;
          if (_vnode.data.attrs.fixed) {
            if (_vnode.data.attrs.fixed === "left") {
              _vnode.data.attrs.key = "left_" + index2;
              fixLeftVnodes.push(_vnode);
            } else {
              _vnode.data.attrs.key = "right_" + index2;
              fixRightVnodes.push(_vnode);
            }
          } else {
            _vnode.data.attrs.key += index2;
            displayVnodes.push(_vnode);
          }
          if (_index > -1) {
            _vnodes.splice(_index, 1);
          }
        });
        const noPropsColumns = [];
        for (let vnode of vnodes) {
          if (!vnode.data)
            continue;
          const attrs = vnode.data.attrs;
          if (attrs.prop)
            continue;
          if (attrs.fixed === "left") {
            fixLeftVnodes.unshift(vnode);
          } else if (attrs.fixed === "right") {
            fixRightVnodes.push(vnode);
          } else {
            noPropsColumns.push(vnode);
          }
        }
        const AllVnodes = [...fixLeftVnodes, ...noPropsColumns, ...displayVnodes, ...fixRightVnodes];
        return AllVnodes;
      }
    },
    submitColumnDisplay(val) {
      this.tableStore.updateDisplayedColumns(this._tableId, val);
      this.tableStore.updateColmns(this._tableId, this.columnList);
      if (this.onSubmitHeaderConfig && typeof this.onSubmitHeaderConfig === "function") {
        this.onSubmitHeaderConfig(val, this.columnList);
      }
      this.forceRender = false;
      this.$nextTick(() => {
        this.forceRender = true;
      });
    },
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.myTable) {
          this.$refs.myTable.doLayout();
        }
      });
    }
  },
  render(h) {
    const defaultOptions2 = {
      elementLoadingText: "\u62FC\u547D\u52A0\u8F7D\u4E2D",
      elementLoadingSpinner: "el-icon-loading",
      border: true,
      stripe: true,
      size: "small",
      data: this.data,
      highlightCurrentRow: true,
      headerRowClassName: "table-header",
      headerCellClassName: "table-header-cell",
      rowClassName: "column-row",
      cellClassName: "column-cell"
    };
    const attrObj = {
      ref: "myTable",
      props: __spreadValues({}, Object.assign({}, defaultOptions2, this.$attrs)),
      on: __spreadValues({}, this.$listeners),
      directives: [{
        name: "loading",
        value: this.loading
      }]
    };
    if (this.cellStyle) {
      attrObj.props.cellStyle = this.cellStyle;
    }
    if (this.treeProps) {
      attrObj.props.treeProps = this.treeProps;
      attrObj.props.defaultExpandAll = this.defaultExpandAll;
      attrObj.props.rowKey = this.rowKey;
    }
    if (this.maxHeight) {
      attrObj.props.maxHeight = this.maxHeight;
      attrObj.props.heigth = this.maxHeight;
    } else {
      attrObj.props.height = "550px";
      const bindingValue = {
        name: "el-height-adaptive-table",
        value: {
          bottomOffset: this.bottomOffset
        }
      };
      if (this.updateToFix) {
        bindingValue.value.updateToFix = this.updateToFix;
      }
      attrObj.directives.push(bindingValue);
    }
    const columnVodeList = this.createColumnVnodes(this.$slots.default);
    if (this.forceRender) {
      return h("el-table", attrObj, columnVodeList);
    } else {
      return h("div");
    }
  }
};
let __vue2_render, __vue2_staticRenderFns;
const __cssModules$g = {};
var __component__$g = /* @__PURE__ */ normalizeComponent(__vue2_script$g, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles$g, null, null, null);
function __vue2_injectStyles$g(context2) {
  for (let o in __cssModules$g) {
    this[o] = __cssModules$g[o];
  }
}
__component__$g.options.__file = "packages/op-table/src/Table.vue";
var OpTable = /* @__PURE__ */ function() {
  return __component__$g.exports;
}();
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key2) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key2) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return function() {
    function class_1() {
      this.__entries__ = [];
    }
    Object.defineProperty(class_1.prototype, "size", {
      get: function() {
        return this.__entries__.length;
      },
      enumerable: true,
      configurable: true
    });
    class_1.prototype.get = function(key2) {
      var index2 = getIndex(this.__entries__, key2);
      var entry = this.__entries__[index2];
      return entry && entry[1];
    };
    class_1.prototype.set = function(key2, value9) {
      var index2 = getIndex(this.__entries__, key2);
      if (~index2) {
        this.__entries__[index2][1] = value9;
      } else {
        this.__entries__.push([key2, value9]);
      }
    };
    class_1.prototype.delete = function(key2) {
      var entries = this.__entries__;
      var index2 = getIndex(entries, key2);
      if (~index2) {
        entries.splice(index2, 1);
      }
    };
    class_1.prototype.has = function(key2) {
      return !!~getIndex(this.__entries__, key2);
    };
    class_1.prototype.clear = function() {
      this.__entries__.splice(0);
    };
    class_1.prototype.forEach = function(callback2, ctx) {
      if (ctx === void 0) {
        ctx = null;
      }
      for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
        var entry = _a[_i];
        callback2.call(ctx, entry[1], entry[0]);
      }
    };
    return class_1;
  }();
}();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback2) {
    return setTimeout(function() {
      return callback2(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle(callback2, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback2();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = function() {
  function ResizeObserverController2() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  ResizeObserverController2.prototype.addObserver = function(observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    if (!this.connected_) {
      this.connect_();
    }
  };
  ResizeObserverController2.prototype.removeObserver = function(observer) {
    var observers2 = this.observers_;
    var index2 = observers2.indexOf(observer);
    if (~index2) {
      observers2.splice(index2, 1);
    }
    if (!observers2.length && this.connected_) {
      this.disconnect_();
    }
  };
  ResizeObserverController2.prototype.refresh = function() {
    var changesDetected = this.updateObservers_();
    if (changesDetected) {
      this.refresh();
    }
  };
  ResizeObserverController2.prototype.updateObservers_ = function() {
    var activeObservers = this.observers_.filter(function(observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    activeObservers.forEach(function(observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  ResizeObserverController2.prototype.connect_ = function() {
    if (!isBrowser || this.connected_) {
      return;
    }
    document.addEventListener("transitionend", this.onTransitionEnd_);
    window.addEventListener("resize", this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener("DOMSubtreeModified", this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  ResizeObserverController2.prototype.disconnect_ = function() {
    if (!isBrowser || !this.connected_) {
      return;
    }
    document.removeEventListener("transitionend", this.onTransitionEnd_);
    window.removeEventListener("resize", this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener("DOMSubtreeModified", this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
    var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
    var isReflowProperty = transitionKeys.some(function(key2) {
      return !!~propertyName.indexOf(key2);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  ResizeObserverController2.getInstance = function() {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController2();
    }
    return this.instance_;
  };
  ResizeObserverController2.instance_ = null;
  return ResizeObserverController2;
}();
var defineConfigurable = function(target, props2) {
  for (var _i = 0, _a = Object.keys(props2); _i < _a.length; _i++) {
    var key2 = _a[_i];
    Object.defineProperty(target, key2, {
      value: props2[key2],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value9) {
  return parseFloat(value9) || 0;
}
function getBordersSize(styles2) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size2, position) {
    var value9 = styles2["border-" + position + "-width"];
    return size2 + toFloat(value9);
  }, 0);
}
function getPaddings(styles2) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value9 = styles2["padding-" + position];
    paddings[position] = toFloat(value9);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles2 = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles2);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles2.width), height = toFloat(styles2.height);
  if (styles2.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles2, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles2, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x,
    y,
    width,
    height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
function createRectInit(x, y, width, height) {
  return {
    x,
    y,
    width,
    height
  };
}
var ResizeObservation = function() {
  function ResizeObservation2(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  ResizeObservation2.prototype.isActive = function() {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  ResizeObservation2.prototype.broadcastRect = function() {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation2;
}();
var ResizeObserverEntry = function() {
  function ResizeObserverEntry2(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    defineConfigurable(this, {
      target,
      contentRect
    });
  }
  return ResizeObserverEntry2;
}();
var ResizeObserverSPI = function() {
  function ResizeObserverSPI2(callback2, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();
    if (typeof callback2 !== "function") {
      throw new TypeError("The callback provided as parameter 1 is not a function.");
    }
    this.callback_ = callback2;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  ResizeObserverSPI2.prototype.observe = function(target) {
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    if (typeof Element === "undefined" || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    this.controller_.refresh();
  };
  ResizeObserverSPI2.prototype.unobserve = function(target) {
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    if (typeof Element === "undefined" || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    if (!observations.has(target)) {
      return;
    }
    observations.delete(target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  ResizeObserverSPI2.prototype.disconnect = function() {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  ResizeObserverSPI2.prototype.gatherActive = function() {
    var _this = this;
    this.clearActive();
    this.observations_.forEach(function(observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  ResizeObserverSPI2.prototype.broadcastActive = function() {
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    var entries = this.activeObservations_.map(function(observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  ResizeObserverSPI2.prototype.clearActive = function() {
    this.activeObservations_.splice(0);
  };
  ResizeObserverSPI2.prototype.hasActive = function() {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI2;
}();
var observers = typeof WeakMap !== "undefined" ? new WeakMap() : new MapShim();
var ResizeObserver = function() {
  function ResizeObserver2(callback2) {
    if (!(this instanceof ResizeObserver2)) {
      throw new TypeError("Cannot call a class as a function.");
    }
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback2, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver2;
}();
["observe", "unobserve", "disconnect"].forEach(function(method) {
  ResizeObserver.prototype[method] = function() {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index$c = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver;
}();
const isServer = typeof window === "undefined";
const resizeHandler = function(entries) {
  for (let entry of entries) {
    const listeners3 = entry.target.__resizeListeners__ || [];
    if (listeners3.length) {
      listeners3.forEach((fn2) => {
        fn2();
      });
    }
  }
};
const addResizeListener = function(element, fn2) {
  if (isServer)
    return;
  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = [];
    element.__ro__ = new index$c(resizeHandler);
    element.__ro__.observe(element);
  }
  element.__resizeListeners__.push(fn2);
};
const removeResizeListener = function(element, fn2) {
  if (!element || !element.__resizeListeners__)
    return;
  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn2), 1);
  if (!element.__resizeListeners__.length) {
    element.__ro__.disconnect();
  }
};
const doResize = (el, binding, vnode) => {
  const {
    componentInstance: $table
  } = vnode;
  const {
    value: value9
  } = binding;
  if (!$table.height) {
    throw new Error(`el-$table must set the height. Such as height='100px'`);
  }
  const bottomOffset = value9 && value9.bottomOffset || 30;
  if (!$table)
    return;
  let height = window.innerHeight - el.getBoundingClientRect().top - bottomOffset;
  if (height > 200) {
    $table.layout.setHeight(height);
    $table.doLayout();
  }
};
var adaptive = {
  bind(el, binding, vnode) {
    el.resizeListener = () => {
      doResize(el, binding, vnode);
    };
    addResizeListener(window.document.body, el.resizeListener);
  },
  inserted(el, binding, vnode) {
    setTimeout(() => {
      doResize(el, binding, vnode);
    }, 20);
  },
  update(el, binding, vnode) {
    const {
      value: value9
    } = binding;
    if (value9.updateToFix && value9.updateToFix > 0) {
      setTimeout(() => {
        doResize(el, binding, vnode);
      }, value9.updateToFix);
    }
  },
  unbind(el) {
    removeResizeListener(window.document.body, el.resizeListener);
  }
};
const install = function(Vue2) {
  Vue2.directive("el-height-adaptive-table", adaptive);
};
if (window.Vue) {
  window["el-height-adaptive-table"] = adaptive;
  Vue.use(install);
}
adaptive.install = install;
OpTable.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpTable.name, prefix);
  Vue2.component(comName, OpTable);
  Vue2.use(adaptive);
};
var __glob_6_27 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpTable
});
OpTableHeaderConfig.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpTableHeaderConfig.name, prefix);
  Vue2.component(comName, OpTableHeaderConfig);
};
var __glob_6_28 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpTableHeaderConfig
});
const elTransition = "0.3s height ease-in-out, 0.3s padding-top ease-in-out, 0.3s padding-bottom ease-in-out";
const Transition = {
  "before-enter"(el) {
    el.style.transition = elTransition;
    if (!el.dataset)
      el.dataset = {};
    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
  },
  enter(el) {
    el.dataset.oldOverflow = el.style.overflow;
    if (el.scrollHeight !== 0) {
      el.style.height = el.scrollHeight + "px";
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    } else {
      el.style.height = "";
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    }
    el.style.overflow = "hidden";
  },
  "after-enter"(el) {
    el.style.transition = "";
    el.style.height = "";
    el.style.overflow = el.dataset.oldOverflow;
  },
  "before-leave"(el) {
    if (!el.dataset)
      el.dataset = {};
    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;
    el.dataset.oldOverflow = el.style.overflow;
    el.style.height = el.scrollHeight + "px";
    el.style.overflow = "hidden";
  },
  leave(el) {
    if (el.scrollHeight !== 0) {
      el.style.transition = elTransition;
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
    }
  },
  "after-leave"(el) {
    el.style.transition = "";
    el.style.height = "";
    el.style.overflow = el.dataset.oldOverflow;
    el.style.paddingTop = el.dataset.oldPaddingTop;
    el.style.paddingBottom = el.dataset.oldPaddingBottom;
  }
};
var TransitionWrap = {
  name: "collapseTransition",
  functional: true,
  render(h, {
    children: children3
  }) {
    const data22 = {
      on: Transition
    };
    return h("transition", data22, children3);
  }
};
var render$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("TransitionWrap", [_vm.display ? _c("div", {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._t("default"), _c("svg-icon", {
    staticClass: "up-icon",
    attrs: {
      "icon-class": "transition-up"
    },
    on: {
      "click": function($event) {
        _vm.display = false;
      }
    }
  })], 2) : _vm._e()]);
};
var staticRenderFns$f = [];
render$f._withStripped = true;
var wrap_vue_vue_type_style_index_0_lang = "";
const __vue2_script$f = {
  name: "TranstitionWrap",
  components: {
    TransitionWrap
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    display: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    }
  }
};
const __cssModules$f = {};
var __component__$f = /* @__PURE__ */ normalizeComponent(__vue2_script$f, render$f, staticRenderFns$f, false, __vue2_injectStyles$f, null, null, null);
function __vue2_injectStyles$f(context2) {
  for (let o in __cssModules$f) {
    this[o] = __cssModules$f[o];
  }
}
__component__$f.options.__file = "packages/op-transition-wrap/src/wrap.vue";
var OpTransitionWrap = /* @__PURE__ */ function() {
  return __component__$f.exports;
}();
var render$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("el-row", [_c("el-col", {
    attrs: {
      "span": _vm.advance ? 22 : 24
    }
  }, [_c("el-row", {
    attrs: {
      "gutter": 10
    }
  }, [_vm._t("simple"), _vm._t("topControl")], 2)], 1), _vm.advance ? _c("el-col", {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 2
    }
  }, [_c("el-button", {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showAdvance = !_vm.showAdvance;
      }
    }
  }, [_vm._v(_vm._s(_vm.showAdvance ? "\u6536\u8D77\u9AD8\u7EA7\u641C\u7D22" : "\u5C55\u5F00\u9AD8\u7EA7\u641C\u7D22"))])], 1) : _vm._e()], 1), _vm.advance ? _c("TransitionWrap", {
    model: {
      value: _vm.showAdvance,
      callback: function($$v) {
        _vm.showAdvance = $$v;
      },
      expression: "showAdvance"
    }
  }, [_vm._t("advance")], 2) : _vm._e(), _c("el-row", {
    staticStyle: {
      "margin-bottom": "8px",
      "text-align": "right",
      "padding-right": "4px"
    },
    attrs: {
      "gutter": 10
    }
  }, [_vm._t("control")], 2)], 1);
};
var staticRenderFns$e = [];
render$e._withStripped = true;
const __vue2_script$e = {
  name: "OpTableSearch",
  components: {
    TransitionWrap: OpTransitionWrap
  },
  props: {},
  data() {
    return {
      showAdvance: false,
      advance: false
    };
  },
  watch: {
    showAdvance(val) {
      this.$emit("advance", val);
      this.updateSibingTable();
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$slots.advance && this.$slots.advance.length > 0) {
        this.advance = true;
      }
    });
  },
  methods: {
    updateSibingTable() {
      const $opTable = this.$parent.$children.find((vnode) => vnode.$vnode.tag.indexOf("OpTable") > -1);
      if ($opTable) {
        $opTable.$forceUpdate();
      }
    }
  }
};
const __cssModules$e = {};
var __component__$e = /* @__PURE__ */ normalizeComponent(__vue2_script$e, render$e, staticRenderFns$e, false, __vue2_injectStyles$e, null, null, null);
function __vue2_injectStyles$e(context2) {
  for (let o in __cssModules$e) {
    this[o] = __cssModules$e[o];
  }
}
__component__$e.options.__file = "packages/op-table/src/Search.vue";
var OpTableSearch = /* @__PURE__ */ function() {
  return __component__$e.exports;
}();
OpTableSearch.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpTableSearch.name, prefix);
  Vue2.component(comName, OpTableSearch);
};
var __glob_6_29 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpTableSearch
});
var render$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-tag-select"
  }, [_c("el-row", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_vm.$slots.default ? _c("el-col", {
    attrs: {
      "span": 24
    }
  }, [_vm._t("default")], 2) : _vm._e(), _c("el-col", {
    staticClass: "tag",
    attrs: {
      "span": 24
    }
  }, [_c("el-card", {
    staticClass: "box-card"
  }, [_c("div", {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("\u5DF2\u6709\u6807\u7B7E\uFF1A")])]), _c("div", _vm._l(_vm.hasSelectList, function(item, index2) {
    return _c("el-tag", {
      key: index2,
      attrs: {
        "type": "primary",
        "size": "medium",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleTagClose(item, index2);
        }
      }
    }, [_c("span", [_vm._v(_vm._s(item.value))]), _c("span", {
      staticStyle: {
        "color": "#ababab"
      }
    }, [_vm._v("\uFF08" + _vm._s(item.tagName) + "\uFF09")])]);
  }), 1)])], 1), _c("el-col", {
    staticClass: "tag",
    attrs: {
      "span": 24
    }
  }, [_c("el-card", {
    staticClass: "box-card"
  }, [_c("div", {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("\u65B0\u589E\u6807\u7B7E\uFF1A")])]), _c("div", _vm._l(_vm.selectList, function(item, index2) {
    return _c("el-tag", {
      key: index2,
      attrs: {
        "type": "success",
        "size": "medium",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleAddClose(item, index2);
        }
      }
    }, [_c("span", [_vm._v(_vm._s(item.valueName))]), _c("span", {
      staticStyle: {
        "color": "#ababab"
      }
    }, [_vm._v("\uFF08" + _vm._s(item.tagName) + "\uFF09")])]);
  }), 1)])], 1), _c("el-form", {
    ref: "form",
    attrs: {
      "model": _vm.searchObj,
      "label-width": "100px"
    }
  }, [_c("el-col", {
    staticClass: "search",
    attrs: {
      "span": 10
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u9002\u7528\u7CFB\u7EDF"
    }
  }, [_c("el-select", {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "\u8BF7\u9009\u62E9",
      "size": "mini",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.searchObj.appCode,
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "appCode", $$v);
      },
      expression: "searchObj.appCode"
    }
  }, _vm._l(_vm.applicableSystemList, function(item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        "label": item.appName,
        "value": item.appCode
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    staticClass: "search",
    attrs: {
      "span": 10
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u6807\u7B7E\u540D\u79F0"
    }
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: _vm.searchObj.name,
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "name", $$v);
      },
      expression: "searchObj.name"
    }
  })], 1)], 1), _c("el-col", {
    staticClass: "search",
    attrs: {
      "span": 10
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u6807\u7B7E\u503C\u540D\u79F0"
    }
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: _vm.searchObj.value,
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "value", $$v);
      },
      expression: "searchObj.value"
    }
  })], 1)], 1), _c("el-col", {
    staticClass: "search",
    attrs: {
      "span": 10
    }
  }, [_c("el-form-item", {
    attrs: {
      "label": "\u6807\u7B7E\u503C\u7F16\u7801"
    }
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: _vm.searchObj.valueCode,
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "valueCode", $$v);
      },
      expression: "searchObj.valueCode"
    }
  })], 1)], 1), _c("el-col", {
    staticClass: "search",
    attrs: {
      "span": 10
    }
  }, [_c("el-button", {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\u641C\u7D22")])], 1)], 1), _c("el-col", {
    attrs: {
      "span": 24
    }
  }, [_c("el-row", [_c("div", {
    staticClass: "tag-list"
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "label-width": "120px"
    }
  }, _vm._l(_vm.listData, function(item, index2) {
    return _c("el-col", {
      key: index2,
      staticClass: "search",
      attrs: {
        "span": 24
      }
    }, [item.inputType === "MULTIPLE" ? [_c("el-form-item", {
      attrs: {
        "label": item.name + "\uFF1A"
      }
    }, [_c("el-checkbox-group", {
      on: {
        "change": function($event) {
          return _vm.checkChange(_vm.form[item.code], item.code);
        }
      },
      model: {
        value: _vm.form[item.code],
        callback: function($$v) {
          _vm.$set(_vm.form, item.code, $$v);
        },
        expression: "form[item.code]"
      }
    }, _vm._l(item.tagValues, function(it, idx) {
      return _c("el-checkbox", {
        key: idx,
        attrs: {
          "label": it.valueCode
        }
      }, [_vm._v(" " + _vm._s(it.value) + " ")]);
    }), 1), _vm.filterShowMore(item.code) ? _c("span", {
      staticClass: "more",
      on: {
        "click": function($event) {
          return _vm.batchTagPageQuery(item.code);
        }
      }
    }, [_vm._v("\u66F4\u591A...")]) : _vm._e()], 1)] : [_c("el-form-item", {
      attrs: {
        "label": item.name + "\uFF1A"
      }
    }, [_c("el-radio-group", {
      on: {
        "change": function($event) {
          return _vm.radioChange(_vm.form[item.code][0], item.code);
        }
      },
      model: {
        value: _vm.form[item.code][0],
        callback: function($$v) {
          _vm.$set(_vm.form[item.code], 0, $$v);
        },
        expression: "form[item.code][0]"
      }
    }, _vm._l(item.tagValues, function(it, idx) {
      return _c("el-radio", {
        key: idx,
        attrs: {
          "label": it.valueCode
        }
      }, [_vm._v(" " + _vm._s(it.value) + " ")]);
    }), 1), _vm.filterShowMore(item.code) ? _c("span", {
      staticClass: "more",
      on: {
        "click": function($event) {
          return _vm.batchTagPageQuery(item.code);
        }
      }
    }, [_vm._v("\u66F4\u591A...")]) : _vm._e()], 1)]], 2);
  }), 1), _c("el-col", {
    attrs: {
      "span": 24
    }
  }, [_vm.pages > _vm.searchObj.pageNo ? _c("div", {
    staticClass: "more op-padding-bottom-20",
    on: {
      "click": function($event) {
        return _vm.more();
      }
    }
  }, [_vm._v("\u52A0\u8F7D\u66F4\u591A")]) : _vm._e()])], 1)])], 1)], 1)], 1);
};
var staticRenderFns$d = [];
render$d._withStripped = true;
var index_vue_vue_type_style_index_0_lang = "";
const __vue2_script$d = {
  name: "OpTagSelect",
  props: {
    appCode: {
      type: String
    },
    subAppCode: {
      type: String
    },
    businessType: {
      type: String,
      required: true
    },
    batchTag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      businessIds: [],
      defaultValue: {},
      loading: false,
      form: {},
      formCopy: {},
      listData: [],
      hasSelectList: [],
      deletedList: [],
      selectList: [],
      applicableSystemList: [],
      pages: 1,
      valueLimit: 20,
      formConfig: {},
      searchObj: {
        appCode: null,
        name: "",
        value: "",
        valueCode: "",
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  mounted() {
    this.getApplicableSystemList();
  },
  methods: {
    filterShowMore(tagCode) {
      return this.formConfig[tagCode] && this.formConfig[tagCode].isSearch;
    },
    async init(businessOrTagList = []) {
      this.selectList = [];
      this.deletedList = [];
      this.hasSelectList = businessOrTagList.filter((item) => typeof item === "object" && !Array.isArray(item));
      this.searchObj.appCode = this.appCode ? this.appCode : null;
      this.businessIds = businessOrTagList.filter((item) => typeof item === "string");
      if (this.businessIds.length > 0) {
        await this.querySelectedTagSetData();
      }
      await this.search();
    },
    async search() {
      this.searchObj.pageNo = 1;
      this.formCopy = {};
      this.formConfig = {};
      this.listData = [];
      this.pages = 1;
      await this.pageTagConfigQueryData();
    },
    more() {
      this.searchObj.pageNo += 1;
      this.pageTagConfigQueryData();
    },
    async pageTagConfigQueryData() {
      this.loading = true;
      let params = __spreadValues({
        applicableBusinessType: this.businessType,
        valueLimit: this.valueLimit
      }, this.searchObj);
      const res = await pageTagConfigQuery(params);
      if (res.status) {
        this.loading = false;
        if (this.searchObj.pageNo === 1) {
          this.listData = [];
          this.form = {};
        }
        this.$set(this.$data, "pages", Number(res.data.pages));
        res.data.records.forEach((item) => {
          this.$set(this.form, item.code, []);
          this.$set(this.formConfig, item.code, {
            isSearch: item.tagValues.length === this.valueLimit,
            pageNo: 1,
            pageSize: this.valueLimit
          });
          this.hasSelectList.forEach((it) => {
            if (it.tagCode === item.code) {
              this.form[item.code].push(it.valueCode);
            }
          });
          this.listData.push(item);
        });
        this.formCopy = deepClone(this.form);
      }
    },
    async batchTagPageQuery(tagCode) {
      let _this = this;
      this.loading = true;
      this.formConfig[tagCode].pageNo += 1;
      let params = {
        tagCode,
        pageNo: this.formConfig[tagCode].pageNo,
        pageSize: this.formConfig[tagCode].pageSize
      };
      await batchTagPage(params).then((res) => {
        if (res.data) {
          _this.listData.forEach((item) => {
            if (item.code === tagCode) {
              if (res.data.records.length > 0) {
                item.tagValues.push(...res.data.records);
              }
              if (this.formConfig[tagCode].pageSize === res.data.records.length) {
                this.formConfig[tagCode].isSearch = true;
              } else {
                this.formConfig[tagCode].isSearch = false;
              }
            }
          });
          this.loading = false;
        }
      });
    },
    async querySelectedTagSetData() {
      const {
        businessType
      } = this.$props;
      const {
        businessIds
      } = this.$data;
      const {
        status,
        data: data22
      } = await querySelectedTagSet({
        businessType,
        businessIds
      });
      status && this.hasSelectList.push(...this.duplicateRemovalArr(data22));
    },
    duplicateRemovalArr(arr) {
      if (!arr || !arr.length) {
        return [];
      }
      let newObj = {};
      return arr.reduce((accumulator, list) => {
        if (!newObj[list.tagCode + "-" + list.valueCode]) {
          newObj[list.tagCode + "-" + list.valueCode] = true;
          accumulator.push(list);
        }
        return accumulator;
      }, []);
    },
    getApplicableSystemList() {
      getApplicableSystem().then((res) => {
        if (res.status) {
          this.applicableSystemList = res.data;
        }
      }).catch((e) => {
        /* @__PURE__ */ console.log(e);
      });
    },
    checkChange(value9, code) {
      Object.keys(this.formCopy).forEach((key2) => {
        if (code === key2) {
          if (value9.length > this.formCopy[key2].length) {
            let selected = {};
            this.listData.map((item) => {
              if (item.code === key2) {
                item.tagValues.map((it) => {
                  if (it.valueCode === value9[value9.length - 1]) {
                    selected = {
                      tagName: item.name,
                      tagCode: item.code,
                      tagId: item.id,
                      valueName: it.value,
                      valueCode: it.valueCode,
                      valueId: it.id
                    };
                    this.selectList.push(selected);
                  }
                });
              }
            });
          } else {
            this.formCopy[key2].map((item) => {
              if (!value9.some((it) => it === item)) {
                let index2 = this.selectList.findIndex((el) => {
                  return el.tagCode === code && el.valueCode === item;
                });
                index2 >= 0 && this.selectList.splice(index2, 1);
                index2 = this.hasSelectList.findIndex((el) => {
                  return el.tagCode === code && el.valueCode === item;
                });
                index2 >= 0 && this.deletedList.push(...this.hasSelectList.splice(index2, 1));
              }
            });
          }
        }
      });
      this.formCopy = deepClone(this.form);
    },
    radioChange(value9, code) {
      Object.keys(this.formCopy).forEach((key2) => {
        if (code === key2) {
          if (value9) {
            let selected = {};
            let index2 = this.selectList.findIndex((el) => {
              return el.tagCode === code;
            });
            if (index2 !== -1) {
              this.selectList.splice(index2, 1);
            }
            index2 = this.hasSelectList.findIndex((el) => {
              return el.tagCode === code;
            });
            index2 >= 0 && this.deletedList.push(...this.hasSelectList.splice(index2, 1));
            this.listData.map((item) => {
              if (item.code === key2) {
                item.tagValues.map((it) => {
                  if (it.valueCode === value9) {
                    selected = {
                      tagName: item.name,
                      tagCode: item.code,
                      tagId: item.id,
                      valueName: it.value,
                      valueCode: it.valueCode,
                      valueId: it.id
                    };
                    this.selectList.push(selected);
                  }
                });
              }
            });
          }
        }
      });
      this.formCopy = deepClone(this.form);
    },
    handleAddClose(item, index2) {
      this.selectList.splice(index2, 1);
      Object.keys(this.form).forEach((key2) => {
        if (item.tagCode === key2) {
          if (Array.isArray(this.form[key2])) {
            this.form[key2].splice(this.form[key2].indexOf(item.valueCode), 1);
          } else {
            this.form[key2] = "";
          }
        }
      });
      this.formCopy = deepClone(this.form);
    },
    handleTagClose(item, index2) {
      this.deletedList.push(...this.hasSelectList.splice(index2, 1));
      Object.keys(this.form).forEach((key2) => {
        if (item.tagCode === key2) {
          if (Array.isArray(this.form[key2])) {
            this.form[key2].splice(this.form[key2].indexOf(item.valueCode), 1);
          } else {
            this.form[key2] = "";
          }
        }
      });
      this.formCopy = deepClone(this.form);
    },
    setModel() {
      let selectList = [];
      this.selectList.forEach((item) => {
        let index2 = 0;
        if (selectList.some((i, idx) => {
          if (i.tagCode === item.tagCode) {
            index2 = idx;
            return true;
          }
          return false;
        })) {
          selectList[index2].tagValues.push({
            valueName: item.valueName,
            valueCode: item.valueCode,
            valueId: item.valueId
          });
        } else {
          selectList.push({
            tagName: item.tagName,
            tagCode: item.tagCode,
            tagId: item.tagId,
            tagValues: [{
              valueName: item.valueName,
              valueCode: item.valueCode,
              valueId: item.valueId
            }]
          });
        }
      });
      this.defaultValue = Object.assign(this.value, {
        selectList
      });
      this.$emit("input", deepClone(this.defaultValue));
    },
    save() {
      if (this.batchTag)
        return new Promise((resolve, reject) => {
          const {
            appCode,
            subAppCode,
            businessType
          } = this.$props;
          const {
            businessIds
          } = this.$data;
          batchTagging({
            appCode,
            subAppCode,
            businessType,
            businessIds,
            deletedTagSets: this.deletedList.map(({
              tagCode,
              valueCode
            }) => ({
              tagCode,
              valueCode
            })),
            newAddTagSets: this.selectList.map(({
              tagCode,
              tagName,
              valueCode,
              valueName
            }) => ({
              tagCode,
              tagName,
              valueCode,
              valueName
            }))
          }).then(({
            status,
            message: message2
          }) => {
            if (status) {
              resolve(businessIds);
              this.deletedList = [];
            } else {
              reject({
                message: message2
              });
            }
          }).catch((reason) => reject(reason));
        });
      const deletedTagSets = this.deletedList.map(({
        tagId,
        tagCode,
        tagName,
        value: value9,
        valueCode,
        businessId
      }) => ({
        tagId,
        tagCode,
        tagName,
        value: value9,
        valueCode,
        businessId
      }));
      this.deletedList = [];
      return {
        hasSelectedTagSets: this.hasSelectList,
        deletedTagSets,
        newAddTagSets: this.selectList.map((_a) => {
          var _b = _a, {
            valueName: value9
          } = _b, rest = __objRest(_b, [
            "valueName"
          ]);
          return Object.assign(rest, {
            value: value9
          });
        })
      };
    }
  }
};
const __cssModules$d = {};
var __component__$d = /* @__PURE__ */ normalizeComponent(__vue2_script$d, render$d, staticRenderFns$d, false, __vue2_injectStyles$d, null, null, null);
function __vue2_injectStyles$d(context2) {
  for (let o in __cssModules$d) {
    this[o] = __cssModules$d[o];
  }
}
__component__$d.options.__file = "packages/op-tag-select/src/index.vue";
var TagSelect = /* @__PURE__ */ function() {
  return __component__$d.exports;
}();
TagSelect.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(TagSelect.name, prefix);
  Vue2.component(comName, TagSelect);
};
var __glob_6_30 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": TagSelect
});
OpTransitionWrap.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpTransitionWrap.name, prefix);
  Vue2.component(comName, OpTransitionWrap);
};
var __glob_6_31 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpTransitionWrap
});
var render$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "skill-select"
  }, [_vm.isCheckAll ? _c("el-checkbox", {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: _vm.checkAll,
      callback: function($$v) {
        _vm.checkAll = $$v;
      },
      expression: "checkAll"
    }
  }, [_vm._v(_vm._s(_vm.checkAllText))]) : _vm._e(), _c("el-checkbox-group", {
    staticStyle: {
      "margin": "10px 0"
    },
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: _vm.selectedList,
      callback: function($$v) {
        _vm.selectedList = $$v;
      },
      expression: "selectedList"
    }
  }, [_c("el-row", _vm._l(_vm.flatData, function(item, index2) {
    return _c("el-col", {
      key: index2,
      staticStyle: {
        "margin": "5px 0"
      },
      attrs: {
        "span": 8
      }
    }, [_c("el-checkbox", {
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.brandName) + "-" + _vm._s(item.categoryName))])], 1);
  }), 1)], 1)], 1);
};
var staticRenderFns$c = [];
render$c._withStripped = true;
var BrandCategorySelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$c = defineComponent({
  props: {
    value: {
      type: Array,
      default: () => []
    },
    isCheckAll: {
      type: Boolean,
      default: false
    },
    checkAllText: {
      type: String,
      default: "\u5168\u90E8"
    },
    allSkillsList: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const {
      flatData,
      getBrandCategory
    } = getBrandCategoryData();
    getBrandCategory();
    const isIndeterminate = ref(false);
    const checkAll = ref(false);
    const selectedList = computed({
      get: () => {
        return flatData.value.filter((x) => props2.value.some((item) => item.brandCode === x.brandCode && item.categoryCode === x.categoryCode));
      },
      set: (val) => {
        emit2("input", val);
      }
    });
    function handleCheckAllChange(val) {
      selectedList.value = val ? props2.allSkillsList : [];
      isIndeterminate.value = false;
    }
    function handleCheckedChange(value9) {
      if (!props2.isCheckAll)
        return;
      let checkedCount = value9.length;
      checkAll.value = checkedCount === props2.allSkillsList.length;
      isIndeterminate.value = checkedCount > 0 && checkedCount < props2.allSkillsList.length;
    }
    return {
      flatData,
      isIndeterminate,
      checkAll,
      selectedList,
      handleCheckAllChange,
      handleCheckedChange
    };
  }
});
const __cssModules$c = {};
var __component__$c = /* @__PURE__ */ normalizeComponent(__vue2_script$c, render$c, staticRenderFns$c, false, __vue2_injectStyles$c, "f63db74a", null, null);
function __vue2_injectStyles$c(context2) {
  for (let o in __cssModules$c) {
    this[o] = __cssModules$c[o];
  }
}
__component__$c.options.__file = "packages/op-uc-all-selector/src/pc/component/BrandCategorySelect.vue";
var BrandCategorySelect = /* @__PURE__ */ function() {
  return __component__$c.exports;
}();
var render$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "op-orgs-tree"
  }, [_c("base-tree", {
    ref: "departmentTree",
    staticClass: "org-tree",
    attrs: {
      "load": _vm.loadOrgTree,
      "data": _vm.orgs,
      "default-expand-all": false,
      "highlight-current": true,
      "support-filter": true,
      "show-checkbox": true,
      "check-strictly": true,
      "props": {
        children: "children",
        label: "name",
        isLeaf: "leaf"
      },
      "node-key": _vm.nodeKey,
      "default-expanded-keys": ["-1"],
      "accordion": ""
    },
    on: {
      "check": _vm.handleCheck
    }
  })], 1);
};
var staticRenderFns$b = [];
render$b._withStripped = true;
const __vue2_script$b = defineComponent({
  components: {
    BaseTree
  },
  props: {
    nodeKey: {
      type: String,
      default: "id"
    },
    selectList: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const {
      orgs,
      loadOrgTree
    } = useOrgsTree();
    const departmentTree = ref(null);
    function initCheck(data22) {
      if (!data22.id) {
        data22.id = data22.deptId;
      }
      departmentTree.value.elTreeRef().setCheckedNodes(data22);
    }
    onMounted(async () => {
      await loadOrgTree();
      initCheck(props2.selectList);
    });
    watch(() => props2.selectList, (newVal) => {
      initCheck(newVal);
    });
    function handleCheck(checkNode, checkInfo) {
      const {
        checkedKeys,
        checkedNodes
      } = checkInfo;
      const {
        id
      } = checkNode;
      if (checkedKeys.includes(id)) {
        recursionChildren(checkNode, checkedKeys, checkedNodes);
        recursionParent(checkNode, checkedKeys, checkedNodes);
      }
      const _checkedNodes = JSON.parse(JSON.stringify(checkedNodes));
      for (let node2 of _checkedNodes) {
        delete node2.children;
      }
      emit2("update:selectList", _checkedNodes);
    }
    function recursionChildren(checkNode, checkedKeys, checkedNodes) {
      if (checkNode.children && checkNode.children.length) {
        checkNode.children.forEach((child) => {
          const {
            id
          } = child;
          const index2 = checkedKeys.indexOf(id);
          if (index2 > -1) {
            checkedKeys.splice(index2, 1);
            checkedNodes.splice(index2, 1);
          }
          recursionChildren(child, checkedKeys, checkedNodes);
        });
      }
    }
    function recursionParent(checkNode, checkedKeys, checkedNodes) {
      const {
        superiorId
      } = checkNode;
      const _nodes = departmentTree.value.elTreeRef().getNode(superiorId);
      if (_nodes && _nodes.data) {
        const parentNode = _nodes.data;
        const childrenIds = recursionChildrenIds(parentNode);
        const isAllChecked = childrenIds.every((childId) => checkedKeys.includes(childId));
        const hasParentKeys = checkedKeys.indexOf(superiorId);
        if (isAllChecked && hasParentKeys === -1) {
          checkedKeys.push(superiorId);
          checkedNodes.push(parentNode);
          recursionChildren(parentNode, checkedKeys, checkedNodes);
        } else if (!isAllChecked && hasParentKeys > -1) {
          checkedKeys.splice(hasParentKeys, 1);
          checkedNodes.splice(hasParentKeys, 1);
        }
        recursionParent(parentNode, checkedKeys, checkedNodes);
      }
    }
    function recursionChildrenIds(node2) {
      const childrenIds = [];
      if (node2.children && node2.children.length) {
        node2.children.forEach((child) => {
          childrenIds.push(child.id);
          childrenIds.push(...recursionChildrenIds(child));
        });
      }
      return childrenIds;
    }
    return {
      departmentTree,
      orgs,
      loadOrgTree,
      handleCheck
    };
  }
});
const __cssModules$b = {};
var __component__$b = /* @__PURE__ */ normalizeComponent(__vue2_script$b, render$b, staticRenderFns$b, false, __vue2_injectStyles$b, null, null, null);
function __vue2_injectStyles$b(context2) {
  for (let o in __cssModules$b) {
    this[o] = __cssModules$b[o];
  }
}
__component__$b.options.__file = "packages/op-uc-all-selector/src/pc/component/DepartmentTreeSelect.vue";
var DepartmentTreeSelect = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
var messageBox$1 = "";
var messageBox = { exports: {} };
var input = { exports: {} };
var migrating = {};
migrating.__esModule = true;
var _util$1 = util;
migrating.default = {
  mounted: function mounted8() {
    if (!this.$vnode)
      return;
    var _getMigratingConfig = this.getMigratingConfig(), _getMigratingConfig$p = _getMigratingConfig.props, props2 = _getMigratingConfig$p === void 0 ? {} : _getMigratingConfig$p, _getMigratingConfig$e = _getMigratingConfig.events, events2 = _getMigratingConfig$e === void 0 ? {} : _getMigratingConfig$e;
    var _$vnode = this.$vnode, data22 = _$vnode.data, componentOptions = _$vnode.componentOptions;
    var definedProps = data22.attrs || {};
    var definedEvents = componentOptions.listeners || {};
    for (var propName in definedProps) {
      propName = (0, _util$1.kebabCase)(propName);
      if (props2[propName]) {
        /* @__PURE__ */ console.warn("[Element Migrating][" + this.$options.name + "][Attribute]: " + props2[propName]);
      }
    }
    for (var eventName in definedEvents) {
      eventName = (0, _util$1.kebabCase)(eventName);
      if (events2[eventName]) {
        /* @__PURE__ */ console.warn("[Element Migrating][" + this.$options.name + "][Event]: " + events2[eventName]);
      }
    }
  },
  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {},
        events: {}
      };
    }
  }
};
var shared = {};
shared.__esModule = true;
shared.isDef = isDef;
shared.isKorean = isKorean;
function isDef(val) {
  return val !== void 0 && val !== null;
}
function isKorean(text) {
  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}
var emitter = {};
emitter.__esModule = true;
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function(child) {
    var name = child.$options.componentName;
    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
emitter.default = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast2(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
};
(function(module) {
  module.exports = function(modules) {
    var installedModules = {};
    function __webpack_require__(moduleId) {
      if (installedModules[moduleId]) {
        return installedModules[moduleId].exports;
      }
      var module2 = installedModules[moduleId] = {
        i: moduleId,
        l: false,
        exports: {}
      };
      modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
      module2.l = true;
      return module2.exports;
    }
    __webpack_require__.m = modules;
    __webpack_require__.c = installedModules;
    __webpack_require__.d = function(exports, name, getter) {
      if (!__webpack_require__.o(exports, name)) {
        Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
      }
    };
    __webpack_require__.r = function(exports) {
      if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module"
        });
      }
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
    };
    __webpack_require__.t = function(value9, mode) {
      if (mode & 1)
        value9 = __webpack_require__(value9);
      if (mode & 8)
        return value9;
      if (mode & 4 && typeof value9 === "object" && value9 && value9.__esModule)
        return value9;
      var ns = Object.create(null);
      __webpack_require__.r(ns);
      Object.defineProperty(ns, "default", {
        enumerable: true,
        value: value9
      });
      if (mode & 2 && typeof value9 != "string")
        for (var key2 in value9)
          __webpack_require__.d(ns, key2, function(key3) {
            return value9[key3];
          }.bind(null, key2));
      return ns;
    };
    __webpack_require__.n = function(module2) {
      var getter = module2 && module2.__esModule ? function getDefault() {
        return module2["default"];
      } : function getModuleExports() {
        return module2;
      };
      __webpack_require__.d(getter, "a", getter);
      return getter;
    };
    __webpack_require__.o = function(object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    __webpack_require__.p = "/dist/";
    return __webpack_require__(__webpack_require__.s = 73);
  }({
    0: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.d(__webpack_exports__, "a", function() {
        return normalizeComponent2;
      });
      function normalizeComponent2(scriptExports, render28, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
        var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
        if (render28) {
          options.render = render28;
          options.staticRenderFns = staticRenderFns2;
          options._compiled = true;
        }
        if (functionalTemplate) {
          options.functional = true;
        }
        if (scopeId) {
          options._scopeId = "data-v-" + scopeId;
        }
        var hook;
        if (moduleIdentifier) {
          hook = function(context2) {
            context2 = context2 || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
            if (!context2 && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
              context2 = __VUE_SSR_CONTEXT__;
            }
            if (injectStyles) {
              injectStyles.call(this, context2);
            }
            if (context2 && context2._registeredComponents) {
              context2._registeredComponents.add(moduleIdentifier);
            }
          };
          options._ssrRegister = hook;
        } else if (injectStyles) {
          hook = shadowMode ? function() {
            injectStyles.call(this, this.$root.$options.shadowRoot);
          } : injectStyles;
        }
        if (hook) {
          if (options.functional) {
            options._injectStyles = hook;
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context2) {
              hook.call(context2);
              return originalRender(h, context2);
            };
          } else {
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
        }
        return {
          exports: scriptExports,
          options
        };
      }
    },
    11: function(module2, exports) {
      module2.exports = migrating;
    },
    21: function(module2, exports) {
      module2.exports = shared;
    },
    4: function(module2, exports) {
      module2.exports = emitter;
    },
    73: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      var render28 = function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("div", {
          class: [_vm.type === "textarea" ? "el-textarea" : "el-input", _vm.inputSize ? "el-input--" + _vm.inputSize : "", {
            "is-disabled": _vm.inputDisabled,
            "is-exceed": _vm.inputExceed,
            "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
            "el-input-group--append": _vm.$slots.append,
            "el-input-group--prepend": _vm.$slots.prepend,
            "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
            "el-input--suffix": _vm.$slots.suffix || _vm.suffixIcon || _vm.clearable || _vm.showPassword
          }],
          on: {
            mouseenter: function($event) {
              _vm.hovering = true;
            },
            mouseleave: function($event) {
              _vm.hovering = false;
            }
          }
        }, [_vm.type !== "textarea" ? [_vm.$slots.prepend ? _c("div", {
          staticClass: "el-input-group__prepend"
        }, [_vm._t("prepend")], 2) : _vm._e(), _vm.type !== "textarea" ? _c("input", _vm._b({
          ref: "input",
          staticClass: "el-input__inner",
          attrs: {
            tabindex: _vm.tabindex,
            type: _vm.showPassword ? _vm.passwordVisible ? "text" : "password" : _vm.type,
            disabled: _vm.inputDisabled,
            readonly: _vm.readonly,
            autocomplete: _vm.autoComplete || _vm.autocomplete,
            "aria-label": _vm.label
          },
          on: {
            compositionstart: _vm.handleCompositionStart,
            compositionupdate: _vm.handleCompositionUpdate,
            compositionend: _vm.handleCompositionEnd,
            input: _vm.handleInput,
            focus: _vm.handleFocus,
            blur: _vm.handleBlur,
            change: _vm.handleChange
          }
        }, "input", _vm.$attrs, false)) : _vm._e(), _vm.$slots.prefix || _vm.prefixIcon ? _c("span", {
          staticClass: "el-input__prefix"
        }, [_vm._t("prefix"), _vm.prefixIcon ? _c("i", {
          staticClass: "el-input__icon",
          class: _vm.prefixIcon
        }) : _vm._e()], 2) : _vm._e(), _vm.getSuffixVisible() ? _c("span", {
          staticClass: "el-input__suffix"
        }, [_c("span", {
          staticClass: "el-input__suffix-inner"
        }, [!_vm.showClear || !_vm.showPwdVisible || !_vm.isWordLimitVisible ? [_vm._t("suffix"), _vm.suffixIcon ? _c("i", {
          staticClass: "el-input__icon",
          class: _vm.suffixIcon
        }) : _vm._e()] : _vm._e(), _vm.showClear ? _c("i", {
          staticClass: "el-input__icon el-icon-circle-close el-input__clear",
          on: {
            mousedown: function($event) {
              $event.preventDefault();
            },
            click: _vm.clear
          }
        }) : _vm._e(), _vm.showPwdVisible ? _c("i", {
          staticClass: "el-input__icon el-icon-view el-input__clear",
          on: {
            click: _vm.handlePasswordVisible
          }
        }) : _vm._e(), _vm.isWordLimitVisible ? _c("span", {
          staticClass: "el-input__count"
        }, [_c("span", {
          staticClass: "el-input__count-inner"
        }, [_vm._v("\n            " + _vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit) + "\n          ")])]) : _vm._e()], 2), _vm.validateState ? _c("i", {
          staticClass: "el-input__icon",
          class: ["el-input__validateIcon", _vm.validateIcon]
        }) : _vm._e()]) : _vm._e(), _vm.$slots.append ? _c("div", {
          staticClass: "el-input-group__append"
        }, [_vm._t("append")], 2) : _vm._e()] : _c("textarea", _vm._b({
          ref: "textarea",
          staticClass: "el-textarea__inner",
          style: _vm.textareaStyle,
          attrs: {
            tabindex: _vm.tabindex,
            disabled: _vm.inputDisabled,
            readonly: _vm.readonly,
            autocomplete: _vm.autoComplete || _vm.autocomplete,
            "aria-label": _vm.label
          },
          on: {
            compositionstart: _vm.handleCompositionStart,
            compositionupdate: _vm.handleCompositionUpdate,
            compositionend: _vm.handleCompositionEnd,
            input: _vm.handleInput,
            focus: _vm.handleFocus,
            blur: _vm.handleBlur,
            change: _vm.handleChange
          }
        }, "textarea", _vm.$attrs, false)), _vm.isWordLimitVisible && _vm.type === "textarea" ? _c("span", {
          staticClass: "el-input__count"
        }, [_vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))]) : _vm._e()], 2);
      };
      var staticRenderFns2 = [];
      render28._withStripped = true;
      var emitter_ = __webpack_require__(4);
      var emitter_default = /* @__PURE__ */ __webpack_require__.n(emitter_);
      var migrating_ = __webpack_require__(11);
      var migrating_default = /* @__PURE__ */ __webpack_require__.n(migrating_);
      var hiddenTextarea = void 0;
      var HIDDEN_STYLE = "\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
      var CONTEXT_STYLE = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing"];
      function calculateNodeStyling(targetElement) {
        var style6 = window.getComputedStyle(targetElement);
        var boxSizing = style6.getPropertyValue("box-sizing");
        var paddingSize = parseFloat(style6.getPropertyValue("padding-bottom")) + parseFloat(style6.getPropertyValue("padding-top"));
        var borderSize = parseFloat(style6.getPropertyValue("border-bottom-width")) + parseFloat(style6.getPropertyValue("border-top-width"));
        var contextStyle = CONTEXT_STYLE.map(function(name) {
          return name + ":" + style6.getPropertyValue(name);
        }).join(";");
        return {
          contextStyle,
          paddingSize,
          borderSize,
          boxSizing
        };
      }
      function calcTextareaHeight(targetElement) {
        var minRows = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        var maxRows = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        if (!hiddenTextarea) {
          hiddenTextarea = document.createElement("textarea");
          document.body.appendChild(hiddenTextarea);
        }
        var _calculateNodeStyling = calculateNodeStyling(targetElement), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, contextStyle = _calculateNodeStyling.contextStyle;
        hiddenTextarea.setAttribute("style", contextStyle + ";" + HIDDEN_STYLE);
        hiddenTextarea.value = targetElement.value || targetElement.placeholder || "";
        var height = hiddenTextarea.scrollHeight;
        var result = {};
        if (boxSizing === "border-box") {
          height = height + borderSize;
        } else if (boxSizing === "content-box") {
          height = height - paddingSize;
        }
        hiddenTextarea.value = "";
        var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
          var minHeight = singleRowHeight * minRows;
          if (boxSizing === "border-box") {
            minHeight = minHeight + paddingSize + borderSize;
          }
          height = Math.max(minHeight, height);
          result.minHeight = minHeight + "px";
        }
        if (maxRows !== null) {
          var maxHeight = singleRowHeight * maxRows;
          if (boxSizing === "border-box") {
            maxHeight = maxHeight + paddingSize + borderSize;
          }
          height = Math.min(maxHeight, height);
        }
        result.height = height + "px";
        hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
        hiddenTextarea = null;
        return result;
      }
      var merge_ = __webpack_require__(9);
      var merge_default = /* @__PURE__ */ __webpack_require__.n(merge_);
      var shared_ = __webpack_require__(21);
      var inputvue_type_script_lang_js_ = {
        name: "ElInput",
        componentName: "ElInput",
        mixins: [emitter_default.a, migrating_default.a],
        inheritAttrs: false,
        inject: {
          elForm: {
            default: ""
          },
          elFormItem: {
            default: ""
          }
        },
        data: function data22() {
          return {
            textareaCalcStyle: {},
            hovering: false,
            focused: false,
            isComposing: false,
            passwordVisible: false
          };
        },
        props: {
          value: [String, Number],
          size: String,
          resize: String,
          form: String,
          disabled: Boolean,
          readonly: Boolean,
          type: {
            type: String,
            default: "text"
          },
          autosize: {
            type: [Boolean, Object],
            default: false
          },
          autocomplete: {
            type: String,
            default: "off"
          },
          autoComplete: {
            type: String,
            validator: function validator(val) {
              return true;
            }
          },
          validateEvent: {
            type: Boolean,
            default: true
          },
          suffixIcon: String,
          prefixIcon: String,
          label: String,
          clearable: {
            type: Boolean,
            default: false
          },
          showPassword: {
            type: Boolean,
            default: false
          },
          showWordLimit: {
            type: Boolean,
            default: false
          },
          tabindex: String
        },
        computed: {
          _elFormItemSize: function _elFormItemSize() {
            return (this.elFormItem || {}).elFormItemSize;
          },
          validateState: function validateState() {
            return this.elFormItem ? this.elFormItem.validateState : "";
          },
          needStatusIcon: function needStatusIcon() {
            return this.elForm ? this.elForm.statusIcon : false;
          },
          validateIcon: function validateIcon() {
            return {
              validating: "el-icon-loading",
              success: "el-icon-circle-check",
              error: "el-icon-circle-close"
            }[this.validateState];
          },
          textareaStyle: function textareaStyle() {
            return merge_default()({}, this.textareaCalcStyle, {
              resize: this.resize
            });
          },
          inputSize: function inputSize() {
            return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          },
          inputDisabled: function inputDisabled() {
            return this.disabled || (this.elForm || {}).disabled;
          },
          nativeInputValue: function nativeInputValue() {
            return this.value === null || this.value === void 0 ? "" : String(this.value);
          },
          showClear: function showClear2() {
            return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
          },
          showPwdVisible: function showPwdVisible() {
            return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
          },
          isWordLimitVisible: function isWordLimitVisible() {
            return this.showWordLimit && this.$attrs.maxlength && (this.type === "text" || this.type === "textarea") && !this.inputDisabled && !this.readonly && !this.showPassword;
          },
          upperLimit: function upperLimit() {
            return this.$attrs.maxlength;
          },
          textLength: function textLength() {
            if (typeof this.value === "number") {
              return String(this.value).length;
            }
            return (this.value || "").length;
          },
          inputExceed: function inputExceed() {
            return this.isWordLimitVisible && this.textLength > this.upperLimit;
          }
        },
        watch: {
          value: function value9(val) {
            this.$nextTick(this.resizeTextarea);
            if (this.validateEvent) {
              this.dispatch("ElFormItem", "el.form.change", [val]);
            }
          },
          nativeInputValue: function nativeInputValue() {
            this.setNativeInputValue();
          },
          type: function type() {
            var _this = this;
            this.$nextTick(function() {
              _this.setNativeInputValue();
              _this.resizeTextarea();
              _this.updateIconOffset();
            });
          }
        },
        methods: {
          focus: function focus2() {
            this.getInput().focus();
          },
          blur: function blur2() {
            this.getInput().blur();
          },
          getMigratingConfig: function getMigratingConfig2() {
            return {
              props: {
                "icon": "icon is removed, use suffix-icon / prefix-icon instead.",
                "on-icon-click": "on-icon-click is removed."
              },
              events: {
                "click": "click is removed."
              }
            };
          },
          handleBlur: function handleBlur(event) {
            this.focused = false;
            this.$emit("blur", event);
            if (this.validateEvent) {
              this.dispatch("ElFormItem", "el.form.blur", [this.value]);
            }
          },
          select: function select() {
            this.getInput().select();
          },
          resizeTextarea: function resizeTextarea() {
            if (this.$isServer)
              return;
            var autosize = this.autosize, type = this.type;
            if (type !== "textarea")
              return;
            if (!autosize) {
              this.textareaCalcStyle = {
                minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
              };
              return;
            }
            var minRows = autosize.minRows;
            var maxRows = autosize.maxRows;
            this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
          },
          setNativeInputValue: function setNativeInputValue() {
            var input3 = this.getInput();
            if (!input3)
              return;
            if (input3.value === this.nativeInputValue)
              return;
            input3.value = this.nativeInputValue;
          },
          handleFocus: function handleFocus(event) {
            this.focused = true;
            this.$emit("focus", event);
          },
          handleCompositionStart: function handleCompositionStart() {
            this.isComposing = true;
          },
          handleCompositionUpdate: function handleCompositionUpdate(event) {
            var text = event.target.value;
            var lastCharacter = text[text.length - 1] || "";
            this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
          },
          handleCompositionEnd: function handleCompositionEnd(event) {
            if (this.isComposing) {
              this.isComposing = false;
              this.handleInput(event);
            }
          },
          handleInput: function handleInput(event) {
            if (this.isComposing)
              return;
            if (event.target.value === this.nativeInputValue)
              return;
            this.$emit("input", event.target.value);
            this.$nextTick(this.setNativeInputValue);
          },
          handleChange: function handleChange(event) {
            this.$emit("change", event.target.value);
          },
          calcIconOffset: function calcIconOffset(place) {
            var elList = [].slice.call(this.$el.querySelectorAll(".el-input__" + place) || []);
            if (!elList.length)
              return;
            var el = null;
            for (var i = 0; i < elList.length; i++) {
              if (elList[i].parentNode === this.$el) {
                el = elList[i];
                break;
              }
            }
            if (!el)
              return;
            var pendantMap = {
              suffix: "append",
              prefix: "prepend"
            };
            var pendant = pendantMap[place];
            if (this.$slots[pendant]) {
              el.style.transform = "translateX(" + (place === "suffix" ? "-" : "") + this.$el.querySelector(".el-input-group__" + pendant).offsetWidth + "px)";
            } else {
              el.removeAttribute("style");
            }
          },
          updateIconOffset: function updateIconOffset() {
            this.calcIconOffset("prefix");
            this.calcIconOffset("suffix");
          },
          clear: function clear2() {
            this.$emit("input", "");
            this.$emit("change", "");
            this.$emit("clear");
          },
          handlePasswordVisible: function handlePasswordVisible() {
            var _this2 = this;
            this.passwordVisible = !this.passwordVisible;
            this.$nextTick(function() {
              _this2.focus();
            });
          },
          getInput: function getInput() {
            return this.$refs.input || this.$refs.textarea;
          },
          getSuffixVisible: function getSuffixVisible() {
            return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
          }
        },
        created: function created6() {
          this.$on("inputSelect", this.select);
        },
        mounted: function mounted12() {
          this.setNativeInputValue();
          this.resizeTextarea();
          this.updateIconOffset();
        },
        updated: function updated2() {
          this.$nextTick(this.updateIconOffset);
        }
      };
      var src_inputvue_type_script_lang_js_ = inputvue_type_script_lang_js_;
      var componentNormalizer = __webpack_require__(0);
      var component = Object(componentNormalizer["a"])(src_inputvue_type_script_lang_js_, render28, staticRenderFns2, false, null, null, null);
      component.options.__file = "packages/input/src/input.vue";
      var input2 = component.exports;
      input2.install = function(Vue2) {
        Vue2.component(input2.name, input2);
      };
      __webpack_exports__["default"] = input2;
    },
    9: function(module2, exports) {
      module2.exports = merge;
    }
  });
})(input);
var button = { exports: {} };
(function(module) {
  module.exports = function(modules) {
    var installedModules = {};
    function __webpack_require__(moduleId) {
      if (installedModules[moduleId]) {
        return installedModules[moduleId].exports;
      }
      var module2 = installedModules[moduleId] = {
        i: moduleId,
        l: false,
        exports: {}
      };
      modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
      module2.l = true;
      return module2.exports;
    }
    __webpack_require__.m = modules;
    __webpack_require__.c = installedModules;
    __webpack_require__.d = function(exports, name, getter) {
      if (!__webpack_require__.o(exports, name)) {
        Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
      }
    };
    __webpack_require__.r = function(exports) {
      if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module"
        });
      }
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
    };
    __webpack_require__.t = function(value9, mode) {
      if (mode & 1)
        value9 = __webpack_require__(value9);
      if (mode & 8)
        return value9;
      if (mode & 4 && typeof value9 === "object" && value9 && value9.__esModule)
        return value9;
      var ns = Object.create(null);
      __webpack_require__.r(ns);
      Object.defineProperty(ns, "default", {
        enumerable: true,
        value: value9
      });
      if (mode & 2 && typeof value9 != "string")
        for (var key2 in value9)
          __webpack_require__.d(ns, key2, function(key3) {
            return value9[key3];
          }.bind(null, key2));
      return ns;
    };
    __webpack_require__.n = function(module2) {
      var getter = module2 && module2.__esModule ? function getDefault() {
        return module2["default"];
      } : function getModuleExports() {
        return module2;
      };
      __webpack_require__.d(getter, "a", getter);
      return getter;
    };
    __webpack_require__.o = function(object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    __webpack_require__.p = "/dist/";
    return __webpack_require__(__webpack_require__.s = 86);
  }({
    0: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.d(__webpack_exports__, "a", function() {
        return normalizeComponent2;
      });
      function normalizeComponent2(scriptExports, render28, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
        var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
        if (render28) {
          options.render = render28;
          options.staticRenderFns = staticRenderFns2;
          options._compiled = true;
        }
        if (functionalTemplate) {
          options.functional = true;
        }
        if (scopeId) {
          options._scopeId = "data-v-" + scopeId;
        }
        var hook;
        if (moduleIdentifier) {
          hook = function(context2) {
            context2 = context2 || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
            if (!context2 && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
              context2 = __VUE_SSR_CONTEXT__;
            }
            if (injectStyles) {
              injectStyles.call(this, context2);
            }
            if (context2 && context2._registeredComponents) {
              context2._registeredComponents.add(moduleIdentifier);
            }
          };
          options._ssrRegister = hook;
        } else if (injectStyles) {
          hook = shadowMode ? function() {
            injectStyles.call(this, this.$root.$options.shadowRoot);
          } : injectStyles;
        }
        if (hook) {
          if (options.functional) {
            options._injectStyles = hook;
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context2) {
              hook.call(context2);
              return originalRender(h, context2);
            };
          } else {
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
        }
        return {
          exports: scriptExports,
          options
        };
      }
    },
    86: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      var render28 = function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("button", {
          staticClass: "el-button",
          class: [_vm.type ? "el-button--" + _vm.type : "", _vm.buttonSize ? "el-button--" + _vm.buttonSize : "", {
            "is-disabled": _vm.buttonDisabled,
            "is-loading": _vm.loading,
            "is-plain": _vm.plain,
            "is-round": _vm.round,
            "is-circle": _vm.circle
          }],
          attrs: {
            disabled: _vm.buttonDisabled || _vm.loading,
            autofocus: _vm.autofocus,
            type: _vm.nativeType
          },
          on: {
            click: _vm.handleClick
          }
        }, [_vm.loading ? _c("i", {
          staticClass: "el-icon-loading"
        }) : _vm._e(), _vm.icon && !_vm.loading ? _c("i", {
          class: _vm.icon
        }) : _vm._e(), _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()]);
      };
      var staticRenderFns2 = [];
      render28._withStripped = true;
      var buttonvue_type_script_lang_js_ = {
        name: "ElButton",
        inject: {
          elForm: {
            default: ""
          },
          elFormItem: {
            default: ""
          }
        },
        props: {
          type: {
            type: String,
            default: "default"
          },
          size: String,
          icon: {
            type: String,
            default: ""
          },
          nativeType: {
            type: String,
            default: "button"
          },
          loading: Boolean,
          disabled: Boolean,
          plain: Boolean,
          autofocus: Boolean,
          round: Boolean,
          circle: Boolean
        },
        computed: {
          _elFormItemSize: function _elFormItemSize() {
            return (this.elFormItem || {}).elFormItemSize;
          },
          buttonSize: function buttonSize() {
            return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          },
          buttonDisabled: function buttonDisabled() {
            return this.disabled || (this.elForm || {}).disabled;
          }
        },
        methods: {
          handleClick: function handleClick(evt) {
            this.$emit("click", evt);
          }
        }
      };
      var src_buttonvue_type_script_lang_js_ = buttonvue_type_script_lang_js_;
      var componentNormalizer = __webpack_require__(0);
      var component = Object(componentNormalizer["a"])(src_buttonvue_type_script_lang_js_, render28, staticRenderFns2, false, null, null, null);
      component.options.__file = "packages/button/src/button.vue";
      var src_button = component.exports;
      src_button.install = function(Vue2) {
        Vue2.component(src_button.name, src_button);
      };
      __webpack_exports__["default"] = src_button;
    }
  });
})(button);
var locale$1 = {};
var zhCN = {};
zhCN.__esModule = true;
zhCN.default = {
  el: {
    colorpicker: {
      confirm: "\u786E\u5B9A",
      clear: "\u6E05\u7A7A"
    },
    datepicker: {
      now: "\u6B64\u523B",
      today: "\u4ECA\u5929",
      cancel: "\u53D6\u6D88",
      clear: "\u6E05\u7A7A",
      confirm: "\u786E\u5B9A",
      selectDate: "\u9009\u62E9\u65E5\u671F",
      selectTime: "\u9009\u62E9\u65F6\u95F4",
      startDate: "\u5F00\u59CB\u65E5\u671F",
      startTime: "\u5F00\u59CB\u65F6\u95F4",
      endDate: "\u7ED3\u675F\u65E5\u671F",
      endTime: "\u7ED3\u675F\u65F6\u95F4",
      prevYear: "\u524D\u4E00\u5E74",
      nextYear: "\u540E\u4E00\u5E74",
      prevMonth: "\u4E0A\u4E2A\u6708",
      nextMonth: "\u4E0B\u4E2A\u6708",
      year: "\u5E74",
      month1: "1 \u6708",
      month2: "2 \u6708",
      month3: "3 \u6708",
      month4: "4 \u6708",
      month5: "5 \u6708",
      month6: "6 \u6708",
      month7: "7 \u6708",
      month8: "8 \u6708",
      month9: "9 \u6708",
      month10: "10 \u6708",
      month11: "11 \u6708",
      month12: "12 \u6708",
      weeks: {
        sun: "\u65E5",
        mon: "\u4E00",
        tue: "\u4E8C",
        wed: "\u4E09",
        thu: "\u56DB",
        fri: "\u4E94",
        sat: "\u516D"
      },
      months: {
        jan: "\u4E00\u6708",
        feb: "\u4E8C\u6708",
        mar: "\u4E09\u6708",
        apr: "\u56DB\u6708",
        may: "\u4E94\u6708",
        jun: "\u516D\u6708",
        jul: "\u4E03\u6708",
        aug: "\u516B\u6708",
        sep: "\u4E5D\u6708",
        oct: "\u5341\u6708",
        nov: "\u5341\u4E00\u6708",
        dec: "\u5341\u4E8C\u6708"
      }
    },
    select: {
      loading: "\u52A0\u8F7D\u4E2D",
      noMatch: "\u65E0\u5339\u914D\u6570\u636E",
      noData: "\u65E0\u6570\u636E",
      placeholder: "\u8BF7\u9009\u62E9"
    },
    cascader: {
      noMatch: "\u65E0\u5339\u914D\u6570\u636E",
      loading: "\u52A0\u8F7D\u4E2D",
      placeholder: "\u8BF7\u9009\u62E9",
      noData: "\u6682\u65E0\u6570\u636E"
    },
    pagination: {
      goto: "\u524D\u5F80",
      pagesize: "\u6761/\u9875",
      total: "\u5171 {total} \u6761",
      pageClassifier: "\u9875"
    },
    messagebox: {
      title: "\u63D0\u793A",
      confirm: "\u786E\u5B9A",
      cancel: "\u53D6\u6D88",
      error: "\u8F93\u5165\u7684\u6570\u636E\u4E0D\u5408\u6CD5!"
    },
    upload: {
      deleteTip: "\u6309 delete \u952E\u53EF\u5220\u9664",
      delete: "\u5220\u9664",
      preview: "\u67E5\u770B\u56FE\u7247",
      continue: "\u7EE7\u7EED\u4E0A\u4F20"
    },
    table: {
      emptyText: "\u6682\u65E0\u6570\u636E",
      confirmFilter: "\u7B5B\u9009",
      resetFilter: "\u91CD\u7F6E",
      clearFilter: "\u5168\u90E8",
      sumText: "\u5408\u8BA1"
    },
    tree: {
      emptyText: "\u6682\u65E0\u6570\u636E"
    },
    transfer: {
      noMatch: "\u65E0\u5339\u914D\u6570\u636E",
      noData: "\u65E0\u6570\u636E",
      titles: ["\u5217\u8868 1", "\u5217\u8868 2"],
      filterPlaceholder: "\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9",
      noCheckedFormat: "\u5171 {total} \u9879",
      hasCheckedFormat: "\u5DF2\u9009 {checked}/{total} \u9879"
    },
    image: {
      error: "\u52A0\u8F7D\u5931\u8D25"
    },
    pageHeader: {
      title: "\u8FD4\u56DE"
    },
    popconfirm: {
      confirmButtonText: "\u786E\u5B9A",
      cancelButtonText: "\u53D6\u6D88"
    },
    empty: {
      description: "\u6682\u65E0\u6570\u636E"
    }
  }
};
var isMergeableObject = function isMergeableObject2(value9) {
  return isNonNullObject(value9) && !isSpecial(value9);
};
function isNonNullObject(value9) {
  return !!value9 && typeof value9 === "object";
}
function isSpecial(value9) {
  var stringValue = Object.prototype.toString.call(value9);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value9);
}
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(value9) {
  return value9.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneIfNecessary(value9, optionsArgument) {
  var clone2 = optionsArgument && optionsArgument.clone === true;
  return clone2 && isMergeableObject(value9) ? deepmerge(emptyTarget(value9), value9, optionsArgument) : value9;
}
function defaultArrayMerge(target, source, optionsArgument) {
  var destination = target.slice();
  source.forEach(function(e, i) {
    if (typeof destination[i] === "undefined") {
      destination[i] = cloneIfNecessary(e, optionsArgument);
    } else if (isMergeableObject(e)) {
      destination[i] = deepmerge(target[i], e, optionsArgument);
    } else if (target.indexOf(e) === -1) {
      destination.push(cloneIfNecessary(e, optionsArgument));
    }
  });
  return destination;
}
function mergeObject(target, source, optionsArgument) {
  var destination = {};
  if (isMergeableObject(target)) {
    Object.keys(target).forEach(function(key2) {
      destination[key2] = cloneIfNecessary(target[key2], optionsArgument);
    });
  }
  Object.keys(source).forEach(function(key2) {
    if (!isMergeableObject(source[key2]) || !target[key2]) {
      destination[key2] = cloneIfNecessary(source[key2], optionsArgument);
    } else {
      destination[key2] = deepmerge(target[key2], source[key2], optionsArgument);
    }
  });
  return destination;
}
function deepmerge(target, source, optionsArgument) {
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var options = optionsArgument || {
    arrayMerge: defaultArrayMerge
  };
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneIfNecessary(source, optionsArgument);
  } else if (sourceIsArray) {
    var arrayMerge = options.arrayMerge || defaultArrayMerge;
    return arrayMerge(target, source, optionsArgument);
  } else {
    return mergeObject(target, source, optionsArgument);
  }
}
deepmerge.all = function deepmergeAll(array, optionsArgument) {
  if (!Array.isArray(array) || array.length < 2) {
    throw new Error("first argument should be an array with at least two elements");
  }
  return array.reduce(function(prev4, next3) {
    return deepmerge(prev4, next3, optionsArgument);
  });
};
var deepmerge_1 = deepmerge;
var es = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": deepmerge_1
});
var require$$2 = /* @__PURE__ */ getAugmentedNamespace(es);
var format$1 = {};
format$1.__esModule = true;
var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
format$1.default = function(Vue2) {
  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (args.length === 1 && _typeof$1(args[0]) === "object") {
      args = args[0];
    }
    if (!args || !args.hasOwnProperty) {
      args = {};
    }
    return string.replace(RE_NARGS, function(match, prefix, i, index2) {
      var result = void 0;
      if (string[index2 - 1] === "{" && string[index2 + match.length] === "}") {
        return i;
      } else {
        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
        if (result === null || result === void 0) {
          return "";
        }
        return result;
      }
    });
  }
  return template;
};
var _util = util;
var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
locale$1.__esModule = true;
locale$1.i18n = locale$1.use = locale$1.t = void 0;
var _zhCN = zhCN;
var _zhCN2 = _interopRequireDefault$1(_zhCN);
var _vue = Vue$1;
var _vue2 = _interopRequireDefault$1(_vue);
var _deepmerge = require$$2;
var _deepmerge2 = _interopRequireDefault$1(_deepmerge);
var _format = format$1;
var _format2 = _interopRequireDefault$1(_format);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var format = (0, _format2.default)(_vue2.default);
var lang = _zhCN2.default;
var merged = false;
var i18nHandler = function i18nHandler2() {
  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
  if (typeof vuei18n === "function" && !!_vue2.default.locale) {
    if (!merged) {
      merged = true;
      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, {
        clone: true
      }));
    }
    return vuei18n.apply(this, arguments);
  }
};
var t$3 = locale$1.t = function t(path, options) {
  var value9 = i18nHandler.apply(this, arguments);
  if (value9 !== null && value9 !== void 0)
    return value9;
  var array = path.split(".");
  var current = lang;
  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value9 = current[property];
    if (i === j - 1)
      return format(value9, options);
    if (!value9)
      return "";
    current = value9;
  }
  return "";
};
var use2 = locale$1.use = function use3(l) {
  lang = l || lang;
};
var i18n = locale$1.i18n = function i18n2(fn2) {
  i18nHandler = fn2 || i18nHandler;
};
locale$1.default = {
  use: use2,
  t: t$3,
  i18n
};
var ariaDialog = {};
var ariaUtils = {};
ariaUtils.__esModule = true;
var aria$1 = aria$1 || {};
aria$1.Utils = aria$1.Utils || {};
aria$1.Utils.focusFirstDescendant = function(element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];
    if (aria$1.Utils.attemptFocus(child) || aria$1.Utils.focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
};
aria$1.Utils.focusLastDescendant = function(element) {
  for (var i = element.childNodes.length - 1; i >= 0; i--) {
    var child = element.childNodes[i];
    if (aria$1.Utils.attemptFocus(child) || aria$1.Utils.focusLastDescendant(child)) {
      return true;
    }
  }
  return false;
};
aria$1.Utils.attemptFocus = function(element) {
  if (!aria$1.Utils.isFocusable(element)) {
    return false;
  }
  aria$1.Utils.IgnoreUtilFocusChanges = true;
  try {
    element.focus();
  } catch (e) {
  }
  aria$1.Utils.IgnoreUtilFocusChanges = false;
  return document.activeElement === element;
};
aria$1.Utils.isFocusable = function(element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute("tabIndex") !== null) {
    return true;
  }
  if (element.disabled) {
    return false;
  }
  switch (element.nodeName) {
    case "A":
      return !!element.href && element.rel !== "ignore";
    case "INPUT":
      return element.type !== "hidden" && element.type !== "file";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return true;
    default:
      return false;
  }
};
aria$1.Utils.triggerEvent = function(elm, name) {
  var eventName = void 0;
  if (/^mouse|click/.test(name)) {
    eventName = "MouseEvents";
  } else if (/^key/.test(name)) {
    eventName = "KeyboardEvent";
  } else {
    eventName = "HTMLEvents";
  }
  var evt = document.createEvent(eventName);
  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    opts[_key - 2] = arguments[_key];
  }
  evt.initEvent.apply(evt, [name].concat(opts));
  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent("on" + name, evt);
  return elm;
};
aria$1.Utils.keys = {
  tab: 9,
  enter: 13,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  esc: 27
};
ariaUtils.default = aria$1.Utils;
ariaDialog.__esModule = true;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _ariaUtils = ariaUtils;
var _ariaUtils2 = _interopRequireDefault(_ariaUtils);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var aria = aria || {};
var tabEvent;
aria.Dialog = function(dialog, focusAfterClosed, focusFirst) {
  var _this = this;
  this.dialogNode = dialog;
  if (this.dialogNode === null || this.dialogNode.getAttribute("role") !== "dialog") {
    throw new Error("Dialog() requires a DOM element with ARIA role of dialog.");
  }
  if (typeof focusAfterClosed === "string") {
    this.focusAfterClosed = document.getElementById(focusAfterClosed);
  } else if ((typeof focusAfterClosed === "undefined" ? "undefined" : _typeof(focusAfterClosed)) === "object") {
    this.focusAfterClosed = focusAfterClosed;
  } else {
    this.focusAfterClosed = null;
  }
  if (typeof focusFirst === "string") {
    this.focusFirst = document.getElementById(focusFirst);
  } else if ((typeof focusFirst === "undefined" ? "undefined" : _typeof(focusFirst)) === "object") {
    this.focusFirst = focusFirst;
  } else {
    this.focusFirst = null;
  }
  if (this.focusFirst) {
    this.focusFirst.focus();
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
  }
  this.lastFocus = document.activeElement;
  tabEvent = function tabEvent2(e) {
    _this.trapFocus(e);
  };
  this.addListeners();
};
aria.Dialog.prototype.addListeners = function() {
  document.addEventListener("focus", tabEvent, true);
};
aria.Dialog.prototype.removeListeners = function() {
  document.removeEventListener("focus", tabEvent, true);
};
aria.Dialog.prototype.closeDialog = function() {
  var _this2 = this;
  this.removeListeners();
  if (this.focusAfterClosed) {
    setTimeout(function() {
      _this2.focusAfterClosed.focus();
    });
  }
};
aria.Dialog.prototype.trapFocus = function(event) {
  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
    return;
  }
  if (this.dialogNode.contains(event.target)) {
    this.lastFocus = event.target;
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
    if (this.lastFocus === document.activeElement) {
      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
    }
    this.lastFocus = document.activeElement;
  }
};
ariaDialog.default = aria.Dialog;
var locale = {};
locale.__esModule = true;
var _locale = locale$1;
locale.default = {
  methods: {
    t: function t2() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _locale.t.apply(this, args);
    }
  }
};
(function(module) {
  module.exports = function(modules) {
    var installedModules = {};
    function __webpack_require__(moduleId) {
      if (installedModules[moduleId]) {
        return installedModules[moduleId].exports;
      }
      var module2 = installedModules[moduleId] = {
        i: moduleId,
        l: false,
        exports: {}
      };
      modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
      module2.l = true;
      return module2.exports;
    }
    __webpack_require__.m = modules;
    __webpack_require__.c = installedModules;
    __webpack_require__.d = function(exports, name, getter) {
      if (!__webpack_require__.o(exports, name)) {
        Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
      }
    };
    __webpack_require__.r = function(exports) {
      if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module"
        });
      }
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
    };
    __webpack_require__.t = function(value9, mode) {
      if (mode & 1)
        value9 = __webpack_require__(value9);
      if (mode & 8)
        return value9;
      if (mode & 4 && typeof value9 === "object" && value9 && value9.__esModule)
        return value9;
      var ns = Object.create(null);
      __webpack_require__.r(ns);
      Object.defineProperty(ns, "default", {
        enumerable: true,
        value: value9
      });
      if (mode & 2 && typeof value9 != "string")
        for (var key2 in value9)
          __webpack_require__.d(ns, key2, function(key3) {
            return value9[key3];
          }.bind(null, key2));
      return ns;
    };
    __webpack_require__.n = function(module2) {
      var getter = module2 && module2.__esModule ? function getDefault() {
        return module2["default"];
      } : function getModuleExports() {
        return module2;
      };
      __webpack_require__.d(getter, "a", getter);
      return getter;
    };
    __webpack_require__.o = function(object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    __webpack_require__.p = "/dist/";
    return __webpack_require__(__webpack_require__.s = 74);
  }({
    0: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.d(__webpack_exports__, "a", function() {
        return normalizeComponent2;
      });
      function normalizeComponent2(scriptExports, render28, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
        var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
        if (render28) {
          options.render = render28;
          options.staticRenderFns = staticRenderFns2;
          options._compiled = true;
        }
        if (functionalTemplate) {
          options.functional = true;
        }
        if (scopeId) {
          options._scopeId = "data-v-" + scopeId;
        }
        var hook;
        if (moduleIdentifier) {
          hook = function(context2) {
            context2 = context2 || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
            if (!context2 && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
              context2 = __VUE_SSR_CONTEXT__;
            }
            if (injectStyles) {
              injectStyles.call(this, context2);
            }
            if (context2 && context2._registeredComponents) {
              context2._registeredComponents.add(moduleIdentifier);
            }
          };
          options._ssrRegister = hook;
        } else if (injectStyles) {
          hook = shadowMode ? function() {
            injectStyles.call(this, this.$root.$options.shadowRoot);
          } : injectStyles;
        }
        if (hook) {
          if (options.functional) {
            options._injectStyles = hook;
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context2) {
              hook.call(context2);
              return originalRender(h, context2);
            };
          } else {
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
        }
        return {
          exports: scriptExports,
          options
        };
      }
    },
    10: function(module2, exports) {
      module2.exports = input.exports;
    },
    13: function(module2, exports) {
      module2.exports = popup;
    },
    14: function(module2, exports) {
      module2.exports = button.exports;
    },
    2: function(module2, exports) {
      module2.exports = dom;
    },
    20: function(module2, exports) {
      module2.exports = locale$1;
    },
    23: function(module2, exports) {
      module2.exports = vdom;
    },
    47: function(module2, exports) {
      module2.exports = ariaDialog;
    },
    6: function(module2, exports) {
      module2.exports = locale;
    },
    7: function(module2, exports) {
      module2.exports = Vue$1;
    },
    74: function(module2, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      var external_vue_ = __webpack_require__(7);
      var external_vue_default = /* @__PURE__ */ __webpack_require__.n(external_vue_);
      var render28 = function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("transition", {
          attrs: {
            name: "msgbox-fade"
          }
        }, [_c("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }],
          staticClass: "el-message-box__wrapper",
          attrs: {
            tabindex: "-1",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": _vm.title || "dialog"
          },
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null;
              }
              return _vm.handleWrapperClick($event);
            }
          }
        }, [_c("div", {
          staticClass: "el-message-box",
          class: [_vm.customClass, _vm.center && "el-message-box--center"]
        }, [_vm.title !== null ? _c("div", {
          staticClass: "el-message-box__header"
        }, [_c("div", {
          staticClass: "el-message-box__title"
        }, [_vm.icon && _vm.center ? _c("div", {
          class: ["el-message-box__status", _vm.icon]
        }) : _vm._e(), _c("span", [_vm._v(_vm._s(_vm.title))])]), _vm.showClose ? _c("button", {
          staticClass: "el-message-box__headerbtn",
          attrs: {
            type: "button",
            "aria-label": "Close"
          },
          on: {
            click: function($event) {
              _vm.handleAction(_vm.distinguishCancelAndClose ? "close" : "cancel");
            },
            keydown: function($event) {
              if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
                return null;
              }
              _vm.handleAction(_vm.distinguishCancelAndClose ? "close" : "cancel");
            }
          }
        }, [_c("i", {
          staticClass: "el-message-box__close el-icon-close"
        })]) : _vm._e()]) : _vm._e(), _c("div", {
          staticClass: "el-message-box__content"
        }, [_c("div", {
          staticClass: "el-message-box__container"
        }, [_vm.icon && !_vm.center && _vm.message !== "" ? _c("div", {
          class: ["el-message-box__status", _vm.icon]
        }) : _vm._e(), _vm.message !== "" ? _c("div", {
          staticClass: "el-message-box__message"
        }, [_vm._t("default", [!_vm.dangerouslyUseHTMLString ? _c("p", [_vm._v(_vm._s(_vm.message))]) : _c("p", {
          domProps: {
            innerHTML: _vm._s(_vm.message)
          }
        })])], 2) : _vm._e()]), _c("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showInput,
            expression: "showInput"
          }],
          staticClass: "el-message-box__input"
        }, [_c("el-input", {
          ref: "input",
          attrs: {
            type: _vm.inputType,
            placeholder: _vm.inputPlaceholder
          },
          nativeOn: {
            keydown: function($event) {
              if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
                return null;
              }
              return _vm.handleInputEnter($event);
            }
          },
          model: {
            value: _vm.inputValue,
            callback: function($$v) {
              _vm.inputValue = $$v;
            },
            expression: "inputValue"
          }
        }), _c("div", {
          staticClass: "el-message-box__errormsg",
          style: {
            visibility: !!_vm.editorErrorMessage ? "visible" : "hidden"
          }
        }, [_vm._v(_vm._s(_vm.editorErrorMessage))])], 1)]), _c("div", {
          staticClass: "el-message-box__btns"
        }, [_vm.showCancelButton ? _c("el-button", {
          class: [_vm.cancelButtonClasses],
          attrs: {
            loading: _vm.cancelButtonLoading,
            round: _vm.roundButton,
            size: "small"
          },
          on: {
            keydown: function($event) {
              if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
                return null;
              }
              _vm.handleAction("cancel");
            }
          },
          nativeOn: {
            click: function($event) {
              _vm.handleAction("cancel");
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.cancelButtonText || _vm.t("el.messagebox.cancel")) + "\n        ")]) : _vm._e(), _c("el-button", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showConfirmButton,
            expression: "showConfirmButton"
          }],
          ref: "confirm",
          class: [_vm.confirmButtonClasses],
          attrs: {
            loading: _vm.confirmButtonLoading,
            round: _vm.roundButton,
            size: "small"
          },
          on: {
            keydown: function($event) {
              if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
                return null;
              }
              _vm.handleAction("confirm");
            }
          },
          nativeOn: {
            click: function($event) {
              _vm.handleAction("confirm");
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.confirmButtonText || _vm.t("el.messagebox.confirm")) + "\n        ")])], 1)])])]);
      };
      var staticRenderFns2 = [];
      render28._withStripped = true;
      var popup_ = __webpack_require__(13);
      var popup_default = /* @__PURE__ */ __webpack_require__.n(popup_);
      var locale_ = __webpack_require__(6);
      var locale_default = /* @__PURE__ */ __webpack_require__.n(locale_);
      var input_ = __webpack_require__(10);
      var input_default = /* @__PURE__ */ __webpack_require__.n(input_);
      var button_ = __webpack_require__(14);
      var button_default = /* @__PURE__ */ __webpack_require__.n(button_);
      var dom_ = __webpack_require__(2);
      var lib_locale_ = __webpack_require__(20);
      var aria_dialog_ = __webpack_require__(47);
      var aria_dialog_default = /* @__PURE__ */ __webpack_require__.n(aria_dialog_);
      var messageBox2 = void 0;
      var typeMap = {
        success: "success",
        info: "info",
        warning: "warning",
        error: "error"
      };
      var mainvue_type_script_lang_js_ = {
        mixins: [popup_default.a, locale_default.a],
        props: {
          modal: {
            default: true
          },
          lockScroll: {
            default: true
          },
          showClose: {
            type: Boolean,
            default: true
          },
          closeOnClickModal: {
            default: true
          },
          closeOnPressEscape: {
            default: true
          },
          closeOnHashChange: {
            default: true
          },
          center: {
            default: false,
            type: Boolean
          },
          roundButton: {
            default: false,
            type: Boolean
          }
        },
        components: {
          ElInput: input_default.a,
          ElButton: button_default.a
        },
        computed: {
          icon: function icon() {
            var type = this.type, iconClass = this.iconClass;
            return iconClass || (type && typeMap[type] ? "el-icon-" + typeMap[type] : "");
          },
          confirmButtonClasses: function confirmButtonClasses() {
            return "el-button--primary " + this.confirmButtonClass;
          },
          cancelButtonClasses: function cancelButtonClasses() {
            return "" + this.cancelButtonClass;
          }
        },
        methods: {
          getSafeClose: function getSafeClose() {
            var _this = this;
            var currentId = this.uid;
            return function() {
              _this.$nextTick(function() {
                if (currentId === _this.uid)
                  _this.doClose();
              });
            };
          },
          doClose: function doClose2() {
            var _this2 = this;
            if (!this.visible)
              return;
            this.visible = false;
            this._closing = true;
            this.onClose && this.onClose();
            messageBox2.closeDialog();
            if (this.lockScroll) {
              setTimeout(this.restoreBodyStyle, 200);
            }
            this.opened = false;
            this.doAfterClose();
            setTimeout(function() {
              if (_this2.action)
                _this2.callback(_this2.action, _this2);
            });
          },
          handleWrapperClick: function handleWrapperClick() {
            if (this.closeOnClickModal) {
              this.handleAction(this.distinguishCancelAndClose ? "close" : "cancel");
            }
          },
          handleInputEnter: function handleInputEnter() {
            if (this.inputType !== "textarea") {
              return this.handleAction("confirm");
            }
          },
          handleAction: function handleAction2(action) {
            if (this.$type === "prompt" && action === "confirm" && !this.validate()) {
              return;
            }
            this.action = action;
            if (typeof this.beforeClose === "function") {
              this.close = this.getSafeClose();
              this.beforeClose(action, this, this.close);
            } else {
              this.doClose();
            }
          },
          validate: function validate3() {
            if (this.$type === "prompt") {
              var inputPattern = this.inputPattern;
              if (inputPattern && !inputPattern.test(this.inputValue || "")) {
                this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])("el.messagebox.error");
                Object(dom_["addClass"])(this.getInputElement(), "invalid");
                return false;
              }
              var inputValidator = this.inputValidator;
              if (typeof inputValidator === "function") {
                var validateResult = inputValidator(this.inputValue);
                if (validateResult === false) {
                  this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])("el.messagebox.error");
                  Object(dom_["addClass"])(this.getInputElement(), "invalid");
                  return false;
                }
                if (typeof validateResult === "string") {
                  this.editorErrorMessage = validateResult;
                  Object(dom_["addClass"])(this.getInputElement(), "invalid");
                  return false;
                }
              }
            }
            this.editorErrorMessage = "";
            Object(dom_["removeClass"])(this.getInputElement(), "invalid");
            return true;
          },
          getFirstFocus: function getFirstFocus() {
            var btn = this.$el.querySelector(".el-message-box__btns .el-button");
            var title2 = this.$el.querySelector(".el-message-box__btns .el-message-box__title");
            return btn || title2;
          },
          getInputElement: function getInputElement() {
            var inputRefs = this.$refs.input.$refs;
            return inputRefs.input || inputRefs.textarea;
          },
          handleClose: function handleClose() {
            this.handleAction("close");
          }
        },
        watch: {
          inputValue: {
            immediate: true,
            handler: function handler(val) {
              var _this3 = this;
              this.$nextTick(function(_) {
                if (_this3.$type === "prompt" && val !== null) {
                  _this3.validate();
                }
              });
            }
          },
          visible: function visible2(val) {
            var _this4 = this;
            if (val) {
              this.uid++;
              if (this.$type === "alert" || this.$type === "confirm") {
                this.$nextTick(function() {
                  _this4.$refs.confirm.$el.focus();
                });
              }
              this.focusAfterClosed = document.activeElement;
              messageBox2 = new aria_dialog_default.a(this.$el, this.focusAfterClosed, this.getFirstFocus());
            }
            if (this.$type !== "prompt")
              return;
            if (val) {
              setTimeout(function() {
                if (_this4.$refs.input && _this4.$refs.input.$el) {
                  _this4.getInputElement().focus();
                }
              }, 500);
            } else {
              this.editorErrorMessage = "";
              Object(dom_["removeClass"])(this.getInputElement(), "invalid");
            }
          }
        },
        mounted: function mounted12() {
          var _this5 = this;
          this.$nextTick(function() {
            if (_this5.closeOnHashChange) {
              window.addEventListener("hashchange", _this5.close);
            }
          });
        },
        beforeDestroy: function beforeDestroy4() {
          if (this.closeOnHashChange) {
            window.removeEventListener("hashchange", this.close);
          }
          setTimeout(function() {
            messageBox2.closeDialog();
          });
        },
        data: function data22() {
          return {
            uid: 1,
            title: void 0,
            message: "",
            type: "",
            iconClass: "",
            customClass: "",
            showInput: false,
            inputValue: null,
            inputPlaceholder: "",
            inputType: "text",
            inputPattern: null,
            inputValidator: null,
            inputErrorMessage: "",
            showConfirmButton: true,
            showCancelButton: false,
            action: "",
            confirmButtonText: "",
            cancelButtonText: "",
            confirmButtonLoading: false,
            cancelButtonLoading: false,
            confirmButtonClass: "",
            confirmButtonDisabled: false,
            cancelButtonClass: "",
            editorErrorMessage: null,
            callback: null,
            dangerouslyUseHTMLString: false,
            focusAfterClosed: null,
            isOnComposition: false,
            distinguishCancelAndClose: false
          };
        }
      };
      var src_mainvue_type_script_lang_js_ = mainvue_type_script_lang_js_;
      var componentNormalizer = __webpack_require__(0);
      var component = Object(componentNormalizer["a"])(src_mainvue_type_script_lang_js_, render28, staticRenderFns2, false, null, null, null);
      component.options.__file = "packages/message-box/src/main.vue";
      var main = component.exports;
      var merge_ = __webpack_require__(9);
      var merge_default = /* @__PURE__ */ __webpack_require__.n(merge_);
      var vdom_ = __webpack_require__(23);
      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
      } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
      var defaults2 = {
        title: null,
        message: "",
        type: "",
        iconClass: "",
        showInput: false,
        showClose: true,
        modalFade: true,
        lockScroll: true,
        closeOnClickModal: true,
        closeOnPressEscape: true,
        closeOnHashChange: true,
        inputValue: null,
        inputPlaceholder: "",
        inputType: "text",
        inputPattern: null,
        inputValidator: null,
        inputErrorMessage: "",
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonPosition: "right",
        confirmButtonHighlight: false,
        cancelButtonHighlight: false,
        confirmButtonText: "",
        cancelButtonText: "",
        confirmButtonClass: "",
        cancelButtonClass: "",
        customClass: "",
        beforeClose: null,
        dangerouslyUseHTMLString: false,
        center: false,
        roundButton: false,
        distinguishCancelAndClose: false
      };
      var MessageBoxConstructor = external_vue_default.a.extend(main);
      var currentMsg = void 0, instance2 = void 0;
      var msgQueue = [];
      var defaultCallback = function defaultCallback2(action) {
        if (currentMsg) {
          var callback2 = currentMsg.callback;
          if (typeof callback2 === "function") {
            if (instance2.showInput) {
              callback2(instance2.inputValue, action);
            } else {
              callback2(action);
            }
          }
          if (currentMsg.resolve) {
            if (action === "confirm") {
              if (instance2.showInput) {
                currentMsg.resolve({
                  value: instance2.inputValue,
                  action
                });
              } else {
                currentMsg.resolve(action);
              }
            } else if (currentMsg.reject && (action === "cancel" || action === "close")) {
              currentMsg.reject(action);
            }
          }
        }
      };
      var initInstance3 = function initInstance4() {
        instance2 = new MessageBoxConstructor({
          el: document.createElement("div")
        });
        instance2.callback = defaultCallback;
      };
      var main_showNextMsg = function showNextMsg() {
        if (!instance2) {
          initInstance3();
        }
        instance2.action = "";
        if (!instance2.visible || instance2.closeTimer) {
          if (msgQueue.length > 0) {
            currentMsg = msgQueue.shift();
            var options = currentMsg.options;
            for (var prop in options) {
              if (options.hasOwnProperty(prop)) {
                instance2[prop] = options[prop];
              }
            }
            if (options.callback === void 0) {
              instance2.callback = defaultCallback;
            }
            var oldCb = instance2.callback;
            instance2.callback = function(action, instance3) {
              oldCb(action, instance3);
              showNextMsg();
            };
            if (Object(vdom_["isVNode"])(instance2.message)) {
              instance2.$slots.default = [instance2.message];
              instance2.message = null;
            } else {
              delete instance2.$slots.default;
            }
            ["modal", "showClose", "closeOnClickModal", "closeOnPressEscape", "closeOnHashChange"].forEach(function(prop2) {
              if (instance2[prop2] === void 0) {
                instance2[prop2] = true;
              }
            });
            document.body.appendChild(instance2.$el);
            external_vue_default.a.nextTick(function() {
              instance2.visible = true;
            });
          }
        }
      };
      var main_MessageBox = function MessageBox(options, callback2) {
        if (external_vue_default.a.prototype.$isServer)
          return;
        if (typeof options === "string" || Object(vdom_["isVNode"])(options)) {
          options = {
            message: options
          };
          if (typeof arguments[1] === "string") {
            options.title = arguments[1];
          }
        } else if (options.callback && !callback2) {
          callback2 = options.callback;
        }
        if (typeof Promise !== "undefined") {
          return new Promise(function(resolve, reject) {
            msgQueue.push({
              options: merge_default()({}, defaults2, MessageBox.defaults, options),
              callback: callback2,
              resolve,
              reject
            });
            main_showNextMsg();
          });
        } else {
          msgQueue.push({
            options: merge_default()({}, defaults2, MessageBox.defaults, options),
            callback: callback2
          });
          main_showNextMsg();
        }
      };
      main_MessageBox.setDefaults = function(defaults3) {
        main_MessageBox.defaults = defaults3;
      };
      main_MessageBox.alert = function(message2, title2, options) {
        if ((typeof title2 === "undefined" ? "undefined" : _typeof2(title2)) === "object") {
          options = title2;
          title2 = "";
        } else if (title2 === void 0) {
          title2 = "";
        }
        return main_MessageBox(merge_default()({
          title: title2,
          message: message2,
          $type: "alert",
          closeOnPressEscape: false,
          closeOnClickModal: false
        }, options));
      };
      main_MessageBox.confirm = function(message2, title2, options) {
        if ((typeof title2 === "undefined" ? "undefined" : _typeof2(title2)) === "object") {
          options = title2;
          title2 = "";
        } else if (title2 === void 0) {
          title2 = "";
        }
        return main_MessageBox(merge_default()({
          title: title2,
          message: message2,
          $type: "confirm",
          showCancelButton: true
        }, options));
      };
      main_MessageBox.prompt = function(message2, title2, options) {
        if ((typeof title2 === "undefined" ? "undefined" : _typeof2(title2)) === "object") {
          options = title2;
          title2 = "";
        } else if (title2 === void 0) {
          title2 = "";
        }
        return main_MessageBox(merge_default()({
          title: title2,
          message: message2,
          showCancelButton: true,
          showInput: true,
          $type: "prompt"
        }, options));
      };
      main_MessageBox.close = function() {
        instance2.doClose();
        instance2.visible = false;
        msgQueue = [];
        currentMsg = null;
      };
      var src_main = main_MessageBox;
      __webpack_exports__["default"] = src_main;
    },
    9: function(module2, exports) {
      module2.exports = merge;
    }
  });
})(messageBox);
var _MessageBox = /* @__PURE__ */ getDefaultExportFromCjs(messageBox.exports);
var render$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonTxt))]), _c("el-dialog", {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "width": "360",
      "close-on-click-modal": false,
      "modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_vm.tips ? _c("div", {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.tips))]) : _vm._e(), _c("el-input", {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 8,
        maxRows: 16
      },
      "placeholder": _vm.placeholder
    },
    model: {
      value: _vm.multipleText,
      callback: function($$v) {
        _vm.multipleText = $$v;
      },
      expression: "multipleText"
    }
  }), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("\u53D6 \u6D88")]), _c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\u786E \u5B9A")])], 1)], 1)], 1);
};
var staticRenderFns$a = [];
render$a._withStripped = true;
const __vue2_script$a = {
  name: "MultipleSearchDialog",
  props: {
    title: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    buttonTxt: {
      type: String,
      default: "\u6279\u91CF\u67E5\u8BE2"
    },
    tips: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      multipleText: ""
    };
  },
  methods: {
    handleSubmit() {
      this.$emit("submit", this.multipleText, () => {
        this.dialogVisible = false;
      });
    }
  }
};
const __cssModules$a = {};
var __component__$a = /* @__PURE__ */ normalizeComponent(__vue2_script$a, render$a, staticRenderFns$a, false, __vue2_injectStyles$a, null, null, null);
function __vue2_injectStyles$a(context2) {
  for (let o in __cssModules$a) {
    this[o] = __cssModules$a[o];
  }
}
__component__$a.options.__file = "packages/op-uc-all-selector/src/pc/component/SearchDialog.vue";
var SearchDialogVue = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "market-select"
  }, [_c("el-row", {
    attrs: {
      "gutter": 10
    }
  }, [_c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u5546\u573A\u7F16\u7801",
      "clearable": ""
    },
    model: {
      value: _vm.searchParams.orgNo,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "orgNo", $$v);
      },
      expression: "searchParams.orgNo"
    }
  })], 1), _c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("el-select", {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "\u8BF7\u9009\u62E9\u5E02\u573A\u7EA7\u522B",
      "clearable": ""
    },
    model: {
      value: _vm.searchParams.orgMarketRank,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "orgMarketRank", $$v);
      },
      expression: "searchParams.orgMarketRank"
    }
  }, _vm._l(_vm.ROOT_MARKETLEVEL, function(item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1), _c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("op-classify-select", {
    on: {
      "change": _vm.handleClassifyChange
    },
    model: {
      value: _vm.searchParams.orgBelongMarketClassify,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "orgBelongMarketClassify", $$v);
      },
      expression: "searchParams.orgBelongMarketClassify"
    }
  })], 1), _c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("op-market-line-select", {
    ref: "marketLineRef",
    attrs: {
      "classify": _vm.searchParams.orgBelongMarketClassify[0]
    },
    model: {
      value: _vm.searchParams.regexpLineId,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "regexpLineId", $$v);
      },
      expression: "searchParams.regexpLineId"
    }
  })], 1)], 1), _c("el-row", {
    staticStyle: {
      "margin": "4px 0"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("op-channel-select", {
    attrs: {
      "multiple": true
    },
    model: {
      value: _vm.searchParams.channel,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "channel", $$v);
      },
      expression: "searchParams.channel"
    }
  })], 1), _c("el-col", {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "span": 4
    }
  }, [_c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("\u67E5\u8BE2")]), _c("SearchDialogVue", {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "title": "\u6279\u91CF\u67E5\u8BE2\u5546\u573A",
      "placeholder": "\u8BF7\u8F93\u5165\u5546\u573A\u7F16\u7801",
      "tips": '\u591A\u4E2A\u67E5\u8BE2\uFF0C\u5219\u6362\u884C\u6216\u7528","\u9694\u5F00\u3002\u4E00\u6B21\u6700\u591A\u53EF\u641C\u7D221000\u4E2A\u5546\u573A'
    },
    on: {
      "submit": _vm.getMultipleMarketData
    }
  })], 1)], 1), _c("el-table", {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": "45vh",
      "border": "",
      "header-row-class-name": "table-header"
    },
    on: {
      "select": _vm.selectChange,
      "select-all": _vm.selectChange
    }
  }, [_c("el-table-column", {
    attrs: {
      "align": "center",
      "type": "selection",
      "min-width": "55"
    }
  }), _vm._l(_vm.headerConfig, function(item) {
    return _c("el-table-column", {
      key: item.prop,
      attrs: {
        "label": item.label,
        "prop": item.prop,
        "align": "center",
        "min-width": item.width || 55
      }
    });
  })], 2), _c("el-pagination", {
    staticClass: "pagination",
    attrs: {
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "current-page": _vm.pagination.pageNo,
      "pager-count": 5,
      "layout": "total, prev, pager, next, jumper, sizes",
      "total": _vm.pagination.total
    },
    on: {
      "update:pageSize": function($event) {
        return _vm.$set(_vm.pagination, "pageSize", $event);
      },
      "update:page-size": function($event) {
        return _vm.$set(_vm.pagination, "pageSize", $event);
      },
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pagination, "pageNo", $event);
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pagination, "pageNo", $event);
      },
      "current-change": _vm.handlePageChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1);
};
var staticRenderFns$9 = [];
render$9._withStripped = true;
var MarketSelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$9 = defineComponent({
  components: {
    SearchDialogVue,
    OpClassifySelect,
    OpChannelSelect
  },
  props: {
    classify: {
      type: Array,
      default: () => []
    },
    outList: {
      type: Array,
      default: () => []
    },
    selectList: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const {
      ROOT_MARKETLEVEL,
      getDictData
    } = useDictData(["ROOT_MARKETLEVEL"]);
    getDictData();
    const marketLineRef = ref(null);
    function handleClassifyChange(val) {
      searchParams.value.regexpLineId = [];
      marketLineRef.value.getData(val[0]);
    }
    const searchParams = ref({
      orgNo: "",
      orgMarketRank: "",
      orgBelongMarketClassify: [],
      regexpLineId: [],
      channel: []
    });
    const pagination = ref({
      pageNo: 1,
      pageSize: 20,
      total: 0
    });
    const loading2 = ref(false);
    const headerConfig = [{
      label: "\u5546\u573A\u7F16\u53F7",
      prop: "orgNo",
      width: "80"
    }, {
      label: "\u5546\u573A\u540D\u79F0",
      prop: "orgName",
      width: "120"
    }, {
      label: "\u5546\u573A\u884C\u653F\u533A\u5212",
      prop: "orgRegionPidsName",
      width: "160"
    }];
    const multipleTable = ref(null);
    const tableData = ref([]);
    async function getMarketData() {
      if (props2.outList && props2.outList.length > 0) {
        tableData.value = props2.outList;
        pagination.value.total = props2.outList.length;
        return;
      }
      loading2.value = true;
      const res = await getMarketListData({
        leaved: 0,
        delFlag: 0,
        pageNo: pagination.value.pageNo,
        pageSize: pagination.value.pageSize,
        searchStr: searchParams.value.orgNo,
        orgBelongMarketClassify: searchParams.value.orgBelongMarketClassify[0],
        orgMarketRank: searchParams.value.orgMarketRank,
        regexpLineId: searchParams.value.regexpLineId[0],
        channelCodeList: searchParams.value.channel
      }).finally(() => {
        loading2.value = false;
      });
      if (res.status) {
        tableData.value = res.data.records;
        pagination.value.total = res.data.total;
        initSelect();
      }
    }
    async function handleSearch() {
      pagination.value.pageNo = 1;
      pagination.value.pageSize = 20;
      await getMarketData();
    }
    async function handlePageChange(val) {
      pagination.value.pageNo = val;
      await getMarketData();
    }
    async function handleSizeChange(val) {
      pagination.value.pageSize = val;
      await getMarketData();
    }
    async function getMultipleMarketData(params, cb) {
      const str = params.replace(/[,，\s]/g, ",");
      const list = str.split(",").filter((x) => !!x);
      if (list.length > 1e3) {
        _Message.error("\u5546\u573A\u641C\u7D22\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC71000\u4E2A");
        return;
      }
      if (list.length === 0) {
        _Message.error("\u8BF7\u8F93\u5165\u5546\u573A\u7F16\u7801");
        return;
      }
      cb();
      loading2.value = true;
      pagination.value.pageSize = 1e3;
      pagination.value.pageNo = 1;
      const res = await getMarketListData({
        leaved: 0,
        delFlag: 0,
        pageNo: 1,
        pageSize: 1e3,
        orgNoList: list
      }).finally(() => {
        loading2.value = false;
      });
      if (res.status) {
        tableData.value = res.data.records;
        pagination.value.total = res.data.total;
        const unSearchOrgNoList = [];
        const resultOrgNoList = tableData.value.map((item) => item.orgNo.toLocaleUpperCase());
        list.forEach((no) => {
          if (!resultOrgNoList.includes(no.toLocaleUpperCase())) {
            unSearchOrgNoList.push(no);
          }
        });
        if (unSearchOrgNoList.length > 0) {
          _MessageBox.confirm(`${unSearchOrgNoList.join(",")}\u65E0\u7ED3\u679C\u8FD4\u56DE\uFF01`, "\u7CFB\u7EDF\u63D0\u793A", {
            closeOnClickModal: false
          });
        }
      }
    }
    function initSelect() {
      multipleTable.value.clearSelection();
      currentSelectList.value = [];
      for (let item of tableData.value) {
        if (props2.selectList.some((x) => x.orgId === item.orgId)) {
          nextTick(() => {
            multipleTable.value.toggleRowSelection(item, true);
            currentSelectList.value.push(item);
          });
        }
      }
    }
    watch(() => props2.selectList, (val) => {
      initSelect();
    });
    const currentSelectList = ref([]);
    function selectChange(val) {
      const selectedList = [];
      const unSelectedList = [];
      const maxLength = Math.max(val.length, currentSelectList.value.length);
      if (maxLength === 0)
        return;
      for (let i = 0; i < maxLength; i++) {
        if (val[i] && !currentSelectList.value.some((c) => c.orgId === val[i].orgId)) {
          selectedList.push(val[i]);
        }
        if (currentSelectList.value[i] && !val.some((v) => v.orgId === currentSelectList.value[i].orgId)) {
          unSelectedList.push(currentSelectList.value[i]);
        }
      }
      currentSelectList.value = [...val];
      const _selectList = props2.selectList.filter((x) => !unSelectedList.some((i) => i.orgId === x.orgId)).concat(selectedList);
      emit2("update:selectList", _selectList);
    }
    return {
      handleClassifyChange,
      marketLineRef,
      searchParams,
      pagination,
      ROOT_MARKETLEVEL,
      loading: loading2,
      tableData,
      multipleTable,
      headerConfig,
      selectChange,
      handleSearch,
      handlePageChange,
      handleSizeChange,
      getMultipleMarketData
    };
  }
});
const __cssModules$9 = {};
var __component__$9 = /* @__PURE__ */ normalizeComponent(__vue2_script$9, render$9, staticRenderFns$9, false, __vue2_injectStyles$9, "60f851ee", null, null);
function __vue2_injectStyles$9(context2) {
  for (let o in __cssModules$9) {
    this[o] = __cssModules$9[o];
  }
}
__component__$9.options.__file = "packages/op-uc-all-selector/src/pc/component/MarketSelect.vue";
var MarketSelect = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "person-select"
  }, [_c("el-row", {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u540D\u79F0\u6216\u5DE5\u53F7",
      "clearable": ""
    },
    model: {
      value: _vm.searchParams.searchStr,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "searchStr", $$v);
      },
      expression: "searchParams.searchStr"
    }
  })], 1), _vm.type === "agent" ? _c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u7EC4\u7EC7\u7F16\u7801",
      "clearable": ""
    },
    model: {
      value: _vm.searchParams.orgNo,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "orgNo", $$v);
      },
      expression: "searchParams.orgNo"
    }
  })], 1) : _vm._e(), _vm.type === "agent" ? _c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u5546\u573A\u540D\u79F0",
      "clearable": ""
    },
    model: {
      value: _vm.searchParams.searchOrgName,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "searchOrgName", $$v);
      },
      expression: "searchParams.searchOrgName"
    }
  })], 1) : _vm._e(), _vm.type === "oppein" ? _c("el-col", {
    attrs: {
      "span": 6
    }
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u90E8\u95E8",
      "clearable": ""
    },
    model: {
      value: _vm.searchParams.searchDepartmentName,
      callback: function($$v) {
        _vm.$set(_vm.searchParams, "searchDepartmentName", $$v);
      },
      expression: "searchParams.searchDepartmentName"
    }
  })], 1) : _vm._e(), _c("el-col", {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "span": 4
    }
  }, [_c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("\u67E5\u8BE2")]), _vm.type === "oppein" ? _c("SearchDialogVue", {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "title": "\u6279\u91CF\u67E5\u8BE2\u4EBA\u5458",
      "placeholder": "\u8BF7\u8F93\u5165\u5458\u5DE5\u53F7",
      "tips": "\u591A\u4E2A\u5DE5\u53F7\u67E5\u8BE2\uFF0C\u5219\u6362\u884C\u6216\u7528\u201C,\u201D\u9694\u5F00\uFF0C\u4E00\u6B21\u6700\u591A\u53EF\u641C\u7D221000\u4E2A\u4EBA\u5458\uFF0C\u5DE5\u53F7\u4E0D\u533A\u5206\u5927\u5C0F\u5199\uFF0C\u5982op.111111"
    },
    on: {
      "submit": _vm.getMultipleData
    }
  }) : _vm._e()], 1)], 1), _c("el-table", {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": "45vh",
      "border": "",
      "header-row-class-name": "table-header"
    },
    on: {
      "select": _vm.selectChange,
      "select-all": _vm.selectChange
    }
  }, [_c("el-table-column", {
    attrs: {
      "align": "center",
      "type": "selection",
      "min-width": "55"
    }
  }), _vm._l(_vm.headerConfig, function(item) {
    return _c("el-table-column", {
      key: item.prop,
      attrs: {
        "label": item.label,
        "prop": item.prop,
        "align": "center",
        "min-width": item.width || 55
      }
    });
  })], 2), _c("el-pagination", {
    staticClass: "pagination",
    attrs: {
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "current-page": _vm.pagination.pageNo,
      "pager-count": 5,
      "layout": "total, prev, pager, next, jumper, sizes",
      "total": _vm.pagination.total
    },
    on: {
      "update:pageSize": function($event) {
        return _vm.$set(_vm.pagination, "pageSize", $event);
      },
      "update:page-size": function($event) {
        return _vm.$set(_vm.pagination, "pageSize", $event);
      },
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pagination, "pageNo", $event);
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pagination, "pageNo", $event);
      },
      "current-change": _vm.handlePageChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1);
};
var staticRenderFns$8 = [];
render$8._withStripped = true;
var PersonSelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$8 = defineComponent({
  components: {
    SearchDialogVue
  },
  props: {
    type: {
      type: String,
      default: "oppein"
    },
    outList: {
      type: Array,
      default: () => []
    },
    selectList: {
      type: Array,
      default: () => []
    },
    excludeUserNoList: {
      type: Array,
      default: () => ["op.00001"]
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const {
      ROOT_MARKETLEVEL,
      getDictData
    } = useDictData(["ROOT_MARKETLEVEL"]);
    getDictData();
    const marketLineRef = ref(null);
    function handleClassifyChange(val) {
      searchParams.value.regexpLineId = [];
      marketLineRef.value.getData(val[0]);
    }
    const searchParams = ref({
      searchStr: "",
      orgNo: "",
      searchOrgName: "",
      searchDepartmentName: ""
    });
    const pagination = ref({
      pageNo: 1,
      pageSize: 20,
      total: 0
    });
    const loading2 = ref(false);
    const headerConfig = ref([]);
    if (props2.type === "agent") {
      headerConfig.value = [{
        label: "\u59D3\u540D",
        prop: "name"
      }, {
        label: "\u8D26\u53F7",
        prop: "no"
      }, {
        label: "\u7EC4\u7EC7\u7F16\u7801",
        prop: "orgNo"
      }, {
        label: "\u5546\u573A\u540D\u79F0",
        prop: "orgName"
      }, {
        label: "\u5C97\u4F4D",
        prop: "positionName"
      }];
    } else {
      headerConfig.value = [{
        label: "\u59D3\u540D",
        prop: "name"
      }, {
        label: "\u5DE5\u53F7",
        prop: "no"
      }, {
        label: "\u5C97\u4F4D",
        prop: "positionName"
      }, {
        label: "\u90E8\u95E8",
        prop: "departmentName"
      }];
    }
    const multipleTable = ref(null);
    const tableData = ref([]);
    async function getPersonData() {
      if (props2.outList && props2.outList.length > 0) {
        tableData.value = props2.outList;
        pagination.value.total = props2.outList.length;
        return;
      }
      loading2.value = true;
      const _params = __spreadValues({
        excludeUserNoList: props2.excludeUserNoList,
        pageNo: pagination.value.pageNo,
        pageSize: pagination.value.pageSize
      }, searchParams.value);
      if (props2.type === "oppein") {
        _params.orgId = "1";
      }
      const res = await getUserPageListByConToPost(_params).finally(() => {
        loading2.value = false;
      });
      if (res.status) {
        tableData.value = res.data.records;
        pagination.value.total = res.data.total;
        initSelect();
      }
    }
    async function handleSearch() {
      pagination.value.pageNo = 1;
      pagination.value.pageSize = 20;
      await getPersonData();
    }
    async function handlePageChange(val) {
      pagination.value.pageNo = val;
      await getPersonData();
    }
    async function handleSizeChange(val) {
      pagination.value.pageSize = val;
      await getPersonData();
    }
    async function getMultipleData(params, cb) {
      const str = params.replace(/[,，\s]/g, ",");
      let list = str.split(",").filter((x) => !!x);
      list = list.filter((x) => !props2.excludeUserNoList.some((i) => i.toLocaleUpperCase() === x.toLocaleUpperCase()));
      if (list.length > 1e3) {
        _Message.error("\u641C\u7D22\u4EBA\u5458\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC71000\u4E2A");
        return;
      }
      if (list.length === 0) {
        _Message.error("\u8BF7\u8F93\u5165\u5458\u5DE5\u5DE5\u53F7");
        return;
      }
      cb();
      loading2.value = true;
      pagination.value.pageSize = 1e3;
      pagination.value.pageNo = 1;
      const res = await getUserByConPost({
        pageNo: 1,
        pageSize: 1e3,
        accountList: list,
        orgId: "1"
      }).finally(() => {
        loading2.value = false;
      });
      if (res.status) {
        tableData.value = res.data;
        pagination.value.total = res.data.length;
        const unSearchList = [];
        const resultList = tableData.value.map((item) => item.account.toLocaleUpperCase());
        list.forEach((no) => {
          if (!resultList.includes(no.toLocaleUpperCase())) {
            unSearchList.push(no);
          }
        });
        if (unSearchList.length > 0) {
          _MessageBox.confirm(`${unSearchList.join(",")}\u65E0\u7ED3\u679C\u8FD4\u56DE\uFF01`, "\u7CFB\u7EDF\u63D0\u793A", {
            closeOnClickModal: false
          });
        }
      }
    }
    function initSelect() {
      multipleTable.value.clearSelection();
      currentSelectList.value = [];
      for (let item of tableData.value) {
        if (props2.selectList.some((x) => x.id === item.id)) {
          nextTick(() => {
            multipleTable.value.toggleRowSelection(item, true);
            currentSelectList.value.push(item);
          });
        }
      }
    }
    watch(() => props2.selectList, (val) => {
      initSelect();
    });
    const currentSelectList = ref([]);
    function selectChange(val) {
      const selectedList = [];
      const unSelectedList = [];
      const maxLength = Math.max(val.length, currentSelectList.value.length);
      if (maxLength === 0)
        return;
      for (let i = 0; i < maxLength; i++) {
        if (val[i] && !currentSelectList.value.some((c) => c.id === val[i].id)) {
          selectedList.push(val[i]);
        }
        if (currentSelectList.value[i] && !val.some((v) => v.id === currentSelectList.value[i].id)) {
          unSelectedList.push(currentSelectList.value[i]);
        }
      }
      currentSelectList.value = [...val];
      const _selectList = props2.selectList.filter((x) => !unSelectedList.some((i) => i.id === x.id)).concat(selectedList);
      emit2("update:selectList", _selectList);
    }
    return {
      handleClassifyChange,
      marketLineRef,
      searchParams,
      pagination,
      ROOT_MARKETLEVEL,
      loading: loading2,
      tableData,
      multipleTable,
      headerConfig,
      selectChange,
      handleSearch,
      handlePageChange,
      handleSizeChange,
      getMultipleData
    };
  }
});
const __cssModules$8 = {};
var __component__$8 = /* @__PURE__ */ normalizeComponent(__vue2_script$8, render$8, staticRenderFns$8, false, __vue2_injectStyles$8, "9e6fe472", null, null);
function __vue2_injectStyles$8(context2) {
  for (let o in __cssModules$8) {
    this[o] = __cssModules$8[o];
  }
}
__component__$8.options.__file = "packages/op-uc-all-selector/src/pc/component/PersonSelect.vue";
var PersonSelect = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "position-select"
  }, [_c("span", [_vm._v("\u4E8B\u4E1A\u90E8\uFF1A")]), _c("el-select", {
    attrs: {
      "placeholder": "\u8BF7\u9009\u62E9\u4E8B\u4E1A\u90E8",
      "clearable": "",
      "size": "small"
    },
    on: {
      "change": _vm.handleClassfiySelect
    },
    model: {
      value: _vm.classifySelected,
      callback: function($$v) {
        _vm.classifySelected = $$v;
      },
      expression: "classifySelected"
    }
  }, [_c("el-option", {
    key: "all",
    attrs: {
      "label": "\u5168\u90E8",
      "value": "all"
    }
  }), _vm._l(_vm.classifyList, function(item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  })], 2), _c("div", {
    staticClass: "job-head"
  }, [_c("el-checkbox", {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.handleCheckAllPositionChange
    },
    model: {
      value: _vm.isAllPositionByClassify[_vm.classifySelected],
      callback: function($$v) {
        _vm.$set(_vm.isAllPositionByClassify, _vm.classifySelected, $$v);
      },
      expression: "isAllPositionByClassify[classifySelected]"
    }
  }, [_vm._v("\u5168\u9009")])], 1), _c("div", {
    staticClass: "jobs-box"
  }, [_c("el-checkbox-group", {
    staticStyle: {
      "margin": "10px 0"
    },
    on: {
      "change": _vm.handleCheckedPositionChange
    },
    model: {
      value: _vm.currentSelectList,
      callback: function($$v) {
        _vm.currentSelectList = $$v;
      },
      expression: "currentSelectList"
    }
  }, _vm._l(_vm.positionListWithClassify, function(item) {
    return _c("el-col", {
      key: item.positionValue,
      staticStyle: {
        "margin": "5px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c("el-checkbox", {
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.label))])], 1);
  }), 1)], 1)], 1);
};
var staticRenderFns$7 = [];
render$7._withStripped = true;
var PositionSelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$7 = defineComponent({
  props: {
    selectList: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const {
      ROOT_market_classify: classifyList,
      ROOT_MARKET_POST_TYPE: positionList,
      getDictData
    } = useDictData(["ROOT_market_classify", "ROOT_MARKET_POST_TYPE"]);
    const classifySelected = ref("all");
    const classifySelectedName = ref("\u5168\u90E8");
    const currentSelectList = ref([]);
    const isAllPositionByClassify = ref({
      all: false
    });
    const searchChannelName = ref("");
    ref("");
    const classPositionTypeList = computed(() => {
      const list = {};
      classifyList.value.forEach((classItem) => {
        list[classItem.value] = positionList.value.map((item) => {
          const newItem = JSON.parse(JSON.stringify(item));
          newItem.marketClassify = classItem.value;
          newItem.marketClassifyName = classItem.label;
          newItem.positionValue = newItem.value;
          return newItem;
        });
      });
      list["all"] = positionList.value.map((item) => {
        const newItem = JSON.parse(JSON.stringify(item));
        newItem.marketClassify = "all";
        newItem.positionValue = newItem.value;
        newItem.marketClassifyName = "\u5168\u90E8";
        return newItem;
      });
      return list;
    });
    const currentClassifyList = computed(() => {
      return (props2.selectList || []).reduce((prev4, next3) => {
        if (!prev4.includes(next3.marketClassify)) {
          prev4.push(next3.marketClassify);
        }
        return prev4;
      }, []);
    });
    const positionListWithClassify = computed(() => {
      return classPositionTypeList.value[classifySelected.value] || [];
    });
    function handleCheckedPositionChange(val) {
      isAllPositionByClassify.value[classifySelected.value] = val.length && val.length === positionListWithClassify.value.length;
      emit2("update:selectList", currentSelectList.value);
    }
    function setCurrentList() {
      let _currentList = [];
      currentClassifyList.value.forEach((classify) => {
        if (classPositionTypeList.value[classify]) {
          _currentList = _currentList.concat(classPositionTypeList.value[classify].filter((x) => {
            return props2.selectList.some((item) => item.marketClassify === x.marketClassify && item.positionValue === x.positionValue);
          }));
        }
      });
      currentSelectList.value = _currentList;
    }
    function handleClassfiySelect(val) {
      let obj = classifyList.value.find((item) => {
        return item.value === val;
      });
      if (obj) {
        classifySelectedName.value = obj.label;
      } else {
        classifySelectedName.value = "\u5168\u90E8";
      }
    }
    function handleCheckAllPositionChange(val) {
      if (val) {
        positionListWithClassify.value.forEach((item) => {
          if (!currentSelectList.value.some((c) => item.positionValue === c.positionValue && item.marketClassify === c.marketClassify)) {
            currentSelectList.value.push(item);
          }
        });
      } else {
        positionListWithClassify.value.forEach((item) => {
          if (currentSelectList.value.some((c) => item.positionValue === c.positionValue && item.marketClassify === c.marketClassify)) {
            const index2 = currentSelectList.value.findIndex((c) => item.positionValue === c.positionValue && item.marketClassify === c.marketClassify);
            currentSelectList.value.splice(index2, 1);
          }
        });
      }
      emit2("update:selectList", currentSelectList.value);
    }
    onMounted(async () => {
      await getDictData();
      classifyList.value.forEach((classify) => {
        isAllPositionByClassify.value[classify.value] = false;
      });
      setCurrentList();
    });
    return {
      classifyList,
      classifySelected,
      classifySelectedName,
      isAllPositionByClassify,
      searchChannelName,
      classPositionTypeList,
      currentSelectList,
      positionListWithClassify,
      handleClassfiySelect,
      handleCheckedPositionChange,
      handleCheckAllPositionChange
    };
  }
});
const __cssModules$7 = {};
var __component__$7 = /* @__PURE__ */ normalizeComponent(__vue2_script$7, render$7, staticRenderFns$7, false, __vue2_injectStyles$7, "05520b1b", null, null);
function __vue2_injectStyles$7(context2) {
  for (let o in __cssModules$7) {
    this[o] = __cssModules$7[o];
  }
}
__component__$7.options.__file = "packages/op-uc-all-selector/src/pc/component/PositionSelect.vue";
var PositionSelect = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "classify-select"
  }, [_c("div", {
    staticClass: "classify-select__search"
  }, [_c("el-input", {
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u5173\u952E\u5B57"
    },
    model: {
      value: _vm.searchText,
      callback: function($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  })], 1), _c("div", {
    staticClass: "classify-select__content"
  }, [_c("el-tree", {
    ref: "tree",
    attrs: {
      "data": _vm.treeData,
      "props": _vm.prop,
      "show-checkbox": "",
      "check-strictly": true,
      "default-checked-keys": _vm.checkedList,
      "default-expanded-keys": _vm.checkedList,
      "node-key": "id",
      "filter-node-method": _vm.filterNode
    },
    on: {
      "check": _vm.handleCheck
    }
  })], 1)]);
};
var staticRenderFns$6 = [];
render$6._withStripped = true;
var ClassifySelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$6 = defineComponent({
  props: {
    classify: {
      type: Array,
      default: () => []
    },
    selectList: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const {
      treeData,
      getTreeData
    } = getMarketLine();
    getTreeData(props2.classify);
    const searchText = ref("");
    const prop = ref({
      label: "name",
      children: "children",
      disabled: function(data22, node2) {
        if (node2.data.type !== "CLASSIFY") {
          return true;
        }
      }
    });
    const checkedList = computed(() => {
      return props2.selectList.map((item) => item.classifyId);
    });
    const currentSelectList = ref([]);
    const handleCheck = (item, prop2) => {
      const {
        checkedKeys,
        checkedNodes,
        halfCheckedKeys,
        halfCheckedNodes
      } = prop2;
      const _selectList = checkedNodes.map((item2) => {
        return {
          classifyId: item2.id,
          classifyName: item2.name
        };
      });
      currentSelectList.value = _selectList;
      emit2("update:selectList", _selectList);
    };
    const filterNode = (value9, data22) => {
      if (!value9)
        return true;
      return data22.name.indexOf(value9) !== -1;
    };
    return {
      searchText,
      treeData,
      prop,
      checkedList,
      currentSelectList,
      handleCheck,
      filterNode
    };
  },
  watch: {
    searchText(val) {
      this.$refs.tree.filter(val);
    },
    selectList(val) {
      const idList = val.map((item) => item.classifyId);
      this.$refs.tree.setCheckedKeys([]);
      this.$refs.tree.setCheckedKeys(idList);
    }
  }
});
const __cssModules$6 = {};
var __component__$6 = /* @__PURE__ */ normalizeComponent(__vue2_script$6, render$6, staticRenderFns$6, false, __vue2_injectStyles$6, "0618d294", null, null);
function __vue2_injectStyles$6(context2) {
  for (let o in __cssModules$6) {
    this[o] = __cssModules$6[o];
  }
}
__component__$6.options.__file = "packages/op-uc-all-selector/src/pc/component/ClassifySelect.vue";
var ClassifySelect = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "position-select"
  }, [_c("span", [_vm._v("\u4E8B\u4E1A\u90E8\uFF1A")]), _c("el-select", {
    attrs: {
      "placeholder": "\u8BF7\u9009\u62E9\u4E8B\u4E1A\u90E8",
      "clearable": "",
      "size": "small"
    },
    on: {
      "change": _vm.handleClassfiySelect
    },
    model: {
      value: _vm.classifySelected,
      callback: function($$v) {
        _vm.classifySelected = $$v;
      },
      expression: "classifySelected"
    }
  }, [_c("el-option", {
    key: "all",
    attrs: {
      "label": "\u5168\u90E8",
      "value": "all"
    }
  }), _vm._l(_vm.classifyList, function(item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  })], 2), _c("el-input", {
    staticStyle: {
      "width": "200px",
      "margin": "0 10px"
    },
    attrs: {
      "placeholder": "\u8BF7\u8F93\u5165\u6E20\u9053\u540D\u79F0\u8FDB\u884C\u641C\u7D22",
      "clearable": ""
    },
    model: {
      value: _vm.searchChannelName,
      callback: function($$v) {
        _vm.searchChannelName = $$v;
      },
      expression: "searchChannelName"
    }
  }), _c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchCurrentChannel
    }
  }, [_vm._v("\u67E5\u8BE2")]), _c("el-button", {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.resetSearchChannelName
    }
  }, [_vm._v("\u91CD\u7F6E")]), _c("div", {
    staticClass: "job-head"
  }, [_c("el-checkbox", {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.handleCheckAllPositionChange
    },
    model: {
      value: _vm.isAllPositionByClassify[_vm.classifySelected],
      callback: function($$v) {
        _vm.$set(_vm.isAllPositionByClassify, _vm.classifySelected, $$v);
      },
      expression: "isAllPositionByClassify[classifySelected]"
    }
  }, [_vm._v("\u5168\u9009")])], 1), _c("div", {
    staticClass: "jobs-box"
  }, _vm._l(_vm.currentClassPositionTypeList[_vm.classifySelected], function(item, index2) {
    return _c("el-col", {
      key: index2,
      class: {
        activeChannel: _vm.currentSelectList.find(function(x) {
          return x.channelCode === item.channelCode && x.marketClassify === item.marketClassify;
        })
      },
      staticStyle: {
        "margin-bottom": "4px"
      },
      attrs: {
        "span": 6
      }
    }, [_c("div", {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.addChannel(item);
        }
      }
    }, [_c("span", [_vm._v(_vm._s(item.channelName))])])]);
  }), 1)], 1);
};
var staticRenderFns$5 = [];
render$5._withStripped = true;
var ChannelSelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$5 = defineComponent({
  props: {
    selectList: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const {
      ROOT_market_classify: classifyList,
      getDictData
    } = useDictData(["ROOT_market_classify"]);
    const {
      flatData: channelData,
      getChannel
    } = getChannelData();
    const classifySelected = ref("all");
    const classifySelectedName = ref("\u5168\u90E8");
    const currentSelectList = ref([]);
    const isAllPositionByClassify = ref({
      all: false
    });
    const searchChannelName = ref("");
    const confirmSearchChannelName = ref("");
    const classPositionTypeList = computed(() => {
      const list = {};
      classifyList.value.forEach((classItem) => {
        list[classItem.value] = channelData.value.map((item) => {
          const newItem = JSON.parse(JSON.stringify(item));
          newItem.marketClassify = classItem.value;
          newItem.marketClassifyName = classItem.label;
          return newItem;
        });
      });
      list["all"] = channelData.value.map((item) => {
        const newItem = JSON.parse(JSON.stringify(item));
        newItem.marketClassify = "all";
        newItem.marketClassifyName = "\u5168\u90E8";
        return newItem;
      });
      return list;
    });
    const currentClassifyList = computed(() => {
      return (props2.selectList || []).reduce((prev4, next3) => {
        if (!prev4.includes(next3.marketClassify)) {
          prev4.push(next3.marketClassify);
        }
        return prev4;
      }, []);
    });
    const channelListWithClassify = computed(() => {
      return classPositionTypeList.value[classifySelected.value] || [];
    });
    function searchCurrentChannel() {
      confirmSearchChannelName.value = searchChannelName.value;
      isAllPositionByClassify.value[classifySelected.value] = false;
    }
    function addChannel(item) {
      const hadSelect = currentSelectList.value.find((x) => x.channelCode === item.channelCode && x.marketClassify === item.marketClassify);
      if (hadSelect) {
        const _currentSelectList = [];
        currentSelectList.value.forEach((item2) => {
          if (hadSelect.channelCode !== item2.channelCode || hadSelect.marketClassify !== item2.marketClassify) {
            _currentSelectList.push(item2);
          }
        });
        currentSelectList.value = _currentSelectList;
      } else {
        currentSelectList.value.push(item);
      }
      emit2("update:selectList", currentSelectList.value);
    }
    function resetSearchChannelName() {
      searchChannelName.value = "";
      confirmSearchChannelName.value = "";
      currentSelectList.value = [];
      for (let key2 in isAllPositionByClassify.value) {
        isAllPositionByClassify.value[key2] = false;
      }
      emit2("update:selectList", currentSelectList.value);
    }
    function setCurrentList() {
      let _currentList = [];
      currentClassifyList.value.forEach((classify) => {
        if (classPositionTypeList.value[classify]) {
          _currentList = _currentList.concat(classPositionTypeList.value[classify].filter((x) => props2.selectList.some((item) => item.marketClassify === x.marketClassify && item.channelCode === x.channelCode)));
        }
      });
      currentSelectList.value = _currentList;
    }
    function handleClassfiySelect(val) {
      let obj = classifyList.value.find((item) => {
        return item.value === val;
      });
      if (obj) {
        classifySelectedName.value = obj.label;
      } else {
        classifySelectedName.value = "\u5168\u90E8";
      }
    }
    function handleCheckAllPositionChange(val) {
      if (val) {
        channelListWithClassify.value.forEach((item) => {
          if (!currentSelectList.value.some((c) => item.id === c.id && item.marketClassify === c.marketClassify)) {
            currentSelectList.value.push(item);
          }
        });
      } else {
        channelListWithClassify.value.forEach((item) => {
          if (currentSelectList.value.some((c) => item.id === c.id && item.marketClassify === c.marketClassify)) {
            const index2 = currentSelectList.value.findIndex((c) => item.id === c.id && item.marketClassify === c.marketClassify);
            currentSelectList.value.splice(index2, 1);
          }
        });
      }
      emit2("update:selectList", currentSelectList.value);
    }
    onMounted(async () => {
      await getDictData();
      getChannel();
      setCurrentList();
    });
    return {
      classifyList,
      channelData,
      classifySelected,
      classifySelectedName,
      isAllPositionByClassify,
      searchChannelName,
      classPositionTypeList,
      currentSelectList,
      searchCurrentChannel,
      resetSearchChannelName,
      handleClassfiySelect,
      addChannel,
      handleCheckAllPositionChange
    };
  }
});
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent(__vue2_script$5, render$5, staticRenderFns$5, false, __vue2_injectStyles$5, "52c2b08e", null, null);
function __vue2_injectStyles$5(context2) {
  for (let o in __cssModules$5) {
    this[o] = __cssModules$5[o];
  }
}
__component__$5.options.__file = "packages/op-uc-all-selector/src/pc/component/ChannelSelect.vue";
var ChannelSelect = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "uc-selector"
  }, [_vm.isShowTagList ? _c("div", {
    staticClass: "tags-area",
    on: {
      "click": function($event) {
        _vm.isDialogVisible = true;
      }
    }
  }, [_c("div", {
    staticClass: "tags-area__content"
  }, _vm._l(_vm.tagList, function(item, index2) {
    return _c("el-tag", {
      key: index2,
      staticClass: "tags-area__content-tag",
      attrs: {
        "type": "warning",
        "size": "small"
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1), _c("div", {
    staticClass: "tags-area-text"
  }, [_vm._v("\u8BF7\u9009\u62E9\u8303\u56F4")])]) : _vm._e(), _c("el-dialog", {
    staticClass: "selector",
    attrs: {
      "title": "\u8303\u56F4\u9009\u62E9",
      "visible": _vm.isDialogVisible,
      "before-close": _vm.onCancel,
      "fullscreen": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.isDialogVisible = $event;
      }
    }
  }, [_c("el-radio-group", {
    staticClass: "selector__type",
    attrs: {
      "size": "small"
    },
    model: {
      value: _vm.selectType,
      callback: function($$v) {
        _vm.selectType = $$v;
      },
      expression: "selectType"
    }
  }, [_vm.showAllSelectType ? [_c("el-radio", {
    attrs: {
      "label": "all",
      "border": ""
    }
  }, [_vm._v("\u5168\u90E8\u7528\u6237")]), _c("el-radio", {
    attrs: {
      "label": "oppein",
      "border": ""
    }
  }, [_vm._v("\u5168\u90E8\u96C6\u56E2\u7528\u6237")]), _c("el-radio", {
    attrs: {
      "label": "agent",
      "border": ""
    }
  }, [_vm._v("\u5168\u90E8\u7ECF\u9500\u5546\u7528\u6237")])] : _vm._e(), _vm.showOppeinTab || _vm.showAgentTab ? _c("el-radio", {
    attrs: {
      "label": "collection",
      "border": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toSelectorTabs.apply(null, arguments);
      }
    }
  }, [_vm._v("\u6307\u5B9A\u8303\u56F4")]) : _vm._e()], 2), _vm.selectType === "collection" ? _c("el-container", {
    staticClass: "selector__container"
  }, [_c("el-main", [_c("el-tabs", {
    staticStyle: {
      "height": "64vh",
      "overflow-x": "hidden",
      "overflow-y": "auto"
    },
    attrs: {
      "tab-position": "left"
    },
    on: {
      "tab-click": _vm.changeAccountType
    },
    model: {
      value: _vm.accountType,
      callback: function($$v) {
        _vm.accountType = $$v;
      },
      expression: "accountType"
    }
  }, [_vm.showOppeinTab ? _c("el-tab-pane", {
    attrs: {
      "label": "\u96C6\u56E2",
      "name": "oppein"
    }
  }, [_c("el-tabs", {
    attrs: {
      "type": "card"
    },
    model: {
      value: _vm.oppeinSubType,
      callback: function($$v) {
        _vm.oppeinSubType = $$v;
      },
      expression: "oppeinSubType"
    }
  }, [_vm.tabsConfig.includes("oppein_department") ? _c("el-tab-pane", {
    attrs: {
      "label": "\u90E8\u95E8",
      "name": "oppein_department"
    }
  }, [_c("department-tree-select", {
    ref: "departmentTreeSelect",
    attrs: {
      "select-list": _vm.oppeinDepartmentData
    },
    on: {
      "update:selectList": function($event) {
        _vm.oppeinDepartmentData = $event;
      },
      "update:select-list": function($event) {
        _vm.oppeinDepartmentData = $event;
      }
    }
  })], 1) : _vm._e(), _vm.tabsConfig.includes("oppein_person") ? _c("el-tab-pane", {
    attrs: {
      "label": "\u4EBA\u5458",
      "name": "oppein_person"
    }
  }, [_c("person-select", {
    attrs: {
      "type": "oppein",
      "select-list": _vm.oppeinPersonData,
      "exclude-user-no-list": _vm.excludeUserNoList
    },
    on: {
      "update:selectList": function($event) {
        _vm.oppeinPersonData = $event;
      },
      "update:select-list": function($event) {
        _vm.oppeinPersonData = $event;
      }
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm.showAgentTab ? _c("el-tab-pane", {
    attrs: {
      "label": "\u7ECF\u9500\u5546",
      "name": "agent"
    }
  }, [_c("el-tabs", {
    attrs: {
      "type": "card"
    },
    model: {
      value: _vm.agentSubType,
      callback: function($$v) {
        _vm.agentSubType = $$v;
      },
      expression: "agentSubType"
    }
  }, [_vm.tabsConfig.includes("agent_position") ? _c("el-tab-pane", {
    attrs: {
      "label": "\u5C97\u4F4D",
      "name": "agent_position"
    }
  }, [_c("position-select", {
    attrs: {
      "select-list": _vm.agentPositionData
    },
    on: {
      "update:selectList": function($event) {
        _vm.agentPositionData = $event;
      },
      "update:select-list": function($event) {
        _vm.agentPositionData = $event;
      }
    }
  })], 1) : _vm._e(), _vm.tabsConfig.includes("agent_skill") ? _c("el-tab-pane", {
    attrs: {
      "label": "\u4E13\u4E1A\u6280\u80FD",
      "name": "agent_skill"
    }
  }, [_c("brand-category-select", {
    model: {
      value: _vm.agentSkillsData,
      callback: function($$v) {
        _vm.agentSkillsData = $$v;
      },
      expression: "agentSkillsData"
    }
  })], 1) : _vm._e(), _vm.tabsConfig.includes("agent_person") ? _c("el-tab-pane", {
    attrs: {
      "label": "\u4EBA\u5458",
      "name": "agent_person"
    }
  }, [_c("person-select", {
    attrs: {
      "type": "agent",
      "select-list": _vm.agentPersonData
    },
    on: {
      "update:selectList": function($event) {
        _vm.agentPersonData = $event;
      },
      "update:select-list": function($event) {
        _vm.agentPersonData = $event;
      }
    }
  })], 1) : _vm._e(), _vm.tabsConfig.includes("agent_classify") ? _c("el-tab-pane", {
    attrs: {
      "label": "\u7EBF\u522B",
      "name": "agent_classify"
    }
  }, [_c("classify-select", {
    attrs: {
      "classify": _vm.classify,
      "select-list": _vm.agentClassifyData
    },
    on: {
      "update:selectList": function($event) {
        _vm.agentClassifyData = $event;
      },
      "update:select-list": function($event) {
        _vm.agentClassifyData = $event;
      }
    }
  })], 1) : _vm._e(), _vm.tabsConfig.includes("agent_market") ? _c("el-tab-pane", {
    attrs: {
      "label": "\u5546\u573A",
      "name": "agent_market"
    }
  }, [_c("market-select", {
    attrs: {
      "classify": _vm.classify,
      "select-list": _vm.agentMarketData
    },
    on: {
      "update:selectList": function($event) {
        _vm.agentMarketData = $event;
      },
      "update:select-list": function($event) {
        _vm.agentMarketData = $event;
      }
    }
  })], 1) : _vm._e(), _vm.tabsConfig.includes("agent_channel") ? _c("el-tab-pane", {
    attrs: {
      "label": "\u62DB\u5546\u6E20\u9053",
      "name": "agent_channel"
    }
  }, [_c("channel-select", {
    attrs: {
      "select-list": _vm.agentChannelData
    },
    on: {
      "update:selectList": function($event) {
        _vm.agentChannelData = $event;
      },
      "update:select-list": function($event) {
        _vm.agentChannelData = $event;
      }
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _c("el-aside", {
    staticClass: "selected-list",
    attrs: {
      "width": _vm.selectedListWidth + "px"
    }
  }, [_c("el-row", [_vm.showOppeinTab ? _c("el-col", {
    staticClass: "oppein-list",
    attrs: {
      "span": 24 * 200 / _vm.selectedListWidth
    }
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("\u5DF2\u9009\uFF08\u6B27\u6D3E\u96C6\u56E2\uFF09")]), _c("div", {
    staticClass: "content"
  }, [_vm._l(_vm.oppeinDepartmentData, function(item, index2) {
    return _c("el-tag", {
      key: index2 + "dep",
      staticClass: "selectTag",
      attrs: {
        "type": "warning",
        "closable": "",
        "size": "small"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose("oppein_department", item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name || item.label) + " ")]);
  }), _vm._l(_vm.oppeinPersonData, function(item, index2) {
    return _c("el-tag", {
      key: index2 + "user",
      staticClass: "selectTag",
      attrs: {
        "type": "success",
        "closable": "",
        "size": "small"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose("oppein_person", item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name || item.label) + " ")]);
  })], 2)]) : _vm._e(), _vm.showAgentTab ? _c("el-col", {
    staticClass: "agent-list",
    attrs: {
      "span": 24 * 200 / _vm.selectedListWidth
    }
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("\u5DF2\u9009\uFF08\u7ECF\u9500\u5546\uFF09")]), _c("div", {
    staticClass: "content"
  }, [_vm._l(_vm.agentPositionData, function(item, index2) {
    return _c("el-tag", {
      key: index2 + "pos",
      staticClass: "selectTag blueColor",
      attrs: {
        "closable": "",
        "size": "small"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose("agent_position", item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name || item.label) + _vm._s(item.marketClassify === "all" ? "" : "(" + item.marketClassifyName + ")") + " ")]);
  }), _vm._l(_vm.agentSkillsData, function(item, index2) {
    return _c("el-tag", {
      key: index2 + "pos1",
      staticClass: "selectTag blackColor",
      attrs: {
        "closable": "",
        "type": "danger",
        "size": "small"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose("agent_skill", item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.brandName) + _vm._s(item.categoryName) + " ")]);
  }), _vm._l(_vm.agentPersonData, function(item, index2) {
    return _c("el-tag", {
      key: index2 + "agent_users",
      staticClass: "selectTag",
      attrs: {
        "type": "success",
        "closable": "",
        "size": "small"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose("agent_person", item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), _vm._l(_vm.agentMarketData, function(item) {
    return _c("el-tag", {
      key: item.orgId,
      staticClass: "selectTag",
      attrs: {
        "type": "info",
        "closable": "",
        "size": "small"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose("agent_market", item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.orgName) + " ")]);
  }), _vm._l(_vm.agentClassifyData, function(item) {
    return _c("el-tag", {
      key: item.classifyId,
      staticClass: "selectTag",
      attrs: {
        "type": "warning",
        "closable": "",
        "size": "small"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose("agent_classify", item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.classifyName) + " ")]);
  }), _vm._l(_vm.agentChannelData, function(item, index2) {
    return _c("el-tag", {
      key: index2 + "pos",
      staticClass: "selectTag channelColor",
      attrs: {
        "closable": "",
        "size": "small"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose("agent_channel", item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.channelName) + _vm._s(item.marketClassify === "all" ? "" : "(" + item.marketClassifyName + ")") + " ")]);
  })], 2)]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _c("div", {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("\u53D6 \u6D88")]), _c("el-button", {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\u786E \u5B9A")])], 1)], 1)], 1);
};
var staticRenderFns$4 = [];
render$4._withStripped = true;
var selector_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$4 = {
  name: "OpUcAllSelector",
  components: {
    BrandCategorySelect,
    DepartmentTreeSelect,
    MarketSelect,
    PersonSelect,
    PositionSelect,
    ClassifySelect,
    ChannelSelect
  },
  props: {
    showAllSelectType: {
      type: Boolean,
      default: false
    },
    isShowTagList: {
      type: Boolean,
      default: true
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    excludeUserNoList: {
      type: Array,
      default: () => ["op.00001", "op.00016"]
    },
    currentSelected: {
      type: Object,
      default: () => ({
        code: "",
        department: [],
        positions: [],
        markets: [],
        skills: [],
        users: [],
        classify: []
      })
    },
    tabsConfig: {
      type: Array,
      default: () => ["oppein_department", "oppein_person", "agent_classify", "agent_position", "agent_skill", "agent_market"]
    },
    classify: {
      type: Array,
      default: () => ["OP-YG0"]
    },
    config: {
      type: Object,
      default: () => {
        return {
          department: {},
          positions: {},
          markets: {},
          skills: {},
          users: {},
          classify: {},
          appName: ""
        };
      }
    }
  },
  data() {
    return {
      isDialogVisible: false,
      selectType: "allUser",
      accountType: "oppein",
      oppeinSubType: "",
      agentSubType: "",
      oppeinDepartmentData: [],
      oppeinPersonData: [],
      agentPositionData: [],
      agentSkillsData: [],
      agentPersonData: [],
      agentMarketData: [],
      agentClassifyData: [],
      agentChannelData: [],
      codeList: [{
        label: "\u5168\u90E8\u7528\u6237",
        value: "all"
      }, {
        label: "\u5168\u90E8\u96C6\u56E2\u7528\u6237",
        value: "oppein"
      }, {
        label: "\u5168\u90E8\u7ECF\u9500\u5546\u7528\u6237",
        value: "agent"
      }],
      tagList: []
    };
  },
  computed: {
    showOppeinTab() {
      return this.tabsConfig.some((item) => item.indexOf("oppein") > -1);
    },
    showAgentTab() {
      return this.tabsConfig.some((item) => item.indexOf("agent") > -1);
    },
    selectedListWidth() {
      if (this.showOppeinTab && this.showAgentTab) {
        return 400;
      } else if (this.showOppeinTab || this.showAgentTab) {
        return 200;
      } else {
        return 0;
      }
    }
  },
  watch: {
    dialogVisible(val) {
      this.isDialogVisible = val;
    },
    currentSelected: {
      handler: function(val) {
        if (val.department) {
          this.oppeinDepartmentData = val.department.map((item) => {
            return {
              id: item.deptId,
              orgNo: item.orgNo,
              name: item.deptName
            };
          });
        }
        if (val.position) {
          this.agentPositionData = val.position.reduce((prev4, cur) => {
            const positionInfo = {
              id: cur.id,
              type: cur.type,
              label: cur.label,
              marketClassify: cur.marketClassify,
              marketClassifyName: cur.marketClassifyName,
              positionId: cur.id,
              positionType: cur.type,
              positionValue: cur.value || cur.positionValue,
              positionName: cur.label
            };
            prev4.push(positionInfo);
            return prev4;
          }, []);
        }
        if (val.markets) {
          this.agentMarketData = val.markets.reduce((prev4, cur) => {
            const marketInfo = {
              orgId: cur.orgId,
              orgName: cur.orgName,
              orgNo: cur.orgNo,
              orgRegion: cur.orgRegion
            };
            prev4.push(marketInfo);
            return prev4;
          }, []);
        }
        if (val.skills)
          this.agentSkillsData = val.skills;
        if (val.classify)
          this.agentClassifyData = val.classify;
        if (val.users) {
          const _oppein = [];
          const _agent = [];
          val.users.forEach((item) => {
            item.userId = item.id;
            item.userName = item.name;
            const userInfo = {
              id: item.id,
              name: item.name,
              userId: item.id,
              userName: item.name,
              account: item.account,
              orgNo: item.orgNo,
              orgId: item.orgId,
              departmentNo: item.departmentNo,
              positionType: item.positionType
            };
            if (item.orgNo === "OPPEIN.COM") {
              _oppein.push(userInfo);
            } else {
              _agent.push(userInfo);
            }
          });
          if (val.channel) {
            this.agentChannelData = val.channel.reduce((prev4, cur) => {
              const channelInfo = {
                channelId: cur.channelId,
                channelCode: cur.channelCode,
                channelName: cur.channelName,
                marketClassify: cur.marketClassify,
                marketClassifyName: cur.marketClassifyName
              };
              prev4.push(channelInfo);
              return prev4;
            }, []);
          }
          this.oppeinPersonData = _oppein;
          this.agentPersonData = _agent;
        }
        if (val.code) {
          this.selectType = val.code;
        }
        this.setTagsList();
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.$validator = this.$root.$validator;
    if (!this.showAllSelectType) {
      this.selectType = "collection";
      this.toSelectorTabs();
    }
  },
  methods: {
    onCancel() {
      this.$emit("update:dialogVisible", false);
      this.isDialogVisible = false;
    },
    toSelectorTabs() {
      if (this.showOppeinTab) {
        this.accountType = "oppein";
        this.oppeinSubType = this.tabsConfig.find((val) => val.indexOf("oppein") > -1);
      } else if (this.showAgentTab) {
        this.accountType = "agent";
        this.agentSubType = this.tabsConfig.find((val) => val.indexOf("agent") > -1);
      } else {
        this.accountType = "";
      }
    },
    changeAccountType(val, event) {
      if (val.name === "oppein" && (!this.oppeinSubType || this.oppeinSubType === "0")) {
        this.oppeinSubType = this.tabsConfig.find((val2) => val2.indexOf("agent") > -1);
      } else if (val.name === "agent" && (!this.agentSubType || this.agentSubType === "0")) {
        this.agentSubType = this.tabsConfig.find((val2) => val2.indexOf("agent") > -1);
      }
    },
    setTagsList() {
      const departmentTags = this.oppeinDepartmentData.map((item) => {
        item = Object.assign({}, item);
        item.label = item.name;
        return item;
      });
      const marketTags = this.agentMarketData.map((item) => {
        item = Object.assign({}, item);
        item.label = item.orgName;
        return item;
      });
      const classifyTags = this.agentClassifyData.map((item) => {
        item = Object.assign({}, item);
        item.label = item.classifyName;
        return item;
      });
      const oppeinPersonTags = this.oppeinPersonData.map((item) => {
        item = Object.assign({}, item);
        item.label = item.name;
        return item;
      });
      const agentPersonTags = this.agentPersonData.map((item) => {
        item = Object.assign({}, item);
        item.label = item.name;
        return item;
      });
      const agentSkillTags = this.agentSkillsData.map((item) => {
        item = Object.assign({}, item);
        item.label = `${item.brandName}${item.categoryName}`;
        return item;
      });
      const agentPositionTags = this.agentPositionData.map((item) => {
        item = Object.assign({}, item);
        item.label = `${item.name || item.label}${item.marketClassify === "all" ? "" : `(${item.marketClassifyName})`}`;
        return item;
      });
      const agentChannelTags = this.agentChannelData.map((item) => {
        item = Object.assign({}, item);
        item.label = `${item.channelName}${item.marketClassify === "all" ? "" : `(${item.marketClassifyName})`}`;
        return item;
      });
      const code = this.codeList.filter((item) => {
        return item.value === this.selectType;
      });
      this.tagList = [...code, ...departmentTags, ...marketTags, ...classifyTags, ...oppeinPersonTags, ...agentPersonTags, ...agentSkillTags, ...agentPositionTags, ...agentChannelTags];
      this.$emit("update:tagList", this.tagList);
    },
    handleClose(type, item) {
      switch (type) {
        case "oppein_department":
          removeItem(this.oppeinDepartmentData, ["id"]);
          break;
        case "oppein_person":
          removeItem(this.oppeinPersonData, ["id"]);
          break;
        case "agent_position":
          removeItem(this.agentPositionData, ["marketClassify", "code"]);
          break;
        case "agent_skill":
          removeItem(this.agentSkillsData, ["brandId", "categoryId"]);
          break;
        case "agent_person":
          removeItem(this.agentPersonData, ["id"]);
          break;
        case "agent_market":
          removeItem(this.agentMarketData, ["orgId"]);
          break;
        case "agent_classify":
          removeItem(this.agentClassifyData, ["classifyId"]);
          break;
        case "agent_channel":
          removeItem(this.agentChannelData, ["marketClassify", "channelCode"]);
          break;
      }
      function removeItem(list, keylist) {
        const index2 = list.findIndex((x) => keylist.every((y) => x[y] === item[y]));
        list.splice(index2, 1);
      }
    },
    handleSubmit() {
      let payload = {
        department: this.oppeinDepartmentData,
        position: this.agentPositionData,
        users: [...this.oppeinPersonData, ...this.agentPersonData],
        markets: this.agentMarketData,
        skills: this.agentSkillsData,
        classify: this.agentClassifyData,
        channel: this.agentChannelData
      };
      payload.department = payload.department.reduce((prev4, cur) => {
        const departmentsInfo = {
          deptId: cur.id,
          orgNo: cur.orgNo,
          deptName: cur.name
        };
        prev4.push(departmentsInfo);
        return prev4;
      }, []);
      payload.position = payload.position.reduce((prev4, cur) => {
        const positionInfo = {
          id: cur.id,
          type: cur.type,
          label: cur.label,
          marketClassify: cur.marketClassify,
          marketClassifyName: cur.marketClassifyName,
          positionId: cur.id,
          positionType: cur.type,
          positionValue: cur.value || cur.positionValue,
          positionName: cur.label
        };
        prev4.push(positionInfo);
        return prev4;
      }, []);
      payload.markets = payload.markets.reduce((prev4, cur) => {
        const marketInfo = {
          orgId: cur.orgId,
          orgName: cur.orgName,
          orgNo: cur.orgNo,
          orgRegion: cur.orgRegion
        };
        prev4.push(marketInfo);
        return prev4;
      }, []);
      payload.users = payload.users.reduce((prev4, cur) => {
        const userInfo = {
          id: cur.id,
          name: cur.name,
          userId: cur.id,
          userName: cur.name,
          account: cur.account,
          orgNo: cur.orgNo,
          orgId: cur.orgId,
          departmentNo: cur.departmentNo,
          positionType: cur.positionType
        };
        prev4.push(userInfo);
        return prev4;
      }, []);
      payload.channel = payload.channel.reduce((prev4, cur) => {
        const channelInfo = {
          channelId: cur.channelId,
          marketClassify: cur.marketClassify,
          marketClassifyName: cur.marketClassifyName,
          channelName: cur.channelName,
          channelCode: cur.channelCode
        };
        prev4.push(channelInfo);
        return prev4;
      }, []);
      this.$emit("update:currentSelected", payload);
      this.$emit("update:mainType", this.selectType);
      this.$emit("update:dialogVisible", false);
      this.$emit("change", payload);
      this.isDialogVisible = false;
    }
  }
};
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(__vue2_script$4, render$4, staticRenderFns$4, false, __vue2_injectStyles$4, "d47b17fa", null, null);
function __vue2_injectStyles$4(context2) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
__component__$4.options.__file = "packages/op-uc-all-selector/src/pc/selector.vue";
var OpUcAllSelector = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
OpUcAllSelector.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpUcAllSelector.name, prefix);
  Vue2.component(comName, OpUcAllSelector);
};
var __glob_6_32 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpUcAllSelector
});
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("SelectorDialog", {
    attrs: {
      "title": "\u9009\u62E9\u7528\u6237",
      "placeholder": "\u8BF7\u8F93\u5165\u5DE5\u53F7\u3001\u59D3\u540D\u641C\u7D22",
      "single": _vm.single,
      "data": _vm.tableData,
      "config": _vm.config,
      "loading": _vm.loading,
      "checked-status-key": _vm.checkedStatusKey,
      "right-text": "\u9009\u62E9\u90E8\u95E8",
      "table-columns": _vm.tableColumns,
      "pagination": _vm.pagination,
      "append-to-body": _vm.appendToBody,
      "width": "80%",
      "quick-search-props": "name,account"
    },
    on: {
      "update:data": function($event) {
        _vm.tableData = $event;
      },
      "load": _vm.loadData,
      "reset": _vm.reset,
      "click-right": _vm.openOrgsTree,
      "onConfirm": _vm.onConfirm
    },
    scopedSlots: _vm._u([{
      key: "modal",
      fn: function() {
        return [_c("op-orgs-tree", {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }],
          ref: "opOrgsTree",
          on: {
            "node-click": _vm.handleNodeClick
          }
        })];
      },
      proxy: true
    }, {
      key: "search",
      fn: function() {
        return [_c("el-select", {
          attrs: {
            "placeholder": "\u8BF7\u9009\u62E9\u5C97\u4F4D",
            "size": "small",
            "clearable": "",
            "filterable": ""
          },
          on: {
            "change": _vm.handleSelectPosition
          },
          model: {
            value: _vm.positionId,
            callback: function($$v) {
              _vm.positionId = $$v;
            },
            expression: "positionId"
          }
        }, _vm._l(_vm.positionList, function(item) {
          return _c("el-option", {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          });
        }), 1)];
      },
      proxy: true
    }, _vm.showLeaveBtn ? {
      key: "rightAction",
      fn: function(ref2) {
        var params = ref2.params;
        return [_c("el-button", {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.searchLeave(params);
            }
          }
        }, [_vm._v("\u79BB\u804C\u4EBA\u5458\u67E5\u8BE2")])];
      }
    } : null], null, true),
    model: {
      value: _vm.userVals,
      callback: function($$v) {
        _vm.userVals = $$v;
      },
      expression: "userVals"
    }
  });
};
var staticRenderFns$3 = [];
render$3._withStripped = true;
const __vue2_script$3 = defineComponent({
  name: "OpUserSelector",
  components: {
    SelectorDialog: OpSelectorDialog
  },
  props: {
    value: String,
    single: Boolean,
    config: Object,
    appendToBody: {
      type: Boolean,
      default: false
    },
    leave: {
      type: Boolean,
      default: false
    },
    excludeUserNoList: {
      type: Array,
      default: () => ["op.00001"]
    },
    checkedStatusKey: {
      type: String,
      default: "id"
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    const tableData = ref([]);
    const loading2 = ref(false);
    const departmentIdList = ref([]);
    const opOrgsTree = ref(null);
    const pagination = ref({
      pageNo: 1,
      pageSize: 20,
      total: 0,
      showTotal: true
    });
    const userVals = computed({
      get() {
        return props2.value;
      },
      set(newValue) {
        emit2("input", newValue);
      }
    });
    const tableColumns = ref([{
      prop: "name",
      label: "\u540D\u79F0",
      width: "100"
    }, {
      prop: "account",
      label: "\u8D26\u53F7",
      width: "120"
    }, {
      prop: "departmentName",
      label: "\u90E8\u95E8\u540D\u79F0",
      width: "200"
    }, {
      prop: "positionName",
      label: "\u5C97\u4F4D\u540D\u79F0"
    }]);
    const showLeaveBtn = computed(() => {
      return props2.leave;
    });
    const noRequestData = ref(false);
    const searchLeave = async (param) => {
      loading2.value = true;
      const {
        querys
      } = param;
      let searchStr = "";
      if (querys) {
        searchStr = querys.name;
      }
      if (!searchStr) {
        return;
      }
      const _params = {
        searchStr,
        accountStatus: 5,
        orgId: "1"
      };
      const res = await getUserByConPost(_params);
      tableData.value = res.data;
      pagination.value.total = res.data.length;
      loading2.value = false;
    };
    const reset2 = async () => {
      departmentIdList.value = [];
      tableData.value = [];
      noRequestData.value = false;
    };
    const loadData = async (param) => {
      let searchStr = "";
      if (param && param.querys && param.querys.name) {
        searchStr = param.querys["name"];
      }
      if (param) {
        pagination.value.pageNo = param.pageNo || 1;
        pagination.value.pageSize = param.pageSize || 20;
      }
      let _params = {
        searchStr,
        excludeUserNoList: props2.excludeUserNoList,
        orgId: "1",
        pageNo: pagination.value.pageNo,
        pageSize: pagination.value.pageSize
      };
      if (departmentIdList.value.length > 0 && departmentIdList.value[0] !== "-1") {
        _params.regexpDepartmentId = departmentIdList.value[0];
      }
      if (positionId.value) {
        _params.positionId = positionId.value;
      }
      if (!searchStr && departmentIdList.value.length === 0) {
        return;
      }
      loading2.value = true;
      const {
        status,
        data: data22
      } = await getUserPageListByConToPost(_params);
      loading2.value = false;
      if (status) {
        noRequestData.value = data22.records.length === 0;
        if (!isPCWidth() && data22.current > 1) {
          tableData.value = [...tableData.value, ...data22.records];
        } else {
          tableData.value = data22.records;
        }
        pagination.value.pageSize = data22.size;
        pagination.value.total = data22.total;
      }
    };
    const handleNodeClick = (org) => {
      if (loading2.value) {
        return;
      }
      positionId.value = "";
      pagination.value.pageNo = 1;
      departmentIdList.value = [org.id];
      getPositionList(org.id);
      loadData();
    };
    const positionList = ref([]);
    const positionId = ref("");
    async function getPositionList(id) {
      const params = {
        orgId: "1",
        departmentId: id,
        pageNo: 1,
        pageSize: 30
      };
      const {
        status,
        data: data22
      } = await getPositionPageListByConToPost(params);
      if (status) {
        positionList.value = data22.records.map((item) => {
          return {
            label: item.name,
            value: item.id
          };
        });
      }
    }
    function handleSelectPosition() {
      pagination.value.pageNo = 1;
      loadData();
    }
    const onConfirm = (users) => {
      emit2("onConfirm", users);
    };
    function openOrgsTree() {
      opOrgsTree.value.showPopup();
    }
    return {
      tableData,
      loading: loading2,
      pagination,
      tableColumns,
      positionList,
      positionId,
      handleSelectPosition,
      userVals,
      opOrgsTree,
      openOrgsTree,
      showLeaveBtn,
      loadData,
      searchLeave,
      reset: reset2,
      handleNodeClick,
      onConfirm
    };
  }
});
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(__vue2_script$3, render$3, staticRenderFns$3, false, __vue2_injectStyles$3, null, null, null);
function __vue2_injectStyles$3(context2) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
__component__$3.options.__file = "packages/op-user-selector/src/OpUserSelector.vue";
var OpUserSelector = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
OpUserSelector.install = (Vue2, opt = {}) => {
  const {
    prefix
  } = opt;
  const comName = changeComPrefix(OpUserSelector.name, prefix);
  Vue2.use(OpOrgsTree);
  Vue2.component(comName, OpUserSelector);
  Vue2.use(OpFormMap);
};
var __glob_6_33 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": OpUserSelector
});
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div");
};
var staticRenderFns$2 = [];
render$2._withStripped = true;
const __vue2_script$2 = defineComponent$1({
  name: "OpVoiceRecord"
});
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(__vue2_script$2, render$2, staticRenderFns$2, false, __vue2_injectStyles$2, null, null, null);
function __vue2_injectStyles$2(context2) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
__component__$2.options.__file = "packages/op-voice-record/src/pc/index.vue";
var PcComponent = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var index$b = "";
var _createNamespace$c = createNamespace("action-sheet"), createComponent$c = _createNamespace$c[0], bem$c = _createNamespace$c[1];
function ActionSheet(h, props2, slots2, ctx) {
  var title2 = props2.title, cancelText = props2.cancelText, closeable = props2.closeable;
  function onCancel() {
    emit$2(ctx, "input", false);
    emit$2(ctx, "cancel");
  }
  function Header() {
    if (title2) {
      return h("div", {
        "class": bem$c("header")
      }, [title2, closeable && h(_Icon, {
        "attrs": {
          "name": props2.closeIcon
        },
        "class": bem$c("close"),
        "on": {
          "click": onCancel
        }
      })]);
    }
  }
  function Option(item, index2) {
    var disabled = item.disabled, loading2 = item.loading, callback2 = item.callback;
    function onClickOption(event) {
      event.stopPropagation();
      if (disabled || loading2) {
        return;
      }
      if (callback2) {
        callback2(item);
      }
      if (props2.closeOnClickAction) {
        emit$2(ctx, "input", false);
      }
      Vue$1.nextTick(function() {
        emit$2(ctx, "select", item, index2);
      });
    }
    function OptionContent() {
      if (loading2) {
        return h(Loading$1, {
          "class": bem$c("loading-icon")
        });
      }
      return [h("span", {
        "class": bem$c("name")
      }, [item.name]), item.subname && h("div", {
        "class": bem$c("subname")
      }, [item.subname])];
    }
    return h("button", {
      "attrs": {
        "type": "button"
      },
      "class": [bem$c("item", {
        disabled,
        loading: loading2
      }), item.className],
      "style": {
        color: item.color
      },
      "on": {
        "click": onClickOption
      }
    }, [OptionContent()]);
  }
  function CancelText() {
    if (cancelText) {
      return [h("div", {
        "class": bem$c("gap")
      }), h("button", {
        "attrs": {
          "type": "button"
        },
        "class": bem$c("cancel"),
        "on": {
          "click": onCancel
        }
      }, [cancelText])];
    }
  }
  function Description() {
    var description = (slots2.description == null ? void 0 : slots2.description()) || props2.description;
    if (description) {
      return h("div", {
        "class": bem$c("description")
      }, [description]);
    }
  }
  return h(_Popup, _mergeJSXProps([{
    "class": bem$c(),
    "attrs": {
      "position": "bottom",
      "round": props2.round,
      "value": props2.value,
      "overlay": props2.overlay,
      "duration": props2.duration,
      "lazyRender": props2.lazyRender,
      "lockScroll": props2.lockScroll,
      "getContainer": props2.getContainer,
      "closeOnPopstate": props2.closeOnPopstate,
      "closeOnClickOverlay": props2.closeOnClickOverlay,
      "safeAreaInsetBottom": props2.safeAreaInsetBottom
    }
  }, inherit(ctx, true)]), [Header(), Description(), h("div", {
    "class": bem$c("content")
  }, [props2.actions && props2.actions.map(Option), slots2.default == null ? void 0 : slots2.default()]), CancelText()]);
}
ActionSheet.props = _extends$o({}, popupMixinProps, {
  title: String,
  actions: Array,
  duration: [Number, String],
  cancelText: String,
  description: String,
  getContainer: [String, Function],
  closeOnPopstate: Boolean,
  closeOnClickAction: Boolean,
  round: {
    type: Boolean,
    default: true
  },
  closeable: {
    type: Boolean,
    default: true
  },
  closeIcon: {
    type: String,
    default: "cross"
  },
  safeAreaInsetBottom: {
    type: Boolean,
    default: true
  },
  overlay: {
    type: Boolean,
    default: true
  },
  closeOnClickOverlay: {
    type: Boolean,
    default: true
  }
});
var _ActionSheet = createComponent$c(ActionSheet);
class FileUploadBase {
  constructor() {
    this.ossPath = baseUrlInst.getBaseUrl().ossPath;
    this.cdnPath = baseUrlInst.getBaseUrl().cdnPath;
    this.props = null;
  }
  setOssPath(ossPath) {
    this.ossPath = ossPath;
    return this;
  }
  setProps(props2) {
    this.props = props2;
    return this;
  }
  handleSrc(file, config = {
    cdn: true,
    compress: false
  }) {
    const _config = Object.assign({
      cdn: true,
      compress: false
    }, config);
    let url2 = file[this.props.src] || (file == null ? void 0 : file.ossKey) || (file == null ? void 0 : file.path) || (file == null ? void 0 : file.url) || (file == null ? void 0 : file.src) || (file == null ? void 0 : file.name);
    if (!url2) {
      return "";
    }
    let formarUrl = "";
    if (_config && _config.cdn) {
      formarUrl = url2.substr(0, 4).toLowerCase() === "http" ? url2 : this.cdnPath + url2;
    } else {
      formarUrl = url2.substr(0, 4).toLowerCase() === "http" ? url2 : this.ossPath + url2;
    }
    if (_config && _config.compress) {
      if (formarUrl.indexOf("?") == -1) {
        formarUrl += "?x-oss-process=image/resize,m_lfit,h_100,w_100";
      }
    }
    return formatOssUrl(formarUrl);
  }
  handleName(file) {
    return file[this.props.name] || file.filename || file.name || file.ossKey || file.path || "\u672A\u77E5\u540D\u79F0";
  }
  openPreview(file, open3 = true) {
    const previewUrl = `https://fileview.oppein.com/onlinePreview?url=${encodeURIComponent(gBase64.encode(this.handleSrc(file)))}`;
    if (open3) {
      window.open(previewUrl);
    } else {
      return previewUrl;
    }
  }
  judgSuffix(file) {
    const fileUrl = this.handleSrc(file);
    if (!fileUrl)
      return "";
    const _url = new URL(fileUrl);
    if (!URL)
      return "";
    if (!_url || !_url.pathname)
      return "";
    const fileExt = _url.pathname.split(".")[1].toLocaleUpperCase();
    let imgType = ["PNG", "JPG", "JPEG", "BMP", "GIF", "WEBP", "SVG", "TIFF"];
    let videpType = ["MP4", "MOV", "AVI", "TS", "RMVB"];
    let audioType = ["MP3", "WAV", "OGG"];
    let type = "";
    if (imgType.indexOf(fileExt) > -1) {
      type = "IMG";
    } else if (videpType.indexOf(fileExt) > -1) {
      type = "VIDEO";
    } else if (audioType.indexOf(fileExt) > -1) {
      type = "AUDIO";
    } else {
      type = fileExt;
    }
    return type;
  }
  getFileIcon(file) {
    const suffix = this.judgSuffix(file);
    const suffixIcons = {
      IMG: "icon-image",
      VIDEO: "icon-shipin",
      DOCX: "icon-word",
      DOC: "icon-word",
      WORD: "icon-word",
      PDF: "icon-pdf",
      EXCEL: "icon-Excel",
      PPT: "icon-ppt",
      XML: "icon-XML"
    };
    return suffixIcons[suffix] || "icon-file";
  }
}
const fileProps = {
  props: {
    type: Object,
    default: () => {
      return {
        name: "name",
        src: "ossKey"
      };
    }
  },
  value: {
    type: Array,
    default: () => []
  },
  sysPlatForm: {
    type: String
  },
  businessType: {
    type: String,
    require: true
  },
  authType: {
    type: [Number, String],
    default: 0
  },
  signatureOption: {
    type: Object,
    default: () => null
  },
  multiPart: {
    type: Boolean,
    default: false
  }
};
function useFileUpload(props2, onDownload) {
  const loading2 = ref(false);
  const opUpload = ref(null);
  const fileUploadBase = ref(null);
  ref("\u4F60\u9009\u62E9\u7684\u6587\u4EF6\u4E0D\u7B26\u5408\u4E0A\u4F20\u89C4\u5219");
  function init2() {
    fileUploadBase.value = new FileUploadBase();
    fileUploadBase.value.setProps(props2.props);
    const oauth2AccessToken = getOauth2AccessToken();
    const apigateway = baseUrlInst.getBaseUrl().apigateway;
    if (!oauth2AccessToken || !apigateway) {
      throw new Error("\u4E0A\u4F20\u7EC4\u4EF6\u521D\u59CB\u5316\u5931\u8D25, \u8BF7\u68C0\u6D4B\u662F\u5426\u914D\u7F6E\u5B8C\u6574");
    }
    const _code = getAppCode();
    opUpload.value = new OssUpload({
      appCode: props2.appCode || _code.appCode,
      subAppCode: props2.subAppCode || _code.subAppCode,
      baseURL: apigateway,
      token: oauth2AccessToken
    });
  }
  async function ossDownLoad(item) {
    if (!opUpload.value) {
      throw new Error("Oss\u5B9E\u4F8B\u672A\u751F\u6210");
    }
    let fileName = item.filename || item.name || item.ossKey || item.path;
    let filePath = item.path || item.ossKey || item.name;
    const downResult = await opUpload.value.downloadPath(filePath, fileName, props2.authType || 0);
    if (onDownload && typeof onDownload === "function") {
      onDownload(item, downResult);
      return;
    } else {
      window.open(downResult);
    }
  }
  async function ossUpload(file) {
    const {
      subAppCode,
      appCode
    } = getAppCode();
    if (!props2.businessType) {
      throw new Error("\u4E0A\u4F20\u6587\u4EF6\u5FC5\u987B\u5B9A\u4E49businessType");
    }
    loading2.value = true;
    const resData = await opUpload.value.uploadFile(file, {
      sysPlatform: props2.sysPlatForm || appCode,
      businessType: props2.businessType
    }, props2.authType);
    loading2.value = false;
    return resData;
  }
  async function ossMultiPartUpload(file, checkpointId, callback2) {
    const {
      subAppCode,
      appCode
    } = getAppCode();
    if (!props2.businessType) {
      throw new Error("\u4E0A\u4F20\u6587\u4EF6\u5FC5\u987B\u5B9A\u4E49businessType");
    }
    loading2.value = true;
    const resData = await opUpload.value.multipartUpload(file, {
      sysPlatform: props2.sysPlatForm || appCode,
      businessType: props2.businessType
    }, callback2, checkpointId, props2.authType);
    loading2.value = false;
    return resData;
  }
  function ossPause() {
    if (opUpload.value.__OSS)
      opUpload.value.__OSS.cancel();
  }
  if (inBrowser$1) {
    init2();
  }
  return {
    init: init2,
    ossDownLoad,
    ossPause,
    ossUpload,
    ossMultiPartUpload,
    fileUploadBase
  };
}
var recorderCore = { exports: {} };
(function(module) {
  (function(factory) {
    var browser = typeof window == "object" && !!window.document;
    var win = browser ? window : Object;
    factory(win, browser);
    if (module.exports) {
      module.exports = win.Recorder;
    }
  })(function(Export, isBrowser2) {
    var NOOP = function() {
    };
    var IsNum = function(v) {
      return typeof v == "number";
    };
    var Recorder2 = function(set4) {
      return new initFn(set4);
    };
    var LM = Recorder2.LM = "2024-04-09 19:15";
    var GitUrl = "https://github.com/xiangyuecn/Recorder";
    var RecTxt = "Recorder";
    var getUserMediaTxt = "getUserMedia";
    var srcSampleRateTxt = "srcSampleRate";
    var sampleRateTxt = "sampleRate";
    var bitRateTxt = "bitRate";
    var CatchTxt = "catch";
    var WRec2 = Export[RecTxt];
    if (WRec2 && WRec2.LM == LM) {
      WRec2.CLog(WRec2.i18n.$T("K8zP::\u91CD\u590D\u5BFC\u5165{1}", 0, RecTxt), 3);
      return;
    }
    Recorder2.IsOpen = function() {
      var stream = Recorder2.Stream;
      if (stream) {
        var tracks = stream.getTracks && stream.getTracks() || stream.audioTracks || [];
        var track = tracks[0];
        if (track) {
          var state = track.readyState;
          return state == "live" || state == track.LIVE;
        }
      }
      return false;
    };
    Recorder2.BufferSize = 4096;
    Recorder2.Destroy = function() {
      CLog(RecTxt + " Destroy");
      Disconnect();
      for (var k in DestroyList) {
        DestroyList[k]();
      }
    };
    var DestroyList = {};
    Recorder2.BindDestroy = function(key2, call) {
      DestroyList[key2] = call;
    };
    Recorder2.Support = function() {
      if (!isBrowser2)
        return false;
      var scope = navigator.mediaDevices || {};
      if (!scope[getUserMediaTxt]) {
        scope = navigator;
        scope[getUserMediaTxt] || (scope[getUserMediaTxt] = scope.webkitGetUserMedia || scope.mozGetUserMedia || scope.msGetUserMedia);
      }
      if (!scope[getUserMediaTxt]) {
        return false;
      }
      Recorder2.Scope = scope;
      if (!Recorder2.GetContext()) {
        return false;
      }
      return true;
    };
    Recorder2.GetContext = function(tryNew) {
      if (!isBrowser2)
        return null;
      var AC = window.AudioContext;
      if (!AC) {
        AC = window.webkitAudioContext;
      }
      if (!AC) {
        return null;
      }
      var ctx = Recorder2.Ctx;
      if (!ctx || ctx.state == "closed") {
        ctx = Recorder2.Ctx = new AC();
        Recorder2.NewCtxs = Recorder2.NewCtxs || [];
        Recorder2.BindDestroy("Ctx", function() {
          var ctx2 = Recorder2.Ctx;
          if (ctx2 && ctx2.close) {
            CloseCtx(ctx2);
            Recorder2.Ctx = 0;
          }
          var arr = Recorder2.NewCtxs;
          Recorder2.NewCtxs = [];
          for (var i = 0; i < arr.length; i++)
            CloseCtx(arr[i]);
        });
      }
      if (tryNew && ctx.close) {
        try {
          ctx = new AC();
          Recorder2.NewCtxs.push(ctx);
        } catch (e) {
          CLog("GetContext tryNew Error", 1, e);
        }
      }
      return ctx;
    };
    Recorder2.CloseNewCtx = function(ctx) {
      if (ctx && ctx != Recorder2.Ctx) {
        CloseCtx(ctx);
        var arr = Recorder2.NewCtxs || [], L = arr.length;
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == ctx) {
            arr.splice(i, 1);
            break;
          }
        }
        CLog($T("mSxV::\u5269{1}\u4E2AGetContext\u672Aclose", 0, L + "-1=" + arr.length), arr.length ? 3 : 0);
      }
    };
    var CloseCtx = function(ctx) {
      if (ctx && ctx.close) {
        ctx._isC = 1;
        try {
          ctx.close();
        } catch (e) {
          CLog("ctx close err", 1, e);
        }
      }
    };
    var ResumeCtx = Recorder2.ResumeCtx = function(ctx, check2, True, False) {
      var isEnd = 0, isBind = 0, isLsSC = 0, runC = 0, EL = "EventListener", Tag = "ResumeCtx ";
      var end = function(err, ok) {
        if (isBind) {
          bind2();
        }
        if (!isEnd) {
          isEnd = 1;
          err && False(err, runC);
          ok && True(runC);
        }
        if (ok) {
          if (!ctx._LsSC && ctx["add" + EL])
            ctx["add" + EL]("statechange", run);
          ctx._LsSC = 1;
          isLsSC = 1;
        }
      };
      var bind2 = function(add2) {
        if (add2 && isBind)
          return;
        isBind = add2 ? 1 : 0;
        var types2 = ["focus", "mousedown", "mouseup", "touchstart", "touchend"];
        for (var i = 0; i < types2.length; i++)
          window[(add2 ? "add" : "remove") + EL](types2[i], run, true);
      };
      var run = function() {
        var sVal = ctx.state, spEnd = CtxSpEnd(sVal);
        if (!isEnd && !check2(spEnd ? ++runC : runC))
          return end();
        if (spEnd) {
          if (isLsSC)
            CLog(Tag + "sc " + sVal, 3);
          bind2(1);
          ctx.resume().then(function() {
            if (isLsSC)
              CLog(Tag + "sc " + ctx.state);
            end(0, 1);
          })[CatchTxt](function(e) {
            CLog(Tag + "error", 1, e);
            if (!CtxSpEnd(ctx.state)) {
              end(e.message || "error");
            }
          });
        } else if (sVal == "closed") {
          if (isLsSC && !ctx._isC)
            CLog(Tag + "sc " + sVal, 1);
          end("ctx closed");
        } else {
          end(0, 1);
        }
      };
      run();
    };
    var CtxSpEnd = Recorder2.CtxSpEnd = function(v) {
      return v == "suspended" || v == "interrupted";
    };
    var CtxState = function(ctx) {
      var v = ctx.state, msg = "ctx.state=" + v;
      if (CtxSpEnd(v))
        msg += $T("nMIy::\uFF08\u6CE8\u610F\uFF1Actx\u4E0D\u662Frunning\u72B6\u6001\uFF0Crec.open\u548Cstart\u81F3\u5C11\u8981\u6709\u4E00\u4E2A\u5728\u7528\u6237\u64CD\u4F5C(\u89E6\u6478\u3001\u70B9\u51FB\u7B49)\u65F6\u8FDB\u884C\u8C03\u7528\uFF0C\u5426\u5219\u5C06\u5728rec.start\u65F6\u5C1D\u8BD5\u8FDB\u884Cctx.resume\uFF0C\u53EF\u80FD\u4F1A\u4EA7\u751F\u517C\u5BB9\u6027\u95EE\u9898(\u4EC5iOS)\uFF0C\u8BF7\u53C2\u9605\u6587\u6863\u4E2DrunningContext\u914D\u7F6E\uFF09");
      return msg;
    };
    var ConnectEnableWebM = "ConnectEnableWebM";
    Recorder2[ConnectEnableWebM] = true;
    var ConnectEnableWorklet = "ConnectEnableWorklet";
    Recorder2[ConnectEnableWorklet] = false;
    var Connect = function(streamStore, isUserMedia) {
      var bufferSize = streamStore.BufferSize || Recorder2.BufferSize;
      var stream = streamStore.Stream;
      var ctx = stream._RC || stream._c || Recorder2.GetContext(true);
      stream._c = ctx;
      var mediaConn = function(node2) {
        var media = stream._m = ctx.createMediaStreamSource(stream);
        var ctxDest = ctx.destination, cmsdTxt = "createMediaStreamDestination";
        if (ctx[cmsdTxt]) {
          ctxDest = stream._d = ctx[cmsdTxt]();
        }
        media.connect(node2);
        node2.connect(ctxDest);
      };
      var isWebM, isWorklet, badInt, webMTips = "";
      var calls = stream._call;
      var onReceive = function(float32Arr) {
        for (var k0 in calls) {
          var size2 = float32Arr.length;
          var pcm = new Int16Array(size2);
          var sum = 0;
          for (var j = 0; j < size2; j++) {
            var s = Math.max(-1, Math.min(1, float32Arr[j]));
            s = s < 0 ? s * 32768 : s * 32767;
            pcm[j] = s;
            sum += Math.abs(s);
          }
          for (var k in calls) {
            calls[k](pcm, sum);
          }
          return;
        }
      };
      var scriptProcessor = "ScriptProcessor";
      var audioWorklet = "audioWorklet";
      var recAudioWorklet = RecTxt + " " + audioWorklet;
      var RecProc = "RecProc";
      var MediaRecorderTxt = "MediaRecorder";
      var MRWebMPCM = MediaRecorderTxt + ".WebM.PCM";
      var oldFn = ctx.createScriptProcessor || ctx.createJavaScriptNode;
      var oldIsBest = $T("ZGlf::\u3002\u7531\u4E8E{1}\u5185\u90E81\u79D2375\u6B21\u56DE\u8C03\uFF0C\u5728\u79FB\u52A8\u7AEF\u53EF\u80FD\u4F1A\u6709\u6027\u80FD\u95EE\u9898\u5BFC\u81F4\u56DE\u8C03\u4E22\u5931\u5F55\u97F3\u53D8\u77ED\uFF0CPC\u7AEF\u65E0\u5F71\u54CD\uFF0C\u6682\u4E0D\u5EFA\u8BAE\u5F00\u542F{1}\u3002", 0, audioWorklet);
      var oldScript = function() {
        isWorklet = stream.isWorklet = false;
        _Disconn_n(stream);
        CLog($T("7TU0::Connect\u91C7\u7528\u8001\u7684{1}\uFF0C", 0, scriptProcessor) + i18n3.get(Recorder2[ConnectEnableWorklet] ? $T("JwCL::\u4F46\u5DF2\u8BBE\u7F6E{1}\u5C1D\u8BD5\u542F\u7528{2}", 2) : $T("VGjB::\u53EF\u8BBE\u7F6E{1}\u5C1D\u8BD5\u542F\u7528{2}", 2), [RecTxt + "." + ConnectEnableWorklet + "=true", audioWorklet]) + webMTips + oldIsBest, 3);
        var process2 = stream._p = oldFn.call(ctx, bufferSize, 1, 1);
        mediaConn(process2);
        process2.onaudioprocess = function(e) {
          var arr = e.inputBuffer.getChannelData(0);
          onReceive(arr);
        };
      };
      var connWorklet = function() {
        isWebM = stream.isWebM = false;
        _Disconn_r(stream);
        isWorklet = stream.isWorklet = !oldFn || Recorder2[ConnectEnableWorklet];
        var AwNode = window.AudioWorkletNode;
        if (!(isWorklet && ctx[audioWorklet] && AwNode)) {
          oldScript();
          return;
        }
        var clazzUrl = function() {
          var xf = function(f) {
            return f.toString().replace(/^function|DEL_/g, "").replace(/\$RA/g, recAudioWorklet);
          };
          var clazz = "class " + RecProc + " extends AudioWorkletProcessor{";
          clazz += "constructor " + xf(function(option2) {
            DEL_super(option2);
            var This = this, bufferSize2 = option2.processorOptions.bufferSize;
            This.bufferSize = bufferSize2;
            This.buffer = new Float32Array(bufferSize2 * 2);
            This.pos = 0;
            This.port.onmessage = function(e) {
              if (e.data.kill) {
                This.kill = true;
                $C.log("$RA kill call");
              }
            };
            $C.log("$RA .ctor call", option2);
          });
          clazz += "process " + xf(function(input2, b, c) {
            var This = this, bufferSize2 = This.bufferSize;
            var buffer = This.buffer, pos = This.pos;
            input2 = (input2[0] || [])[0] || [];
            if (input2.length) {
              buffer.set(input2, pos);
              pos += input2.length;
              var len = ~~(pos / bufferSize2) * bufferSize2;
              if (len) {
                this.port.postMessage({
                  val: buffer.slice(0, len)
                });
                var more = buffer.subarray(len, pos);
                buffer = new Float32Array(bufferSize2 * 2);
                buffer.set(more);
                pos = more.length;
                This.buffer = buffer;
              }
              This.pos = pos;
            }
            return !This.kill;
          });
          clazz += '}try{registerProcessor("' + RecProc + '", ' + RecProc + ')}catch(e){$C.error("' + recAudioWorklet + ' Reg Error",e)}';
          clazz = clazz.replace(/\$C\./g, "console.");
          return "data:text/javascript;base64," + btoa(unescape(encodeURIComponent(clazz)));
        };
        var awNext = function() {
          return isWorklet && stream._na;
        };
        var nodeAlive = stream._na = function() {
          if (badInt !== "") {
            clearTimeout(badInt);
            badInt = setTimeout(function() {
              badInt = 0;
              if (awNext()) {
                CLog($T("MxX1::{1}\u672A\u8FD4\u56DE\u4EFB\u4F55\u97F3\u9891\uFF0C\u6062\u590D\u4F7F\u7528{2}", 0, audioWorklet, scriptProcessor), 3);
                oldFn && oldScript();
              }
            }, 500);
          }
        };
        var createNode = function() {
          if (!awNext())
            return;
          var node2 = stream._n = new AwNode(ctx, RecProc, {
            processorOptions: {
              bufferSize
            }
          });
          mediaConn(node2);
          node2.port.onmessage = function(e) {
            if (badInt) {
              clearTimeout(badInt);
              badInt = "";
            }
            if (awNext()) {
              onReceive(e.data.val);
            } else if (!isWorklet) {
              CLog($T("XUap::{1}\u591A\u4F59\u56DE\u8C03", 0, audioWorklet), 3);
            }
          };
          CLog($T("yOta::Connect\u91C7\u7528{1}\uFF0C\u8BBE\u7F6E{2}\u53EF\u6062\u590D\u8001\u5F0F{3}", 0, audioWorklet, RecTxt + "." + ConnectEnableWorklet + "=false", scriptProcessor) + webMTips + oldIsBest, 3);
        };
        var ctxOK = function() {
          if (!awNext())
            return;
          if (ctx[RecProc]) {
            createNode();
            return;
          }
          var url2 = clazzUrl();
          ctx[audioWorklet].addModule(url2).then(function(e) {
            if (!awNext())
              return;
            ctx[RecProc] = 1;
            createNode();
            if (badInt) {
              nodeAlive();
            }
          })[CatchTxt](function(e) {
            CLog(audioWorklet + ".addModule Error", 1, e);
            awNext() && oldScript();
          });
        };
        ResumeCtx(ctx, function() {
          return awNext();
        }, ctxOK, ctxOK);
      };
      var connWebM = function() {
        var MR = window[MediaRecorderTxt];
        var onData = "ondataavailable";
        var webmType = "audio/webm; codecs=pcm";
        isWebM = stream.isWebM = Recorder2[ConnectEnableWebM];
        var supportMR = MR && onData in MR.prototype && MR.isTypeSupported(webmType);
        webMTips = supportMR ? "" : $T("VwPd::\uFF08\u6B64\u6D4F\u89C8\u5668\u4E0D\u652F\u6301{1}\uFF09", 0, MRWebMPCM);
        if (!isUserMedia || !isWebM || !supportMR) {
          connWorklet();
          return;
        }
        var mrNext = function() {
          return isWebM && stream._ra;
        };
        stream._ra = function() {
          if (badInt !== "") {
            clearTimeout(badInt);
            badInt = setTimeout(function() {
              if (mrNext()) {
                CLog($T("vHnb::{1}\u672A\u8FD4\u56DE\u4EFB\u4F55\u97F3\u9891\uFF0C\u964D\u7EA7\u4F7F\u7528{2}", 0, MediaRecorderTxt, audioWorklet), 3);
                connWorklet();
              }
            }, 500);
          }
        };
        var mrSet = Object.assign({
          mimeType: webmType
        }, Recorder2.ConnectWebMOptions);
        var mr = stream._r = new MR(stream, mrSet);
        var webmData = stream._rd = {
          sampleRate: ctx[sampleRateTxt]
        };
        mr[onData] = function(e) {
          var reader = new FileReader();
          reader.onloadend = function() {
            if (mrNext()) {
              var f32arr = WebM_Extract(new Uint8Array(reader.result), webmData);
              if (!f32arr)
                return;
              if (f32arr == -1) {
                connWorklet();
                return;
              }
              if (badInt) {
                clearTimeout(badInt);
                badInt = "";
              }
              onReceive(f32arr);
            } else if (!isWebM) {
              CLog($T("O9P7::{1}\u591A\u4F59\u56DE\u8C03", 0, MediaRecorderTxt), 3);
            }
          };
          reader.readAsArrayBuffer(e.data);
        };
        mr.start(~~(bufferSize / 48));
        CLog($T("LMEm::Connect\u91C7\u7528{1}\uFF0C\u8BBE\u7F6E{2}\u53EF\u6062\u590D\u4F7F\u7528{3}\u6216\u8001\u5F0F{4}", 0, MRWebMPCM, RecTxt + "." + ConnectEnableWebM + "=false", audioWorklet, scriptProcessor));
      };
      connWebM();
    };
    var ConnAlive = function(stream) {
      if (stream._na)
        stream._na();
      if (stream._ra)
        stream._ra();
    };
    var _Disconn_n = function(stream) {
      stream._na = null;
      if (stream._n) {
        stream._n.port.postMessage({
          kill: true
        });
        stream._n.disconnect();
        stream._n = null;
      }
    };
    var _Disconn_r = function(stream) {
      stream._ra = null;
      if (stream._r) {
        try {
          stream._r.stop();
        } catch (e) {
          CLog("mr stop err", 1, e);
        }
        stream._r = null;
      }
    };
    var Disconnect = function(streamStore) {
      streamStore = streamStore || Recorder2;
      var isGlobal = streamStore == Recorder2;
      var stream = streamStore.Stream;
      if (stream) {
        if (stream._m) {
          stream._m.disconnect();
          stream._m = null;
        }
        if (!stream._RC && stream._c) {
          Recorder2.CloseNewCtx(stream._c);
        }
        stream._RC = null;
        stream._c = null;
        if (stream._d) {
          StopS_(stream._d.stream);
          stream._d = null;
        }
        if (stream._p) {
          stream._p.disconnect();
          stream._p.onaudioprocess = stream._p = null;
        }
        _Disconn_n(stream);
        _Disconn_r(stream);
        if (isGlobal) {
          StopS_(stream);
        }
      }
      streamStore.Stream = 0;
    };
    var StopS_ = Recorder2.StopS_ = function(stream) {
      var tracks = stream.getTracks && stream.getTracks() || stream.audioTracks || [];
      for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];
        track.stop && track.stop();
      }
      stream.stop && stream.stop();
    };
    Recorder2.SampleData = function(pcmDatas, pcmSampleRate, newSampleRate, prevChunkInfo, option2) {
      var Txt = "SampleData";
      prevChunkInfo || (prevChunkInfo = {});
      var index2 = prevChunkInfo.index || 0;
      var offset = prevChunkInfo.offset || 0;
      var filter = prevChunkInfo.filter;
      if (filter && filter.fn && filter.sr != pcmSampleRate) {
        filter = null;
        CLog($T("d48C::{1}\u7684filter\u91C7\u6837\u7387\u53D8\u4E86\uFF0C\u91CD\u8BBE\u6EE4\u6CE2", 0, Txt), 3);
      }
      if (!filter) {
        var freq = newSampleRate > pcmSampleRate * 3 / 4 ? 0 : newSampleRate / 2 * 3 / 4;
        filter = {
          fn: freq ? Recorder2.IIRFilter(true, pcmSampleRate, freq) : 0
        };
      }
      filter.sr = pcmSampleRate;
      var filterFn = filter.fn;
      var frameNext = prevChunkInfo.frameNext || [];
      option2 || (option2 = {});
      var frameSize = option2.frameSize || 1;
      if (option2.frameType) {
        frameSize = option2.frameType == "mp3" ? 1152 : 1;
      }
      var nLen = pcmDatas.length;
      if (index2 > nLen + 1) {
        CLog($T("tlbC::{1}\u4F3C\u4E4E\u4F20\u5165\u4E86\u672A\u91CD\u7F6Echunk {2}", 0, Txt, index2 + ">" + nLen), 3);
      }
      var size2 = 0;
      for (var i = index2; i < nLen; i++) {
        size2 += pcmDatas[i].length;
      }
      size2 = Math.max(0, size2 - Math.floor(offset));
      var step = pcmSampleRate / newSampleRate;
      if (step > 1) {
        size2 = Math.floor(size2 / step);
      } else {
        step = 1;
        newSampleRate = pcmSampleRate;
      }
      size2 += frameNext.length;
      var res = new Int16Array(size2);
      var idx = 0;
      for (var i = 0; i < frameNext.length; i++) {
        res[idx] = frameNext[i];
        idx++;
      }
      for (; index2 < nLen; index2++) {
        var o = pcmDatas[index2];
        var i = offset, il = o.length;
        var F = filterFn && filterFn.Embed, F1 = 0, F2 = 0, Fx = 0, Fy = 0;
        for (var i0 = 0, i2 = 0; i0 < il; i0++, i2++) {
          if (i2 < il) {
            if (F) {
              Fx = o[i2];
              Fy = F.b0 * Fx + F.b1 * F.x1 + F.b0 * F.x2 - F.a1 * F.y1 - F.a2 * F.y2;
              F.x2 = F.x1;
              F.x1 = Fx;
              F.y2 = F.y1;
              F.y1 = Fy;
            } else {
              Fy = filterFn ? filterFn(o[i2]) : o[i2];
            }
          }
          F1 = F2;
          F2 = Fy;
          if (i2 == 0) {
            i0--;
            continue;
          }
          var before = Math.floor(i);
          if (i0 != before)
            continue;
          var after = Math.ceil(i);
          var atPoint = i - before;
          var beforeVal = F1;
          var afterVal = after < il ? F2 : beforeVal;
          var val = beforeVal + (afterVal - beforeVal) * atPoint;
          if (val > 32767)
            val = 32767;
          else if (val < -32768)
            val = -32768;
          res[idx] = val;
          idx++;
          i += step;
        }
        offset = Math.max(0, i - il);
      }
      frameNext = null;
      var frameNextSize = res.length % frameSize;
      if (frameNextSize > 0) {
        var u8Pos = (res.length - frameNextSize) * 2;
        frameNext = new Int16Array(res.buffer.slice(u8Pos));
        res = new Int16Array(res.buffer.slice(0, u8Pos));
      }
      return {
        index: index2,
        offset,
        filter,
        frameNext,
        sampleRate: newSampleRate,
        data: res
      };
    };
    Recorder2.IIRFilter = function(useLowPass, sampleRate, freq) {
      var ov = 2 * Math.PI * freq / sampleRate;
      var sn = Math.sin(ov);
      var cs = Math.cos(ov);
      var alpha = sn / 2;
      var a0 = 1 + alpha;
      var a1 = -2 * cs / a0;
      var a2 = (1 - alpha) / a0;
      if (useLowPass) {
        var b0 = (1 - cs) / 2 / a0;
        var b1 = (1 - cs) / a0;
      } else {
        var b0 = (1 + cs) / 2 / a0;
        var b1 = -(1 + cs) / a0;
      }
      var x1 = 0, x2 = 0, y = 0, y1 = 0, y2 = 0;
      var fn2 = function(x) {
        y = b0 * x + b1 * x1 + b0 * x2 - a1 * y1 - a2 * y2;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
        return y;
      };
      fn2.Embed = {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 0,
        b0,
        b1,
        a1,
        a2
      };
      return fn2;
    };
    Recorder2.PowerLevel = function(pcmAbsSum, pcmLength) {
      var power = pcmAbsSum / pcmLength || 0;
      var level;
      if (power < 1251) {
        level = Math.round(power / 1250 * 10);
      } else {
        level = Math.round(Math.min(100, Math.max(0, (1 + Math.log(power / 1e4) / Math.log(10)) * 100)));
      }
      return level;
    };
    Recorder2.PowerDBFS = function(maxSample) {
      var val = Math.max(0.1, maxSample || 0), Pref = 32767;
      val = Math.min(val, Pref);
      val = 20 * Math.log(val / Pref) / Math.log(10);
      return Math.max(-100, Math.round(val));
    };
    Recorder2.CLog = function(msg, err) {
      if (typeof console != "object")
        return;
      var now = new Date();
      var t4 = ("0" + now.getMinutes()).substr(-2) + ":" + ("0" + now.getSeconds()).substr(-2) + "." + ("00" + now.getMilliseconds()).substr(-3);
      var recID = this && this.envIn && this.envCheck && this.id;
      var arr = ["[" + t4 + " " + RecTxt + (recID ? ":" + recID : "") + "]" + msg];
      var a = arguments, cwe = Recorder2.CLog;
      var i = 2, fn2 = cwe.log || console.log;
      if (IsNum(err)) {
        fn2 = err == 1 ? cwe.error || console.error : err == 3 ? cwe.warn || console.warn : fn2;
      } else {
        i = 1;
      }
      for (; i < a.length; i++) {
        arr.push(a[i]);
      }
      if (IsLoser) {
        fn2 && fn2("[IsLoser]" + arr[0], arr.length > 1 ? arr : "");
      } else {
        fn2.apply(console, arr);
      }
    };
    var CLog = function() {
      Recorder2.CLog.apply(this, arguments);
    };
    var IsLoser = true;
    try {
      IsLoser = !console.log.apply;
    } catch (e) {
    }
    var ID = 0;
    function initFn(set4) {
      var This = this;
      This.id = ++ID;
      Traffic();
      var o = {
        type: "mp3",
        onProcess: NOOP
      };
      for (var k in set4) {
        o[k] = set4[k];
      }
      This.set = o;
      var vB = o[bitRateTxt], vS = o[sampleRateTxt];
      if (vB && !IsNum(vB) || vS && !IsNum(vS)) {
        This.CLog($T.G("IllegalArgs-1", [$T("VtS4::{1}\u548C{2}\u5FC5\u987B\u662F\u6570\u503C", 0, sampleRateTxt, bitRateTxt)]), 1, set4);
      }
      o[bitRateTxt] = +vB || 16;
      o[sampleRateTxt] = +vS || 16e3;
      This.state = 0;
      This._S = 9;
      This.Sync = {
        O: 9,
        C: 9
      };
    }
    Recorder2.Sync = {
      O: 9,
      C: 9
    };
    Recorder2.prototype = initFn.prototype = {
      CLog,
      _streamStore: function() {
        if (this.set.sourceStream) {
          return this;
        } else {
          return Recorder2;
        }
      },
      _streamCtx: function() {
        var m = this._streamStore().Stream;
        return m && m._c;
      },
      open: function(True, False) {
        var This = this, set4 = This.set, streamStore = This._streamStore(), newCtx = 0;
        True = True || NOOP;
        var failCall = function(errMsg, isUserNotAllow) {
          isUserNotAllow = !!isUserNotAllow;
          This.CLog($T("5tWi::\u5F55\u97F3open\u5931\u8D25\uFF1A") + errMsg + ",isUserNotAllow:" + isUserNotAllow, 1);
          if (newCtx)
            Recorder2.CloseNewCtx(newCtx);
          False && False(errMsg, isUserNotAllow);
        };
        This._streamTag = getUserMediaTxt;
        var ok = function() {
          This.CLog("open ok, id:" + This.id + " stream:" + This._streamTag);
          True();
          This._SO = 0;
        };
        var Lock = streamStore.Sync;
        var lockOpen = ++Lock.O, lockClose = Lock.C;
        This._O = This._O_ = lockOpen;
        This._SO = This._S;
        var lockFail = function() {
          if (lockClose != Lock.C || !This._O) {
            var err = $T("dFm8::open\u88AB\u53D6\u6D88");
            if (lockOpen == Lock.O) {
              This.close();
            } else {
              err = $T("VtJO::open\u88AB\u4E2D\u65AD");
            }
            failCall(err);
            return true;
          }
        };
        if (!isBrowser2) {
          failCall($T.G("NonBrowser-1", ["open"]) + $T("EMJq::\uFF0C\u53EF\u5C1D\u8BD5\u4F7F\u7528RecordApp\u89E3\u51B3\u65B9\u6848") + "(" + GitUrl + "/tree/master/app-support-sample)");
          return;
        }
        var checkMsg = This.envCheck({
          envName: "H5",
          canProcess: true
        });
        if (checkMsg) {
          failCall($T("A5bm::\u4E0D\u80FD\u5F55\u97F3\uFF1A") + checkMsg);
          return;
        }
        if (set4.sourceStream) {
          This._streamTag = "set.sourceStream";
          if (!Recorder2.GetContext()) {
            failCall($T("1iU7::\u4E0D\u652F\u6301\u6B64\u6D4F\u89C8\u5668\u4ECE\u6D41\u4E2D\u83B7\u53D6\u5F55\u97F3"));
            return;
          }
          Disconnect(streamStore);
          var stream = This.Stream = set4.sourceStream;
          stream._RC = set4.runningContext;
          stream._call = {};
          try {
            Connect(streamStore);
          } catch (e) {
            Disconnect(streamStore);
            failCall($T("BTW2::\u4ECE\u6D41\u4E2D\u6253\u5F00\u5F55\u97F3\u5931\u8D25\uFF1A") + e.message);
            return;
          }
          ok();
          return;
        }
        var codeFail = function(code, msg) {
          try {
            window.top.a;
          } catch (e) {
            failCall($T("Nclz::\u65E0\u6743\u5F55\u97F3(\u8DE8\u57DF\uFF0C\u8BF7\u5C1D\u8BD5\u7ED9iframe\u6DFB\u52A0\u9EA6\u514B\u98CE\u8BBF\u95EE\u7B56\u7565\uFF0C\u5982{1})", 0, 'allow="camera;microphone"'));
            return;
          }
          if (/Permission|Allow/i.test(code)) {
            failCall($T("gyO5::\u7528\u6237\u62D2\u7EDD\u4E86\u5F55\u97F3\u6743\u9650"), true);
          } else if (window.isSecureContext === false) {
            failCall($T("oWNo::\u6D4F\u89C8\u5668\u7981\u6B62\u4E0D\u5B89\u5168\u9875\u9762\u5F55\u97F3\uFF0C\u53EF\u5F00\u542Fhttps\u89E3\u51B3"));
          } else if (/Found/i.test(code)) {
            failCall(msg + $T("jBa9::\uFF0C\u65E0\u53EF\u7528\u9EA6\u514B\u98CE"));
          } else {
            failCall(msg);
          }
        };
        if (Recorder2.IsOpen()) {
          ok();
          return;
        }
        if (!Recorder2.Support()) {
          codeFail("", $T("COxc::\u6B64\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u5F55\u97F3"));
          return;
        }
        var ctx = set4.runningContext;
        if (!ctx)
          ctx = newCtx = Recorder2.GetContext(true);
        var f1 = function(stream2) {
          setTimeout(function() {
            stream2._call = {};
            var oldStream = Recorder2.Stream;
            if (oldStream) {
              Disconnect();
              stream2._call = oldStream._call;
            }
            Recorder2.Stream = stream2;
            stream2._c = ctx;
            stream2._RC = set4.runningContext;
            if (lockFail())
              return;
            if (Recorder2.IsOpen()) {
              if (oldStream)
                This.CLog($T("upb8::\u53D1\u73B0\u540C\u65F6\u591A\u6B21\u8C03\u7528open"), 1);
              Connect(streamStore, 1);
              ok();
            } else {
              failCall($T("Q1GA::\u5F55\u97F3\u529F\u80FD\u65E0\u6548\uFF1A\u65E0\u97F3\u9891\u6D41"));
            }
          }, 100);
        };
        var f2 = function(e) {
          var code = e.name || e.message || e.code + ":" + e;
          This.CLog($T("xEQR::\u8BF7\u6C42\u5F55\u97F3\u6743\u9650\u9519\u8BEF"), 1, e);
          codeFail(code, $T("bDOG::\u65E0\u6CD5\u5F55\u97F3\uFF1A") + code);
        };
        var trackSet = set4.audioTrackSet || {};
        trackSet[sampleRateTxt] = ctx[sampleRateTxt];
        var mSet = {
          audio: trackSet
        };
        try {
          var pro = Recorder2.Scope[getUserMediaTxt](mSet, f1, f2);
        } catch (e) {
          This.CLog(getUserMediaTxt, 3, e);
          mSet = {
            audio: true
          };
          pro = Recorder2.Scope[getUserMediaTxt](mSet, f1, f2);
        }
        This.CLog(getUserMediaTxt + "(" + JSON.stringify(mSet) + ") " + CtxState(ctx) + $T("RiWe::\uFF0C\u672A\u914D\u7F6EnoiseSuppression\u548CechoCancellation\u65F6\u6D4F\u89C8\u5668\u53EF\u80FD\u4F1A\u81EA\u52A8\u6253\u5F00\u964D\u566A\u548C\u56DE\u58F0\u6D88\u9664\uFF0C\u79FB\u52A8\u7AEF\u53EF\u80FD\u4F1A\u964D\u4F4E\u7CFB\u7EDF\u64AD\u653E\u97F3\u91CF\uFF08\u5173\u95ED\u5F55\u97F3\u540E\u53EF\u6062\u590D\uFF09\uFF0C\u8BF7\u53C2\u9605\u6587\u6863\u4E2DaudioTrackSet\u914D\u7F6E") + "(" + GitUrl + ") LM:" + LM + " UA:" + navigator.userAgent);
        if (pro && pro.then) {
          pro.then(f1)[CatchTxt](f2);
        }
      },
      close: function(call) {
        call = call || NOOP;
        var This = this, streamStore = This._streamStore();
        This._stop();
        var sTag = " stream:" + This._streamTag;
        var Lock = streamStore.Sync;
        This._O = 0;
        if (This._O_ != Lock.O) {
          This.CLog($T("hWVz::close\u88AB\u5FFD\u7565\uFF08\u56E0\u4E3A\u540C\u65F6open\u4E86\u591A\u4E2Arec\uFF0C\u53EA\u6709\u6700\u540E\u4E00\u4E2A\u4F1A\u771F\u6B63close\uFF09") + sTag, 3);
          call();
          return;
        }
        Lock.C++;
        Disconnect(streamStore);
        This.CLog("close," + sTag);
        call();
      },
      mock: function(pcmData, pcmSampleRate) {
        var This = this;
        This._stop();
        This.isMock = 1;
        This.mockEnvInfo = null;
        This.buffers = [pcmData];
        This.recSize = pcmData.length;
        This._setSrcSR(pcmSampleRate);
        This._streamTag = "mock";
        return This;
      },
      _setSrcSR: function(sampleRate) {
        var This = this, set4 = This.set;
        var setSr = set4[sampleRateTxt];
        if (setSr > sampleRate) {
          set4[sampleRateTxt] = sampleRate;
        } else {
          setSr = 0;
        }
        This[srcSampleRateTxt] = sampleRate;
        This.CLog(srcSampleRateTxt + ": " + sampleRate + " set." + sampleRateTxt + ": " + set4[sampleRateTxt] + (setSr ? " " + $T("UHvm::\u5FFD\u7565") + ": " + setSr : ""), setSr ? 3 : 0);
      },
      envCheck: function(envInfo) {
        var errMsg, This = this, set4 = This.set;
        var tag = "CPU_BE";
        if (!errMsg && !Recorder2[tag] && typeof Int8Array == "function" && !new Int8Array(new Int32Array([1]).buffer)[0]) {
          Traffic(tag);
          errMsg = $T("Essp::\u4E0D\u652F\u6301{1}\u67B6\u6784", 0, tag);
        }
        if (!errMsg) {
          var type = set4.type, hasFn = This[type + "_envCheck"];
          if (set4.takeoffEncodeChunk) {
            if (!hasFn) {
              errMsg = $T("2XBl::{1}\u7C7B\u578B\u4E0D\u652F\u6301\u8BBE\u7F6EtakeoffEncodeChunk", 0, type) + (This[type] ? "" : $T("LG7e::(\u672A\u52A0\u8F7D\u7F16\u7801\u5668)"));
            } else if (!envInfo.canProcess) {
              errMsg = $T("7uMV::{1}\u73AF\u5883\u4E0D\u652F\u6301\u5B9E\u65F6\u5904\u7406", 0, envInfo.envName);
            }
          }
          if (!errMsg && hasFn) {
            errMsg = This[type + "_envCheck"](envInfo, set4);
          }
        }
        return errMsg || "";
      },
      envStart: function(mockEnvInfo, sampleRate) {
        var This = this, set4 = This.set;
        This.isMock = mockEnvInfo ? 1 : 0;
        This.mockEnvInfo = mockEnvInfo;
        This.buffers = [];
        This.recSize = 0;
        if (mockEnvInfo) {
          This._streamTag = "env$" + mockEnvInfo.envName;
        }
        This.state = 1;
        This.envInLast = 0;
        This.envInFirst = 0;
        This.envInFix = 0;
        This.envInFixTs = [];
        This._setSrcSR(sampleRate);
        This.engineCtx = 0;
        if (This[set4.type + "_start"]) {
          var engineCtx = This.engineCtx = This[set4.type + "_start"](set4);
          if (engineCtx) {
            engineCtx.pcmDatas = [];
            engineCtx.pcmSize = 0;
          }
        }
      },
      envResume: function() {
        this.envInFixTs = [];
      },
      envIn: function(pcm, sum) {
        var This = this, set4 = This.set, engineCtx = This.engineCtx;
        if (This.state != 1) {
          if (!This.state)
            This.CLog("envIn at state=0", 3);
          return;
        }
        var bufferSampleRate = This[srcSampleRateTxt];
        var size2 = pcm.length;
        var powerLevel = Recorder2.PowerLevel(sum, size2);
        var buffers = This.buffers;
        var bufferFirstIdx = buffers.length;
        buffers.push(pcm);
        var buffersThis = buffers;
        var bufferFirstIdxThis = bufferFirstIdx;
        var now = Date.now();
        var pcmTime = Math.round(size2 / bufferSampleRate * 1e3);
        This.envInLast = now;
        if (This.buffers.length == 1) {
          This.envInFirst = now - pcmTime;
        }
        var envInFixTs = This.envInFixTs;
        envInFixTs.splice(0, 0, {
          t: now,
          d: pcmTime
        });
        var tsInStart = now, tsPcm = 0;
        for (var i = 0; i < envInFixTs.length; i++) {
          var o = envInFixTs[i];
          if (now - o.t > 3e3) {
            envInFixTs.length = i;
            break;
          }
          tsInStart = o.t;
          tsPcm += o.d;
        }
        var tsInPrev = envInFixTs[1];
        var tsIn = now - tsInStart;
        var lost = tsIn - tsPcm;
        if (lost > tsIn / 3 && (tsInPrev && tsIn > 1e3 || envInFixTs.length >= 6)) {
          var addTime = now - tsInPrev.t - pcmTime;
          if (addTime > pcmTime / 5) {
            var fixOpen = !set4.disableEnvInFix;
            This.CLog("[" + now + "]" + i18n3.get(fixOpen ? $T("4Kfd::\u8865\u507F{1}ms", 1) : $T("bM5i::\u672A\u8865\u507F{1}ms", 1), [addTime]), 3);
            This.envInFix += addTime;
            if (fixOpen) {
              var addPcm = new Int16Array(addTime * bufferSampleRate / 1e3);
              size2 += addPcm.length;
              buffers.push(addPcm);
            }
          }
        }
        var sizeOld = This.recSize, addSize = size2;
        var bufferSize = sizeOld + addSize;
        This.recSize = bufferSize;
        if (engineCtx) {
          var chunkInfo = Recorder2.SampleData(buffers, bufferSampleRate, set4[sampleRateTxt], engineCtx.chunkInfo);
          engineCtx.chunkInfo = chunkInfo;
          sizeOld = engineCtx.pcmSize;
          addSize = chunkInfo.data.length;
          bufferSize = sizeOld + addSize;
          engineCtx.pcmSize = bufferSize;
          buffers = engineCtx.pcmDatas;
          bufferFirstIdx = buffers.length;
          buffers.push(chunkInfo.data);
          bufferSampleRate = chunkInfo[sampleRateTxt];
        }
        var duration = Math.round(bufferSize / bufferSampleRate * 1e3);
        var bufferNextIdx = buffers.length;
        var bufferNextIdxThis = buffersThis.length;
        var asyncEnd = function() {
          var num = asyncBegin ? 0 : -addSize;
          var hasClear2 = buffers[0] == null;
          for (var i2 = bufferFirstIdx; i2 < bufferNextIdx; i2++) {
            var buffer = buffers[i2];
            if (buffer == null) {
              hasClear2 = 1;
            } else {
              num += buffer.length;
              if (engineCtx && buffer.length) {
                This[set4.type + "_encode"](engineCtx, buffer);
              }
            }
          }
          if (hasClear2 && engineCtx) {
            var i2 = bufferFirstIdxThis;
            if (buffersThis[0]) {
              i2 = 0;
            }
            for (; i2 < bufferNextIdxThis; i2++) {
              buffersThis[i2] = null;
            }
          }
          if (hasClear2) {
            num = asyncBegin ? addSize : 0;
            buffers[0] = null;
          }
          if (engineCtx) {
            engineCtx.pcmSize += num;
          } else {
            This.recSize += num;
          }
        };
        var asyncBegin = 0, procTxt = "rec.set.onProcess";
        try {
          asyncBegin = set4.onProcess(buffers, powerLevel, duration, bufferSampleRate, bufferFirstIdx, asyncEnd);
        } catch (e) {
          /* @__PURE__ */ console.error(procTxt + $T("gFUF::\u56DE\u8C03\u51FA\u9519\u662F\u4E0D\u5141\u8BB8\u7684\uFF0C\u9700\u4FDD\u8BC1\u4E0D\u4F1A\u629B\u5F02\u5E38"), e);
        }
        var slowT = Date.now() - now;
        if (slowT > 10 && This.envInFirst - now > 1e3) {
          This.CLog(procTxt + $T("2ghS::\u4F4E\u6027\u80FD\uFF0C\u8017\u65F6{1}ms", 0, slowT), 3);
        }
        if (asyncBegin === true) {
          var hasClear = 0;
          for (var i = bufferFirstIdx; i < bufferNextIdx; i++) {
            if (buffers[i] == null) {
              hasClear = 1;
            } else {
              buffers[i] = new Int16Array(0);
            }
          }
          if (hasClear) {
            This.CLog($T("ufqH::\u672A\u8FDB\u5165\u5F02\u6B65\u524D\u4E0D\u80FD\u6E05\u9664buffers"), 3);
          } else {
            if (engineCtx) {
              engineCtx.pcmSize -= addSize;
            } else {
              This.recSize -= addSize;
            }
          }
        } else {
          asyncEnd();
        }
      },
      start: function() {
        var This = this;
        var isOpen = 1;
        if (This.set.sourceStream) {
          if (!This.Stream) {
            isOpen = 0;
          }
        } else if (!Recorder2.IsOpen()) {
          isOpen = 0;
        }
        if (!isOpen) {
          This.CLog($T("6WmN::start\u5931\u8D25\uFF1A\u672Aopen"), 1);
          return;
        }
        var ctx = This._streamCtx();
        This.CLog($T("kLDN::start \u5F00\u59CB\u5F55\u97F3\uFF0C") + CtxState(ctx) + " stream:" + This._streamTag);
        This._stop();
        This.envStart(null, ctx[sampleRateTxt]);
        This.state = 3;
        if (This._SO && This._SO + 1 != This._S) {
          This.CLog($T("Bp2y::start\u88AB\u4E2D\u65AD"), 3);
          return;
        }
        This._SO = 0;
        var end = function() {
          if (This.state == 3) {
            This.state = 1;
            This.resume();
          }
        };
        var tag = "AudioContext resume: ";
        ResumeCtx(ctx, function(runC) {
          runC && This.CLog(tag + "wait...");
          return This.state == 3;
        }, function(runC) {
          runC && This.CLog(tag + ctx.state);
          end();
        }, function(err) {
          This.CLog(tag + ctx.state + $T("upkE::\uFF0C\u53EF\u80FD\u65E0\u6CD5\u5F55\u97F3\uFF1A") + err, 1);
          end();
        });
      },
      pause: function() {
        var This = this, stream = This._streamStore().Stream;
        if (This.state) {
          This.state = 2;
          This.CLog("pause");
          if (stream)
            delete stream._call[This.id];
        }
      },
      resume: function() {
        var This = this, stream = This._streamStore().Stream;
        var tag = "resume", tag3 = tag + "(wait ctx)";
        if (This.state == 3) {
          This.CLog(tag3);
        } else if (This.state) {
          This.state = 1;
          This.CLog(tag);
          This.envResume();
          if (stream) {
            stream._call[This.id] = function(pcm, sum) {
              if (This.state == 1) {
                This.envIn(pcm, sum);
              }
            };
            ConnAlive(stream);
          }
          var ctx = This._streamCtx();
          if (ctx) {
            ResumeCtx(ctx, function(runC) {
              runC && This.CLog(tag3 + "...");
              return This.state == 1;
            }, function(runC) {
              runC && This.CLog(tag3 + ctx.state);
              ConnAlive(stream);
            }, function(err) {
              This.CLog(tag3 + ctx.state + "[err]" + err, 1);
            });
          }
        }
      },
      _stop: function(keepEngine) {
        var This = this, set4 = This.set;
        if (!This.isMock) {
          This._S++;
        }
        if (This.state) {
          This.pause();
          This.state = 0;
        }
        if (!keepEngine && This[set4.type + "_stop"]) {
          This[set4.type + "_stop"](This.engineCtx);
          This.engineCtx = 0;
        }
      },
      stop: function(True, False, autoClose) {
        var This = this, set4 = This.set, t1;
        var envInMS = This.envInLast - This.envInFirst, envInLen = envInMS && This.buffers.length;
        This.CLog($T("Xq4s::stop \u548Cstart\u65F6\u5DEE:") + (envInMS ? envInMS + "ms " + $T("3CQP::\u8865\u507F:") + This.envInFix + "ms envIn:" + envInLen + " fps:" + (envInLen / envInMS * 1e3).toFixed(1) : "-") + " stream:" + This._streamTag + " (" + GitUrl + ") LM:" + LM);
        var end = function() {
          This._stop();
          if (autoClose) {
            This.close();
          }
        };
        var err = function(msg) {
          This.CLog($T("u8JG::\u7ED3\u675F\u5F55\u97F3\u5931\u8D25\uFF1A") + msg, 1);
          False && False(msg);
          end();
        };
        var ok = function(blob, mime, duration2) {
          var tBlob = "blob", tABuf = "arraybuffer", tDT = "dataType", tDDT = "DefaultDataType";
          var dType = This[tDT] || Recorder2[tDDT] || tBlob, dTag = tDT + "=" + dType;
          var isAB = blob instanceof ArrayBuffer, dErr = 0;
          var dLen = isAB ? blob.byteLength : blob.size;
          if (dType == tABuf) {
            if (!isAB)
              dErr = 1;
          } else if (dType == tBlob) {
            if (typeof Blob != "function") {
              dErr = $T.G("NonBrowser-1", [dTag]) + $T("1skY::\uFF0C\u8BF7\u8BBE\u7F6E{1}", 0, RecTxt + "." + tDDT + '="' + tABuf + '"');
            } else {
              if (isAB)
                blob = new Blob([blob], {
                  type: mime
                });
              if (!(blob instanceof Blob))
                dErr = 1;
              mime = blob.type || mime;
            }
          } else {
            dErr = $T.G("NotSupport-1", [dTag]);
          }
          This.CLog($T("Wv7l::\u7ED3\u675F\u5F55\u97F3 \u7F16\u7801\u82B1{1}ms \u97F3\u9891\u65F6\u957F{2}ms \u6587\u4EF6\u5927\u5C0F{3}b", 0, Date.now() - t1, duration2, dLen) + " " + dTag + "," + mime);
          if (dErr) {
            err(dErr != 1 ? dErr : $T("Vkbd::{1}\u7F16\u7801\u5668\u8FD4\u56DE\u7684\u4E0D\u662F{2}", 0, set4.type, dType) + ", " + dTag);
            return;
          }
          if (set4.takeoffEncodeChunk) {
            This.CLog($T("QWnr::\u542F\u7528takeoffEncodeChunk\u540Estop\u8FD4\u56DE\u7684blob\u957F\u5EA6\u4E3A0\u4E0D\u63D0\u4F9B\u97F3\u9891\u6570\u636E"), 3);
          } else if (dLen < Math.max(50, duration2 / 5)) {
            err($T("Sz2H::\u751F\u6210\u7684{1}\u65E0\u6548", 0, set4.type));
            return;
          }
          True && True(blob, duration2, mime);
          end();
        };
        if (!This.isMock) {
          var isCtxWait = This.state == 3;
          if (!This.state || isCtxWait) {
            err($T("wf9t::\u672A\u5F00\u59CB\u5F55\u97F3") + (isCtxWait ? $T("Dl2c::\uFF0C\u5F00\u59CB\u5F55\u97F3\u524D\u65E0\u7528\u6237\u4EA4\u4E92\u5BFC\u81F4AudioContext\u672A\u8FD0\u884C") : ""));
            return;
          }
        }
        This._stop(true);
        var size2 = This.recSize;
        if (!size2) {
          err($T("Ltz3::\u672A\u91C7\u96C6\u5230\u5F55\u97F3"));
          return;
        }
        if (!This[set4.type]) {
          err($T("xGuI::\u672A\u52A0\u8F7D{1}\u7F16\u7801\u5668\uFF0C\u8BF7\u5C1D\u8BD5\u5230{2}\u7684src/engine\u5185\u627E\u5230{1}\u7684\u7F16\u7801\u5668\u5E76\u52A0\u8F7D", 0, set4.type, RecTxt));
          return;
        }
        if (This.isMock) {
          var checkMsg = This.envCheck(This.mockEnvInfo || {
            envName: "mock",
            canProcess: false
          });
          if (checkMsg) {
            err($T("AxOH::\u5F55\u97F3\u9519\u8BEF\uFF1A") + checkMsg);
            return;
          }
        }
        var engineCtx = This.engineCtx;
        if (This[set4.type + "_complete"] && engineCtx) {
          var duration = Math.round(engineCtx.pcmSize / set4[sampleRateTxt] * 1e3);
          t1 = Date.now();
          This[set4.type + "_complete"](engineCtx, function(blob, mime) {
            ok(blob, mime, duration);
          }, err);
          return;
        }
        t1 = Date.now();
        if (!This.buffers[0]) {
          err($T("xkKd::\u97F3\u9891buffers\u88AB\u91CA\u653E"));
          return;
        }
        var chunk = Recorder2.SampleData(This.buffers, This[srcSampleRateTxt], set4[sampleRateTxt]);
        set4[sampleRateTxt] = chunk[sampleRateTxt];
        var res = chunk.data;
        var duration = Math.round(res.length / set4[sampleRateTxt] * 1e3);
        This.CLog($T("CxeT::\u91C7\u6837:{1} \u82B1:{2}ms", 0, size2 + "->" + res.length, Date.now() - t1));
        setTimeout(function() {
          t1 = Date.now();
          This[set4.type](res, function(blob, mime) {
            ok(blob, mime, duration);
          }, function(msg) {
            err(msg);
          });
        });
      }
    };
    var WebM_Extract = function(inBytes, scope) {
      if (!scope.pos) {
        scope.pos = [0];
        scope.tracks = {};
        scope.bytes = [];
      }
      var tracks = scope.tracks, position = [scope.pos[0]];
      var endPos = function() {
        scope.pos[0] = position[0];
      };
      var sBL = scope.bytes.length;
      var bytes = new Uint8Array(sBL + inBytes.length);
      bytes.set(scope.bytes);
      bytes.set(inBytes, sBL);
      scope.bytes = bytes;
      if (!scope._ht) {
        readMatroskaVInt(bytes, position);
        readMatroskaBlock(bytes, position);
        if (!BytesEq(readMatroskaVInt(bytes, position), [24, 83, 128, 103])) {
          return;
        }
        readMatroskaVInt(bytes, position);
        while (position[0] < bytes.length) {
          var eid0 = readMatroskaVInt(bytes, position);
          var bytes0 = readMatroskaBlock(bytes, position);
          var pos0 = [0], audioIdx = 0;
          if (!bytes0)
            return;
          if (BytesEq(eid0, [22, 84, 174, 107])) {
            while (pos0[0] < bytes0.length) {
              var eid1 = readMatroskaVInt(bytes0, pos0);
              var bytes1 = readMatroskaBlock(bytes0, pos0);
              var pos1 = [0], track = {
                channels: 0,
                sampleRate: 0
              };
              if (BytesEq(eid1, [174])) {
                while (pos1[0] < bytes1.length) {
                  var eid2 = readMatroskaVInt(bytes1, pos1);
                  var bytes2 = readMatroskaBlock(bytes1, pos1);
                  var pos2 = [0];
                  if (BytesEq(eid2, [215])) {
                    var val = BytesInt(bytes2);
                    track.number = val;
                    tracks[val] = track;
                  } else if (BytesEq(eid2, [131])) {
                    var val = BytesInt(bytes2);
                    if (val == 1)
                      track.type = "video";
                    else if (val == 2) {
                      track.type = "audio";
                      if (!audioIdx)
                        scope.track0 = track;
                      track.idx = audioIdx++;
                    } else
                      track.type = "Type-" + val;
                  } else if (BytesEq(eid2, [134])) {
                    var str = "";
                    for (var i = 0; i < bytes2.length; i++) {
                      str += String.fromCharCode(bytes2[i]);
                    }
                    track.codec = str;
                  } else if (BytesEq(eid2, [225])) {
                    while (pos2[0] < bytes2.length) {
                      var eid3 = readMatroskaVInt(bytes2, pos2);
                      var bytes3 = readMatroskaBlock(bytes2, pos2);
                      if (BytesEq(eid3, [181])) {
                        var val = 0, arr = new Uint8Array(bytes3.reverse()).buffer;
                        if (bytes3.length == 4)
                          val = new Float32Array(arr)[0];
                        else if (bytes3.length == 8)
                          val = new Float64Array(arr)[0];
                        else
                          CLog("WebM Track !Float", 1, bytes3);
                        track[sampleRateTxt] = Math.round(val);
                      } else if (BytesEq(eid3, [98, 100]))
                        track.bitDepth = BytesInt(bytes3);
                      else if (BytesEq(eid3, [159]))
                        track.channels = BytesInt(bytes3);
                    }
                  }
                }
              }
            }
            scope._ht = 1;
            CLog("WebM Tracks", tracks);
            endPos();
            break;
          }
        }
      }
      var track0 = scope.track0;
      if (!track0)
        return;
      if (track0.bitDepth == 16 && /FLOAT/i.test(track0.codec)) {
        track0.bitDepth = 32;
        CLog("WebM 16->32 bit", 3);
      }
      if (track0[sampleRateTxt] != scope[sampleRateTxt] || track0.bitDepth != 32 || track0.channels < 1 || !/(\b|_)PCM\b/i.test(track0.codec)) {
        scope.bytes = [];
        if (!scope.bad)
          CLog("WebM Track Unexpected", 3, scope);
        scope.bad = 1;
        return -1;
      }
      var datas = [], dataLen = 0;
      while (position[0] < bytes.length) {
        var eid1 = readMatroskaVInt(bytes, position);
        var bytes1 = readMatroskaBlock(bytes, position);
        if (!bytes1)
          break;
        if (BytesEq(eid1, [163])) {
          var trackNo = bytes1[0] & 15;
          var track = tracks[trackNo];
          if (!track) {
            CLog("WebM !Track" + trackNo, 1, tracks);
          } else if (track.idx === 0) {
            var u8arr = new Uint8Array(bytes1.length - 4);
            for (var i = 4; i < bytes1.length; i++) {
              u8arr[i - 4] = bytes1[i];
            }
            datas.push(u8arr);
            dataLen += u8arr.length;
          }
        }
        endPos();
      }
      if (dataLen) {
        var more = new Uint8Array(bytes.length - scope.pos[0]);
        more.set(bytes.subarray(scope.pos[0]));
        scope.bytes = more;
        scope.pos[0] = 0;
        var u8arr = new Uint8Array(dataLen);
        for (var i = 0, i2 = 0; i < datas.length; i++) {
          u8arr.set(datas[i], i2);
          i2 += datas[i].length;
        }
        var arr = new Float32Array(u8arr.buffer);
        if (track0.channels > 1) {
          var arr2 = [];
          for (var i = 0; i < arr.length; ) {
            arr2.push(arr[i]);
            i += track0.channels;
          }
          arr = new Float32Array(arr2);
        }
        return arr;
      }
    };
    var BytesEq = function(bytes1, bytes2) {
      if (!bytes1 || bytes1.length != bytes2.length)
        return false;
      if (bytes1.length == 1)
        return bytes1[0] == bytes2[0];
      for (var i = 0; i < bytes1.length; i++) {
        if (bytes1[i] != bytes2[i])
          return false;
      }
      return true;
    };
    var BytesInt = function(bytes) {
      var s = "";
      for (var i = 0; i < bytes.length; i++) {
        var n = bytes[i];
        s += (n < 16 ? "0" : "") + n.toString(16);
      }
      return parseInt(s, 16) || 0;
    };
    var readMatroskaVInt = function(arr, pos, trim3) {
      var i = pos[0];
      if (i >= arr.length)
        return;
      var b0 = arr[i], b2 = ("0000000" + b0.toString(2)).substr(-8);
      var m = /^(0*1)(\d*)$/.exec(b2);
      if (!m)
        return;
      var len = m[1].length, val = [];
      if (i + len > arr.length)
        return;
      for (var i2 = 0; i2 < len; i2++) {
        val[i2] = arr[i];
        i++;
      }
      if (trim3)
        val[0] = parseInt(m[2] || "0", 2);
      pos[0] = i;
      return val;
    };
    var readMatroskaBlock = function(arr, pos) {
      var lenVal = readMatroskaVInt(arr, pos, 1);
      if (!lenVal)
        return;
      var len = BytesInt(lenVal);
      var i = pos[0], val = [];
      if (len < 2147483647) {
        if (i + len > arr.length)
          return;
        for (var i2 = 0; i2 < len; i2++) {
          val[i2] = arr[i];
          i++;
        }
      }
      pos[0] = i;
      return val;
    };
    var i18n3 = Recorder2.i18n = {
      lang: "zh-CN",
      alias: {
        "zh-CN": "zh",
        "en-US": "en"
      },
      locales: {},
      data: {},
      put: function(set4, texts) {
        var tag = RecTxt + ".i18n.put: ";
        var overwrite = set4.overwrite;
        overwrite = overwrite == null || overwrite;
        var lang2 = set4.lang;
        lang2 = i18n3.alias[lang2] || lang2;
        if (!lang2)
          throw new Error(tag + "set.lang?");
        var locale2 = i18n3.locales[lang2];
        if (!locale2) {
          locale2 = {};
          i18n3.locales[lang2] = locale2;
        }
        var exp = /^([\w\-]+):/, m;
        for (var i = 0; i < texts.length; i++) {
          var v = texts[i];
          m = exp.exec(v);
          if (!m) {
            CLog(tag + "'key:'? " + v, 3, set4);
            continue;
          }
          var key2 = m[1], v = v.substr(key2.length + 1);
          if (!overwrite && locale2[key2])
            continue;
          locale2[key2] = v;
        }
      },
      get: function() {
        return i18n3.v_G.apply(null, arguments);
      },
      v_G: function(key2, args, lang2) {
        args = args || [];
        lang2 = lang2 || i18n3.lang;
        lang2 = i18n3.alias[lang2] || lang2;
        var locale2 = i18n3.locales[lang2];
        var val = locale2 && locale2[key2] || "";
        if (!val && lang2 != "zh") {
          if (lang2 == "en")
            return i18n3.v_G(key2, args, "zh");
          return i18n3.v_G(key2, args, "en");
        }
        i18n3.lastLang = lang2;
        if (val == "=Empty")
          return "";
        return val.replace(/\{(\d+)(\!?)\}/g, function(v, a, b) {
          a = +a || 0;
          v = args[a - 1];
          if (a < 1 || a > args.length) {
            v = "{?}";
            CLog("i18n[" + key2 + "] no {" + a + "}: " + val, 3);
          }
          return b ? "" : v;
        });
      },
      $T: function() {
        return i18n3.v_T.apply(null, arguments);
      },
      v_T: function() {
        var a = arguments, key2 = "", args = [], isArgs = 0, tag = RecTxt + ".i18n.$T:";
        var exp = /^([\w\-]*):/, m;
        for (var i = 0; i < a.length; i++) {
          var v = a[i];
          if (i == 0) {
            m = exp.exec(v);
            key2 = m && m[1];
            if (!key2)
              throw new Error(tag + "0 'key:'?");
            v = v.substr(key2.length + 1);
          }
          if (isArgs === -1)
            args.push(v);
          else if (isArgs)
            throw new Error(tag + " bad args");
          else if (v === 0)
            isArgs = -1;
          else if (IsNum(v)) {
            if (v < 1)
              throw new Error(tag + " bad args");
            isArgs = v;
          } else {
            var lang2 = i == 1 ? "en" : i ? "" : "zh";
            m = exp.exec(v);
            if (m) {
              lang2 = m[1] || lang2;
              v = v.substr(m[1].length + 1);
            }
            if (!m || !lang2)
              throw new Error(tag + i + " 'lang:'?");
            i18n3.put({
              lang: lang2,
              overwrite: false
            }, [key2 + ":" + v]);
          }
        }
        if (!key2)
          return "";
        if (isArgs > 0)
          return key2;
        return i18n3.v_G(key2, args);
      }
    };
    var $T = i18n3.$T;
    $T.G = i18n3.get;
    $T("NonBrowser-1::\u975E\u6D4F\u89C8\u5668\u73AF\u5883\uFF0C\u4E0D\u652F\u6301{1}", 1);
    $T("IllegalArgs-1::\u53C2\u6570\u9519\u8BEF\uFF1A{1}", 1);
    $T("NeedImport-2::\u8C03\u7528{1}\u9700\u8981\u5148\u5BFC\u5165{2}", 2);
    $T("NotSupport-1::\u4E0D\u652F\u6301\uFF1A{1}", 1);
    Recorder2.TrafficImgUrl = "//ia.51.la/go1?id=20469973&pvFlag=1";
    var Traffic = Recorder2.Traffic = function(report) {
      if (!isBrowser2)
        return;
      report = report ? "/" + RecTxt + "/Report/" + report : "";
      var imgUrl = Recorder2.TrafficImgUrl;
      if (imgUrl) {
        var data22 = Recorder2.Traffic;
        var m = /^(https?:..[^\/#]*\/?)[^#]*/i.exec(location.href) || [];
        var host = m[1] || "http://file/";
        var idf = (m[0] || host) + report;
        if (imgUrl.indexOf("//") == 0) {
          if (/^https:/i.test(idf)) {
            imgUrl = "https:" + imgUrl;
          } else {
            imgUrl = "http:" + imgUrl;
          }
        }
        if (report) {
          imgUrl = imgUrl + "&cu=" + encodeURIComponent(host + report);
        }
        if (!data22[idf]) {
          data22[idf] = 1;
          var img = new Image();
          img.src = imgUrl;
          CLog("Traffic Analysis Image: " + (report || RecTxt + ".TrafficImgUrl=" + Recorder2.TrafficImgUrl));
        }
      }
    };
    if (WRec2) {
      CLog($T("8HO5::\u8986\u76D6\u5BFC\u5165{1}", 0, RecTxt), 1);
      WRec2.Destroy();
    }
    Export[RecTxt] = Recorder2;
  });
})(recorderCore);
var Recorder = recorderCore.exports;
(function(factory) {
  var browser = typeof window == "object" && !!window.document;
  var win = browser ? window : Object;
  var rec = win.Recorder, ni = rec.i18n;
  factory(rec, ni, ni.$T, browser);
})(function(Recorder2, i18n3, $T, isBrowser2) {
  var SampleS = "48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000";
  var BitS = "8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, 192, 224, 256, 320";
  Recorder2.prototype.enc_mp3 = {
    stable: true,
    takeEC: "full",
    getTestMsg: function() {
      return $T("Zm7L::\u91C7\u6837\u7387\u8303\u56F4\uFF1A{1}\uFF1B\u6BD4\u7279\u7387\u8303\u56F4\uFF1A{2}\uFF08\u4E0D\u540C\u6BD4\u7279\u7387\u652F\u6301\u7684\u91C7\u6837\u7387\u8303\u56F4\u4E0D\u540C\uFF0C\u5C0F\u4E8E32kbps\u65F6\u91C7\u6837\u7387\u9700\u5C0F\u4E8E32000\uFF09", 0, SampleS, BitS);
    }
  };
  var NormalizeSet = function(set4) {
    var bS = set4.bitRate, sS = set4.sampleRate, s = sS;
    if ((" " + BitS + ",").indexOf(" " + bS + ",") == -1) {
      Recorder2.CLog($T("eGB9::{1}\u4E0D\u5728mp3\u652F\u6301\u7684\u53D6\u503C\u8303\u56F4\uFF1A{2}", 0, "bitRate=" + bS, BitS), 3);
    }
    if ((" " + SampleS + ",").indexOf(" " + sS + ",") == -1) {
      var arr = SampleS.split(", "), vs = [];
      for (var i = 0; i < arr.length; i++)
        vs.push({
          v: +arr[i],
          s: Math.abs(arr[i] - sS)
        });
      vs.sort(function(a, b) {
        return a.s - b.s;
      });
      s = vs[0].v;
      set4.sampleRate = s;
      Recorder2.CLog($T("zLTa::sampleRate\u5DF2\u66F4\u65B0\u4E3A{1}\uFF0C\u56E0\u4E3A{2}\u4E0D\u5728mp3\u652F\u6301\u7684\u53D6\u503C\u8303\u56F4\uFF1A{3}", 0, s, sS, SampleS), 3);
    }
  };
  var ImportEngineErr = function() {
    return $T.G("NeedImport-2", ["mp3.js", "src/engine/mp3-engine.js"]);
  };
  var HasWebWorker = isBrowser2 && typeof Worker == "function";
  Recorder2.prototype.mp3 = function(res, True, False) {
    var This = this, set4 = This.set, size2 = res.length;
    if (!Recorder2.lamejs) {
      False(ImportEngineErr());
      return;
    }
    if (HasWebWorker) {
      var ctx = This.mp3_start(set4);
      if (ctx) {
        if (ctx.isW) {
          This.mp3_encode(ctx, res);
          This.mp3_complete(ctx, True, False, 1);
          return;
        }
        This.mp3_stop(ctx);
      }
    }
    NormalizeSet(set4);
    var mp3 = new Recorder2.lamejs.Mp3Encoder(1, set4.sampleRate, set4.bitRate);
    var blockSize = 57600;
    var memory = new Int8Array(5e5), mOffset = 0;
    var idx = 0, isFlush = 0;
    var run = function() {
      try {
        if (idx < size2) {
          var buf = mp3.encodeBuffer(res.subarray(idx, idx + blockSize));
        } else {
          isFlush = 1;
          var buf = mp3.flush();
        }
        ;
      } catch (e) {
        /* @__PURE__ */ console.error(e);
        if (!isFlush)
          try {
            mp3.flush();
          } catch (r) {
            /* @__PURE__ */ console.error(r);
          }
        False("MP3 Encoder: " + e.message);
        return;
      }
      var bufLen = buf.length;
      if (bufLen > 0) {
        if (mOffset + bufLen > memory.length) {
          var tmp = new Int8Array(memory.length + Math.max(5e5, bufLen));
          tmp.set(memory.subarray(0, mOffset));
          memory = tmp;
        }
        memory.set(buf, mOffset);
        mOffset += bufLen;
      }
      if (idx < size2) {
        idx += blockSize;
        setTimeout(run);
      } else {
        var data22 = [memory.buffer.slice(0, mOffset)];
        var meta = mp3TrimFix.fn(data22, mOffset, size2, set4.sampleRate);
        mp3TrimFixSetMeta(meta, set4);
        True(data22[0] || new ArrayBuffer(0), "audio/mp3");
      }
    };
    run();
  };
  var mp3Worker;
  Recorder2.BindDestroy("mp3Worker", function() {
    if (mp3Worker) {
      Recorder2.CLog("mp3Worker Destroy");
      mp3Worker.terminate();
      mp3Worker = null;
    }
  });
  Recorder2.prototype.mp3_envCheck = function(envInfo, set4) {
    var errMsg = "";
    if (set4.takeoffEncodeChunk) {
      if (!newContext()) {
        errMsg = $T("yhUs::\u5F53\u524D\u6D4F\u89C8\u5668\u7248\u672C\u592A\u4F4E\uFF0C\u65E0\u6CD5\u5B9E\u65F6\u5904\u7406");
      }
    }
    if (!errMsg && !Recorder2.lamejs) {
      errMsg = ImportEngineErr();
    }
    return errMsg;
  };
  Recorder2.prototype.mp3_start = function(set4) {
    return newContext(set4);
  };
  var openList = {
    id: 0
  };
  var newContext = function(setOrNull, _badW) {
    var run = function(e) {
      var ed = e.data;
      var wk_ctxs = scope.wkScope.wk_ctxs;
      var wk_lame = scope.wkScope.wk_lame;
      var wk_mp3TrimFix = scope.wkScope.wk_mp3TrimFix;
      var cur = wk_ctxs[ed.id];
      if (ed.action == "init") {
        wk_ctxs[ed.id] = {
          sampleRate: ed.sampleRate,
          bitRate: ed.bitRate,
          takeoff: ed.takeoff,
          pcmSize: 0,
          memory: new Int8Array(5e5),
          mOffset: 0,
          encObj: new wk_lame.Mp3Encoder(1, ed.sampleRate, ed.bitRate)
        };
      } else if (!cur) {
        return;
      }
      var addBytes = function(buf2) {
        var bufLen = buf2.length;
        if (cur.mOffset + bufLen > cur.memory.length) {
          var tmp = new Int8Array(cur.memory.length + Math.max(5e5, bufLen));
          tmp.set(cur.memory.subarray(0, cur.mOffset));
          cur.memory = tmp;
        }
        cur.memory.set(buf2, cur.mOffset);
        cur.mOffset += bufLen;
      };
      switch (ed.action) {
        case "stop":
          if (!cur.isCp)
            try {
              cur.encObj.flush();
            } catch (e2) {
              /* @__PURE__ */ console.error(e2);
            }
          cur.encObj = null;
          delete wk_ctxs[ed.id];
          break;
        case "encode":
          if (cur.isCp)
            break;
          cur.pcmSize += ed.pcm.length;
          try {
            var buf = cur.encObj.encodeBuffer(ed.pcm);
          } catch (e2) {
            cur.err = e2;
            /* @__PURE__ */ console.error(e2);
          }
          if (buf && buf.length > 0) {
            if (cur.takeoff) {
              worker.onmessage({
                action: "takeoff",
                id: ed.id,
                chunk: buf
              });
            } else {
              addBytes(buf);
            }
          }
          break;
        case "complete":
          cur.isCp = 1;
          try {
            var buf = cur.encObj.flush();
          } catch (e2) {
            cur.err = e2;
            /* @__PURE__ */ console.error(e2);
          }
          if (buf && buf.length > 0) {
            if (cur.takeoff) {
              worker.onmessage({
                action: "takeoff",
                id: ed.id,
                chunk: buf
              });
            } else {
              addBytes(buf);
            }
          }
          if (cur.err) {
            worker.onmessage({
              action: ed.action,
              id: ed.id,
              err: "MP3 Encoder: " + cur.err.message
            });
            break;
          }
          var data22 = [cur.memory.buffer.slice(0, cur.mOffset)];
          var meta = wk_mp3TrimFix.fn(data22, cur.mOffset, cur.pcmSize, cur.sampleRate);
          worker.onmessage({
            action: ed.action,
            id: ed.id,
            blob: data22[0] || new ArrayBuffer(0),
            meta
          });
          break;
      }
    };
    var initOnMsg = function(isW) {
      worker.onmessage = function(e) {
        var data22 = e;
        if (isW)
          data22 = e.data;
        var ctx2 = openList[data22.id];
        if (ctx2) {
          if (data22.action == "takeoff") {
            ctx2.set.takeoffEncodeChunk(new Uint8Array(data22.chunk.buffer));
          } else {
            ctx2.call && ctx2.call(data22);
            ctx2.call = null;
          }
        }
      };
    };
    var initCtx = function() {
      var ctx2 = {
        worker,
        set: setOrNull
      };
      if (setOrNull) {
        ctx2.id = ++openList.id;
        openList[ctx2.id] = ctx2;
        NormalizeSet(setOrNull);
        worker.postMessage({
          action: "init",
          id: ctx2.id,
          sampleRate: setOrNull.sampleRate,
          bitRate: setOrNull.bitRate,
          takeoff: !!setOrNull.takeoffEncodeChunk,
          x: new Int16Array(5)
        });
      } else {
        worker.postMessage({
          x: new Int16Array(5)
        });
      }
      return ctx2;
    };
    var scope, worker = mp3Worker;
    if (_badW || !HasWebWorker) {
      Recorder2.CLog($T("k9PT::\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301Web Worker\uFF0Cmp3\u5B9E\u65F6\u7F16\u7801\u5668\u8FD0\u884C\u5728\u4E3B\u7EBF\u7A0B\u4E2D"), 3);
      worker = {
        postMessage: function(ed) {
          run({
            data: ed
          });
        }
      };
      scope = {
        wkScope: {
          wk_ctxs: {},
          wk_lame: Recorder2.lamejs,
          wk_mp3TrimFix: mp3TrimFix
        }
      };
      initOnMsg();
      return initCtx();
    }
    try {
      if (!worker) {
        var onmsg = (run + "").replace(/[\w\$]+\.onmessage/g, "self.postMessage");
        onmsg = onmsg.replace(/[\w\$]+\.wkScope/g, "wkScope");
        var jsCode = ");wk_lame();self.onmessage=" + onmsg;
        jsCode += ";var wkScope={ wk_ctxs:{},wk_lame:wk_lame";
        jsCode += ",wk_mp3TrimFix:{rm:" + mp3TrimFix.rm + ",fn:" + mp3TrimFix.fn + "} }";
        var lamejsCode = Recorder2.lamejs.toString();
        var url2 = (window.URL || webkitURL).createObjectURL(new Blob(["var wk_lame=(", lamejsCode, jsCode], {
          type: "text/javascript"
        }));
        worker = new Worker(url2);
        setTimeout(function() {
          (window.URL || webkitURL).revokeObjectURL(url2);
        }, 1e4);
        initOnMsg(1);
      }
      ;
      var ctx = initCtx();
      ctx.isW = 1;
      mp3Worker = worker;
      return ctx;
    } catch (e) {
      worker && worker.terminate();
      /* @__PURE__ */ console.error(e);
      return newContext(setOrNull, 1);
    }
  };
  Recorder2.prototype.mp3_stop = function(startCtx) {
    if (startCtx && startCtx.worker) {
      startCtx.worker.postMessage({
        action: "stop",
        id: startCtx.id
      });
      startCtx.worker = null;
      delete openList[startCtx.id];
      var opens = -1;
      for (var k in openList) {
        opens++;
      }
      if (opens) {
        Recorder2.CLog($T("fT6M::mp3 worker\u5269{1}\u4E2A\u672Astop", 0, opens), 3);
      }
    }
  };
  Recorder2.prototype.mp3_encode = function(startCtx, pcm) {
    if (startCtx && startCtx.worker) {
      startCtx.worker.postMessage({
        action: "encode",
        id: startCtx.id,
        pcm
      });
    }
  };
  Recorder2.prototype.mp3_complete = function(startCtx, True, False, autoStop) {
    var This = this;
    if (startCtx && startCtx.worker) {
      startCtx.call = function(data22) {
        if (autoStop) {
          This.mp3_stop(startCtx);
        }
        if (data22.err) {
          False(data22.err);
        } else {
          mp3TrimFixSetMeta(data22.meta, startCtx.set);
          True(data22.blob, "audio/mp3");
        }
      };
      startCtx.worker.postMessage({
        action: "complete",
        id: startCtx.id
      });
    } else {
      False($T("mPxH::mp3\u7F16\u7801\u5668\u672Astart"));
    }
  };
  Recorder2.mp3ReadMeta = function(mp3Buffers, length) {
    var parseInt_ES3 = typeof window != "undefined" && window.parseInt || typeof self != "undefined" && self.parseInt || parseInt;
    var u8arr0 = new Uint8Array(mp3Buffers[0] || []);
    if (u8arr0.length < 4) {
      return null;
    }
    var byteAt = function(idx2, u8) {
      return ("0000000" + ((u8 || u8arr0)[idx2] || 0).toString(2)).substr(-8);
    };
    var b2 = byteAt(0) + byteAt(1);
    var b4 = byteAt(2) + byteAt(3);
    if (!/^1{11}/.test(b2)) {
      return null;
    }
    var version2 = {
      "00": 2.5,
      "10": 2,
      "11": 1
    }[b2.substr(11, 2)];
    var layer = {
      "01": 3
    }[b2.substr(13, 2)];
    var sampleRate = {
      "1": [44100, 48e3, 32e3],
      "2": [22050, 24e3, 16e3],
      "2.5": [11025, 12e3, 8e3]
    }[version2];
    sampleRate && (sampleRate = sampleRate[parseInt_ES3(b4.substr(4, 2), 2)]);
    var bitRate = [
      [0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160],
      [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320]
    ][version2 == 1 ? 1 : 0][parseInt_ES3(b4.substr(0, 4), 2)];
    if (!version2 || !layer || !bitRate || !sampleRate) {
      return null;
    }
    var duration = Math.round(length * 8 / bitRate);
    var frame = layer == 1 ? 384 : layer == 2 ? 1152 : version2 == 1 ? 1152 : 576;
    var frameDurationFloat = frame / sampleRate * 1e3;
    var frameSize = Math.floor(frame * bitRate / 8 / sampleRate * 1e3);
    var hasPadding = 0, seek = 0;
    for (var i = 0; i < mp3Buffers.length; i++) {
      var buf = mp3Buffers[i];
      seek += buf.byteLength;
      if (seek >= frameSize + 3) {
        var buf8 = new Uint8Array(buf);
        var idx = buf.byteLength - (seek - (frameSize + 3) + 1);
        var ib4 = byteAt(idx, buf8);
        hasPadding = ib4.charAt(6) == "1";
        break;
      }
    }
    if (hasPadding) {
      frameSize++;
    }
    return {
      version: version2,
      layer,
      sampleRate,
      bitRate,
      duration,
      size: length,
      hasPadding,
      frameSize,
      frameDurationFloat
    };
  };
  var mp3TrimFix = {
    rm: Recorder2.mp3ReadMeta,
    fn: function(mp3Buffers, length, pcmLength, pcmSampleRate) {
      var meta = this.rm(mp3Buffers, length);
      if (!meta) {
        return {
          err: "mp3 unknown format"
        };
      }
      var pcmDuration = Math.round(pcmLength / pcmSampleRate * 1e3);
      var num = Math.floor((meta.duration - pcmDuration) / meta.frameDurationFloat);
      if (num > 0) {
        var size2 = num * meta.frameSize - (meta.hasPadding ? 1 : 0);
        length -= size2;
        var arr0 = 0, arrs = [];
        for (var i = 0; i < mp3Buffers.length; i++) {
          var arr = mp3Buffers[i];
          if (size2 <= 0) {
            break;
          }
          if (size2 >= arr.byteLength) {
            size2 -= arr.byteLength;
            arrs.push(arr);
            mp3Buffers.splice(i, 1);
            i--;
          } else {
            mp3Buffers[i] = arr.slice(size2);
            arr0 = arr;
            size2 = 0;
          }
        }
        var checkMeta = this.rm(mp3Buffers, length);
        if (!checkMeta) {
          arr0 && (mp3Buffers[0] = arr0);
          for (var i = 0; i < arrs.length; i++) {
            mp3Buffers.splice(i, 0, arrs[i]);
          }
          meta.err = "mp3 fix error: \u5DF2\u8FD8\u539F\uFF0C\u9519\u8BEF\u539F\u56E0\u4E0D\u660E";
        }
        var fix = meta.trimFix = {};
        fix.remove = num;
        fix.removeDuration = Math.round(num * meta.frameDurationFloat);
        fix.duration = Math.round(length * 8 / meta.bitRate);
      }
      return meta;
    }
  };
  var mp3TrimFixSetMeta = function(meta, set4) {
    var tag = "MP3 Info: ";
    if (meta.sampleRate && meta.sampleRate != set4.sampleRate || meta.bitRate && meta.bitRate != set4.bitRate) {
      Recorder2.CLog(tag + $T("uY9i::\u548C\u8BBE\u7F6E\u7684\u4E0D\u5339\u914D{1}\uFF0C\u5DF2\u66F4\u65B0\u6210{2}", 0, "set:" + set4.bitRate + "kbps " + set4.sampleRate + "hz", "set:" + meta.bitRate + "kbps " + meta.sampleRate + "hz"), 3, set4);
      set4.sampleRate = meta.sampleRate;
      set4.bitRate = meta.bitRate;
    }
    var trimFix = meta.trimFix;
    if (trimFix) {
      tag += $T("iMSm::Fix\u79FB\u9664{1}\u5E27", 0, trimFix.remove) + " " + trimFix.removeDuration + "ms -> " + trimFix.duration + "ms";
      if (trimFix.remove > 2) {
        meta.err = (meta.err ? meta.err + ", " : "") + $T("b9zm::\u79FB\u9664\u5E27\u6570\u8FC7\u591A");
      }
    } else {
      tag += (meta.duration || "-") + "ms";
    }
    if (meta.err) {
      Recorder2.CLog(tag, 1, meta.err, meta);
    } else {
      Recorder2.CLog(tag, meta);
    }
  };
});
(function(factory) {
  var browser = typeof window == "object" && !!window.document;
  var win = browser ? window : Object;
  var rec = win.Recorder;
  factory(rec);
})(function(Recorder2) {
  function lamejs() {
    var Math_log10 = function(s) {
      return Math.log(s) / Math.log(10);
    };
    var abort = function(what) {
      throw new Error("abort(" + what + ")");
    };
    function new_byte(count3) {
      return new Int8Array(count3);
    }
    function new_short(count3) {
      return new Int16Array(count3);
    }
    function new_int(count3) {
      return new Int32Array(count3);
    }
    function new_float(count3) {
      return new Float32Array(count3);
    }
    function new_double(count3) {
      return new Float64Array(count3);
    }
    function new_float_n(args) {
      if (args.length == 1) {
        return new_float(args[0]);
      }
      var sz = args[0];
      args = args.slice(1);
      var A = [];
      for (var i = 0; i < sz; i++) {
        A.push(new_float_n(args));
      }
      return A;
    }
    function new_int_n(args) {
      if (args.length == 1) {
        return new_int(args[0]);
      }
      var sz = args[0];
      args = args.slice(1);
      var A = [];
      for (var i = 0; i < sz; i++) {
        A.push(new_int_n(args));
      }
      return A;
    }
    function new_short_n(args) {
      if (args.length == 1) {
        return new_short(args[0]);
      }
      var sz = args[0];
      args = args.slice(1);
      var A = [];
      for (var i = 0; i < sz; i++) {
        A.push(new_short_n(args));
      }
      return A;
    }
    function new_array_n(args) {
      if (args.length == 1) {
        return new Array(args[0]);
      }
      var sz = args[0];
      args = args.slice(1);
      var A = [];
      for (var i = 0; i < sz; i++) {
        A.push(new_array_n(args));
      }
      return A;
    }
    var Arrays = {};
    Arrays.fill = function(a, fromIndex, toIndex, val) {
      if (arguments.length == 2) {
        for (var i = 0; i < a.length; i++) {
          a[i] = arguments[1];
        }
      } else {
        for (var i = fromIndex; i < toIndex; i++) {
          a[i] = val;
        }
      }
    };
    var System = {};
    System.arraycopy = function(src2, srcPos, dest, destPos, length) {
      var srcEnd = srcPos + length;
      while (srcPos < srcEnd)
        dest[destPos++] = src2[srcPos++];
    };
    var Util = {};
    Util.SQRT2 = 1.4142135623730951;
    Util.FAST_LOG10 = function(x) {
      return Math_log10(x);
    };
    Util.FAST_LOG10_X = function(x, y) {
      return Math_log10(x) * y;
    };
    function ShortBlock(ordinal) {
      this.ordinal = ordinal;
    }
    ShortBlock.short_block_allowed = new ShortBlock(0);
    ShortBlock.short_block_coupled = new ShortBlock(1);
    ShortBlock.short_block_dispensed = new ShortBlock(2);
    ShortBlock.short_block_forced = new ShortBlock(3);
    var Float = {};
    Float.MAX_VALUE = 34028235e31;
    function VbrMode(ordinal) {
      this.ordinal = ordinal;
    }
    VbrMode.vbr_off = new VbrMode(0);
    VbrMode.vbr_mt = new VbrMode(1);
    VbrMode.vbr_rh = new VbrMode(2);
    VbrMode.vbr_abr = new VbrMode(3);
    VbrMode.vbr_mtrh = new VbrMode(4);
    VbrMode.vbr_default = VbrMode.vbr_mtrh;
    function MPEGMode(ordinal) {
      var _ordinal = ordinal;
      this.ordinal = function() {
        return _ordinal;
      };
    }
    MPEGMode.STEREO = new MPEGMode(0);
    MPEGMode.JOINT_STEREO = new MPEGMode(1);
    MPEGMode.DUAL_CHANNEL = new MPEGMode(2);
    MPEGMode.MONO = new MPEGMode(3);
    MPEGMode.NOT_SET = new MPEGMode(4);
    function Version() {
      var LAME_MAJOR_VERSION = 3;
      var LAME_MINOR_VERSION = 98;
      var LAME_PATCH_VERSION = 4;
      this.getLameShortVersion = function() {
        return LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "." + LAME_PATCH_VERSION;
      };
    }
    function Takehiro() {
      var qupvt = null;
      this.qupvt = null;
      this.setModules = function(_qupvt) {
        this.qupvt = _qupvt;
        qupvt = _qupvt;
      };
      function Bits(b) {
        this.bits = 0 | b;
      }
      var subdv_table = [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 1],
        [1, 1],
        [1, 1],
        [1, 2],
        [2, 2],
        [2, 3],
        [2, 3],
        [3, 4],
        [3, 4],
        [3, 4],
        [4, 5],
        [4, 5],
        [4, 6],
        [5, 6],
        [5, 6],
        [5, 7],
        [6, 7],
        [6, 7]
      ];
      function quantize_lines_xrpow_01(l, istep, xr, xrPos, ix, ixPos) {
        var compareval0 = (1 - 0.4054) / istep;
        l = l >> 1;
        while (l-- != 0) {
          ix[ixPos++] = compareval0 > xr[xrPos++] ? 0 : 1;
          ix[ixPos++] = compareval0 > xr[xrPos++] ? 0 : 1;
        }
      }
      function quantize_lines_xrpow(l, istep, xr, xrPos, ix, ixPos) {
        l = l >> 1;
        var remaining = l % 2;
        l = l >> 1;
        while (l-- != 0) {
          var x0, x1, x2, x3;
          var rx0, rx1, rx2, rx3;
          x0 = xr[xrPos++] * istep;
          x1 = xr[xrPos++] * istep;
          rx0 = 0 | x0;
          x2 = xr[xrPos++] * istep;
          rx1 = 0 | x1;
          x3 = xr[xrPos++] * istep;
          rx2 = 0 | x2;
          x0 += qupvt.adj43[rx0];
          rx3 = 0 | x3;
          x1 += qupvt.adj43[rx1];
          ix[ixPos++] = 0 | x0;
          x2 += qupvt.adj43[rx2];
          ix[ixPos++] = 0 | x1;
          x3 += qupvt.adj43[rx3];
          ix[ixPos++] = 0 | x2;
          ix[ixPos++] = 0 | x3;
        }
        if (remaining != 0) {
          var x0, x1;
          var rx0, rx1;
          x0 = xr[xrPos++] * istep;
          x1 = xr[xrPos++] * istep;
          rx0 = 0 | x0;
          rx1 = 0 | x1;
          x0 += qupvt.adj43[rx0];
          x1 += qupvt.adj43[rx1];
          ix[ixPos++] = 0 | x0;
          ix[ixPos++] = 0 | x1;
        }
      }
      function quantize_xrpow(xp, pi, istep, codInfo, prevNoise) {
        var sfb;
        var sfbmax;
        var j = 0;
        var prev_data_use;
        var accumulate = 0;
        var accumulate01 = 0;
        var xpPos = 0;
        var iData = pi;
        var iDataPos = 0;
        var acc_iData = iData;
        var acc_iDataPos = 0;
        var acc_xp = xp;
        var acc_xpPos = 0;
        prev_data_use = prevNoise != null && codInfo.global_gain == prevNoise.global_gain;
        if (codInfo.block_type == Encoder.SHORT_TYPE)
          sfbmax = 38;
        else
          sfbmax = 21;
        for (sfb = 0; sfb <= sfbmax; sfb++) {
          var step = -1;
          if (prev_data_use || codInfo.block_type == Encoder.NORM_TYPE) {
            step = codInfo.global_gain - (codInfo.scalefac[sfb] + (codInfo.preflag != 0 ? qupvt.pretab[sfb] : 0) << codInfo.scalefac_scale + 1) - codInfo.subblock_gain[codInfo.window[sfb]] * 8;
          }
          if (prev_data_use && prevNoise.step[sfb] == step) {
            if (accumulate != 0) {
              quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
              accumulate = 0;
            }
            if (accumulate01 != 0) {
              abort();
            }
          } else {
            var l = codInfo.width[sfb];
            if (j + codInfo.width[sfb] > codInfo.max_nonzero_coeff) {
              var usefullsize;
              usefullsize = codInfo.max_nonzero_coeff - j + 1;
              Arrays.fill(pi, codInfo.max_nonzero_coeff, 576, 0);
              l = usefullsize;
              if (l < 0) {
                l = 0;
              }
              sfb = sfbmax + 1;
            }
            if (accumulate == 0 && accumulate01 == 0) {
              acc_iData = iData;
              acc_iDataPos = iDataPos;
              acc_xp = xp;
              acc_xpPos = xpPos;
            }
            if (prevNoise != null && prevNoise.sfb_count1 > 0 && sfb >= prevNoise.sfb_count1 && prevNoise.step[sfb] > 0 && step >= prevNoise.step[sfb]) {
              if (accumulate != 0) {
                quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
                accumulate = 0;
                acc_iData = iData;
                acc_iDataPos = iDataPos;
                acc_xp = xp;
                acc_xpPos = xpPos;
              }
              accumulate01 += l;
            } else {
              if (accumulate01 != 0) {
                quantize_lines_xrpow_01(accumulate01, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
                accumulate01 = 0;
                acc_iData = iData;
                acc_iDataPos = iDataPos;
                acc_xp = xp;
                acc_xpPos = xpPos;
              }
              accumulate += l;
            }
            if (l <= 0) {
              if (accumulate01 != 0) {
                abort();
              }
              if (accumulate != 0) {
                abort();
              }
              break;
            }
          }
          if (sfb <= sfbmax) {
            iDataPos += codInfo.width[sfb];
            xpPos += codInfo.width[sfb];
            j += codInfo.width[sfb];
          }
        }
        if (accumulate != 0) {
          quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos, acc_iData, acc_iDataPos);
          accumulate = 0;
        }
        if (accumulate01 != 0) {
          abort();
        }
      }
      function ix_max(ix, ixPos, endPos) {
        var max1 = 0, max2 = 0;
        do {
          var x1 = ix[ixPos++];
          var x2 = ix[ixPos++];
          if (max1 < x1)
            max1 = x1;
          if (max2 < x2)
            max2 = x2;
        } while (ixPos < endPos);
        if (max1 < max2)
          max1 = max2;
        return max1;
      }
      function count_bit_ESC(ix, ixPos, end, t1, t22, s) {
        var linbits = Tables.ht[t1].xlen * 65536 + Tables.ht[t22].xlen;
        var sum = 0, sum2;
        do {
          var x = ix[ixPos++];
          var y = ix[ixPos++];
          if (x != 0) {
            if (x > 14) {
              x = 15;
              sum += linbits;
            }
            x *= 16;
          }
          if (y != 0) {
            if (y > 14) {
              y = 15;
              sum += linbits;
            }
            x += y;
          }
          sum += Tables.largetbl[x];
        } while (ixPos < end);
        sum2 = sum & 65535;
        sum >>= 16;
        if (sum > sum2) {
          sum = sum2;
          t1 = t22;
        }
        s.bits += sum;
        return t1;
      }
      function count_bit_noESC(ix, ixPos, end, s) {
        var sum1 = 0;
        var hlen1 = Tables.ht[1].hlen;
        do {
          var x = ix[ixPos + 0] * 2 + ix[ixPos + 1];
          ixPos += 2;
          sum1 += hlen1[x];
        } while (ixPos < end);
        s.bits += sum1;
        return 1;
      }
      function count_bit_noESC_from2(ix, ixPos, end, t1, s) {
        var sum = 0, sum2;
        var xlen = Tables.ht[t1].xlen;
        var hlen;
        if (t1 == 2)
          hlen = Tables.table23;
        else
          hlen = Tables.table56;
        do {
          var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
          ixPos += 2;
          sum += hlen[x];
        } while (ixPos < end);
        sum2 = sum & 65535;
        sum >>= 16;
        if (sum > sum2) {
          sum = sum2;
          t1++;
        }
        s.bits += sum;
        return t1;
      }
      function count_bit_noESC_from3(ix, ixPos, end, t1, s) {
        var sum1 = 0;
        var sum2 = 0;
        var sum3 = 0;
        var xlen = Tables.ht[t1].xlen;
        var hlen1 = Tables.ht[t1].hlen;
        var hlen2 = Tables.ht[t1 + 1].hlen;
        var hlen3 = Tables.ht[t1 + 2].hlen;
        do {
          var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
          ixPos += 2;
          sum1 += hlen1[x];
          sum2 += hlen2[x];
          sum3 += hlen3[x];
        } while (ixPos < end);
        var t4 = t1;
        if (sum1 > sum2) {
          sum1 = sum2;
          t4++;
        }
        if (sum1 > sum3) {
          sum1 = sum3;
          t4 = t1 + 2;
        }
        s.bits += sum1;
        return t4;
      }
      var huf_tbl_noESC = [1, 2, 5, 7, 7, 10, 10, 13, 13, 13, 13, 13, 13, 13, 13];
      function choose_table(ix, ixPos, endPos, s) {
        var max = ix_max(ix, ixPos, endPos);
        switch (max) {
          case 0:
            return max;
          case 1:
            return count_bit_noESC(ix, ixPos, endPos, s);
          case 2:
          case 3:
            return count_bit_noESC_from2(ix, ixPos, endPos, huf_tbl_noESC[max - 1], s);
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
          case 15:
            return count_bit_noESC_from3(ix, ixPos, endPos, huf_tbl_noESC[max - 1], s);
          default:
            if (max > QuantizePVT.IXMAX_VAL) {
              abort();
            }
            max -= 15;
            var choice2;
            for (choice2 = 24; choice2 < 32; choice2++) {
              if (Tables.ht[choice2].linmax >= max) {
                break;
              }
            }
            var choice;
            for (choice = choice2 - 8; choice < 24; choice++) {
              if (Tables.ht[choice].linmax >= max) {
                break;
              }
            }
            return count_bit_ESC(ix, ixPos, endPos, choice, choice2, s);
        }
      }
      this.noquant_count_bits = function(gfc, gi, prev_noise) {
        var ix = gi.l3_enc;
        var i = Math.min(576, gi.max_nonzero_coeff + 2 >> 1 << 1);
        if (prev_noise != null)
          prev_noise.sfb_count1 = 0;
        for (; i > 1; i -= 2)
          if ((ix[i - 1] | ix[i - 2]) != 0)
            break;
        gi.count1 = i;
        var a1 = 0;
        var a2 = 0;
        for (; i > 3; i -= 4) {
          var p;
          if (((ix[i - 1] | ix[i - 2] | ix[i - 3] | ix[i - 4]) & 2147483647) > 1) {
            break;
          }
          p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2 + ix[i - 1];
          a1 += Tables.t32l[p];
          a2 += Tables.t33l[p];
        }
        var bits = a1;
        gi.count1table_select = 0;
        if (a1 > a2) {
          bits = a2;
          gi.count1table_select = 1;
        }
        gi.count1bits = bits;
        gi.big_values = i;
        if (i == 0)
          return bits;
        if (gi.block_type == Encoder.SHORT_TYPE) {
          a1 = 3 * gfc.scalefac_band.s[3];
          if (a1 > gi.big_values)
            a1 = gi.big_values;
          a2 = gi.big_values;
        } else if (gi.block_type == Encoder.NORM_TYPE) {
          a1 = gi.region0_count = gfc.bv_scf[i - 2];
          a2 = gi.region1_count = gfc.bv_scf[i - 1];
          a2 = gfc.scalefac_band.l[a1 + a2 + 2];
          a1 = gfc.scalefac_band.l[a1 + 1];
          if (a2 < i) {
            var bi = new Bits(bits);
            gi.table_select[2] = choose_table(ix, a2, i, bi);
            bits = bi.bits;
          }
        } else {
          gi.region0_count = 7;
          gi.region1_count = Encoder.SBMAX_l - 1 - 7 - 1;
          a1 = gfc.scalefac_band.l[7 + 1];
          a2 = i;
          if (a1 > a2) {
            a1 = a2;
          }
        }
        a1 = Math.min(a1, i);
        a2 = Math.min(a2, i);
        if (0 < a1) {
          var bi = new Bits(bits);
          gi.table_select[0] = choose_table(ix, 0, a1, bi);
          bits = bi.bits;
        }
        if (a1 < a2) {
          var bi = new Bits(bits);
          gi.table_select[1] = choose_table(ix, a1, a2, bi);
          bits = bi.bits;
        }
        if (gfc.use_best_huffman == 2) {
          abort();
        }
        if (prev_noise != null) {
          if (gi.block_type == Encoder.NORM_TYPE) {
            var sfb = 0;
            while (gfc.scalefac_band.l[sfb] < gi.big_values) {
              sfb++;
            }
            prev_noise.sfb_count1 = sfb;
          }
        }
        return bits;
      };
      this.count_bits = function(gfc, xr, gi, prev_noise) {
        var ix = gi.l3_enc;
        var w = QuantizePVT.IXMAX_VAL / qupvt.IPOW20(gi.global_gain);
        if (gi.xrpow_max > w)
          return QuantizePVT.LARGE_BITS;
        quantize_xrpow(xr, ix, qupvt.IPOW20(gi.global_gain), gi, prev_noise);
        if ((gfc.substep_shaping & 2) != 0) {
          abort();
        }
        return this.noquant_count_bits(gfc, gi, prev_noise);
      };
      function recalc_divide_init(gfc, cod_info, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
        var bigv = cod_info.big_values;
        for (var r0 = 0; r0 <= 7 + 15; r0++) {
          r01_bits[r0] = QuantizePVT.LARGE_BITS;
        }
        for (var r0 = 0; r0 < 16; r0++) {
          var a1 = gfc.scalefac_band.l[r0 + 1];
          if (a1 >= bigv)
            break;
          var r0bits = 0;
          var bi = new Bits(r0bits);
          var r0t = choose_table(ix, 0, a1, bi);
          r0bits = bi.bits;
          for (var r1 = 0; r1 < 8; r1++) {
            var a2 = gfc.scalefac_band.l[r0 + r1 + 2];
            if (a2 >= bigv)
              break;
            var bits = r0bits;
            bi = new Bits(bits);
            var r1t = choose_table(ix, a1, a2, bi);
            bits = bi.bits;
            if (r01_bits[r0 + r1] > bits) {
              r01_bits[r0 + r1] = bits;
              r01_div[r0 + r1] = r0;
              r0_tbl[r0 + r1] = r0t;
              r1_tbl[r0 + r1] = r1t;
            }
          }
        }
      }
      function recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
        var bigv = cod_info2.big_values;
        for (var r2 = 2; r2 < Encoder.SBMAX_l + 1; r2++) {
          var a2 = gfc.scalefac_band.l[r2];
          if (a2 >= bigv)
            break;
          var bits = r01_bits[r2 - 2] + cod_info2.count1bits;
          if (gi.part2_3_length <= bits)
            break;
          var bi = new Bits(bits);
          var r2t = choose_table(ix, a2, bigv, bi);
          bits = bi.bits;
          if (gi.part2_3_length <= bits)
            continue;
          gi.assign(cod_info2);
          gi.part2_3_length = bits;
          gi.region0_count = r01_div[r2 - 2];
          gi.region1_count = r2 - 2 - r01_div[r2 - 2];
          gi.table_select[0] = r0_tbl[r2 - 2];
          gi.table_select[1] = r1_tbl[r2 - 2];
          gi.table_select[2] = r2t;
        }
      }
      this.best_huffman_divide = function(gfc, gi) {
        var cod_info2 = new GrInfo();
        var ix = gi.l3_enc;
        var r01_bits = new_int(7 + 15 + 1);
        var r01_div = new_int(7 + 15 + 1);
        var r0_tbl = new_int(7 + 15 + 1);
        var r1_tbl = new_int(7 + 15 + 1);
        if (gi.block_type == Encoder.SHORT_TYPE && gfc.mode_gr == 1)
          return;
        cod_info2.assign(gi);
        if (gi.block_type == Encoder.NORM_TYPE) {
          recalc_divide_init(gfc, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl);
          recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl);
        }
        var i = cod_info2.big_values;
        if (i == 0 || (ix[i - 2] | ix[i - 1]) > 1)
          return;
        i = gi.count1 + 2;
        if (i > 576)
          return;
        cod_info2.assign(gi);
        cod_info2.count1 = i;
        var a1 = 0;
        var a2 = 0;
        for (; i > cod_info2.big_values; i -= 4) {
          var p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2 + ix[i - 1];
          a1 += Tables.t32l[p];
          a2 += Tables.t33l[p];
        }
        cod_info2.big_values = i;
        cod_info2.count1table_select = 0;
        if (a1 > a2) {
          a1 = a2;
          cod_info2.count1table_select = 1;
        }
        cod_info2.count1bits = a1;
        if (cod_info2.block_type == Encoder.NORM_TYPE)
          recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl);
        else {
          cod_info2.part2_3_length = a1;
          a1 = gfc.scalefac_band.l[7 + 1];
          if (a1 > i) {
            a1 = i;
          }
          if (a1 > 0) {
            var bi = new Bits(cod_info2.part2_3_length);
            cod_info2.table_select[0] = choose_table(ix, 0, a1, bi);
            cod_info2.part2_3_length = bi.bits;
          }
          if (i > a1) {
            var bi = new Bits(cod_info2.part2_3_length);
            cod_info2.table_select[1] = choose_table(ix, a1, i, bi);
            cod_info2.part2_3_length = bi.bits;
          }
          if (gi.part2_3_length > cod_info2.part2_3_length)
            gi.assign(cod_info2);
        }
      };
      var slen1_n = [1, 1, 1, 1, 8, 2, 2, 2, 4, 4, 4, 8, 8, 8, 16, 16];
      var slen2_n = [1, 2, 4, 8, 1, 2, 4, 8, 2, 4, 8, 2, 4, 8, 4, 8];
      var slen1_tab = [0, 0, 0, 0, 3, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4];
      var slen2_tab = [0, 1, 2, 3, 0, 1, 2, 3, 1, 2, 3, 1, 2, 3, 2, 3];
      Takehiro.slen1_tab = slen1_tab;
      Takehiro.slen2_tab = slen2_tab;
      function scfsi_calc(ch, l3_side) {
        var sfb;
        var gi = l3_side.tt[1][ch];
        var g0 = l3_side.tt[0][ch];
        for (var i = 0; i < Tables.scfsi_band.length - 1; i++) {
          for (sfb = Tables.scfsi_band[i]; sfb < Tables.scfsi_band[i + 1]; sfb++) {
            if (g0.scalefac[sfb] != gi.scalefac[sfb] && gi.scalefac[sfb] >= 0)
              break;
          }
          if (sfb == Tables.scfsi_band[i + 1]) {
            for (sfb = Tables.scfsi_band[i]; sfb < Tables.scfsi_band[i + 1]; sfb++) {
              gi.scalefac[sfb] = -1;
            }
            l3_side.scfsi[ch][i] = 1;
          }
        }
        var s1 = 0;
        var c1 = 0;
        for (sfb = 0; sfb < 11; sfb++) {
          if (gi.scalefac[sfb] == -1)
            continue;
          c1++;
          if (s1 < gi.scalefac[sfb])
            s1 = gi.scalefac[sfb];
        }
        var s2 = 0;
        var c2 = 0;
        for (; sfb < Encoder.SBPSY_l; sfb++) {
          if (gi.scalefac[sfb] == -1)
            continue;
          c2++;
          if (s2 < gi.scalefac[sfb])
            s2 = gi.scalefac[sfb];
        }
        for (var i = 0; i < 16; i++) {
          if (s1 < slen1_n[i] && s2 < slen2_n[i]) {
            var c = slen1_tab[i] * c1 + slen2_tab[i] * c2;
            if (gi.part2_length > c) {
              gi.part2_length = c;
              gi.scalefac_compress = i;
            }
          }
        }
      }
      this.best_scalefac_store = function(gfc, gr, ch, l3_side) {
        var gi = l3_side.tt[gr][ch];
        var sfb, i, j, l;
        var recalc = 0;
        j = 0;
        for (sfb = 0; sfb < gi.sfbmax; sfb++) {
          var width = gi.width[sfb];
          j += width;
          for (l = -width; l < 0; l++) {
            if (gi.l3_enc[l + j] != 0)
              break;
          }
          if (l == 0)
            gi.scalefac[sfb] = recalc = -2;
        }
        if (gi.scalefac_scale == 0 && gi.preflag == 0) {
          var s = 0;
          for (sfb = 0; sfb < gi.sfbmax; sfb++)
            if (gi.scalefac[sfb] > 0)
              s |= gi.scalefac[sfb];
          if ((s & 1) == 0 && s != 0) {
            for (sfb = 0; sfb < gi.sfbmax; sfb++)
              if (gi.scalefac[sfb] > 0)
                gi.scalefac[sfb] >>= 1;
            gi.scalefac_scale = recalc = 1;
          }
        }
        if (gi.preflag == 0 && gi.block_type != Encoder.SHORT_TYPE && gfc.mode_gr == 2) {
          for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
            if (gi.scalefac[sfb] < qupvt.pretab[sfb] && gi.scalefac[sfb] != -2)
              break;
          if (sfb == Encoder.SBPSY_l) {
            for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
              if (gi.scalefac[sfb] > 0)
                gi.scalefac[sfb] -= qupvt.pretab[sfb];
            gi.preflag = recalc = 1;
          }
        }
        for (i = 0; i < 4; i++)
          l3_side.scfsi[ch][i] = 0;
        if (gfc.mode_gr == 2 && gr == 1 && l3_side.tt[0][ch].block_type != Encoder.SHORT_TYPE && l3_side.tt[1][ch].block_type != Encoder.SHORT_TYPE) {
          scfsi_calc(ch, l3_side);
          recalc = 0;
        }
        for (sfb = 0; sfb < gi.sfbmax; sfb++) {
          if (gi.scalefac[sfb] == -2) {
            gi.scalefac[sfb] = 0;
          }
        }
        if (recalc != 0) {
          if (gfc.mode_gr == 2) {
            this.scale_bitcount(gi);
          } else {
            this.scale_bitcount_lsf(gfc, gi);
          }
        }
      };
      var scale_short = [0, 18, 36, 54, 54, 36, 54, 72, 54, 72, 90, 72, 90, 108, 108, 126];
      var scale_mixed = [0, 18, 36, 54, 51, 35, 53, 71, 52, 70, 88, 69, 87, 105, 104, 122];
      var scale_long = [0, 10, 20, 30, 33, 21, 31, 41, 32, 42, 52, 43, 53, 63, 64, 74];
      this.scale_bitcount = function(cod_info) {
        var k, sfb, max_slen1 = 0, max_slen2 = 0;
        var tab;
        var scalefac = cod_info.scalefac;
        if (cod_info.block_type == Encoder.SHORT_TYPE) {
          tab = scale_short;
          if (cod_info.mixed_block_flag != 0)
            tab = scale_mixed;
        } else {
          tab = scale_long;
          if (cod_info.preflag == 0) {
            for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
              if (scalefac[sfb] < qupvt.pretab[sfb])
                break;
            if (sfb == Encoder.SBPSY_l) {
              cod_info.preflag = 1;
              for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
                scalefac[sfb] -= qupvt.pretab[sfb];
            }
          }
        }
        for (sfb = 0; sfb < cod_info.sfbdivide; sfb++)
          if (max_slen1 < scalefac[sfb])
            max_slen1 = scalefac[sfb];
        for (; sfb < cod_info.sfbmax; sfb++)
          if (max_slen2 < scalefac[sfb])
            max_slen2 = scalefac[sfb];
        cod_info.part2_length = QuantizePVT.LARGE_BITS;
        for (k = 0; k < 16; k++) {
          if (max_slen1 < slen1_n[k] && max_slen2 < slen2_n[k] && cod_info.part2_length > tab[k]) {
            cod_info.part2_length = tab[k];
            cod_info.scalefac_compress = k;
          }
        }
        return cod_info.part2_length == QuantizePVT.LARGE_BITS;
      };
      var max_range_sfac_tab = [[15, 15, 7, 7], [15, 15, 7, 0], [7, 3, 0, 0], [15, 31, 31, 0], [7, 7, 7, 0], [3, 3, 0, 0]];
      this.scale_bitcount_lsf = function(gfc, cod_info) {
        var table_number, row_in_table, partition, nr_sfb, window2;
        var over;
        var i, sfb;
        var max_sfac = new_int(4);
        var scalefac = cod_info.scalefac;
        if (cod_info.preflag != 0)
          table_number = 2;
        else
          table_number = 0;
        for (i = 0; i < 4; i++)
          max_sfac[i] = 0;
        if (cod_info.block_type == Encoder.SHORT_TYPE) {
          row_in_table = 1;
          var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
          for (sfb = 0, partition = 0; partition < 4; partition++) {
            nr_sfb = partition_table[partition] / 3;
            for (i = 0; i < nr_sfb; i++, sfb++)
              for (window2 = 0; window2 < 3; window2++)
                if (scalefac[sfb * 3 + window2] > max_sfac[partition])
                  max_sfac[partition] = scalefac[sfb * 3 + window2];
          }
        } else {
          row_in_table = 0;
          var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
          for (sfb = 0, partition = 0; partition < 4; partition++) {
            nr_sfb = partition_table[partition];
            for (i = 0; i < nr_sfb; i++, sfb++)
              if (scalefac[sfb] > max_sfac[partition])
                max_sfac[partition] = scalefac[sfb];
          }
        }
        for (over = false, partition = 0; partition < 4; partition++) {
          if (max_sfac[partition] > max_range_sfac_tab[table_number][partition])
            over = true;
        }
        if (!over) {
          var slen1, slen2, slen3, slen4;
          cod_info.sfb_partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
          for (partition = 0; partition < 4; partition++)
            cod_info.slen[partition] = log2tab[max_sfac[partition]];
          slen1 = cod_info.slen[0];
          slen2 = cod_info.slen[1];
          slen3 = cod_info.slen[2];
          slen4 = cod_info.slen[3];
          switch (table_number) {
            case 0:
              cod_info.scalefac_compress = (slen1 * 5 + slen2 << 4) + (slen3 << 2) + slen4;
              break;
            case 1:
              cod_info.scalefac_compress = 400 + (slen1 * 5 + slen2 << 2) + slen3;
              break;
            case 2:
              cod_info.scalefac_compress = 500 + slen1 * 3 + slen2;
              break;
          }
        }
        if (!over) {
          cod_info.part2_length = 0;
          for (partition = 0; partition < 4; partition++)
            cod_info.part2_length += cod_info.slen[partition] * cod_info.sfb_partition_table[partition];
        }
        return over;
      };
      var log2tab = [0, 1, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4];
      this.huffman_init = function(gfc) {
        for (var i = 2; i <= 576; i += 2) {
          var scfb_anz = 0, bv_index;
          while (gfc.scalefac_band.l[++scfb_anz] < i)
            ;
          bv_index = subdv_table[scfb_anz][0];
          while (gfc.scalefac_band.l[bv_index + 1] > i)
            bv_index--;
          if (bv_index < 0) {
            bv_index = subdv_table[scfb_anz][0];
          }
          gfc.bv_scf[i - 2] = bv_index;
          bv_index = subdv_table[scfb_anz][1];
          while (gfc.scalefac_band.l[bv_index + gfc.bv_scf[i - 2] + 2] > i)
            bv_index--;
          if (bv_index < 0) {
            bv_index = subdv_table[scfb_anz][1];
          }
          gfc.bv_scf[i - 1] = bv_index;
        }
      };
    }
    GainAnalysis.STEPS_per_dB = 100;
    GainAnalysis.MAX_dB = 120;
    GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES = -24601;
    GainAnalysis.GAIN_ANALYSIS_ERROR = 0;
    GainAnalysis.GAIN_ANALYSIS_OK = 1;
    GainAnalysis.INIT_GAIN_ANALYSIS_ERROR = 0;
    GainAnalysis.INIT_GAIN_ANALYSIS_OK = 1;
    GainAnalysis.YULE_ORDER = 10;
    GainAnalysis.MAX_ORDER = GainAnalysis.YULE_ORDER;
    GainAnalysis.MAX_SAMP_FREQ = 48e3;
    GainAnalysis.RMS_WINDOW_TIME_NUMERATOR = 1;
    GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR = 20;
    GainAnalysis.MAX_SAMPLES_PER_WINDOW = GainAnalysis.MAX_SAMP_FREQ * GainAnalysis.RMS_WINDOW_TIME_NUMERATOR / GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR + 1;
    function GainAnalysis() {
    }
    function Presets() {
      function ABRPresets(kbps, comp, compS, joint, fix, shThreshold, shThresholdS, bass, sc, mask, lower, curve, interCh, sfScale) {
        this.quant_comp = comp;
        this.quant_comp_s = compS;
        this.safejoint = joint;
        this.nsmsfix = fix;
        this.st_lrm = shThreshold;
        this.st_s = shThresholdS;
        this.nsbass = bass;
        this.scale = sc;
        this.masking_adj = mask;
        this.ath_lower = lower;
        this.ath_curve = curve;
        this.interch = interCh;
        this.sfscale = sfScale;
      }
      var lame;
      this.setModules = function(_lame) {
        lame = _lame;
      };
      function apply_vbr_preset(gfp, a, enforce) {
        abort();
      }
      var abr_switch_map = [
        new ABRPresets(8, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -30, 11, 12e-4, 1),
        new ABRPresets(16, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -25, 11, 1e-3, 1),
        new ABRPresets(24, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -20, 11, 1e-3, 1),
        new ABRPresets(32, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -15, 11, 1e-3, 1),
        new ABRPresets(40, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -10, 11, 9e-4, 1),
        new ABRPresets(48, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -10, 11, 9e-4, 1),
        new ABRPresets(56, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -6, 11, 8e-4, 1),
        new ABRPresets(64, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -2, 11, 8e-4, 1),
        new ABRPresets(80, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, 0, 8, 7e-4, 1),
        new ABRPresets(96, 9, 9, 0, 2.5, 6.6, 145, 0, 0.95, 0, 1, 5.5, 6e-4, 1),
        new ABRPresets(112, 9, 9, 0, 2.25, 6.6, 145, 0, 0.95, 0, 2, 4.5, 5e-4, 1),
        new ABRPresets(128, 9, 9, 0, 1.95, 6.4, 140, 0, 0.95, 0, 3, 4, 2e-4, 1),
        new ABRPresets(160, 9, 9, 1, 1.79, 6, 135, 0, 0.95, -2, 5, 3.5, 0, 1),
        new ABRPresets(192, 9, 9, 1, 1.49, 5.6, 125, 0, 0.97, -4, 7, 3, 0, 0),
        new ABRPresets(224, 9, 9, 1, 1.25, 5.2, 125, 0, 0.98, -6, 9, 2, 0, 0),
        new ABRPresets(256, 9, 9, 1, 0.97, 5.2, 125, 0, 1, -8, 10, 1, 0, 0),
        new ABRPresets(320, 9, 9, 1, 0.9, 5.2, 125, 0, 1, -10, 12, 0, 0, 0)
      ];
      function apply_abr_preset(gfp, preset, enforce) {
        var actual_bitrate = preset;
        var r = lame.nearestBitrateFullIndex(preset);
        gfp.VBR = VbrMode.vbr_abr;
        gfp.VBR_mean_bitrate_kbps = actual_bitrate;
        gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 320);
        gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 8);
        gfp.brate = gfp.VBR_mean_bitrate_kbps;
        if (gfp.VBR_mean_bitrate_kbps > 320) {
          gfp.disable_reservoir = true;
        }
        if (abr_switch_map[r].safejoint > 0)
          gfp.exp_nspsytune = gfp.exp_nspsytune | 2;
        if (abr_switch_map[r].sfscale > 0) {
          gfp.internal_flags.noise_shaping = 2;
        }
        if (Math.abs(abr_switch_map[r].nsbass) > 0) {
          var k = int(abr_switch_map[r].nsbass * 4);
          if (k < 0)
            k += 64;
          gfp.exp_nspsytune = gfp.exp_nspsytune | k << 2;
        }
        if (enforce != 0)
          gfp.quant_comp = abr_switch_map[r].quant_comp;
        else if (!(Math.abs(gfp.quant_comp - -1) > 0))
          gfp.quant_comp = abr_switch_map[r].quant_comp;
        if (enforce != 0)
          gfp.quant_comp_short = abr_switch_map[r].quant_comp_s;
        else if (!(Math.abs(gfp.quant_comp_short - -1) > 0))
          gfp.quant_comp_short = abr_switch_map[r].quant_comp_s;
        if (enforce != 0)
          gfp.msfix = abr_switch_map[r].nsmsfix;
        else if (!(Math.abs(gfp.msfix - -1) > 0))
          gfp.msfix = abr_switch_map[r].nsmsfix;
        if (enforce != 0)
          gfp.internal_flags.nsPsy.attackthre = abr_switch_map[r].st_lrm;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre - -1) > 0))
          gfp.internal_flags.nsPsy.attackthre = abr_switch_map[r].st_lrm;
        if (enforce != 0)
          gfp.internal_flags.nsPsy.attackthre_s = abr_switch_map[r].st_s;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre_s - -1) > 0))
          gfp.internal_flags.nsPsy.attackthre_s = abr_switch_map[r].st_s;
        if (enforce != 0)
          gfp.scale = abr_switch_map[r].scale;
        else if (!(Math.abs(gfp.scale - -1) > 0))
          gfp.scale = abr_switch_map[r].scale;
        if (enforce != 0)
          gfp.maskingadjust = abr_switch_map[r].masking_adj;
        else if (!(Math.abs(gfp.maskingadjust - 0) > 0))
          gfp.maskingadjust = abr_switch_map[r].masking_adj;
        if (abr_switch_map[r].masking_adj > 0) {
          if (enforce != 0)
            gfp.maskingadjust_short = abr_switch_map[r].masking_adj * 0.9;
          else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
            gfp.maskingadjust_short = abr_switch_map[r].masking_adj * 0.9;
        } else {
          if (enforce != 0)
            gfp.maskingadjust_short = abr_switch_map[r].masking_adj * 1.1;
          else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
            gfp.maskingadjust_short = abr_switch_map[r].masking_adj * 1.1;
        }
        if (enforce != 0)
          gfp.ATHlower = -abr_switch_map[r].ath_lower / 10;
        else if (!(Math.abs(-gfp.ATHlower * 10 - 0) > 0))
          gfp.ATHlower = -abr_switch_map[r].ath_lower / 10;
        if (enforce != 0)
          gfp.ATHcurve = abr_switch_map[r].ath_curve;
        else if (!(Math.abs(gfp.ATHcurve - -1) > 0))
          gfp.ATHcurve = abr_switch_map[r].ath_curve;
        if (enforce != 0)
          gfp.interChRatio = abr_switch_map[r].interch;
        else if (!(Math.abs(gfp.interChRatio - -1) > 0))
          gfp.interChRatio = abr_switch_map[r].interch;
        return preset;
      }
      this.apply_preset = function(gfp, preset, enforce) {
        switch (preset) {
          case Lame.R3MIX: {
            preset = Lame.V3;
            gfp.VBR = VbrMode.vbr_mtrh;
            break;
          }
          case Lame.MEDIUM: {
            preset = Lame.V4;
            gfp.VBR = VbrMode.vbr_rh;
            break;
          }
          case Lame.MEDIUM_FAST: {
            preset = Lame.V4;
            gfp.VBR = VbrMode.vbr_mtrh;
            break;
          }
          case Lame.STANDARD: {
            preset = Lame.V2;
            gfp.VBR = VbrMode.vbr_rh;
            break;
          }
          case Lame.STANDARD_FAST: {
            preset = Lame.V2;
            gfp.VBR = VbrMode.vbr_mtrh;
            break;
          }
          case Lame.EXTREME: {
            preset = Lame.V0;
            gfp.VBR = VbrMode.vbr_rh;
            break;
          }
          case Lame.EXTREME_FAST: {
            preset = Lame.V0;
            gfp.VBR = VbrMode.vbr_mtrh;
            break;
          }
          case Lame.INSANE: {
            preset = 320;
            gfp.preset = preset;
            apply_abr_preset(gfp, preset, enforce);
            gfp.VBR = VbrMode.vbr_off;
            return preset;
          }
        }
        gfp.preset = preset;
        {
          switch (preset) {
            case Lame.V9:
              apply_vbr_preset();
              return preset;
            case Lame.V8:
              apply_vbr_preset();
              return preset;
            case Lame.V7:
              apply_vbr_preset();
              return preset;
            case Lame.V6:
              apply_vbr_preset();
              return preset;
            case Lame.V5:
              apply_vbr_preset();
              return preset;
            case Lame.V4:
              apply_vbr_preset();
              return preset;
            case Lame.V3:
              apply_vbr_preset();
              return preset;
            case Lame.V2:
              apply_vbr_preset();
              return preset;
            case Lame.V1:
              apply_vbr_preset();
              return preset;
            case Lame.V0:
              apply_vbr_preset();
              return preset;
          }
        }
        if (8 <= preset && preset <= 320) {
          return apply_abr_preset(gfp, preset, enforce);
        }
        gfp.preset = 0;
        return preset;
      };
    }
    function Reservoir() {
      var bs;
      this.setModules = function(_bs) {
        bs = _bs;
      };
      this.ResvFrameBegin = function(gfp, mean_bits) {
        var gfc = gfp.internal_flags;
        var maxmp3buf;
        var l3_side = gfc.l3_side;
        var frameLength = bs.getframebits(gfp);
        mean_bits.bits = (frameLength - gfc.sideinfo_len * 8) / gfc.mode_gr;
        var resvLimit = 8 * 256 * gfc.mode_gr - 8;
        if (gfp.brate > 320) {
          abort();
        } else {
          maxmp3buf = 8 * 1440;
          if (gfp.strict_ISO) {
            abort();
          }
        }
        gfc.ResvMax = maxmp3buf - frameLength;
        if (gfc.ResvMax > resvLimit)
          gfc.ResvMax = resvLimit;
        if (gfc.ResvMax < 0 || gfp.disable_reservoir)
          gfc.ResvMax = 0;
        var fullFrameBits = mean_bits.bits * gfc.mode_gr + Math.min(gfc.ResvSize, gfc.ResvMax);
        if (fullFrameBits > maxmp3buf)
          fullFrameBits = maxmp3buf;
        l3_side.resvDrain_pre = 0;
        if (gfc.pinfo != null) {
          abort();
        }
        return fullFrameBits;
      };
      this.ResvMaxBits = function(gfp, mean_bits, targ_bits, cbr) {
        var gfc = gfp.internal_flags;
        var add_bits;
        var ResvSize = gfc.ResvSize, ResvMax = gfc.ResvMax;
        if (cbr != 0)
          ResvSize += mean_bits;
        if ((gfc.substep_shaping & 1) != 0)
          ResvMax *= 0.9;
        targ_bits.bits = mean_bits;
        if (ResvSize * 10 > ResvMax * 9) {
          add_bits = ResvSize - ResvMax * 9 / 10;
          targ_bits.bits += add_bits;
          gfc.substep_shaping |= 128;
        } else {
          add_bits = 0;
          gfc.substep_shaping &= 127;
          if (!gfp.disable_reservoir && (gfc.substep_shaping & 1) == 0)
            targ_bits.bits -= 0.1 * mean_bits;
        }
        var extra_bits = ResvSize < gfc.ResvMax * 6 / 10 ? ResvSize : gfc.ResvMax * 6 / 10;
        extra_bits -= add_bits;
        if (extra_bits < 0)
          extra_bits = 0;
        return extra_bits;
      };
      this.ResvAdjust = function(gfc, gi) {
        gfc.ResvSize -= gi.part2_3_length + gi.part2_length;
      };
      this.ResvFrameEnd = function(gfc, mean_bits) {
        var over_bits;
        var l3_side = gfc.l3_side;
        gfc.ResvSize += mean_bits * gfc.mode_gr;
        var stuffingBits = 0;
        l3_side.resvDrain_post = 0;
        l3_side.resvDrain_pre = 0;
        if ((over_bits = gfc.ResvSize % 8) != 0)
          stuffingBits += over_bits;
        over_bits = gfc.ResvSize - stuffingBits - gfc.ResvMax;
        if (over_bits > 0) {
          stuffingBits += over_bits;
        }
        {
          var mdb_bytes = Math.min(l3_side.main_data_begin * 8, stuffingBits) / 8;
          l3_side.resvDrain_pre += 8 * mdb_bytes;
          stuffingBits -= 8 * mdb_bytes;
          gfc.ResvSize -= 8 * mdb_bytes;
          l3_side.main_data_begin -= mdb_bytes;
        }
        l3_side.resvDrain_post += stuffingBits;
        gfc.ResvSize -= stuffingBits;
      };
    }
    VBRTag.NUMTOCENTRIES = 100;
    VBRTag.MAXFRAMESIZE = 2880;
    function VBRTag() {
      this.setModules = function(_lame, _bs, _v) {
      };
      var crc16Lookup = [0, 49345, 49537, 320, 49921, 960, 640, 49729, 50689, 1728, 1920, 51009, 1280, 50625, 50305, 1088, 52225, 3264, 3456, 52545, 3840, 53185, 52865, 3648, 2560, 51905, 52097, 2880, 51457, 2496, 2176, 51265, 55297, 6336, 6528, 55617, 6912, 56257, 55937, 6720, 7680, 57025, 57217, 8e3, 56577, 7616, 7296, 56385, 5120, 54465, 54657, 5440, 55041, 6080, 5760, 54849, 53761, 4800, 4992, 54081, 4352, 53697, 53377, 4160, 61441, 12480, 12672, 61761, 13056, 62401, 62081, 12864, 13824, 63169, 63361, 14144, 62721, 13760, 13440, 62529, 15360, 64705, 64897, 15680, 65281, 16320, 16e3, 65089, 64001, 15040, 15232, 64321, 14592, 63937, 63617, 14400, 10240, 59585, 59777, 10560, 60161, 11200, 10880, 59969, 60929, 11968, 12160, 61249, 11520, 60865, 60545, 11328, 58369, 9408, 9600, 58689, 9984, 59329, 59009, 9792, 8704, 58049, 58241, 9024, 57601, 8640, 8320, 57409, 40961, 24768, 24960, 41281, 25344, 41921, 41601, 25152, 26112, 42689, 42881, 26432, 42241, 26048, 25728, 42049, 27648, 44225, 44417, 27968, 44801, 28608, 28288, 44609, 43521, 27328, 27520, 43841, 26880, 43457, 43137, 26688, 30720, 47297, 47489, 31040, 47873, 31680, 31360, 47681, 48641, 32448, 32640, 48961, 32e3, 48577, 48257, 31808, 46081, 29888, 30080, 46401, 30464, 47041, 46721, 30272, 29184, 45761, 45953, 29504, 45313, 29120, 28800, 45121, 20480, 37057, 37249, 20800, 37633, 21440, 21120, 37441, 38401, 22208, 22400, 38721, 21760, 38337, 38017, 21568, 39937, 23744, 23936, 40257, 24320, 40897, 40577, 24128, 23040, 39617, 39809, 23360, 39169, 22976, 22656, 38977, 34817, 18624, 18816, 35137, 19200, 35777, 35457, 19008, 19968, 36545, 36737, 20288, 36097, 19904, 19584, 35905, 17408, 33985, 34177, 17728, 34561, 18368, 18048, 34369, 33281, 17088, 17280, 33601, 16640, 33217, 32897, 16448];
      function crcUpdateLookup(value9, crc) {
        var tmp = crc ^ value9;
        crc = crc >> 8 ^ crc16Lookup[tmp & 255];
        return crc;
      }
      this.updateMusicCRC = function(crc, buffer, bufferPos, size2) {
        for (var i = 0; i < size2; ++i)
          crc[0] = crcUpdateLookup(buffer[bufferPos + i], crc[0]);
      };
    }
    BitStream.EQ = function(a, b) {
      return Math.abs(a) > Math.abs(b) ? Math.abs(a - b) <= Math.abs(a) * 1e-6 : Math.abs(a - b) <= Math.abs(b) * 1e-6;
    };
    BitStream.NEQ = function(a, b) {
      return !BitStream.EQ(a, b);
    };
    function BitStream() {
      var self2 = this;
      var ver = null;
      var vbr = null;
      this.setModules = function(_ga, _mpg, _ver, _vbr) {
        ver = _ver;
        vbr = _vbr;
      };
      var buf = null;
      var totbit = 0;
      var bufByteIdx = 0;
      var bufBitIdx = 0;
      this.getframebits = function(gfp) {
        var gfc = gfp.internal_flags;
        var bit_rate;
        if (gfc.bitrate_index != 0)
          bit_rate = Tables.bitrate_table[gfp.version][gfc.bitrate_index];
        else
          bit_rate = gfp.brate;
        var bytes = 0 | (gfp.version + 1) * 72e3 * bit_rate / gfp.out_samplerate + gfc.padding;
        return 8 * bytes;
      };
      function putheader_bits(gfc) {
        System.arraycopy(gfc.header[gfc.w_ptr].buf, 0, buf, bufByteIdx, gfc.sideinfo_len);
        bufByteIdx += gfc.sideinfo_len;
        totbit += gfc.sideinfo_len * 8;
        gfc.w_ptr = gfc.w_ptr + 1 & LameInternalFlags.MAX_HEADER_BUF - 1;
      }
      function putbits2(gfc, val, j) {
        while (j > 0) {
          var k;
          if (bufBitIdx == 0) {
            bufBitIdx = 8;
            bufByteIdx++;
            if (gfc.header[gfc.w_ptr].write_timing == totbit) {
              putheader_bits(gfc);
            }
            buf[bufByteIdx] = 0;
          }
          k = Math.min(j, bufBitIdx);
          j -= k;
          bufBitIdx -= k;
          buf[bufByteIdx] |= val >> j << bufBitIdx;
          totbit += k;
        }
      }
      function drain_into_ancillary(gfp, remainingBits) {
        var gfc = gfp.internal_flags;
        var i;
        if (remainingBits >= 8) {
          putbits2(gfc, 76, 8);
          remainingBits -= 8;
        }
        if (remainingBits >= 8) {
          putbits2(gfc, 65, 8);
          remainingBits -= 8;
        }
        if (remainingBits >= 8) {
          putbits2(gfc, 77, 8);
          remainingBits -= 8;
        }
        if (remainingBits >= 8) {
          putbits2(gfc, 69, 8);
          remainingBits -= 8;
        }
        if (remainingBits >= 32) {
          var version2 = ver.getLameShortVersion();
          if (remainingBits >= 32)
            for (i = 0; i < version2.length && remainingBits >= 8; ++i) {
              remainingBits -= 8;
              putbits2(gfc, version2.charCodeAt(i), 8);
            }
        }
        for (; remainingBits >= 1; remainingBits -= 1) {
          putbits2(gfc, gfc.ancillary_flag, 1);
          gfc.ancillary_flag ^= !gfp.disable_reservoir ? 1 : 0;
        }
      }
      function writeheader(gfc, val, j) {
        var ptr = gfc.header[gfc.h_ptr].ptr;
        while (j > 0) {
          var k = Math.min(j, 8 - (ptr & 7));
          j -= k;
          gfc.header[gfc.h_ptr].buf[ptr >> 3] |= val >> j << 8 - (ptr & 7) - k;
          ptr += k;
        }
        gfc.header[gfc.h_ptr].ptr = ptr;
      }
      function encodeSideInfo2(gfp, bitsPerFrame) {
        var gfc = gfp.internal_flags;
        var l3_side;
        var gr, ch;
        l3_side = gfc.l3_side;
        gfc.header[gfc.h_ptr].ptr = 0;
        Arrays.fill(gfc.header[gfc.h_ptr].buf, 0, gfc.sideinfo_len, 0);
        if (gfp.out_samplerate < 16e3)
          writeheader(gfc, 4094, 12);
        else
          writeheader(gfc, 4095, 12);
        writeheader(gfc, gfp.version, 1);
        writeheader(gfc, 4 - 3, 2);
        writeheader(gfc, !gfp.error_protection ? 1 : 0, 1);
        writeheader(gfc, gfc.bitrate_index, 4);
        writeheader(gfc, gfc.samplerate_index, 2);
        writeheader(gfc, gfc.padding, 1);
        writeheader(gfc, gfp.extension, 1);
        writeheader(gfc, gfp.mode.ordinal(), 2);
        writeheader(gfc, gfc.mode_ext, 2);
        writeheader(gfc, gfp.copyright, 1);
        writeheader(gfc, gfp.original, 1);
        writeheader(gfc, gfp.emphasis, 2);
        if (gfp.error_protection) {
          writeheader(gfc, 0, 16);
        }
        if (gfp.version == 1) {
          writeheader(gfc, l3_side.main_data_begin, 9);
          if (gfc.channels_out == 2)
            writeheader(gfc, l3_side.private_bits, 3);
          else
            writeheader(gfc, l3_side.private_bits, 5);
          for (ch = 0; ch < gfc.channels_out; ch++) {
            var band;
            for (band = 0; band < 4; band++) {
              writeheader(gfc, l3_side.scfsi[ch][band], 1);
            }
          }
          for (gr = 0; gr < 2; gr++) {
            for (ch = 0; ch < gfc.channels_out; ch++) {
              var gi = l3_side.tt[gr][ch];
              writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
              writeheader(gfc, gi.big_values / 2, 9);
              writeheader(gfc, gi.global_gain, 8);
              writeheader(gfc, gi.scalefac_compress, 4);
              if (gi.block_type != Encoder.NORM_TYPE) {
                writeheader(gfc, 1, 1);
                writeheader(gfc, gi.block_type, 2);
                writeheader(gfc, gi.mixed_block_flag, 1);
                if (gi.table_select[0] == 14)
                  gi.table_select[0] = 16;
                writeheader(gfc, gi.table_select[0], 5);
                if (gi.table_select[1] == 14)
                  gi.table_select[1] = 16;
                writeheader(gfc, gi.table_select[1], 5);
                writeheader(gfc, gi.subblock_gain[0], 3);
                writeheader(gfc, gi.subblock_gain[1], 3);
                writeheader(gfc, gi.subblock_gain[2], 3);
              } else {
                writeheader(gfc, 0, 1);
                if (gi.table_select[0] == 14)
                  gi.table_select[0] = 16;
                writeheader(gfc, gi.table_select[0], 5);
                if (gi.table_select[1] == 14)
                  gi.table_select[1] = 16;
                writeheader(gfc, gi.table_select[1], 5);
                if (gi.table_select[2] == 14)
                  gi.table_select[2] = 16;
                writeheader(gfc, gi.table_select[2], 5);
                writeheader(gfc, gi.region0_count, 4);
                writeheader(gfc, gi.region1_count, 3);
              }
              writeheader(gfc, gi.preflag, 1);
              writeheader(gfc, gi.scalefac_scale, 1);
              writeheader(gfc, gi.count1table_select, 1);
            }
          }
        } else {
          writeheader(gfc, l3_side.main_data_begin, 8);
          writeheader(gfc, l3_side.private_bits, gfc.channels_out);
          gr = 0;
          for (ch = 0; ch < gfc.channels_out; ch++) {
            var gi = l3_side.tt[gr][ch];
            writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
            writeheader(gfc, gi.big_values / 2, 9);
            writeheader(gfc, gi.global_gain, 8);
            writeheader(gfc, gi.scalefac_compress, 9);
            if (gi.block_type != Encoder.NORM_TYPE) {
              writeheader(gfc, 1, 1);
              writeheader(gfc, gi.block_type, 2);
              writeheader(gfc, gi.mixed_block_flag, 1);
              if (gi.table_select[0] == 14)
                gi.table_select[0] = 16;
              writeheader(gfc, gi.table_select[0], 5);
              if (gi.table_select[1] == 14)
                gi.table_select[1] = 16;
              writeheader(gfc, gi.table_select[1], 5);
              writeheader(gfc, gi.subblock_gain[0], 3);
              writeheader(gfc, gi.subblock_gain[1], 3);
              writeheader(gfc, gi.subblock_gain[2], 3);
            } else {
              writeheader(gfc, 0, 1);
              if (gi.table_select[0] == 14)
                gi.table_select[0] = 16;
              writeheader(gfc, gi.table_select[0], 5);
              if (gi.table_select[1] == 14)
                gi.table_select[1] = 16;
              writeheader(gfc, gi.table_select[1], 5);
              if (gi.table_select[2] == 14)
                gi.table_select[2] = 16;
              writeheader(gfc, gi.table_select[2], 5);
              writeheader(gfc, gi.region0_count, 4);
              writeheader(gfc, gi.region1_count, 3);
            }
            writeheader(gfc, gi.scalefac_scale, 1);
            writeheader(gfc, gi.count1table_select, 1);
          }
        }
        if (gfp.error_protection) {
          abort();
        }
        {
          var old = gfc.h_ptr;
          gfc.h_ptr = old + 1 & LameInternalFlags.MAX_HEADER_BUF - 1;
          gfc.header[gfc.h_ptr].write_timing = gfc.header[old].write_timing + bitsPerFrame;
          if (gfc.h_ptr == gfc.w_ptr)
            ;
        }
      }
      function huffman_coder_count1(gfc, gi) {
        var h = Tables.ht[gi.count1table_select + 32];
        var i, bits = 0;
        var ix = gi.big_values;
        var xr = gi.big_values;
        for (i = (gi.count1 - gi.big_values) / 4; i > 0; --i) {
          var huffbits = 0;
          var p = 0, v;
          v = gi.l3_enc[ix + 0];
          if (v != 0) {
            p += 8;
            if (gi.xr[xr + 0] < 0)
              huffbits++;
          }
          v = gi.l3_enc[ix + 1];
          if (v != 0) {
            p += 4;
            huffbits *= 2;
            if (gi.xr[xr + 1] < 0)
              huffbits++;
          }
          v = gi.l3_enc[ix + 2];
          if (v != 0) {
            p += 2;
            huffbits *= 2;
            if (gi.xr[xr + 2] < 0)
              huffbits++;
          }
          v = gi.l3_enc[ix + 3];
          if (v != 0) {
            p++;
            huffbits *= 2;
            if (gi.xr[xr + 3] < 0)
              huffbits++;
          }
          ix += 4;
          xr += 4;
          putbits2(gfc, huffbits + h.table[p], h.hlen[p]);
          bits += h.hlen[p];
        }
        return bits;
      }
      function Huffmancode(gfc, tableindex, start, end, gi) {
        var h = Tables.ht[tableindex];
        var bits = 0;
        if (tableindex == 0)
          return bits;
        for (var i = start; i < end; i += 2) {
          var cbits = 0;
          var xbits = 0;
          var linbits = h.xlen;
          var xlen = h.xlen;
          var ext = 0;
          var x1 = gi.l3_enc[i];
          var x2 = gi.l3_enc[i + 1];
          if (x1 != 0) {
            if (gi.xr[i] < 0)
              ext++;
            cbits--;
          }
          if (tableindex > 15) {
            if (x1 > 14) {
              var linbits_x1 = x1 - 15;
              ext |= linbits_x1 << 1;
              xbits = linbits;
              x1 = 15;
            }
            if (x2 > 14) {
              var linbits_x2 = x2 - 15;
              ext <<= linbits;
              ext |= linbits_x2;
              xbits += linbits;
              x2 = 15;
            }
            xlen = 16;
          }
          if (x2 != 0) {
            ext <<= 1;
            if (gi.xr[i + 1] < 0)
              ext++;
            cbits--;
          }
          x1 = x1 * xlen + x2;
          xbits -= cbits;
          cbits += h.hlen[x1];
          putbits2(gfc, h.table[x1], cbits);
          putbits2(gfc, ext, xbits);
          bits += cbits + xbits;
        }
        return bits;
      }
      function ShortHuffmancodebits(gfc, gi) {
        var region1Start = 3 * gfc.scalefac_band.s[3];
        if (region1Start > gi.big_values)
          region1Start = gi.big_values;
        var bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
        bits += Huffmancode(gfc, gi.table_select[1], region1Start, gi.big_values, gi);
        return bits;
      }
      function LongHuffmancodebits(gfc, gi) {
        var bigvalues, bits;
        var region1Start, region2Start;
        bigvalues = gi.big_values;
        var i = gi.region0_count + 1;
        region1Start = gfc.scalefac_band.l[i];
        i += gi.region1_count + 1;
        region2Start = gfc.scalefac_band.l[i];
        if (region1Start > bigvalues)
          region1Start = bigvalues;
        if (region2Start > bigvalues)
          region2Start = bigvalues;
        bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
        bits += Huffmancode(gfc, gi.table_select[1], region1Start, region2Start, gi);
        bits += Huffmancode(gfc, gi.table_select[2], region2Start, bigvalues, gi);
        return bits;
      }
      function writeMainData(gfp) {
        var gr, ch, sfb, data_bits, tot_bits = 0;
        var gfc = gfp.internal_flags;
        var l3_side = gfc.l3_side;
        if (gfp.version == 1) {
          for (gr = 0; gr < 2; gr++) {
            for (ch = 0; ch < gfc.channels_out; ch++) {
              var gi = l3_side.tt[gr][ch];
              var slen1 = Takehiro.slen1_tab[gi.scalefac_compress];
              var slen2 = Takehiro.slen2_tab[gi.scalefac_compress];
              data_bits = 0;
              for (sfb = 0; sfb < gi.sfbdivide; sfb++) {
                if (gi.scalefac[sfb] == -1)
                  continue;
                putbits2(gfc, gi.scalefac[sfb], slen1);
                data_bits += slen1;
              }
              for (; sfb < gi.sfbmax; sfb++) {
                if (gi.scalefac[sfb] == -1)
                  continue;
                putbits2(gfc, gi.scalefac[sfb], slen2);
                data_bits += slen2;
              }
              if (gi.block_type == Encoder.SHORT_TYPE) {
                data_bits += ShortHuffmancodebits(gfc, gi);
              } else {
                data_bits += LongHuffmancodebits(gfc, gi);
              }
              data_bits += huffman_coder_count1(gfc, gi);
              tot_bits += data_bits;
            }
          }
        } else {
          gr = 0;
          for (ch = 0; ch < gfc.channels_out; ch++) {
            var gi = l3_side.tt[gr][ch];
            var i, sfb_partition, scale_bits = 0;
            data_bits = 0;
            sfb = 0;
            sfb_partition = 0;
            if (gi.block_type == Encoder.SHORT_TYPE) {
              for (; sfb_partition < 4; sfb_partition++) {
                var sfbs = gi.sfb_partition_table[sfb_partition] / 3;
                var slen = gi.slen[sfb_partition];
                for (i = 0; i < sfbs; i++, sfb++) {
                  putbits2(gfc, Math.max(gi.scalefac[sfb * 3 + 0], 0), slen);
                  putbits2(gfc, Math.max(gi.scalefac[sfb * 3 + 1], 0), slen);
                  putbits2(gfc, Math.max(gi.scalefac[sfb * 3 + 2], 0), slen);
                  scale_bits += 3 * slen;
                }
              }
              data_bits += ShortHuffmancodebits(gfc, gi);
            } else {
              for (; sfb_partition < 4; sfb_partition++) {
                var sfbs = gi.sfb_partition_table[sfb_partition];
                var slen = gi.slen[sfb_partition];
                for (i = 0; i < sfbs; i++, sfb++) {
                  putbits2(gfc, Math.max(gi.scalefac[sfb], 0), slen);
                  scale_bits += slen;
                }
              }
              data_bits += LongHuffmancodebits(gfc, gi);
            }
            data_bits += huffman_coder_count1(gfc, gi);
            tot_bits += scale_bits + data_bits;
          }
        }
        return tot_bits;
      }
      function TotalBytes() {
        this.total = 0;
      }
      function compute_flushbits(gfp, total_bytes_output) {
        var gfc = gfp.internal_flags;
        var flushbits;
        var bitsPerFrame;
        var last_ptr;
        last_ptr = gfc.h_ptr - 1;
        if (last_ptr == -1)
          last_ptr = LameInternalFlags.MAX_HEADER_BUF - 1;
        flushbits = gfc.header[last_ptr].write_timing - totbit;
        total_bytes_output.total = flushbits;
        if (flushbits >= 0) {
          abort();
        }
        bitsPerFrame = self2.getframebits(gfp);
        flushbits += bitsPerFrame;
        total_bytes_output.total += bitsPerFrame;
        if (total_bytes_output.total % 8 != 0)
          total_bytes_output.total = 1 + total_bytes_output.total / 8;
        else
          total_bytes_output.total = total_bytes_output.total / 8;
        total_bytes_output.total += bufByteIdx + 1;
        return flushbits;
      }
      this.flush_bitstream = function(gfp) {
        var gfc = gfp.internal_flags;
        var l3_side;
        var flushbits;
        gfc.h_ptr - 1;
        l3_side = gfc.l3_side;
        if ((flushbits = compute_flushbits(gfp, new TotalBytes())) < 0)
          return;
        drain_into_ancillary(gfp, flushbits);
        gfc.ResvSize = 0;
        l3_side.main_data_begin = 0;
        if (gfc.findReplayGain) {
          abort();
        }
        if (gfc.findPeakSample) {
          abort();
        }
      };
      this.format_bitstream = function(gfp) {
        var gfc = gfp.internal_flags;
        var l3_side;
        l3_side = gfc.l3_side;
        var bitsPerFrame = this.getframebits(gfp);
        drain_into_ancillary(gfp, l3_side.resvDrain_pre);
        encodeSideInfo2(gfp, bitsPerFrame);
        var bits = 8 * gfc.sideinfo_len;
        bits += writeMainData(gfp);
        drain_into_ancillary(gfp, l3_side.resvDrain_post);
        bits += l3_side.resvDrain_post;
        l3_side.main_data_begin += (bitsPerFrame - bits) / 8;
        if (compute_flushbits(gfp, new TotalBytes()) != gfc.ResvSize)
          ;
        if (l3_side.main_data_begin * 8 != gfc.ResvSize) {
          gfc.ResvSize = l3_side.main_data_begin * 8;
        }
        if (totbit > 1e9) {
          var i;
          for (i = 0; i < LameInternalFlags.MAX_HEADER_BUF; ++i)
            gfc.header[i].write_timing -= totbit;
          totbit = 0;
        }
        return 0;
      };
      this.copy_buffer = function(gfc, buffer, bufferPos, size2, mp3data) {
        var minimum = bufByteIdx + 1;
        if (minimum <= 0)
          return 0;
        if (size2 != 0 && minimum > size2) {
          return -1;
        }
        System.arraycopy(buf, 0, buffer, bufferPos, minimum);
        bufByteIdx = -1;
        bufBitIdx = 0;
        if (mp3data != 0) {
          var crc = new_int(1);
          crc[0] = gfc.nMusicCRC;
          vbr.updateMusicCRC(crc, buffer, bufferPos, minimum);
          gfc.nMusicCRC = crc[0];
          if (minimum > 0) {
            gfc.VBR_seek_table.nBytesWritten += minimum;
          }
          if (gfc.decode_on_the_fly) {
            abort();
          }
        }
        return minimum;
      };
      this.init_bit_stream_w = function(gfc) {
        buf = new_byte(Lame.LAME_MAXMP3BUFFER);
        gfc.h_ptr = gfc.w_ptr = 0;
        gfc.header[gfc.h_ptr].write_timing = 0;
        bufByteIdx = -1;
        bufBitIdx = 0;
        totbit = 0;
      };
    }
    function HuffCodeTab(len, max, tab, hl) {
      this.xlen = len;
      this.linmax = max;
      this.table = tab;
      this.hlen = hl;
    }
    var Tables = {};
    Tables.t1HB = [1, 1, 1, 0];
    Tables.t2HB = [1, 2, 1, 3, 1, 1, 3, 2, 0];
    Tables.t3HB = [3, 2, 1, 1, 1, 1, 3, 2, 0];
    Tables.t5HB = [1, 2, 6, 5, 3, 1, 4, 4, 7, 5, 7, 1, 6, 1, 1, 0];
    Tables.t6HB = [7, 3, 5, 1, 6, 2, 3, 2, 5, 4, 4, 1, 3, 3, 2, 0];
    Tables.t7HB = [1, 2, 10, 19, 16, 10, 3, 3, 7, 10, 5, 3, 11, 4, 13, 17, 8, 4, 12, 11, 18, 15, 11, 2, 7, 6, 9, 14, 3, 1, 6, 4, 5, 3, 2, 0];
    Tables.t8HB = [3, 4, 6, 18, 12, 5, 5, 1, 2, 16, 9, 3, 7, 3, 5, 14, 7, 3, 19, 17, 15, 13, 10, 4, 13, 5, 8, 11, 5, 1, 12, 4, 4, 1, 1, 0];
    Tables.t9HB = [7, 5, 9, 14, 15, 7, 6, 4, 5, 5, 6, 7, 7, 6, 8, 8, 8, 5, 15, 6, 9, 10, 5, 1, 11, 7, 9, 6, 4, 1, 14, 4, 6, 2, 6, 0];
    Tables.t10HB = [1, 2, 10, 23, 35, 30, 12, 17, 3, 3, 8, 12, 18, 21, 12, 7, 11, 9, 15, 21, 32, 40, 19, 6, 14, 13, 22, 34, 46, 23, 18, 7, 20, 19, 33, 47, 27, 22, 9, 3, 31, 22, 41, 26, 21, 20, 5, 3, 14, 13, 10, 11, 16, 6, 5, 1, 9, 8, 7, 8, 4, 4, 2, 0];
    Tables.t11HB = [3, 4, 10, 24, 34, 33, 21, 15, 5, 3, 4, 10, 32, 17, 11, 10, 11, 7, 13, 18, 30, 31, 20, 5, 25, 11, 19, 59, 27, 18, 12, 5, 35, 33, 31, 58, 30, 16, 7, 5, 28, 26, 32, 19, 17, 15, 8, 14, 14, 12, 9, 13, 14, 9, 4, 1, 11, 4, 6, 6, 6, 3, 2, 0];
    Tables.t12HB = [9, 6, 16, 33, 41, 39, 38, 26, 7, 5, 6, 9, 23, 16, 26, 11, 17, 7, 11, 14, 21, 30, 10, 7, 17, 10, 15, 12, 18, 28, 14, 5, 32, 13, 22, 19, 18, 16, 9, 5, 40, 17, 31, 29, 17, 13, 4, 2, 27, 12, 11, 15, 10, 7, 4, 1, 27, 12, 8, 12, 6, 3, 1, 0];
    Tables.t13HB = [1, 5, 14, 21, 34, 51, 46, 71, 42, 52, 68, 52, 67, 44, 43, 19, 3, 4, 12, 19, 31, 26, 44, 33, 31, 24, 32, 24, 31, 35, 22, 14, 15, 13, 23, 36, 59, 49, 77, 65, 29, 40, 30, 40, 27, 33, 42, 16, 22, 20, 37, 61, 56, 79, 73, 64, 43, 76, 56, 37, 26, 31, 25, 14, 35, 16, 60, 57, 97, 75, 114, 91, 54, 73, 55, 41, 48, 53, 23, 24, 58, 27, 50, 96, 76, 70, 93, 84, 77, 58, 79, 29, 74, 49, 41, 17, 47, 45, 78, 74, 115, 94, 90, 79, 69, 83, 71, 50, 59, 38, 36, 15, 72, 34, 56, 95, 92, 85, 91, 90, 86, 73, 77, 65, 51, 44, 43, 42, 43, 20, 30, 44, 55, 78, 72, 87, 78, 61, 46, 54, 37, 30, 20, 16, 53, 25, 41, 37, 44, 59, 54, 81, 66, 76, 57, 54, 37, 18, 39, 11, 35, 33, 31, 57, 42, 82, 72, 80, 47, 58, 55, 21, 22, 26, 38, 22, 53, 25, 23, 38, 70, 60, 51, 36, 55, 26, 34, 23, 27, 14, 9, 7, 34, 32, 28, 39, 49, 75, 30, 52, 48, 40, 52, 28, 18, 17, 9, 5, 45, 21, 34, 64, 56, 50, 49, 45, 31, 19, 12, 15, 10, 7, 6, 3, 48, 23, 20, 39, 36, 35, 53, 21, 16, 23, 13, 10, 6, 1, 4, 2, 16, 15, 17, 27, 25, 20, 29, 11, 17, 12, 16, 8, 1, 1, 0, 1];
    Tables.t15HB = [7, 12, 18, 53, 47, 76, 124, 108, 89, 123, 108, 119, 107, 81, 122, 63, 13, 5, 16, 27, 46, 36, 61, 51, 42, 70, 52, 83, 65, 41, 59, 36, 19, 17, 15, 24, 41, 34, 59, 48, 40, 64, 50, 78, 62, 80, 56, 33, 29, 28, 25, 43, 39, 63, 55, 93, 76, 59, 93, 72, 54, 75, 50, 29, 52, 22, 42, 40, 67, 57, 95, 79, 72, 57, 89, 69, 49, 66, 46, 27, 77, 37, 35, 66, 58, 52, 91, 74, 62, 48, 79, 63, 90, 62, 40, 38, 125, 32, 60, 56, 50, 92, 78, 65, 55, 87, 71, 51, 73, 51, 70, 30, 109, 53, 49, 94, 88, 75, 66, 122, 91, 73, 56, 42, 64, 44, 21, 25, 90, 43, 41, 77, 73, 63, 56, 92, 77, 66, 47, 67, 48, 53, 36, 20, 71, 34, 67, 60, 58, 49, 88, 76, 67, 106, 71, 54, 38, 39, 23, 15, 109, 53, 51, 47, 90, 82, 58, 57, 48, 72, 57, 41, 23, 27, 62, 9, 86, 42, 40, 37, 70, 64, 52, 43, 70, 55, 42, 25, 29, 18, 11, 11, 118, 68, 30, 55, 50, 46, 74, 65, 49, 39, 24, 16, 22, 13, 14, 7, 91, 44, 39, 38, 34, 63, 52, 45, 31, 52, 28, 19, 14, 8, 9, 3, 123, 60, 58, 53, 47, 43, 32, 22, 37, 24, 17, 12, 15, 10, 2, 1, 71, 37, 34, 30, 28, 20, 17, 26, 21, 16, 10, 6, 8, 6, 2, 0];
    Tables.t16HB = [1, 5, 14, 44, 74, 63, 110, 93, 172, 149, 138, 242, 225, 195, 376, 17, 3, 4, 12, 20, 35, 62, 53, 47, 83, 75, 68, 119, 201, 107, 207, 9, 15, 13, 23, 38, 67, 58, 103, 90, 161, 72, 127, 117, 110, 209, 206, 16, 45, 21, 39, 69, 64, 114, 99, 87, 158, 140, 252, 212, 199, 387, 365, 26, 75, 36, 68, 65, 115, 101, 179, 164, 155, 264, 246, 226, 395, 382, 362, 9, 66, 30, 59, 56, 102, 185, 173, 265, 142, 253, 232, 400, 388, 378, 445, 16, 111, 54, 52, 100, 184, 178, 160, 133, 257, 244, 228, 217, 385, 366, 715, 10, 98, 48, 91, 88, 165, 157, 148, 261, 248, 407, 397, 372, 380, 889, 884, 8, 85, 84, 81, 159, 156, 143, 260, 249, 427, 401, 392, 383, 727, 713, 708, 7, 154, 76, 73, 141, 131, 256, 245, 426, 406, 394, 384, 735, 359, 710, 352, 11, 139, 129, 67, 125, 247, 233, 229, 219, 393, 743, 737, 720, 885, 882, 439, 4, 243, 120, 118, 115, 227, 223, 396, 746, 742, 736, 721, 712, 706, 223, 436, 6, 202, 224, 222, 218, 216, 389, 386, 381, 364, 888, 443, 707, 440, 437, 1728, 4, 747, 211, 210, 208, 370, 379, 734, 723, 714, 1735, 883, 877, 876, 3459, 865, 2, 377, 369, 102, 187, 726, 722, 358, 711, 709, 866, 1734, 871, 3458, 870, 434, 0, 12, 10, 7, 11, 10, 17, 11, 9, 13, 12, 10, 7, 5, 3, 1, 3];
    Tables.t24HB = [15, 13, 46, 80, 146, 262, 248, 434, 426, 669, 653, 649, 621, 517, 1032, 88, 14, 12, 21, 38, 71, 130, 122, 216, 209, 198, 327, 345, 319, 297, 279, 42, 47, 22, 41, 74, 68, 128, 120, 221, 207, 194, 182, 340, 315, 295, 541, 18, 81, 39, 75, 70, 134, 125, 116, 220, 204, 190, 178, 325, 311, 293, 271, 16, 147, 72, 69, 135, 127, 118, 112, 210, 200, 188, 352, 323, 306, 285, 540, 14, 263, 66, 129, 126, 119, 114, 214, 202, 192, 180, 341, 317, 301, 281, 262, 12, 249, 123, 121, 117, 113, 215, 206, 195, 185, 347, 330, 308, 291, 272, 520, 10, 435, 115, 111, 109, 211, 203, 196, 187, 353, 332, 313, 298, 283, 531, 381, 17, 427, 212, 208, 205, 201, 193, 186, 177, 169, 320, 303, 286, 268, 514, 377, 16, 335, 199, 197, 191, 189, 181, 174, 333, 321, 305, 289, 275, 521, 379, 371, 11, 668, 184, 183, 179, 175, 344, 331, 314, 304, 290, 277, 530, 383, 373, 366, 10, 652, 346, 171, 168, 164, 318, 309, 299, 287, 276, 263, 513, 375, 368, 362, 6, 648, 322, 316, 312, 307, 302, 292, 284, 269, 261, 512, 376, 370, 364, 359, 4, 620, 300, 296, 294, 288, 282, 273, 266, 515, 380, 374, 369, 365, 361, 357, 2, 1033, 280, 278, 274, 267, 264, 259, 382, 378, 372, 367, 363, 360, 358, 356, 0, 43, 20, 19, 17, 15, 13, 11, 9, 7, 6, 4, 7, 5, 3, 1, 3];
    Tables.t32HB = [1 << 0, 5 << 1, 4 << 1, 5 << 2, 6 << 1, 5 << 2, 4 << 2, 4 << 3, 7 << 1, 3 << 2, 6 << 2, 0 << 3, 7 << 2, 2 << 3, 3 << 3, 1 << 4];
    Tables.t33HB = [15 << 0, 14 << 1, 13 << 1, 12 << 2, 11 << 1, 10 << 2, 9 << 2, 8 << 3, 7 << 1, 6 << 2, 5 << 2, 4 << 3, 3 << 2, 2 << 3, 1 << 3, 0 << 4];
    Tables.t1l = [1, 4, 3, 5];
    Tables.t2l = [1, 4, 7, 4, 5, 7, 6, 7, 8];
    Tables.t3l = [2, 3, 7, 4, 4, 7, 6, 7, 8];
    Tables.t5l = [1, 4, 7, 8, 4, 5, 8, 9, 7, 8, 9, 10, 8, 8, 9, 10];
    Tables.t6l = [3, 4, 6, 8, 4, 4, 6, 7, 5, 6, 7, 8, 7, 7, 8, 9];
    Tables.t7l = [1, 4, 7, 9, 9, 10, 4, 6, 8, 9, 9, 10, 7, 7, 9, 10, 10, 11, 8, 9, 10, 11, 11, 11, 8, 9, 10, 11, 11, 12, 9, 10, 11, 12, 12, 12];
    Tables.t8l = [2, 4, 7, 9, 9, 10, 4, 4, 6, 10, 10, 10, 7, 6, 8, 10, 10, 11, 9, 10, 10, 11, 11, 12, 9, 9, 10, 11, 12, 12, 10, 10, 11, 11, 13, 13];
    Tables.t9l = [3, 4, 6, 7, 9, 10, 4, 5, 6, 7, 8, 10, 5, 6, 7, 8, 9, 10, 7, 7, 8, 9, 9, 10, 8, 8, 9, 9, 10, 11, 9, 9, 10, 10, 11, 11];
    Tables.t10l = [1, 4, 7, 9, 10, 10, 10, 11, 4, 6, 8, 9, 10, 11, 10, 10, 7, 8, 9, 10, 11, 12, 11, 11, 8, 9, 10, 11, 12, 12, 11, 12, 9, 10, 11, 12, 12, 12, 12, 12, 10, 11, 12, 12, 13, 13, 12, 13, 9, 10, 11, 12, 12, 12, 13, 13, 10, 10, 11, 12, 12, 13, 13, 13];
    Tables.t11l = [2, 4, 6, 8, 9, 10, 9, 10, 4, 5, 6, 8, 10, 10, 9, 10, 6, 7, 8, 9, 10, 11, 10, 10, 8, 8, 9, 11, 10, 12, 10, 11, 9, 10, 10, 11, 11, 12, 11, 12, 9, 10, 11, 12, 12, 13, 12, 13, 9, 9, 9, 10, 11, 12, 12, 12, 9, 9, 10, 11, 12, 12, 12, 12];
    Tables.t12l = [4, 4, 6, 8, 9, 10, 10, 10, 4, 5, 6, 7, 9, 9, 10, 10, 6, 6, 7, 8, 9, 10, 9, 10, 7, 7, 8, 8, 9, 10, 10, 10, 8, 8, 9, 9, 10, 10, 10, 11, 9, 9, 10, 10, 10, 11, 10, 11, 9, 9, 9, 10, 10, 11, 11, 12, 10, 10, 10, 11, 11, 11, 11, 12];
    Tables.t13l = [1, 5, 7, 8, 9, 10, 10, 11, 10, 11, 12, 12, 13, 13, 14, 14, 4, 6, 8, 9, 10, 10, 11, 11, 11, 11, 12, 12, 13, 14, 14, 14, 7, 8, 9, 10, 11, 11, 12, 12, 11, 12, 12, 13, 13, 14, 15, 15, 8, 9, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 15, 9, 9, 11, 11, 12, 12, 13, 13, 12, 13, 13, 14, 14, 15, 15, 16, 10, 10, 11, 12, 12, 12, 13, 13, 13, 13, 14, 13, 15, 15, 16, 16, 10, 11, 12, 12, 13, 13, 13, 13, 13, 14, 14, 14, 15, 15, 16, 16, 11, 11, 12, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 16, 18, 18, 10, 10, 11, 12, 12, 13, 13, 14, 14, 14, 14, 15, 15, 16, 17, 17, 11, 11, 12, 12, 13, 13, 13, 15, 14, 15, 15, 16, 16, 16, 18, 17, 11, 12, 12, 13, 13, 14, 14, 15, 14, 15, 16, 15, 16, 17, 18, 19, 12, 12, 12, 13, 14, 14, 14, 14, 15, 15, 15, 16, 17, 17, 17, 18, 12, 13, 13, 14, 14, 15, 14, 15, 16, 16, 17, 17, 17, 18, 18, 18, 13, 13, 14, 15, 15, 15, 16, 16, 16, 16, 16, 17, 18, 17, 18, 18, 14, 14, 14, 15, 15, 15, 17, 16, 16, 19, 17, 17, 17, 19, 18, 18, 13, 14, 15, 16, 16, 16, 17, 16, 17, 17, 18, 18, 21, 20, 21, 18];
    Tables.t15l = [3, 5, 6, 8, 8, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 14, 5, 5, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 13, 6, 7, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 13, 13, 13, 7, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 12, 13, 13, 13, 8, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 9, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 13, 13, 13, 14, 10, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 14, 14, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 14, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 14, 14, 14, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 14, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15, 12, 12, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 14, 14, 15, 15, 12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 14, 15, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 15, 15];
    Tables.t16_5l = [1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 11, 4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 11, 7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 12, 9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 13, 10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 12, 10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 13, 11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 13, 11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 13, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 13, 12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 14, 12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 13, 13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 14, 13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 14, 15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 14, 14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 14, 11, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 12];
    Tables.t16l = [1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 10, 4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 10, 7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 11, 9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 12, 10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 11, 10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 12, 11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 12, 11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 12, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 12, 12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 13, 12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 12, 13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 13, 15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 13, 14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 13, 10, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10];
    Tables.t24l = [4, 5, 7, 8, 9, 10, 10, 11, 11, 12, 12, 12, 12, 12, 13, 10, 5, 6, 7, 8, 9, 10, 10, 11, 11, 11, 12, 12, 12, 12, 12, 10, 7, 7, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 9, 8, 8, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 9, 9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 12, 12, 12, 12, 13, 9, 10, 9, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 9, 10, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 9, 11, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 10, 11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 10, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 10, 12, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10, 12, 12, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 10, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10, 13, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 10, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 6];
    Tables.t32l = [1 + 0, 4 + 1, 4 + 1, 5 + 2, 4 + 1, 6 + 2, 5 + 2, 6 + 3, 4 + 1, 5 + 2, 5 + 2, 6 + 3, 5 + 2, 6 + 3, 6 + 3, 6 + 4];
    Tables.t33l = [4 + 0, 4 + 1, 4 + 1, 4 + 2, 4 + 1, 4 + 2, 4 + 2, 4 + 3, 4 + 1, 4 + 2, 4 + 2, 4 + 3, 4 + 2, 4 + 3, 4 + 3, 4 + 4];
    Tables.ht = [
      new HuffCodeTab(0, 0, null, null),
      new HuffCodeTab(2, 0, Tables.t1HB, Tables.t1l),
      new HuffCodeTab(3, 0, Tables.t2HB, Tables.t2l),
      new HuffCodeTab(3, 0, Tables.t3HB, Tables.t3l),
      new HuffCodeTab(0, 0, null, null),
      new HuffCodeTab(4, 0, Tables.t5HB, Tables.t5l),
      new HuffCodeTab(4, 0, Tables.t6HB, Tables.t6l),
      new HuffCodeTab(6, 0, Tables.t7HB, Tables.t7l),
      new HuffCodeTab(6, 0, Tables.t8HB, Tables.t8l),
      new HuffCodeTab(6, 0, Tables.t9HB, Tables.t9l),
      new HuffCodeTab(8, 0, Tables.t10HB, Tables.t10l),
      new HuffCodeTab(8, 0, Tables.t11HB, Tables.t11l),
      new HuffCodeTab(8, 0, Tables.t12HB, Tables.t12l),
      new HuffCodeTab(16, 0, Tables.t13HB, Tables.t13l),
      new HuffCodeTab(0, 0, null, Tables.t16_5l),
      new HuffCodeTab(16, 0, Tables.t15HB, Tables.t15l),
      new HuffCodeTab(1, 1, Tables.t16HB, Tables.t16l),
      new HuffCodeTab(2, 3, Tables.t16HB, Tables.t16l),
      new HuffCodeTab(3, 7, Tables.t16HB, Tables.t16l),
      new HuffCodeTab(4, 15, Tables.t16HB, Tables.t16l),
      new HuffCodeTab(6, 63, Tables.t16HB, Tables.t16l),
      new HuffCodeTab(8, 255, Tables.t16HB, Tables.t16l),
      new HuffCodeTab(10, 1023, Tables.t16HB, Tables.t16l),
      new HuffCodeTab(13, 8191, Tables.t16HB, Tables.t16l),
      new HuffCodeTab(4, 15, Tables.t24HB, Tables.t24l),
      new HuffCodeTab(5, 31, Tables.t24HB, Tables.t24l),
      new HuffCodeTab(6, 63, Tables.t24HB, Tables.t24l),
      new HuffCodeTab(7, 127, Tables.t24HB, Tables.t24l),
      new HuffCodeTab(8, 255, Tables.t24HB, Tables.t24l),
      new HuffCodeTab(9, 511, Tables.t24HB, Tables.t24l),
      new HuffCodeTab(11, 2047, Tables.t24HB, Tables.t24l),
      new HuffCodeTab(13, 8191, Tables.t24HB, Tables.t24l),
      new HuffCodeTab(0, 0, Tables.t32HB, Tables.t32l),
      new HuffCodeTab(0, 0, Tables.t33HB, Tables.t33l)
    ];
    Tables.largetbl = [65540, 327685, 458759, 589832, 655369, 655370, 720906, 720907, 786443, 786444, 786444, 851980, 851980, 851980, 917517, 655370, 262149, 393222, 524295, 589832, 655369, 720906, 720906, 720907, 786443, 786443, 786444, 851980, 917516, 851980, 917516, 655370, 458759, 524295, 589832, 655369, 720905, 720906, 786442, 786443, 851979, 786443, 851979, 851980, 851980, 917516, 917517, 720905, 589832, 589832, 655369, 720905, 720906, 786442, 786442, 786443, 851979, 851979, 917515, 917516, 917516, 983052, 983052, 786441, 655369, 655369, 720905, 720906, 786442, 786442, 851978, 851979, 851979, 917515, 917516, 917516, 983052, 983052, 983053, 720905, 655370, 655369, 720906, 720906, 786442, 851978, 851979, 917515, 851979, 917515, 917516, 983052, 983052, 983052, 1048588, 786441, 720906, 720906, 720906, 786442, 851978, 851979, 851979, 851979, 917515, 917516, 917516, 917516, 983052, 983052, 1048589, 786441, 720907, 720906, 786442, 786442, 851979, 851979, 851979, 917515, 917516, 983052, 983052, 983052, 983052, 1114125, 1114125, 786442, 720907, 786443, 786443, 851979, 851979, 851979, 917515, 917515, 983051, 983052, 983052, 983052, 1048588, 1048589, 1048589, 786442, 786443, 786443, 786443, 851979, 851979, 917515, 917515, 983052, 983052, 983052, 983052, 1048588, 983053, 1048589, 983053, 851978, 786444, 851979, 786443, 851979, 917515, 917516, 917516, 917516, 983052, 1048588, 1048588, 1048589, 1114125, 1114125, 1048589, 786442, 851980, 851980, 851979, 851979, 917515, 917516, 983052, 1048588, 1048588, 1048588, 1048588, 1048589, 1048589, 983053, 1048589, 851978, 851980, 917516, 917516, 917516, 917516, 983052, 983052, 983052, 983052, 1114124, 1048589, 1048589, 1048589, 1048589, 1179661, 851978, 983052, 917516, 917516, 917516, 983052, 983052, 1048588, 1048588, 1048589, 1179661, 1114125, 1114125, 1114125, 1245197, 1114125, 851978, 917517, 983052, 851980, 917516, 1048588, 1048588, 983052, 1048589, 1048589, 1114125, 1179661, 1114125, 1245197, 1114125, 1048589, 851978, 655369, 655369, 655369, 720905, 720905, 786441, 786441, 786441, 851977, 851977, 851977, 851978, 851978, 851978, 851978, 655366];
    Tables.table23 = [65538, 262147, 458759, 262148, 327684, 458759, 393222, 458759, 524296];
    Tables.table56 = [65539, 262148, 458758, 524296, 262148, 327684, 524294, 589831, 458757, 524294, 589831, 655368, 524295, 524295, 589832, 655369];
    Tables.bitrate_table = [
      [0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, -1],
      [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, -1],
      [0, 8, 16, 24, 32, 40, 48, 56, 64, -1, -1, -1, -1, -1, -1, -1]
    ];
    Tables.samplerate_table = [[22050, 24e3, 16e3, -1], [44100, 48e3, 32e3, -1], [11025, 12e3, 8e3, -1]];
    Tables.scfsi_band = [0, 6, 11, 16, 21];
    function MeanBits(meanBits) {
      this.bits = meanBits;
    }
    function CalcNoiseResult() {
      this.over_noise = 0;
      this.tot_noise = 0;
      this.max_noise = 0;
      this.over_count = 0;
      this.over_SSD = 0;
      this.bits = 0;
    }
    function VBRQuantize() {
      this.setModules = function(_qupvt, _tk) {
      };
    }
    function ATH() {
      this.useAdjust = 0;
      this.aaSensitivityP = 0;
      this.adjust = 0;
      this.adjustLimit = 0;
      this.decay = 0;
      this.floor = 0;
      this.l = new_float(Encoder.SBMAX_l);
      this.s = new_float(Encoder.SBMAX_s);
      this.psfb21 = new_float(Encoder.PSFB21);
      this.psfb12 = new_float(Encoder.PSFB12);
      this.cb_l = new_float(Encoder.CBANDS);
      this.cb_s = new_float(Encoder.CBANDS);
      this.eql_w = new_float(Encoder.BLKSIZE / 2);
    }
    function LameGlobalFlags() {
      this.class_id = 0;
      this.num_samples = 0;
      this.num_channels = 0;
      this.in_samplerate = 0;
      this.out_samplerate = 0;
      this.scale = 0;
      this.scale_left = 0;
      this.scale_right = 0;
      this.analysis = false;
      this.bWriteVbrTag = false;
      this.decode_only = false;
      this.quality = 0;
      this.mode = MPEGMode.STEREO;
      this.force_ms = false;
      this.free_format = false;
      this.findReplayGain = false;
      this.decode_on_the_fly = false;
      this.write_id3tag_automatic = false;
      this.brate = 0;
      this.compression_ratio = 0;
      this.copyright = 0;
      this.original = 0;
      this.extension = 0;
      this.emphasis = 0;
      this.error_protection = 0;
      this.strict_ISO = false;
      this.disable_reservoir = false;
      this.quant_comp = 0;
      this.quant_comp_short = 0;
      this.experimentalY = false;
      this.experimentalZ = 0;
      this.exp_nspsytune = 0;
      this.preset = 0;
      this.VBR = null;
      this.VBR_q_frac = 0;
      this.VBR_q = 0;
      this.VBR_mean_bitrate_kbps = 0;
      this.VBR_min_bitrate_kbps = 0;
      this.VBR_max_bitrate_kbps = 0;
      this.VBR_hard_min = 0;
      this.lowpassfreq = 0;
      this.highpassfreq = 0;
      this.lowpasswidth = 0;
      this.highpasswidth = 0;
      this.maskingadjust = 0;
      this.maskingadjust_short = 0;
      this.ATHonly = false;
      this.ATHshort = false;
      this.noATH = false;
      this.ATHtype = 0;
      this.ATHcurve = 0;
      this.ATHlower = 0;
      this.athaa_type = 0;
      this.athaa_loudapprox = 0;
      this.athaa_sensitivity = 0;
      this.short_blocks = null;
      this.useTemporal = false;
      this.interChRatio = 0;
      this.msfix = 0;
      this.tune = false;
      this.tune_value_a = 0;
      this.version = 0;
      this.encoder_delay = 0;
      this.encoder_padding = 0;
      this.framesize = 0;
      this.frameNum = 0;
      this.lame_allocated_gfp = 0;
      this.internal_flags = null;
    }
    function CBRNewIterationLoop(_quantize) {
      var quantize = _quantize;
      this.quantize = quantize;
      this.iteration_loop = function(gfp, pe, ms_ener_ratio, ratio) {
        var gfc = gfp.internal_flags;
        var l3_xmin = new_float(L3Side.SFBMAX);
        var xrpow = new_float(576);
        var targ_bits = new_int(2);
        var mean_bits = 0;
        var l3_side = gfc.l3_side;
        var mb = new MeanBits(mean_bits);
        this.quantize.rv.ResvFrameBegin(gfp, mb);
        mean_bits = mb.bits;
        for (var gr = 0; gr < gfc.mode_gr; gr++) {
          this.quantize.qupvt.on_pe(gfp, pe, targ_bits, mean_bits, gr, gr);
          if (gfc.mode_ext == Encoder.MPG_MD_MS_LR) {
            abort();
          }
          for (var ch = 0; ch < gfc.channels_out; ch++) {
            var adjust, masking_lower_db;
            var cod_info = l3_side.tt[gr][ch];
            if (cod_info.block_type != Encoder.SHORT_TYPE) {
              adjust = 0;
              masking_lower_db = gfc.PSY.mask_adjust - adjust;
            } else {
              adjust = 0;
              masking_lower_db = gfc.PSY.mask_adjust_short - adjust;
            }
            gfc.masking_lower = Math.pow(10, masking_lower_db * 0.1);
            this.quantize.init_outer_loop(gfc, cod_info);
            if (this.quantize.init_xrpow(gfc, cod_info, xrpow)) {
              this.quantize.qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info, l3_xmin);
              this.quantize.outer_loop(gfp, cod_info, l3_xmin, xrpow, ch, targ_bits[ch]);
            }
            this.quantize.iteration_finish_one(gfc, gr, ch);
          }
        }
        this.quantize.rv.ResvFrameEnd(gfc, mean_bits);
      };
    }
    function ReplayGain() {
    }
    function ScaleFac(arrL, arrS, arr21, arr12) {
      this.l = new_int(1 + Encoder.SBMAX_l);
      this.s = new_int(1 + Encoder.SBMAX_s);
      this.psfb21 = new_int(1 + Encoder.PSFB21);
      this.psfb12 = new_int(1 + Encoder.PSFB12);
      var l = this.l;
      var s = this.s;
      if (arguments.length == 4) {
        this.arrL = arguments[0];
        this.arrS = arguments[1];
        this.arr21 = arguments[2];
        this.arr12 = arguments[3];
        System.arraycopy(this.arrL, 0, l, 0, Math.min(this.arrL.length, this.l.length));
        System.arraycopy(this.arrS, 0, s, 0, Math.min(this.arrS.length, this.s.length));
        System.arraycopy(this.arr21, 0, this.psfb21, 0, Math.min(this.arr21.length, this.psfb21.length));
        System.arraycopy(this.arr12, 0, this.psfb12, 0, Math.min(this.arr12.length, this.psfb12.length));
      }
    }
    QuantizePVT.Q_MAX = 256 + 1;
    QuantizePVT.Q_MAX2 = 116;
    QuantizePVT.LARGE_BITS = 1e5;
    QuantizePVT.IXMAX_VAL = 8206;
    function QuantizePVT() {
      var tak = null;
      var rv = null;
      var psy = null;
      this.setModules = function(_tk, _rv, _psy) {
        tak = _tk;
        rv = _rv;
        psy = _psy;
      };
      function POW20(x) {
        return pow20[x + QuantizePVT.Q_MAX2];
      }
      this.IPOW20 = function(x) {
        return ipow20[x];
      };
      var DBL_EPSILON = 2220446049250313e-31;
      var IXMAX_VAL = QuantizePVT.IXMAX_VAL;
      var PRECALC_SIZE = IXMAX_VAL + 2;
      var Q_MAX = QuantizePVT.Q_MAX;
      var Q_MAX2 = QuantizePVT.Q_MAX2;
      var NSATHSCALE = 100;
      this.nr_of_sfb_block = [[[6, 5, 5, 5], [9, 9, 9, 9], [6, 9, 9, 9]], [[6, 5, 7, 3], [9, 9, 12, 6], [6, 9, 12, 6]], [[11, 10, 0, 0], [18, 18, 0, 0], [15, 18, 0, 0]], [[7, 7, 7, 0], [12, 12, 12, 0], [6, 15, 12, 0]], [[6, 6, 6, 3], [12, 9, 9, 6], [6, 12, 9, 6]], [[8, 8, 5, 0], [15, 12, 9, 0], [6, 18, 9, 0]]];
      var pretab = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 3, 3, 3, 2, 0];
      this.pretab = pretab;
      this.sfBandIndex = [
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0, 4, 8, 12, 18, 24, 32, 42, 56, 74, 100, 132, 174, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]),
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 114, 136, 162, 194, 232, 278, 332, 394, 464, 540, 576], [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 136, 180, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]),
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 134, 174, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]),
        new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 52, 62, 74, 90, 110, 134, 162, 196, 238, 288, 342, 418, 576], [0, 4, 8, 12, 16, 22, 30, 40, 52, 66, 84, 106, 136, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]),
        new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 42, 50, 60, 72, 88, 106, 128, 156, 190, 230, 276, 330, 384, 576], [0, 4, 8, 12, 16, 22, 28, 38, 50, 64, 80, 100, 126, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]),
        new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 54, 66, 82, 102, 126, 156, 194, 240, 296, 364, 448, 550, 576], [0, 4, 8, 12, 16, 22, 30, 42, 58, 78, 104, 138, 180, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]),
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3, 402 / 3, 522 / 3, 576 / 3], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]),
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3, 402 / 3, 522 / 3, 576 / 3], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]),
        new ScaleFac([0, 12, 24, 36, 48, 60, 72, 88, 108, 132, 160, 192, 232, 280, 336, 400, 476, 566, 568, 570, 572, 574, 576], [0 / 3, 24 / 3, 48 / 3, 72 / 3, 108 / 3, 156 / 3, 216 / 3, 288 / 3, 372 / 3, 480 / 3, 486 / 3, 492 / 3, 498 / 3, 576 / 3], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0])
      ];
      var pow20 = new_float(Q_MAX + Q_MAX2 + 1);
      var ipow20 = new_float(Q_MAX);
      var pow43 = new_float(PRECALC_SIZE);
      var adj43 = new_float(PRECALC_SIZE);
      this.adj43 = adj43;
      function ATHmdct(gfp, f) {
        var ath = psy.ATHformula(f, gfp);
        ath -= NSATHSCALE;
        ath = Math.pow(10, ath / 10 + gfp.ATHlower);
        return ath;
      }
      function compute_ath(gfp) {
        var ATH_l = gfp.internal_flags.ATH.l;
        var ATH_psfb21 = gfp.internal_flags.ATH.psfb21;
        var ATH_s = gfp.internal_flags.ATH.s;
        var ATH_psfb12 = gfp.internal_flags.ATH.psfb12;
        var gfc = gfp.internal_flags;
        var samp_freq = gfp.out_samplerate;
        for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
          var start = gfc.scalefac_band.l[sfb];
          var end = gfc.scalefac_band.l[sfb + 1];
          ATH_l[sfb] = Float.MAX_VALUE;
          for (var i = start; i < end; i++) {
            var freq = i * samp_freq / (2 * 576);
            var ATH_f = ATHmdct(gfp, freq);
            ATH_l[sfb] = Math.min(ATH_l[sfb], ATH_f);
          }
        }
        for (var sfb = 0; sfb < Encoder.PSFB21; sfb++) {
          var start = gfc.scalefac_band.psfb21[sfb];
          var end = gfc.scalefac_band.psfb21[sfb + 1];
          ATH_psfb21[sfb] = Float.MAX_VALUE;
          for (var i = start; i < end; i++) {
            var freq = i * samp_freq / (2 * 576);
            var ATH_f = ATHmdct(gfp, freq);
            ATH_psfb21[sfb] = Math.min(ATH_psfb21[sfb], ATH_f);
          }
        }
        for (var sfb = 0; sfb < Encoder.SBMAX_s; sfb++) {
          var start = gfc.scalefac_band.s[sfb];
          var end = gfc.scalefac_band.s[sfb + 1];
          ATH_s[sfb] = Float.MAX_VALUE;
          for (var i = start; i < end; i++) {
            var freq = i * samp_freq / (2 * 192);
            var ATH_f = ATHmdct(gfp, freq);
            ATH_s[sfb] = Math.min(ATH_s[sfb], ATH_f);
          }
          ATH_s[sfb] *= gfc.scalefac_band.s[sfb + 1] - gfc.scalefac_band.s[sfb];
        }
        for (var sfb = 0; sfb < Encoder.PSFB12; sfb++) {
          var start = gfc.scalefac_band.psfb12[sfb];
          var end = gfc.scalefac_band.psfb12[sfb + 1];
          ATH_psfb12[sfb] = Float.MAX_VALUE;
          for (var i = start; i < end; i++) {
            var freq = i * samp_freq / (2 * 192);
            var ATH_f = ATHmdct(gfp, freq);
            ATH_psfb12[sfb] = Math.min(ATH_psfb12[sfb], ATH_f);
          }
          ATH_psfb12[sfb] *= gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12];
        }
        if (gfp.noATH) {
          abort();
        }
        gfc.ATH.floor = 10 * Math_log10(ATHmdct(gfp, -1));
      }
      this.iteration_init = function(gfp) {
        var gfc = gfp.internal_flags;
        var l3_side = gfc.l3_side;
        var i;
        if (gfc.iteration_init_init == 0) {
          gfc.iteration_init_init = 1;
          l3_side.main_data_begin = 0;
          compute_ath(gfp);
          pow43[0] = 0;
          for (i = 1; i < PRECALC_SIZE; i++)
            pow43[i] = Math.pow(i, 4 / 3);
          for (i = 0; i < PRECALC_SIZE - 1; i++)
            adj43[i] = i + 1 - Math.pow(0.5 * (pow43[i] + pow43[i + 1]), 0.75);
          adj43[i] = 0.5;
          for (i = 0; i < Q_MAX; i++)
            ipow20[i] = Math.pow(2, (i - 210) * -0.1875);
          for (i = 0; i <= Q_MAX + Q_MAX2; i++)
            pow20[i] = Math.pow(2, (i - 210 - Q_MAX2) * 0.25);
          tak.huffman_init(gfc);
          {
            var bass, alto, treble, sfb21;
            i = gfp.exp_nspsytune >> 2 & 63;
            if (i >= 32)
              i -= 64;
            bass = Math.pow(10, i / 4 / 10);
            i = gfp.exp_nspsytune >> 8 & 63;
            if (i >= 32)
              i -= 64;
            alto = Math.pow(10, i / 4 / 10);
            i = gfp.exp_nspsytune >> 14 & 63;
            if (i >= 32)
              i -= 64;
            treble = Math.pow(10, i / 4 / 10);
            i = gfp.exp_nspsytune >> 20 & 63;
            if (i >= 32)
              i -= 64;
            sfb21 = treble * Math.pow(10, i / 4 / 10);
            for (i = 0; i < Encoder.SBMAX_l; i++) {
              var f;
              if (i <= 6)
                f = bass;
              else if (i <= 13)
                f = alto;
              else if (i <= 20)
                f = treble;
              else
                f = sfb21;
              gfc.nsPsy.longfact[i] = f;
            }
            for (i = 0; i < Encoder.SBMAX_s; i++) {
              var f;
              if (i <= 5)
                f = bass;
              else if (i <= 10)
                f = alto;
              else if (i <= 11)
                f = treble;
              else
                f = sfb21;
              gfc.nsPsy.shortfact[i] = f;
            }
          }
        }
      };
      this.on_pe = function(gfp, pe, targ_bits, mean_bits, gr, cbr) {
        var gfc = gfp.internal_flags;
        var tbits = 0, bits;
        var add_bits = new_int(2);
        var ch;
        var mb = new MeanBits(tbits);
        var extra_bits = rv.ResvMaxBits(gfp, mean_bits, mb, cbr);
        tbits = mb.bits;
        var max_bits = tbits + extra_bits;
        if (max_bits > LameInternalFlags.MAX_BITS_PER_GRANULE) {
          max_bits = LameInternalFlags.MAX_BITS_PER_GRANULE;
        }
        for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
          targ_bits[ch] = Math.min(LameInternalFlags.MAX_BITS_PER_CHANNEL, tbits / gfc.channels_out);
          add_bits[ch] = 0 | targ_bits[ch] * pe[gr][ch] / 700 - targ_bits[ch];
          if (add_bits[ch] > mean_bits * 3 / 4)
            add_bits[ch] = mean_bits * 3 / 4;
          if (add_bits[ch] < 0)
            add_bits[ch] = 0;
          if (add_bits[ch] + targ_bits[ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL)
            add_bits[ch] = Math.max(0, LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[ch]);
          bits += add_bits[ch];
        }
        if (bits > extra_bits) {
          for (ch = 0; ch < gfc.channels_out; ++ch) {
            add_bits[ch] = extra_bits * add_bits[ch] / bits;
          }
        }
        for (ch = 0; ch < gfc.channels_out; ++ch) {
          targ_bits[ch] += add_bits[ch];
          extra_bits -= add_bits[ch];
        }
        for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
          bits += targ_bits[ch];
        }
        if (bits > LameInternalFlags.MAX_BITS_PER_GRANULE) {
          abort();
        }
        return max_bits;
      };
      this.athAdjust = function(a, x, athFloor) {
        var o = 90.30873362;
        var p = 94.82444863;
        var u = Util.FAST_LOG10_X(x, 10);
        var v = a * a;
        var w = 0;
        u -= athFloor;
        if (v > 1e-20)
          w = 1 + Util.FAST_LOG10_X(v, 10 / o);
        if (w < 0)
          w = 0;
        u *= w;
        u += athFloor + o - p;
        return Math.pow(10, 0.1 * u);
      };
      this.calc_xmin = function(gfp, ratio, cod_info, pxmin) {
        var pxminPos = 0;
        var gfc = gfp.internal_flags;
        var gsfb, j = 0, ath_over = 0;
        var ATH2 = gfc.ATH;
        var xr = cod_info.xr;
        var enable_athaa_fix = gfp.VBR == VbrMode.vbr_mtrh ? 1 : 0;
        var masking_lower = gfc.masking_lower;
        if (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
          masking_lower = 1;
        }
        for (gsfb = 0; gsfb < cod_info.psy_lmax; gsfb++) {
          var en0, xmin;
          var rh1, rh2;
          var width, l;
          if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh)
            xmin = athAdjust(ATH2.adjust, ATH2.l[gsfb], ATH2.floor);
          else
            xmin = ATH2.adjust * ATH2.l[gsfb];
          width = cod_info.width[gsfb];
          rh1 = xmin / width;
          rh2 = DBL_EPSILON;
          l = width >> 1;
          en0 = 0;
          do {
            var xa, xb;
            xa = xr[j] * xr[j];
            en0 += xa;
            rh2 += xa < rh1 ? xa : rh1;
            j++;
            xb = xr[j] * xr[j];
            en0 += xb;
            rh2 += xb < rh1 ? xb : rh1;
            j++;
          } while (--l > 0);
          if (en0 > xmin)
            ath_over++;
          if (gsfb == Encoder.SBPSY_l) {
            abort();
          }
          if (enable_athaa_fix != 0) {
            xmin = rh2;
          }
          if (!gfp.ATHonly) {
            var e = ratio.en.l[gsfb];
            if (e > 0) {
              var x;
              x = en0 * ratio.thm.l[gsfb] * masking_lower / e;
              if (enable_athaa_fix != 0)
                x *= gfc.nsPsy.longfact[gsfb];
              if (xmin < x)
                xmin = x;
            }
          }
          if (enable_athaa_fix != 0)
            pxmin[pxminPos++] = xmin;
          else
            pxmin[pxminPos++] = xmin * gfc.nsPsy.longfact[gsfb];
        }
        var max_nonzero = 575;
        if (cod_info.block_type != Encoder.SHORT_TYPE) {
          var k = 576;
          while (k-- != 0 && BitStream.EQ(xr[k], 0)) {
            max_nonzero = k;
          }
        }
        cod_info.max_nonzero_coeff = max_nonzero;
        for (var sfb = cod_info.sfb_smin; gsfb < cod_info.psymax; sfb++, gsfb += 3) {
          var width, b;
          var tmpATH;
          if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh)
            tmpATH = athAdjust(ATH2.adjust, ATH2.s[sfb], ATH2.floor);
          else
            tmpATH = ATH2.adjust * ATH2.s[sfb];
          width = cod_info.width[gsfb];
          for (b = 0; b < 3; b++) {
            var en0 = 0, xmin;
            var rh1, rh2;
            var l = width >> 1;
            rh1 = tmpATH / width;
            rh2 = DBL_EPSILON;
            do {
              var xa, xb;
              xa = xr[j] * xr[j];
              en0 += xa;
              rh2 += xa < rh1 ? xa : rh1;
              j++;
              xb = xr[j] * xr[j];
              en0 += xb;
              rh2 += xb < rh1 ? xb : rh1;
              j++;
            } while (--l > 0);
            if (en0 > tmpATH)
              ath_over++;
            if (sfb == Encoder.SBPSY_s) {
              abort();
            }
            if (enable_athaa_fix != 0)
              xmin = rh2;
            else
              xmin = tmpATH;
            if (!gfp.ATHonly && !gfp.ATHshort) {
              var e = ratio.en.s[sfb][b];
              if (e > 0) {
                var x;
                x = en0 * ratio.thm.s[sfb][b] * masking_lower / e;
                if (enable_athaa_fix != 0)
                  x *= gfc.nsPsy.shortfact[sfb];
                if (xmin < x)
                  xmin = x;
              }
            }
            if (enable_athaa_fix != 0)
              pxmin[pxminPos++] = xmin;
            else
              pxmin[pxminPos++] = xmin * gfc.nsPsy.shortfact[sfb];
          }
          if (gfp.useTemporal) {
            if (pxmin[pxminPos - 3] > pxmin[pxminPos - 3 + 1])
              pxmin[pxminPos - 3 + 1] += (pxmin[pxminPos - 3] - pxmin[pxminPos - 3 + 1]) * gfc.decay;
            if (pxmin[pxminPos - 3 + 1] > pxmin[pxminPos - 3 + 2])
              pxmin[pxminPos - 3 + 2] += (pxmin[pxminPos - 3 + 1] - pxmin[pxminPos - 3 + 2]) * gfc.decay;
          }
        }
        return ath_over;
      };
      function StartLine(j) {
        this.s = j;
      }
      this.calc_noise_core = function(cod_info, startline, l, step) {
        var noise = 0;
        var j = startline.s;
        var ix = cod_info.l3_enc;
        if (j > cod_info.count1) {
          while (l-- != 0) {
            var temp;
            temp = cod_info.xr[j];
            j++;
            noise += temp * temp;
            temp = cod_info.xr[j];
            j++;
            noise += temp * temp;
          }
        } else if (j > cod_info.big_values) {
          var ix01 = new_float(2);
          ix01[0] = 0;
          ix01[1] = step;
          while (l-- != 0) {
            var temp;
            temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
            j++;
            noise += temp * temp;
            temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
            j++;
            noise += temp * temp;
          }
        } else {
          while (l-- != 0) {
            var temp;
            temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
            j++;
            noise += temp * temp;
            temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
            j++;
            noise += temp * temp;
          }
        }
        startline.s = j;
        return noise;
      };
      this.calc_noise = function(cod_info, l3_xmin, distort, res, prev_noise) {
        var distortPos = 0;
        var l3_xminPos = 0;
        var sfb, l, over = 0;
        var over_noise_db = 0;
        var tot_noise_db = 0;
        var max_noise = -20;
        var j = 0;
        var scalefac = cod_info.scalefac;
        var scalefacPos = 0;
        res.over_SSD = 0;
        for (sfb = 0; sfb < cod_info.psymax; sfb++) {
          var s = cod_info.global_gain - (scalefac[scalefacPos++] + (cod_info.preflag != 0 ? pretab[sfb] : 0) << cod_info.scalefac_scale + 1) - cod_info.subblock_gain[cod_info.window[sfb]] * 8;
          var noise = 0;
          if (prev_noise != null && prev_noise.step[sfb] == s) {
            noise = prev_noise.noise[sfb];
            j += cod_info.width[sfb];
            distort[distortPos++] = noise / l3_xmin[l3_xminPos++];
            noise = prev_noise.noise_log[sfb];
          } else {
            var step = POW20(s);
            l = cod_info.width[sfb] >> 1;
            if (j + cod_info.width[sfb] > cod_info.max_nonzero_coeff) {
              var usefullsize;
              usefullsize = cod_info.max_nonzero_coeff - j + 1;
              if (usefullsize > 0)
                l = usefullsize >> 1;
              else
                l = 0;
            }
            var sl = new StartLine(j);
            noise = this.calc_noise_core(cod_info, sl, l, step);
            j = sl.s;
            if (prev_noise != null) {
              prev_noise.step[sfb] = s;
              prev_noise.noise[sfb] = noise;
            }
            noise = distort[distortPos++] = noise / l3_xmin[l3_xminPos++];
            noise = Util.FAST_LOG10(Math.max(noise, 1e-20));
            if (prev_noise != null) {
              prev_noise.noise_log[sfb] = noise;
            }
          }
          if (prev_noise != null) {
            prev_noise.global_gain = cod_info.global_gain;
          }
          tot_noise_db += noise;
          if (noise > 0) {
            var tmp;
            tmp = Math.max(0 | noise * 10 + 0.5, 1);
            res.over_SSD += tmp * tmp;
            over++;
            over_noise_db += noise;
          }
          max_noise = Math.max(max_noise, noise);
        }
        res.over_count = over;
        res.tot_noise = tot_noise_db;
        res.over_noise = over_noise_db;
        res.max_noise = max_noise;
        return over;
      };
    }
    function CalcNoiseData() {
      this.global_gain = 0;
      this.sfb_count1 = 0;
      this.step = new_int(39);
      this.noise = new_float(39);
      this.noise_log = new_float(39);
    }
    function GrInfo() {
      this.xr = new_float(576);
      this.l3_enc = new_int(576);
      this.scalefac = new_int(L3Side.SFBMAX);
      this.xrpow_max = 0;
      this.part2_3_length = 0;
      this.big_values = 0;
      this.count1 = 0;
      this.global_gain = 0;
      this.scalefac_compress = 0;
      this.block_type = 0;
      this.mixed_block_flag = 0;
      this.table_select = new_int(3);
      this.subblock_gain = new_int(3 + 1);
      this.region0_count = 0;
      this.region1_count = 0;
      this.preflag = 0;
      this.scalefac_scale = 0;
      this.count1table_select = 0;
      this.part2_length = 0;
      this.sfb_lmax = 0;
      this.sfb_smin = 0;
      this.psy_lmax = 0;
      this.sfbmax = 0;
      this.psymax = 0;
      this.sfbdivide = 0;
      this.width = new_int(L3Side.SFBMAX);
      this.window = new_int(L3Side.SFBMAX);
      this.count1bits = 0;
      this.sfb_partition_table = null;
      this.slen = new_int(4);
      this.max_nonzero_coeff = 0;
      var self2 = this;
      function clone_int(array) {
        return new Int32Array(array);
      }
      function clone_float(array) {
        return new Float32Array(array);
      }
      this.assign = function(other) {
        self2.xr = clone_float(other.xr);
        self2.l3_enc = clone_int(other.l3_enc);
        self2.scalefac = clone_int(other.scalefac);
        self2.xrpow_max = other.xrpow_max;
        self2.part2_3_length = other.part2_3_length;
        self2.big_values = other.big_values;
        self2.count1 = other.count1;
        self2.global_gain = other.global_gain;
        self2.scalefac_compress = other.scalefac_compress;
        self2.block_type = other.block_type;
        self2.mixed_block_flag = other.mixed_block_flag;
        self2.table_select = clone_int(other.table_select);
        self2.subblock_gain = clone_int(other.subblock_gain);
        self2.region0_count = other.region0_count;
        self2.region1_count = other.region1_count;
        self2.preflag = other.preflag;
        self2.scalefac_scale = other.scalefac_scale;
        self2.count1table_select = other.count1table_select;
        self2.part2_length = other.part2_length;
        self2.sfb_lmax = other.sfb_lmax;
        self2.sfb_smin = other.sfb_smin;
        self2.psy_lmax = other.psy_lmax;
        self2.sfbmax = other.sfbmax;
        self2.psymax = other.psymax;
        self2.sfbdivide = other.sfbdivide;
        self2.width = clone_int(other.width);
        self2.window = clone_int(other.window);
        self2.count1bits = other.count1bits;
        self2.sfb_partition_table = other.sfb_partition_table.slice(0);
        self2.slen = clone_int(other.slen);
        self2.max_nonzero_coeff = other.max_nonzero_coeff;
      };
    }
    var L3Side = {};
    L3Side.SFBMAX = Encoder.SBMAX_s * 3;
    function Quantize() {
      this.rv = null;
      var rv;
      this.qupvt = null;
      var qupvt;
      var vbr = new VBRQuantize();
      var tk;
      this.setModules = function(_bs, _rv, _qupvt, _tk) {
        rv = _rv;
        this.rv = _rv;
        qupvt = _qupvt;
        this.qupvt = _qupvt;
        tk = _tk;
        vbr.setModules(qupvt, tk);
      };
      function init_xrpow_core(cod_info, xrpow, upper, sum) {
        sum = 0;
        for (var i = 0; i <= upper; ++i) {
          var tmp = Math.abs(cod_info.xr[i]);
          sum += tmp;
          xrpow[i] = Math.sqrt(tmp * Math.sqrt(tmp));
          if (xrpow[i] > cod_info.xrpow_max)
            cod_info.xrpow_max = xrpow[i];
        }
        return sum;
      }
      this.init_xrpow = function(gfc, cod_info, xrpow) {
        var sum = 0;
        var upper = 0 | cod_info.max_nonzero_coeff;
        cod_info.xrpow_max = 0;
        Arrays.fill(xrpow, upper, 576, 0);
        sum = init_xrpow_core(cod_info, xrpow, upper, sum);
        if (sum > 1e-20) {
          var j = 0;
          if ((gfc.substep_shaping & 2) != 0)
            j = 1;
          for (var i = 0; i < cod_info.psymax; i++)
            gfc.pseudohalf[i] = j;
          return true;
        }
        Arrays.fill(cod_info.l3_enc, 0, 576, 0);
        return false;
      };
      function psfb21_analogsilence(gfc, cod_info) {
        var ath = gfc.ATH;
        var xr = cod_info.xr;
        if (cod_info.block_type != Encoder.SHORT_TYPE) {
          var stop2 = false;
          for (var gsfb = Encoder.PSFB21 - 1; gsfb >= 0 && !stop2; gsfb--) {
            var start = gfc.scalefac_band.psfb21[gsfb];
            var end = gfc.scalefac_band.psfb21[gsfb + 1];
            var ath21 = qupvt.athAdjust(ath.adjust, ath.psfb21[gsfb], ath.floor);
            if (gfc.nsPsy.longfact[21] > 1e-12)
              ath21 *= gfc.nsPsy.longfact[21];
            for (var j = end - 1; j >= start; j--) {
              if (Math.abs(xr[j]) < ath21)
                xr[j] = 0;
              else {
                stop2 = true;
                break;
              }
            }
          }
        } else {
          for (var block = 0; block < 3; block++) {
            var stop2 = false;
            for (var gsfb = Encoder.PSFB12 - 1; gsfb >= 0 && !stop2; gsfb--) {
              var start = gfc.scalefac_band.s[12] * 3 + (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12]) * block + (gfc.scalefac_band.psfb12[gsfb] - gfc.scalefac_band.psfb12[0]);
              var end = start + (gfc.scalefac_band.psfb12[gsfb + 1] - gfc.scalefac_band.psfb12[gsfb]);
              var ath12 = qupvt.athAdjust(ath.adjust, ath.psfb12[gsfb], ath.floor);
              if (gfc.nsPsy.shortfact[12] > 1e-12)
                ath12 *= gfc.nsPsy.shortfact[12];
              for (var j = end - 1; j >= start; j--) {
                if (Math.abs(xr[j]) < ath12)
                  xr[j] = 0;
                else {
                  stop2 = true;
                  break;
                }
              }
            }
          }
        }
      }
      this.init_outer_loop = function(gfc, cod_info) {
        cod_info.part2_3_length = 0;
        cod_info.big_values = 0;
        cod_info.count1 = 0;
        cod_info.global_gain = 210;
        cod_info.scalefac_compress = 0;
        cod_info.table_select[0] = 0;
        cod_info.table_select[1] = 0;
        cod_info.table_select[2] = 0;
        cod_info.subblock_gain[0] = 0;
        cod_info.subblock_gain[1] = 0;
        cod_info.subblock_gain[2] = 0;
        cod_info.subblock_gain[3] = 0;
        cod_info.region0_count = 0;
        cod_info.region1_count = 0;
        cod_info.preflag = 0;
        cod_info.scalefac_scale = 0;
        cod_info.count1table_select = 0;
        cod_info.part2_length = 0;
        cod_info.sfb_lmax = Encoder.SBPSY_l;
        cod_info.sfb_smin = Encoder.SBPSY_s;
        cod_info.psy_lmax = gfc.sfb21_extra ? Encoder.SBMAX_l : Encoder.SBPSY_l;
        cod_info.psymax = cod_info.psy_lmax;
        cod_info.sfbmax = cod_info.sfb_lmax;
        cod_info.sfbdivide = 11;
        for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
          cod_info.width[sfb] = gfc.scalefac_band.l[sfb + 1] - gfc.scalefac_band.l[sfb];
          cod_info.window[sfb] = 3;
        }
        if (cod_info.block_type == Encoder.SHORT_TYPE) {
          var ixwork = new_float(576);
          cod_info.sfb_smin = 0;
          cod_info.sfb_lmax = 0;
          if (cod_info.mixed_block_flag != 0) {
            abort();
          }
          cod_info.psymax = cod_info.sfb_lmax + 3 * ((gfc.sfb21_extra ? Encoder.SBMAX_s : Encoder.SBPSY_s) - cod_info.sfb_smin);
          cod_info.sfbmax = cod_info.sfb_lmax + 3 * (Encoder.SBPSY_s - cod_info.sfb_smin);
          cod_info.sfbdivide = cod_info.sfbmax - 18;
          cod_info.psy_lmax = cod_info.sfb_lmax;
          var ix = gfc.scalefac_band.l[cod_info.sfb_lmax];
          System.arraycopy(cod_info.xr, 0, ixwork, 0, 576);
          for (var sfb = cod_info.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
            var start = gfc.scalefac_band.s[sfb];
            var end = gfc.scalefac_band.s[sfb + 1];
            for (var window2 = 0; window2 < 3; window2++) {
              for (var l = start; l < end; l++) {
                cod_info.xr[ix++] = ixwork[3 * l + window2];
              }
            }
          }
          var j = cod_info.sfb_lmax;
          for (var sfb = cod_info.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
            cod_info.width[j] = cod_info.width[j + 1] = cod_info.width[j + 2] = gfc.scalefac_band.s[sfb + 1] - gfc.scalefac_band.s[sfb];
            cod_info.window[j] = 0;
            cod_info.window[j + 1] = 1;
            cod_info.window[j + 2] = 2;
            j += 3;
          }
        }
        cod_info.count1bits = 0;
        cod_info.sfb_partition_table = qupvt.nr_of_sfb_block[0][0];
        cod_info.slen[0] = 0;
        cod_info.slen[1] = 0;
        cod_info.slen[2] = 0;
        cod_info.slen[3] = 0;
        cod_info.max_nonzero_coeff = 575;
        Arrays.fill(cod_info.scalefac, 0);
        psfb21_analogsilence(gfc, cod_info);
      };
      function BinSearchDirection(ordinal) {
        this.ordinal = ordinal;
      }
      BinSearchDirection.BINSEARCH_NONE = new BinSearchDirection(0);
      BinSearchDirection.BINSEARCH_UP = new BinSearchDirection(1);
      BinSearchDirection.BINSEARCH_DOWN = new BinSearchDirection(2);
      function bin_search_StepSize(gfc, cod_info, desired_rate, ch, xrpow) {
        var nBits;
        var CurrentStep = gfc.CurrentStep[ch];
        var flagGoneOver = false;
        var start = gfc.OldValue[ch];
        var Direction = BinSearchDirection.BINSEARCH_NONE;
        cod_info.global_gain = start;
        desired_rate -= cod_info.part2_length;
        for (; ; ) {
          var step;
          nBits = tk.count_bits(gfc, xrpow, cod_info, null);
          if (CurrentStep == 1 || nBits == desired_rate)
            break;
          if (nBits > desired_rate) {
            if (Direction == BinSearchDirection.BINSEARCH_DOWN)
              flagGoneOver = true;
            if (flagGoneOver)
              CurrentStep /= 2;
            Direction = BinSearchDirection.BINSEARCH_UP;
            step = CurrentStep;
          } else {
            if (Direction == BinSearchDirection.BINSEARCH_UP)
              flagGoneOver = true;
            if (flagGoneOver)
              CurrentStep /= 2;
            Direction = BinSearchDirection.BINSEARCH_DOWN;
            step = -CurrentStep;
          }
          cod_info.global_gain += step;
          if (cod_info.global_gain < 0) {
            abort();
          }
          if (cod_info.global_gain > 255) {
            abort();
          }
        }
        while (nBits > desired_rate && cod_info.global_gain < 255) {
          cod_info.global_gain++;
          nBits = tk.count_bits(gfc, xrpow, cod_info, null);
        }
        gfc.CurrentStep[ch] = start - cod_info.global_gain >= 4 ? 4 : 2;
        gfc.OldValue[ch] = cod_info.global_gain;
        cod_info.part2_3_length = nBits;
        return nBits;
      }
      function loop_break(cod_info) {
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++)
          if (cod_info.scalefac[sfb] + cod_info.subblock_gain[cod_info.window[sfb]] == 0)
            return false;
        return true;
      }
      function quant_compare(quant_comp, best, calc, gi, distort) {
        var better;
        switch (quant_comp) {
          default:
          case 9: {
            if (best.over_count > 0) {
              better = calc.over_SSD <= best.over_SSD;
              if (calc.over_SSD == best.over_SSD)
                better = calc.bits < best.bits;
            } else {
              better = calc.max_noise < 0 && calc.max_noise * 10 + calc.bits <= best.max_noise * 10 + best.bits;
            }
            break;
          }
          case 0:
            better = calc.over_count < best.over_count || calc.over_count == best.over_count && calc.over_noise < best.over_noise || calc.over_count == best.over_count && BitStream.EQ(calc.over_noise, best.over_noise) && calc.tot_noise < best.tot_noise;
            break;
          case 8:
            abort();
          case 1:
            better = calc.max_noise < best.max_noise;
            break;
          case 2:
            better = calc.tot_noise < best.tot_noise;
            break;
          case 3:
            better = calc.tot_noise < best.tot_noise && calc.max_noise < best.max_noise;
            break;
          case 4:
            better = calc.max_noise <= 0 && best.max_noise > 0.2 || calc.max_noise <= 0 && best.max_noise < 0 && best.max_noise > calc.max_noise - 0.2 && calc.tot_noise < best.tot_noise || calc.max_noise <= 0 && best.max_noise > 0 && best.max_noise > calc.max_noise - 0.2 && calc.tot_noise < best.tot_noise + best.over_noise || calc.max_noise > 0 && best.max_noise > -0.05 && best.max_noise > calc.max_noise - 0.1 && calc.tot_noise + calc.over_noise < best.tot_noise + best.over_noise || calc.max_noise > 0 && best.max_noise > -0.1 && best.max_noise > calc.max_noise - 0.15 && calc.tot_noise + calc.over_noise + calc.over_noise < best.tot_noise + best.over_noise + best.over_noise;
            break;
          case 5:
            better = calc.over_noise < best.over_noise || BitStream.EQ(calc.over_noise, best.over_noise) && calc.tot_noise < best.tot_noise;
            break;
          case 6:
            better = calc.over_noise < best.over_noise || BitStream.EQ(calc.over_noise, best.over_noise) && (calc.max_noise < best.max_noise || BitStream.EQ(calc.max_noise, best.max_noise) && calc.tot_noise <= best.tot_noise);
            break;
          case 7:
            better = calc.over_count < best.over_count || calc.over_noise < best.over_noise;
            break;
        }
        if (best.over_count == 0) {
          better = better && calc.bits < best.bits;
        }
        return better;
      }
      function amp_scalefac_bands(gfp, cod_info, distort, xrpow, bRefine) {
        var gfc = gfp.internal_flags;
        var ifqstep34;
        if (cod_info.scalefac_scale == 0) {
          ifqstep34 = 1.2968395546510096;
        } else {
          ifqstep34 = 1.6817928305074292;
        }
        var trigger = 0;
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
          if (trigger < distort[sfb])
            trigger = distort[sfb];
        }
        var noise_shaping_amp = gfc.noise_shaping_amp;
        if (noise_shaping_amp == 3) {
          abort();
        }
        switch (noise_shaping_amp) {
          case 2:
            break;
          case 1:
            if (trigger > 1)
              trigger = Math.pow(trigger, 0.5);
            else
              trigger *= 0.95;
            break;
          case 0:
          default:
            if (trigger > 1)
              trigger = 1;
            else
              trigger *= 0.95;
            break;
        }
        var j = 0;
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
          var width = cod_info.width[sfb];
          var l;
          j += width;
          if (distort[sfb] < trigger)
            continue;
          if ((gfc.substep_shaping & 2) != 0) {
            abort();
          }
          cod_info.scalefac[sfb]++;
          for (l = -width; l < 0; l++) {
            xrpow[j + l] *= ifqstep34;
            if (xrpow[j + l] > cod_info.xrpow_max)
              cod_info.xrpow_max = xrpow[j + l];
          }
          if (gfc.noise_shaping_amp == 2)
            return;
        }
      }
      function inc_scalefac_scale(cod_info, xrpow) {
        var ifqstep34 = 1.2968395546510096;
        var j = 0;
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
          var width = cod_info.width[sfb];
          var s = cod_info.scalefac[sfb];
          if (cod_info.preflag != 0)
            s += qupvt.pretab[sfb];
          j += width;
          if ((s & 1) != 0) {
            s++;
            for (var l = -width; l < 0; l++) {
              xrpow[j + l] *= ifqstep34;
              if (xrpow[j + l] > cod_info.xrpow_max)
                cod_info.xrpow_max = xrpow[j + l];
            }
          }
          cod_info.scalefac[sfb] = s >> 1;
        }
        cod_info.preflag = 0;
        cod_info.scalefac_scale = 1;
      }
      function inc_subblock_gain(gfc, cod_info, xrpow) {
        var sfb;
        var scalefac = cod_info.scalefac;
        for (sfb = 0; sfb < cod_info.sfb_lmax; sfb++) {
          if (scalefac[sfb] >= 16)
            return true;
        }
        for (var window2 = 0; window2 < 3; window2++) {
          var s1 = 0;
          var s2 = 0;
          for (sfb = cod_info.sfb_lmax + window2; sfb < cod_info.sfbdivide; sfb += 3) {
            if (s1 < scalefac[sfb])
              s1 = scalefac[sfb];
          }
          for (; sfb < cod_info.sfbmax; sfb += 3) {
            if (s2 < scalefac[sfb])
              s2 = scalefac[sfb];
          }
          if (s1 < 16 && s2 < 8)
            continue;
          if (cod_info.subblock_gain[window2] >= 7)
            return true;
          cod_info.subblock_gain[window2]++;
          var j = gfc.scalefac_band.l[cod_info.sfb_lmax];
          for (sfb = cod_info.sfb_lmax + window2; sfb < cod_info.sfbmax; sfb += 3) {
            var amp;
            var width = cod_info.width[sfb];
            var s = scalefac[sfb];
            s = s - (4 >> cod_info.scalefac_scale);
            if (s >= 0) {
              scalefac[sfb] = s;
              j += width * 3;
              continue;
            }
            scalefac[sfb] = 0;
            {
              var gain = 210 + (s << cod_info.scalefac_scale + 1);
              amp = qupvt.IPOW20(gain);
            }
            j += width * (window2 + 1);
            for (var l = -width; l < 0; l++) {
              xrpow[j + l] *= amp;
              if (xrpow[j + l] > cod_info.xrpow_max)
                cod_info.xrpow_max = xrpow[j + l];
            }
            j += width * (3 - window2 - 1);
          }
          {
            var amp = qupvt.IPOW20(202);
            j += cod_info.width[sfb] * (window2 + 1);
            for (var l = -cod_info.width[sfb]; l < 0; l++) {
              xrpow[j + l] *= amp;
              if (xrpow[j + l] > cod_info.xrpow_max)
                cod_info.xrpow_max = xrpow[j + l];
            }
          }
        }
        return false;
      }
      function balance_noise(gfp, cod_info, distort, xrpow, bRefine) {
        var gfc = gfp.internal_flags;
        amp_scalefac_bands(gfp, cod_info, distort, xrpow);
        var status = loop_break(cod_info);
        if (status)
          return false;
        if (gfc.mode_gr == 2)
          status = tk.scale_bitcount(cod_info);
        else
          status = tk.scale_bitcount_lsf(gfc, cod_info);
        if (!status)
          return true;
        if (gfc.noise_shaping > 1) {
          Arrays.fill(gfc.pseudohalf, 0);
          if (cod_info.scalefac_scale == 0) {
            inc_scalefac_scale(cod_info, xrpow);
            status = false;
          } else {
            if (cod_info.block_type == Encoder.SHORT_TYPE && gfc.subblock_gain > 0) {
              status = inc_subblock_gain(gfc, cod_info, xrpow) || loop_break(cod_info);
            }
          }
        }
        if (!status) {
          if (gfc.mode_gr == 2)
            status = tk.scale_bitcount(cod_info);
          else
            status = tk.scale_bitcount_lsf(gfc, cod_info);
        }
        return !status;
      }
      this.outer_loop = function(gfp, cod_info, l3_xmin, xrpow, ch, targ_bits) {
        var gfc = gfp.internal_flags;
        var cod_info_w = new GrInfo();
        var save_xrpow = new_float(576);
        var distort = new_float(L3Side.SFBMAX);
        var best_noise_info = new CalcNoiseResult();
        var better;
        var prev_noise = new CalcNoiseData();
        var best_part2_3_length = 9999999;
        var bEndOfSearch = false;
        var bRefine = false;
        var best_ggain_pass1 = 0;
        bin_search_StepSize(gfc, cod_info, targ_bits, ch, xrpow);
        if (gfc.noise_shaping == 0)
          return 100;
        qupvt.calc_noise(cod_info, l3_xmin, distort, best_noise_info, prev_noise);
        best_noise_info.bits = cod_info.part2_3_length;
        cod_info_w.assign(cod_info);
        var age = 0;
        System.arraycopy(xrpow, 0, save_xrpow, 0, 576);
        while (!bEndOfSearch) {
          do {
            var noise_info = new CalcNoiseResult();
            var search_limit;
            var maxggain = 255;
            if ((gfc.substep_shaping & 2) != 0) {
              search_limit = 20;
            } else {
              search_limit = 3;
            }
            if (gfc.sfb21_extra) {
              abort();
            }
            if (!balance_noise(gfp, cod_info_w, distort, xrpow))
              break;
            if (cod_info_w.scalefac_scale != 0)
              maxggain = 254;
            var huff_bits = targ_bits - cod_info_w.part2_length;
            if (huff_bits <= 0)
              break;
            while ((cod_info_w.part2_3_length = tk.count_bits(gfc, xrpow, cod_info_w, prev_noise)) > huff_bits && cod_info_w.global_gain <= maxggain)
              cod_info_w.global_gain++;
            if (cod_info_w.global_gain > maxggain)
              break;
            if (best_noise_info.over_count == 0) {
              while ((cod_info_w.part2_3_length = tk.count_bits(gfc, xrpow, cod_info_w, prev_noise)) > best_part2_3_length && cod_info_w.global_gain <= maxggain)
                cod_info_w.global_gain++;
              if (cod_info_w.global_gain > maxggain)
                break;
            }
            qupvt.calc_noise(cod_info_w, l3_xmin, distort, noise_info, prev_noise);
            noise_info.bits = cod_info_w.part2_3_length;
            if (cod_info.block_type != Encoder.SHORT_TYPE) {
              better = gfp.quant_comp;
            } else
              better = gfp.quant_comp_short;
            better = quant_compare(better, best_noise_info, noise_info) ? 1 : 0;
            if (better != 0) {
              best_part2_3_length = cod_info.part2_3_length;
              best_noise_info = noise_info;
              cod_info.assign(cod_info_w);
              age = 0;
              System.arraycopy(xrpow, 0, save_xrpow, 0, 576);
            } else {
              if (gfc.full_outer_loop == 0) {
                if (++age > search_limit && best_noise_info.over_count == 0)
                  break;
                if (gfc.noise_shaping_amp == 3 && bRefine && age > 30)
                  break;
                if (gfc.noise_shaping_amp == 3 && bRefine && cod_info_w.global_gain - best_ggain_pass1 > 15)
                  break;
              }
            }
          } while (cod_info_w.global_gain + cod_info_w.scalefac_scale < 255);
          if (gfc.noise_shaping_amp == 3) {
            abort();
          } else {
            bEndOfSearch = true;
          }
        }
        if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh)
          System.arraycopy(save_xrpow, 0, xrpow, 0, 576);
        else if ((gfc.substep_shaping & 1) != 0)
          abort();
        return best_noise_info.over_count;
      };
      this.iteration_finish_one = function(gfc, gr, ch) {
        var l3_side = gfc.l3_side;
        var cod_info = l3_side.tt[gr][ch];
        tk.best_scalefac_store(gfc, gr, ch, l3_side);
        if (gfc.use_best_huffman == 1)
          tk.best_huffman_divide(gfc, cod_info);
        rv.ResvAdjust(gfc, cod_info);
      };
    }
    function NewMDCT() {
      var enwindow = [
        -477e-9 * 0.740951125354959 / 2384e-9,
        103951e-9 * 0.740951125354959 / 2384e-9,
        953674e-9 * 0.740951125354959 / 2384e-9,
        2841473e-9 * 0.740951125354959 / 2384e-9,
        0.035758972 * 0.740951125354959 / 2384e-9,
        3401756e-9 * 0.740951125354959 / 2384e-9,
        983715e-9 * 0.740951125354959 / 2384e-9,
        99182e-9 * 0.740951125354959 / 2384e-9,
        12398e-9 * 0.740951125354959 / 2384e-9,
        191212e-9 * 0.740951125354959 / 2384e-9,
        2283096e-9 * 0.740951125354959 / 2384e-9,
        0.016994476 * 0.740951125354959 / 2384e-9,
        -0.018756866 * 0.740951125354959 / 2384e-9,
        -2630711e-9 * 0.740951125354959 / 2384e-9,
        -247478e-9 * 0.740951125354959 / 2384e-9,
        -14782e-9 * 0.740951125354959 / 2384e-9,
        0.9063471690191471,
        0.1960342806591213,
        -477e-9 * 0.773010453362737 / 2384e-9,
        105858e-9 * 0.773010453362737 / 2384e-9,
        930786e-9 * 0.773010453362737 / 2384e-9,
        2521515e-9 * 0.773010453362737 / 2384e-9,
        0.035694122 * 0.773010453362737 / 2384e-9,
        3643036e-9 * 0.773010453362737 / 2384e-9,
        991821e-9 * 0.773010453362737 / 2384e-9,
        96321e-9 * 0.773010453362737 / 2384e-9,
        11444e-9 * 0.773010453362737 / 2384e-9,
        165462e-9 * 0.773010453362737 / 2384e-9,
        2110004e-9 * 0.773010453362737 / 2384e-9,
        0.016112804 * 0.773010453362737 / 2384e-9,
        -0.019634247 * 0.773010453362737 / 2384e-9,
        -2803326e-9 * 0.773010453362737 / 2384e-9,
        -277042e-9 * 0.773010453362737 / 2384e-9,
        -16689e-9 * 0.773010453362737 / 2384e-9,
        0.8206787908286602,
        0.3901806440322567,
        -477e-9 * 0.803207531480645 / 2384e-9,
        107288e-9 * 0.803207531480645 / 2384e-9,
        902653e-9 * 0.803207531480645 / 2384e-9,
        2174854e-9 * 0.803207531480645 / 2384e-9,
        0.035586357 * 0.803207531480645 / 2384e-9,
        3858566e-9 * 0.803207531480645 / 2384e-9,
        995159e-9 * 0.803207531480645 / 2384e-9,
        9346e-8 * 0.803207531480645 / 2384e-9,
        10014e-9 * 0.803207531480645 / 2384e-9,
        14019e-8 * 0.803207531480645 / 2384e-9,
        1937389e-9 * 0.803207531480645 / 2384e-9,
        0.015233517 * 0.803207531480645 / 2384e-9,
        -0.020506859 * 0.803207531480645 / 2384e-9,
        -2974033e-9 * 0.803207531480645 / 2384e-9,
        -30756e-8 * 0.803207531480645 / 2384e-9,
        -1812e-8 * 0.803207531480645 / 2384e-9,
        0.7416505462720353,
        0.5805693545089249,
        -477e-9 * 0.831469612302545 / 2384e-9,
        108242e-9 * 0.831469612302545 / 2384e-9,
        868797e-9 * 0.831469612302545 / 2384e-9,
        1800537e-9 * 0.831469612302545 / 2384e-9,
        0.0354352 * 0.831469612302545 / 2384e-9,
        4049301e-9 * 0.831469612302545 / 2384e-9,
        994205e-9 * 0.831469612302545 / 2384e-9,
        90599e-9 * 0.831469612302545 / 2384e-9,
        906e-8 * 0.831469612302545 / 2384e-9,
        116348e-9 * 0.831469612302545 / 2384e-9,
        1766682e-9 * 0.831469612302545 / 2384e-9,
        0.014358521 * 0.831469612302545 / 2384e-9,
        -0.021372318 * 0.831469612302545 / 2384e-9,
        -314188e-8 * 0.831469612302545 / 2384e-9,
        -339031e-9 * 0.831469612302545 / 2384e-9,
        -1955e-8 * 0.831469612302545 / 2384e-9,
        0.6681786379192989,
        0.7653668647301797,
        -477e-9 * 0.857728610000272 / 2384e-9,
        108719e-9 * 0.857728610000272 / 2384e-9,
        82922e-8 * 0.857728610000272 / 2384e-9,
        1399517e-9 * 0.857728610000272 / 2384e-9,
        0.035242081 * 0.857728610000272 / 2384e-9,
        421524e-8 * 0.857728610000272 / 2384e-9,
        989437e-9 * 0.857728610000272 / 2384e-9,
        87261e-9 * 0.857728610000272 / 2384e-9,
        8106e-9 * 0.857728610000272 / 2384e-9,
        93937e-9 * 0.857728610000272 / 2384e-9,
        1597881e-9 * 0.857728610000272 / 2384e-9,
        0.013489246 * 0.857728610000272 / 2384e-9,
        -0.022228718 * 0.857728610000272 / 2384e-9,
        -3306866e-9 * 0.857728610000272 / 2384e-9,
        -371456e-9 * 0.857728610000272 / 2384e-9,
        -21458e-9 * 0.857728610000272 / 2384e-9,
        0.5993769336819237,
        0.9427934736519954,
        -477e-9 * 0.881921264348355 / 2384e-9,
        108719e-9 * 0.881921264348355 / 2384e-9,
        78392e-8 * 0.881921264348355 / 2384e-9,
        971317e-9 * 0.881921264348355 / 2384e-9,
        0.035007 * 0.881921264348355 / 2384e-9,
        4357815e-9 * 0.881921264348355 / 2384e-9,
        980854e-9 * 0.881921264348355 / 2384e-9,
        83923e-9 * 0.881921264348355 / 2384e-9,
        7629e-9 * 0.881921264348355 / 2384e-9,
        72956e-9 * 0.881921264348355 / 2384e-9,
        1432419e-9 * 0.881921264348355 / 2384e-9,
        0.012627602 * 0.881921264348355 / 2384e-9,
        -0.02307415 * 0.881921264348355 / 2384e-9,
        -3467083e-9 * 0.881921264348355 / 2384e-9,
        -404358e-9 * 0.881921264348355 / 2384e-9,
        -23365e-9 * 0.881921264348355 / 2384e-9,
        0.5345111359507916,
        1.111140466039205,
        -954e-9 * 0.903989293123443 / 2384e-9,
        108242e-9 * 0.903989293123443 / 2384e-9,
        731945e-9 * 0.903989293123443 / 2384e-9,
        515938e-9 * 0.903989293123443 / 2384e-9,
        0.034730434 * 0.903989293123443 / 2384e-9,
        4477024e-9 * 0.903989293123443 / 2384e-9,
        968933e-9 * 0.903989293123443 / 2384e-9,
        80585e-9 * 0.903989293123443 / 2384e-9,
        6676e-9 * 0.903989293123443 / 2384e-9,
        52929e-9 * 0.903989293123443 / 2384e-9,
        1269817e-9 * 0.903989293123443 / 2384e-9,
        0.011775017 * 0.903989293123443 / 2384e-9,
        -0.023907185 * 0.903989293123443 / 2384e-9,
        -3622532e-9 * 0.903989293123443 / 2384e-9,
        -438213e-9 * 0.903989293123443 / 2384e-9,
        -25272e-9 * 0.903989293123443 / 2384e-9,
        0.4729647758913199,
        1.268786568327291,
        -954e-9 * 0.9238795325112867 / 2384e-9,
        106812e-9 * 0.9238795325112867 / 2384e-9,
        674248e-9 * 0.9238795325112867 / 2384e-9,
        33379e-9 * 0.9238795325112867 / 2384e-9,
        0.034412861 * 0.9238795325112867 / 2384e-9,
        4573822e-9 * 0.9238795325112867 / 2384e-9,
        954151e-9 * 0.9238795325112867 / 2384e-9,
        76771e-9 * 0.9238795325112867 / 2384e-9,
        6199e-9 * 0.9238795325112867 / 2384e-9,
        34332e-9 * 0.9238795325112867 / 2384e-9,
        1111031e-9 * 0.9238795325112867 / 2384e-9,
        0.010933399 * 0.9238795325112867 / 2384e-9,
        -0.024725437 * 0.9238795325112867 / 2384e-9,
        -3771782e-9 * 0.9238795325112867 / 2384e-9,
        -472546e-9 * 0.9238795325112867 / 2384e-9,
        -27657e-9 * 0.9238795325112867 / 2384e-9,
        0.41421356237309503,
        1.414213562373095,
        -954e-9 * 0.941544065183021 / 2384e-9,
        105381e-9 * 0.941544065183021 / 2384e-9,
        610352e-9 * 0.941544065183021 / 2384e-9,
        -475883e-9 * 0.941544065183021 / 2384e-9,
        0.03405571 * 0.941544065183021 / 2384e-9,
        4649162e-9 * 0.941544065183021 / 2384e-9,
        935555e-9 * 0.941544065183021 / 2384e-9,
        73433e-9 * 0.941544065183021 / 2384e-9,
        5245e-9 * 0.941544065183021 / 2384e-9,
        17166e-9 * 0.941544065183021 / 2384e-9,
        956535e-9 * 0.941544065183021 / 2384e-9,
        0.010103703 * 0.941544065183021 / 2384e-9,
        -0.025527 * 0.941544065183021 / 2384e-9,
        -3914356e-9 * 0.941544065183021 / 2384e-9,
        -507355e-9 * 0.941544065183021 / 2384e-9,
        -30041e-9 * 0.941544065183021 / 2384e-9,
        0.3578057213145241,
        1.546020906725474,
        -954e-9 * 0.956940335732209 / 2384e-9,
        10252e-8 * 0.956940335732209 / 2384e-9,
        539303e-9 * 0.956940335732209 / 2384e-9,
        -1011848e-9 * 0.956940335732209 / 2384e-9,
        0.033659935 * 0.956940335732209 / 2384e-9,
        4703045e-9 * 0.956940335732209 / 2384e-9,
        915051e-9 * 0.956940335732209 / 2384e-9,
        70095e-9 * 0.956940335732209 / 2384e-9,
        4768e-9 * 0.956940335732209 / 2384e-9,
        954e-9 * 0.956940335732209 / 2384e-9,
        806808e-9 * 0.956940335732209 / 2384e-9,
        9287834e-9 * 0.956940335732209 / 2384e-9,
        -0.026310921 * 0.956940335732209 / 2384e-9,
        -4048824e-9 * 0.956940335732209 / 2384e-9,
        -542164e-9 * 0.956940335732209 / 2384e-9,
        -32425e-9 * 0.956940335732209 / 2384e-9,
        0.3033466836073424,
        1.66293922460509,
        -1431e-9 * 0.970031253194544 / 2384e-9,
        99182e-9 * 0.970031253194544 / 2384e-9,
        462532e-9 * 0.970031253194544 / 2384e-9,
        -1573563e-9 * 0.970031253194544 / 2384e-9,
        0.033225536 * 0.970031253194544 / 2384e-9,
        4737377e-9 * 0.970031253194544 / 2384e-9,
        891685e-9 * 0.970031253194544 / 2384e-9,
        6628e-8 * 0.970031253194544 / 2384e-9,
        4292e-9 * 0.970031253194544 / 2384e-9,
        -13828e-9 * 0.970031253194544 / 2384e-9,
        66185e-8 * 0.970031253194544 / 2384e-9,
        8487225e-9 * 0.970031253194544 / 2384e-9,
        -0.02707386 * 0.970031253194544 / 2384e-9,
        -4174709e-9 * 0.970031253194544 / 2384e-9,
        -576973e-9 * 0.970031253194544 / 2384e-9,
        -34809e-9 * 0.970031253194544 / 2384e-9,
        0.2504869601913055,
        1.76384252869671,
        -1431e-9 * 0.98078528040323 / 2384e-9,
        95367e-9 * 0.98078528040323 / 2384e-9,
        378609e-9 * 0.98078528040323 / 2384e-9,
        -2161503e-9 * 0.98078528040323 / 2384e-9,
        0.032754898 * 0.98078528040323 / 2384e-9,
        4752159e-9 * 0.98078528040323 / 2384e-9,
        866413e-9 * 0.98078528040323 / 2384e-9,
        62943e-9 * 0.98078528040323 / 2384e-9,
        3815e-9 * 0.98078528040323 / 2384e-9,
        -2718e-8 * 0.98078528040323 / 2384e-9,
        522137e-9 * 0.98078528040323 / 2384e-9,
        7703304e-9 * 0.98078528040323 / 2384e-9,
        -0.027815342 * 0.98078528040323 / 2384e-9,
        -4290581e-9 * 0.98078528040323 / 2384e-9,
        -611782e-9 * 0.98078528040323 / 2384e-9,
        -3767e-8 * 0.98078528040323 / 2384e-9,
        0.198912367379658,
        1.847759065022573,
        -1907e-9 * 0.989176509964781 / 2384e-9,
        90122e-9 * 0.989176509964781 / 2384e-9,
        288486e-9 * 0.989176509964781 / 2384e-9,
        -2774239e-9 * 0.989176509964781 / 2384e-9,
        0.03224802 * 0.989176509964781 / 2384e-9,
        4748821e-9 * 0.989176509964781 / 2384e-9,
        838757e-9 * 0.989176509964781 / 2384e-9,
        59605e-9 * 0.989176509964781 / 2384e-9,
        3338e-9 * 0.989176509964781 / 2384e-9,
        -39577e-9 * 0.989176509964781 / 2384e-9,
        388145e-9 * 0.989176509964781 / 2384e-9,
        6937027e-9 * 0.989176509964781 / 2384e-9,
        -0.028532982 * 0.989176509964781 / 2384e-9,
        -4395962e-9 * 0.989176509964781 / 2384e-9,
        -646591e-9 * 0.989176509964781 / 2384e-9,
        -40531e-9 * 0.989176509964781 / 2384e-9,
        0.1483359875383474,
        1.913880671464418,
        -1907e-9 * 0.995184726672197 / 2384e-9,
        844e-7 * 0.995184726672197 / 2384e-9,
        191689e-9 * 0.995184726672197 / 2384e-9,
        -3411293e-9 * 0.995184726672197 / 2384e-9,
        0.03170681 * 0.995184726672197 / 2384e-9,
        4728317e-9 * 0.995184726672197 / 2384e-9,
        809669e-9 * 0.995184726672197 / 2384e-9,
        5579e-8 * 0.995184726672197 / 2384e-9,
        3338e-9 * 0.995184726672197 / 2384e-9,
        -50545e-9 * 0.995184726672197 / 2384e-9,
        259876e-9 * 0.995184726672197 / 2384e-9,
        6189346e-9 * 0.995184726672197 / 2384e-9,
        -0.029224873 * 0.995184726672197 / 2384e-9,
        -4489899e-9 * 0.995184726672197 / 2384e-9,
        -680923e-9 * 0.995184726672197 / 2384e-9,
        -43392e-9 * 0.995184726672197 / 2384e-9,
        0.09849140335716425,
        1.961570560806461,
        -2384e-9 * 0.998795456205172 / 2384e-9,
        77724e-9 * 0.998795456205172 / 2384e-9,
        88215e-9 * 0.998795456205172 / 2384e-9,
        -4072189e-9 * 0.998795456205172 / 2384e-9,
        0.031132698 * 0.998795456205172 / 2384e-9,
        4691124e-9 * 0.998795456205172 / 2384e-9,
        779152e-9 * 0.998795456205172 / 2384e-9,
        52929e-9 * 0.998795456205172 / 2384e-9,
        2861e-9 * 0.998795456205172 / 2384e-9,
        -60558e-9 * 0.998795456205172 / 2384e-9,
        137329e-9 * 0.998795456205172 / 2384e-9,
        546217e-8 * 0.998795456205172 / 2384e-9,
        -0.02989006 * 0.998795456205172 / 2384e-9,
        -4570484e-9 * 0.998795456205172 / 2384e-9,
        -714302e-9 * 0.998795456205172 / 2384e-9,
        -46253e-9 * 0.998795456205172 / 2384e-9,
        0.04912684976946725,
        1.990369453344394,
        0.035780907 * Util.SQRT2 * 0.5 / 2384e-9,
        0.017876148 * Util.SQRT2 * 0.5 / 2384e-9,
        3134727e-9 * Util.SQRT2 * 0.5 / 2384e-9,
        2457142e-9 * Util.SQRT2 * 0.5 / 2384e-9,
        971317e-9 * Util.SQRT2 * 0.5 / 2384e-9,
        218868e-9 * Util.SQRT2 * 0.5 / 2384e-9,
        101566e-9 * Util.SQRT2 * 0.5 / 2384e-9,
        13828e-9 * Util.SQRT2 * 0.5 / 2384e-9,
        0.030526638 / 2384e-9,
        4638195e-9 / 2384e-9,
        747204e-9 / 2384e-9,
        49591e-9 / 2384e-9,
        4756451e-9 / 2384e-9,
        21458e-9 / 2384e-9,
        -69618e-9 / 2384e-9
      ];
      var NS = 12;
      var NL = 36;
      var win = [[2382191739347913e-28, 6423305872147834e-28, 9400849094049688e-28, 1122435026096556e-27, 1183840321267481e-27, 1122435026096556e-27, 940084909404969e-27, 6423305872147839e-28, 2382191739347918e-28, 5456116108943412e-27, 4878985199565852e-27, 4240448995017367e-27, 3559909094758252e-27, 2858043359288075e-27, 2156177623817898e-27, 1475637723558783e-27, 8371015190102974e-28, 2599706096327376e-28, -5456116108943412e-27, -4878985199565852e-27, -4240448995017367e-27, -3559909094758252e-27, -2858043359288076e-27, -2156177623817898e-27, -1475637723558783e-27, -8371015190102975e-28, -2599706096327376e-28, -2382191739347923e-28, -6423305872147843e-28, -9400849094049696e-28, -1122435026096556e-27, -1183840321267481e-27, -1122435026096556e-27, -9400849094049694e-28, -642330587214784e-27, -2382191739347918e-28], [2382191739347913e-28, 6423305872147834e-28, 9400849094049688e-28, 1122435026096556e-27, 1183840321267481e-27, 1122435026096556e-27, 9400849094049688e-28, 6423305872147841e-28, 2382191739347918e-28, 5456116108943413e-27, 4878985199565852e-27, 4240448995017367e-27, 3559909094758253e-27, 2858043359288075e-27, 2156177623817898e-27, 1475637723558782e-27, 8371015190102975e-28, 2599706096327376e-28, -5461314069809755e-27, -4921085770524055e-27, -4343405037091838e-27, -3732668368707687e-27, -3093523840190885e-27, -2430835727329465e-27, -1734679010007751e-27, -974825365660928e-27, -2797435120168326e-28, 0, 0, 0, 0, 0, 0, -2283748241799531e-28, -4037858874020686e-28, -2146547464825323e-28], [
        0.1316524975873958,
        0.414213562373095,
        0.7673269879789602,
        1.091308501069271,
        1.303225372841206,
        1.56968557711749,
        1.920982126971166,
        2.414213562373094,
        3.171594802363212,
        4.510708503662055,
        7.595754112725146,
        22.90376554843115,
        0.984807753012208,
        0.6427876096865394,
        0.3420201433256688,
        0.9396926207859084,
        -0.1736481776669303,
        -0.7660444431189779,
        0.8660254037844387,
        0.5,
        -0.5144957554275265,
        -0.4717319685649723,
        -0.3133774542039019,
        -0.1819131996109812,
        -0.09457419252642064,
        -0.04096558288530405,
        -0.01419856857247115,
        -0.003699974673760037,
        0.8574929257125442,
        0.8817419973177052,
        0.9496286491027329,
        0.9833145924917901,
        0.9955178160675857,
        0.9991605581781475,
        0.999899195244447,
        0.9999931550702802
      ], [0, 0, 0, 0, 0, 0, 2283748241799531e-28, 4037858874020686e-28, 2146547464825323e-28, 5461314069809755e-27, 4921085770524055e-27, 4343405037091838e-27, 3732668368707687e-27, 3093523840190885e-27, 2430835727329466e-27, 1734679010007751e-27, 974825365660928e-27, 2797435120168326e-28, -5456116108943413e-27, -4878985199565852e-27, -4240448995017367e-27, -3559909094758253e-27, -2858043359288075e-27, -2156177623817898e-27, -1475637723558782e-27, -8371015190102975e-28, -2599706096327376e-28, -2382191739347913e-28, -6423305872147834e-28, -9400849094049688e-28, -1122435026096556e-27, -1183840321267481e-27, -1122435026096556e-27, -9400849094049688e-28, -6423305872147841e-28, -2382191739347918e-28]];
      var tantab_l = win[Encoder.SHORT_TYPE];
      var cx = win[Encoder.SHORT_TYPE];
      var ca = win[Encoder.SHORT_TYPE];
      var cs = win[Encoder.SHORT_TYPE];
      var order = [0, 1, 16, 17, 8, 9, 24, 25, 4, 5, 20, 21, 12, 13, 28, 29, 2, 3, 18, 19, 10, 11, 26, 27, 6, 7, 22, 23, 14, 15, 30, 31];
      function window_subband(x1, x1Pos, a) {
        var wp = 10;
        var x2 = x1Pos + 238 - 14 - 286;
        for (var i = -15; i < 0; i++) {
          var w, s, t4;
          w = enwindow[wp + -10];
          s = x1[x2 + -224] * w;
          t4 = x1[x1Pos + 224] * w;
          w = enwindow[wp + -9];
          s += x1[x2 + -160] * w;
          t4 += x1[x1Pos + 160] * w;
          w = enwindow[wp + -8];
          s += x1[x2 + -96] * w;
          t4 += x1[x1Pos + 96] * w;
          w = enwindow[wp + -7];
          s += x1[x2 + -32] * w;
          t4 += x1[x1Pos + 32] * w;
          w = enwindow[wp + -6];
          s += x1[x2 + 32] * w;
          t4 += x1[x1Pos + -32] * w;
          w = enwindow[wp + -5];
          s += x1[x2 + 96] * w;
          t4 += x1[x1Pos + -96] * w;
          w = enwindow[wp + -4];
          s += x1[x2 + 160] * w;
          t4 += x1[x1Pos + -160] * w;
          w = enwindow[wp + -3];
          s += x1[x2 + 224] * w;
          t4 += x1[x1Pos + -224] * w;
          w = enwindow[wp + -2];
          s += x1[x1Pos + -256] * w;
          t4 -= x1[x2 + 256] * w;
          w = enwindow[wp + -1];
          s += x1[x1Pos + -192] * w;
          t4 -= x1[x2 + 192] * w;
          w = enwindow[wp + 0];
          s += x1[x1Pos + -128] * w;
          t4 -= x1[x2 + 128] * w;
          w = enwindow[wp + 1];
          s += x1[x1Pos + -64] * w;
          t4 -= x1[x2 + 64] * w;
          w = enwindow[wp + 2];
          s += x1[x1Pos + 0] * w;
          t4 -= x1[x2 + 0] * w;
          w = enwindow[wp + 3];
          s += x1[x1Pos + 64] * w;
          t4 -= x1[x2 + -64] * w;
          w = enwindow[wp + 4];
          s += x1[x1Pos + 128] * w;
          t4 -= x1[x2 + -128] * w;
          w = enwindow[wp + 5];
          s += x1[x1Pos + 192] * w;
          t4 -= x1[x2 + -192] * w;
          s *= enwindow[wp + 6];
          w = t4 - s;
          a[30 + i * 2] = t4 + s;
          a[31 + i * 2] = enwindow[wp + 7] * w;
          wp += 18;
          x1Pos--;
          x2++;
        }
        {
          var s, t4, u, v;
          t4 = x1[x1Pos + -16] * enwindow[wp + -10];
          s = x1[x1Pos + -32] * enwindow[wp + -2];
          t4 += (x1[x1Pos + -48] - x1[x1Pos + 16]) * enwindow[wp + -9];
          s += x1[x1Pos + -96] * enwindow[wp + -1];
          t4 += (x1[x1Pos + -80] + x1[x1Pos + 48]) * enwindow[wp + -8];
          s += x1[x1Pos + -160] * enwindow[wp + 0];
          t4 += (x1[x1Pos + -112] - x1[x1Pos + 80]) * enwindow[wp + -7];
          s += x1[x1Pos + -224] * enwindow[wp + 1];
          t4 += (x1[x1Pos + -144] + x1[x1Pos + 112]) * enwindow[wp + -6];
          s -= x1[x1Pos + 32] * enwindow[wp + 2];
          t4 += (x1[x1Pos + -176] - x1[x1Pos + 144]) * enwindow[wp + -5];
          s -= x1[x1Pos + 96] * enwindow[wp + 3];
          t4 += (x1[x1Pos + -208] + x1[x1Pos + 176]) * enwindow[wp + -4];
          s -= x1[x1Pos + 160] * enwindow[wp + 4];
          t4 += (x1[x1Pos + -240] - x1[x1Pos + 208]) * enwindow[wp + -3];
          s -= x1[x1Pos + 224];
          u = s - t4;
          v = s + t4;
          t4 = a[14];
          s = a[15] - t4;
          a[31] = v + t4;
          a[30] = u + s;
          a[15] = u - s;
          a[14] = v - t4;
        }
        {
          var xr;
          xr = a[28] - a[0];
          a[0] += a[28];
          a[28] = xr * enwindow[wp + -2 * 18 + 7];
          xr = a[29] - a[1];
          a[1] += a[29];
          a[29] = xr * enwindow[wp + -2 * 18 + 7];
          xr = a[26] - a[2];
          a[2] += a[26];
          a[26] = xr * enwindow[wp + -4 * 18 + 7];
          xr = a[27] - a[3];
          a[3] += a[27];
          a[27] = xr * enwindow[wp + -4 * 18 + 7];
          xr = a[24] - a[4];
          a[4] += a[24];
          a[24] = xr * enwindow[wp + -6 * 18 + 7];
          xr = a[25] - a[5];
          a[5] += a[25];
          a[25] = xr * enwindow[wp + -6 * 18 + 7];
          xr = a[22] - a[6];
          a[6] += a[22];
          a[22] = xr * Util.SQRT2;
          xr = a[23] - a[7];
          a[7] += a[23];
          a[23] = xr * Util.SQRT2 - a[7];
          a[7] -= a[6];
          a[22] -= a[7];
          a[23] -= a[22];
          xr = a[6];
          a[6] = a[31] - xr;
          a[31] = a[31] + xr;
          xr = a[7];
          a[7] = a[30] - xr;
          a[30] = a[30] + xr;
          xr = a[22];
          a[22] = a[15] - xr;
          a[15] = a[15] + xr;
          xr = a[23];
          a[23] = a[14] - xr;
          a[14] = a[14] + xr;
          xr = a[20] - a[8];
          a[8] += a[20];
          a[20] = xr * enwindow[wp + -10 * 18 + 7];
          xr = a[21] - a[9];
          a[9] += a[21];
          a[21] = xr * enwindow[wp + -10 * 18 + 7];
          xr = a[18] - a[10];
          a[10] += a[18];
          a[18] = xr * enwindow[wp + -12 * 18 + 7];
          xr = a[19] - a[11];
          a[11] += a[19];
          a[19] = xr * enwindow[wp + -12 * 18 + 7];
          xr = a[16] - a[12];
          a[12] += a[16];
          a[16] = xr * enwindow[wp + -14 * 18 + 7];
          xr = a[17] - a[13];
          a[13] += a[17];
          a[17] = xr * enwindow[wp + -14 * 18 + 7];
          xr = -a[20] + a[24];
          a[20] += a[24];
          a[24] = xr * enwindow[wp + -12 * 18 + 7];
          xr = -a[21] + a[25];
          a[21] += a[25];
          a[25] = xr * enwindow[wp + -12 * 18 + 7];
          xr = a[4] - a[8];
          a[4] += a[8];
          a[8] = xr * enwindow[wp + -12 * 18 + 7];
          xr = a[5] - a[9];
          a[5] += a[9];
          a[9] = xr * enwindow[wp + -12 * 18 + 7];
          xr = a[0] - a[12];
          a[0] += a[12];
          a[12] = xr * enwindow[wp + -4 * 18 + 7];
          xr = a[1] - a[13];
          a[1] += a[13];
          a[13] = xr * enwindow[wp + -4 * 18 + 7];
          xr = a[16] - a[28];
          a[16] += a[28];
          a[28] = xr * enwindow[wp + -4 * 18 + 7];
          xr = -a[17] + a[29];
          a[17] += a[29];
          a[29] = xr * enwindow[wp + -4 * 18 + 7];
          xr = Util.SQRT2 * (a[2] - a[10]);
          a[2] += a[10];
          a[10] = xr;
          xr = Util.SQRT2 * (a[3] - a[11]);
          a[3] += a[11];
          a[11] = xr;
          xr = Util.SQRT2 * (-a[18] + a[26]);
          a[18] += a[26];
          a[26] = xr - a[18];
          xr = Util.SQRT2 * (-a[19] + a[27]);
          a[19] += a[27];
          a[27] = xr - a[19];
          xr = a[2];
          a[19] -= a[3];
          a[3] -= xr;
          a[2] = a[31] - xr;
          a[31] += xr;
          xr = a[3];
          a[11] -= a[19];
          a[18] -= xr;
          a[3] = a[30] - xr;
          a[30] += xr;
          xr = a[18];
          a[27] -= a[11];
          a[19] -= xr;
          a[18] = a[15] - xr;
          a[15] += xr;
          xr = a[19];
          a[10] -= xr;
          a[19] = a[14] - xr;
          a[14] += xr;
          xr = a[10];
          a[11] -= xr;
          a[10] = a[23] - xr;
          a[23] += xr;
          xr = a[11];
          a[26] -= xr;
          a[11] = a[22] - xr;
          a[22] += xr;
          xr = a[26];
          a[27] -= xr;
          a[26] = a[7] - xr;
          a[7] += xr;
          xr = a[27];
          a[27] = a[6] - xr;
          a[6] += xr;
          xr = Util.SQRT2 * (a[0] - a[4]);
          a[0] += a[4];
          a[4] = xr;
          xr = Util.SQRT2 * (a[1] - a[5]);
          a[1] += a[5];
          a[5] = xr;
          xr = Util.SQRT2 * (a[16] - a[20]);
          a[16] += a[20];
          a[20] = xr;
          xr = Util.SQRT2 * (a[17] - a[21]);
          a[17] += a[21];
          a[21] = xr;
          xr = -Util.SQRT2 * (a[8] - a[12]);
          a[8] += a[12];
          a[12] = xr - a[8];
          xr = -Util.SQRT2 * (a[9] - a[13]);
          a[9] += a[13];
          a[13] = xr - a[9];
          xr = -Util.SQRT2 * (a[25] - a[29]);
          a[25] += a[29];
          a[29] = xr - a[25];
          xr = -Util.SQRT2 * (a[24] + a[28]);
          a[24] -= a[28];
          a[28] = xr - a[24];
          xr = a[24] - a[16];
          a[24] = xr;
          xr = a[20] - xr;
          a[20] = xr;
          xr = a[28] - xr;
          a[28] = xr;
          xr = a[25] - a[17];
          a[25] = xr;
          xr = a[21] - xr;
          a[21] = xr;
          xr = a[29] - xr;
          a[29] = xr;
          xr = a[17] - a[1];
          a[17] = xr;
          xr = a[9] - xr;
          a[9] = xr;
          xr = a[25] - xr;
          a[25] = xr;
          xr = a[5] - xr;
          a[5] = xr;
          xr = a[21] - xr;
          a[21] = xr;
          xr = a[13] - xr;
          a[13] = xr;
          xr = a[29] - xr;
          a[29] = xr;
          xr = a[1] - a[0];
          a[1] = xr;
          xr = a[16] - xr;
          a[16] = xr;
          xr = a[17] - xr;
          a[17] = xr;
          xr = a[8] - xr;
          a[8] = xr;
          xr = a[9] - xr;
          a[9] = xr;
          xr = a[24] - xr;
          a[24] = xr;
          xr = a[25] - xr;
          a[25] = xr;
          xr = a[4] - xr;
          a[4] = xr;
          xr = a[5] - xr;
          a[5] = xr;
          xr = a[20] - xr;
          a[20] = xr;
          xr = a[21] - xr;
          a[21] = xr;
          xr = a[12] - xr;
          a[12] = xr;
          xr = a[13] - xr;
          a[13] = xr;
          xr = a[28] - xr;
          a[28] = xr;
          xr = a[29] - xr;
          a[29] = xr;
          xr = a[0];
          a[0] += a[31];
          a[31] -= xr;
          xr = a[1];
          a[1] += a[30];
          a[30] -= xr;
          xr = a[16];
          a[16] += a[15];
          a[15] -= xr;
          xr = a[17];
          a[17] += a[14];
          a[14] -= xr;
          xr = a[8];
          a[8] += a[23];
          a[23] -= xr;
          xr = a[9];
          a[9] += a[22];
          a[22] -= xr;
          xr = a[24];
          a[24] += a[7];
          a[7] -= xr;
          xr = a[25];
          a[25] += a[6];
          a[6] -= xr;
          xr = a[4];
          a[4] += a[27];
          a[27] -= xr;
          xr = a[5];
          a[5] += a[26];
          a[26] -= xr;
          xr = a[20];
          a[20] += a[11];
          a[11] -= xr;
          xr = a[21];
          a[21] += a[10];
          a[10] -= xr;
          xr = a[12];
          a[12] += a[19];
          a[19] -= xr;
          xr = a[13];
          a[13] += a[18];
          a[18] -= xr;
          xr = a[28];
          a[28] += a[3];
          a[3] -= xr;
          xr = a[29];
          a[29] += a[2];
          a[2] -= xr;
        }
      }
      function mdct_short(inout, inoutPos) {
        for (var l = 0; l < 3; l++) {
          var tc0, tc1, tc2, ts0, ts1, ts2;
          ts0 = inout[inoutPos + 2 * 3] * win[Encoder.SHORT_TYPE][0] - inout[inoutPos + 5 * 3];
          tc0 = inout[inoutPos + 0 * 3] * win[Encoder.SHORT_TYPE][2] - inout[inoutPos + 3 * 3];
          tc1 = ts0 + tc0;
          tc2 = ts0 - tc0;
          ts0 = inout[inoutPos + 5 * 3] * win[Encoder.SHORT_TYPE][0] + inout[inoutPos + 2 * 3];
          tc0 = inout[inoutPos + 3 * 3] * win[Encoder.SHORT_TYPE][2] + inout[inoutPos + 0 * 3];
          ts1 = ts0 + tc0;
          ts2 = -ts0 + tc0;
          tc0 = (inout[inoutPos + 1 * 3] * win[Encoder.SHORT_TYPE][1] - inout[inoutPos + 4 * 3]) * 2069978111953089e-26;
          ts0 = (inout[inoutPos + 4 * 3] * win[Encoder.SHORT_TYPE][1] + inout[inoutPos + 1 * 3]) * 2069978111953089e-26;
          inout[inoutPos + 3 * 0] = tc1 * 190752519173728e-25 + tc0;
          inout[inoutPos + 3 * 5] = -ts1 * 190752519173728e-25 + ts0;
          tc2 = tc2 * 0.8660254037844387 * 1907525191737281e-26;
          ts1 = ts1 * 0.5 * 1907525191737281e-26 + ts0;
          inout[inoutPos + 3 * 1] = tc2 - ts1;
          inout[inoutPos + 3 * 2] = tc2 + ts1;
          tc1 = tc1 * 0.5 * 1907525191737281e-26 - tc0;
          ts2 = ts2 * 0.8660254037844387 * 1907525191737281e-26;
          inout[inoutPos + 3 * 3] = tc1 + ts2;
          inout[inoutPos + 3 * 4] = tc1 - ts2;
          inoutPos++;
        }
      }
      function mdct_long(out, outPos, _in) {
        var ct, st;
        {
          var tc1, tc2, tc3, tc4, ts5, ts6, ts7, ts8;
          tc1 = _in[17] - _in[9];
          tc3 = _in[15] - _in[11];
          tc4 = _in[14] - _in[12];
          ts5 = _in[0] + _in[8];
          ts6 = _in[1] + _in[7];
          ts7 = _in[2] + _in[6];
          ts8 = _in[3] + _in[5];
          out[outPos + 17] = ts5 + ts7 - ts8 - (ts6 - _in[4]);
          st = (ts5 + ts7 - ts8) * cx[12 + 7] + (ts6 - _in[4]);
          ct = (tc1 - tc3 - tc4) * cx[12 + 6];
          out[outPos + 5] = ct + st;
          out[outPos + 6] = ct - st;
          tc2 = (_in[16] - _in[10]) * cx[12 + 6];
          ts6 = ts6 * cx[12 + 7] + _in[4];
          ct = tc1 * cx[12 + 0] + tc2 + tc3 * cx[12 + 1] + tc4 * cx[12 + 2];
          st = -ts5 * cx[12 + 4] + ts6 - ts7 * cx[12 + 5] + ts8 * cx[12 + 3];
          out[outPos + 1] = ct + st;
          out[outPos + 2] = ct - st;
          ct = tc1 * cx[12 + 1] - tc2 - tc3 * cx[12 + 2] + tc4 * cx[12 + 0];
          st = -ts5 * cx[12 + 5] + ts6 - ts7 * cx[12 + 3] + ts8 * cx[12 + 4];
          out[outPos + 9] = ct + st;
          out[outPos + 10] = ct - st;
          ct = tc1 * cx[12 + 2] - tc2 + tc3 * cx[12 + 0] - tc4 * cx[12 + 1];
          st = ts5 * cx[12 + 3] - ts6 + ts7 * cx[12 + 4] - ts8 * cx[12 + 5];
          out[outPos + 13] = ct + st;
          out[outPos + 14] = ct - st;
        }
        {
          var ts1, ts2, ts3, ts4, tc5, tc6, tc7, tc8;
          ts1 = _in[8] - _in[0];
          ts3 = _in[6] - _in[2];
          ts4 = _in[5] - _in[3];
          tc5 = _in[17] + _in[9];
          tc6 = _in[16] + _in[10];
          tc7 = _in[15] + _in[11];
          tc8 = _in[14] + _in[12];
          out[outPos + 0] = tc5 + tc7 + tc8 + (tc6 + _in[13]);
          ct = (tc5 + tc7 + tc8) * cx[12 + 7] - (tc6 + _in[13]);
          st = (ts1 - ts3 + ts4) * cx[12 + 6];
          out[outPos + 11] = ct + st;
          out[outPos + 12] = ct - st;
          ts2 = (_in[7] - _in[1]) * cx[12 + 6];
          tc6 = _in[13] - tc6 * cx[12 + 7];
          ct = tc5 * cx[12 + 3] - tc6 + tc7 * cx[12 + 4] + tc8 * cx[12 + 5];
          st = ts1 * cx[12 + 2] + ts2 + ts3 * cx[12 + 0] + ts4 * cx[12 + 1];
          out[outPos + 3] = ct + st;
          out[outPos + 4] = ct - st;
          ct = -tc5 * cx[12 + 5] + tc6 - tc7 * cx[12 + 3] - tc8 * cx[12 + 4];
          st = ts1 * cx[12 + 1] + ts2 - ts3 * cx[12 + 2] - ts4 * cx[12 + 0];
          out[outPos + 7] = ct + st;
          out[outPos + 8] = ct - st;
          ct = -tc5 * cx[12 + 4] + tc6 - tc7 * cx[12 + 5] - tc8 * cx[12 + 3];
          st = ts1 * cx[12 + 0] - ts2 + ts3 * cx[12 + 1] - ts4 * cx[12 + 2];
          out[outPos + 15] = ct + st;
          out[outPos + 16] = ct - st;
        }
      }
      this.mdct_sub48 = function(gfc, w0, w1) {
        var wk = w0;
        var wkPos = 286;
        for (var ch = 0; ch < gfc.channels_out; ch++) {
          for (var gr = 0; gr < gfc.mode_gr; gr++) {
            var band;
            var gi = gfc.l3_side.tt[gr][ch];
            var mdct_enc = gi.xr;
            var mdct_encPos = 0;
            var samp = gfc.sb_sample[ch][1 - gr];
            var sampPos = 0;
            for (var k = 0; k < 18 / 2; k++) {
              window_subband(wk, wkPos, samp[sampPos]);
              window_subband(wk, wkPos + 32, samp[sampPos + 1]);
              sampPos += 2;
              wkPos += 64;
              for (band = 1; band < 32; band += 2) {
                samp[sampPos - 1][band] *= -1;
              }
            }
            for (band = 0; band < 32; band++, mdct_encPos += 18) {
              var type = gi.block_type;
              var band0 = gfc.sb_sample[ch][gr];
              var band1 = gfc.sb_sample[ch][1 - gr];
              if (gi.mixed_block_flag != 0 && band < 2)
                type = 0;
              if (gfc.amp_filter[band] < 1e-12) {
                Arrays.fill(mdct_enc, mdct_encPos + 0, mdct_encPos + 18, 0);
              } else {
                if (gfc.amp_filter[band] < 1) {
                  abort();
                }
                if (type == Encoder.SHORT_TYPE) {
                  for (var k = -NS / 4; k < 0; k++) {
                    var w = win[Encoder.SHORT_TYPE][k + 3];
                    mdct_enc[mdct_encPos + k * 3 + 9] = band0[9 + k][order[band]] * w - band0[8 - k][order[band]];
                    mdct_enc[mdct_encPos + k * 3 + 18] = band0[14 - k][order[band]] * w + band0[15 + k][order[band]];
                    mdct_enc[mdct_encPos + k * 3 + 10] = band0[15 + k][order[band]] * w - band0[14 - k][order[band]];
                    mdct_enc[mdct_encPos + k * 3 + 19] = band1[2 - k][order[band]] * w + band1[3 + k][order[band]];
                    mdct_enc[mdct_encPos + k * 3 + 11] = band1[3 + k][order[band]] * w - band1[2 - k][order[band]];
                    mdct_enc[mdct_encPos + k * 3 + 20] = band1[8 - k][order[band]] * w + band1[9 + k][order[band]];
                  }
                  mdct_short(mdct_enc, mdct_encPos);
                } else {
                  var work = new_float(18);
                  for (var k = -NL / 4; k < 0; k++) {
                    var a, b;
                    a = win[type][k + 27] * band1[k + 9][order[band]] + win[type][k + 36] * band1[8 - k][order[band]];
                    b = win[type][k + 9] * band0[k + 9][order[band]] - win[type][k + 18] * band0[8 - k][order[band]];
                    work[k + 9] = a - b * tantab_l[3 + k + 9];
                    work[k + 18] = a * tantab_l[3 + k + 9] + b;
                  }
                  mdct_long(mdct_enc, mdct_encPos, work);
                }
              }
              if (type != Encoder.SHORT_TYPE && band != 0) {
                for (var k = 7; k >= 0; --k) {
                  var bu, bd;
                  bu = mdct_enc[mdct_encPos + k] * ca[20 + k] + mdct_enc[mdct_encPos + -1 - k] * cs[28 + k];
                  bd = mdct_enc[mdct_encPos + k] * cs[28 + k] - mdct_enc[mdct_encPos + -1 - k] * ca[20 + k];
                  mdct_enc[mdct_encPos + -1 - k] = bu;
                  mdct_enc[mdct_encPos + k] = bd;
                }
              }
            }
          }
          wk = w1;
          wkPos = 286;
          if (gfc.mode_gr == 1) {
            for (var i = 0; i < 18; i++) {
              System.arraycopy(gfc.sb_sample[ch][1][i], 0, gfc.sb_sample[ch][0][i], 0, 32);
            }
          }
        }
      };
    }
    function III_psy_ratio() {
      this.thm = new III_psy_xmin();
      this.en = new III_psy_xmin();
    }
    Encoder.ENCDELAY = 576;
    Encoder.POSTDELAY = 1152;
    Encoder.MDCTDELAY = 48;
    Encoder.FFTOFFSET = 224 + Encoder.MDCTDELAY;
    Encoder.DECDELAY = 528;
    Encoder.SBLIMIT = 32;
    Encoder.CBANDS = 64;
    Encoder.SBPSY_l = 21;
    Encoder.SBPSY_s = 12;
    Encoder.SBMAX_l = 22;
    Encoder.SBMAX_s = 13;
    Encoder.PSFB21 = 6;
    Encoder.PSFB12 = 6;
    Encoder.BLKSIZE = 1024;
    Encoder.HBLKSIZE = Encoder.BLKSIZE / 2 + 1;
    Encoder.BLKSIZE_s = 256;
    Encoder.HBLKSIZE_s = Encoder.BLKSIZE_s / 2 + 1;
    Encoder.NORM_TYPE = 0;
    Encoder.START_TYPE = 1;
    Encoder.SHORT_TYPE = 2;
    Encoder.STOP_TYPE = 3;
    Encoder.MPG_MD_LR_LR = 0;
    Encoder.MPG_MD_LR_I = 1;
    Encoder.MPG_MD_MS_LR = 2;
    Encoder.MPG_MD_MS_I = 3;
    Encoder.fircoef = [-0.0207887 * 5, -0.0378413 * 5, -0.0432472 * 5, -0.031183 * 5, 779609e-23 * 5, 0.0467745 * 5, 0.10091 * 5, 0.151365 * 5, 0.187098 * 5];
    function Encoder() {
      var MPG_MD_MS_LR = Encoder.MPG_MD_MS_LR;
      var bs = null;
      this.psy = null;
      var psy = null;
      var vbr = null;
      this.setModules = function(_bs, _psy, _qupvt, _vbr) {
        bs = _bs;
        this.psy = _psy;
        psy = _psy;
        vbr = _vbr;
      };
      var newMDCT = new NewMDCT();
      function adjust_ATH(gfc) {
        var gr2_max, max_pow;
        if (gfc.ATH.useAdjust == 0) {
          gfc.ATH.adjust = 1;
          return;
        }
        max_pow = gfc.loudness_sq[0][0];
        gr2_max = gfc.loudness_sq[1][0];
        if (gfc.channels_out == 2) {
          abort();
        } else {
          max_pow += max_pow;
          gr2_max += gr2_max;
        }
        if (gfc.mode_gr == 2) {
          max_pow = Math.max(max_pow, gr2_max);
        }
        max_pow *= 0.5;
        max_pow *= gfc.ATH.aaSensitivityP;
        if (max_pow > 0.03125) {
          if (gfc.ATH.adjust >= 1) {
            gfc.ATH.adjust = 1;
          } else {
            if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
              gfc.ATH.adjust = gfc.ATH.adjustLimit;
            }
          }
          gfc.ATH.adjustLimit = 1;
        } else {
          var adj_lim_new = 31.98 * max_pow + 625e-6;
          if (gfc.ATH.adjust >= adj_lim_new) {
            gfc.ATH.adjust *= adj_lim_new * 0.075 + 0.925;
            if (gfc.ATH.adjust < adj_lim_new) {
              gfc.ATH.adjust = adj_lim_new;
            }
          } else {
            if (gfc.ATH.adjustLimit >= adj_lim_new) {
              gfc.ATH.adjust = adj_lim_new;
            } else {
              if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
                gfc.ATH.adjust = gfc.ATH.adjustLimit;
              }
            }
          }
          gfc.ATH.adjustLimit = adj_lim_new;
        }
      }
      function updateStats(gfc) {
        var gr, ch;
        gfc.bitrate_stereoMode_Hist[gfc.bitrate_index][4]++;
        gfc.bitrate_stereoMode_Hist[15][4]++;
        if (gfc.channels_out == 2) {
          abort();
        }
        for (gr = 0; gr < gfc.mode_gr; ++gr) {
          for (ch = 0; ch < gfc.channels_out; ++ch) {
            var bt = gfc.l3_side.tt[gr][ch].block_type | 0;
            if (gfc.l3_side.tt[gr][ch].mixed_block_flag != 0)
              bt = 4;
            gfc.bitrate_blockType_Hist[gfc.bitrate_index][bt]++;
            gfc.bitrate_blockType_Hist[gfc.bitrate_index][5]++;
            gfc.bitrate_blockType_Hist[15][bt]++;
            gfc.bitrate_blockType_Hist[15][5]++;
          }
        }
      }
      function lame_encode_frame_init(gfp, inbuf) {
        var gfc = gfp.internal_flags;
        var ch, gr;
        if (gfc.lame_encode_frame_init == 0) {
          var i, j;
          var primebuff0 = new_float(286 + 1152 + 576);
          var primebuff1 = new_float(286 + 1152 + 576);
          gfc.lame_encode_frame_init = 1;
          for (i = 0, j = 0; i < 286 + 576 * (1 + gfc.mode_gr); ++i) {
            if (i < 576 * gfc.mode_gr) {
              primebuff0[i] = 0;
              if (gfc.channels_out == 2)
                primebuff1[i] = 0;
            } else {
              primebuff0[i] = inbuf[0][j];
              if (gfc.channels_out == 2)
                primebuff1[i] = inbuf[1][j];
              ++j;
            }
          }
          for (gr = 0; gr < gfc.mode_gr; gr++) {
            for (ch = 0; ch < gfc.channels_out; ch++) {
              gfc.l3_side.tt[gr][ch].block_type = Encoder.SHORT_TYPE;
            }
          }
          newMDCT.mdct_sub48(gfc, primebuff0, primebuff1);
        }
      }
      this.lame_encode_mp3_frame = function(gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
        var mp3count;
        var masking_LR = new_array_n([2, 2]);
        masking_LR[0][0] = new III_psy_ratio();
        masking_LR[0][1] = new III_psy_ratio();
        masking_LR[1][0] = new III_psy_ratio();
        masking_LR[1][1] = new III_psy_ratio();
        var masking_MS = new_array_n([2, 2]);
        masking_MS[0][0] = new III_psy_ratio();
        masking_MS[0][1] = new III_psy_ratio();
        masking_MS[1][0] = new III_psy_ratio();
        masking_MS[1][1] = new III_psy_ratio();
        var masking;
        var inbuf = [null, null];
        var gfc = gfp.internal_flags;
        var tot_ener = new_float_n([2, 4]);
        var ms_ener_ratio = [0.5, 0.5];
        var pe = [[0, 0], [0, 0]];
        var pe_MS = [[0, 0], [0, 0]];
        var pe_use;
        var ch, gr;
        inbuf[0] = inbuf_l;
        inbuf[1] = inbuf_r;
        if (gfc.lame_encode_frame_init == 0) {
          lame_encode_frame_init(gfp, inbuf);
        }
        gfc.padding = 0;
        if ((gfc.slot_lag -= gfc.frac_SpF) < 0) {
          gfc.slot_lag += gfp.out_samplerate;
          gfc.padding = 1;
        }
        if (gfc.psymodel != 0) {
          var ret;
          var bufp = [null, null];
          var bufpPos = 0;
          var blocktype = new_int(2);
          for (gr = 0; gr < gfc.mode_gr; gr++) {
            for (ch = 0; ch < gfc.channels_out; ch++) {
              bufp[ch] = inbuf[ch];
              bufpPos = 576 + gr * 576 - Encoder.FFTOFFSET;
            }
            if (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
              abort();
            } else {
              ret = psy.L3psycho_anal_ns(gfp, bufp, bufpPos, gr, masking_LR, masking_MS, pe[gr], pe_MS[gr], tot_ener[gr], blocktype);
            }
            if (ret != 0)
              return -4;
            if (gfp.mode == MPEGMode.JOINT_STEREO) {
              abort();
            }
            for (ch = 0; ch < gfc.channels_out; ch++) {
              var cod_info = gfc.l3_side.tt[gr][ch];
              cod_info.block_type = blocktype[ch];
              cod_info.mixed_block_flag = 0;
            }
          }
        } else {
          abort();
        }
        adjust_ATH(gfc);
        newMDCT.mdct_sub48(gfc, inbuf[0], inbuf[1]);
        gfc.mode_ext = Encoder.MPG_MD_LR_LR;
        if (gfp.force_ms) {
          gfc.mode_ext = Encoder.MPG_MD_MS_LR;
        } else if (gfp.mode == MPEGMode.JOINT_STEREO) {
          abort();
        }
        if (gfc.mode_ext == MPG_MD_MS_LR) {
          masking = masking_MS;
          pe_use = pe_MS;
        } else {
          masking = masking_LR;
          pe_use = pe;
        }
        if (gfp.analysis && gfc.pinfo != null) {
          abort();
        }
        if (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_abr) {
          var i;
          var f;
          for (i = 0; i < 18; i++)
            gfc.nsPsy.pefirbuf[i] = gfc.nsPsy.pefirbuf[i + 1];
          f = 0;
          for (gr = 0; gr < gfc.mode_gr; gr++)
            for (ch = 0; ch < gfc.channels_out; ch++)
              f += pe_use[gr][ch];
          gfc.nsPsy.pefirbuf[18] = f;
          f = gfc.nsPsy.pefirbuf[9];
          for (i = 0; i < 9; i++)
            f += (gfc.nsPsy.pefirbuf[i] + gfc.nsPsy.pefirbuf[18 - i]) * Encoder.fircoef[i];
          f = 670 * 5 * gfc.mode_gr * gfc.channels_out / f;
          for (gr = 0; gr < gfc.mode_gr; gr++) {
            for (ch = 0; ch < gfc.channels_out; ch++) {
              pe_use[gr][ch] *= f;
            }
          }
        }
        gfc.iteration_loop.iteration_loop(gfp, pe_use, ms_ener_ratio, masking);
        bs.format_bitstream(gfp);
        mp3count = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 1);
        if (gfp.bWriteVbrTag)
          vbr.addVbrFrame(gfp);
        if (gfp.analysis && gfc.pinfo != null) {
          abort();
        }
        updateStats(gfc);
        return mp3count;
      };
    }
    function VBRSeekInfo() {
      this.sum = 0;
      this.seen = 0;
      this.want = 0;
      this.pos = 0;
      this.size = 0;
      this.bag = null;
      this.nVbrNumFrames = 0;
      this.nBytesWritten = 0;
      this.TotalFrameSize = 0;
    }
    function IIISideInfo() {
      this.tt = [[null, null], [null, null]];
      this.main_data_begin = 0;
      this.private_bits = 0;
      this.resvDrain_pre = 0;
      this.resvDrain_post = 0;
      this.scfsi = [new_int(4), new_int(4)];
      for (var gr = 0; gr < 2; gr++) {
        for (var ch = 0; ch < 2; ch++) {
          this.tt[gr][ch] = new GrInfo();
        }
      }
    }
    function III_psy_xmin() {
      this.l = new_float(Encoder.SBMAX_l);
      this.s = new_float_n([Encoder.SBMAX_s, 3]);
      var self2 = this;
      this.assign = function(iii_psy_xmin) {
        System.arraycopy(iii_psy_xmin.l, 0, self2.l, 0, Encoder.SBMAX_l);
        for (var i = 0; i < Encoder.SBMAX_s; i++) {
          for (var j = 0; j < 3; j++) {
            self2.s[i][j] = iii_psy_xmin.s[i][j];
          }
        }
      };
    }
    function NsPsy() {
      this.last_en_subshort = new_float_n([4, 9]);
      this.lastAttacks = new_int(4);
      this.pefirbuf = new_float(19);
      this.longfact = new_float(Encoder.SBMAX_l);
      this.shortfact = new_float(Encoder.SBMAX_s);
      this.attackthre = 0;
      this.attackthre_s = 0;
    }
    LameInternalFlags.MFSIZE = 3 * 1152 + Encoder.ENCDELAY - Encoder.MDCTDELAY;
    LameInternalFlags.MAX_HEADER_BUF = 256;
    LameInternalFlags.MAX_BITS_PER_CHANNEL = 4095;
    LameInternalFlags.MAX_BITS_PER_GRANULE = 7680;
    LameInternalFlags.BPC = 320;
    function LameInternalFlags() {
      var MAX_HEADER_LEN = 40;
      this.Class_ID = 0;
      this.lame_encode_frame_init = 0;
      this.iteration_init_init = 0;
      this.fill_buffer_resample_init = 0;
      this.mfbuf = new_float_n([2, LameInternalFlags.MFSIZE]);
      this.mode_gr = 0;
      this.channels_in = 0;
      this.channels_out = 0;
      this.resample_ratio = 0;
      this.mf_samples_to_encode = 0;
      this.mf_size = 0;
      this.VBR_min_bitrate = 0;
      this.VBR_max_bitrate = 0;
      this.bitrate_index = 0;
      this.samplerate_index = 0;
      this.mode_ext = 0;
      this.lowpass1 = 0;
      this.lowpass2 = 0;
      this.highpass1 = 0;
      this.highpass2 = 0;
      this.noise_shaping = 0;
      this.noise_shaping_amp = 0;
      this.substep_shaping = 0;
      this.psymodel = 0;
      this.noise_shaping_stop = 0;
      this.subblock_gain = 0;
      this.use_best_huffman = 0;
      this.full_outer_loop = 0;
      this.l3_side = new IIISideInfo();
      this.ms_ratio = new_float(2);
      this.padding = 0;
      this.frac_SpF = 0;
      this.slot_lag = 0;
      this.tag_spec = null;
      this.nMusicCRC = 0;
      this.OldValue = new_int(2);
      this.CurrentStep = new_int(2);
      this.masking_lower = 0;
      this.bv_scf = new_int(576);
      this.pseudohalf = new_int(L3Side.SFBMAX);
      this.sfb21_extra = false;
      this.inbuf_old = new Array(2);
      this.blackfilt = new Array(2 * LameInternalFlags.BPC + 1);
      this.itime = new_double(2);
      this.sideinfo_len = 0;
      this.sb_sample = new_float_n([2, 2, 18, Encoder.SBLIMIT]);
      this.amp_filter = new_float(32);
      function Header() {
        this.write_timing = 0;
        this.ptr = 0;
        this.buf = new_byte(MAX_HEADER_LEN);
      }
      this.header = new Array(LameInternalFlags.MAX_HEADER_BUF);
      this.h_ptr = 0;
      this.w_ptr = 0;
      this.ancillary_flag = 0;
      this.ResvSize = 0;
      this.ResvMax = 0;
      this.scalefac_band = new ScaleFac();
      this.minval_l = new_float(Encoder.CBANDS);
      this.minval_s = new_float(Encoder.CBANDS);
      this.nb_1 = new_float_n([4, Encoder.CBANDS]);
      this.nb_2 = new_float_n([4, Encoder.CBANDS]);
      this.nb_s1 = new_float_n([4, Encoder.CBANDS]);
      this.nb_s2 = new_float_n([4, Encoder.CBANDS]);
      this.s3_ss = null;
      this.s3_ll = null;
      this.decay = 0;
      this.thm = new Array(4);
      this.en = new Array(4);
      this.tot_ener = new_float(4);
      this.loudness_sq = new_float_n([2, 2]);
      this.loudness_sq_save = new_float(2);
      this.mld_l = new_float(Encoder.SBMAX_l);
      this.mld_s = new_float(Encoder.SBMAX_s);
      this.bm_l = new_int(Encoder.SBMAX_l);
      this.bo_l = new_int(Encoder.SBMAX_l);
      this.bm_s = new_int(Encoder.SBMAX_s);
      this.bo_s = new_int(Encoder.SBMAX_s);
      this.npart_l = 0;
      this.npart_s = 0;
      this.s3ind = new_int_n([Encoder.CBANDS, 2]);
      this.s3ind_s = new_int_n([Encoder.CBANDS, 2]);
      this.numlines_s = new_int(Encoder.CBANDS);
      this.numlines_l = new_int(Encoder.CBANDS);
      this.rnumlines_l = new_float(Encoder.CBANDS);
      this.mld_cb_l = new_float(Encoder.CBANDS);
      this.mld_cb_s = new_float(Encoder.CBANDS);
      this.numlines_s_num1 = 0;
      this.numlines_l_num1 = 0;
      this.pe = new_float(4);
      this.ms_ratio_s_old = 0;
      this.ms_ratio_l_old = 0;
      this.ms_ener_ratio_old = 0;
      this.blocktype_old = new_int(2);
      this.nsPsy = new NsPsy();
      this.VBR_seek_table = new VBRSeekInfo();
      this.ATH = null;
      this.PSY = null;
      this.nogap_total = 0;
      this.nogap_current = 0;
      this.decode_on_the_fly = true;
      this.findReplayGain = true;
      this.findPeakSample = true;
      this.PeakSample = 0;
      this.RadioGain = 0;
      this.AudiophileGain = 0;
      this.rgdata = null;
      this.noclipGainChange = 0;
      this.noclipScale = 0;
      this.bitrate_stereoMode_Hist = new_int_n([16, 4 + 1]);
      this.bitrate_blockType_Hist = new_int_n([16, 4 + 1 + 1]);
      this.pinfo = null;
      this.hip = null;
      this.in_buffer_nsamples = 0;
      this.in_buffer_0 = null;
      this.in_buffer_1 = null;
      this.iteration_loop = null;
      for (var i = 0; i < this.en.length; i++) {
        this.en[i] = new III_psy_xmin();
      }
      for (var i = 0; i < this.thm.length; i++) {
        this.thm[i] = new III_psy_xmin();
      }
      for (var i = 0; i < this.header.length; i++) {
        this.header[i] = new Header();
      }
    }
    function FFT() {
      var window2 = new_float(Encoder.BLKSIZE);
      var window_s = new_float(Encoder.BLKSIZE_s / 2);
      var costab = [0.9238795325112867, 0.3826834323650898, 0.9951847266721969, 0.0980171403295606, 0.9996988186962042, 0.02454122852291229, 0.9999811752826011, 0.006135884649154475];
      function fht(fz, fzPos, n) {
        var tri = 0;
        var k4;
        var fi;
        var gi;
        n <<= 1;
        var fn2 = fzPos + n;
        k4 = 4;
        do {
          var s1, c1;
          var i, k1, k2, k3, kx;
          kx = k4 >> 1;
          k1 = k4;
          k2 = k4 << 1;
          k3 = k2 + k1;
          k4 = k2 << 1;
          fi = fzPos;
          gi = fi + kx;
          do {
            var f0, f1, f2, f3;
            f1 = fz[fi + 0] - fz[fi + k1];
            f0 = fz[fi + 0] + fz[fi + k1];
            f3 = fz[fi + k2] - fz[fi + k3];
            f2 = fz[fi + k2] + fz[fi + k3];
            fz[fi + k2] = f0 - f2;
            fz[fi + 0] = f0 + f2;
            fz[fi + k3] = f1 - f3;
            fz[fi + k1] = f1 + f3;
            f1 = fz[gi + 0] - fz[gi + k1];
            f0 = fz[gi + 0] + fz[gi + k1];
            f3 = Util.SQRT2 * fz[gi + k3];
            f2 = Util.SQRT2 * fz[gi + k2];
            fz[gi + k2] = f0 - f2;
            fz[gi + 0] = f0 + f2;
            fz[gi + k3] = f1 - f3;
            fz[gi + k1] = f1 + f3;
            gi += k4;
            fi += k4;
          } while (fi < fn2);
          c1 = costab[tri + 0];
          s1 = costab[tri + 1];
          for (i = 1; i < kx; i++) {
            var c2, s2;
            c2 = 1 - 2 * s1 * s1;
            s2 = 2 * s1 * c1;
            fi = fzPos + i;
            gi = fzPos + k1 - i;
            do {
              var a, b, g0, f0, f1, g1, f2, g2, f3, g3;
              b = s2 * fz[fi + k1] - c2 * fz[gi + k1];
              a = c2 * fz[fi + k1] + s2 * fz[gi + k1];
              f1 = fz[fi + 0] - a;
              f0 = fz[fi + 0] + a;
              g1 = fz[gi + 0] - b;
              g0 = fz[gi + 0] + b;
              b = s2 * fz[fi + k3] - c2 * fz[gi + k3];
              a = c2 * fz[fi + k3] + s2 * fz[gi + k3];
              f3 = fz[fi + k2] - a;
              f2 = fz[fi + k2] + a;
              g3 = fz[gi + k2] - b;
              g2 = fz[gi + k2] + b;
              b = s1 * f2 - c1 * g3;
              a = c1 * f2 + s1 * g3;
              fz[fi + k2] = f0 - a;
              fz[fi + 0] = f0 + a;
              fz[gi + k3] = g1 - b;
              fz[gi + k1] = g1 + b;
              b = c1 * g2 - s1 * f3;
              a = s1 * g2 + c1 * f3;
              fz[gi + k2] = g0 - a;
              fz[gi + 0] = g0 + a;
              fz[fi + k3] = f1 - b;
              fz[fi + k1] = f1 + b;
              gi += k4;
              fi += k4;
            } while (fi < fn2);
            c2 = c1;
            c1 = c2 * costab[tri + 0] - s1 * costab[tri + 1];
            s1 = c2 * costab[tri + 1] + s1 * costab[tri + 0];
          }
          tri += 2;
        } while (k4 < n);
      }
      var rv_tbl = [0, 128, 64, 192, 32, 160, 96, 224, 16, 144, 80, 208, 48, 176, 112, 240, 8, 136, 72, 200, 40, 168, 104, 232, 24, 152, 88, 216, 56, 184, 120, 248, 4, 132, 68, 196, 36, 164, 100, 228, 20, 148, 84, 212, 52, 180, 116, 244, 12, 140, 76, 204, 44, 172, 108, 236, 28, 156, 92, 220, 60, 188, 124, 252, 2, 130, 66, 194, 34, 162, 98, 226, 18, 146, 82, 210, 50, 178, 114, 242, 10, 138, 74, 202, 42, 170, 106, 234, 26, 154, 90, 218, 58, 186, 122, 250, 6, 134, 70, 198, 38, 166, 102, 230, 22, 150, 86, 214, 54, 182, 118, 246, 14, 142, 78, 206, 46, 174, 110, 238, 30, 158, 94, 222, 62, 190, 126, 254];
      this.fft_short = function(gfc, x_real, chn, buffer, bufPos) {
        for (var b = 0; b < 3; b++) {
          var x = Encoder.BLKSIZE_s / 2;
          var k = 65535 & 576 / 3 * (b + 1);
          var j = Encoder.BLKSIZE_s / 8 - 1;
          do {
            var f0, f1, f2, f3, w;
            var i = rv_tbl[j << 2] & 255;
            f0 = window_s[i] * buffer[chn][bufPos + i + k];
            w = window_s[127 - i] * buffer[chn][bufPos + i + k + 128];
            f1 = f0 - w;
            f0 = f0 + w;
            f2 = window_s[i + 64] * buffer[chn][bufPos + i + k + 64];
            w = window_s[63 - i] * buffer[chn][bufPos + i + k + 192];
            f3 = f2 - w;
            f2 = f2 + w;
            x -= 4;
            x_real[b][x + 0] = f0 + f2;
            x_real[b][x + 2] = f0 - f2;
            x_real[b][x + 1] = f1 + f3;
            x_real[b][x + 3] = f1 - f3;
            f0 = window_s[i + 1] * buffer[chn][bufPos + i + k + 1];
            w = window_s[126 - i] * buffer[chn][bufPos + i + k + 129];
            f1 = f0 - w;
            f0 = f0 + w;
            f2 = window_s[i + 65] * buffer[chn][bufPos + i + k + 65];
            w = window_s[62 - i] * buffer[chn][bufPos + i + k + 193];
            f3 = f2 - w;
            f2 = f2 + w;
            x_real[b][x + Encoder.BLKSIZE_s / 2 + 0] = f0 + f2;
            x_real[b][x + Encoder.BLKSIZE_s / 2 + 2] = f0 - f2;
            x_real[b][x + Encoder.BLKSIZE_s / 2 + 1] = f1 + f3;
            x_real[b][x + Encoder.BLKSIZE_s / 2 + 3] = f1 - f3;
          } while (--j >= 0);
          fht(x_real[b], x, Encoder.BLKSIZE_s / 2);
        }
      };
      this.fft_long = function(gfc, y, chn, buffer, bufPos) {
        var jj = Encoder.BLKSIZE / 8 - 1;
        var x = Encoder.BLKSIZE / 2;
        do {
          var f0, f1, f2, f3, w;
          var i = rv_tbl[jj] & 255;
          f0 = window2[i] * buffer[chn][bufPos + i];
          w = window2[i + 512] * buffer[chn][bufPos + i + 512];
          f1 = f0 - w;
          f0 = f0 + w;
          f2 = window2[i + 256] * buffer[chn][bufPos + i + 256];
          w = window2[i + 768] * buffer[chn][bufPos + i + 768];
          f3 = f2 - w;
          f2 = f2 + w;
          x -= 4;
          y[x + 0] = f0 + f2;
          y[x + 2] = f0 - f2;
          y[x + 1] = f1 + f3;
          y[x + 3] = f1 - f3;
          f0 = window2[i + 1] * buffer[chn][bufPos + i + 1];
          w = window2[i + 513] * buffer[chn][bufPos + i + 513];
          f1 = f0 - w;
          f0 = f0 + w;
          f2 = window2[i + 257] * buffer[chn][bufPos + i + 257];
          w = window2[i + 769] * buffer[chn][bufPos + i + 769];
          f3 = f2 - w;
          f2 = f2 + w;
          y[x + Encoder.BLKSIZE / 2 + 0] = f0 + f2;
          y[x + Encoder.BLKSIZE / 2 + 2] = f0 - f2;
          y[x + Encoder.BLKSIZE / 2 + 1] = f1 + f3;
          y[x + Encoder.BLKSIZE / 2 + 3] = f1 - f3;
        } while (--jj >= 0);
        fht(y, x, Encoder.BLKSIZE / 2);
      };
      this.init_fft = function(gfc) {
        for (var i = 0; i < Encoder.BLKSIZE; i++)
          window2[i] = 0.42 - 0.5 * Math.cos(2 * Math.PI * (i + 0.5) / Encoder.BLKSIZE) + 0.08 * Math.cos(4 * Math.PI * (i + 0.5) / Encoder.BLKSIZE);
        for (var i = 0; i < Encoder.BLKSIZE_s / 2; i++)
          window_s[i] = 0.5 * (1 - Math.cos(2 * Math.PI * (i + 0.5) / Encoder.BLKSIZE_s));
      };
    }
    function PsyModel() {
      var fft = new FFT();
      var LOG10 = 2.302585092994046;
      var rpelev = 2;
      var rpelev2 = 16;
      var rpelev_s = 2;
      var rpelev2_s = 16;
      var DELBARK = 0.34;
      var VO_SCALE = 1 / (14752 * 14752) / (Encoder.BLKSIZE / 2);
      var temporalmask_sustain_sec = 0.01;
      var NS_PREECHO_ATT0 = 0.8;
      var NS_PREECHO_ATT1 = 0.6;
      var NS_PREECHO_ATT2 = 0.3;
      var NS_MSFIX = 3.5;
      var NSFIRLEN = 21;
      var LN_TO_LOG10 = 0.2302585093;
      function psycho_loudness_approx(energy, gfc) {
        var loudness_power = 0;
        for (var i = 0; i < Encoder.BLKSIZE / 2; ++i)
          loudness_power += energy[i] * gfc.ATH.eql_w[i];
        loudness_power *= VO_SCALE;
        return loudness_power;
      }
      function compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, wsamp_lPos, wsamp_s, wsamp_sPos, gr_out, chn, buffer, bufPos) {
        var gfc = gfp.internal_flags;
        if (chn < 2) {
          fft.fft_long(gfc, wsamp_l[wsamp_lPos], chn, buffer, bufPos);
          fft.fft_short(gfc, wsamp_s[wsamp_sPos], chn, buffer, bufPos);
        } else if (chn == 2) {
          abort();
        }
        fftenergy[0] = wsamp_l[wsamp_lPos + 0][0];
        fftenergy[0] *= fftenergy[0];
        for (var j = Encoder.BLKSIZE / 2 - 1; j >= 0; --j) {
          var re = wsamp_l[wsamp_lPos + 0][Encoder.BLKSIZE / 2 - j];
          var im = wsamp_l[wsamp_lPos + 0][Encoder.BLKSIZE / 2 + j];
          fftenergy[Encoder.BLKSIZE / 2 - j] = (re * re + im * im) * 0.5;
        }
        for (var b = 2; b >= 0; --b) {
          fftenergy_s[b][0] = wsamp_s[wsamp_sPos + 0][b][0];
          fftenergy_s[b][0] *= fftenergy_s[b][0];
          for (var j = Encoder.BLKSIZE_s / 2 - 1; j >= 0; --j) {
            var re = wsamp_s[wsamp_sPos + 0][b][Encoder.BLKSIZE_s / 2 - j];
            var im = wsamp_s[wsamp_sPos + 0][b][Encoder.BLKSIZE_s / 2 + j];
            fftenergy_s[b][Encoder.BLKSIZE_s / 2 - j] = (re * re + im * im) * 0.5;
          }
        }
        {
          var totalenergy = 0;
          for (var j = 11; j < Encoder.HBLKSIZE; j++)
            totalenergy += fftenergy[j];
          gfc.tot_ener[chn] = totalenergy;
        }
        if (gfp.analysis) {
          abort();
        }
        if (gfp.athaa_loudapprox == 2 && chn < 2) {
          gfc.loudness_sq[gr_out][chn] = gfc.loudness_sq_save[chn];
          gfc.loudness_sq_save[chn] = psycho_loudness_approx(fftenergy, gfc);
        }
      }
      var I1LIMIT = 8;
      var I2LIMIT = 23;
      var MLIMIT = 15;
      var ma_max_i1;
      var ma_max_i2;
      var ma_max_m;
      var tab = [1, 0.79433, 0.63096, 0.63096, 0.63096, 0.63096, 0.63096, 0.25119, 0.11749];
      function init_mask_add_max_values() {
        ma_max_i1 = Math.pow(10, (I1LIMIT + 1) / 16);
        ma_max_i2 = Math.pow(10, (I2LIMIT + 1) / 16);
        ma_max_m = Math.pow(10, MLIMIT / 10);
      }
      var table1 = [3.3246 * 3.3246, 3.23837 * 3.23837, 3.15437 * 3.15437, 3.00412 * 3.00412, 2.86103 * 2.86103, 2.65407 * 2.65407, 2.46209 * 2.46209, 2.284 * 2.284, 2.11879 * 2.11879, 1.96552 * 1.96552, 1.82335 * 1.82335, 1.69146 * 1.69146, 1.56911 * 1.56911, 1.46658 * 1.46658, 1.37074 * 1.37074, 1.31036 * 1.31036, 1.25264 * 1.25264, 1.20648 * 1.20648, 1.16203 * 1.16203, 1.12765 * 1.12765, 1.09428 * 1.09428, 1.0659 * 1.0659, 1.03826 * 1.03826, 1.01895 * 1.01895, 1];
      var table2 = [1.33352 * 1.33352, 1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497, 1.40548 * 1.40548, 1.3537 * 1.3537, 1.30382 * 1.30382, 1.22321 * 1.22321, 1.14758 * 1.14758, 1];
      var table3 = [2.35364 * 2.35364, 2.29259 * 2.29259, 2.23313 * 2.23313, 2.12675 * 2.12675, 2.02545 * 2.02545, 1.87894 * 1.87894, 1.74303 * 1.74303, 1.61695 * 1.61695, 1.49999 * 1.49999, 1.39148 * 1.39148, 1.29083 * 1.29083, 1.19746 * 1.19746, 1.11084 * 1.11084, 1.03826 * 1.03826];
      function mask_add(m1, m2, kk, b, gfc, shortblock) {
        var ratio;
        if (m2 > m1) {
          if (m2 < m1 * ma_max_i2)
            ratio = m2 / m1;
          else
            return m1 + m2;
        } else {
          if (m1 >= m2 * ma_max_i2)
            return m1 + m2;
          ratio = m1 / m2;
        }
        m1 += m2;
        if (b + 3 <= 3 + 3) {
          if (ratio >= ma_max_i1) {
            return m1;
          }
          var i = 0 | Util.FAST_LOG10_X(ratio, 16);
          return m1 * table2[i];
        }
        var i = 0 | Util.FAST_LOG10_X(ratio, 16);
        if (shortblock != 0) {
          m2 = gfc.ATH.cb_s[kk] * gfc.ATH.adjust;
        } else {
          m2 = gfc.ATH.cb_l[kk] * gfc.ATH.adjust;
        }
        if (m1 < ma_max_m * m2) {
          if (m1 > m2) {
            var f, r;
            f = 1;
            if (i <= 13)
              f = table3[i];
            r = Util.FAST_LOG10_X(m1 / m2, 10 / 15);
            return m1 * ((table1[i] - f) * r + f);
          }
          if (i > 13)
            return m1;
          return m1 * table3[i];
        }
        return m1 * table1[i];
      }
      function convert_partition2scalefac_s(gfc, eb, thr, chn, sblock) {
        var sb, b;
        var enn = 0;
        var thmm = 0;
        for (sb = b = 0; sb < Encoder.SBMAX_s; ++b, ++sb) {
          var bo_s_sb = gfc.bo_s[sb];
          var npart_s = gfc.npart_s;
          var b_lim = bo_s_sb < npart_s ? bo_s_sb : npart_s;
          while (b < b_lim) {
            enn += eb[b];
            thmm += thr[b];
            b++;
          }
          gfc.en[chn].s[sb][sblock] = enn;
          gfc.thm[chn].s[sb][sblock] = thmm;
          if (b >= npart_s) {
            ++sb;
            break;
          }
          {
            var w_curr = gfc.PSY.bo_s_weight[sb];
            var w_next = 1 - w_curr;
            enn = w_curr * eb[b];
            thmm = w_curr * thr[b];
            gfc.en[chn].s[sb][sblock] += enn;
            gfc.thm[chn].s[sb][sblock] += thmm;
            enn = w_next * eb[b];
            thmm = w_next * thr[b];
          }
        }
        for (; sb < Encoder.SBMAX_s; ++sb) {
          gfc.en[chn].s[sb][sblock] = 0;
          gfc.thm[chn].s[sb][sblock] = 0;
        }
      }
      function convert_partition2scalefac_l(gfc, eb, thr, chn) {
        var sb, b;
        var enn = 0;
        var thmm = 0;
        for (sb = b = 0; sb < Encoder.SBMAX_l; ++b, ++sb) {
          var bo_l_sb = gfc.bo_l[sb];
          var npart_l = gfc.npart_l;
          var b_lim = bo_l_sb < npart_l ? bo_l_sb : npart_l;
          while (b < b_lim) {
            enn += eb[b];
            thmm += thr[b];
            b++;
          }
          gfc.en[chn].l[sb] = enn;
          gfc.thm[chn].l[sb] = thmm;
          if (b >= npart_l) {
            ++sb;
            break;
          }
          {
            var w_curr = gfc.PSY.bo_l_weight[sb];
            var w_next = 1 - w_curr;
            enn = w_curr * eb[b];
            thmm = w_curr * thr[b];
            gfc.en[chn].l[sb] += enn;
            gfc.thm[chn].l[sb] += thmm;
            enn = w_next * eb[b];
            thmm = w_next * thr[b];
          }
        }
        for (; sb < Encoder.SBMAX_l; ++sb) {
          gfc.en[chn].l[sb] = 0;
          gfc.thm[chn].l[sb] = 0;
        }
      }
      function compute_masking_s(gfp, fftenergy_s, eb, thr, chn, sblock) {
        var gfc = gfp.internal_flags;
        var j, b;
        for (b = j = 0; b < gfc.npart_s; ++b) {
          var ebb = 0;
          var n = gfc.numlines_s[b];
          for (var i = 0; i < n; ++i, ++j) {
            var el = fftenergy_s[sblock][j];
            ebb += el;
          }
          eb[b] = ebb;
        }
        for (j = b = 0; b < gfc.npart_s; b++) {
          var kk = gfc.s3ind_s[b][0];
          var ecb = gfc.s3_ss[j++] * eb[kk];
          ++kk;
          while (kk <= gfc.s3ind_s[b][1]) {
            ecb += gfc.s3_ss[j] * eb[kk];
            ++j;
            ++kk;
          }
          {
            var x = rpelev_s * gfc.nb_s1[chn][b];
            thr[b] = Math.min(ecb, x);
          }
          if (gfc.blocktype_old[chn & 1] == Encoder.SHORT_TYPE) {
            var x = rpelev2_s * gfc.nb_s2[chn][b];
            var y = thr[b];
            thr[b] = Math.min(x, y);
          }
          gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
          gfc.nb_s1[chn][b] = ecb;
        }
        for (; b <= Encoder.CBANDS; ++b) {
          eb[b] = 0;
          thr[b] = 0;
        }
      }
      function block_type_set(gfp, uselongblock, blocktype_d, blocktype) {
        var gfc = gfp.internal_flags;
        if (gfp.short_blocks == ShortBlock.short_block_coupled && !(uselongblock[0] != 0 && uselongblock[1] != 0))
          uselongblock[0] = uselongblock[1] = 0;
        for (var chn = 0; chn < gfc.channels_out; chn++) {
          blocktype[chn] = Encoder.NORM_TYPE;
          if (gfp.short_blocks == ShortBlock.short_block_dispensed)
            uselongblock[chn] = 1;
          if (gfp.short_blocks == ShortBlock.short_block_forced)
            uselongblock[chn] = 0;
          if (uselongblock[chn] != 0) {
            if (gfc.blocktype_old[chn] == Encoder.SHORT_TYPE)
              blocktype[chn] = Encoder.STOP_TYPE;
          } else {
            blocktype[chn] = Encoder.SHORT_TYPE;
            if (gfc.blocktype_old[chn] == Encoder.NORM_TYPE) {
              gfc.blocktype_old[chn] = Encoder.START_TYPE;
            }
            if (gfc.blocktype_old[chn] == Encoder.STOP_TYPE)
              gfc.blocktype_old[chn] = Encoder.SHORT_TYPE;
          }
          blocktype_d[chn] = gfc.blocktype_old[chn];
          gfc.blocktype_old[chn] = blocktype[chn];
        }
      }
      function NS_INTERP(x, y, r) {
        if (r >= 1) {
          return x;
        }
        if (r <= 0)
          return y;
        if (y > 0) {
          return Math.pow(x / y, r) * y;
        }
        return 0;
      }
      var regcoef_s = [
        11.8,
        13.6,
        17.2,
        32,
        46.5,
        51.3,
        57.5,
        67.1,
        71.5,
        84.6,
        97.6,
        130
      ];
      function pecalc_s(mr, masking_lower) {
        var pe_s = 1236.28 / 4;
        for (var sb = 0; sb < Encoder.SBMAX_s - 1; sb++) {
          for (var sblock = 0; sblock < 3; sblock++) {
            var thm = mr.thm.s[sb][sblock];
            if (thm > 0) {
              var x = thm * masking_lower;
              var en = mr.en.s[sb][sblock];
              if (en > x) {
                if (en > x * 1e10) {
                  pe_s += regcoef_s[sb] * (10 * LOG10);
                } else {
                  pe_s += regcoef_s[sb] * Util.FAST_LOG10(en / x);
                }
              }
            }
          }
        }
        return pe_s;
      }
      var regcoef_l = [
        6.8,
        5.8,
        5.8,
        6.4,
        6.5,
        9.9,
        12.1,
        14.4,
        15,
        18.9,
        21.6,
        26.9,
        34.2,
        40.2,
        46.8,
        56.5,
        60.7,
        73.9,
        85.7,
        93.4,
        126.1
      ];
      function pecalc_l(mr, masking_lower) {
        var pe_l = 1124.23 / 4;
        for (var sb = 0; sb < Encoder.SBMAX_l - 1; sb++) {
          var thm = mr.thm.l[sb];
          if (thm > 0) {
            var x = thm * masking_lower;
            var en = mr.en.l[sb];
            if (en > x) {
              if (en > x * 1e10) {
                pe_l += regcoef_l[sb] * (10 * LOG10);
              } else {
                pe_l += regcoef_l[sb] * Util.FAST_LOG10(en / x);
              }
            }
          }
        }
        return pe_l;
      }
      function calc_energy(gfc, fftenergy, eb, max, avg) {
        var b, j;
        for (b = j = 0; b < gfc.npart_l; ++b) {
          var ebb = 0, m = 0;
          var i;
          for (i = 0; i < gfc.numlines_l[b]; ++i, ++j) {
            var el = fftenergy[j];
            ebb += el;
            if (m < el)
              m = el;
          }
          eb[b] = ebb;
          max[b] = m;
          avg[b] = ebb * gfc.rnumlines_l[b];
        }
      }
      function calc_mask_index_l(gfc, max, avg, mask_idx) {
        var last_tab_entry = tab.length - 1;
        var b = 0;
        var a = avg[b] + avg[b + 1];
        if (a > 0) {
          var m = max[b];
          if (m < max[b + 1])
            m = max[b + 1];
          a = 20 * (m * 2 - a) / (a * (gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1));
          var k = 0 | a;
          if (k > last_tab_entry)
            k = last_tab_entry;
          mask_idx[b] = k;
        } else {
          mask_idx[b] = 0;
        }
        for (b = 1; b < gfc.npart_l - 1; b++) {
          a = avg[b - 1] + avg[b] + avg[b + 1];
          if (a > 0) {
            var m = max[b - 1];
            if (m < max[b])
              m = max[b];
            if (m < max[b + 1])
              m = max[b + 1];
            a = 20 * (m * 3 - a) / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1));
            var k = 0 | a;
            if (k > last_tab_entry)
              k = last_tab_entry;
            mask_idx[b] = k;
          } else {
            mask_idx[b] = 0;
          }
        }
        a = avg[b - 1] + avg[b];
        if (a > 0) {
          var m = max[b - 1];
          if (m < max[b])
            m = max[b];
          a = 20 * (m * 2 - a) / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b] - 1));
          var k = 0 | a;
          if (k > last_tab_entry)
            k = last_tab_entry;
          mask_idx[b] = k;
        } else {
          mask_idx[b] = 0;
        }
      }
      var fircoef = [-865163e-23 * 2, -851586e-8 * 2, -674764e-23 * 2, 0.0209036 * 2, -336639e-22 * 2, -0.0438162 * 2, -154175e-22 * 2, 0.0931738 * 2, -552212e-22 * 2, -0.313819 * 2];
      this.L3psycho_anal_ns = function(gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, percep_entropy, percep_MS_entropy, energy, blocktype_d) {
        var gfc = gfp.internal_flags;
        var wsamp_L = new_float_n([2, Encoder.BLKSIZE]);
        var wsamp_S = new_float_n([2, 3, Encoder.BLKSIZE_s]);
        var eb_l = new_float(Encoder.CBANDS + 1);
        var eb_s = new_float(Encoder.CBANDS + 1);
        var thr = new_float(Encoder.CBANDS + 2);
        var blocktype = new_int(2), uselongblock = new_int(2);
        var numchn, chn;
        var b, i, j, k;
        var sb, sblock;
        var ns_hpfsmpl = new_float_n([2, 576]);
        var pcfact;
        var mask_idx_l = new_int(Encoder.CBANDS + 2), mask_idx_s = new_int(Encoder.CBANDS + 2);
        Arrays.fill(mask_idx_s, 0);
        numchn = gfc.channels_out;
        if (gfp.mode == MPEGMode.JOINT_STEREO)
          numchn = 4;
        if (gfp.VBR == VbrMode.vbr_off)
          pcfact = gfc.ResvMax == 0 ? 0 : gfc.ResvSize / gfc.ResvMax * 0.5;
        else if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
          pcfact = 0.6;
        } else
          pcfact = 1;
        for (chn = 0; chn < gfc.channels_out; chn++) {
          var firbuf = buffer[chn];
          var firbufPos = bufPos + 576 - 350 - NSFIRLEN + 192;
          for (i = 0; i < 576; i++) {
            var sum1, sum2;
            sum1 = firbuf[firbufPos + i + 10];
            sum2 = 0;
            for (j = 0; j < (NSFIRLEN - 1) / 2 - 1; j += 2) {
              sum1 += fircoef[j] * (firbuf[firbufPos + i + j] + firbuf[firbufPos + i + NSFIRLEN - j]);
              sum2 += fircoef[j + 1] * (firbuf[firbufPos + i + j + 1] + firbuf[firbufPos + i + NSFIRLEN - j - 1]);
            }
            ns_hpfsmpl[chn][i] = sum1 + sum2;
          }
          masking_ratio[gr_out][chn].en.assign(gfc.en[chn]);
          masking_ratio[gr_out][chn].thm.assign(gfc.thm[chn]);
          if (numchn > 2) {
            abort();
          }
        }
        for (chn = 0; chn < numchn; chn++) {
          var wsamp_l;
          var wsamp_s;
          var en_subshort = new_float(12);
          var en_short = [0, 0, 0, 0];
          var attack_intensity = new_float(12);
          var ns_uselongblock = 1;
          var attackThreshold;
          var max = new_float(Encoder.CBANDS), avg = new_float(Encoder.CBANDS);
          var ns_attacks = [0, 0, 0, 0];
          var fftenergy = new_float(Encoder.HBLKSIZE);
          var fftenergy_s = new_float_n([3, Encoder.HBLKSIZE_s]);
          for (i = 0; i < 3; i++) {
            en_subshort[i] = gfc.nsPsy.last_en_subshort[chn][i + 6];
            attack_intensity[i] = en_subshort[i] / gfc.nsPsy.last_en_subshort[chn][i + 4];
            en_short[0] += en_subshort[i];
          }
          if (chn == 2) {
            abort();
          }
          {
            var pf = ns_hpfsmpl[chn & 1];
            var pfPos = 0;
            for (i = 0; i < 9; i++) {
              var pfe = pfPos + 576 / 9;
              var p = 1;
              for (; pfPos < pfe; pfPos++)
                if (p < Math.abs(pf[pfPos]))
                  p = Math.abs(pf[pfPos]);
              gfc.nsPsy.last_en_subshort[chn][i] = en_subshort[i + 3] = p;
              en_short[1 + i / 3] += p;
              if (p > en_subshort[i + 3 - 2]) {
                p = p / en_subshort[i + 3 - 2];
              } else if (en_subshort[i + 3 - 2] > p * 10) {
                p = en_subshort[i + 3 - 2] / (p * 10);
              } else
                p = 0;
              attack_intensity[i + 3] = p;
            }
          }
          if (gfp.analysis) {
            abort();
          }
          attackThreshold = chn == 3 ? gfc.nsPsy.attackthre_s : gfc.nsPsy.attackthre;
          for (i = 0; i < 12; i++)
            if (ns_attacks[i / 3] == 0 && attack_intensity[i] > attackThreshold)
              ns_attacks[i / 3] = i % 3 + 1;
          for (i = 1; i < 4; i++) {
            var ratio;
            if (en_short[i - 1] > en_short[i]) {
              ratio = en_short[i - 1] / en_short[i];
            } else {
              ratio = en_short[i] / en_short[i - 1];
            }
            if (ratio < 1.7) {
              ns_attacks[i] = 0;
              if (i == 1)
                ns_attacks[0] = 0;
            }
          }
          if (ns_attacks[0] != 0 && gfc.nsPsy.lastAttacks[chn] != 0)
            ns_attacks[0] = 0;
          if (gfc.nsPsy.lastAttacks[chn] == 3 || ns_attacks[0] + ns_attacks[1] + ns_attacks[2] + ns_attacks[3] != 0) {
            ns_uselongblock = 0;
            if (ns_attacks[1] != 0 && ns_attacks[0] != 0)
              ns_attacks[1] = 0;
            if (ns_attacks[2] != 0 && ns_attacks[1] != 0)
              ns_attacks[2] = 0;
            if (ns_attacks[3] != 0 && ns_attacks[2] != 0)
              ns_attacks[3] = 0;
          }
          if (chn < 2) {
            uselongblock[chn] = ns_uselongblock;
          } else {
            abort();
          }
          energy[chn] = gfc.tot_ener[chn];
          wsamp_s = wsamp_S;
          wsamp_l = wsamp_L;
          compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, chn & 1, wsamp_s, chn & 1, gr_out, chn, buffer, bufPos);
          calc_energy(gfc, fftenergy, eb_l, max, avg);
          calc_mask_index_l(gfc, max, avg, mask_idx_l);
          for (sblock = 0; sblock < 3; sblock++) {
            var enn, thmm;
            compute_masking_s(gfp, fftenergy_s, eb_s, thr, chn, sblock);
            convert_partition2scalefac_s(gfc, eb_s, thr, chn, sblock);
            for (sb = 0; sb < Encoder.SBMAX_s; sb++) {
              thmm = gfc.thm[chn].s[sb][sblock];
              thmm *= NS_PREECHO_ATT0;
              if (ns_attacks[sblock] >= 2 || ns_attacks[sblock + 1] == 1) {
                var idx = sblock != 0 ? sblock - 1 : 2;
                var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm, NS_PREECHO_ATT1 * pcfact);
                thmm = Math.min(thmm, p);
              }
              if (ns_attacks[sblock] == 1) {
                var idx = sblock != 0 ? sblock - 1 : 2;
                var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm, NS_PREECHO_ATT2 * pcfact);
                thmm = Math.min(thmm, p);
              } else if (sblock != 0 && ns_attacks[sblock - 1] == 3 || sblock == 0 && gfc.nsPsy.lastAttacks[chn] == 3) {
                var idx = sblock != 2 ? sblock + 1 : 0;
                var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm, NS_PREECHO_ATT2 * pcfact);
                thmm = Math.min(thmm, p);
              }
              enn = en_subshort[sblock * 3 + 3] + en_subshort[sblock * 3 + 4] + en_subshort[sblock * 3 + 5];
              if (en_subshort[sblock * 3 + 5] * 6 < enn) {
                thmm *= 0.5;
                if (en_subshort[sblock * 3 + 4] * 6 < enn)
                  thmm *= 0.5;
              }
              gfc.thm[chn].s[sb][sblock] = thmm;
            }
          }
          gfc.nsPsy.lastAttacks[chn] = ns_attacks[2];
          k = 0;
          {
            for (b = 0; b < gfc.npart_l; b++) {
              var kk = gfc.s3ind[b][0];
              var eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
              var ecb = gfc.s3_ll[k++] * eb2;
              while (++kk <= gfc.s3ind[b][1]) {
                eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
                ecb = mask_add(ecb, gfc.s3_ll[k++] * eb2, kk, kk - b, gfc, 0);
              }
              ecb *= 0.158489319246111;
              if (gfc.blocktype_old[chn & 1] == Encoder.SHORT_TYPE)
                thr[b] = ecb;
              else
                thr[b] = NS_INTERP(Math.min(ecb, Math.min(rpelev * gfc.nb_1[chn][b], rpelev2 * gfc.nb_2[chn][b])), ecb, pcfact);
              gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
              gfc.nb_1[chn][b] = ecb;
            }
          }
          for (; b <= Encoder.CBANDS; ++b) {
            eb_l[b] = 0;
            thr[b] = 0;
          }
          convert_partition2scalefac_l(gfc, eb_l, thr, chn);
        }
        if (gfp.mode == MPEGMode.STEREO || gfp.mode == MPEGMode.JOINT_STEREO) {
          abort();
        }
        if (gfp.mode == MPEGMode.JOINT_STEREO) {
          abort();
        }
        block_type_set(gfp, uselongblock, blocktype_d, blocktype);
        for (chn = 0; chn < numchn; chn++) {
          var ppe;
          var ppePos = 0;
          var type;
          var mr;
          if (chn > 1) {
            abort();
          } else {
            ppe = percep_entropy;
            ppePos = 0;
            type = blocktype_d[chn];
            mr = masking_ratio[gr_out][chn];
          }
          if (type == Encoder.SHORT_TYPE)
            ppe[ppePos + chn] = pecalc_s(mr, gfc.masking_lower);
          else
            ppe[ppePos + chn] = pecalc_l(mr, gfc.masking_lower);
          if (gfp.analysis)
            gfc.pinfo.pe[gr_out][chn] = ppe[ppePos + chn];
        }
        return 0;
      };
      function s3_func(bark) {
        var tempx, x, tempy, temp;
        tempx = bark;
        if (tempx >= 0)
          tempx *= 3;
        else
          tempx *= 1.5;
        if (tempx >= 0.5 && tempx <= 2.5) {
          temp = tempx - 0.5;
          x = 8 * (temp * temp - 2 * temp);
        } else
          x = 0;
        tempx += 0.474;
        tempy = 15.811389 + 7.5 * tempx - 17.5 * Math.sqrt(1 + tempx * tempx);
        if (tempy <= -60)
          return 0;
        tempx = Math.exp((x + tempy) * LN_TO_LOG10);
        tempx /= 0.6609193;
        return tempx;
      }
      function freq2bark(freq) {
        if (freq < 0)
          freq = 0;
        freq = freq * 1e-3;
        return 13 * Math.atan(0.76 * freq) + 3.5 * Math.atan(freq * freq / (7.5 * 7.5));
      }
      function init_numline(numlines, bo, bm, bval, bval_width, mld, bo_w, sfreq, blksize, scalepos, deltafreq, sbmax) {
        var b_frq = new_float(Encoder.CBANDS + 1);
        var sample_freq_frac = sfreq / (sbmax > 15 ? 2 * 576 : 2 * 192);
        var partition = new_int(Encoder.HBLKSIZE);
        var i;
        sfreq /= blksize;
        var j = 0;
        var ni = 0;
        for (i = 0; i < Encoder.CBANDS; i++) {
          var bark1;
          var j2;
          bark1 = freq2bark(sfreq * j);
          b_frq[i] = sfreq * j;
          for (j2 = j; freq2bark(sfreq * j2) - bark1 < DELBARK && j2 <= blksize / 2; j2++)
            ;
          numlines[i] = j2 - j;
          ni = i + 1;
          while (j < j2) {
            partition[j++] = i;
          }
          if (j > blksize / 2) {
            j = blksize / 2;
            ++i;
            break;
          }
        }
        b_frq[i] = sfreq * j;
        for (var sfb = 0; sfb < sbmax; sfb++) {
          var i1, i2, start, end;
          var arg;
          start = scalepos[sfb];
          end = scalepos[sfb + 1];
          i1 = 0 | Math.floor(0.5 + deltafreq * (start - 0.5));
          if (i1 < 0)
            i1 = 0;
          i2 = 0 | Math.floor(0.5 + deltafreq * (end - 0.5));
          if (i2 > blksize / 2)
            i2 = blksize / 2;
          bm[sfb] = (partition[i1] + partition[i2]) / 2;
          bo[sfb] = partition[i2];
          var f_tmp = sample_freq_frac * end;
          bo_w[sfb] = (f_tmp - b_frq[bo[sfb]]) / (b_frq[bo[sfb] + 1] - b_frq[bo[sfb]]);
          if (bo_w[sfb] < 0) {
            bo_w[sfb] = 0;
          } else {
            if (bo_w[sfb] > 1) {
              bo_w[sfb] = 1;
            }
          }
          arg = freq2bark(sfreq * scalepos[sfb] * deltafreq);
          arg = Math.min(arg, 15.5) / 15.5;
          mld[sfb] = Math.pow(10, 1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
        }
        j = 0;
        for (var k = 0; k < ni; k++) {
          var w = numlines[k];
          var bark1, bark2;
          bark1 = freq2bark(sfreq * j);
          bark2 = freq2bark(sfreq * (j + w - 1));
          bval[k] = 0.5 * (bark1 + bark2);
          bark1 = freq2bark(sfreq * (j - 0.5));
          bark2 = freq2bark(sfreq * (j + w - 0.5));
          bval_width[k] = bark2 - bark1;
          j += w;
        }
        return ni;
      }
      function init_s3_values(s3ind, npart, bval, bval_width, norm, use_old_s3) {
        var s3 = new_float_n([Encoder.CBANDS, Encoder.CBANDS]);
        var j;
        var numberOfNoneZero = 0;
        if (use_old_s3) {
          for (var i = 0; i < npart; i++) {
            for (j = 0; j < npart; j++) {
              var v = s3_func(bval[i] - bval[j]) * bval_width[j];
              s3[i][j] = v * norm[i];
            }
          }
        } else {
          abort();
        }
        for (var i = 0; i < npart; i++) {
          for (j = 0; j < npart; j++) {
            if (s3[i][j] > 0)
              break;
          }
          s3ind[i][0] = j;
          for (j = npart - 1; j > 0; j--) {
            if (s3[i][j] > 0)
              break;
          }
          s3ind[i][1] = j;
          numberOfNoneZero += s3ind[i][1] - s3ind[i][0] + 1;
        }
        var p = new_float(numberOfNoneZero);
        var k = 0;
        for (var i = 0; i < npart; i++)
          for (j = s3ind[i][0]; j <= s3ind[i][1]; j++)
            p[k++] = s3[i][j];
        return p;
      }
      function stereo_demask(f) {
        var arg = freq2bark(f);
        arg = Math.min(arg, 15.5) / 15.5;
        return Math.pow(10, 1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
      }
      this.psymodel_init = function(gfp) {
        var gfc = gfp.internal_flags;
        var i;
        var useOldS3 = true;
        var bvl_a = 13, bvl_b = 24;
        var snr_l_a = 0, snr_l_b = 0;
        var snr_s_a = -8.25, snr_s_b = -4.5;
        var bval = new_float(Encoder.CBANDS);
        var bval_width = new_float(Encoder.CBANDS);
        var norm = new_float(Encoder.CBANDS);
        var sfreq = gfp.out_samplerate;
        switch (gfp.experimentalZ) {
          default:
          case 0:
            useOldS3 = true;
            break;
          case 1:
            useOldS3 = gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt ? false : true;
            break;
          case 2:
            useOldS3 = false;
            break;
          case 3:
            bvl_a = 8;
            snr_l_a = -1.75;
            snr_l_b = -0.0125;
            snr_s_a = -8.25;
            snr_s_b = -2.25;
            break;
        }
        gfc.ms_ener_ratio_old = 0.25;
        gfc.blocktype_old[0] = gfc.blocktype_old[1] = Encoder.NORM_TYPE;
        for (i = 0; i < 4; ++i) {
          for (var j = 0; j < Encoder.CBANDS; ++j) {
            gfc.nb_1[i][j] = 1e20;
            gfc.nb_2[i][j] = 1e20;
            gfc.nb_s1[i][j] = gfc.nb_s2[i][j] = 1;
          }
          for (var sb = 0; sb < Encoder.SBMAX_l; sb++) {
            gfc.en[i].l[sb] = 1e20;
            gfc.thm[i].l[sb] = 1e20;
          }
          for (var j = 0; j < 3; ++j) {
            for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
              gfc.en[i].s[sb][j] = 1e20;
              gfc.thm[i].s[sb][j] = 1e20;
            }
            gfc.nsPsy.lastAttacks[i] = 0;
          }
          for (var j = 0; j < 9; j++)
            gfc.nsPsy.last_en_subshort[i][j] = 10;
        }
        gfc.loudness_sq_save[0] = gfc.loudness_sq_save[1] = 0;
        gfc.npart_l = init_numline(gfc.numlines_l, gfc.bo_l, gfc.bm_l, bval, bval_width, gfc.mld_l, gfc.PSY.bo_l_weight, sfreq, Encoder.BLKSIZE, gfc.scalefac_band.l, Encoder.BLKSIZE / (2 * 576), Encoder.SBMAX_l);
        for (i = 0; i < gfc.npart_l; i++) {
          var snr = snr_l_a;
          if (bval[i] >= bvl_a) {
            snr = snr_l_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_l_a * (bvl_b - bval[i]) / (bvl_b - bvl_a);
          }
          norm[i] = Math.pow(10, snr / 10);
          if (gfc.numlines_l[i] > 0) {
            gfc.rnumlines_l[i] = 1 / gfc.numlines_l[i];
          } else {
            gfc.rnumlines_l[i] = 0;
          }
        }
        gfc.s3_ll = init_s3_values(gfc.s3ind, gfc.npart_l, bval, bval_width, norm, useOldS3);
        var j = 0;
        for (i = 0; i < gfc.npart_l; i++) {
          var x;
          x = Float.MAX_VALUE;
          for (var k = 0; k < gfc.numlines_l[i]; k++, j++) {
            var freq = sfreq * j / (1e3 * Encoder.BLKSIZE);
            var level;
            level = this.ATHformula(freq * 1e3, gfp) - 20;
            level = Math.pow(10, 0.1 * level);
            level *= gfc.numlines_l[i];
            if (x > level)
              x = level;
          }
          gfc.ATH.cb_l[i] = x;
          x = -20 + bval[i] * 20 / 10;
          if (x > 6) {
            x = 100;
          }
          if (x < -15) {
            x = -15;
          }
          x -= 8;
          gfc.minval_l[i] = Math.pow(10, x / 10) * gfc.numlines_l[i];
        }
        gfc.npart_s = init_numline(gfc.numlines_s, gfc.bo_s, gfc.bm_s, bval, bval_width, gfc.mld_s, gfc.PSY.bo_s_weight, sfreq, Encoder.BLKSIZE_s, gfc.scalefac_band.s, Encoder.BLKSIZE_s / (2 * 192), Encoder.SBMAX_s);
        j = 0;
        for (i = 0; i < gfc.npart_s; i++) {
          var x;
          var snr = snr_s_a;
          if (bval[i] >= bvl_a) {
            snr = snr_s_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_s_a * (bvl_b - bval[i]) / (bvl_b - bvl_a);
          }
          norm[i] = Math.pow(10, snr / 10);
          x = Float.MAX_VALUE;
          for (var k = 0; k < gfc.numlines_s[i]; k++, j++) {
            var freq = sfreq * j / (1e3 * Encoder.BLKSIZE_s);
            var level;
            level = this.ATHformula(freq * 1e3, gfp) - 20;
            level = Math.pow(10, 0.1 * level);
            level *= gfc.numlines_s[i];
            if (x > level)
              x = level;
          }
          gfc.ATH.cb_s[i] = x;
          x = -7 + bval[i] * 7 / 12;
          if (bval[i] > 12) {
            x *= 1 + Math.log(1 + x) * 3.1;
          }
          if (bval[i] < 12) {
            x *= 1 + Math.log(1 - x) * 2.3;
          }
          if (x < -15) {
            x = -15;
          }
          x -= 8;
          gfc.minval_s[i] = Math.pow(10, x / 10) * gfc.numlines_s[i];
        }
        gfc.s3_ss = init_s3_values(gfc.s3ind_s, gfc.npart_s, bval, bval_width, norm, useOldS3);
        init_mask_add_max_values();
        fft.init_fft(gfc);
        gfc.decay = Math.exp(-1 * LOG10 / (temporalmask_sustain_sec * sfreq / 192));
        {
          var msfix;
          msfix = NS_MSFIX;
          if ((gfp.exp_nspsytune & 2) != 0)
            msfix = 1;
          if (Math.abs(gfp.msfix) > 0)
            msfix = gfp.msfix;
          gfp.msfix = msfix;
          for (var b = 0; b < gfc.npart_l; b++)
            if (gfc.s3ind[b][1] > gfc.npart_l - 1)
              gfc.s3ind[b][1] = gfc.npart_l - 1;
        }
        var frame_duration = 576 * gfc.mode_gr / sfreq;
        gfc.ATH.decay = Math.pow(10, -12 / 10 * frame_duration);
        gfc.ATH.adjust = 0.01;
        gfc.ATH.adjustLimit = 1;
        if (gfp.ATHtype != -1) {
          var freq;
          var freq_inc = gfp.out_samplerate / Encoder.BLKSIZE;
          var eql_balance = 0;
          freq = 0;
          for (i = 0; i < Encoder.BLKSIZE / 2; ++i) {
            freq += freq_inc;
            gfc.ATH.eql_w[i] = 1 / Math.pow(10, this.ATHformula(freq, gfp) / 10);
            eql_balance += gfc.ATH.eql_w[i];
          }
          eql_balance = 1 / eql_balance;
          for (i = Encoder.BLKSIZE / 2; --i >= 0; ) {
            gfc.ATH.eql_w[i] *= eql_balance;
          }
        }
        {
          for (var b = j = 0; b < gfc.npart_s; ++b) {
            for (i = 0; i < gfc.numlines_s[b]; ++i) {
              ++j;
            }
          }
          for (var b = j = 0; b < gfc.npart_l; ++b) {
            for (i = 0; i < gfc.numlines_l[b]; ++i) {
              ++j;
            }
          }
        }
        j = 0;
        for (i = 0; i < gfc.npart_l; i++) {
          var freq = sfreq * (j + gfc.numlines_l[i] / 2) / (1 * Encoder.BLKSIZE);
          gfc.mld_cb_l[i] = stereo_demask(freq);
          j += gfc.numlines_l[i];
        }
        for (; i < Encoder.CBANDS; ++i) {
          gfc.mld_cb_l[i] = 1;
        }
        j = 0;
        for (i = 0; i < gfc.npart_s; i++) {
          var freq = sfreq * (j + gfc.numlines_s[i] / 2) / (1 * Encoder.BLKSIZE_s);
          gfc.mld_cb_s[i] = stereo_demask(freq);
          j += gfc.numlines_s[i];
        }
        for (; i < Encoder.CBANDS; ++i) {
          gfc.mld_cb_s[i] = 1;
        }
        return 0;
      };
      function ATHformula_GB(f, value9) {
        if (f < -0.3)
          f = 3410;
        f /= 1e3;
        f = Math.max(0.1, f);
        var ath = 3.64 * Math.pow(f, -0.8) - 6.8 * Math.exp(-0.6 * Math.pow(f - 3.4, 2)) + 6 * Math.exp(-0.15 * Math.pow(f - 8.7, 2)) + (0.6 + 0.04 * value9) * 1e-3 * Math.pow(f, 4);
        return ath;
      }
      this.ATHformula = function(f, gfp) {
        var ath;
        switch (gfp.ATHtype) {
          case 0:
            ath = ATHformula_GB(f, 9);
            break;
          case 1:
            ath = ATHformula_GB(f, -1);
            break;
          case 2:
            ath = ATHformula_GB(f, 0);
            break;
          case 3:
            ath = ATHformula_GB(f, 1) + 6;
            break;
          case 4:
            ath = ATHformula_GB(f, gfp.ATHcurve);
            break;
          default:
            ath = ATHformula_GB(f, 0);
            break;
        }
        return ath;
      };
    }
    function Lame() {
      var self2 = this;
      var LAME_MAXALBUMART = 128 * 1024;
      Lame.V9 = 410;
      Lame.V8 = 420;
      Lame.V7 = 430;
      Lame.V6 = 440;
      Lame.V5 = 450;
      Lame.V4 = 460;
      Lame.V3 = 470;
      Lame.V2 = 480;
      Lame.V1 = 490;
      Lame.V0 = 500;
      Lame.R3MIX = 1e3;
      Lame.STANDARD = 1001;
      Lame.EXTREME = 1002;
      Lame.INSANE = 1003;
      Lame.STANDARD_FAST = 1004;
      Lame.EXTREME_FAST = 1005;
      Lame.MEDIUM = 1006;
      Lame.MEDIUM_FAST = 1007;
      var LAME_MAXMP3BUFFER = 16384 + LAME_MAXALBUMART;
      Lame.LAME_MAXMP3BUFFER = LAME_MAXMP3BUFFER;
      var ga;
      var bs;
      var p;
      var qupvt;
      var qu;
      var psy = new PsyModel();
      var vbr;
      var id3;
      this.enc = new Encoder();
      this.setModules = function(_ga, _bs, _p, _qupvt, _qu, _vbr, _ver, _id3, _mpglib) {
        ga = _ga;
        bs = _bs;
        p = _p;
        qupvt = _qupvt;
        qu = _qu;
        vbr = _vbr;
        id3 = _id3;
        this.enc.setModules(bs, psy, qupvt, vbr);
      };
      function PSY() {
        this.mask_adjust = 0;
        this.mask_adjust_short = 0;
        this.bo_l_weight = new_float(Encoder.SBMAX_l);
        this.bo_s_weight = new_float(Encoder.SBMAX_s);
      }
      function LowPassHighPass() {
        this.lowerlimit = 0;
      }
      function BandPass(bitrate, lPass) {
        this.lowpass = lPass;
      }
      var LAME_ID = 4294479419;
      function lame_init_old(gfp) {
        var gfc;
        gfp.class_id = LAME_ID;
        gfc = gfp.internal_flags = new LameInternalFlags();
        gfp.mode = MPEGMode.NOT_SET;
        gfp.original = 1;
        gfp.in_samplerate = 44100;
        gfp.num_channels = 2;
        gfp.num_samples = -1;
        gfp.bWriteVbrTag = true;
        gfp.quality = -1;
        gfp.short_blocks = null;
        gfc.subblock_gain = -1;
        gfp.lowpassfreq = 0;
        gfp.highpassfreq = 0;
        gfp.lowpasswidth = -1;
        gfp.highpasswidth = -1;
        gfp.VBR = VbrMode.vbr_off;
        gfp.VBR_q = 4;
        gfp.ATHcurve = -1;
        gfp.VBR_mean_bitrate_kbps = 128;
        gfp.VBR_min_bitrate_kbps = 0;
        gfp.VBR_max_bitrate_kbps = 0;
        gfp.VBR_hard_min = 0;
        gfc.VBR_min_bitrate = 1;
        gfc.VBR_max_bitrate = 13;
        gfp.quant_comp = -1;
        gfp.quant_comp_short = -1;
        gfp.msfix = -1;
        gfc.resample_ratio = 1;
        gfc.OldValue[0] = 180;
        gfc.OldValue[1] = 180;
        gfc.CurrentStep[0] = 4;
        gfc.CurrentStep[1] = 4;
        gfc.masking_lower = 1;
        gfc.nsPsy.attackthre = -1;
        gfc.nsPsy.attackthre_s = -1;
        gfp.scale = -1;
        gfp.athaa_type = -1;
        gfp.ATHtype = -1;
        gfp.athaa_loudapprox = -1;
        gfp.athaa_sensitivity = 0;
        gfp.useTemporal = null;
        gfp.interChRatio = -1;
        gfc.mf_samples_to_encode = Encoder.ENCDELAY + Encoder.POSTDELAY;
        gfp.encoder_padding = 0;
        gfc.mf_size = Encoder.ENCDELAY - Encoder.MDCTDELAY;
        gfp.findReplayGain = false;
        gfp.decode_on_the_fly = false;
        gfc.decode_on_the_fly = false;
        gfc.findReplayGain = false;
        gfc.findPeakSample = false;
        gfc.RadioGain = 0;
        gfc.AudiophileGain = 0;
        gfc.noclipGainChange = 0;
        gfc.noclipScale = -1;
        gfp.preset = 0;
        gfp.write_id3tag_automatic = true;
        return 0;
      }
      this.lame_init = function() {
        var gfp = new LameGlobalFlags();
        lame_init_old(gfp);
        gfp.lame_allocated_gfp = 1;
        return gfp;
      };
      function filter_coef(x) {
        if (x > 1)
          return 0;
        if (x <= 0)
          return 1;
        return Math.cos(Math.PI / 2 * x);
      }
      this.nearestBitrateFullIndex = function(bitrate) {
        var full_bitrate_table = [8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320];
        var lower_range = 0, lower_range_kbps = 0, upper_range = 0, upper_range_kbps = 0;
        upper_range_kbps = full_bitrate_table[16];
        upper_range = 16;
        lower_range_kbps = full_bitrate_table[16];
        lower_range = 16;
        for (var b = 0; b < 16; b++) {
          if (Math.max(bitrate, full_bitrate_table[b + 1]) != bitrate) {
            upper_range_kbps = full_bitrate_table[b + 1];
            upper_range = b + 1;
            lower_range_kbps = full_bitrate_table[b];
            lower_range = b;
            break;
          }
        }
        if (upper_range_kbps - bitrate > bitrate - lower_range_kbps) {
          return lower_range;
        }
        return upper_range;
      };
      function SmpFrqIndex(sample_freq, gpf) {
        switch (sample_freq) {
          case 44100:
            gpf.version = 1;
            return 0;
          case 48e3:
            gpf.version = 1;
            return 1;
          case 32e3:
            gpf.version = 1;
            return 2;
          case 22050:
            gpf.version = 0;
            return 0;
          case 24e3:
            gpf.version = 0;
            return 1;
          case 16e3:
            gpf.version = 0;
            return 2;
          case 11025:
            gpf.version = 0;
            return 0;
          case 12e3:
            gpf.version = 0;
            return 1;
          case 8e3:
            gpf.version = 0;
            return 2;
          default:
            gpf.version = 0;
            return -1;
        }
      }
      function FindNearestBitrate(bRate, version2, samplerate) {
        if (samplerate < 16e3)
          version2 = 2;
        var bitrate = Tables.bitrate_table[version2][1];
        for (var i = 2; i <= 14; i++) {
          if (Tables.bitrate_table[version2][i] > 0) {
            if (Math.abs(Tables.bitrate_table[version2][i] - bRate) < Math.abs(bitrate - bRate))
              bitrate = Tables.bitrate_table[version2][i];
          }
        }
        return bitrate;
      }
      function BitrateIndex(bRate, version2, samplerate) {
        if (samplerate < 16e3)
          version2 = 2;
        for (var i = 0; i <= 14; i++) {
          if (Tables.bitrate_table[version2][i] > 0) {
            if (Tables.bitrate_table[version2][i] == bRate) {
              return i;
            }
          }
        }
        return -1;
      }
      function optimum_bandwidth(lh, bitrate) {
        var freq_map = [new BandPass(8, 2e3), new BandPass(16, 3700), new BandPass(24, 3900), new BandPass(32, 5500), new BandPass(40, 7e3), new BandPass(48, 7500), new BandPass(56, 1e4), new BandPass(64, 11e3), new BandPass(80, 13500), new BandPass(96, 15100), new BandPass(112, 15600), new BandPass(128, 17e3), new BandPass(160, 17500), new BandPass(192, 18600), new BandPass(224, 19400), new BandPass(256, 19700), new BandPass(320, 20500)];
        var table_index = self2.nearestBitrateFullIndex(bitrate);
        lh.lowerlimit = freq_map[table_index].lowpass;
      }
      function lame_init_params_ppflt(gfp) {
        var gfc = gfp.internal_flags;
        var lowpass_band = 32;
        if (gfc.lowpass1 > 0) {
          var minband = 999;
          for (var band = 0; band <= 31; band++) {
            var freq = band / 31;
            if (freq >= gfc.lowpass2) {
              lowpass_band = Math.min(lowpass_band, band);
            }
            if (gfc.lowpass1 < freq && freq < gfc.lowpass2) {
              minband = Math.min(minband, band);
            }
          }
          if (minband == 999) {
            gfc.lowpass1 = (lowpass_band - 0.75) / 31;
          } else {
            gfc.lowpass1 = (minband - 0.75) / 31;
          }
          gfc.lowpass2 = lowpass_band / 31;
        }
        if (gfc.highpass2 > 0) {
          abort();
        }
        if (gfc.highpass2 > 0) {
          abort();
        }
        for (var band = 0; band < 32; band++) {
          var fc1, fc2;
          var freq = band / 31;
          if (gfc.highpass2 > gfc.highpass1) {
            abort();
          } else {
            fc1 = 1;
          }
          if (gfc.lowpass2 > gfc.lowpass1) {
            fc2 = filter_coef((freq - gfc.lowpass1) / (gfc.lowpass2 - gfc.lowpass1 + 1e-20));
          } else {
            fc2 = 1;
          }
          gfc.amp_filter[band] = fc1 * fc2;
        }
      }
      function lame_init_qval(gfp) {
        var gfc = gfp.internal_flags;
        switch (gfp.quality) {
          default:
          case 9:
            gfc.psymodel = 0;
            gfc.noise_shaping = 0;
            gfc.noise_shaping_amp = 0;
            gfc.noise_shaping_stop = 0;
            gfc.use_best_huffman = 0;
            gfc.full_outer_loop = 0;
            break;
          case 8:
            gfp.quality = 7;
          case 7:
            gfc.psymodel = 1;
            gfc.noise_shaping = 0;
            gfc.noise_shaping_amp = 0;
            gfc.noise_shaping_stop = 0;
            gfc.use_best_huffman = 0;
            gfc.full_outer_loop = 0;
            break;
          case 6:
            gfc.psymodel = 1;
            if (gfc.noise_shaping == 0)
              gfc.noise_shaping = 1;
            gfc.noise_shaping_amp = 0;
            gfc.noise_shaping_stop = 0;
            if (gfc.subblock_gain == -1)
              gfc.subblock_gain = 1;
            gfc.use_best_huffman = 0;
            gfc.full_outer_loop = 0;
            break;
          case 5:
            gfc.psymodel = 1;
            if (gfc.noise_shaping == 0)
              gfc.noise_shaping = 1;
            gfc.noise_shaping_amp = 0;
            gfc.noise_shaping_stop = 0;
            if (gfc.subblock_gain == -1)
              gfc.subblock_gain = 1;
            gfc.use_best_huffman = 0;
            gfc.full_outer_loop = 0;
            break;
          case 4:
            gfc.psymodel = 1;
            if (gfc.noise_shaping == 0)
              gfc.noise_shaping = 1;
            gfc.noise_shaping_amp = 0;
            gfc.noise_shaping_stop = 0;
            if (gfc.subblock_gain == -1)
              gfc.subblock_gain = 1;
            gfc.use_best_huffman = 1;
            gfc.full_outer_loop = 0;
            break;
          case 3:
            gfc.psymodel = 1;
            if (gfc.noise_shaping == 0)
              gfc.noise_shaping = 1;
            gfc.noise_shaping_amp = 1;
            gfc.noise_shaping_stop = 1;
            if (gfc.subblock_gain == -1)
              gfc.subblock_gain = 1;
            gfc.use_best_huffman = 1;
            gfc.full_outer_loop = 0;
            break;
          case 2:
            gfc.psymodel = 1;
            if (gfc.noise_shaping == 0)
              gfc.noise_shaping = 1;
            if (gfc.substep_shaping == 0)
              gfc.substep_shaping = 2;
            gfc.noise_shaping_amp = 1;
            gfc.noise_shaping_stop = 1;
            if (gfc.subblock_gain == -1)
              gfc.subblock_gain = 1;
            gfc.use_best_huffman = 1;
            gfc.full_outer_loop = 0;
            break;
          case 1:
            gfc.psymodel = 1;
            if (gfc.noise_shaping == 0)
              gfc.noise_shaping = 1;
            if (gfc.substep_shaping == 0)
              gfc.substep_shaping = 2;
            gfc.noise_shaping_amp = 2;
            gfc.noise_shaping_stop = 1;
            if (gfc.subblock_gain == -1)
              gfc.subblock_gain = 1;
            gfc.use_best_huffman = 1;
            gfc.full_outer_loop = 0;
            break;
          case 0:
            gfc.psymodel = 1;
            if (gfc.noise_shaping == 0)
              gfc.noise_shaping = 1;
            if (gfc.substep_shaping == 0)
              gfc.substep_shaping = 2;
            gfc.noise_shaping_amp = 2;
            gfc.noise_shaping_stop = 1;
            if (gfc.subblock_gain == -1)
              gfc.subblock_gain = 1;
            gfc.use_best_huffman = 1;
            gfc.full_outer_loop = 0;
            break;
        }
      }
      function lame_init_bitstream(gfp) {
        var gfc = gfp.internal_flags;
        gfp.frameNum = 0;
        if (gfp.write_id3tag_automatic) {
          id3.id3tag_write_v2(gfp);
        }
        gfc.bitrate_stereoMode_Hist = new_int_n([16, 4 + 1]);
        gfc.bitrate_blockType_Hist = new_int_n([16, 4 + 1 + 1]);
        gfc.PeakSample = 0;
        if (gfp.bWriteVbrTag)
          vbr.InitVbrTag(gfp);
      }
      this.lame_init_params = function(gfp) {
        var gfc = gfp.internal_flags;
        gfc.Class_ID = 0;
        if (gfc.ATH == null)
          gfc.ATH = new ATH();
        if (gfc.PSY == null)
          gfc.PSY = new PSY();
        if (gfc.rgdata == null)
          gfc.rgdata = new ReplayGain();
        gfc.channels_in = gfp.num_channels;
        if (gfc.channels_in == 1)
          gfp.mode = MPEGMode.MONO;
        gfc.channels_out = gfp.mode == MPEGMode.MONO ? 1 : 2;
        gfc.mode_ext = Encoder.MPG_MD_MS_LR;
        if (gfp.mode == MPEGMode.MONO)
          gfp.force_ms = false;
        if (gfp.VBR == VbrMode.vbr_off && gfp.VBR_mean_bitrate_kbps != 128 && gfp.brate == 0)
          gfp.brate = gfp.VBR_mean_bitrate_kbps;
        if (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt)
          ;
        else {
          gfp.free_format = false;
        }
        if (gfp.VBR == VbrMode.vbr_off && gfp.brate == 0) {
          abort();
        }
        if (gfp.VBR == VbrMode.vbr_off && gfp.compression_ratio > 0) {
          abort();
        }
        if (gfp.out_samplerate != 0) {
          if (gfp.out_samplerate < 16e3) {
            gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 8);
            gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 64);
          } else if (gfp.out_samplerate < 32e3) {
            gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 8);
            gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 160);
          } else {
            gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 32);
            gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 320);
          }
        }
        if (gfp.lowpassfreq == 0) {
          var lowpass = 16e3;
          switch (gfp.VBR) {
            case VbrMode.vbr_off: {
              var lh = new LowPassHighPass();
              optimum_bandwidth(lh, gfp.brate);
              lowpass = lh.lowerlimit;
              break;
            }
            case VbrMode.vbr_abr: {
              var lh = new LowPassHighPass();
              optimum_bandwidth(lh, gfp.VBR_mean_bitrate_kbps);
              lowpass = lh.lowerlimit;
              break;
            }
            case VbrMode.vbr_rh: {
              abort();
            }
            default: {
              abort();
            }
          }
          if (gfp.mode == MPEGMode.MONO && (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_abr))
            lowpass *= 1.5;
          gfp.lowpassfreq = lowpass | 0;
        }
        if (gfp.out_samplerate == 0) {
          abort();
        }
        gfp.lowpassfreq = Math.min(20500, gfp.lowpassfreq);
        gfp.lowpassfreq = Math.min(gfp.out_samplerate / 2, gfp.lowpassfreq);
        if (gfp.VBR == VbrMode.vbr_off) {
          gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out / (1e3 * gfp.brate);
        }
        if (gfp.VBR == VbrMode.vbr_abr) {
          abort();
        }
        if (!gfp.bWriteVbrTag) {
          gfp.findReplayGain = false;
          gfp.decode_on_the_fly = false;
          gfc.findPeakSample = false;
        }
        gfc.findReplayGain = gfp.findReplayGain;
        gfc.decode_on_the_fly = gfp.decode_on_the_fly;
        if (gfc.decode_on_the_fly)
          gfc.findPeakSample = true;
        if (gfc.findReplayGain) {
          abort();
        }
        if (gfc.decode_on_the_fly && !gfp.decode_only) {
          abort();
        }
        gfc.mode_gr = gfp.out_samplerate <= 24e3 ? 1 : 2;
        gfp.framesize = 576 * gfc.mode_gr;
        gfp.encoder_delay = Encoder.ENCDELAY;
        gfc.resample_ratio = gfp.in_samplerate / gfp.out_samplerate;
        switch (gfp.VBR) {
          case VbrMode.vbr_mt:
          case VbrMode.vbr_rh:
          case VbrMode.vbr_mtrh:
            {
              var cmp = [5.7, 6.5, 7.3, 8.2, 10, 11.9, 13, 14, 15, 16.5];
              gfp.compression_ratio = cmp[gfp.VBR_q];
            }
            break;
          case VbrMode.vbr_abr:
            gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out / (1e3 * gfp.VBR_mean_bitrate_kbps);
            break;
          default:
            gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out / (1e3 * gfp.brate);
            break;
        }
        if (gfp.mode == MPEGMode.NOT_SET) {
          gfp.mode = MPEGMode.JOINT_STEREO;
        }
        if (gfp.highpassfreq > 0) {
          abort();
        } else {
          gfc.highpass1 = 0;
          gfc.highpass2 = 0;
        }
        if (gfp.lowpassfreq > 0) {
          gfc.lowpass2 = 2 * gfp.lowpassfreq;
          if (gfp.lowpasswidth >= 0) {
            abort();
          } else {
            gfc.lowpass1 = (1 - 0) * 2 * gfp.lowpassfreq;
          }
          gfc.lowpass1 /= gfp.out_samplerate;
          gfc.lowpass2 /= gfp.out_samplerate;
        } else {
          abort();
        }
        lame_init_params_ppflt(gfp);
        gfc.samplerate_index = SmpFrqIndex(gfp.out_samplerate, gfp);
        if (gfc.samplerate_index < 0) {
          abort();
        }
        if (gfp.VBR == VbrMode.vbr_off) {
          if (gfp.free_format) {
            gfc.bitrate_index = 0;
          } else {
            gfp.brate = FindNearestBitrate(gfp.brate, gfp.version, gfp.out_samplerate);
            gfc.bitrate_index = BitrateIndex(gfp.brate, gfp.version, gfp.out_samplerate);
            if (gfc.bitrate_index <= 0) {
              abort();
            }
          }
        } else {
          gfc.bitrate_index = 1;
        }
        if (gfp.analysis)
          gfp.bWriteVbrTag = false;
        if (gfc.pinfo != null)
          gfp.bWriteVbrTag = false;
        bs.init_bit_stream_w(gfc);
        var j = gfc.samplerate_index + 3 * gfp.version + 6 * (gfp.out_samplerate < 16e3 ? 1 : 0);
        for (var i = 0; i < Encoder.SBMAX_l + 1; i++)
          gfc.scalefac_band.l[i] = qupvt.sfBandIndex[j].l[i];
        for (var i = 0; i < Encoder.PSFB21 + 1; i++) {
          var size2 = (gfc.scalefac_band.l[22] - gfc.scalefac_band.l[21]) / Encoder.PSFB21;
          var start = gfc.scalefac_band.l[21] + i * size2;
          gfc.scalefac_band.psfb21[i] = start;
        }
        gfc.scalefac_band.psfb21[Encoder.PSFB21] = 576;
        for (var i = 0; i < Encoder.SBMAX_s + 1; i++)
          gfc.scalefac_band.s[i] = qupvt.sfBandIndex[j].s[i];
        for (var i = 0; i < Encoder.PSFB12 + 1; i++) {
          var size2 = (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12]) / Encoder.PSFB12;
          var start = gfc.scalefac_band.s[12] + i * size2;
          gfc.scalefac_band.psfb12[i] = start;
        }
        gfc.scalefac_band.psfb12[Encoder.PSFB12] = 192;
        if (gfp.version == 1)
          gfc.sideinfo_len = gfc.channels_out == 1 ? 4 + 17 : 4 + 32;
        else
          gfc.sideinfo_len = gfc.channels_out == 1 ? 4 + 9 : 4 + 17;
        if (gfp.error_protection)
          gfc.sideinfo_len += 2;
        lame_init_bitstream(gfp);
        gfc.Class_ID = LAME_ID;
        {
          var k;
          for (k = 0; k < 19; k++)
            gfc.nsPsy.pefirbuf[k] = 700 * gfc.mode_gr * gfc.channels_out;
          if (gfp.ATHtype == -1)
            gfp.ATHtype = 4;
        }
        switch (gfp.VBR) {
          case VbrMode.vbr_mt:
            gfp.VBR = VbrMode.vbr_mtrh;
          case VbrMode.vbr_mtrh: {
            if (gfp.useTemporal == null) {
              gfp.useTemporal = false;
            }
            p.apply_preset(gfp, 500 - gfp.VBR_q * 10, 0);
            if (gfp.quality < 0)
              gfp.quality = LAME_DEFAULT_QUALITY;
            if (gfp.quality < 5)
              gfp.quality = 0;
            if (gfp.quality > 5)
              gfp.quality = 5;
            gfc.PSY.mask_adjust = gfp.maskingadjust;
            gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;
            if (gfp.experimentalY)
              gfc.sfb21_extra = false;
            else
              gfc.sfb21_extra = gfp.out_samplerate > 44e3;
            gfc.iteration_loop = new VBRNewIterationLoop(qu);
            break;
          }
          case VbrMode.vbr_rh: {
            p.apply_preset(gfp, 500 - gfp.VBR_q * 10, 0);
            gfc.PSY.mask_adjust = gfp.maskingadjust;
            gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;
            if (gfp.experimentalY)
              gfc.sfb21_extra = false;
            else
              gfc.sfb21_extra = gfp.out_samplerate > 44e3;
            if (gfp.quality > 6)
              gfp.quality = 6;
            if (gfp.quality < 0)
              gfp.quality = LAME_DEFAULT_QUALITY;
            gfc.iteration_loop = new VBROldIterationLoop(qu);
            break;
          }
          default: {
            var vbrmode;
            gfc.sfb21_extra = false;
            if (gfp.quality < 0)
              gfp.quality = LAME_DEFAULT_QUALITY;
            vbrmode = gfp.VBR;
            if (vbrmode == VbrMode.vbr_off)
              gfp.VBR_mean_bitrate_kbps = gfp.brate;
            p.apply_preset(gfp, gfp.VBR_mean_bitrate_kbps, 0);
            gfp.VBR = vbrmode;
            gfc.PSY.mask_adjust = gfp.maskingadjust;
            gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;
            if (vbrmode == VbrMode.vbr_off) {
              gfc.iteration_loop = new CBRNewIterationLoop(qu);
            } else {
              abort();
            }
            break;
          }
        }
        if (gfp.VBR != VbrMode.vbr_off) {
          abort();
        }
        if (gfp.tune) {
          abort();
        }
        lame_init_qval(gfp);
        if (gfp.athaa_type < 0)
          gfc.ATH.useAdjust = 3;
        else
          gfc.ATH.useAdjust = gfp.athaa_type;
        gfc.ATH.aaSensitivityP = Math.pow(10, gfp.athaa_sensitivity / -10);
        if (gfp.short_blocks == null) {
          gfp.short_blocks = ShortBlock.short_block_allowed;
        }
        if (gfp.short_blocks == ShortBlock.short_block_allowed && (gfp.mode == MPEGMode.JOINT_STEREO || gfp.mode == MPEGMode.STEREO)) {
          gfp.short_blocks = ShortBlock.short_block_coupled;
        }
        if (gfp.quant_comp < 0)
          gfp.quant_comp = 1;
        if (gfp.quant_comp_short < 0)
          gfp.quant_comp_short = 0;
        if (gfp.msfix < 0)
          gfp.msfix = 0;
        gfp.exp_nspsytune = gfp.exp_nspsytune | 1;
        if (gfp.internal_flags.nsPsy.attackthre < 0)
          gfp.internal_flags.nsPsy.attackthre = PsyModel.NSATTACKTHRE;
        if (gfp.internal_flags.nsPsy.attackthre_s < 0)
          gfp.internal_flags.nsPsy.attackthre_s = PsyModel.NSATTACKTHRE_S;
        if (gfp.scale < 0)
          gfp.scale = 1;
        if (gfp.ATHtype < 0)
          gfp.ATHtype = 4;
        if (gfp.ATHcurve < 0)
          gfp.ATHcurve = 4;
        if (gfp.athaa_loudapprox < 0)
          gfp.athaa_loudapprox = 2;
        if (gfp.interChRatio < 0)
          gfp.interChRatio = 0;
        if (gfp.useTemporal == null)
          gfp.useTemporal = true;
        gfc.slot_lag = gfc.frac_SpF = 0;
        if (gfp.VBR == VbrMode.vbr_off)
          gfc.slot_lag = gfc.frac_SpF = (gfp.version + 1) * 72e3 * gfp.brate % gfp.out_samplerate | 0;
        qupvt.iteration_init(gfp);
        psy.psymodel_init(gfp);
        return 0;
      };
      function update_inbuffer_size(gfc, nsamples) {
        if (gfc.in_buffer_0 == null || gfc.in_buffer_nsamples < nsamples) {
          gfc.in_buffer_0 = new_float(nsamples);
          gfc.in_buffer_1 = new_float(nsamples);
          gfc.in_buffer_nsamples = nsamples;
        }
      }
      this.lame_encode_flush = function(gfp, mp3buffer, mp3bufferPos, mp3buffer_size) {
        var gfc = gfp.internal_flags;
        var buffer = new_short_n([2, 1152]);
        var imp3 = 0, mp3count, mp3buffer_size_remaining;
        var end_padding;
        var frames_left;
        var samples_to_encode = gfc.mf_samples_to_encode - Encoder.POSTDELAY;
        var mf_needed = calcNeeded(gfp);
        if (gfc.mf_samples_to_encode < 1) {
          return 0;
        }
        mp3count = 0;
        if (gfp.in_samplerate != gfp.out_samplerate) {
          abort();
        }
        end_padding = gfp.framesize - samples_to_encode % gfp.framesize;
        if (end_padding < 576)
          end_padding += gfp.framesize;
        gfp.encoder_padding = end_padding;
        frames_left = (samples_to_encode + end_padding) / gfp.framesize;
        while (frames_left > 0 && imp3 >= 0) {
          var bunch = mf_needed - gfc.mf_size;
          var frame_num = gfp.frameNum;
          bunch *= gfp.in_samplerate;
          bunch /= gfp.out_samplerate;
          if (bunch > 1152)
            bunch = 1152;
          if (bunch < 1)
            bunch = 1;
          mp3buffer_size_remaining = mp3buffer_size - mp3count;
          if (mp3buffer_size == 0)
            mp3buffer_size_remaining = 0;
          imp3 = this.lame_encode_buffer(gfp, buffer[0], buffer[1], bunch, mp3buffer, mp3bufferPos, mp3buffer_size_remaining);
          mp3bufferPos += imp3;
          mp3count += imp3;
          frames_left -= frame_num != gfp.frameNum ? 1 : 0;
        }
        gfc.mf_samples_to_encode = 0;
        if (imp3 < 0) {
          return imp3;
        }
        mp3buffer_size_remaining = mp3buffer_size - mp3count;
        if (mp3buffer_size == 0)
          mp3buffer_size_remaining = 0;
        bs.flush_bitstream(gfp);
        imp3 = bs.copy_buffer(gfc, mp3buffer, mp3bufferPos, mp3buffer_size_remaining, 1);
        if (imp3 < 0) {
          return imp3;
        }
        mp3bufferPos += imp3;
        mp3count += imp3;
        mp3buffer_size_remaining = mp3buffer_size - mp3count;
        if (mp3buffer_size == 0)
          mp3buffer_size_remaining = 0;
        if (gfp.write_id3tag_automatic) {
          abort();
        }
        return mp3count;
      };
      this.lame_encode_buffer = function(gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
        var gfc = gfp.internal_flags;
        var in_buffer = [null, null];
        if (gfc.Class_ID != LAME_ID)
          return -3;
        if (nsamples == 0)
          return 0;
        update_inbuffer_size(gfc, nsamples);
        in_buffer[0] = gfc.in_buffer_0;
        in_buffer[1] = gfc.in_buffer_1;
        for (var i = 0; i < nsamples; i++) {
          in_buffer[0][i] = buffer_l[i];
          if (gfc.channels_in > 1)
            in_buffer[1][i] = buffer_r[i];
        }
        return lame_encode_buffer_sample(gfp, in_buffer[0], in_buffer[1], nsamples, mp3buf, mp3bufPos, mp3buf_size);
      };
      function calcNeeded(gfp) {
        var mf_needed = Encoder.BLKSIZE + gfp.framesize - Encoder.FFTOFFSET;
        mf_needed = Math.max(mf_needed, 512 + gfp.framesize - 32);
        return mf_needed;
      }
      function lame_encode_buffer_sample(gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
        var gfc = gfp.internal_flags;
        var mp3size = 0, ret, i, ch, mf_needed;
        var mp3out;
        var mfbuf = [null, null];
        var in_buffer = [null, null];
        if (gfc.Class_ID != LAME_ID)
          return -3;
        if (nsamples == 0)
          return 0;
        mp3out = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 0);
        if (mp3out < 0)
          return mp3out;
        mp3bufPos += mp3out;
        mp3size += mp3out;
        in_buffer[0] = buffer_l;
        in_buffer[1] = buffer_r;
        if (BitStream.NEQ(gfp.scale, 0) && BitStream.NEQ(gfp.scale, 1)) {
          for (i = 0; i < nsamples; ++i) {
            in_buffer[0][i] *= gfp.scale;
            if (gfc.channels_out == 2)
              in_buffer[1][i] *= gfp.scale;
          }
        }
        if (BitStream.NEQ(gfp.scale_left, 0) && BitStream.NEQ(gfp.scale_left, 1)) {
          for (i = 0; i < nsamples; ++i) {
            in_buffer[0][i] *= gfp.scale_left;
          }
        }
        if (BitStream.NEQ(gfp.scale_right, 0) && BitStream.NEQ(gfp.scale_right, 1)) {
          for (i = 0; i < nsamples; ++i) {
            in_buffer[1][i] *= gfp.scale_right;
          }
        }
        if (gfp.num_channels == 2 && gfc.channels_out == 1) {
          abort();
        }
        mf_needed = calcNeeded(gfp);
        mfbuf[0] = gfc.mfbuf[0];
        mfbuf[1] = gfc.mfbuf[1];
        var in_bufferPos = 0;
        while (nsamples > 0) {
          var in_buffer_ptr = [null, null];
          var n_in = 0;
          var n_out = 0;
          in_buffer_ptr[0] = in_buffer[0];
          in_buffer_ptr[1] = in_buffer[1];
          var inOut = new InOut();
          fill_buffer(gfp, mfbuf, in_buffer_ptr, in_bufferPos, nsamples, inOut);
          n_in = inOut.n_in;
          n_out = inOut.n_out;
          if (gfc.findReplayGain && !gfc.decode_on_the_fly) {
            if (ga.AnalyzeSamples(gfc.rgdata, mfbuf[0], gfc.mf_size, mfbuf[1], gfc.mf_size, n_out, gfc.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR)
              return -6;
          }
          nsamples -= n_in;
          in_bufferPos += n_in;
          if (gfc.channels_out == 2)
            ;
          gfc.mf_size += n_out;
          if (gfc.mf_samples_to_encode < 1) {
            abort();
          }
          gfc.mf_samples_to_encode += n_out;
          if (gfc.mf_size >= mf_needed) {
            var buf_size = mp3buf_size - mp3size;
            if (mp3buf_size == 0)
              buf_size = 0;
            ret = lame_encode_frame(gfp, mfbuf[0], mfbuf[1], mp3buf, mp3bufPos, buf_size);
            if (ret < 0)
              return ret;
            mp3bufPos += ret;
            mp3size += ret;
            gfc.mf_size -= gfp.framesize;
            gfc.mf_samples_to_encode -= gfp.framesize;
            for (ch = 0; ch < gfc.channels_out; ch++)
              for (i = 0; i < gfc.mf_size; i++)
                mfbuf[ch][i] = mfbuf[ch][i + gfp.framesize];
          }
        }
        return mp3size;
      }
      function lame_encode_frame(gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
        var ret = self2.enc.lame_encode_mp3_frame(gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size);
        gfp.frameNum++;
        return ret;
      }
      function InOut() {
        this.n_in = 0;
        this.n_out = 0;
      }
      function fill_buffer(gfp, mfbuf, in_buffer, in_bufferPos, nsamples, io) {
        var gfc = gfp.internal_flags;
        if (gfc.resample_ratio < 0.9999 || gfc.resample_ratio > 1.0001) {
          abort();
        } else {
          io.n_out = Math.min(gfp.framesize, nsamples);
          io.n_in = io.n_out;
          for (var i = 0; i < io.n_out; ++i) {
            mfbuf[0][gfc.mf_size + i] = in_buffer[0][in_bufferPos + i];
            if (gfc.channels_out == 2)
              mfbuf[1][gfc.mf_size + i] = in_buffer[1][in_bufferPos + i];
          }
        }
      }
    }
    function GetAudio() {
      this.setModules = function(parse2, mpg2) {
      };
    }
    function Parse() {
      this.setModules = function(ver2, id32, pre2) {
      };
    }
    function MPGLib() {
    }
    function ID3Tag() {
      this.setModules = function(_bits, _ver) {
      };
    }
    function Mp3Encoder(channels, samplerate, kbps) {
      if (channels != 1) {
        abort("fix cc: only supports mono");
      }
      var lame = new Lame();
      var gaud = new GetAudio();
      var ga = new GainAnalysis();
      var bs = new BitStream();
      var p = new Presets();
      var qupvt = new QuantizePVT();
      var qu = new Quantize();
      var vbr = new VBRTag();
      var ver = new Version();
      var id3 = new ID3Tag();
      var rv = new Reservoir();
      var tak = new Takehiro();
      var parse2 = new Parse();
      var mpg = new MPGLib();
      lame.setModules(ga, bs, p, qupvt, qu, vbr, ver, id3, mpg);
      bs.setModules(ga, mpg, ver, vbr);
      id3.setModules(bs, ver);
      p.setModules(lame);
      qu.setModules(bs, rv, qupvt, tak);
      qupvt.setModules(tak, rv, lame.enc.psy);
      rv.setModules(bs);
      tak.setModules(qupvt);
      vbr.setModules(lame, bs, ver);
      gaud.setModules(parse2, mpg);
      parse2.setModules(ver, id3, p);
      var gfp = lame.lame_init();
      gfp.num_channels = channels;
      gfp.in_samplerate = samplerate;
      gfp.out_samplerate = samplerate;
      gfp.brate = kbps;
      gfp.mode = MPEGMode.STEREO;
      gfp.quality = 3;
      gfp.bWriteVbrTag = false;
      gfp.disable_reservoir = true;
      gfp.write_id3tag_automatic = false;
      lame.lame_init_params(gfp);
      var maxSamples = 1152;
      var mp3buf_size = 0 | 1.25 * maxSamples + 7200;
      var mp3buf = new_byte(mp3buf_size);
      this.encodeBuffer = function(left, right) {
        if (channels == 1) {
          right = left;
        }
        if (left.length > maxSamples) {
          maxSamples = left.length;
          mp3buf_size = 0 | 1.25 * maxSamples + 7200;
          mp3buf = new_byte(mp3buf_size);
        }
        var _sz = lame.lame_encode_buffer(gfp, left, right, left.length, mp3buf, 0, mp3buf_size);
        return new Int8Array(mp3buf.subarray(0, _sz));
      };
      this.flush = function() {
        var _sz = lame.lame_encode_flush(gfp, mp3buf, 0, mp3buf_size);
        return new Int8Array(mp3buf.subarray(0, _sz));
      };
    }
    L3Side.SFBMAX = Encoder.SBMAX_s * 3;
    lamejs.Mp3Encoder = Mp3Encoder;
  }
  lamejs();
  Recorder2.lamejs = lamejs;
});
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.audioList && _vm.audioList.length ? _c("div", {
    staticClass: "radio-box"
  }, [_c("van-cell-group", {
    attrs: {
      "border": ""
    }
  }, _vm._l(_vm.audioList, function(audio, audioIndex) {
    return _c("van-cell", {
      key: audioIndex,
      attrs: {
        "icon": "sound",
        "title": audio.name,
        "custom-class": "" + (audioIndex === _vm.innerAudioContextIndex ? "radio-box__active" : "")
      }
    }, [_c("div", {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "400",
        "padding-right": "5px",
        "display": "inline"
      }
    }, [_vm._v(" " + _vm._s(audio.duration) + " ")]), _vm.innerAudioContextIndex === audioIndex ? _c("van-icon", {
      attrs: {
        "name": "pause-circle",
        "size": "12px",
        "color": "#ff771c"
      },
      on: {
        "click": function($event) {
          return _vm.stopAudio(audio, audioIndex);
        }
      }
    }) : _c("van-icon", {
      attrs: {
        "name": "play-circle",
        "size": "12px"
      },
      on: {
        "click": function($event) {
          return _vm.onAudio(audio, audioIndex);
        }
      }
    }), _vm.isDelete ? _c("van-icon", {
      staticStyle: {
        "padding": "0 0 0 10px"
      },
      attrs: {
        "name": "cross",
        "size": "12px"
      },
      on: {
        "click": function($event) {
          return _vm.onDelete(audioIndex);
        }
      }
    }) : _vm._e()], 1);
  }), 1)], 1) : _vm._e();
};
var staticRenderFns$1 = [];
render$1._withStripped = true;
var VoiceList_vue_vue_type_style_index_0_scoped_true_lang = "";
Vue$1.use(Toast);
Vue$1.use(Dialog$1);
const __vue2_script$1 = defineComponent({
  name: "VoiceList",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    isDelete: {
      type: Boolean,
      default: true
    }
  },
  setup(props2, {
    emit: emit2
  }) {
    toRefs(props2);
    const innerAudioContextIndex = ref("");
    const sound = ref(null);
    ref([]);
    getCurrentInstance().proxy;
    const audioList = computed({
      get() {
        return props2.value.map((_a, index2) => {
          _a.src = _a.fullPath;
          _a.audio = new Audio();
          _a.audio.src = _a.src;
          _a.currentTime = null;
          if (!_a.duration) {
            _a.audio.oncanplaythrough = function() {
              _a.duration = secTotime(_a.audio.duration);
              stopAudio(_a.audio, index2);
            };
          }
          return _a;
        });
      },
      set(value9) {
        emit2("input", value9);
      }
    });
    function onAudio(audio, index2) {
      if (index2 === innerAudioContextIndex.value) {
        stop2(innerAudioContextIndex.value);
        play2(innerAudioContextIndex.value);
      } else {
        stop2(innerAudioContextIndex.value);
        play2(index2);
      }
    }
    function stopAudio(audio, index2) {
      stop2(index2);
      innerAudioContextIndex.value = "";
    }
    function onDelete(index2) {
      Dialog$1.confirm({
        title: "\u6E29\u99A8\u63D0\u793A",
        message: "\u662F\u5426\u786E\u5B9A\u5220\u9664\uFF0C\u4E0D\u53EF\u6062\u590D\uFF01"
      }).then(() => {
        audioList.value.splice(index2, 1);
        audioList.value = [].concat(audioList.value);
        Toast("\u5220\u9664\u6210\u529F\uFF01");
      }).catch(() => {
      });
    }
    function stop2(index2) {
      if (audioList.value[index2] && audioList.value[index2].audio) {
        sound.value = audioList.value[index2].audio;
        sound.value.pause();
        audioList.value[index2].currentTime = null;
        audioList.value = Object.assign(audioList.value, {});
      }
    }
    function secTotime(s) {
      let t4 = "";
      if (s > -1) {
        const min = Math.floor(s / 60) % 60;
        const sec = s % 60;
        if (min <= 9) {
          t4 += "0";
        }
        t4 += min + ":";
        if (sec <= 9) {
          t4 += "0";
        }
        t4 += sec.toFixed(0);
      }
      return t4;
    }
    function play2(index2) {
      const data22 = audioList.value[index2];
      if (data22.audio) {
        sound.value = data22.audio;
        sound.value.play();
      } else {
        sound.value = audioList.value[index2].audio = new Audio();
        sound.value.src = data22.src;
        sound.value.play();
      }
      innerAudioContextIndex.value = index2;
    }
    return {
      audioList,
      innerAudioContextIndex,
      stopAudio,
      onAudio,
      onDelete
    };
  }
});
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(__vue2_script$1, render$1, staticRenderFns$1, false, __vue2_injectStyles$1, "805a93ae", null, null);
function __vue2_injectStyles$1(context2) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
__component__$1.options.__file = "packages/op-voice-record/src/mobile/VoiceList.vue";
var VoiceList = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var props = __spreadValues({}, fileProps);
var render20 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "mic-manager"
  }, [_c("div", {
    staticStyle: {
      "display": "inline-block",
      "padding": "10px 0",
      "width": "100%"
    }
  }, [!_vm.isRecord ? _c("van-button", {
    attrs: {
      "type": "primary",
      "color": "#f08519",
      "icon": "volume-o",
      "plain": "",
      "size": "small",
      "disabled": _vm.isRecord
    },
    on: {
      "click": _vm.onstartRecord
    }
  }, [_vm._v(" \u8BED\u97F3\u63CF\u8FF0\u95EE\u9898 ")]) : _c("van-button", {
    attrs: {
      "type": "primary",
      "color": "#f08519",
      "icon": "stop-circle",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.setStopRecord
    }
  }, [_vm._v(_vm._s(_vm.showTime + "\u7ED3\u675F\u5F55\u97F3"))]), _c("span", {
    staticClass: "tips"
  }, [_vm._v("\u6700\u591A\u652F\u6301" + _vm._s(_vm.maxLength) + "\u4E2A\u5F55\u97F3\u6587\u4EF6\uFF0C\u6BCF\u4E2A\u6587\u4EF6" + _vm._s(_vm.maxSize) + "M\u4EE5\u5185")])], 1), _c("voice-list", {
    ref: "radioRef",
    attrs: {
      "is-delete": _vm.isDelete
    },
    model: {
      value: _vm._value,
      callback: function($$v) {
        _vm._value = $$v;
      },
      expression: "_value"
    }
  }), _c("van-action-sheet", {
    attrs: {
      "actions": _vm.list,
      "close-on-click-modal": false,
      "cancel-text": "\u5173\u95ED",
      "z-index": "101"
    },
    on: {
      "close": function($event) {
        _vm.showAction = false;
      },
      "select": _vm.onSelect
    },
    model: {
      value: _vm.showAction,
      callback: function($$v) {
        _vm.showAction = $$v;
      },
      expression: "showAction"
    }
  })], 1);
};
var staticRenderFns = [];
render20._withStripped = true;
var index_vue_vue_type_style_index_0_scoped_true_lang = "";
Vue$1.use(_ActionSheet);
Vue$1.use(Toast);
const __vue2_script = defineComponent({
  name: "OpVoiceRecord",
  components: {
    VoiceList
  },
  props: __spreadProps(__spreadValues({}, props), {
    isDelete: {
      type: Boolean,
      default: true
    },
    maxSize: {
      type: Number,
      default: 50
    },
    maxLength: {
      type: [Number, String],
      default: 1
    }
  }),
  setup(props2, {
    emit: emit2
  }) {
    let _value = computed({
      get() {
        return props2.value;
      },
      set(newValue) {
        emit2("input", newValue);
      }
    });
    const {
      ossUpload,
      loading: loading2
    } = useFileUpload(props2);
    const isRecord = ref(false);
    const showAction = ref(false);
    const list = [{
      name: "\u4E0A\u4F20\u5F55\u97F3",
      type: "upload"
    }, {
      name: "\u91CD\u7F6E\u5F55\u97F3",
      type: "reset"
    }];
    const currentFile = reactive({
      name: new Date().valueOf() + ".mp3",
      size: null,
      thumb: "",
      type: "audio/mp3",
      url: ""
    });
    function showNum(num) {
      if (num < 10) {
        return "0" + num;
      }
      return num;
    }
    const timer2 = ref(null);
    const count3 = ref(0);
    const showTime = ref("00:00:00 ");
    function setTime() {
      showTime.value = "00:00:00 ";
      count3.value = 0;
      timer2.value = setInterval(function() {
        count3.value++;
        let id_S = showNum(count3.value % 60);
        let id_M = showNum(parseInt(count3.value / 60) % 60);
        let id_H = showNum(parseInt(count3.value / 60 / 60));
        showTime.value = `${id_H}:${id_M}:${id_S} `;
      }, 1e3);
    }
    const rec = ref(null);
    ref(null);
    const recBlob = ref(null);
    function formatMs(ms, all) {
      var f = Math.floor(ms / 6e4), m = Math.floor(ms / 1e3) % 60;
      var s = (all || f > 0 ? (f < 10 ? "0" : "") + f + ":" : "") + (all || f > 0 || m > 0 ? ("0" + m).substr(-2) + "\u2033" : "") + ("00" + ms % 1e3).substr(-3);
      return s;
    }
    const powerLevelNum = ref("");
    const bufferDurationNum = ref("");
    function onstartRecord() {
      if (rec.value && Recorder.IsOpen()) {
        recBlob.value = null;
        rec.value.start();
        isRecord.value = true;
        setTime();
        Toast("\u5DF2\u5F00\u59CB\u5F55\u97F3...");
        return;
      }
      const newRec = Recorder({
        type: "mp3",
        sampleRate: 16e3,
        bitRate: 16,
        onProcess: function(buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) {
          powerLevelNum.value = powerLevel + "%";
          bufferDurationNum.value = formatMs(bufferDuration, 1) + " / " + powerLevel;
        }
      });
      newRec.open(function() {
        rec.value = newRec;
        Toast("\u5DF2\u6253\u5F00\u5F55\u97F3\uFF0C\u53EF\u4EE5\u70B9\u51FB\u5F55\u5236\u5F00\u59CB\u5F55\u97F3\u4E86");
        /* @__PURE__ */ console.log("\u5DF2\u6253\u5F00\u5F55\u97F3\uFF0C\u53EF\u4EE5\u70B9\u51FB\u5F55\u5236\u5F00\u59CB\u5F55\u97F3\u4E86", 2);
        if (rec.value && Recorder.IsOpen()) {
          recBlob.value = null;
          rec.value.start();
          isRecord.value = true;
          setTime();
          Toast("\u5DF2\u5F00\u59CB\u5F55\u97F3...");
        } else {
          Toast("\u672A\u6253\u5F00\u5F55\u97F3...");
          /* @__PURE__ */ console.log("\u672A\u6253\u5F00\u5F55\u97F3", 1);
        }
      }, function(msg, isUserNotAllow) {
        /* @__PURE__ */ console.log((isUserNotAllow ? "UserNotAllow\uFF0C" : "") + "\u6253\u5F00\u5F55\u97F3\u5931\u8D25\uFF1A" + msg, 1);
        Toast((isUserNotAllow ? "UserNotAllow\uFF0C" : "") + "\u6253\u5F00\u5F55\u97F3\u5931\u8D25\uFF1A" + msg);
      });
    }
    function onSelect2(item) {
      switch (item.type) {
        case "upload":
          afterReadAudio();
          showAction.value = false;
          break;
        case "reset":
          isRecord.value = false;
          showAction.value = false;
          timer2.value && clearInterval(timer2.value);
          break;
      }
    }
    function setStopRecord() {
      if (!(rec.value && Recorder.IsOpen())) {
        /* @__PURE__ */ console.log("\u672A\u6253\u5F00\u5F55\u97F3", 1);
        Toast("\u672A\u6253\u5F00\u5F55\u97F3");
        return;
      }
      isRecord.value = false;
      showAction.value = true;
      clearInterval(timer2.value);
      rec.value.stop(function(blob, duration) {
        recBlob.value = blob;
        currentFile.size = blob.size;
      }, function(msg) {
        /* @__PURE__ */ console.log("\u5F55\u97F3\u5931\u8D25:" + msg, 1);
        Toast("\u5F55\u97F3\u5931\u8D25");
      }, true);
    }
    async function afterReadAudio() {
      if (!recBlob.value) {
        return Toast("\u8BF7\u5148\u5F55\u97F3\uFF01");
      }
      if (_value.value.length >= props2.maxLength) {
        return Toast("\u5DF2\u8D85\u51FA\u6700\u5927\u4E0A\u4F20\u6587\u4EF6\u6570\u91CF\uFF01");
      }
      window.URL.createObjectURL(recBlob.value);
      currentFile.file = new File([recBlob.value], dataFilter(new Date(), "YYYYMMDDHHmmss") + ".mp3");
      currentFile.filename = "file";
      if (currentFile.file.size / 1024 / 1024 > props2.maxSize) {
        return Toast(`\u4E0A\u4F20\u6587\u4EF6\u4E0D\u80FD\u8D85\u8FC7${props2.maxSize}M`);
      }
      const isLoading = Toast.loading({
        duration: 0,
        mask: true,
        message: "\u6B63\u5728\u52A0\u8F7D..."
      });
      const result = await uploadFile(currentFile);
      isLoading.clear();
      _value.value.push(result);
    }
    async function uploadFile(file) {
      try {
        const resData = await ossUpload(file);
        if (!resData.status) {
          return;
        }
        let fileData = {
          id: resData.id || "",
          name: resData.filename,
          suffix: resData.suffix,
          ossKey: resData.name,
          path: resData.name,
          uid: resData.uid,
          size: resData.size,
          file,
          url: resData.signatureUrl || resData.name,
          filename: resData.filename,
          fullPath: resData.url,
          isDelete: true,
          isDownload: true
        };
        fileData[props2.name] = resData.filename;
        fileData[props2.src] = resData.signatureUrl || resData.name;
        return fileData;
      } catch (error) {
        loading2.value = false;
        throw new Error("\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25");
      }
    }
    return {
      isRecord,
      showTime,
      showAction,
      list,
      _value,
      onstartRecord,
      setStopRecord,
      onSelect: onSelect2
    };
  }
});
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render20, staticRenderFns, false, __vue2_injectStyles, "177b4caa", null, null);
function __vue2_injectStyles(context2) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
__component__.options.__file = "packages/op-voice-record/src/mobile/index.vue";
var MobileComponent = /* @__PURE__ */ function() {
  return __component__.exports;
}();
const Component = {};
Component.install = (Vue2) => {
  if (isPCWidth()) {
    Vue2.component(MobileComponent.name, PcComponent);
  } else {
    Vue2.component(MobileComponent.name, MobileComponent);
  }
};
var __glob_6_34 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": Component
});
var index$a = "";
var _createNamespace$b = createNamespace("divider"), createComponent$b = _createNamespace$b[0], bem$b = _createNamespace$b[1];
function Divider(h, props2, slots2, ctx) {
  var _bem;
  return h("div", _mergeJSXProps([{
    "attrs": {
      "role": "separator"
    },
    "style": {
      borderColor: props2.borderColor
    },
    "class": bem$b((_bem = {
      dashed: props2.dashed,
      hairline: props2.hairline
    }, _bem["content-" + props2.contentPosition] = slots2.default, _bem))
  }, inherit(ctx, true)]), [slots2.default && slots2.default()]);
}
Divider.props = {
  dashed: Boolean,
  hairline: {
    type: Boolean,
    default: true
  },
  contentPosition: {
    type: String,
    default: "center"
  }
};
var _Divider = createComponent$b(Divider);
var index$9 = "";
var _createNamespace$a = createNamespace("cell-group"), createComponent$a = _createNamespace$a[0], bem$a = _createNamespace$a[1];
function CellGroup(h, props2, slots2, ctx) {
  var _ref;
  var Group = h("div", _mergeJSXProps([{
    "class": [bem$a({
      inset: props2.inset
    }), (_ref = {}, _ref[BORDER_TOP_BOTTOM] = props2.border, _ref)]
  }, inherit(ctx, true)]), [slots2.default == null ? void 0 : slots2.default()]);
  if (props2.title || slots2.title) {
    return h("div", {
      "key": ctx.data.key
    }, [h("div", {
      "class": bem$a("title", {
        inset: props2.inset
      })
    }, [slots2.title ? slots2.title() : props2.title]), Group]);
  }
  return Group;
}
CellGroup.props = {
  title: String,
  inset: Boolean,
  border: {
    type: Boolean,
    default: true
  }
};
var _CellGroup = createComponent$a(CellGroup);
var index$8 = "";
var FieldMixin = {
  inject: {
    vanField: {
      default: null
    }
  },
  watch: {
    value: function value4() {
      var field = this.vanField;
      if (field) {
        field.resetValidation();
        field.validateWithTrigger("onChange");
      }
    }
  },
  created: function created4() {
    var field = this.vanField;
    if (field && !field.children) {
      field.children = this;
    }
  }
};
var CheckboxMixin = function CheckboxMixin2(_ref) {
  var parent = _ref.parent, bem2 = _ref.bem, role = _ref.role;
  return {
    mixins: [ChildrenMixin(parent), FieldMixin],
    props: {
      name: null,
      value: null,
      disabled: Boolean,
      iconSize: [Number, String],
      checkedColor: String,
      labelPosition: String,
      labelDisabled: Boolean,
      shape: {
        type: String,
        default: "round"
      },
      bindGroup: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      disableBindRelation: function disableBindRelation() {
        return !this.bindGroup;
      },
      isDisabled: function isDisabled() {
        return this.parent && this.parent.disabled || this.disabled;
      },
      direction: function direction() {
        return this.parent && this.parent.direction || null;
      },
      iconStyle: function iconStyle() {
        var checkedColor = this.checkedColor || this.parent && this.parent.checkedColor;
        if (checkedColor && this.checked && !this.isDisabled) {
          return {
            borderColor: checkedColor,
            backgroundColor: checkedColor
          };
        }
      },
      tabindex: function tabindex() {
        if (this.isDisabled || role === "radio" && !this.checked) {
          return -1;
        }
        return 0;
      }
    },
    methods: {
      onClick: function onClick8(event) {
        var _this = this;
        var target = event.target;
        var icon = this.$refs.icon;
        var iconClicked = icon === target || (icon == null ? void 0 : icon.contains(target));
        if (!this.isDisabled && (iconClicked || !this.labelDisabled)) {
          this.toggle();
          setTimeout(function() {
            _this.$emit("click", event);
          });
        } else {
          this.$emit("click", event);
        }
      },
      genIcon: function genIcon2() {
        var h = this.$createElement;
        var checked2 = this.checked;
        var iconSize = this.iconSize || this.parent && this.parent.iconSize;
        return h("div", {
          "ref": "icon",
          "class": bem2("icon", [this.shape, {
            disabled: this.isDisabled,
            checked: checked2
          }]),
          "style": {
            fontSize: addUnit(iconSize)
          }
        }, [this.slots("icon", {
          checked: checked2
        }) || h(_Icon, {
          "attrs": {
            "name": "success"
          },
          "style": this.iconStyle
        })]);
      },
      genLabel: function genLabel2() {
        var h = this.$createElement;
        var slot = this.slots();
        if (slot) {
          return h("span", {
            "class": bem2("label", [this.labelPosition, {
              disabled: this.isDisabled
            }])
          }, [slot]);
        }
      }
    },
    render: function render28() {
      var h = arguments[0];
      var Children = [this.genIcon()];
      if (this.labelPosition === "left") {
        Children.unshift(this.genLabel());
      } else {
        Children.push(this.genLabel());
      }
      return h("div", {
        "attrs": {
          "role": role,
          "tabindex": this.tabindex,
          "aria-checked": String(this.checked)
        },
        "class": bem2([{
          disabled: this.isDisabled,
          "label-disabled": this.labelDisabled
        }, this.direction]),
        "on": {
          "click": this.onClick
        }
      }, [Children]);
    }
  };
};
var _createNamespace$9 = createNamespace("radio"), createComponent$9 = _createNamespace$9[0], bem$9 = _createNamespace$9[1];
var _Radio = createComponent$9({
  mixins: [CheckboxMixin({
    bem: bem$9,
    role: "radio",
    parent: "vanRadio"
  })],
  computed: {
    currentValue: {
      get: function get3() {
        return this.parent ? this.parent.value : this.value;
      },
      set: function set2(val) {
        (this.parent || this).$emit("input", val);
      }
    },
    checked: function checked() {
      return this.currentValue === this.name;
    }
  },
  methods: {
    toggle: function toggle2() {
      this.currentValue = this.name;
    }
  }
});
var index$7 = "";
var _createNamespace$8 = createNamespace("radio-group"), createComponent$8 = _createNamespace$8[0], bem$8 = _createNamespace$8[1];
var _RadioGroup = createComponent$8({
  mixins: [ParentMixin("vanRadio"), FieldMixin],
  props: {
    value: null,
    disabled: Boolean,
    direction: String,
    checkedColor: String,
    iconSize: [Number, String]
  },
  watch: {
    value: function value5(_value) {
      this.$emit("change", _value);
    }
  },
  render: function render21() {
    var h = arguments[0];
    return h("div", {
      "class": bem$8([this.direction]),
      "attrs": {
        "role": "radiogroup"
      }
    }, [this.slots()]);
  }
});
var index$6 = "";
var _createNamespace$7 = createNamespace("checkbox-group"), createComponent$7 = _createNamespace$7[0], bem$7 = _createNamespace$7[1];
var _CheckboxGroup = createComponent$7({
  mixins: [ParentMixin("vanCheckbox"), FieldMixin],
  props: {
    max: [Number, String],
    disabled: Boolean,
    direction: String,
    iconSize: [Number, String],
    checkedColor: String,
    value: {
      type: Array,
      default: function _default4() {
        return [];
      }
    }
  },
  watch: {
    value: function value6(val) {
      this.$emit("change", val);
    }
  },
  methods: {
    toggleAll: function toggleAll(options) {
      if (options === void 0) {
        options = {};
      }
      if (typeof options === "boolean") {
        options = {
          checked: options
        };
      }
      var _options = options, checked2 = _options.checked, skipDisabled = _options.skipDisabled;
      var children3 = this.children.filter(function(item) {
        if (item.disabled && skipDisabled) {
          return item.checked;
        }
        return checked2 != null ? checked2 : !item.checked;
      });
      var names = children3.map(function(item) {
        return item.name;
      });
      this.$emit("input", names);
    }
  },
  render: function render22() {
    var h = arguments[0];
    return h("div", {
      "class": bem$7([this.direction])
    }, [this.slots()]);
  }
});
var index$5 = "";
var _createNamespace$6 = createNamespace("checkbox"), createComponent$6 = _createNamespace$6[0], bem$6 = _createNamespace$6[1];
var _Checkbox = createComponent$6({
  mixins: [CheckboxMixin({
    bem: bem$6,
    role: "checkbox",
    parent: "vanCheckbox"
  })],
  computed: {
    checked: {
      get: function get4() {
        if (this.parent) {
          return this.parent.value.indexOf(this.name) !== -1;
        }
        return this.value;
      },
      set: function set3(val) {
        if (this.parent) {
          this.setParentValue(val);
        } else {
          this.$emit("input", val);
        }
      }
    }
  },
  watch: {
    value: function value7(val) {
      this.$emit("change", val);
    }
  },
  methods: {
    toggle: function toggle3(checked2) {
      var _this = this;
      if (checked2 === void 0) {
        checked2 = !this.checked;
      }
      clearTimeout(this.toggleTask);
      this.toggleTask = setTimeout(function() {
        _this.checked = checked2;
      });
    },
    setParentValue: function setParentValue(val) {
      var parent = this.parent;
      var value9 = parent.value.slice();
      if (val) {
        if (parent.max && value9.length >= parent.max) {
          return;
        }
        if (value9.indexOf(this.name) === -1) {
          value9.push(this.name);
          parent.$emit("input", value9);
        }
      } else {
        var index2 = value9.indexOf(this.name);
        if (index2 !== -1) {
          value9.splice(index2, 1);
          parent.$emit("input", value9);
        }
      }
    }
  }
});
var index$4 = "";
var _createNamespace$5 = createNamespace("collapse-item"), createComponent$5 = _createNamespace$5[0], bem$5 = _createNamespace$5[1];
var CELL_SLOTS = ["title", "icon", "right-icon"];
var _CollapseItem = createComponent$5({
  mixins: [ChildrenMixin("vanCollapse")],
  props: _extends$o({}, cellProps, {
    name: [Number, String],
    disabled: Boolean,
    lazyRender: {
      type: Boolean,
      default: true
    },
    isLink: {
      type: Boolean,
      default: true
    }
  }),
  data: function data18() {
    return {
      show: null,
      inited: null
    };
  },
  computed: {
    currentName: function currentName2() {
      var _this$name;
      return (_this$name = this.name) != null ? _this$name : this.index;
    },
    expanded: function expanded() {
      var _this = this;
      if (!this.parent) {
        return null;
      }
      var _this$parent = this.parent, value9 = _this$parent.value, accordion = _this$parent.accordion;
      return accordion ? value9 === this.currentName : value9.some(function(name) {
        return name === _this.currentName;
      });
    }
  },
  created: function created5() {
    this.show = this.expanded;
    this.inited = this.expanded;
  },
  watch: {
    expanded: function expanded2(_expanded, prev4) {
      var _this2 = this;
      if (prev4 === null) {
        return;
      }
      if (_expanded) {
        this.show = true;
        this.inited = true;
      }
      var nextTick2 = _expanded ? this.$nextTick : raf;
      nextTick2(function() {
        var _this2$$refs = _this2.$refs, content = _this2$$refs.content, wrapper = _this2$$refs.wrapper;
        if (!content || !wrapper) {
          return;
        }
        var offsetHeight = content.offsetHeight;
        if (offsetHeight) {
          var contentHeight = offsetHeight + "px";
          wrapper.style.height = _expanded ? 0 : contentHeight;
          doubleRaf(function() {
            wrapper.style.height = _expanded ? contentHeight : 0;
          });
        } else {
          _this2.onTransitionEnd();
        }
      });
    }
  },
  methods: {
    onClick: function onClick7() {
      if (!this.disabled) {
        this.toggle();
      }
    },
    toggle: function toggle4(expanded3) {
      if (expanded3 === void 0) {
        expanded3 = !this.expanded;
      }
      var parent = this.parent, currentName3 = this.currentName;
      var close3 = parent.accordion && currentName3 === parent.value;
      var name = close3 ? "" : currentName3;
      this.parent.switch(name, expanded3);
    },
    onTransitionEnd: function onTransitionEnd() {
      if (!this.expanded) {
        this.show = false;
      } else {
        this.$refs.wrapper.style.height = "";
      }
    },
    genTitle: function genTitle() {
      var _this3 = this;
      var h = this.$createElement;
      var border = this.border, disabled = this.disabled, expanded3 = this.expanded;
      var titleSlots = CELL_SLOTS.reduce(function(slots2, name) {
        if (_this3.slots(name)) {
          slots2[name] = function() {
            return _this3.slots(name);
          };
        }
        return slots2;
      }, {});
      if (this.slots("value")) {
        titleSlots.default = function() {
          return _this3.slots("value");
        };
      }
      return h(_Cell, {
        "attrs": {
          "role": "button",
          "tabindex": disabled ? -1 : 0,
          "aria-expanded": String(expanded3)
        },
        "class": bem$5("title", {
          disabled,
          expanded: expanded3,
          borderless: !border
        }),
        "on": {
          "click": this.onClick
        },
        "scopedSlots": titleSlots,
        "props": _extends$o({}, this.$props)
      });
    },
    genContent: function genContent2() {
      var h = this.$createElement;
      if (this.inited || !this.lazyRender) {
        return h("div", {
          "directives": [{
            name: "show",
            value: this.show
          }],
          "ref": "wrapper",
          "class": bem$5("wrapper"),
          "on": {
            "transitionend": this.onTransitionEnd
          }
        }, [h("div", {
          "ref": "content",
          "class": bem$5("content")
        }, [this.slots()])]);
      }
    }
  },
  render: function render23() {
    var h = arguments[0];
    return h("div", {
      "class": [bem$5({
        border: this.index && this.border
      })]
    }, [this.genTitle(), this.genContent()]);
  }
});
var _createNamespace$4 = createNamespace("collapse"), createComponent$4 = _createNamespace$4[0], bem$4 = _createNamespace$4[1];
var _Collapse = createComponent$4({
  mixins: [ParentMixin("vanCollapse")],
  props: {
    accordion: Boolean,
    value: [String, Number, Array],
    border: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    switch: function _switch(name, expanded3) {
      if (!this.accordion) {
        name = expanded3 ? this.value.concat(name) : this.value.filter(function(activeName) {
          return activeName !== name;
        });
      }
      this.$emit("change", name);
      this.$emit("input", name);
    }
  },
  render: function render24() {
    var _ref;
    var h = arguments[0];
    return h("div", {
      "class": [bem$4(), (_ref = {}, _ref[BORDER_TOP_BOTTOM] = this.border, _ref)]
    }, [this.slots()]);
  }
});
var index$3 = "";
var _createNamespace$3 = createNamespace("nav-bar"), createComponent$3 = _createNamespace$3[0], bem$3 = _createNamespace$3[1];
var _NavBar = createComponent$3({
  props: {
    title: String,
    fixed: Boolean,
    zIndex: [Number, String],
    leftText: String,
    rightText: String,
    leftArrow: Boolean,
    placeholder: Boolean,
    safeAreaInsetTop: Boolean,
    border: {
      type: Boolean,
      default: true
    }
  },
  data: function data19() {
    return {
      height: null
    };
  },
  mounted: function mounted9() {
    var _this = this;
    if (this.placeholder && this.fixed) {
      var setHeight = function setHeight2() {
        _this.height = _this.$refs.navBar.getBoundingClientRect().height;
      };
      setHeight();
      setTimeout(setHeight, 100);
    }
  },
  methods: {
    genLeft: function genLeft() {
      var h = this.$createElement;
      var leftSlot = this.slots("left");
      if (leftSlot) {
        return leftSlot;
      }
      return [this.leftArrow && h(_Icon, {
        "class": bem$3("arrow"),
        "attrs": {
          "name": "arrow-left"
        }
      }), this.leftText && h("span", {
        "class": bem$3("text")
      }, [this.leftText])];
    },
    genRight: function genRight() {
      var h = this.$createElement;
      var rightSlot = this.slots("right");
      if (rightSlot) {
        return rightSlot;
      }
      if (this.rightText) {
        return h("span", {
          "class": bem$3("text")
        }, [this.rightText]);
      }
    },
    genNavBar: function genNavBar() {
      var _ref;
      var h = this.$createElement;
      return h("div", {
        "ref": "navBar",
        "style": {
          zIndex: this.zIndex
        },
        "class": [bem$3({
          fixed: this.fixed,
          "safe-area-inset-top": this.safeAreaInsetTop
        }), (_ref = {}, _ref[BORDER_BOTTOM] = this.border, _ref)]
      }, [h("div", {
        "class": bem$3("content")
      }, [this.hasLeft() && h("div", {
        "class": bem$3("left"),
        "on": {
          "click": this.onClickLeft
        }
      }, [this.genLeft()]), h("div", {
        "class": [bem$3("title"), "van-ellipsis"]
      }, [this.slots("title") || this.title]), this.hasRight() && h("div", {
        "class": bem$3("right"),
        "on": {
          "click": this.onClickRight
        }
      }, [this.genRight()])])]);
    },
    hasLeft: function hasLeft() {
      return this.leftArrow || this.leftText || this.slots("left");
    },
    hasRight: function hasRight() {
      return this.rightText || this.slots("right");
    },
    onClickLeft: function onClickLeft(event) {
      this.$emit("click-left", event);
    },
    onClickRight: function onClickRight(event) {
      this.$emit("click-right", event);
    }
  },
  render: function render25() {
    var h = arguments[0];
    if (this.placeholder && this.fixed) {
      return h("div", {
        "class": bem$3("placeholder"),
        "style": {
          height: this.height + "px"
        }
      }, [this.genNavBar()]);
    }
    return this.genNavBar();
  }
});
var index$2 = "";
var _createNamespace$2 = createNamespace("list"), createComponent$2 = _createNamespace$2[0], bem$2 = _createNamespace$2[1], t$2 = _createNamespace$2[2];
var _List = createComponent$2({
  mixins: [BindEventMixin(function(bind2) {
    if (!this.scroller) {
      this.scroller = getScroller(this.$el);
    }
    bind2(this.scroller, "scroll", this.check);
  })],
  model: {
    prop: "loading"
  },
  props: {
    error: Boolean,
    loading: Boolean,
    finished: Boolean,
    errorText: String,
    loadingText: String,
    finishedText: String,
    immediateCheck: {
      type: Boolean,
      default: true
    },
    offset: {
      type: [Number, String],
      default: 300
    },
    direction: {
      type: String,
      default: "down"
    }
  },
  data: function data20() {
    return {
      innerLoading: this.loading
    };
  },
  updated: function updated() {
    this.innerLoading = this.loading;
  },
  mounted: function mounted10() {
    if (this.immediateCheck) {
      this.check();
    }
  },
  watch: {
    loading: "check",
    finished: "check"
  },
  methods: {
    check: function check() {
      var _this = this;
      this.$nextTick(function() {
        if (_this.innerLoading || _this.finished || _this.error) {
          return;
        }
        var el = _this.$el, scroller = _this.scroller, offset = _this.offset, direction = _this.direction;
        var scrollerRect;
        if (scroller.getBoundingClientRect) {
          scrollerRect = scroller.getBoundingClientRect();
        } else {
          scrollerRect = {
            top: 0,
            bottom: scroller.innerHeight
          };
        }
        var scrollerHeight = scrollerRect.bottom - scrollerRect.top;
        if (!scrollerHeight || isHidden(el)) {
          return false;
        }
        var isReachEdge = false;
        var placeholderRect = _this.$refs.placeholder.getBoundingClientRect();
        if (direction === "up") {
          isReachEdge = scrollerRect.top - placeholderRect.top <= offset;
        } else {
          isReachEdge = placeholderRect.bottom - scrollerRect.bottom <= offset;
        }
        if (isReachEdge) {
          _this.innerLoading = true;
          _this.$emit("input", true);
          _this.$emit("load");
        }
      });
    },
    clickErrorText: function clickErrorText() {
      this.$emit("update:error", false);
      this.check();
    },
    genLoading: function genLoading() {
      var h = this.$createElement;
      if (this.innerLoading && !this.finished) {
        return h("div", {
          "key": "loading",
          "class": bem$2("loading")
        }, [this.slots("loading") || h(Loading$1, {
          "attrs": {
            "size": "16"
          }
        }, [this.loadingText || t$2("loading")])]);
      }
    },
    genFinishedText: function genFinishedText() {
      var h = this.$createElement;
      if (this.finished) {
        var text = this.slots("finished") || this.finishedText;
        if (text) {
          return h("div", {
            "class": bem$2("finished-text")
          }, [text]);
        }
      }
    },
    genErrorText: function genErrorText() {
      var h = this.$createElement;
      if (this.error) {
        var text = this.slots("error") || this.errorText;
        if (text) {
          return h("div", {
            "on": {
              "click": this.clickErrorText
            },
            "class": bem$2("error-text")
          }, [text]);
        }
      }
    }
  },
  render: function render26() {
    var h = arguments[0];
    var Placeholder = h("div", {
      "ref": "placeholder",
      "key": "placeholder",
      "class": bem$2("placeholder")
    });
    return h("div", {
      "class": bem$2(),
      "attrs": {
        "role": "feed",
        "aria-busy": this.innerLoading
      }
    }, [this.direction === "down" ? this.slots() : Placeholder, this.genLoading(), this.genFinishedText(), this.genErrorText(), this.direction === "up" ? this.slots() : Placeholder]);
  }
});
var index$1 = "";
var _createNamespace$1 = createNamespace("search"), createComponent$1 = _createNamespace$1[0], bem$1 = _createNamespace$1[1], t$1 = _createNamespace$1[2];
function Search(h, props2, slots2, ctx) {
  function Label() {
    if (slots2.label || props2.label) {
      return h("div", {
        "class": bem$1("label")
      }, [slots2.label ? slots2.label() : props2.label]);
    }
  }
  function Action() {
    if (!props2.showAction) {
      return;
    }
    function onCancel() {
      if (slots2.action) {
        return;
      }
      emit$2(ctx, "input", "");
      emit$2(ctx, "cancel");
    }
    return h("div", {
      "class": bem$1("action"),
      "attrs": {
        "role": "button",
        "tabindex": "0"
      },
      "on": {
        "click": onCancel
      }
    }, [slots2.action ? slots2.action() : props2.actionText || t$1("cancel")]);
  }
  var fieldData = {
    attrs: ctx.data.attrs,
    on: _extends$o({}, ctx.listeners, {
      keypress: function keypress(event) {
        if (event.keyCode === 13) {
          preventDefault(event);
          emit$2(ctx, "search", props2.value);
        }
        emit$2(ctx, "keypress", event);
      }
    })
  };
  var inheritData = inherit(ctx);
  inheritData.attrs = void 0;
  return h("div", _mergeJSXProps([{
    "class": bem$1({
      "show-action": props2.showAction
    }),
    "style": {
      background: props2.background
    }
  }, inheritData]), [slots2.left == null ? void 0 : slots2.left(), h("div", {
    "class": bem$1("content", props2.shape)
  }, [Label(), h(_Field, _mergeJSXProps([{
    "attrs": {
      "type": "search",
      "border": false,
      "value": props2.value,
      "leftIcon": props2.leftIcon,
      "rightIcon": props2.rightIcon,
      "clearable": props2.clearable,
      "clearTrigger": props2.clearTrigger
    },
    "scopedSlots": {
      "left-icon": slots2["left-icon"],
      "right-icon": slots2["right-icon"]
    }
  }, fieldData]))]), Action()]);
}
Search.props = {
  value: String,
  label: String,
  rightIcon: String,
  actionText: String,
  background: String,
  showAction: Boolean,
  clearTrigger: String,
  shape: {
    type: String,
    default: "square"
  },
  clearable: {
    type: Boolean,
    default: true
  },
  leftIcon: {
    type: String,
    default: "search"
  }
};
var _Search = createComponent$1(Search);
var index = "";
var _createNamespace = createNamespace("pull-refresh"), createComponent = _createNamespace[0], bem = _createNamespace[1], t3 = _createNamespace[2];
var DEFAULT_HEAD_HEIGHT = 50;
var TEXT_STATUS = ["pulling", "loosing", "success"];
var _PullRefresh = createComponent({
  mixins: [TouchMixin],
  props: {
    disabled: Boolean,
    successText: String,
    pullingText: String,
    loosingText: String,
    loadingText: String,
    pullDistance: [Number, String],
    value: {
      type: Boolean,
      required: true
    },
    successDuration: {
      type: [Number, String],
      default: 500
    },
    animationDuration: {
      type: [Number, String],
      default: 300
    },
    headHeight: {
      type: [Number, String],
      default: DEFAULT_HEAD_HEIGHT
    }
  },
  data: function data21() {
    return {
      status: "normal",
      distance: 0,
      duration: 0
    };
  },
  computed: {
    touchable: function touchable() {
      return this.status !== "loading" && this.status !== "success" && !this.disabled;
    },
    headStyle: function headStyle() {
      if (this.headHeight !== DEFAULT_HEAD_HEIGHT) {
        return {
          height: this.headHeight + "px"
        };
      }
    }
  },
  watch: {
    value: function value8(loading2) {
      this.duration = this.animationDuration;
      if (loading2) {
        this.setStatus(+this.headHeight, true);
      } else if (this.slots("success") || this.successText) {
        this.showSuccessTip();
      } else {
        this.setStatus(0, false);
      }
    }
  },
  mounted: function mounted11() {
    this.bindTouchEvent(this.$refs.track);
    this.scrollEl = getScroller(this.$el);
  },
  methods: {
    checkPullStart: function checkPullStart(event) {
      this.ceiling = getScrollTop(this.scrollEl) === 0;
      if (this.ceiling) {
        this.duration = 0;
        this.touchStart(event);
      }
    },
    onTouchStart: function onTouchStart3(event) {
      if (this.touchable) {
        this.checkPullStart(event);
      }
    },
    onTouchMove: function onTouchMove3(event) {
      if (!this.touchable) {
        return;
      }
      if (!this.ceiling) {
        this.checkPullStart(event);
      }
      this.touchMove(event);
      if (this.ceiling && this.deltaY >= 0 && this.direction === "vertical") {
        preventDefault(event);
        this.setStatus(this.ease(this.deltaY));
      }
    },
    onTouchEnd: function onTouchEnd4() {
      var _this = this;
      if (this.touchable && this.ceiling && this.deltaY) {
        this.duration = this.animationDuration;
        if (this.status === "loosing") {
          this.setStatus(+this.headHeight, true);
          this.$emit("input", true);
          this.$nextTick(function() {
            _this.$emit("refresh");
          });
        } else {
          this.setStatus(0);
        }
      }
    },
    ease: function ease(distance) {
      var pullDistance = +(this.pullDistance || this.headHeight);
      if (distance > pullDistance) {
        if (distance < pullDistance * 2) {
          distance = pullDistance + (distance - pullDistance) / 2;
        } else {
          distance = pullDistance * 1.5 + (distance - pullDistance * 2) / 4;
        }
      }
      return Math.round(distance);
    },
    setStatus: function setStatus(distance, isLoading) {
      var status;
      if (isLoading) {
        status = "loading";
      } else if (distance === 0) {
        status = "normal";
      } else {
        status = distance < (this.pullDistance || this.headHeight) ? "pulling" : "loosing";
      }
      this.distance = distance;
      if (status !== this.status) {
        this.status = status;
      }
    },
    genStatus: function genStatus() {
      var h = this.$createElement;
      var status = this.status, distance = this.distance;
      var slot = this.slots(status, {
        distance
      });
      if (slot) {
        return slot;
      }
      var nodes = [];
      var text = this[status + "Text"] || t3(status);
      if (TEXT_STATUS.indexOf(status) !== -1) {
        nodes.push(h("div", {
          "class": bem("text")
        }, [text]));
      }
      if (status === "loading") {
        nodes.push(h(Loading$1, {
          "attrs": {
            "size": "16"
          }
        }, [text]));
      }
      return nodes;
    },
    showSuccessTip: function showSuccessTip() {
      var _this2 = this;
      this.status = "success";
      setTimeout(function() {
        _this2.setStatus(0);
      }, this.successDuration);
    }
  },
  render: function render27() {
    var h = arguments[0];
    var trackStyle2 = {
      transitionDuration: this.duration + "ms",
      transform: this.distance ? "translate3d(0," + this.distance + "px, 0)" : ""
    };
    return h("div", {
      "class": bem()
    }, [h("div", {
      "ref": "track",
      "class": bem("track"),
      "style": trackStyle2
    }, [h("div", {
      "class": bem("head"),
      "style": this.headStyle
    }, [this.genStatus()]), this.slots()])]);
  }
});
Vue$1.component(_PullRefresh.name, _PullRefresh);
Vue$1.component(_Search.name, _Search);
Vue$1.component(_Popup.name, _Popup);
Vue$1.component(_List.name, _List);
Vue$1.component(Toast);
Vue$1.component(_NavBar.name, _NavBar);
Vue$1.component(_Collapse.name, _Collapse);
Vue$1.component(_CollapseItem.name, _CollapseItem);
Vue$1.component(_Checkbox.name, _Checkbox);
Vue$1.component(_CheckboxGroup.name, _CheckboxGroup);
Vue$1.component(_RadioGroup.name, _RadioGroup);
Vue$1.component(_Radio.name, _Radio);
Vue$1.component(_Cascader.name, _Cascader);
Vue$1.component(_Cell.name, _Cell);
Vue$1.component(_CellGroup.name, _CellGroup);
Vue$1.component(_Field.name, _Field);
Vue$1.component(_Button.name, _Button);
Vue$1.component(_Icon.name, _Icon);
Vue$1.component(_Divider.name, _Divider);
var root = "";
const components = { "../../packages/hook-function/index.js": __glob_6_0, "../../packages/op-address-input/index.js": __glob_6_1, "../../packages/op-appcode-select/index.js": __glob_6_2, "../../packages/op-brand-category-select/index.js": __glob_6_3, "../../packages/op-channel-select/index.js": __glob_6_4, "../../packages/op-classify-select/index.js": __glob_6_5, "../../packages/op-column/index.js": __glob_6_6, "../../packages/op-directory-tree/index.js": __glob_6_7, "../../packages/op-file-pc-preview/index.js": __glob_6_8, "../../packages/op-file-upload/index.js": __glob_6_9, "../../packages/op-icons/index.js": __glob_6_10, "../../packages/op-iframe-dialog/index.js": __glob_6_11, "../../packages/op-image-preview/index.js": __glob_6_12, "../../packages/op-intervals-select/index.js": __glob_6_13, "../../packages/op-map-select/index.js": __glob_6_14, "../../packages/op-market-line-select/index.js": __glob_6_15, "../../packages/op-market-select/index.js": __glob_6_16, "../../packages/op-menu-select/index.js": __glob_6_17, "../../packages/op-org-dialog-selector/index.js": __glob_6_18, "../../packages/op-org-right-select/index.js": __glob_6_19, "../../packages/op-org-selector/index.js": __glob_6_20, "../../packages/op-orgs-tree/index.js": __glob_6_21, "../../packages/op-outer-login/index.js": __glob_6_22, "../../packages/op-position-selector/index.js": __glob_6_23, "../../packages/op-region-select/index.js": __glob_6_24, "../../packages/op-role-selector/index.js": __glob_6_25, "../../packages/op-shop-select/index.js": __glob_6_26, "../../packages/op-table/index.js": __glob_6_27, "../../packages/op-table-header-config/index.js": __glob_6_28, "../../packages/op-table-search/index.js": __glob_6_29, "../../packages/op-tag-select/index.js": __glob_6_30, "../../packages/op-transition-wrap/index.js": __glob_6_31, "../../packages/op-uc-all-selector/index.js": __glob_6_32, "../../packages/op-user-selector/index.js": __glob_6_33, "../../packages/op-voice-record/index.js": __glob_6_34, "../../packages/request-server/index.js": __glob_6_35 };
const AllComponent = {};
AllComponent.install = (Vue2, opt = {}) => {
  const {
    env,
    appCode,
    subAppCode,
    prefix,
    mode = "pc"
  } = opt;
  if (inBrowser$1) {
    window.$OP_COMPONENT_MODE = mode.toLocaleLowerCase();
  }
  if (env) {
    baseUrlInst.init(env);
  }
  Vue2.use(OpIcons);
  if (!Vue2.prototype.$loading) {
    Vue2.use(_Loading.directive);
    Vue2.prototype.$loading = _Loading.service;
  }
  for (let path in components) {
    if (components[path] && components[path].default) {
      if (Array.isArray(components[path].default)) {
        components[path].default.map((_vm) => Vue2.use(_vm, {
          prefix
        }));
      } else {
        Vue2.use(components[path].default, {
          prefix
        });
      }
    }
  }
  if (!appCode || !subAppCode) {
    throw new Error("\u8BF7\u8F93\u5165appCode\u548CsubAppCode");
  }
  initAppCode(subAppCode);
};
export { HookFunction, AllComponent as default };
